import { MaybeComputedRef } from '@unhead/vue';
import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: MaybeComputedRef<T[K]> };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  code: { input: any; output: any };
  cursor: { input: any; output: any };
  date: { input: any; output: any };
  dateTime: { input: any; output: any };
  uri: { input: any; output: any };
};

export type AccountConfiguration = {
  alarmAckTemplates?: Maybe<Array<Maybe<AlarmAckTemplateOutput>>>;
};

export type AccountFeatures = {
  axisCameras?: Maybe<Scalars['Boolean']['output']>;
  beta: Scalars['Boolean']['output'];
  continuousSupervision?: Maybe<Scalars['Boolean']['output']>;
  defaultLocale?: Maybe<Scalars['String']['output']>;
  disablePasswordForDialoggUsers?: Maybe<Scalars['Boolean']['output']>;
  disablePasswordForUsers?: Maybe<Scalars['Boolean']['output']>;
  distanceApi?: Maybe<Scalars['Boolean']['output']>;
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  externalHumanIdTypeIdForDialoggUser?: Maybe<Scalars['String']['output']>;
  externalHumanIdTypeIdForPatient?: Maybe<Scalars['String']['output']>;
  externalHumanIdTypeIdForUser?: Maybe<Scalars['String']['output']>;
  hasCmpAccount?: Maybe<Scalars['Boolean']['output']>;
  hasJournalConfig?: Maybe<Scalars['Boolean']['output']>;
  hasKomp?: Maybe<Scalars['Boolean']['output']>;
  hasSkyresponseCustomerGroup?: Maybe<Scalars['Boolean']['output']>;
  joinNhnMeeting?: Maybe<Scalars['Boolean']['output']>;
  legacyIntegration?: Maybe<Scalars['Boolean']['output']>;
  safemateIntegration?: Maybe<Scalars['Boolean']['output']>;
  selfTreatmentPlan?: Maybe<Scalars['Boolean']['output']>;
  sendNotificationToNextOfKin?: Maybe<Scalars['Boolean']['output']>;
  skyresponse?: Maybe<Scalars['Boolean']['output']>;
  smsNotifications?: Maybe<Scalars['Boolean']['output']>;
  taskCodesForJournaling?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tcifIntegration?: Maybe<Scalars['Boolean']['output']>;
  videoMeetings?: Maybe<Scalars['Boolean']['output']>;
  vkpSearchEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type AccountLess = {
  accountDisplayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Address = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  postalCode?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  use?: Maybe<AddressUse>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  use?: InputMaybe<AddressUse>;
};

export enum AddressUse {
  Home = 'home',
  Old = 'old',
  Temp = 'temp',
  Work = 'work',
}

export enum AdministrativeGender {
  Female = 'female',
  Male = 'male',
  Other = 'other',
  Unknown = 'unknown',
}

export type AlarmAckTemplate = {
  status: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

export type AlarmAckTemplateOutput = {
  status?: Maybe<Scalars['String']['output']>;
  template?: Maybe<Scalars['String']['output']>;
};

export type AlarmActivity = {
  alarmIcon?: Maybe<Scalars['String']['output']>;
  callbackMinutes?: Maybe<Scalars['Int']['output']>;
  cep?: Maybe<CepConfig>;
  code: CodeableConcept;
  component?: Maybe<Array<Maybe<ObservationComponent>>>;
  debounceDelay?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveTiming?: Maybe<Timing>;
  fromTemplate?: Maybe<Reference>;
  generatesAlarm?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  identifier: Array<Maybe<Identifier>>;
  interpretation?: Maybe<Array<Maybe<CodeableConcept>>>;
  locationTraceOnly?: Maybe<Scalars['Boolean']['output']>;
  noCarePlanRequired?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Array<Maybe<Annotation>>>;
  resolveAction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status: Scalars['String']['output'];
  tagAction?: Maybe<Array<Maybe<TagAction>>>;
  technical?: Maybe<Scalars['Boolean']['output']>;
  timedCep?: Maybe<TimedCepConfig>;
  vkpEncounter?: Maybe<VkpEncounter>;
};

export type AlarmActivityInput = {
  alarmIcon?: InputMaybe<Scalars['String']['input']>;
  cep?: InputMaybe<CepConfigInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayText?: InputMaybe<Scalars['String']['input']>;
  effectiveTiming?: InputMaybe<TimingInput>;
  interpretation?: InputMaybe<Array<CodeableConceptInput>>;
  timedCep?: InputMaybe<TimedCepConfigInput>;
};

export type AlarmActivityMutationResponse = {
  alarmActivity?: Maybe<AlarmActivity>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AlarmActivityWithoutTemplateInput = {
  alarmIcon: Scalars['String']['input'];
  cep?: InputMaybe<CepConfigInput>;
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  displayText: Scalars['String']['input'];
  effectiveTiming?: InputMaybe<TimingInput>;
  interpretation: Array<CodeableConceptInput>;
};

export type AlarmDetail = {
  skyresponseAlarmDetail?: Maybe<SkyresponseAlarmDetail>;
  telluAlarmDetail?: Maybe<Task>;
};

export type AlarmEventsPaginated = {
  cursor?: Maybe<Scalars['cursor']['output']>;
  events: Array<Observation>;
};

export type AlarmHandlingAttempt = {
  details?: Maybe<Scalars['String']['output']>;
  doneAt: Scalars['dateTime']['output'];
  handledBy?: Maybe<Array<Scalars['String']['output']>>;
  payload?: Maybe<Scalars['String']['output']>;
  rawResponse?: Maybe<Scalars['String']['output']>;
  rawStatus?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['dateTime']['output'];
  status: Scalars['String']['output'];
};

export type AlarmHandlingFeedbackInput = {
  alarmId: Scalars['ID']['input'];
  alarmList?: InputMaybe<Array<Scalars['String']['input']>>;
  alarmStatus?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<ClientStatus>;
  comment?: InputMaybe<Scalars['String']['input']>;
  devices?: InputMaybe<Array<Scalars['String']['input']>>;
  errorType?: InputMaybe<Scalars['String']['input']>;
};

export type AlarmHandlingStatus = {
  attempts: Array<AlarmHandlingAttempt>;
  handler: Scalars['String']['output'];
  initiatedAt: Scalars['dateTime']['output'];
};

export type AlarmHistory = {
  acceptedAt?: Maybe<Scalars['dateTime']['output']>;
  alarmAction?: Maybe<Scalars['String']['output']>;
  alarmCode?: Maybe<Scalars['String']['output']>;
  alarmCodeDescription?: Maybe<Scalars['String']['output']>;
  alarmEvent?: Maybe<Scalars['String']['output']>;
  alarmHandling?: Maybe<Scalars['String']['output']>;
  alarmReason?: Maybe<Scalars['String']['output']>;
  deactivationTime?: Maybe<Scalars['dateTime']['output']>;
  for?: Maybe<Reference>;
  globalAlarmId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  journalWorkflowStatus?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Reference>;
  organization?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Reference>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Array<HumanName>>;
  priority: Scalars['String']['output'];
  priorityInput?: Maybe<TaskInput>;
  responseCenter?: Maybe<Scalars['String']['output']>;
  responseCenterAlarmId?: Maybe<Scalars['String']['output']>;
  serverAlarmTime?: Maybe<Scalars['dateTime']['output']>;
  tag: Scalars['String']['output'];
  telluAlarmId?: Maybe<Scalars['String']['output']>;
  textMessage?: Maybe<Scalars['String']['output']>;
  timeUntilVisible?: Maybe<Scalars['String']['output']>;
};

export type AlarmPatient = {
  address?: Maybe<Array<Maybe<Address>>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Array<HumanName>>;
  patientGroups?: Maybe<Array<Maybe<PatientGroupLess>>>;
  skyresponseDetails?: Maybe<SkyresponseConfig>;
};

export type AlarmRoute = {
  configId: Scalars['String']['output'];
  configName: Scalars['String']['output'];
  configType: Scalars['String']['output'];
  createPatientAlarmOnFail: Scalars['Boolean']['output'];
  idMappingStrategy: Scalars['ID']['output'];
  incomingTemplate: SimpleAlarmTemplate;
  outgoingTemplate: SimpleAlarmTemplate;
  patientGroupId: Scalars['String']['output'];
  routeId: Scalars['ID']['output'];
};

export type AlarmRouteInput = {
  configId: Scalars['String']['input'];
  configType: Scalars['String']['input'];
  createPatientAlarmOnFail: Scalars['Boolean']['input'];
  idMappingStrategy: Scalars['ID']['input'];
  incomingTemplate: Scalars['String']['input'];
  outgoingTemplate?: InputMaybe<Scalars['String']['input']>;
  patientGroupId: Scalars['String']['input'];
};

export type AlarmRouteOptions = {
  configs: Array<Config>;
  idMappingStrategies: Array<ExternalHumanIdType>;
  templates: Array<SimpleAlarmTemplate>;
};

export type AlarmStatus = {
  directRoutingDetails?: Maybe<DirectRoutingDetails>;
  id: Scalars['ID']['output'];
  input?: Maybe<Array<Maybe<TaskInput>>>;
  owner?: Maybe<Reference>;
  priorityInput?: Maybe<TaskInput>;
  status: Scalars['String']['output'];
};

export type AlarmSubscription = {
  deviceGroupIds?: Maybe<Array<Scalars['ID']['output']>>;
  healthProvider_fk?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  patientGroupIds?: Maybe<Array<Scalars['ID']['output']>>;
  targetEmails?: Maybe<Array<Scalars['String']['output']>>;
  targetPhoneNumbers?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type AlarmSubscriptionCreateInput = {
  deviceGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  patientGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  targetPhoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AlarmSubscriptionDeleteInput = {
  id: Scalars['String']['input'];
};

export type AlarmSubscriptionMutationResponse = {
  alarmSubscription?: Maybe<AlarmSubscription>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AlarmSubscriptionUpdateInput = {
  deviceGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  patientGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  targetPhoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AlarmTemplate = {
  acceptWithin?: Maybe<Scalars['Int']['output']>;
  alarmIcon?: Maybe<Scalars['String']['output']>;
  callbackMinutes?: Maybe<Scalars['Int']['output']>;
  cep?: Maybe<CepConfig>;
  code: CodeableConcept;
  component?: Maybe<Array<Maybe<ObservationComponent>>>;
  debounceDelay?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  effectiveTiming?: Maybe<Timing>;
  forwardingOnly?: Maybe<Scalars['Boolean']['output']>;
  generatesAlarm?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  identifier: Array<Maybe<Identifier>>;
  interpretation?: Maybe<Array<Maybe<CodeableConcept>>>;
  locationTraceOnly?: Maybe<Scalars['Boolean']['output']>;
  noCarePlanRequired?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Array<Maybe<Annotation>>>;
  resolveAction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resolveWithin?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  tagAction?: Maybe<Array<Maybe<TagAction>>>;
  technical?: Maybe<Scalars['Boolean']['output']>;
  vkpEncounter?: Maybe<VkpEncounter>;
};

export type AlarmTemplateCreateInput = {
  acceptWithin?: InputMaybe<Scalars['Int']['input']>;
  alarmIcon?: InputMaybe<Scalars['String']['input']>;
  callbackMinutes?: InputMaybe<Scalars['Int']['input']>;
  cep?: InputMaybe<CepConfigInput>;
  code: CodeableConceptInput;
  component?: InputMaybe<Array<InputMaybe<ObservationComponentInput>>>;
  debounceDelay?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  effectiveTiming?: InputMaybe<TimingInput>;
  forwardingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  generatesAlarm?: InputMaybe<Scalars['Boolean']['input']>;
  identifier: Array<InputMaybe<IdentifierInput>>;
  interpretation?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  locationTraceOnly?: InputMaybe<Scalars['Boolean']['input']>;
  noCarePlanRequired?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>>>;
  resolveAction?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resolveWithin?: InputMaybe<Scalars['Int']['input']>;
  tagAction?: InputMaybe<Array<InputMaybe<TagActionInput>>>;
  technical?: InputMaybe<Scalars['Boolean']['input']>;
  vkpEncounter?: InputMaybe<VkpEncounterInput>;
};

export type AlarmTemplateMutationResponse = {
  alarmTemplate?: Maybe<AlarmTemplate>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AlarmTemplateUpdateInput = {
  acceptWithin?: InputMaybe<Scalars['Int']['input']>;
  alarmIcon?: InputMaybe<Scalars['String']['input']>;
  callbackMinutes?: InputMaybe<Scalars['Int']['input']>;
  cep?: InputMaybe<CepConfigInput>;
  code?: InputMaybe<CodeableConceptInput>;
  component?: InputMaybe<Array<InputMaybe<ObservationComponentInput>>>;
  debounceDelay?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  effectiveTiming?: InputMaybe<TimingInput>;
  forwardingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  generatesAlarm?: InputMaybe<Scalars['Boolean']['input']>;
  identifier?: InputMaybe<Array<InputMaybe<IdentifierInput>>>;
  interpretation?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  locationTraceOnly?: InputMaybe<Scalars['Boolean']['input']>;
  noCarePlanRequired?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>>>;
  resolveAction?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resolveWithin?: InputMaybe<Scalars['Int']['input']>;
  tagAction?: InputMaybe<Array<InputMaybe<TagActionInput>>>;
  technical?: InputMaybe<Scalars['Boolean']['input']>;
  vkpEncounter?: InputMaybe<VkpEncounterInput>;
};

export type AlarmVkpConfiguration = {
  enabled: Scalars['Boolean']['output'];
};

export type AllPatientStats = {
  active: Scalars['Int']['output'];
  inactive: Scalars['Int']['output'];
};

export type AlmaForwarder = {
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  password?: Maybe<Scalars['String']['output']>;
  primaryUrl?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type AlmaForwarderConfig = {
  displayName?: Maybe<Scalars['String']['output']>;
  healthProvider_fk?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  password?: Maybe<Scalars['String']['output']>;
  primaryUrl?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type Annotation = {
  authorReference?: Maybe<Reference>;
  authorString?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['dateTime']['output']>;
};

export type AnnotationInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export type Anonymization = {
  /** Specifies for how long the anonymization can be disabled, if anonymization is required and supported. */
  disablePeriod?: Maybe<Scalars['Int']['output']>;
  /** Whether or not the customer requires anonymization before the video stream is started. */
  requirement?: Maybe<Scalars['Boolean']['output']>;
  /** Specifies if anonymization is currently enabled/disabled. */
  status?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the camera supports anonymization. */
  supports?: Maybe<Scalars['Boolean']['output']>;
};

export type AppDevice = {
  appSettings?: Maybe<AppSettings>;
  deviceName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastActive?: Maybe<Scalars['dateTime']['output']>;
  medicalDevices?: Maybe<Array<Device>>;
  notificationSettings?: Maybe<NotificationSettings>;
  os: Scalars['String']['output'];
  remindedTasks?: Maybe<Array<ReminderStatus>>;
  username: Scalars['ID']['output'];
};

export type AppDeviceCreateInput = {
  appSettings: AppSettingsInput;
  deviceName: Scalars['String']['input'];
  os: Scalars['String']['input'];
};

export type AppDeviceForPatientUpdateInput = {
  appLocale?: InputMaybe<Scalars['String']['input']>;
  deviation: Scalars['Boolean']['input'];
  measurement: Scalars['Boolean']['input'];
  message: Scalars['Boolean']['input'];
  reminder: Scalars['Int']['input'];
  reviewed: Scalars['Boolean']['input'];
};

export type AppDeviceMutationResponse = {
  appDevice?: Maybe<AppDevice>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AppDeviceUpdateInput = {
  appSettings?: InputMaybe<AppSettingsInput>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
};

export type AppManagementStatus = {
  id: Scalars['ID']['output'];
  latestVersion: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profileCount?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type AppSettings = {
  appLocale?: Maybe<Scalars['String']['output']>;
  appName?: Maybe<Scalars['String']['output']>;
  pushId?: Maybe<Scalars['String']['output']>;
};

export type AppSettingsInput = {
  appLocale?: InputMaybe<Scalars['String']['input']>;
  appName: Scalars['String']['input'];
  pushId: Scalars['String']['input'];
};

export type Applications = {
  default?: Maybe<Scalars['String']['output']>;
  dho?: Maybe<Scalars['Boolean']['output']>;
  dhv?: Maybe<Scalars['Boolean']['output']>;
  dialogg?: Maybe<Scalars['Boolean']['output']>;
  tilsyn?: Maybe<Scalars['Boolean']['output']>;
};

export type Appointment = {
  appointmentType: Scalars['String']['output'];
  carePlan?: Maybe<CarePlan>;
  description?: Maybe<Scalars['String']['output']>;
  end: Scalars['dateTime']['output'];
  id: Scalars['ID']['output'];
  participant?: Maybe<Array<Maybe<AppointmentParticipant>>>;
  patient?: Maybe<Patient>;
  start: Scalars['dateTime']['output'];
  status: AppointmentStatus;
  supportingInformation?: Maybe<Array<Maybe<Reference>>>;
};

export type AppointmentParticipant = {
  actor?: Maybe<Reference>;
  task?: Maybe<Reference>;
};

export type AppointmentParticipantInput = {
  actor?: InputMaybe<ReferenceInput>;
};

export enum AppointmentStatus {
  Arrived = 'arrived',
  Booked = 'booked',
  Cancelled = 'cancelled',
  Fulfilled = 'fulfilled',
  Pending = 'pending',
  Proposed = 'proposed',
}

export type AscomConnectionStatus = {
  details?: Maybe<Scalars['String']['output']>;
  httpStatus: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type AscomForwarder = {
  active?: Maybe<Scalars['Boolean']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  ascomIntegrationId?: Maybe<Scalars['String']['output']>;
  connectionStatus?: Maybe<AscomConnectionStatus>;
  displayName?: Maybe<Scalars['String']['output']>;
  heartbeatRate?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  primaryUrl?: Maybe<Scalars['String']['output']>;
};

export type AscomForwarderConfig = {
  active?: Maybe<Scalars['Boolean']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  ascomIntegrationId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  healthProvider_fk?: Maybe<Scalars['String']['output']>;
  heartbeatRate?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  primaryUrl?: Maybe<Scalars['String']['output']>;
};

export type Attachment = {
  contentType?: Maybe<Scalars['String']['output']>;
  creation?: Maybe<Scalars['dateTime']['output']>;
  documentReferenceId?: Maybe<Scalars['ID']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uploadMutation?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AttachmentInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AudioManagementStatus = {
  audioSupported?: Maybe<Scalars['Boolean']['output']>;
  enabled: Scalars['Boolean']['output'];
  inputGain?: Maybe<Scalars['String']['output']>;
  inputType?: Maybe<Scalars['String']['output']>;
  microphonePowerType?: Maybe<Scalars['String']['output']>;
  microphonePowered?: Maybe<Scalars['Boolean']['output']>;
};

export type AuditEntitySummaryEntry = {
  count: Scalars['Int']['output'];
  entityType: Scalars['String']['output'];
};

export type AuditEvent = {
  action?: Maybe<Scalars['String']['output']>;
  agent?: Maybe<Array<AuditEventAgent>>;
  entity?: Maybe<Array<AuditEventEntity>>;
  id: Scalars['ID']['output'];
  mainEntity?: Maybe<Scalars['String']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  outcomeDesc?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Period>;
  purposeOfEvent?: Maybe<Array<Maybe<CodeableConcept>>>;
  recorded?: Maybe<Scalars['dateTime']['output']>;
  session?: Maybe<Scalars['String']['output']>;
  source?: Maybe<AuditEventSource>;
  type: AuditEventType;
  userName?: Maybe<Scalars['String']['output']>;
};

export enum AuditEventAction {
  C = 'C',
  D = 'D',
  E = 'E',
  R = 'R',
  U = 'U',
}

export type AuditEventAgent = {
  altId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<AuditEventAgentNetwork>;
  requestor: Scalars['Boolean']['output'];
  role?: Maybe<Array<CodeableConcept>>;
  who?: Maybe<Reference>;
};

export type AuditEventAgentNetwork = {
  address?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AuditEventDetail = {
  type?: Maybe<Scalars['String']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type AuditEventEntity = {
  detail?: Maybe<Array<AuditEventDetail>>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Coding>;
  type?: Maybe<Coding>;
  what?: Maybe<Reference>;
};

export type AuditEventSource = {
  observer: Reference;
};

export type AuditEventType = {
  code: Scalars['String']['output'];
};

export type AuditLogOperationSelector = {
  operation: Scalars['String']['input'];
  outcome?: InputMaybe<Scalars['String']['input']>;
};

export type AuditLogPaginated = {
  cursor?: Maybe<Scalars['cursor']['output']>;
  events?: Maybe<Array<AuditEvent>>;
};

export type AuditLogSummaries = {
  auditEntitySummary: Array<AuditEntitySummaryEntry>;
  auditLogSummary: Array<AuditLogSummaryEntry>;
  auditRoleSummary: Array<AuditRoleSummaryEntry>;
};

export type AuditLogSummaryEntry = {
  count: Scalars['Int']['output'];
  operation: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
};

export type AuditRoleSummaryEntry = {
  count: Scalars['Int']['output'];
  operation: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type AuditStats = {
  defaultRoleDefinitionId?: Maybe<Scalars['String']['output']>;
  healthProvider?: Maybe<Scalars['String']['output']>;
  loginSessionId?: Maybe<Scalars['String']['output']>;
  numberOfOperations?: Maybe<Scalars['Int']['output']>;
  roleDefinitionId?: Maybe<Scalars['String']['output']>;
  roleInstanceName?: Maybe<Scalars['String']['output']>;
  sessionEnd?: Maybe<Scalars['dateTime']['output']>;
  sessionStart?: Maybe<Scalars['dateTime']['output']>;
  userGroupName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AuthUpdateInput = {
  ipRestriction: Scalars['Boolean']['input'];
  timeLimitedAccess: Scalars['Boolean']['input'];
  twoFactorSms: Scalars['Boolean']['input'];
};

export type AzureAccount = {
  alias: Scalars['String']['output'];
  azureGroups?: Maybe<Array<Maybe<AzureGroup>>>;
  azureProvisioningCredentials?: Maybe<AzureProvisioningCredentials>;
  clientId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  externalIdentityProvider: ExternalIdentityProvider;
  id: Scalars['String']['output'];
  patientRealm: Scalars['Boolean']['output'];
  prio?: Maybe<Scalars['String']['output']>;
  support: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
};

export type AzureAccountMutationResponse = {
  azureAccount?: Maybe<ExternalIdentityProviderForHealthProvider>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AzureGroup = {
  displayName?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  members?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roleIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roles?: Maybe<Array<Role>>;
};

export type AzureGroupMutationResponse = {
  azureGroup?: Maybe<AzureGroup>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AzureProvisioningCredentials = {
  secretToken?: Maybe<Scalars['String']['output']>;
  tenantUrl?: Maybe<Scalars['String']['output']>;
};

export type AzureProvisioningMutationResponse = {
  azureProvisioningCredentials?: Maybe<AzureProvisioningCredentials>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Badges = {
  syncAlarms: Scalars['Int']['output'];
  technicalAlarms: Scalars['Int']['output'];
};

export type Camera = {
  /**
   * Is the camera currently enabled?
   *
   * Example: true
   */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Says whether or not the camera model supports anonymization, if it's required or not, how long it can be disabled at a time and whether or not it's currently enabled. */
  anonymization?: Maybe<Anonymization>;
  /** Defines when the camera video stream is accessible in Tellucare, following the standard opening_hours format. */
  availableHours?: Maybe<Scalars['String']['output']>;
  /**
   * Text description of the camera, for humans
   *
   * Example: Camera watching the bedroom
   */
  description?: Maybe<Scalars['String']['output']>;
  detailedStatus?: Maybe<CameraDetailedStatus>;
  deviceGroup?: Maybe<DeviceGroup>;
  hasOfflineAlarm?: Maybe<Scalars['Boolean']['output']>;
  /** Camera FHIR ID. */
  id: Scalars['ID']['output'];
  isAttachedToPatient?: Maybe<Scalars['Boolean']['output']>;
  isConfiguredInRegistry?: Maybe<Scalars['Boolean']['output']>;
  /** MAC-address of the camera */
  macAddress: Scalars['String']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  /**
   * Human-readable name
   *
   * Example: bed room.
   */
  name: Scalars['String']['output'];
  /** Pings the camera. Only query when needed (e.g. before opening stream). */
  online?: Maybe<Scalars['Boolean']['output']>;
  /** FHIR reference to the patient the camera is attached to. */
  patientReference?: Maybe<Reference>;
  /** List of camera presets. */
  presets: Array<Maybe<Scalars['String']['output']>>;
  ptzEnabled?: Maybe<Scalars['Boolean']['output']>;
  userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
  /** Pan, tilt and zoom. */
  view?: Maybe<CameraView>;
};

export type CameraAdmin = {
  /** List HTTPS URLS to the various applications related to the camera */
  adminApps?: Maybe<Array<Maybe<CameraAdminApp>>>;
  /**
   * HTTPs URL to the camera administration interface
   *
   * null if the camera doesn't have an administration interface
   *
   * or if the user is not allowed to access the interface
   */
  adminUrl?: Maybe<Scalars['String']['output']>;
  detailedStatus?: Maybe<CameraDetailedStatus>;
  filteredEvents?: Maybe<Array<FilteredCameraEvents>>;
  firmware?: Maybe<Scalars['String']['output']>;
  hasOfflineAlarm?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isConfiguredInRegistry?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Those statuses query the camera (slow)
   * Do not query them together with getAllCameras
   */
  mqttClientStatus?: Maybe<MqttClientStatus>;
  online?: Maybe<Scalars['Boolean']['output']>;
  patientReference?: Maybe<Reference>;
  /** Optional information about the router providing connectivity to the camera (e.g. Novo, Teltonika) */
  router?: Maybe<RouterInfo>;
  systemStatus?: Maybe<SystemStatus>;
};

/** A camera Admin APP can be used to configured an application */
export type CameraAdminApp = {
  /** ID of the admin app */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Profiles for apps like VMD, FG, OA */
  profiles?: Maybe<Array<CameraAppProfile>>;
  status?: Maybe<Scalars['String']['output']>;
  /** URL of the admin URL */
  url?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type CameraAppProfile = {
  accountTemplate?: Maybe<SimpleAlarmTemplate>;
  cameraTopic?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patientTemplate?: Maybe<SimpleAlarmTemplate>;
};

export type CameraAppUpdate = {
  activate: Scalars['Boolean']['output'];
  deactivate: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  install: Scalars['Boolean']['output'];
  uninstall: Scalars['Boolean']['output'];
};

export type CameraAppUpdateInput = {
  activate: Scalars['Boolean']['input'];
  deactivate: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  install: Scalars['Boolean']['input'];
  uninstall: Scalars['Boolean']['input'];
};

export type CameraDetailedStatus = {
  eventsDeactivated?: Maybe<Scalars['Boolean']['output']>;
  eventsDeactivatedUntil?: Maybe<Scalars['dateTime']['output']>;
  hasViewersEnabled?: Maybe<Scalars['Boolean']['output']>;
  heartbeatCount?: Maybe<Scalars['Int']['output']>;
  isAssociatedToPatient?: Maybe<Scalars['Boolean']['output']>;
  lastSeen?: Maybe<Scalars['dateTime']['output']>;
  privacyMode?: Maybe<Scalars['Boolean']['output']>;
  privacyModeUntil?: Maybe<Scalars['dateTime']['output']>;
  ttl?: Maybe<Scalars['Int']['output']>;
};

export type CameraFirmwareUpgrade = {
  reinstallIfSameVersion: Scalars['Boolean']['output'];
};

export type CameraFirmwareUpgradeInput = {
  reinstallIfSameVersion: Scalars['Boolean']['input'];
};

export type CameraInInventory = {
  macAddress?: Maybe<Scalars['String']['output']>;
  modelNumber?: Maybe<Scalars['String']['output']>;
};

/** Will allow to track each camera in the bacth */
export type CameraManagementInput = {
  id: Scalars['ID']['input'];
  macAddress: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Will allow to track each camera in the bacth */
export type CameraManagementInputWithOptionalId = {
  id?: InputMaybe<Scalars['ID']['input']>;
  macAddress: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CameraManagementStatus = {
  apps?: Maybe<Array<CameraAppUpdate>>;
  cameraName: Scalars['String']['output'];
  cameraSetup?: Maybe<CameraSetup>;
  firmwareUpgrade?: Maybe<CameraFirmwareUpgrade>;
  logs?: Maybe<Array<Scalars['String']['output']>>;
  serial: Scalars['String']['output'];
  status?: Maybe<Array<CameraManagementStepStatus>>;
  type: CameraManagementType;
};

export type CameraManagementStepStatus = {
  status: Scalars['String']['output'];
  step: Scalars['String']['output'];
  timestamp: Scalars['dateTime']['output'];
};

export enum CameraManagementType {
  AppManagement = 'app_management',
  Decommissioning = 'decommissioning',
  FirmwareUpgrade = 'firmware_upgrade',
  InitialProvisioning = 'initial_provisioning',
  Networking = 'networking',
}

export type CameraModelWithCapabilities = {
  apps: Array<SupportedCameraApp>;
  model: Scalars['String']['output'];
};

export type CameraMutationResponse = {
  camera?: Maybe<Camera>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CameraSetup = {
  cameraName: Scalars['String']['output'];
  customerId: Scalars['Int']['output'];
  deviceGroupId: Scalars['ID']['output'];
  enableAudio: Scalars['Boolean']['output'];
  firmwareUpgrade: Scalars['Boolean']['output'];
  installApps: Scalars['Boolean']['output'];
  installFG: Scalars['Boolean']['output'];
  installOA: Scalars['Boolean']['output'];
  installPS: Scalars['Boolean']['output'];
  installVMD: Scalars['Boolean']['output'];
  model: Scalars['String']['output'];
  oak: Scalars['String']['output'];
  serial: Scalars['String']['output'];
  siteId: Scalars['Int']['output'];
};

export type CameraSetupInput = {
  cameraName: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
  deviceGroupId: Scalars['ID']['input'];
  enableAudio: Scalars['Boolean']['input'];
  firmwareUpgrade: Scalars['Boolean']['input'];
  installApps: Scalars['Boolean']['input'];
  installFG: Scalars['Boolean']['input'];
  installOA: Scalars['Boolean']['input'];
  installPS: Scalars['Boolean']['input'];
  installVMD: Scalars['Boolean']['input'];
  model: Scalars['String']['input'];
  oak: Scalars['String']['input'];
  serial: Scalars['String']['input'];
  siteId: Scalars['Int']['input'];
};

export type CameraStatus = {
  apps?: Maybe<Array<Maybe<AppManagementStatus>>>;
  arch?: Maybe<Scalars['String']['output']>;
  audio?: Maybe<AudioManagementStatus>;
  connectedToMorphean: Scalars['Boolean']['output'];
  deviceGroup?: Maybe<Scalars['String']['output']>;
  deviceGroupId?: Maybe<Scalars['String']['output']>;
  firmware?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inAccount: Scalars['Boolean']['output'];
  inMorphean: Scalars['Boolean']['output'];
  inRegistry: Scalars['Boolean']['output'];
  isAttachedToPatient: Scalars['Boolean']['output'];
  lastSeen?: Maybe<Scalars['dateTime']['output']>;
  latestFirmware?: Maybe<Scalars['String']['output']>;
  macAddress: Scalars['String']['output'];
  model?: Maybe<Scalars['String']['output']>;
  mqttConfig?: Maybe<MqttConfig>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<NetworkMangementStatus>;
  ptz?: Maybe<PtzManagementStatus>;
  routerMac?: Maybe<Scalars['String']['output']>;
  routerVendor?: Maybe<Scalars['String']['output']>;
  soc?: Maybe<Scalars['String']['output']>;
  time?: Maybe<TimeManagementStatus>;
  video?: Maybe<VideoManagementStatus>;
};

/** Camera stream details */
export type CameraStream = {
  /**
   * Date and time at which the video stream will expires and stop.
   *
   * Null if the stream never expires. The stream may be expanded by
   *
   * sending a /extend command.
   */
  expires?: Maybe<Scalars['dateTime']['output']>;
  /**
   * Video stream ID
   *
   * Example: ea9648c9-25c0-468f-8a87-adde147d6feb
   */
  id: Scalars['ID']['output'];
  /**
   * Time to live / duration of the stream in seconds before it will expires and
   *
   * stop. The straim may be expanded by sending a keep alive command.
   *
   * 60 seconds by default, can be restricted in the device or JWT
   */
  ttl?: Maybe<Scalars['Int']['output']>;
  /**
   * Video stream type
   *
   * Unavailable in keepStreamAlive answers
   *
   * Example: rtsp-wss
   */
  type?: Maybe<Scalars['String']['output']>;
  /**
   * URL of the video stream
   *
   * Example: rtsp://streaming.example.net/ea9648c9-25c0-468f-8a87-adde147d6feb.vod
   */
  url: Scalars['String']['output'];
};

/** Camera stream profile */
export type CameraStreamProfile = {
  /**
   * Does the stream profile includes audio ?
   *
   * Example: false
   */
  audio?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Video codec of the stream profile
   *
   * Example: h264
   */
  codec?: Maybe<Scalars['String']['output']>;
  /**
   * Number of frames per seconds
   *
   * Example: 24
   */
  framerate?: Maybe<Scalars['Int']['output']>;
  /**
   * Name of the string profile (used as ID)
   *
   * Example: High Quality
   */
  name: Scalars['String']['output'];
  /**
   * Resolution of the stream
   *
   * Example: 1920x1080
   */
  resolution?: Maybe<Scalars['String']['output']>;
};

export type CameraSupervisionFeedback = {
  cameraId: Scalars['ID']['input'];
  cameraMacAddress: Scalars['String']['input'];
  client?: InputMaybe<ClientStatus>;
  endTime?: InputMaybe<Scalars['dateTime']['input']>;
  playerStatus?: InputMaybe<PlayerStatus>;
  startTime?: InputMaybe<Scalars['dateTime']['input']>;
  videoComment?: InputMaybe<Scalars['String']['input']>;
  videoImageQuality?: InputMaybe<ImageQuality>;
  videoStreamQuality?: InputMaybe<StreamQuality>;
};

export type CameraView = {
  maxPan?: Maybe<Scalars['Float']['output']>;
  maxTilt?: Maybe<Scalars['Float']['output']>;
  maxZoom?: Maybe<Scalars['Float']['output']>;
  minPan?: Maybe<Scalars['Float']['output']>;
  minTilt?: Maybe<Scalars['Float']['output']>;
  minZoom?: Maybe<Scalars['Float']['output']>;
  /**
   * pan of the camera (in degrees)
   *
   * 0 is north, 90 is east, 180 is south, 270 is west
   *
   * Synonym: Pan
   *
   * Example: 158.5
   */
  pan?: Maybe<Scalars['Float']['output']>;
  /**
   * tilt of the camera (in degrees)
   *
   * 0 is horizontal, 90 is pointing up, -90 is pointing down
   *
   * Synonym: Tilt
   *
   * Example: 18.0
   */
  tilt?: Maybe<Scalars['Float']['output']>;
  /**
   * Field of View of the camera.
   *
   * A high number represents a camera with a wide lens, while
   *
   * a low number represents a camera with a zoom.
   *
   * The ZOOM changes when the camera zoom is manipulated.
   *
   * Example: 90.0
   */
  zoom?: Maybe<Scalars['Float']['output']>;
};

export type CameraWithStatus = {
  anonymization?: Maybe<Anonymization>;
  /** Defines when the camera video stream is accessible in Tellucare, following the standard opening_hours format. */
  availableHours?: Maybe<Scalars['String']['output']>;
  detailedStatus?: Maybe<CameraDetailedStatus>;
  deviceGroup?: Maybe<DeviceGroup>;
  hasOfflineAlarm?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isAttachedToPatient?: Maybe<Scalars['Boolean']['output']>;
  isConfiguredInRegistry?: Maybe<Scalars['Boolean']['output']>;
  macAddress?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patientReference?: Maybe<Reference>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
};

export type CamerasPatientsWithoutAuditLog = {
  detailedStatus?: Maybe<DetailedStatusCamerasPatientsWithoutAuditLog>;
  hasOfflineAlarm?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isConfiguredInRegistry?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
};

export type CarePlan = {
  activity: Array<Maybe<CarePlanActivity>>;
  carePlanType?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['dateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<DocumentReference>>>;
  id: Scalars['ID']['output'];
  period?: Maybe<Period>;
  status: CarePlanStatus;
  subject: Reference;
  title?: Maybe<Scalars['String']['output']>;
};

export type CarePlanActivity = {
  detail: CarePlanActivityDef;
  observations?: Maybe<Array<Maybe<Observation>>>;
  outcomeReference?: Maybe<Array<Maybe<Reference>>>;
};

export type CarePlanActivityDef = {
  code?: Maybe<CodeableConcept>;
  description?: Maybe<Scalars['String']['output']>;
  instantiatesCanonical?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  questionnaires?: Maybe<Array<Maybe<Questionnaire>>>;
  scheduledPeriod?: Maybe<Period>;
  scheduledTiming?: Maybe<Timing>;
  status: Scalars['String']['output'];
};

export type CarePlanActivityDefInput = {
  code?: InputMaybe<CodeableConceptInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  instantiatesCanonical?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scheduledTiming?: InputMaybe<TimingInput>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CarePlanActivityInput = {
  detail: CarePlanActivityDefInput;
  outcomeReference?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
};

export type CarePlanInput = {
  activity?: InputMaybe<Array<InputMaybe<CarePlanActivityInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<PeriodInput>;
  status?: InputMaybe<CarePlanStatus>;
  subject?: InputMaybe<ReferenceInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CarePlanMutationResponse = {
  carePlan?: Maybe<CarePlan>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum CarePlanStatus {
  Active = 'active',
  Completed = 'completed',
  Draft = 'draft',
  Revoked = 'revoked',
}

export type CarePlanTemplateActivityInput = {
  detail: CarePlanActivityDefInput;
  outcomeReference?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
};

export type CarePlanTemplateInput = {
  activity?: InputMaybe<Array<InputMaybe<CarePlanTemplateActivityInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<PeriodInput>;
  status?: InputMaybe<CarePlanStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CarePlanTemplateUpdateInput = {
  activity?: InputMaybe<Array<InputMaybe<CarePlanTemplateActivityInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<PeriodInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CarePlanUpdateInput = {
  activity?: InputMaybe<Array<InputMaybe<CarePlanActivityInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<PeriodInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CareTeam = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
};

export type CepConfig = {
  after?: Maybe<Scalars['Int']['output']>;
  cancelledBy?: Maybe<Array<Scalars['String']['output']>>;
  trigger?: Maybe<Array<Scalars['String']['output']>>;
};

export type CepConfigInput = {
  after?: InputMaybe<Scalars['Int']['input']>;
  cancelledBy?: InputMaybe<Array<Scalars['String']['input']>>;
  trigger?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClientStatus = {
  browserHeight?: InputMaybe<Scalars['Int']['input']>;
  browserWidth?: InputMaybe<Scalars['Int']['input']>;
  useragent?: InputMaybe<Scalars['String']['input']>;
};

export type CmpAccount = {
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  customerGroup?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type CmpAccountCreateInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  customerGroup?: InputMaybe<Scalars['String']['input']>;
};

export type CmpAccountMutationResponse = {
  cmpAccount?: Maybe<CmpAccount>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CmpAccountUpdateInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  customerGroup?: InputMaybe<Scalars['String']['input']>;
};

export type CmpChildDevice = {
  activeTimeSpan?: Maybe<CmpChildDeviceActiveTimeSpan>;
  batteryStatus?: Maybe<CmpResponseType>;
  equipmentType?: Maybe<CmpResponseType>;
  locationCode?: Maybe<CmpResponseType>;
  radioIdCode?: Maybe<Scalars['String']['output']>;
  supervisionStatus?: Maybe<CmpResponseWithDateTime>;
};

export type CmpChildDeviceActiveTimeSpan = {
  hasTimeSpan?: Maybe<Scalars['Boolean']['output']>;
  timeSpan?: Maybe<Scalars['String']['output']>;
};

export type CmpCredentialsInput = {
  clientId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type CmpDevice = {
  alarmCode?: Maybe<Scalars['String']['output']>;
  batteryStatus?: Maybe<CmpResponseWithDateTime>;
  children?: Maybe<Array<CmpChildDevice>>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  operationalStatus?: Maybe<CmpResponseType>;
  portalConnection?: Maybe<CmpResponseWithDateTime>;
  powerSupply?: Maybe<CmpResponseWithDateTime>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CmpResponseType = {
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type CmpResponseWithDateTime = {
  name?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['dateTime']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type CodeableConcept = {
  coding?: Maybe<Array<Maybe<Coding>>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CodeableConceptInput = {
  coding?: InputMaybe<Array<InputMaybe<CodingInput>>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type Coding = {
  code?: Maybe<Scalars['code']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  system?: Maybe<Scalars['uri']['output']>;
  userSelected?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type CodingInput = {
  code?: InputMaybe<Scalars['code']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  system?: InputMaybe<Scalars['uri']['input']>;
  userSelected?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CombinedPatientContacts = {
  groupContacts: Array<Contact>;
  patientContacts: Array<Contact>;
};

export type Communication = {
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  patient?: Maybe<Patient>;
  payload?: Maybe<Array<Maybe<CommunicationPayload>>>;
  received?: Maybe<Scalars['dateTime']['output']>;
  sender?: Maybe<Reference>;
  sent?: Maybe<Scalars['dateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Reference>;
};

export type CommunicationInput = {
  payload?: InputMaybe<Array<InputMaybe<CommunicationPayloadInput>>>;
  subject?: InputMaybe<ReferenceOnlyInput>;
};

export type CommunicationMutationResponse = {
  communication?: Maybe<Communication>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CommunicationPaginated = {
  cursor?: Maybe<Scalars['cursor']['output']>;
  events?: Maybe<Array<Maybe<Communication>>>;
};

export type CommunicationPayload = {
  contentReference?: Maybe<Reference>;
  contentString?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<DocumentReference>;
};

export type CommunicationPayloadInput = {
  contentReference?: InputMaybe<ReferenceOnlyInput>;
  contentString?: InputMaybe<Scalars['String']['input']>;
};

export type CommunicationsMutationResponse = {
  communications: Array<Communication>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CompleteAlarmInput = {
  completionOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  freeTextNote?: InputMaybe<Scalars['String']['input']>;
  journal?: InputMaybe<Scalars['Boolean']['input']>;
  status: Scalars['String']['input'];
};

export type Config = {
  configId: Scalars['String']['output'];
  configName: Scalars['String']['output'];
  configType: Scalars['String']['output'];
};

export type ConfigMutationResponse = {
  healthProviderId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Configuration = {
  hasExternalUrl?: Maybe<Scalars['Boolean']['output']>;
  registeredInInventory?: Maybe<Scalars['Boolean']['output']>;
};

export type Contact = {
  availableHours: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<Identifier>>;
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  skyresponseConfig?: Maybe<ContactSkyresponseConfig>;
  telecom?: Maybe<Array<ContactPoint>>;
};

export type ContactPoint = {
  system?: Maybe<ContactPointSystem>;
  use?: Maybe<ContactPointUse>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ContactPointInput = {
  system?: InputMaybe<ContactPointSystem>;
  use?: InputMaybe<ContactPointUse>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ContactPointSystem {
  Email = 'email',
  Fax = 'fax',
  Other = 'other',
  Pager = 'pager',
  Phone = 'phone',
  Sms = 'sms',
  Url = 'url',
}

export enum ContactPointUse {
  Home = 'home',
  Mobile = 'mobile',
  Old = 'old',
  Temp = 'temp',
  Work = 'work',
}

export type ContactSkyresponseConfig = {
  callMethod?: Maybe<Scalars['Int']['output']>;
};

export type ContactsExport = {
  name?: Maybe<Scalars['String']['output']>;
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
};

export type ContinuousSupervisionCandidate = {
  cameras: Array<PatientSupervisionCamera>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type CoordinateOfAddressResponse = {
  latLng?: Maybe<GpsPosition>;
  status: Scalars['String']['output'];
};

export type CreateAlmaForwarder = {
  displayName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  primaryUrl: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateAscomForwarder = {
  active: Scalars['Boolean']['input'];
  apiKey: Scalars['String']['input'];
  ascomIntegrationId: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  heartbeatRate: Scalars['Int']['input'];
  primaryUrl: Scalars['String']['input'];
};

export type CreateCameraInput = {
  deviceGroupId: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
  macAddress: Scalars['String']['input'];
};

export type CreateCareTeamInput = {
  name: Scalars['String']['input'];
  telecom: Array<InputMaybe<ContactPointInput>>;
};

export type CreateContactInput = {
  availableHours: Scalars['String']['input'];
  name: Scalars['String']['input'];
  telecom: Array<ContactPointInput>;
};

export type CreateDialoggUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  externalIdentities?: InputMaybe<Array<InputMaybe<ExternalIdentityInput>>>;
  externalUserId?: InputMaybe<ExternalHumanIdInput>;
  externalUserIds?: InputMaybe<Array<ExternalHumanIdInput>>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  passwordEnabled: Scalars['Boolean']['input'];
  username: Scalars['ID']['input'];
};

export type CreateExternalAccessInput = {
  allowedAccess?: InputMaybe<Array<Scalars['String']['input']>>;
  ipRestrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type CreateFhirDeviceInput = {
  deviceGroupId: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
};

export type CreateNextOfKinInput = {
  active: Scalars['Boolean']['input'];
  address?: InputMaybe<Array<AddressInput>>;
  name?: InputMaybe<HumanNameInput>;
  notifyNextOfKin?: InputMaybe<Scalars['Boolean']['input']>;
  relationship: Scalars['String']['input'];
  telecom?: InputMaybe<Array<ContactPointInput>>;
};

export type CreatePatientInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  addressNote?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['date']['input']>;
  dialoggUser?: InputMaybe<CreateDialoggUserInput>;
  externalPatientId?: InputMaybe<ExternalHumanIdInput>;
  externalPatientIds?: InputMaybe<Array<ExternalHumanIdInput>>;
  gender?: InputMaybe<Scalars['String']['input']>;
  keyCode?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<LanguageInput>>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<HumanNameInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationInput>;
  secretAddress?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  telecom?: InputMaybe<Array<InputMaybe<ContactPointInput>>>;
};

export type CreateTellucareIntegrationInput = {
  apiEndpoint: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  hpName: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

export type CreateUserGroupInput = {
  name: Scalars['String']['input'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  skyresponseConfig?: InputMaybe<SkyresponseConfigInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserManualInput = {
  applications?: InputMaybe<UserManualApplicationsInput>;
  icon?: InputMaybe<Scalars['String']['input']>;
  localeEntries: Array<UserManualLocaleEntryInput>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  roleDefinitionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Customer = {
  accounts: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type CustomerInput = {
  name: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type CustomerLess = {
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CustomerMutationResponse = {
  customer?: Maybe<Customer>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CustomerUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DailyAuditLogStatsPaginated = {
  count: Scalars['Int']['output'];
  stats: Array<AuditStats>;
};

export type DailyDeviceStats = {
  active?: Maybe<Scalars['Int']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  devices?: Maybe<Scalars['Int']['output']>;
  endTimestamp?: Maybe<Scalars['dateTime']['output']>;
  online?: Maybe<Scalars['Int']['output']>;
  startTimestamp?: Maybe<Scalars['dateTime']['output']>;
  technicalAlarmEvents?: Maybe<Scalars['Int']['output']>;
  technicalAlarms?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['dateTime']['output']>;
};

export type DailyDeviceStatsPaginated = {
  count?: Maybe<Scalars['Int']['output']>;
  stats: Array<DailyDeviceStats>;
};

export type DailyDeviceStatsPaginatedCountArgs = {
  countFrom?: InputMaybe<Scalars['dateTime']['input']>;
  countTo?: InputMaybe<Scalars['dateTime']['input']>;
};

export type DailyPatientStats = {
  activePatients?: Maybe<Scalars['Int']['output']>;
  alarmEvents?: Maybe<Scalars['Int']['output']>;
  alarms?: Maybe<Scalars['Int']['output']>;
  deviceObservations?: Maybe<Scalars['Int']['output']>;
  endTimestamp?: Maybe<Scalars['dateTime']['output']>;
  inactivePatients?: Maybe<Scalars['Int']['output']>;
  manualObservations?: Maybe<Scalars['Int']['output']>;
  notifyEnabledNextOfKins?: Maybe<Scalars['Int']['output']>;
  questionnaireResponses?: Maybe<Scalars['Int']['output']>;
  startTimestamp?: Maybe<Scalars['dateTime']['output']>;
  timestamp?: Maybe<Scalars['dateTime']['output']>;
};

export type DailyPatientStatsPaginated = {
  count?: Maybe<Scalars['Int']['output']>;
  stats: Array<DailyPatientStats>;
};

export type DailyPatientStatsPaginatedCountArgs = {
  countFrom?: InputMaybe<Scalars['dateTime']['input']>;
  countTo?: InputMaybe<Scalars['dateTime']['input']>;
};

export type DailyUserStats = {
  dialoggUsers: Scalars['Int']['output'];
  dialoggUsersActive: Scalars['Int']['output'];
  dialoggUsersDefaultLogin: Scalars['Int']['output'];
  dialoggUsersExternalLogin: Scalars['Int']['output'];
  dialoggUsersLoginErrors: Scalars['Int']['output'];
  endTimestamp?: Maybe<Scalars['dateTime']['output']>;
  healthPersonnelActive: Scalars['Int']['output'];
  healthPersonnelDefaultLogin: Scalars['Int']['output'];
  healthPersonnelExternalLogin: Scalars['Int']['output'];
  healthPersonnelLoginErrors: Scalars['Int']['output'];
  healthPersonnelUsers: Scalars['Int']['output'];
  startTimestamp?: Maybe<Scalars['dateTime']['output']>;
  timestamp: Scalars['dateTime']['output'];
};

export type DailyUserStatsPaginated = {
  count?: Maybe<Scalars['Int']['output']>;
  stats: Array<DailyUserStats>;
};

export type DailyUserStatsPaginatedCountArgs = {
  countFrom?: InputMaybe<Scalars['dateTime']['input']>;
  countTo?: InputMaybe<Scalars['dateTime']['input']>;
};

export type DatabaseSchemaMigration = {
  databaseName: Scalars['String']['output'];
  healthProviderName: Scalars['String']['output'];
  report?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DatabaseSchemaSyncResponse = {
  databaseName: Scalars['String']['output'];
  healthProviderName: Scalars['String']['output'];
  isSynced?: Maybe<Scalars['Boolean']['output']>;
  output?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DayNightManagementStatus = {
  cutFilterMode: Scalars['String']['output'];
  manualIrOverriden: Scalars['Boolean']['output'];
  shiftLevel: Scalars['String']['output'];
};

export enum DayOfWeek {
  Fri = 'fri',
  Mon = 'mon',
  Sat = 'sat',
  Sun = 'sun',
  Thu = 'thu',
  Tue = 'tue',
  Wed = 'wed',
}

export type DefaultRoleDefinitionCreateInput = {
  abilities?: InputMaybe<Array<InputMaybe<AbilityInput>>>;
  accessScopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dashboardRouteName?: InputMaybe<Scalars['String']['input']>;
  display: Array<InputMaybe<LocaleDefinitionInput>>;
  id: Scalars['String']['input'];
  isDefaultType: Scalars['String']['input'];
  protected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DefaultRoleDefinitionUpdateInput = {
  abilities?: InputMaybe<Array<InputMaybe<AbilityInput>>>;
  accessScopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dashboardRouteName?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Array<InputMaybe<LocaleDefinitionInput>>>;
  id: Scalars['String']['input'];
  isDefaultType?: InputMaybe<Scalars['String']['input']>;
  protected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DefaultTemplates = {
  camera: Array<SimpleAlarmTemplate>;
  delegation: Array<SimpleAlarmTemplate>;
  forwarding: Array<SimpleAlarmTemplate>;
  measurement: Array<SimpleAlarmTemplate>;
  novo: Array<SimpleAlarmTemplate>;
  safemate: Array<SimpleAlarmTemplate>;
  timedCep: Array<SimpleAlarmTemplate>;
  videoMeeting: Array<SimpleAlarmTemplate>;
};

export type DetailedStatusCamerasPatientsWithoutAuditLog = {
  privacyMode?: Maybe<Scalars['Boolean']['output']>;
  ttl?: Maybe<Scalars['String']['output']>;
};

export type Device = {
  deviceGroup?: Maybe<DeviceGroup>;
  deviceName?: Maybe<Array<DeviceName>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<Identifier>>;
  isAttachedToPatient?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  modelNumber?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Reference>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<CodeableConcept>;
  userFriendlyName?: Maybe<Scalars['String']['output']>;
  userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
};

export type DeviceExport = {
  identifier?: Maybe<Scalars['String']['output']>;
  modelNumber?: Maybe<Scalars['String']['output']>;
};

export type DeviceGeofence = {
  name?: Maybe<Scalars['String']['output']>;
  polygon?: Maybe<Scalars['Boolean']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
  vertices?: Maybe<Array<Maybe<DeviceGeofenceVertex>>>;
};

export type DeviceGeofenceVertex = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type DeviceGroup = {
  hasCmpCredentials?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  streamTTL?: Maybe<Scalars['Int']['output']>;
};

export type DeviceGroupCreateInput = {
  cmpCredentials?: InputMaybe<CmpCredentialsInput>;
  name: Scalars['String']['input'];
  streamTTL?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceGroupMutationResponse = {
  deviceGroup?: Maybe<DeviceGroup>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeviceGroupUpdateInput = {
  cmpCredentials?: InputMaybe<CmpCredentialsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  streamTTL?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceInList = {
  childDeviceIds?: Maybe<Array<Scalars['ID']['output']>>;
  deviceName?: Maybe<Array<DeviceName>>;
  id: Scalars['ID']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  modelNumber?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  registeredInInventory?: Maybe<Scalars['Boolean']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type DeviceName = {
  name?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type DeviceProperty = {
  callbackPhoneNumber?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
};

export type DevicePropertyInput = {
  callbackPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceStats = {
  deviceType?: Maybe<Scalars['String']['output']>;
  technicalAlarmEvents?: Maybe<Scalars['Int']['output']>;
  technicalAlarms?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['dateTime']['output']>;
};

export type DeviceStatsPaginated = {
  count?: Maybe<Scalars['Int']['output']>;
  stats: Array<DeviceStats>;
};

export type DeviceStatsPaginatedCountArgs = {
  countFrom?: InputMaybe<Scalars['dateTime']['input']>;
  countTo?: InputMaybe<Scalars['dateTime']['input']>;
};

export type DeviceStatus = {
  connected?: Maybe<Scalars['Boolean']['output']>;
  heartbeatCount?: Maybe<Scalars['Int']['output']>;
  lastBatteryStatus?: Maybe<Scalars['Int']['output']>;
  lastBatteryTimestamp?: Maybe<Scalars['dateTime']['output']>;
  lastSeen?: Maybe<Scalars['dateTime']['output']>;
};

export type DialoggUser = {
  appDeviceIds?: Maybe<Array<Scalars['ID']['output']>>;
  email?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  externalIdentities?: Maybe<Array<ExternalIdentity>>;
  externalUserIds?: Maybe<Array<ExternalHumanId>>;
  firstName?: Maybe<Scalars['String']['output']>;
  ipRestrictions?: Maybe<Array<Scalars['String']['output']>>;
  lastActive?: Maybe<Scalars['dateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  onBehalf?: Maybe<OnBehalf>;
  otpStatus?: Maybe<Scalars['String']['output']>;
  passwordEnabled?: Maybe<Scalars['Boolean']['output']>;
  passwordStatus?: Maybe<Scalars['String']['output']>;
  picturePermission?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  smsOtpPhoneNumber?: Maybe<Scalars['String']['output']>;
  smsOtpStatus?: Maybe<Scalars['String']['output']>;
  timeLimitedAccess?: Maybe<Period>;
  username: Scalars['ID']['output'];
};

export type DialoggUserMutationResponse = {
  dialoggUser?: Maybe<DialoggUser>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DirectRoutingDetails = {
  escalationStatus?: Maybe<Scalars['String']['output']>;
  hasActiveCall: Scalars['Boolean']['output'];
};

export type DisplaySummary = {
  computedTaskPriority?: Maybe<QuestionnairePrioritiesCode>;
  priorities?: Maybe<QuestionnairePriorities>;
  score?: Maybe<Scalars['Int']['output']>;
};

export type DistanceMatrixDistance = {
  text: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type DistanceMatrixDuration = {
  text: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type DistanceMatrixRow = {
  distance?: Maybe<DistanceMatrixDistance>;
  duration?: Maybe<DistanceMatrixDuration>;
  durationInTraffic?: Maybe<DistanceMatrixDuration>;
  status: Scalars['String']['output'];
};

export type DistanceRows = {
  elements: Array<DistanceMatrixRow>;
};

export type DistanceToPositionsResponse = {
  rows?: Maybe<Array<DistanceRows>>;
  status: Scalars['String']['output'];
};

export type DocumentReference = {
  content?: Maybe<Array<Maybe<DocumentReferenceContent>>>;
  context?: Maybe<DocumentReferenceContext>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Reference>;
  id: Scalars['ID']['output'];
  subject?: Maybe<Reference>;
  uploadMutation?: Maybe<Scalars['Boolean']['output']>;
};

export type DocumentReferenceContent = {
  attachment?: Maybe<Attachment>;
  documentReferenceId?: Maybe<Scalars['ID']['output']>;
  uploadMutation?: Maybe<Scalars['Boolean']['output']>;
};

export type DocumentReferenceContentInput = {
  attachment?: InputMaybe<AttachmentInput>;
};

export type DocumentReferenceContext = {
  carePlan?: Maybe<CarePlan>;
  related?: Maybe<Array<Maybe<Reference>>>;
};

export type DocumentReferenceContextInput = {
  related?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
};

export type DocumentReferenceInput = {
  content?: InputMaybe<Array<InputMaybe<DocumentReferenceContentInput>>>;
  context?: InputMaybe<DocumentReferenceContextInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<ReferenceInput>;
};

export type DocumentReferenceMutationResult = {
  documentReference?: Maybe<DocumentReference>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EmbeddedLinkOptions = {
  autoPlay?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  expireAfter?: InputMaybe<Scalars['Int']['input']>;
  hideControls?: InputMaybe<Scalars['Boolean']['input']>;
  hideStatusbar?: InputMaybe<Scalars['Boolean']['input']>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Equipment = {
  createdAt: Scalars['dateTime']['output'];
  deviceGroup?: Maybe<Scalars['String']['output']>;
  hasExternalUrl?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  lastBatteryStatus?: Maybe<Scalars['Int']['output']>;
  lastSeen?: Maybe<Scalars['dateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  registeredInInventory?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  topPriorityAlarm?: Maybe<EquipmentAlarm>;
  type?: Maybe<Scalars['String']['output']>;
  userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
};

export type EquipmentAlarm = {
  priority?: Maybe<Scalars['String']['output']>;
};

export type Extension = {
  ValueId?: Maybe<Scalars['ID']['output']>;
  extension?: Maybe<Array<Extension>>;
  url?: Maybe<Scalars['String']['output']>;
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueInteger?: Maybe<Scalars['Int']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type ExtensionInput = {
  ValueId?: InputMaybe<Scalars['ID']['input']>;
  extension?: InputMaybe<Array<ExtensionInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
  valueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  valueInteger?: InputMaybe<Scalars['Int']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalAccess = {
  allowedAccess?: Maybe<Array<Scalars['String']['output']>>;
  healthProviderName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ipRestrictions: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  patientGroupIds: Array<Scalars['String']['output']>;
};

export type ExternalAccessCreateResponse = {
  id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  secret?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExternalAccessCredentials = {
  apiEndpoint: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type ExternalAccessLess = {
  healthProviderName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  patientGroupIds: Array<Scalars['String']['output']>;
  scim?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalAccessNames = {
  externalAccessName: Scalars['String']['output'];
  externalAccessNameToShow: Scalars['String']['output'];
};

export type ExternalAccessUpdateResponse = {
  id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ExternalHumanId = {
  externalHumanIdType: ExternalHumanIdType;
  externalId: Scalars['String']['output'];
};

export type ExternalHumanIdInput = {
  externalHumanIdTypeId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
};

export type ExternalHumanIdType = {
  fhirIdentifier: Identifier;
  globalSearchAllowed: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  localeEntries: Array<LocaleEntry>;
  use: ExternalHumanIdTypeUse;
  validationRegexp?: Maybe<Scalars['String']['output']>;
};

export type ExternalHumanIdTypeCreateInput = {
  fhirIdentifier: IdentifierInput;
  globalSearchAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  localeEntries: Array<LocaleEntryInput>;
  use: ExternalHumanIdTypeUseInput;
  validationRegexp?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalHumanIdTypeMutationResponse = {
  externalHumanIdType?: Maybe<ExternalHumanIdType>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExternalHumanIdTypePatientUse = {
  applicable?: Maybe<Scalars['Boolean']['output']>;
  canAddToFhirPatientOnly?: Maybe<Scalars['Boolean']['output']>;
  immutable?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalHumanIdTypePatientUseInput = {
  applicable: Scalars['Boolean']['input'];
  canAddToFhirPatientOnly: Scalars['Boolean']['input'];
};

export type ExternalHumanIdTypePersonnelUse = {
  applicable?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalHumanIdTypePersonnelUseInput = {
  applicable: Scalars['Boolean']['input'];
};

export type ExternalHumanIdTypeUpdateInput = {
  globalSearchAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  localeEntries?: InputMaybe<Array<LocaleEntryInput>>;
  use?: InputMaybe<ExternalHumanIdTypeUseInput>;
  validationRegexp?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalHumanIdTypeUse = {
  patientUse?: Maybe<ExternalHumanIdTypePatientUse>;
  personnelUse?: Maybe<ExternalHumanIdTypePersonnelUse>;
};

export type ExternalHumanIdTypeUseInput = {
  patientUse: ExternalHumanIdTypePatientUseInput;
  personnelUse: ExternalHumanIdTypePersonnelUseInput;
};

export type ExternalIdExport = {
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ExternalIdRequest = {
  externalHumanIdType: Scalars['String']['output'];
  requested: Scalars['Boolean']['output'];
};

export type ExternalIdentity = {
  externalIdentityUsername: Scalars['ID']['output'];
  provider: Scalars['ID']['output'];
};

export type ExternalIdentityInput = {
  externalIdentityUsername: Scalars['ID']['input'];
  provider: Scalars['ID']['input'];
};

export type ExternalIdentityProvider = {
  canSync: Scalars['Boolean']['output'];
  client: Array<LocaleEntry>;
  display: Array<LocaleEntry>;
  externalHumanIdType?: Maybe<ExternalHumanIdType>;
  provider: Scalars['String']['output'];
  tenant: Array<LocaleEntry>;
};

export type ExternalIdentityProviderForHealthProvider = {
  alias: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  externalIdentityProvider: ExternalIdentityProvider;
  id: Scalars['String']['output'];
  patientRealm: Scalars['Boolean']['output'];
  prio?: Maybe<Scalars['String']['output']>;
  support: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
};

export type ExternalIdentityProviderForHealthProviderCreateInput = {
  alias: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  patientRealm: Scalars['Boolean']['input'];
  prio?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  support?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['String']['input'];
};

export type ExternalIdentityProviderForHealthProviderMutationResponse = {
  externalIdentityProviderForHealthProvider?: Maybe<ExternalIdentityProviderForHealthProvider>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExternalIdentityProviderForHealthProviderUpdateInput = {
  alias: Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  prio?: InputMaybe<Scalars['String']['input']>;
  support?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalIdentityProviderRedirector = {
  alias?: Maybe<Scalars['String']['output']>;
  config?: Maybe<ExternalIdentityProviderRedirectorConfig>;
  id?: Maybe<Scalars['String']['output']>;
  isPatientRealm?: Maybe<Scalars['Boolean']['output']>;
};

export type ExternalIdentityProviderRedirectorConfig = {
  defaultProvider?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagMutationResponse = {
  healthProvider?: Maybe<HealthProvider>;
  isEnabled: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  wasEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type FeatureFlags = {
  beta?: Maybe<Scalars['Boolean']['output']>;
  continuousSupervision?: Maybe<Scalars['Boolean']['output']>;
  hasKomp?: Maybe<Scalars['Boolean']['output']>;
  joinNhnMeeting?: Maybe<Scalars['Boolean']['output']>;
  selfTreatmentPlan?: Maybe<Scalars['Boolean']['output']>;
  sendNotificationToNextOfKin?: Maybe<Scalars['Boolean']['output']>;
};

export enum FeedbackSeverity {
  Critical = 'critical',
  Error = 'error',
  Fatal = 'fatal',
  Info = 'info',
  Warning = 'warning',
}

export type FilteredCameraEvents = {
  counter: Scalars['Int']['output'];
  resetAt?: Maybe<Scalars['dateTime']['output']>;
  timestamp: Scalars['dateTime']['output'];
  type: Scalars['String']['output'];
};

export type FlowAuditLogReference = {
  auditEventId: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type FlowStatus = {
  completed: Scalars['Boolean']['output'];
  currentStep: Scalars['Int']['output'];
  flowName: Scalars['String']['output'];
  hasFailed?: Maybe<Scalars['Boolean']['output']>;
  healthProviderName?: Maybe<Scalars['String']['output']>;
  logs: Array<FlowStatusLogEntry>;
  numberOfSteps: Scalars['Int']['output'];
  paused?: Maybe<Scalars['Boolean']['output']>;
  stepStatuses?: Maybe<Array<StepStatus>>;
  willBeCleanedUpAt?: Maybe<Scalars['dateTime']['output']>;
};

export type FlowStatusLogEntry = {
  attempts: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  localePath: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stepName: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type GenericMigration = {
  healthProviderName: Scalars['String']['output'];
  report?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GenericMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GenericTagConfig = {
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type GenericTagConfigCreateInput = {
  displayName: Scalars['String']['input'];
};

export type GetExternalDevicesResponse = {
  hasSafemateIntegration: Scalars['Boolean']['output'];
  safemateDevices: Array<SafemateProDevice>;
};

export type GlobalStats = {
  allPatientStats: AllPatientStats;
  cameras: Scalars['Int']['output'];
  healthProvider: Scalars['String']['output'];
  notifyEnabledNextOfKins: Scalars['Int']['output'];
  novo: Scalars['Int']['output'];
  personnel: Scalars['Int']['output'];
};

export type Goal = {
  goal?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type GoalInput = {
  goal: Scalars['String']['input'];
};

export type GooglemapsAccount = {
  accountDisplayName?: Maybe<Scalars['String']['output']>;
  apiToken?: Maybe<Scalars['String']['output']>;
  apiUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type GooglemapsAccountCreateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  apiUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GooglemapsAccountMutationResponse = {
  googlemapsAccount?: Maybe<GooglemapsAccount>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GooglemapsAccountUpdateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  apiToken?: InputMaybe<Scalars['String']['input']>;
  apiUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GpsLocation = {
  address?: Maybe<Address>;
  description?: Maybe<Scalars['String']['output']>;
  gpsTimestamp?: Maybe<Scalars['dateTime']['output']>;
  position?: Maybe<GpsPosition>;
  receivedTimestamp?: Maybe<Scalars['dateTime']['output']>;
  type?: Maybe<GpsType>;
};

export type GpsPosition = {
  altitude?: Maybe<Scalars['Float']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GpsPositionInput = {
  altitude?: InputMaybe<Scalars['Float']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type GpsPositionOrStringInput = {
  position?: InputMaybe<GpsPositionInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  type: GpsPositionOrStringUse;
};

export enum GpsPositionOrStringUse {
  Lonlat = 'lonlat',
  String = 'string',
}

export type GpsType = {
  code: Scalars['String']['output'];
  display: Scalars['String']['output'];
};

export type HealthProvider = {
  customer?: Maybe<CustomerLess>;
  defaultApplication?: Maybe<Scalars['String']['output']>;
  defaultLocale?: Maybe<Scalars['String']['output']>;
  dialoggCode?: Maybe<Scalars['String']['output']>;
  disablePasswordForDialoggUsers?: Maybe<Scalars['Boolean']['output']>;
  disablePasswordForUsers?: Maybe<Scalars['Boolean']['output']>;
  displayName: Scalars['String']['output'];
  externalHumanIdTypeIdForDialoggUser?: Maybe<Scalars['String']['output']>;
  externalHumanIdTypeIdForPatient?: Maybe<Scalars['String']['output']>;
  externalHumanIdTypeIdForUser?: Maybe<Scalars['String']['output']>;
  features?: Maybe<FeatureFlags>;
  googlemapsAccount?: Maybe<AccountLess>;
  hasDho?: Maybe<Scalars['Boolean']['output']>;
  hasDhv?: Maybe<Scalars['Boolean']['output']>;
  hasSupportTeam?: Maybe<Scalars['Boolean']['output']>;
  hasTilsyn?: Maybe<Scalars['Boolean']['output']>;
  markedForDeletion: Scalars['Boolean']['output'];
  markedForDeletionAt?: Maybe<Scalars['dateTime']['output']>;
  morpheanAccount?: Maybe<AccountLess>;
  name: Scalars['ID']['output'];
  patientRealm?: Maybe<Scalars['String']['output']>;
  patientSessionLifespan?: Maybe<Scalars['Int']['output']>;
  safemateAccount?: Maybe<AccountLess>;
  sendGridAccount?: Maybe<AccountLess>;
  service?: Maybe<Service>;
  serviceId?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<HealthProviderSettings>;
  skyresponseAccount?: Maybe<AccountLess>;
  taskCodesForJournaling?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tcifAccount?: Maybe<AccountLess>;
  timeZone?: Maybe<Scalars['String']['output']>;
  twilioAccount?: Maybe<AccountLess>;
  url?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['String']['output']>;
  userSessionLifespan?: Maybe<Scalars['Int']['output']>;
  videonorAccount?: Maybe<AccountLess>;
};

export type HealthProviderAuthOptions = {
  externalIdP?: Maybe<Array<IdentityProvider>>;
  ipRestriction?: Maybe<Scalars['Boolean']['output']>;
  timeLimitedAccess?: Maybe<Scalars['Boolean']['output']>;
  twoFactorSms?: Maybe<Scalars['Boolean']['output']>;
};

export type HealthProviderInput = {
  createPatientRealm?: InputMaybe<Scalars['Boolean']['input']>;
  defaultApplication?: InputMaybe<Scalars['String']['input']>;
  defaultLocale?: InputMaybe<Scalars['String']['input']>;
  defaultRoleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dialoggCode?: InputMaybe<Scalars['String']['input']>;
  disablePasswordForDialoggUsers?: InputMaybe<Scalars['Boolean']['input']>;
  disablePasswordForUsers?: InputMaybe<Scalars['Boolean']['input']>;
  displayName: Scalars['String']['input'];
  externalHumanIdTypeIdForDialoggUser?: InputMaybe<Scalars['String']['input']>;
  externalHumanIdTypeIdForPatient?: InputMaybe<Scalars['String']['input']>;
  externalHumanIdTypeIdForUser?: InputMaybe<Scalars['String']['input']>;
  externalHumanIdTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hasDho?: InputMaybe<Scalars['Boolean']['input']>;
  hasDhv?: InputMaybe<Scalars['Boolean']['input']>;
  hasSupportTeam?: InputMaybe<Scalars['Boolean']['input']>;
  hasTilsyn?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['ID']['input'];
  taskCodesForJournaling?: InputMaybe<Array<Scalars['String']['input']>>;
  timeZone: Scalars['String']['input'];
  topLevelRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
  usage: Scalars['String']['input'];
};

export type HealthProviderLess = {
  customerName?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  features?: Maybe<FeatureFlags>;
  hasDho: Scalars['Boolean']['output'];
  hasDhv: Scalars['Boolean']['output'];
  hasSupportTeam: Scalars['Boolean']['output'];
  hasTilsyn: Scalars['Boolean']['output'];
  name: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['String']['output']>;
};

export type HealthProviderMutationResponse = {
  healthProvider?: Maybe<HealthProvider>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type HealthProviderSettings = {
  externalHumanIdTypes?: Maybe<Array<ExternalHumanIdType>>;
  patientAuth?: Maybe<HealthProviderAuthOptions>;
  userAuth?: Maybe<HealthProviderAuthOptions>;
};

export type HealthProviderUpdateInput = {
  defaultApplication?: InputMaybe<Scalars['String']['input']>;
  defaultLocale?: InputMaybe<Scalars['String']['input']>;
  dialoggCode?: InputMaybe<Scalars['String']['input']>;
  disablePasswordForDialoggUsers?: InputMaybe<Scalars['Boolean']['input']>;
  disablePasswordForUsers?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  externalHumanIdTypeIdForDialoggUser?: InputMaybe<Scalars['String']['input']>;
  externalHumanIdTypeIdForPatient?: InputMaybe<Scalars['String']['input']>;
  externalHumanIdTypeIdForUser?: InputMaybe<Scalars['String']['input']>;
  hasDho?: InputMaybe<Scalars['Boolean']['input']>;
  hasDhv?: InputMaybe<Scalars['Boolean']['input']>;
  hasTilsyn?: InputMaybe<Scalars['Boolean']['input']>;
  taskCodesForJournaling?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  usage?: InputMaybe<Scalars['String']['input']>;
};

export type HelseIdAccount = {
  accountDisplayName: Scalars['String']['output'];
  credentials?: Maybe<HelseIdCredentials>;
  id: Scalars['ID']['output'];
  organizationNumber: Scalars['String']['output'];
};

export type HelseIdAccountCreateInput = {
  accountDisplayName: Scalars['String']['input'];
  helseIdCredentials: HelseIdCredentialsInput;
  organizationNumber: Scalars['String']['input'];
};

export type HelseIdAccountMutationResponse = {
  helseIdAccount?: Maybe<HelseIdAccount>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type HelseIdAccountUpdateInput = {
  accountDisplayName: Scalars['String']['input'];
  authority: Scalars['String']['input'];
  organizationNumber: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']>;
};

export type HelseIdCredentials = {
  authority: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  grantTypes: Array<Scalars['String']['output']>;
  maskedPrivateJwk: Scalars['String']['output'];
  maskedRsaPrivateKey: Scalars['String']['output'];
  rsaKeyExpiryDate: Scalars['dateTime']['output'];
  rsaKeySizeBits: Scalars['Int']['output'];
  scopes: Array<Scalars['String']['output']>;
  secretType: Scalars['String']['output'];
};

export type HelseIdCredentialsInput = {
  authority: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientName: Scalars['String']['input'];
  grantTypes: Array<Scalars['String']['input']>;
  privateJwk: Scalars['String']['input'];
  rsaKeyExpiryDate: Scalars['String']['input'];
  rsaKeySizeBits: Scalars['Int']['input'];
  rsaPrivateKey?: InputMaybe<Scalars['String']['input']>;
  scopes: Array<Scalars['String']['input']>;
  secretType: Scalars['String']['input'];
};

export type HourlyPatientStats = {
  alarmEvents?: Maybe<Scalars['Int']['output']>;
  alarms?: Maybe<Scalars['Int']['output']>;
  deviceObservations?: Maybe<Scalars['Int']['output']>;
  endTimestamp?: Maybe<Scalars['dateTime']['output']>;
  manualObservations?: Maybe<Scalars['Int']['output']>;
  openAlarms?: Maybe<Scalars['Int']['output']>;
  openTasks?: Maybe<Scalars['Int']['output']>;
  patientGroupId?: Maybe<Scalars['String']['output']>;
  patientGroupName?: Maybe<Scalars['String']['output']>;
  questionnaireResponses?: Maybe<Scalars['Int']['output']>;
  startTimestamp?: Maybe<Scalars['dateTime']['output']>;
  subscribedResponders?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['dateTime']['output']>;
};

export type HourlyPatientStatsPaginated = {
  count?: Maybe<Scalars['Int']['output']>;
  stats: Array<HourlyPatientStats>;
};

export type HourlyPatientStatsPaginatedCountArgs = {
  countFrom?: InputMaybe<Scalars['dateTime']['input']>;
  countTo?: InputMaybe<Scalars['dateTime']['input']>;
};

export type HourlyUserStats = {
  dialoggUsersExternalLoginCount: Scalars['Int']['output'];
  dialoggUsersLoginCount: Scalars['Int']['output'];
  dialoggUsersLoginErrorCount: Scalars['Int']['output'];
  dialoggUserskeycloakLoginCount: Scalars['Int']['output'];
  endTimestamp?: Maybe<Scalars['dateTime']['output']>;
  externalLoginCount: Scalars['Int']['output'];
  keycloakLoginCount: Scalars['Int']['output'];
  loginCount: Scalars['Int']['output'];
  loginErrorCount: Scalars['Int']['output'];
  startTimestamp?: Maybe<Scalars['dateTime']['output']>;
  timestamp: Scalars['dateTime']['output'];
};

export type HourlyUserStatsPaginated = {
  count: Scalars['Int']['output'];
  stats: Array<HourlyUserStats>;
};

export type HpTaskAndPatientTasks = {
  patientTasks: Array<Maybe<Task>>;
  task: Task;
};

export type HumanName = {
  family?: Maybe<Scalars['String']['output']>;
  given?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HumanNameInput = {
  family?: InputMaybe<Scalars['String']['input']>;
  given?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Identifier = {
  system?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CodeableConcept>;
  use?: Maybe<IdentifierUse>;
  value?: Maybe<Scalars['String']['output']>;
};

export type IdentifierInput = {
  system?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CodeableConceptInput>;
  use?: InputMaybe<IdentifierUse>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum IdentifierUse {
  Official = 'official',
  Secondary = 'secondary',
  Usual = 'usual',
}

export type IdentityProvider = {
  alias?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  support?: Maybe<Scalars['Boolean']['output']>;
  usernamePolicy?: Maybe<Scalars['String']['output']>;
};

export enum ImageQuality {
  Bad = 'BAD',
  Badnight = 'BADNIGHT',
  Good = 'GOOD',
  Other = 'OTHER',
}

export type ImportAlarmTemplatesFromDefaultResponse = {
  importedTemplates: Array<ImportTemplateResponse>;
  success: Scalars['Boolean']['output'];
};

export type ImportDevicesInput = {
  devices: Array<WelfareDeviceCreateInput>;
};

export type ImportDevicesResponse = {
  devices: Array<WelfareDevice>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImportTemplateResponse = {
  code: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type InconsistentHealthProviderReport = {
  healthProviderRealmName?: Maybe<Scalars['String']['output']>;
  patientRealmName?: Maybe<Scalars['String']['output']>;
  registryHealthProviderName?: Maybe<Scalars['String']['output']>;
};

export type InconsistentHealthProviderReportInput = {
  healthProviderRealmName?: InputMaybe<Scalars['String']['input']>;
  patientRealmName?: InputMaybe<Scalars['String']['input']>;
  registryHealthProviderName?: InputMaybe<Scalars['String']['input']>;
};

export type InputValidationResult = {
  errors?: Maybe<Array<Maybe<ValidationError>>>;
  message?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type IotCommsLogs = {
  logs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type IotcommsConfig = {
  trunks: Array<IotcommsTrunk>;
};

export type IotcommsNotificationSettingsMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  notificationSettings?: Maybe<IotcommsNotificationSettingsResponse>;
  success: Scalars['Boolean']['output'];
};

export type IotcommsNotificationSettingsResponse = {
  alarmEventsRestEndpoint?: Maybe<Scalars['String']['output']>;
  alarmTopic?: Maybe<Scalars['String']['output']>;
  alarmbridgeCallbackEndpoint?: Maybe<Scalars['String']['output']>;
  httpTimeout?: Maybe<Scalars['Int']['output']>;
  requireUpdate?: Maybe<Array<Scalars['String']['output']>>;
  restAuthentication?: Maybe<Scalars['String']['output']>;
  sipEventsRestEndpoint?: Maybe<Scalars['String']['output']>;
  sipEventsTopic?: Maybe<Scalars['String']['output']>;
  useHttpEvents?: Maybe<Scalars['Boolean']['output']>;
};

export type IotcommsSipConfig = {
  destinationAddressPrimary: Scalars['String']['output'];
  destinationAddressSecondary?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sipFrom: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
};

export type IotcommsSipConfigCreateInput = {
  destinationAddressPrimary: Scalars['String']['input'];
  destinationAddressSecondary?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  sipFrom: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
};

export type IotcommsTrunk = {
  destinationMatchRegexp?: Maybe<Scalars['String']['output']>;
  destinationTargetDomain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  whitelistedIps?: Maybe<Array<Scalars['String']['output']>>;
};

export type IotcommsTrunkInput = {
  destinationMatchRegexp: Scalars['String']['input'];
  destinationTargetDomain: Scalars['String']['input'];
  whitelistedIps: Array<Scalars['String']['input']>;
};

export type IotcommsTrunkMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  trunk?: Maybe<IotcommsTrunk>;
};

export type JournalConfigForPatient = {
  remotePatientMonitoring: RemotePatientMonitoringConfigForPatient;
  remoteSupervision: RemoteSupervisionConfigForPatient;
};

export type JournalConfigForUserGroup = {
  forUserGroupId: Scalars['ID']['output'];
  inheritedFromUserGroup?: Maybe<Scalars['ID']['output']>;
  monitoringEmailAddresses: Array<Scalars['String']['output']>;
  read: JournalConfigRead;
  remotePatientMonitoring: JournalConfigRemotePatientMonitoring;
  remoteSupervision: JournalConfigRemoteSupervision;
  vkpAccountId: Scalars['ID']['output'];
};

export type JournalConfigForUserGroupInput = {
  monitoringEmailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  read?: InputMaybe<JournalConfigReadInput>;
  remotePatientMonitoring?: InputMaybe<JournalConfigRemotePatientMonitoringInput>;
  remoteSupervision?: InputMaybe<JournalConfigRemoteSupervisionInput>;
  vkpAccountId: Scalars['ID']['input'];
};

export type JournalConfigMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  journalConfigForUserGroup?: Maybe<JournalConfigForUserGroup>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type JournalConfigRead = {
  apiUrl?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  features?: Maybe<JournalConfigReadFeatures>;
};

export type JournalConfigReadFeatures = {
  hasCreatePatientFromVkp: Scalars['Boolean']['output'];
  responseCenter: JournalConfigResponseCenterFeatures;
};

export type JournalConfigReadFeaturesInput = {
  hasCreatePatientFromVkp: Scalars['Boolean']['input'];
  responseCenter: JournalConfigResponseCenterFeaturesInput;
};

export type JournalConfigReadInput = {
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  features?: InputMaybe<JournalConfigReadFeaturesInput>;
};

export type JournalConfigRemotePatientMonitoring = {
  apiUrl?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  isLabModuleEnabled?: Maybe<Scalars['Boolean']['output']>;
  journalingDisabledForPatientGroupIds: Array<Scalars['String']['output']>;
  taskCodesForJournaling?: Maybe<Array<Scalars['String']['output']>>;
};

export type JournalConfigRemotePatientMonitoringInput = {
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  isLabModuleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  journalingDisabledForPatientGroupIds: Array<Scalars['String']['input']>;
  taskCodesForJournaling?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type JournalConfigRemoteSupervision = {
  apiUrl?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  journalingDisabledForPatientGroupIds: Array<Scalars['String']['output']>;
};

export type JournalConfigRemoteSupervisionInput = {
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  journalingDisabledForPatientGroupIds: Array<Scalars['String']['input']>;
};

export type JournalConfigResponseCenterFeatures = {
  hasCarePlanRead: Scalars['Boolean']['output'];
  hasEpisodesOfCareRead: Scalars['Boolean']['output'];
  hasPatientRead: Scalars['Boolean']['output'];
};

export type JournalConfigResponseCenterFeaturesInput = {
  hasCarePlanRead: Scalars['Boolean']['input'];
  hasEpisodesOfCareRead: Scalars['Boolean']['input'];
  hasPatientRead: Scalars['Boolean']['input'];
};

export type JournalInput = {
  journal: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type JournalWorkflow = {
  completedAt?: Maybe<Scalars['dateTime']['output']>;
  completionOptions?: Maybe<Array<Scalars['String']['output']>>;
  debugDetails?: Maybe<Scalars['String']['output']>;
  freeTextNote?: Maybe<Scalars['String']['output']>;
  nextRetry?: Maybe<Scalars['dateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  retriedAt?: Maybe<Array<Maybe<Scalars['dateTime']['output']>>>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userGroupId?: Maybe<Scalars['String']['output']>;
};

export type Language = {
  language: Scalars['String']['output'];
  preferred: Scalars['Boolean']['output'];
};

export type LanguageCode = {
  code: Scalars['String']['output'];
};

export type LanguageInput = {
  language: Scalars['String']['input'];
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LastMeasurement = {
  count?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['dateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Link = {
  other?: Maybe<Reference>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LinkedHealthProvider = {
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ListAddress = {
  addressLine?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Scalars['String']['output']>;
};

export type ListAlarm = {
  authoredOn: Scalars['dateTime']['output'];
  code?: Maybe<CodeableConcept>;
  directRoutingDetails?: Maybe<DirectRoutingDetails>;
  id: Scalars['ID']['output'];
  input?: Maybe<Array<Maybe<TaskInput>>>;
  locationTraces?: Maybe<Array<LocationTrace>>;
  owner?: Maybe<Reference>;
  patient?: Maybe<AlarmPatient>;
  priority?: Maybe<Scalars['String']['output']>;
  priorityInput?: Maybe<TaskInput>;
  status: Scalars['String']['output'];
};

export type ListCamera = {
  createdAt: Scalars['dateTime']['output'];
  deviceGroup?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastSeen?: Maybe<Scalars['dateTime']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  /** Has the camera been temporarily put in privacy mode? */
  privacyMode?: Maybe<Scalars['Boolean']['output']>;
  privacyModeUntil?: Maybe<Scalars['dateTime']['output']>;
  registeredInInventory?: Maybe<Scalars['Boolean']['output']>;
  routeMac?: Maybe<Scalars['String']['output']>;
  routerVendor?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  topPriorityAlarm?: Maybe<EquipmentAlarm>;
  ttl?: Maybe<Scalars['Int']['output']>;
  userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
};

export type ListPatient = {
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['dateTime']['output'];
  devices: Array<PatientListDevice>;
  externalIds: Array<PatientListExternalIds>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  openSyncAlarmId?: Maybe<Scalars['String']['output']>;
  patientGroupNames: Array<Scalars['String']['output']>;
  primaryAddress?: Maybe<ListAddress>;
  rpmLastActive?: Maybe<Scalars['dateTime']['output']>;
  secretAddress: Scalars['Boolean']['output'];
  shareAlarmWithPatients?: Maybe<Array<SharedAlarmPatients>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type LocaleEntry = {
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  localeId: Scalars['String']['output'];
};

export type LocaleEntryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  localeId: Scalars['String']['input'];
};

export type LocationTrace = {
  forDeviceId: Scalars['String']['output'];
  gpsLocations: Array<GpsLocation>;
  latestGpsLocation?: Maybe<GpsLocation>;
};

export type MeasurementDevice = {
  id: Scalars['ID']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  modelNumber?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type MedicalState = {
  symptoms?: Maybe<Array<Scalars['String']['output']>>;
  treatments?: Maybe<Array<Scalars['String']['output']>>;
};

export type MedicalStateInput = {
  symptoms?: InputMaybe<Array<Scalars['String']['input']>>;
  treatments?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MedicalStates = {
  green: MedicalState;
  red: MedicalState;
  yellow: MedicalState;
};

export type MedicalStatesInput = {
  green: MedicalStateInput;
  red: MedicalStateInput;
  yellow: MedicalStateInput;
};

export type Migration = {
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type MorpheanAccount = {
  accountDisplayName: Scalars['String']['output'];
  customerId?: Maybe<Scalars['Int']['output']>;
  customerIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  id: Scalars['ID']['output'];
  server: Scalars['String']['output'];
};

export type MorpheanAccountCreateInput = {
  accountDisplayName: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['Int']['input']>;
  customerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  server?: InputMaybe<Scalars['String']['input']>;
};

export type MorpheanAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  morpheanAccount?: Maybe<MorpheanAccount>;
  success: Scalars['Boolean']['output'];
};

export type MorpheanAccountUpdateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  server?: InputMaybe<Scalars['String']['input']>;
};

export type MorpheanSite = {
  siteId: Scalars['Int']['output'];
  siteName: Scalars['String']['output'];
};

export type MorpheanSitesForMorpheanCustomer = {
  customerId: Scalars['Int']['output'];
  customerName: Scalars['String']['output'];
  morpheanSites: Array<MorpheanSite>;
};

export type MoveAccessGroupResponse = {
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MqttClientStatus = {
  connectionStatus: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type MqttConfig = {
  connectionStatus: Scalars['String']['output'];
  state: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Mutation = {
  _?: Maybe<Scalars['ID']['output']>;
  acceptVideoMeetingTask?: Maybe<TaskMutationResponse>;
  activateAlarmTemplate: AlarmTemplateMutationResponse;
  activateAzureProvisioning?: Maybe<AzureProvisioningMutationResponse>;
  activateCarePlan: CarePlanMutationResponse;
  activateCarePlanTemplate: CarePlanMutationResponse;
  activateDialoggUserOtp: Scalars['Boolean']['output'];
  activateDialoggUserSmsOtp: Scalars['Boolean']['output'];
  activateObservationTemplate?: Maybe<ObservationMutationResponse>;
  activateOtp?: Maybe<Scalars['Boolean']['output']>;
  activateQuestionnaireTemplate: QuestionnaireMutationResponse;
  activateSelfTreatmentPlan: SelfTreatmentPlanMutationResponse;
  activateSmsOtp?: Maybe<Scalars['Boolean']['output']>;
  addAccountToCustomer: CustomerMutationResponse;
  addCameraToPatient: CameraMutationResponse;
  addCameraToSetupBatchTelluSupport: Scalars['Boolean']['output'];
  addCareTeam: GenericMutationResponse;
  addDefaultRolesToHealthProvider: GenericMutationResponse;
  addExternalDialoggUserId: DialoggUserMutationResponse;
  addExternalHumanTypeToHealthProvider: Scalars['Boolean']['output'];
  addExternalIdentityProviderToHealthProvider: ExternalIdentityProviderForHealthProviderMutationResponse;
  addExternalPatientIdToPatient: GenericMutationResponse;
  addExternalUserId: UserMutationResponse;
  addGooglemapsAccountToHealthProvider: HealthProviderMutationResponse;
  addMorpheanAccountToHealthProvider: HealthProviderMutationResponse;
  addMyExternalId: UserMutationResponse;
  addNextOfKin: NextOfKinMutationResponse;
  addNotesToAlarm: TaskMutationResponse;
  addNotesToTask?: Maybe<TaskMutationResponse>;
  addNotesToTechnicalAlarm: TaskMutationResponse;
  addPatientAlarmHandling: AlarmActivityMutationResponse;
  addPatientAlarmHandlingWithoutTemplate: AlarmActivityMutationResponse;
  addPatientByExternalId?: Maybe<PatientMutationResponse>;
  addPatientContact: GenericMutationResponse;
  addPlannedSupervision?: Maybe<PlannedSupervisionMutationResponse>;
  addPlannedVideoMeeting?: Maybe<PlannedVideoMeetingMutationResponse>;
  addReferenceRangeToPatient?: Maybe<ObservationMutationResponse>;
  addRpmGatewayToPatient: RpmGatewayMutationResponse;
  addRpmMedicalDeviceToPatient: RpmMedicalDeviceMutationResponse;
  addRpmMedicalDeviceToRpmGateway: RpmGatewayMutationResponse;
  addSafemateAccountToHealthProvider: HealthProviderMutationResponse;
  addSendGridAccountToHealthProvider: HealthProviderMutationResponse;
  addShareSkyresponseAlarmWithPatient?: Maybe<PatientMutationResponse>;
  addSkyresponseAccountToHealthProvider: HealthProviderMutationResponse;
  addTagToPatient?: Maybe<PatientMutationResponse>;
  addTcifAccountToHealthProvider: HealthProviderMutationResponse;
  addTwilioAccountToHealthProvider: HealthProviderMutationResponse;
  addUserGroupContact: GenericMutationResponse;
  addUserReservation?: Maybe<Scalars['Boolean']['output']>;
  addUserToRole?: Maybe<GenericMutationResponse>;
  addVideonorAccountToHealthProvider: HealthProviderMutationResponse;
  addWelfareDeviceToPatient: WelfareDeviceMutationResponse;
  assignPatientToDialoggUser: DialoggUserMutationResponse;
  cameraAppBulkUpdate: Scalars['Boolean']['output'];
  cameraFirmwareBulkUpgrade: Scalars['Boolean']['output'];
  cameraNetworkingBulkUpdate: Scalars['Boolean']['output'];
  cancelCarePlan: CarePlanMutationResponse;
  cancelDialoggUserOtp: Scalars['Boolean']['output'];
  cancelOtp?: Maybe<Scalars['Boolean']['output']>;
  cancelSkyresponseSyncAlarm: TaskMutationResponse;
  cancelVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  changePicturePermission: DialoggUserMutationResponse;
  cleanupAlarmActivities: Scalars['String']['output'];
  clearRpmMedicalDeviceFromRpmGateway: RpmGatewayMutationResponse;
  clearRpmMedicalDevicePairingWithRpmGateway: RpmGatewayMutationResponse;
  completeAlarm: TaskMutationResponse;
  completeCarePlan: CarePlanMutationResponse;
  completeCarePlanTemplate: CarePlanMutationResponse;
  completeCompositeTask?: Maybe<TaskMutationResponse>;
  completeCompositeTaskAndItsSubTasks?: Maybe<TaskMutationResponse>;
  completeSubTask?: Maybe<TaskMutationResponse>;
  configureCamera: RegistryDeviceMutationResponse;
  configureCameraEvents: CameraMutationResponse;
  correctValidationRules: Scalars['String']['output'];
  createAlarmRoute?: Maybe<AlarmRoute>;
  createAlarmSubscription?: Maybe<AlarmSubscriptionMutationResponse>;
  createAlarmTemplate: AlarmTemplateMutationResponse;
  createAlmaForwarder: GenericMutationResponse;
  createAscomForwarder: GenericMutationResponse;
  createCamera: CameraMutationResponse;
  /** Set a new view preset for a camera */
  createCameraViewPreset: Scalars['Boolean']['output'];
  createCarePlanBasedOnExisting: CarePlanMutationResponse;
  createCarePlanForPatient: CarePlanMutationResponse;
  createCarePlanTemplate: CarePlanMutationResponse;
  createCarePlanTemplateBasedOnExisting: CarePlanMutationResponse;
  createCmpAccount: CmpAccountMutationResponse;
  createCommunication: CommunicationMutationResponse;
  createCommunicationToSeveral: Array<CommunicationMutationResponse>;
  createCustomer: CustomerMutationResponse;
  createDefaultRoleDefinition: RoleDefinitionMutationResponse;
  createDeviceGroup: DeviceGroupMutationResponse;
  createDialoggUser: DialoggUserMutationResponse;
  createDocument?: Maybe<DocumentReferenceMutationResult>;
  createExternalHumanIdType: ExternalHumanIdTypeMutationResponse;
  createGooglemapsAccount: GooglemapsAccountMutationResponse;
  createHealthProvider: HealthProviderMutationResponse;
  createHelseIdAccount: HelseIdAccountMutationResponse;
  createIotcommsSipConfig: ConfigMutationResponse;
  createJournalConfigForUserGroup: JournalConfigMutationResponse;
  createMorpheanAccount: MorpheanAccountMutationResponse;
  createObservationForActivityInCarePlan: ObservationMutationResponse;
  createObservationForActivityInCarePlanTemplate: ObservationMutationResponse;
  createObservationTemplate?: Maybe<ObservationMutationResponse>;
  createPatient?: Maybe<PatientMutationResponse>;
  createPatientGoals: SelfTreatmentPlanMutationResponse;
  createPatientGroup?: Maybe<PatientGroupMutationResponse>;
  createPatientInGroup?: Maybe<PatientMutationResponse>;
  createPatientMedicalStates: SelfTreatmentPlanMutationResponse;
  createPatientRealm: HealthProviderMutationResponse;
  createQuestionnaireForActivityInCarePlan: QuestionnaireMutationResponse;
  createQuestionnaireForActivityInCarePlanTemplate: QuestionnaireMutationResponse;
  createQuestionnaireTemplate: QuestionnaireMutationResponse;
  createRegistryDevice: RegistryDeviceMutationResponse;
  createRole: RoleMutationResponse;
  createRoleDefinition: RoleDefinitionMutationResponse;
  createRpmGateway: RpmGatewayMutationResponse;
  createRpmMedicalDevice: RpmMedicalDeviceMutationResponse;
  createSafemateAccount: SafemateAccountMutationResponse;
  createSelfTreatmentPlanTemplate: SelfTreatmentPlanMutationResponse;
  createSendGridAccount: SendGridAccountMutationResponse;
  createShiftSessionForPatientGroups?: Maybe<ShiftSession>;
  createSipConfigFor: ConfigMutationResponse;
  createSkyresponseAccount: SkyresponseAccountMutationResponse;
  createSkyresponseForwarderConfig: ConfigMutationResponse;
  createTcifAccount: TcifAccountMutationResponse;
  createTimeLimitedFhirCredentialsForHealthProvider: Scalars['String']['output'];
  createTwilioAccount: TwilioAccountMutationResponse;
  createUnplannedSupervision: TaskMutationResponse;
  createUser?: Maybe<UserMutationResponse>;
  createUserGroup: UserGroupMutationResponse;
  createUserManual: UserManualMutationResponse;
  createVideonorAccount: VideonorAccountMutationResponse;
  createVkpAccount: VkpAccountMutationResponse;
  createWelfareDevice: WelfareDeviceMutationResponse;
  deactivateDialoggUserSmsOtp: Scalars['Boolean']['output'];
  deactivateSelfTreatmentPlan: SelfTreatmentPlanMutationResponse;
  deactivateSmsOtp?: Maybe<Scalars['Boolean']['output']>;
  decommissionCameras: Scalars['Boolean']['output'];
  decommissionCamerasLimited: Scalars['Boolean']['output'];
  deleteAlarmRoute?: Maybe<Scalars['Boolean']['output']>;
  deleteAlarmSubscription?: Maybe<AlarmSubscriptionMutationResponse>;
  deleteAlarmTemplate: AlarmTemplateMutationResponse;
  deleteAlmaForwarder: GenericMutationResponse;
  deleteAppDeviceForPatient: AppDeviceMutationResponse;
  deleteAscomForwarder: GenericMutationResponse;
  deleteCameraViewPreset: Scalars['Boolean']['output'];
  deleteCmpAccount: CmpAccountMutationResponse;
  deleteCustomer: CustomerMutationResponse;
  deleteDefaultRoleDefinition: RoleDefinitionMutationResponse;
  deleteDeviceGroup: GenericMutationResponse;
  deleteDialoggUser: DialoggUserMutationResponse;
  deleteDialoggUserOtp: Scalars['Boolean']['output'];
  deleteDocument?: Maybe<DocumentReferenceMutationResult>;
  deleteDraftCarePlan: CarePlanMutationResponse;
  deleteDraftCarePlanTemplate: CarePlanMutationResponse;
  deleteEscalationDelay: GenericMutationResponse;
  deleteExternalAccess: Scalars['Boolean']['output'];
  deleteExternalHumanIdType: ExternalHumanIdTypeMutationResponse;
  deleteExternalIdentityProviderFromHealthProvider: ExternalIdentityProviderForHealthProviderMutationResponse;
  deleteExternalIdentityProviderRedirectorFromHealthProvider?: Maybe<GenericMutationResponse>;
  deleteGooglemapsAccount: GooglemapsAccountMutationResponse;
  deleteHealthProvider: HealthProviderMutationResponse;
  deleteHelseIdAccount: HelseIdAccountMutationResponse;
  deleteInconsistentHealthProvider: HealthProviderMutationResponse;
  deleteIotcommsSipConfig: ConfigMutationResponse;
  deleteIotcommsTrunk: IotcommsTrunkMutationResponse;
  deleteJournalConfigForUserGroup: JournalConfigMutationResponse;
  deleteMorpheanAccount: MorpheanAccountMutationResponse;
  deleteNextOfKin: NextOfKinMutationResponse;
  deleteObservationTemplate?: Maybe<ObservationMutationResponse>;
  deleteOldServiceResponsibleRole: GenericMutationResponse;
  deleteOtp?: Maybe<Scalars['Boolean']['output']>;
  deletePatient?: Maybe<PatientMutationResponse>;
  deleteQuestionnaireResponse?: Maybe<QuestionnaireResponseMutationResponse>;
  deleteQuestionnaireTemplate: QuestionnaireMutationResponse;
  deleteRegistryDevice: RegistryDeviceMutationResponse;
  deleteRole: GenericMutationResponse;
  deleteRoleDefinition: RoleDefinitionMutationResponse;
  deleteRpmGateway: RpmGatewayMutationResponse;
  deleteRpmMedicalDevice: RpmMedicalDeviceMutationResponse;
  deleteSafemateAccount: SafemateAccountMutationResponse;
  deleteSendGridAccount: SendGridAccountMutationResponse;
  deleteSipConfig: ConfigMutationResponse;
  deleteSkyresponseAccount: SkyresponseAccountMutationResponse;
  deleteSkyresponseForwarderConfig: ConfigMutationResponse;
  deleteTcifAccount: TcifAccountMutationResponse;
  deleteTellucareIntegration: Scalars['Boolean']['output'];
  deleteTwilioAccount: TwilioAccountMutationResponse;
  deleteUser?: Maybe<GenericMutationResponse>;
  deleteUserGroup: UserGroupMutationResponse;
  deleteUserManual: UserManualMutationResponse;
  deleteVideonorAccount: VideonorAccountMutationResponse;
  deleteVkpAccount: VkpAccountMutationResponse;
  deleteWelfareDevice: WelfareDeviceMutationResponse;
  disableBeta: FeatureFlagMutationResponse;
  disableContinuousSupervision: FeatureFlagMutationResponse;
  disableJoinNhnMeeting: FeatureFlagMutationResponse;
  disableKomp: FeatureFlagMutationResponse;
  disableSelfTreatmentPlan: FeatureFlagMutationResponse;
  disableSendNotificationToNextOfKin: FeatureFlagMutationResponse;
  disableUserPassword?: Maybe<Scalars['Boolean']['output']>;
  enableBeta: FeatureFlagMutationResponse;
  enableContinuousSupervision: FeatureFlagMutationResponse;
  enableJoinNhnMeeting: FeatureFlagMutationResponse;
  enableKomp: FeatureFlagMutationResponse;
  enableSelfTreatmentPlan: FeatureFlagMutationResponse;
  enableSendNotificationToNextOfKin: FeatureFlagMutationResponse;
  enableUserPassword?: Maybe<Scalars['Boolean']['output']>;
  endJoinVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  endVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  executeDatabaseSchemaSync: Array<DatabaseSchemaSyncResponse>;
  executeMigration: Array<DatabaseSchemaMigration>;
  forceDeleteDialoggUser: DialoggUserMutationResponse;
  hideTechnicalAlarmNotificationsForPatientGroup?: Maybe<PatientGroupMutationResponse>;
  importAlarmTemplates: GenericMutationResponse;
  importAlarmTemplatesFromDefault: ImportAlarmTemplatesFromDefaultResponse;
  importDevicesFromSafematePro: ImportDevicesResponse;
  importMeasurementTemplatesFromDefault: Array<ImportTemplateResponse>;
  importObservationTemplates: GenericMutationResponse;
  initializeExternalAccess: ExternalAccessCreateResponse;
  inviteToVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  /** Keep a video stream alive */
  keepStreamAlive: CameraStream;
  logLocalExport: GenericMutationResponse;
  markCommunicationAsRead: CommunicationMutationResponse;
  markHealthProviderForDeletion: HealthProviderMutationResponse;
  markNextOfKinAsMain?: Maybe<GenericMutationResponse>;
  migrateOwnerDatabase: Array<DatabaseSchemaMigration>;
  migrateServiceResponsibleRole: GenericMutationResponse;
  moveAccessGroup: MoveAccessGroupResponse;
  notifyNextOfKins?: Maybe<Array<NotificationLogResponse>>;
  openPatientGroupsForExternalAccess?: Maybe<GenericMutationResponse>;
  orderPatientContacts: GenericMutationResponse;
  orderUserGroupContacts: GenericMutationResponse;
  pauseHealthProviderDeletion: Scalars['Boolean']['output'];
  planVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  previewDatabaseSchemaSync: Array<DatabaseSchemaSyncResponse>;
  provisionIotcommsTrunk: IotcommsTrunkMutationResponse;
  putPatientAlarmHandlingPlanOnHold: GenericMutationResponse;
  reboot: Scalars['Boolean']['output'];
  redoCameraSetupTelluSupport: Scalars['Boolean']['output'];
  refreshAzureProvisioningSecret?: Maybe<AzureProvisioningMutationResponse>;
  registerPushIdForShiftSession?: Maybe<GenericMutationResponse>;
  registerPushSubscription?: Maybe<GenericMutationResponse>;
  rejectCompositeTask?: Maybe<TaskMutationResponse>;
  rejectSubTask?: Maybe<TaskMutationResponse>;
  releaseVideoMeetingTask?: Maybe<TaskMutationResponse>;
  removeAccountFromCustomer: CustomerMutationResponse;
  removeCameraFromPatient: CameraMutationResponse;
  removeCareTeam: GenericMutationResponse;
  removeDefaultRolesFromHealthProvider: GenericMutationResponse;
  removeDialoggUserPassword: DialoggUserMutationResponse;
  removeExternalDialoggUserId: DialoggUserMutationResponse;
  removeExternalHumanTypeFromHealthProvider: Scalars['Boolean']['output'];
  removeExternalPatientIdFromPatient: GenericMutationResponse;
  removeExternalUserId: UserMutationResponse;
  removeGooglemapsAccountFromHealthProvider: HealthProviderMutationResponse;
  removeMorpheanAccountFromHealthProvider: HealthProviderMutationResponse;
  removeMyExternalId: UserMutationResponse;
  removePatientAlarmHandling: AlarmActivityMutationResponse;
  removePatientContact: GenericMutationResponse;
  removePatientFromDialoggUser: DialoggUserMutationResponse;
  removePatientGroupFromUserGroup?: Maybe<GenericMutationResponse>;
  removePlannedSupervision?: Maybe<PlannedSupervisionMutationResponse>;
  removePlannedVideoMeeting?: Maybe<PlannedVideoMeetingMutationResponse>;
  removeReferenceRangeFromPatient?: Maybe<ObservationMutationResponse>;
  removeRpmGatewayFromPatient: RpmGatewayMutationResponse;
  removeRpmMedicalDeviceFromPatient: RpmMedicalDeviceMutationResponse;
  removeSafemateAccountFromHealthProvider: HealthProviderMutationResponse;
  removeSendGridAccountFromHealthProvider: HealthProviderMutationResponse;
  removeSkyresponseAccountFromHealthProvider: HealthProviderMutationResponse;
  removeTagFromPatient?: Maybe<PatientMutationResponse>;
  removeTcifAccountFromHealthProvider: HealthProviderMutationResponse;
  removeTwilioAccountFromHealthProvider: HealthProviderMutationResponse;
  removeUserFromRole?: Maybe<GenericMutationResponse>;
  removeUserGroupContact: GenericMutationResponse;
  removeUserReservation?: Maybe<Scalars['Boolean']['output']>;
  removeVideonorAccountFromHealthProvider: HealthProviderMutationResponse;
  removeWelfareDeviceFromPatient: WelfareDeviceMutationResponse;
  replaceWelfareDeviceIdentifier: WelfareDeviceMutationResponse;
  rescheduleVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  resetCameraSetupBatchTelluSupport: Scalars['Boolean']['output'];
  resetCameraSetupTelluSupport: Scalars['Boolean']['output'];
  resetExternalIdentityProviderLinksForHealthProvider: ExternalIdentityProviderForHealthProviderMutationResponse;
  resetHelseIdCredentials: HelseIdAccountMutationResponse;
  resetMorpheanCacheTelluSupport: Scalars['Boolean']['output'];
  resetSecretForExternalAccess: ExternalAccessCreateResponse;
  resetUserPassword?: Maybe<Scalars['Boolean']['output']>;
  restoreHealthProviderMarkedForDeletion: HealthProviderMutationResponse;
  resumeHealthProviderDeletion: Scalars['Boolean']['output'];
  resumePatientAlarmHandlingPlan: GenericMutationResponse;
  retireAlarmTemplate: AlarmTemplateMutationResponse;
  retireObservationTemplate?: Maybe<ObservationMutationResponse>;
  retireQuestionnaireTemplate: QuestionnaireMutationResponse;
  retryAlarmJournaling: TaskMutationResponse;
  retryTaskJournaling?: Maybe<TaskMutationResponse>;
  revertOwnerDatabase: Array<DatabaseSchemaMigration>;
  revokeInviteToVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  setAnonymizationRequirement: Scalars['Boolean']['output'];
  /** Rotate and zoom for a camera */
  setCameraViewWithAngles: Scalars['Boolean']['output'];
  setCameraViewWithPreset: Scalars['Boolean']['output'];
  setDialoggUserEnabled: DialoggUserMutationResponse;
  setDialoggUserExternalIdP: Scalars['Boolean']['output'];
  setDistanceEstimationToPatientGroup?: Maybe<PatientGroupMutationResponse>;
  setEmailAndSmsNotificationSettingsForShiftSession?: Maybe<ShiftSession>;
  setExternalIdP?: Maybe<Scalars['Boolean']['output']>;
  setExternalIdRequest: Scalars['Boolean']['output'];
  setExternalIdentities?: Maybe<Scalars['Boolean']['output']>;
  setExternalIdentityProviderRedirectorFromHealthProvider?: Maybe<GenericMutationResponse>;
  setOnSiteRegistrationToPatientGroup?: Maybe<PatientGroupMutationResponse>;
  setPatientCamerasInPrivacyMode?: Maybe<Array<CameraMutationResponse>>;
  setupTellucareIntegration: TelluCareIntegrationCreateResponse;
  simulateCarePlanObservationResponse: ObservationMutationResponse;
  simulateCarePlanQuestionnaireResponse: QuestionnaireMutationResponse;
  simulateNovoEvent: GenericMutationResponse;
  simulateSafemateEvent: GenericMutationResponse;
  simulateSkyResponseEvent: GenericMutationResponse;
  simulateSyncEvent: TaskMutationResponse;
  startApp: Scalars['Boolean']['output'];
  startCompositeTask?: Maybe<TaskMutationResponse>;
  startJoinVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  /** Start a video stream */
  startStream: CameraStream;
  startVideoMeeting?: Maybe<VideoMeetingMutationResponse>;
  stopApp: Scalars['Boolean']['output'];
  /** Stop a video stream */
  stopStream: Scalars['Boolean']['output'];
  submitAlarmHandlingFeedback: Scalars['Boolean']['output'];
  submitSupervisionFeeback: FeedbackSeverity;
  supportTeamLinkToHealthProvider: GenericMutationResponse;
  supportTeamUnlinkFromHealthProvider: GenericMutationResponse;
  switchAnonymization: Scalars['Boolean']['output'];
  syncDefaultRoleDefinitions: GenericMutationResponse;
  syncExternalHumanIdTypesWithDefaults: GenericMutationResponse;
  syncPatientInfoWithSkyresponse: MutationResponseWithPagination;
  syncSpecificPatientWithSkyresponse: GenericMutationResponse;
  takeCall: TaskMutationResponse;
  terminateShiftSessionOnAllDevices?: Maybe<Scalars['Boolean']['output']>;
  terminateShiftSessionOnDevice?: Maybe<ShiftSession>;
  testAzureAccountCredentials: TestAzureAccountCredentialsMutationResponse;
  testHelseIdCredentials: Scalars['Boolean']['output'];
  testPushNotification: ReminderStatus;
  testTellucareIntegrationSetup: TestTellucareIntegrationSetupResponse;
  triggerDailyStatCollection: Scalars['Boolean']['output'];
  triggerEventInCamera: Scalars['Boolean']['output'];
  triggerHourlyStatCollection: Scalars['Boolean']['output'];
  triggerResolveActionsForSyncAlarms: GenericMutationResponse;
  unsetPatientCamerasFromPrivacyMode?: Maybe<Array<CameraMutationResponse>>;
  updateAlarmAckTemplates: GenericMutationResponse;
  updateAlarmRoute?: Maybe<GenericMutationResponse>;
  updateAlarmStatus: TaskMutationResponse;
  updateAlarmSubscription?: Maybe<AlarmSubscriptionMutationResponse>;
  updateAlarmTemplate: AlarmTemplateMutationResponse;
  updateAlarmTemplateStatus: GenericMutationResponse;
  updateAlmaForwarder: GenericMutationResponse;
  updateAppDeviceForPatient: AppDeviceMutationResponse;
  updateAscomForwarder: GenericMutationResponse;
  updateAvailableHours: CameraMutationResponse;
  updateAzureAccount: AzureAccountMutationResponse;
  updateCamera: CameraMutationResponse;
  updateCarePlanQuestionnaire: QuestionnaireMutationResponse;
  updateCarePlanTemplateQuestionnaire: QuestionnaireMutationResponse;
  updateCareTeam: GenericMutationResponse;
  updateCmpAccount: CmpAccountMutationResponse;
  updateCompositeTaskPriority?: Maybe<TaskMutationResponse>;
  updateCustomer: CustomerMutationResponse;
  updateDefaultRoleDefinition: RoleDefinitionMutationResponse;
  updateDeviceGroup: DeviceGroupMutationResponse;
  updateDialoggUser: DialoggUserMutationResponse;
  updateDialoggUserIPRestrictions: DialoggUserMutationResponse;
  updateDialoggUserPassword: DialoggUserMutationResponse;
  updateDialoggUserTimeLimitedAccess: DialoggUserMutationResponse;
  updateDraftCarePlan: CarePlanMutationResponse;
  updateDraftCarePlanTemplate: CarePlanMutationResponse;
  updateEscalationDelay: GenericMutationResponse;
  updateExternalHumanIdType: ExternalHumanIdTypeMutationResponse;
  updateExternalIdRequestsOnAzureGroup: AzureGroupMutationResponse;
  updateExternalIdentityProviderForHealthProvider: ExternalIdentityProviderForHealthProviderMutationResponse;
  updateGooglemapsAccount: GooglemapsAccountMutationResponse;
  updateHealthProvider: HealthProviderMutationResponse;
  updateHealthProviderPatientAuth: GenericMutationResponse;
  updateHealthProviderPatientSessionLifespan: GenericMutationResponse;
  updateHealthProviderRolesBasedOnDefaultRoles: GenericMutationResponse;
  updateHealthProviderUserAuth: GenericMutationResponse;
  updateHealthProviderUserSessionLifespan: GenericMutationResponse;
  updateHelseIdAccount: HelseIdAccountMutationResponse;
  updateHelseIdCredentials: HelseIdAccountMutationResponse;
  updateIPRestrictions?: Maybe<GenericMutationResponse>;
  updateInheritedJournalConfigForUserGroup: JournalConfigMutationResponse;
  updateIotcommsNotificationSettings: IotcommsNotificationSettingsMutationResponse;
  updateIotcommsSipConfig: ConfigMutationResponse;
  updateJournalConfigForUserGroup: JournalConfigMutationResponse;
  updateLinkedPatientGroups: UserGroupMutationResponse;
  updateMorpheanAccount: MorpheanAccountMutationResponse;
  updateNameOrIpRestrictionsForExternalAccess: ExternalAccessUpdateResponse;
  updateNextOfKin: NextOfKinMutationResponse;
  updateObservationStatus?: Maybe<ObservationMutationResponse>;
  updateObservationTemplate?: Maybe<ObservationMutationResponse>;
  updateObservationTemplateStatus: GenericMutationResponse;
  updatePatient?: Maybe<PatientMutationResponse>;
  updatePatientAlarmHandling: AlarmActivityMutationResponse;
  updatePatientContact: GenericMutationResponse;
  updatePatientGoals: SelfTreatmentPlanMutationResponse;
  updatePatientGroup?: Maybe<PatientGroupMutationResponse>;
  updatePatientGroupsOfPatient?: Maybe<PatientGroupsMutationResponse>;
  updatePatientLastActive?: Maybe<Scalars['Boolean']['output']>;
  updatePatientMedicalStates: SelfTreatmentPlanMutationResponse;
  updatePatientReferenceRange?: Maybe<ObservationMutationResponse>;
  updatePlannedSupervision?: Maybe<PlannedSupervisionMutationResponse>;
  updatePlannedVideoMeeting?: Maybe<PlannedVideoMeetingMutationResponse>;
  updateQuestionnaireTemplate: QuestionnaireMutationResponse;
  updateRegistryDevice: RegistryDeviceMutationResponse;
  updateRoleDefinition: RoleDefinitionMutationResponse;
  updateRoleDefinitionBasedOn: RoleDefinitionMutationResponse;
  updateRolesOnAzureGroup: AzureGroupMutationResponse;
  updateRpmGateway: RpmGatewayMutationResponse;
  updateRpmMedicalDevice: RpmMedicalDeviceMutationResponse;
  updateSafemateAccount: SafemateAccountMutationResponse;
  updateSelfTreatmentPlanTemplate: SelfTreatmentPlanMutationResponse;
  updateSendGridAccount: SendGridAccountMutationResponse;
  updateSipConfigFor: ConfigMutationResponse;
  updateSkyresponseAccount: SkyresponseAccountMutationResponse;
  updateSkyresponseConfig: GenericMutationResponse;
  updateSkyresponseForwarderConfig: ConfigMutationResponse;
  updateSubTaskPriority?: Maybe<TaskMutationResponse>;
  updateTaskAcceptedAt: TaskMutationResponse;
  updateTaskPresenceAt: TaskMutationResponse;
  updateTcifAccount: TcifAccountMutationResponse;
  updateTechnicalAlarmStatus: TaskMutationResponse;
  updateTellucareIntegration: TelluCareIntegrationUpdateResponse;
  updateTwilioAccount: TwilioAccountMutationResponse;
  updateUser?: Maybe<UserMutationResponse>;
  updateUserGroup: UserGroupMutationResponse;
  updateUserGroupContact: GenericMutationResponse;
  updateUserManual: UserManualMutationResponse;
  updateUserPassword?: Maybe<Scalars['Boolean']['output']>;
  updateUserTimeLimitedAccess?: Maybe<GenericMutationResponse>;
  updateVideonorAccount: VideonorAccountMutationResponse;
  updateVkpAccount: VkpAccountMutationResponse;
  updateWelfareDevice: WelfareDeviceMutationResponse;
  validateCmpAccountTowardsCmp: CmpAccountMutationResponse;
  validateCustomerGroupTowardsCmp: ValidateCustomerGroupTowardsCmpResponse;
};

export type MutationAcceptVideoMeetingTaskArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationActivateAlarmTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationActivateAzureProvisioningArgs = {
  azureAccountId: Scalars['ID']['input'];
};

export type MutationActivateCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
};

export type MutationActivateCarePlanTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationActivateDialoggUserOtpArgs = {
  username?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationActivateDialoggUserSmsOtpArgs = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationActivateObservationTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationActivateOtpArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationActivateQuestionnaireTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationActivateSelfTreatmentPlanArgs = {
  selfTreatmentPlanId: Scalars['ID']['input'];
};

export type MutationActivateSmsOtpArgs = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationAddAccountToCustomerArgs = {
  customerId: Scalars['ID']['input'];
  healthProviderId: Scalars['ID']['input'];
};

export type MutationAddCameraToPatientArgs = {
  availableHours?: InputMaybe<Scalars['String']['input']>;
  cameraId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationAddCameraToSetupBatchTelluSupportArgs = {
  cameraSetupInput: CameraSetupInput;
};

export type MutationAddCareTeamArgs = {
  careTeam: CreateCareTeamInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationAddDefaultRolesToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  roleIds: Array<Scalars['ID']['input']>;
};

export type MutationAddExternalDialoggUserIdArgs = {
  externalUserId: ExternalHumanIdInput;
  username: Scalars['ID']['input'];
};

export type MutationAddExternalHumanTypeToHealthProviderArgs = {
  externalHumanTypeId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
};

export type MutationAddExternalIdentityProviderToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  input: ExternalIdentityProviderForHealthProviderCreateInput;
};

export type MutationAddExternalPatientIdToPatientArgs = {
  externalPatientId: ExternalHumanIdInput;
  patientId: Scalars['ID']['input'];
};

export type MutationAddExternalUserIdArgs = {
  externalUserId: ExternalHumanIdInput;
  userId: Scalars['ID']['input'];
};

export type MutationAddGooglemapsAccountToHealthProviderArgs = {
  googlemapsAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
};

export type MutationAddMorpheanAccountToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  morpheanAccountId: Scalars['ID']['input'];
};

export type MutationAddMyExternalIdArgs = {
  externalUserId: ExternalHumanIdInput;
};

export type MutationAddNextOfKinArgs = {
  nextOfKinInput: CreateNextOfKinInput;
  patientId: Scalars['ID']['input'];
};

export type MutationAddNotesToAlarmArgs = {
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>>>;
  taskId: Scalars['ID']['input'];
};

export type MutationAddNotesToTaskArgs = {
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>>>;
  taskId: Scalars['ID']['input'];
};

export type MutationAddNotesToTechnicalAlarmArgs = {
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>>>;
  taskId: Scalars['ID']['input'];
};

export type MutationAddPatientAlarmHandlingArgs = {
  fromTemplate?: InputMaybe<Scalars['ID']['input']>;
  input: AlarmActivityInput;
  patientId: Scalars['ID']['input'];
};

export type MutationAddPatientAlarmHandlingWithoutTemplateArgs = {
  input: AlarmActivityWithoutTemplateInput;
  patientId: Scalars['ID']['input'];
};

export type MutationAddPatientByExternalIdArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  externalPatientId: ExternalHumanIdInput;
  patientGroupId: Scalars['ID']['input'];
};

export type MutationAddPatientContactArgs = {
  contact: CreateContactInput;
  patientId: Scalars['ID']['input'];
};

export type MutationAddPlannedSupervisionArgs = {
  fromTemplateId: Scalars['ID']['input'];
  input: PlannedSupervisionCreateInput;
  patientId: Scalars['ID']['input'];
};

export type MutationAddPlannedVideoMeetingArgs = {
  fromTemplateId: Scalars['ID']['input'];
  input: PlannedVideoMeetingCreateInput;
  patientId: Scalars['ID']['input'];
};

export type MutationAddReferenceRangeToPatientArgs = {
  patientId: Scalars['ID']['input'];
  referenceRange: PatientReferenceRangeInput;
};

export type MutationAddRpmGatewayToPatientArgs = {
  patientId: Scalars['ID']['input'];
  rpmGatewayId: Scalars['ID']['input'];
};

export type MutationAddRpmMedicalDeviceToPatientArgs = {
  patientId: Scalars['ID']['input'];
  rpmMedicalDeviceId: Scalars['ID']['input'];
};

export type MutationAddRpmMedicalDeviceToRpmGatewayArgs = {
  rpmGatewayId: Scalars['ID']['input'];
  rpmMedicalDeviceId: Scalars['ID']['input'];
};

export type MutationAddSafemateAccountToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  safemateAccountId: Scalars['ID']['input'];
};

export type MutationAddSendGridAccountToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  sendGridAccountId: Scalars['ID']['input'];
};

export type MutationAddShareSkyresponseAlarmWithPatientArgs = {
  patientId: Scalars['ID']['input'];
  shareWithPatientIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type MutationAddSkyresponseAccountToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  skyresponseAccountId: Scalars['ID']['input'];
};

export type MutationAddTagToPatientArgs = {
  patientId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};

export type MutationAddTcifAccountToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  tcifAccountId: Scalars['ID']['input'];
};

export type MutationAddTwilioAccountToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  twilioAccountId: Scalars['ID']['input'];
};

export type MutationAddUserGroupContactArgs = {
  contact: CreateContactInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationAddUserReservationArgs = {
  patientId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationAddUserToRoleArgs = {
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationAddVideonorAccountToHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  videonorAccountId: Scalars['ID']['input'];
};

export type MutationAddWelfareDeviceToPatientArgs = {
  patientId: Scalars['ID']['input'];
  welfareDeviceId: Scalars['ID']['input'];
};

export type MutationAssignPatientToDialoggUserArgs = {
  patientId: Scalars['ID']['input'];
  username: Scalars['ID']['input'];
};

export type MutationCameraAppBulkUpdateArgs = {
  appUpdates: Array<CameraAppUpdateInput>;
  cameras: Array<CameraManagementInput>;
};

export type MutationCameraFirmwareBulkUpgradeArgs = {
  cameras: Array<CameraManagementInput>;
  firmwareUpgradeOptions: CameraFirmwareUpgradeInput;
};

export type MutationCameraNetworkingBulkUpdateArgs = {
  cameras: Array<CameraManagementInput>;
};

export type MutationCancelCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
};

export type MutationCancelDialoggUserOtpArgs = {
  username?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCancelOtpArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCancelSkyresponseSyncAlarmArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationCancelVideoMeetingArgs = {
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationChangePicturePermissionArgs = {
  enabled: Scalars['Boolean']['input'];
  username: Scalars['ID']['input'];
};

export type MutationCleanupAlarmActivitiesArgs = {
  healthProviderName: Scalars['String']['input'];
};

export type MutationClearRpmMedicalDeviceFromRpmGatewayArgs = {
  rpmGatewayId: Scalars['ID']['input'];
  rpmMedicalDeviceId: Scalars['ID']['input'];
};

export type MutationClearRpmMedicalDevicePairingWithRpmGatewayArgs = {
  rpmGatewayId: Scalars['ID']['input'];
  rpmMedicalDeviceId: Scalars['ID']['input'];
};

export type MutationCompleteAlarmArgs = {
  completionInput?: InputMaybe<CompleteAlarmInput>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  taskId: Scalars['ID']['input'];
};

export type MutationCompleteCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
};

export type MutationCompleteCarePlanTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationCompleteCompositeTaskArgs = {
  journal?: InputMaybe<JournalInput>;
  taskId: Scalars['ID']['input'];
};

export type MutationCompleteCompositeTaskAndItsSubTasksArgs = {
  journal?: InputMaybe<JournalInput>;
  taskId: Scalars['ID']['input'];
};

export type MutationCompleteSubTaskArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationConfigureCameraArgs = {
  deviceId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
};

export type MutationConfigureCameraEventsArgs = {
  cameraId: Scalars['ID']['input'];
};

export type MutationCorrectValidationRulesArgs = {
  healthProviderName: Scalars['String']['input'];
};

export type MutationCreateAlarmRouteArgs = {
  inputs: AlarmRouteInput;
};

export type MutationCreateAlarmSubscriptionArgs = {
  createInput: AlarmSubscriptionCreateInput;
};

export type MutationCreateAlarmTemplateArgs = {
  input: AlarmTemplateCreateInput;
};

export type MutationCreateAlmaForwarderArgs = {
  input: CreateAlmaForwarder;
};

export type MutationCreateAscomForwarderArgs = {
  input: CreateAscomForwarder;
};

export type MutationCreateCameraArgs = {
  createInput: CreateCameraInput;
};

export type MutationCreateCameraViewPresetArgs = {
  cameraId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MutationCreateCarePlanBasedOnExistingArgs = {
  existingCarePlanId: Scalars['ID']['input'];
  newCarePlanTitle: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationCreateCarePlanForPatientArgs = {
  createInput?: InputMaybe<CarePlanInput>;
};

export type MutationCreateCarePlanTemplateArgs = {
  createInput: CarePlanTemplateInput;
};

export type MutationCreateCarePlanTemplateBasedOnExistingArgs = {
  basedOn: Scalars['ID']['input'];
  newTitle: Scalars['String']['input'];
};

export type MutationCreateCmpAccountArgs = {
  input: CmpAccountCreateInput;
};

export type MutationCreateCommunicationArgs = {
  communication: PersonnelCommunicationInput;
};

export type MutationCreateCommunicationToSeveralArgs = {
  communication: PersonnelCommunicationToSeveralInput;
};

export type MutationCreateCustomerArgs = {
  customer: CustomerInput;
};

export type MutationCreateDefaultRoleDefinitionArgs = {
  createInput: DefaultRoleDefinitionCreateInput;
};

export type MutationCreateDeviceGroupArgs = {
  createInput: DeviceGroupCreateInput;
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreateDialoggUserArgs = {
  dialoggUser: CreateDialoggUserInput;
};

export type MutationCreateDocumentArgs = {
  createInput: DocumentReferenceInput;
};

export type MutationCreateExternalHumanIdTypeArgs = {
  input: ExternalHumanIdTypeCreateInput;
};

export type MutationCreateGooglemapsAccountArgs = {
  input: GooglemapsAccountCreateInput;
};

export type MutationCreateHealthProviderArgs = {
  healthProvider: HealthProviderInput;
};

export type MutationCreateHelseIdAccountArgs = {
  input: HelseIdAccountCreateInput;
};

export type MutationCreateIotcommsSipConfigArgs = {
  healthProviderName: Scalars['ID']['input'];
  input: IotcommsSipConfigCreateInput;
};

export type MutationCreateJournalConfigForUserGroupArgs = {
  input: JournalConfigForUserGroupInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationCreateMorpheanAccountArgs = {
  input: MorpheanAccountCreateInput;
};

export type MutationCreateObservationForActivityInCarePlanArgs = {
  observationActivityInput?: InputMaybe<ObservationInput>;
};

export type MutationCreateObservationForActivityInCarePlanTemplateArgs = {
  observationActivityInput?: InputMaybe<ObservationInput>;
};

export type MutationCreateObservationTemplateArgs = {
  observationInput: ObservationInput;
};

export type MutationCreatePatientArgs = {
  patientGroupIds: Array<Scalars['ID']['input']>;
  patientInput?: InputMaybe<CreatePatientInput>;
};

export type MutationCreatePatientGoalsArgs = {
  goalInput: GoalInput;
  patientId: Scalars['ID']['input'];
};

export type MutationCreatePatientGroupArgs = {
  createInput: PatientGroupInput;
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreatePatientInGroupArgs = {
  patientGroup: Scalars['ID']['input'];
  patientInput?: InputMaybe<CreatePatientInput>;
};

export type MutationCreatePatientMedicalStatesArgs = {
  medicalStateInput: MedicalStatesInput;
  patientId: Scalars['ID']['input'];
};

export type MutationCreatePatientRealmArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationCreateQuestionnaireForActivityInCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
  questionnaireTemplateId: Scalars['ID']['input'];
};

export type MutationCreateQuestionnaireForActivityInCarePlanTemplateArgs = {
  carePlanTemplateId: Scalars['ID']['input'];
  questionnaireTemplateId: Scalars['ID']['input'];
};

export type MutationCreateQuestionnaireTemplateArgs = {
  createInput?: InputMaybe<QuestionnaireInput>;
};

export type MutationCreateRegistryDeviceArgs = {
  registryDeviceInput: RegistryDeviceInput;
};

export type MutationCreateRoleArgs = {
  id: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type MutationCreateRoleDefinitionArgs = {
  createInput: RoleDefinitionCreateInput;
  healthProviderName: Scalars['ID']['input'];
};

export type MutationCreateRpmGatewayArgs = {
  createInput: RpmGatewayCreateInput;
};

export type MutationCreateRpmMedicalDeviceArgs = {
  createInput: RpmMedicalDeviceCreateInput;
};

export type MutationCreateSafemateAccountArgs = {
  input: SafemateAccountCreateInput;
};

export type MutationCreateSelfTreatmentPlanTemplateArgs = {
  selfTreatmentPlanTemplateInput: SelfTreatmentPlanTemplateInput;
};

export type MutationCreateSendGridAccountArgs = {
  input: SendGridAccountCreateInput;
};

export type MutationCreateShiftSessionForPatientGroupsArgs = {
  patientGroupIds: Array<Scalars['ID']['input']>;
};

export type MutationCreateSipConfigForArgs = {
  healthProviderName: Scalars['ID']['input'];
  input: SipConfigCreateInput;
};

export type MutationCreateSkyresponseAccountArgs = {
  input: SkyresponseAccountCreateInput;
};

export type MutationCreateSkyresponseForwarderConfigArgs = {
  healthProviderName: Scalars['ID']['input'];
  input: SkyresponseForwarderConfigCreateInput;
};

export type MutationCreateTcifAccountArgs = {
  input: TcifAccountCreateInput;
};

export type MutationCreateTimeLimitedFhirCredentialsForHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationCreateTwilioAccountArgs = {
  input: TwilioAccountCreateInput;
};

export type MutationCreateUnplannedSupervisionArgs = {
  patientId: Scalars['ID']['input'];
};

export type MutationCreateUserArgs = {
  userInput: UserCreateInput;
};

export type MutationCreateUserGroupArgs = {
  parentId: Scalars['ID']['input'];
  userGroup: CreateUserGroupInput;
};

export type MutationCreateUserManualArgs = {
  createInput: CreateUserManualInput;
};

export type MutationCreateVideonorAccountArgs = {
  input: VideonorAccountCreateInput;
};

export type MutationCreateVkpAccountArgs = {
  input: VkpAccountInput;
};

export type MutationCreateWelfareDeviceArgs = {
  createInput: WelfareDeviceCreateInput;
};

export type MutationDeactivateDialoggUserSmsOtpArgs = {
  username?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationDeactivateSelfTreatmentPlanArgs = {
  selfTreatmentPlanId: Scalars['ID']['input'];
};

export type MutationDeactivateSmsOtpArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationDecommissionCamerasArgs = {
  cameras: Array<CameraManagementInputWithOptionalId>;
};

export type MutationDecommissionCamerasLimitedArgs = {
  cameras: Array<CameraManagementInputWithOptionalId>;
};

export type MutationDeleteAlarmRouteArgs = {
  routeId: Scalars['ID']['input'];
};

export type MutationDeleteAlarmSubscriptionArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteAlarmTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteAlmaForwarderArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteAppDeviceForPatientArgs = {
  appDeviceId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationDeleteAscomForwarderArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCameraViewPresetArgs = {
  cameraId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MutationDeleteCmpAccountArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteCustomerArgs = {
  customerId: Scalars['ID']['input'];
};

export type MutationDeleteDefaultRoleDefinitionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteDeviceGroupArgs = {
  deviceGroupId: Scalars['ID']['input'];
};

export type MutationDeleteDialoggUserArgs = {
  username: Scalars['ID']['input'];
};

export type MutationDeleteDialoggUserOtpArgs = {
  username?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationDeleteDocumentArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteDraftCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
};

export type MutationDeleteDraftCarePlanTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEscalationDelayArgs = {
  userGroupId: Scalars['ID']['input'];
};

export type MutationDeleteExternalAccessArgs = {
  healthProviderName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDeleteExternalHumanIdTypeArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteExternalIdentityProviderFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDeleteExternalIdentityProviderRedirectorFromHealthProviderArgs = {
  isPatientRealm: Scalars['Boolean']['input'];
  realmName: Scalars['String']['input'];
  redirectorId: Scalars['String']['input'];
};

export type MutationDeleteGooglemapsAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDeleteHelseIdAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteInconsistentHealthProviderArgs = {
  report: InconsistentHealthProviderReportInput;
};

export type MutationDeleteIotcommsSipConfigArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteIotcommsTrunkArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteJournalConfigForUserGroupArgs = {
  userGroupId: Scalars['ID']['input'];
};

export type MutationDeleteMorpheanAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteNextOfKinArgs = {
  nokId: Scalars['ID']['input'];
};

export type MutationDeleteObservationTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteOtpArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationDeletePatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type MutationDeleteQuestionnaireResponseArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteQuestionnaireTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteRegistryDeviceArgs = {
  deviceId: Scalars['ID']['input'];
};

export type MutationDeleteRoleArgs = {
  roleId: Scalars['ID']['input'];
};

export type MutationDeleteRoleDefinitionArgs = {
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDeleteRpmGatewayArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteRpmMedicalDeviceArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSafemateAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSendGridAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSipConfigArgs = {
  configId: Scalars['ID']['input'];
};

export type MutationDeleteSkyresponseAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSkyresponseForwarderConfigArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteTcifAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteTellucareIntegrationArgs = {
  healthProviderName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDeleteTwilioAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationDeleteUserGroupArgs = {
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  userGroupId: Scalars['ID']['input'];
};

export type MutationDeleteUserManualArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteVideonorAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteVkpAccountArgs = {
  vkpAccountId: Scalars['ID']['input'];
};

export type MutationDeleteWelfareDeviceArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDisableBetaArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableContinuousSupervisionArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableJoinNhnMeetingArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableKompArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableSelfTreatmentPlanArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableSendNotificationToNextOfKinArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationDisableUserPasswordArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationEnableBetaArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableContinuousSupervisionArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableJoinNhnMeetingArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableKompArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableSelfTreatmentPlanArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableSendNotificationToNextOfKinArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationEnableUserPasswordArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationEndJoinVideoMeetingArgs = {
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationEndVideoMeetingArgs = {
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationExecuteDatabaseSchemaSyncArgs = {
  healthProviderNames: Array<Scalars['String']['input']>;
};

export type MutationExecuteMigrationArgs = {
  healthProviderNames?: InputMaybe<Array<Scalars['String']['input']>>;
  migrationId: Scalars['ID']['input'];
};

export type MutationForceDeleteDialoggUserArgs = {
  username: Scalars['ID']['input'];
};

export type MutationHideTechnicalAlarmNotificationsForPatientGroupArgs = {
  hideTechnicalAlarmNotifications: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationImportAlarmTemplatesArgs = {
  dropAllExisting?: InputMaybe<Scalars['Boolean']['input']>;
  fhirAlarmTemplates?: InputMaybe<Array<Scalars['String']['input']>>;
  healthProviderName: Scalars['ID']['input'];
  keepTemplateIds?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationImportAlarmTemplatesFromDefaultArgs = {
  alarmTemplateCodes: Array<Scalars['String']['input']>;
  healthProviderName: Scalars['ID']['input'];
};

export type MutationImportDevicesFromSafemateProArgs = {
  createInput: ImportDevicesInput;
};

export type MutationImportMeasurementTemplatesFromDefaultArgs = {
  healthProviderName: Scalars['ID']['input'];
  measurementTemplateCodes: Array<Scalars['String']['input']>;
};

export type MutationImportObservationTemplatesArgs = {
  dropAllExisting?: InputMaybe<Scalars['Boolean']['input']>;
  fhirTemplates?: InputMaybe<Array<Scalars['String']['input']>>;
  healthProviderName: Scalars['ID']['input'];
  keepTemplateIds?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationInitializeExternalAccessArgs = {
  healthProviderName: Scalars['String']['input'];
  input: CreateExternalAccessInput;
};

export type MutationInviteToVideoMeetingArgs = {
  participants: Array<InputMaybe<AppointmentParticipantInput>>;
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationKeepStreamAliveArgs = {
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};

export type MutationLogLocalExportArgs = {
  count: Scalars['Int']['input'];
  resourceType: Scalars['String']['input'];
};

export type MutationMarkCommunicationAsReadArgs = {
  communicationId: Scalars['ID']['input'];
};

export type MutationMarkHealthProviderForDeletionArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationMarkNextOfKinAsMainArgs = {
  nokId: Scalars['ID']['input'];
};

export type MutationMoveAccessGroupArgs = {
  attachToUserGroup: Scalars['String']['input'];
  userGroupToMove: Scalars['String']['input'];
};

export type MutationNotifyNextOfKinsArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
};

export type MutationOpenPatientGroupsForExternalAccessArgs = {
  input: UpdateExternalAccessInput;
};

export type MutationOrderPatientContactsArgs = {
  orderedContactIds: Array<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
};

export type MutationOrderUserGroupContactsArgs = {
  orderedContactIds: Array<Scalars['ID']['input']>;
  userGroupId: Scalars['ID']['input'];
};

export type MutationPauseHealthProviderDeletionArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationPlanVideoMeetingArgs = {
  createInput?: InputMaybe<VideoMeetingInput>;
  patientId: Scalars['ID']['input'];
};

export type MutationPreviewDatabaseSchemaSyncArgs = {
  healthProviderNames: Array<Scalars['String']['input']>;
};

export type MutationProvisionIotcommsTrunkArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: IotcommsTrunkInput;
};

export type MutationPutPatientAlarmHandlingPlanOnHoldArgs = {
  patientId: Scalars['ID']['input'];
};

export type MutationRebootArgs = {
  cameraId: Scalars['ID']['input'];
};

export type MutationRedoCameraSetupTelluSupportArgs = {
  serial: Scalars['String']['input'];
};

export type MutationRefreshAzureProvisioningSecretArgs = {
  azureAccountId: Scalars['ID']['input'];
};

export type MutationRegisterPushIdForShiftSessionArgs = {
  pushNotificationSettings: PushNotificationSettingsInput;
};

export type MutationRegisterPushSubscriptionArgs = {
  pushSubscription: PushSubscriptionInput;
};

export type MutationRejectCompositeTaskArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationRejectSubTaskArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationReleaseVideoMeetingTaskArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationRemoveAccountFromCustomerArgs = {
  customerId: Scalars['ID']['input'];
  healthProviderId: Scalars['ID']['input'];
};

export type MutationRemoveCameraFromPatientArgs = {
  cameraId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationRemoveCareTeamArgs = {
  careTeamId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type MutationRemoveDefaultRolesFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  roleIds: Array<Scalars['ID']['input']>;
};

export type MutationRemoveDialoggUserPasswordArgs = {
  username: Scalars['ID']['input'];
};

export type MutationRemoveExternalDialoggUserIdArgs = {
  externalUserId: ExternalHumanIdInput;
  username: Scalars['ID']['input'];
};

export type MutationRemoveExternalHumanTypeFromHealthProviderArgs = {
  externalHumanTypeId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
};

export type MutationRemoveExternalPatientIdFromPatientArgs = {
  externalPatientId: ExternalHumanIdInput;
  patientId: Scalars['ID']['input'];
};

export type MutationRemoveExternalUserIdArgs = {
  externalUserId: ExternalHumanIdInput;
  userId: Scalars['ID']['input'];
};

export type MutationRemoveGooglemapsAccountFromHealthProviderArgs = {
  googlemapsAccountId: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
};

export type MutationRemoveMorpheanAccountFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  morpheanAccountId: Scalars['ID']['input'];
};

export type MutationRemoveMyExternalIdArgs = {
  externalUserId: ExternalHumanIdInput;
};

export type MutationRemovePatientAlarmHandlingArgs = {
  alarmId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationRemovePatientContactArgs = {
  contactId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationRemovePatientFromDialoggUserArgs = {
  patientId: Scalars['ID']['input'];
  username: Scalars['ID']['input'];
};

export type MutationRemovePatientGroupFromUserGroupArgs = {
  patientGroupId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type MutationRemovePlannedSupervisionArgs = {
  alarmActivityId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationRemovePlannedVideoMeetingArgs = {
  patientId: Scalars['ID']['input'];
  plannedVideoMeetingId: Scalars['ID']['input'];
};

export type MutationRemoveReferenceRangeFromPatientArgs = {
  patientId: Scalars['ID']['input'];
  referenceRangeId: Scalars['ID']['input'];
};

export type MutationRemoveRpmGatewayFromPatientArgs = {
  patientId: Scalars['ID']['input'];
  rpmGatewayId: Scalars['ID']['input'];
};

export type MutationRemoveRpmMedicalDeviceFromPatientArgs = {
  patientId: Scalars['ID']['input'];
  rpmMedicalDeviceId: Scalars['ID']['input'];
};

export type MutationRemoveSafemateAccountFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  safemateAccountId: Scalars['ID']['input'];
};

export type MutationRemoveSendGridAccountFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  sendGridAccountId: Scalars['ID']['input'];
};

export type MutationRemoveSkyresponseAccountFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  skyresponseAccountId: Scalars['ID']['input'];
};

export type MutationRemoveTagFromPatientArgs = {
  patientId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};

export type MutationRemoveTcifAccountFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  tcifAccountId: Scalars['ID']['input'];
};

export type MutationRemoveTwilioAccountFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  twilioAccountId: Scalars['ID']['input'];
};

export type MutationRemoveUserFromRoleArgs = {
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationRemoveUserGroupContactArgs = {
  contactId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type MutationRemoveUserReservationArgs = {
  patientId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationRemoveVideonorAccountFromHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  videonorAccountId: Scalars['ID']['input'];
};

export type MutationRemoveWelfareDeviceFromPatientArgs = {
  patientId: Scalars['ID']['input'];
  welfareDeviceId: Scalars['ID']['input'];
};

export type MutationReplaceWelfareDeviceIdentifierArgs = {
  id: Scalars['ID']['input'];
  input: ReplaceWelfareDeviceIdentifierInput;
};

export type MutationRescheduleVideoMeetingArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['dateTime']['input'];
  start: Scalars['dateTime']['input'];
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationResetCameraSetupTelluSupportArgs = {
  serial: Scalars['String']['input'];
};

export type MutationResetExternalIdentityProviderLinksForHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationResetHelseIdCredentialsArgs = {
  helseIdAccountId: Scalars['ID']['input'];
};

export type MutationResetSecretForExternalAccessArgs = {
  healthProviderName: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type MutationResetUserPasswordArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationRestoreHealthProviderMarkedForDeletionArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationResumeHealthProviderDeletionArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type MutationResumePatientAlarmHandlingPlanArgs = {
  patientId: Scalars['ID']['input'];
};

export type MutationRetireAlarmTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRetireObservationTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRetireQuestionnaireTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRetryAlarmJournalingArgs = {
  alarmId: Scalars['ID']['input'];
};

export type MutationRetryTaskJournalingArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationRevokeInviteToVideoMeetingArgs = {
  participants: Array<InputMaybe<AppointmentParticipantInput>>;
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationSetAnonymizationRequirementArgs = {
  anonymizationRequirement: Scalars['Boolean']['input'];
  cameraId: Scalars['ID']['input'];
};

export type MutationSetCameraViewWithAnglesArgs = {
  cameraId: Scalars['ID']['input'];
  pan?: InputMaybe<Scalars['Float']['input']>;
  tilt?: InputMaybe<Scalars['Float']['input']>;
  zoom?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationSetCameraViewWithPresetArgs = {
  cameraId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MutationSetDialoggUserEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  username: Scalars['ID']['input'];
};

export type MutationSetDialoggUserExternalIdPArgs = {
  identities?: InputMaybe<Array<InputMaybe<ExternalIdentityInput>>>;
  username?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationSetDistanceEstimationToPatientGroupArgs = {
  enableDistanceEstimation: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationSetEmailAndSmsNotificationSettingsForShiftSessionArgs = {
  notificationSettings: SessionNotificationSettingsInput;
};

export type MutationSetExternalIdPArgs = {
  idP?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationSetExternalIdRequestArgs = {
  externalHumanIdType: Scalars['String']['input'];
  requested: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationSetExternalIdentitiesArgs = {
  identities?: InputMaybe<Array<InputMaybe<ExternalIdentityInput>>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationSetExternalIdentityProviderRedirectorFromHealthProviderArgs = {
  alias: Scalars['String']['input'];
  isPatientRealm: Scalars['Boolean']['input'];
  realmName: Scalars['String']['input'];
};

export type MutationSetOnSiteRegistrationToPatientGroupArgs = {
  enableOnSiteRegistration: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationSetPatientCamerasInPrivacyModeArgs = {
  patientId: Scalars['ID']['input'];
  seconds?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationSetupTellucareIntegrationArgs = {
  healthProviderName: Scalars['String']['input'];
  input: CreateTellucareIntegrationInput;
};

export type MutationSimulateCarePlanObservationResponseArgs = {
  activityId: Scalars['ID']['input'];
  observation: ObservationInput;
  patientId: Scalars['ID']['input'];
};

export type MutationSimulateCarePlanQuestionnaireResponseArgs = {
  patientId: Scalars['ID']['input'];
  questionnaireResponseInput: QuestionnaireResponseSimulatorInput;
};

export type MutationSimulateNovoEventArgs = {
  event: NovoEventInput;
};

export type MutationSimulateSafemateEventArgs = {
  event: SafemateEventInput;
};

export type MutationSimulateSkyResponseEventArgs = {
  event: SkyresponseEventInput;
  externalAccessId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export type MutationSimulateSyncEventArgs = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  eventCode: Scalars['String']['input'];
  patientId?: InputMaybe<Scalars['ID']['input']>;
  payload?: InputMaybe<SimulateSyncEventPayloadInput>;
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationStartAppArgs = {
  appId: Scalars['String']['input'];
  cameraId: Scalars['ID']['input'];
};

export type MutationStartCompositeTaskArgs = {
  taskId: Scalars['ID']['input'];
};

export type MutationStartJoinVideoMeetingArgs = {
  videoMeetingId: Scalars['ID']['input'];
  videoMeetingURL?: InputMaybe<Scalars['String']['input']>;
};

export type MutationStartStreamArgs = {
  cameraId: Scalars['ID']['input'];
};

export type MutationStartVideoMeetingArgs = {
  videoMeetingId: Scalars['ID']['input'];
};

export type MutationStopAppArgs = {
  appId: Scalars['String']['input'];
  cameraId: Scalars['ID']['input'];
};

export type MutationStopStreamArgs = {
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
};

export type MutationSubmitAlarmHandlingFeedbackArgs = {
  alarmHandlingFeedback?: InputMaybe<AlarmHandlingFeedbackInput>;
};

export type MutationSubmitSupervisionFeebackArgs = {
  feedback: CameraSupervisionFeedback;
};

export type MutationSupportTeamLinkToHealthProviderArgs = {
  healthProviderName: Scalars['String']['input'];
  supportTeamName: Scalars['ID']['input'];
};

export type MutationSupportTeamUnlinkFromHealthProviderArgs = {
  healthProviderName: Scalars['String']['input'];
  supportTeamName: Scalars['ID']['input'];
};

export type MutationSwitchAnonymizationArgs = {
  cameraId: Scalars['ID']['input'];
};

export type MutationSyncPatientInfoWithSkyresponseArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  syncScenario?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  userGroupId: Scalars['ID']['input'];
};

export type MutationSyncSpecificPatientWithSkyresponseArgs = {
  patientId: Scalars['ID']['input'];
};

export type MutationTakeCallArgs = {
  takeCallInput?: InputMaybe<TakeCallInput>;
  taskId: Scalars['ID']['input'];
};

export type MutationTerminateShiftSessionOnDeviceArgs = {
  device: Scalars['String']['input'];
};

export type MutationTestAzureAccountCredentialsArgs = {
  id: Scalars['ID']['input'];
};

export type MutationTestHelseIdCredentialsArgs = {
  helseIdAccountId: Scalars['ID']['input'];
};

export type MutationTestPushNotificationArgs = {
  appDeviceId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationTestTellucareIntegrationSetupArgs = {
  healthProviderName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  input: TestTellucareIntegrationSetupInput;
};

export type MutationTriggerEventInCameraArgs = {
  appName: Scalars['String']['input'];
  cameraId: Scalars['ID']['input'];
  profileId: Scalars['Int']['input'];
};

export type MutationTriggerResolveActionsForSyncAlarmsArgs = {
  alarmIds: Array<Scalars['ID']['input']>;
};

export type MutationUnsetPatientCamerasFromPrivacyModeArgs = {
  patientId: Scalars['ID']['input'];
};

export type MutationUpdateAlarmAckTemplatesArgs = {
  alarmAckTemplates?: InputMaybe<Array<AlarmAckTemplate>>;
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateAlarmRouteArgs = {
  patientGroupId: Scalars['ID']['input'];
  routeId: Scalars['ID']['input'];
  updateInput: UpdateAlarmRouteInput;
};

export type MutationUpdateAlarmStatusArgs = {
  status: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
};

export type MutationUpdateAlarmSubscriptionArgs = {
  updateInput: AlarmSubscriptionUpdateInput;
};

export type MutationUpdateAlarmTemplateArgs = {
  id: Scalars['ID']['input'];
  input: AlarmTemplateUpdateInput;
};

export type MutationUpdateAlarmTemplateStatusArgs = {
  allTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  newStatus: ObservationTemplateStatus;
};

export type MutationUpdateAlmaForwarderArgs = {
  id: Scalars['ID']['input'];
  updateInput: UpdateAlmaForwarder;
};

export type MutationUpdateAppDeviceForPatientArgs = {
  appDeviceId: Scalars['ID']['input'];
  input: AppDeviceForPatientUpdateInput;
  patientId: Scalars['ID']['input'];
};

export type MutationUpdateAscomForwarderArgs = {
  id: Scalars['ID']['input'];
  updateInput: UpdateAscomForwarder;
};

export type MutationUpdateAvailableHoursArgs = {
  availableHours: Scalars['String']['input'];
  cameraId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type MutationUpdateAzureAccountArgs = {
  input: ExternalIdentityProviderForHealthProviderUpdateInput;
};

export type MutationUpdateCameraArgs = {
  id: Scalars['ID']['input'];
  updateInput?: InputMaybe<UpdateCameraInput>;
};

export type MutationUpdateCarePlanQuestionnaireArgs = {
  carePlanId: Scalars['ID']['input'];
  questionnaireId: Scalars['ID']['input'];
  updateInput?: InputMaybe<QuestionnaireInput>;
};

export type MutationUpdateCarePlanTemplateQuestionnaireArgs = {
  carePlanTemplateId: Scalars['ID']['input'];
  questionnaireId: Scalars['ID']['input'];
  updateInput: QuestionnaireInput;
};

export type MutationUpdateCareTeamArgs = {
  careTeam: UpdateCareTeamInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateCmpAccountArgs = {
  id: Scalars['String']['input'];
  input: CmpAccountUpdateInput;
};

export type MutationUpdateCompositeTaskPriorityArgs = {
  priority?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
};

export type MutationUpdateCustomerArgs = {
  customer: CustomerUpdateInput;
  customerId: Scalars['ID']['input'];
};

export type MutationUpdateDefaultRoleDefinitionArgs = {
  updateInput: DefaultRoleDefinitionUpdateInput;
};

export type MutationUpdateDeviceGroupArgs = {
  id: Scalars['ID']['input'];
  updateInput?: InputMaybe<DeviceGroupUpdateInput>;
};

export type MutationUpdateDialoggUserArgs = {
  dialoggUser: UpdateDialoggUser;
  username: Scalars['ID']['input'];
};

export type MutationUpdateDialoggUserIpRestrictionsArgs = {
  ipRestrictions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  username: Scalars['ID']['input'];
};

export type MutationUpdateDialoggUserPasswordArgs = {
  password: Scalars['String']['input'];
  username: Scalars['ID']['input'];
};

export type MutationUpdateDialoggUserTimeLimitedAccessArgs = {
  timeLimitedAccess?: InputMaybe<PeriodInput>;
  username: Scalars['ID']['input'];
};

export type MutationUpdateDraftCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
  updateInput?: InputMaybe<CarePlanInput>;
};

export type MutationUpdateDraftCarePlanTemplateArgs = {
  id: Scalars['ID']['input'];
  updateInput?: InputMaybe<CarePlanTemplateUpdateInput>;
};

export type MutationUpdateEscalationDelayArgs = {
  escalationDelay: Scalars['Int']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateExternalHumanIdTypeArgs = {
  id: Scalars['String']['input'];
  input: ExternalHumanIdTypeUpdateInput;
};

export type MutationUpdateExternalIdRequestsOnAzureGroupArgs = {
  id: Scalars['ID']['input'];
  requestedExternalIdTypeIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type MutationUpdateExternalIdentityProviderForHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  input: ExternalIdentityProviderForHealthProviderUpdateInput;
};

export type MutationUpdateGooglemapsAccountArgs = {
  id: Scalars['ID']['input'];
  input: GooglemapsAccountUpdateInput;
};

export type MutationUpdateHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
  updateInput: HealthProviderUpdateInput;
};

export type MutationUpdateHealthProviderPatientAuthArgs = {
  healthProviderName: Scalars['ID']['input'];
  input: AuthUpdateInput;
};

export type MutationUpdateHealthProviderPatientSessionLifespanArgs = {
  healthProviderName: Scalars['ID']['input'];
  lifespan: Scalars['Int']['input'];
};

export type MutationUpdateHealthProviderRolesBasedOnDefaultRolesArgs = {
  defaultRoleIds: Array<Scalars['ID']['input']>;
  healthProviderName: Scalars['ID']['input'];
};

export type MutationUpdateHealthProviderUserAuthArgs = {
  healthProviderName: Scalars['ID']['input'];
  input: AuthUpdateInput;
};

export type MutationUpdateHealthProviderUserSessionLifespanArgs = {
  healthProviderName: Scalars['ID']['input'];
  lifespan: Scalars['Int']['input'];
};

export type MutationUpdateHelseIdAccountArgs = {
  helseIdAccountId: Scalars['ID']['input'];
  input: HelseIdAccountUpdateInput;
};

export type MutationUpdateHelseIdCredentialsArgs = {
  helseIdAccountId: Scalars['ID']['input'];
  helseIdCredentials: HelseIdCredentialsInput;
};

export type MutationUpdateIpRestrictionsArgs = {
  ipRestrictions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId: Scalars['ID']['input'];
};

export type MutationUpdateInheritedJournalConfigForUserGroupArgs = {
  input: InheritedJournalConfigForUserGroupInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateIotcommsSipConfigArgs = {
  id: Scalars['ID']['input'];
  input: IotcommsSipConfigCreateInput;
};

export type MutationUpdateJournalConfigForUserGroupArgs = {
  input: JournalConfigForUserGroupInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateLinkedPatientGroupsArgs = {
  addPatientGroups: Array<Scalars['String']['input']>;
  removePatientGroups: Array<Scalars['String']['input']>;
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateMorpheanAccountArgs = {
  id: Scalars['ID']['input'];
  input: MorpheanAccountUpdateInput;
};

export type MutationUpdateNameOrIpRestrictionsForExternalAccessArgs = {
  healthProviderName: Scalars['String']['input'];
  input: UpdateNameOrIpRestrictionForExternalAccessInput;
};

export type MutationUpdateNextOfKinArgs = {
  nextOfKinInput: UpdateNextOfKinInput;
  nokId: Scalars['ID']['input'];
};

export type MutationUpdateObservationStatusArgs = {
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

export type MutationUpdateObservationTemplateArgs = {
  id: Scalars['ID']['input'];
  updateInput: ObservationInput;
};

export type MutationUpdateObservationTemplateStatusArgs = {
  allTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  healthProviderName: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  newStatus: ObservationTemplateStatus;
};

export type MutationUpdatePatientArgs = {
  patientId: Scalars['ID']['input'];
  patientInput?: InputMaybe<UpdatePatientInput>;
};

export type MutationUpdatePatientAlarmHandlingArgs = {
  alarmId: Scalars['ID']['input'];
  input: AlarmActivityInput;
  patientId: Scalars['ID']['input'];
};

export type MutationUpdatePatientContactArgs = {
  contact: UpdateContactInput;
  patientId: Scalars['ID']['input'];
};

export type MutationUpdatePatientGoalsArgs = {
  goalInput: UpdateGoalInput;
  patientId: Scalars['ID']['input'];
};

export type MutationUpdatePatientGroupArgs = {
  id: Scalars['ID']['input'];
  updateInput: PatientGroupInput;
};

export type MutationUpdatePatientGroupsOfPatientArgs = {
  addPatientGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  patientId: Scalars['ID']['input'];
  removePatientGroups?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationUpdatePatientLastActiveArgs = {
  lastActive?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
};

export type MutationUpdatePatientMedicalStatesArgs = {
  medicalStateInput: MedicalStatesInput;
  patientId: Scalars['ID']['input'];
};

export type MutationUpdatePatientReferenceRangeArgs = {
  patientId: Scalars['ID']['input'];
  referenceRange: Array<InputMaybe<ObservationComponentInput>>;
  referenceRangeId: Scalars['ID']['input'];
};

export type MutationUpdatePlannedSupervisionArgs = {
  alarmActivityId: Scalars['ID']['input'];
  input: PlannedSupervisionUpdateInput;
  patientId: Scalars['ID']['input'];
};

export type MutationUpdatePlannedVideoMeetingArgs = {
  input: PlannedVideoMeetingUpdateInput;
  patientId: Scalars['ID']['input'];
  plannedVideoMeetingId: Scalars['ID']['input'];
};

export type MutationUpdateQuestionnaireTemplateArgs = {
  id: Scalars['ID']['input'];
  updateInput?: InputMaybe<QuestionnaireInput>;
};

export type MutationUpdateRegistryDeviceArgs = {
  deviceId: Scalars['ID']['input'];
  healthProviderName?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateRoleDefinitionArgs = {
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  updateInput: RoleDefinitionUpdateInput;
};

export type MutationUpdateRoleDefinitionBasedOnArgs = {
  basedOn: Scalars['ID']['input'];
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationUpdateRolesOnAzureGroupArgs = {
  id: Scalars['ID']['input'];
  roleIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type MutationUpdateRpmGatewayArgs = {
  id: Scalars['ID']['input'];
  updateInput: RpmGatewayUpdateInput;
};

export type MutationUpdateRpmMedicalDeviceArgs = {
  id: Scalars['ID']['input'];
  updateInput: RpmMedicalDeviceUpdateInput;
};

export type MutationUpdateSafemateAccountArgs = {
  id: Scalars['ID']['input'];
  input: SafemateAccountUpdateInput;
};

export type MutationUpdateSelfTreatmentPlanTemplateArgs = {
  selfTreatmentPlanTemplateId: Scalars['ID']['input'];
  selfTreatmentPlanTemplateUpdateInput: SelfTreatmentPlanTemplateUpdateInput;
};

export type MutationUpdateSendGridAccountArgs = {
  id: Scalars['ID']['input'];
  input: SendGridAccountUpdateInput;
};

export type MutationUpdateSipConfigForArgs = {
  configId: Scalars['ID']['input'];
  input: SipConfigCreateInput;
};

export type MutationUpdateSkyresponseAccountArgs = {
  id: Scalars['ID']['input'];
  input: SkyresponseAccountUpdateInput;
};

export type MutationUpdateSkyresponseConfigArgs = {
  skyresponseConfig: SkyresponseConfigInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateSkyresponseForwarderConfigArgs = {
  id: Scalars['ID']['input'];
  input: SkyresponseForwarderConfigCreateInput;
};

export type MutationUpdateSubTaskPriorityArgs = {
  priority?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
};

export type MutationUpdateTaskAcceptedAtArgs = {
  taskId: Scalars['ID']['input'];
  when?: InputMaybe<Scalars['dateTime']['input']>;
};

export type MutationUpdateTaskPresenceAtArgs = {
  taskId: Scalars['ID']['input'];
  when?: InputMaybe<Scalars['dateTime']['input']>;
};

export type MutationUpdateTcifAccountArgs = {
  id: Scalars['ID']['input'];
  input: TcifAccountUpdateInput;
};

export type MutationUpdateTechnicalAlarmStatusArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  status: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
};

export type MutationUpdateTellucareIntegrationArgs = {
  healthProviderName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  updateInput: UpdateTellucareIntegrationInput;
};

export type MutationUpdateTwilioAccountArgs = {
  id: Scalars['ID']['input'];
  input: TwilioAccountUpdateInput;
};

export type MutationUpdateUserArgs = {
  userId: Scalars['ID']['input'];
  userInput: UserUpdateInput;
};

export type MutationUpdateUserGroupArgs = {
  userGroup: UpdateUserGroupInput;
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateUserGroupContactArgs = {
  contact: UpdateContactInput;
  userGroupId: Scalars['ID']['input'];
};

export type MutationUpdateUserManualArgs = {
  id: Scalars['ID']['input'];
  updateInput: UpdateUserManualInput;
};

export type MutationUpdateUserPasswordArgs = {
  password: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationUpdateUserTimeLimitedAccessArgs = {
  timeLimitedAccess?: InputMaybe<PeriodInput>;
  userId: Scalars['ID']['input'];
};

export type MutationUpdateVideonorAccountArgs = {
  id: Scalars['ID']['input'];
  input: VideonorAccountUpdateInput;
};

export type MutationUpdateVkpAccountArgs = {
  input: VkpAccountInput;
  vkpAccountId: Scalars['ID']['input'];
};

export type MutationUpdateWelfareDeviceArgs = {
  id: Scalars['ID']['input'];
  updateInput: WelfareDeviceUpdateInput;
};

export type MutationValidateCmpAccountTowardsCmpArgs = {
  id: Scalars['String']['input'];
};

export type MutationValidateCustomerGroupTowardsCmpArgs = {
  id: Scalars['String']['input'];
};

export type MutationResponseWithPagination = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  next?: Maybe<PaginationNext>;
  skip?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type NamePatientsWithoutAuditLog = {
  text?: Maybe<Scalars['String']['output']>;
};

export type NetworkMangementStatus = {
  allowOldTLS: Scalars['Boolean']['output'];
  bandwidthLimit: Scalars['Boolean']['output'];
  bonjour: Scalars['Boolean']['output'];
  dot1x: Scalars['Boolean']['output'];
  ftp: Scalars['Boolean']['output'];
  https: Scalars['Boolean']['output'];
  isHardened: Scalars['Boolean']['output'];
  ssh: Scalars['Boolean']['output'];
  upnp: Scalars['Boolean']['output'];
  zeroConf: Scalars['Boolean']['output'];
};

export type NextOfKin = {
  active: Scalars['Boolean']['output'];
  address?: Maybe<Array<Address>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<Identifier>>;
  isMain: Scalars['Boolean']['output'];
  name?: Maybe<Array<HumanName>>;
  notifyNextOfKin?: Maybe<Scalars['Boolean']['output']>;
  patient: Reference;
  relationship?: Maybe<Scalars['String']['output']>;
  telecom?: Maybe<Array<ContactPoint>>;
};

export type NextOfKinExport = {
  name?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
};

export type NextOfKinImport = {
  id: Scalars['ID']['output'];
  name?: Maybe<Array<HumanName>>;
};

export type NextOfKinMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  nextOfKin?: Maybe<NextOfKin>;
  success: Scalars['Boolean']['output'];
};

export type Notification = {
  inactiveDays?: Maybe<Scalars['Int']['output']>;
  inactiveDaysSetBy?: Maybe<Scalars['String']['output']>;
};

export type NotificationInput = {
  inactiveDays?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationLog = {
  alarmId?: Maybe<Scalars['String']['output']>;
  apiStatus?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  deviceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  patientId?: Maybe<Scalars['String']['output']>;
  relatedPersonId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetEmailAddress?: Maybe<Scalars['String']['output']>;
  targetPhoneNumber?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  twilioId?: Maybe<Scalars['String']['output']>;
  twilioPrice?: Maybe<Scalars['String']['output']>;
  twilioPriceUnit?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  useCase?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type NotificationLogResponse = {
  messageStatus: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type NotificationSettings = {
  deviation?: Maybe<Scalars['Boolean']['output']>;
  measurement?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['Boolean']['output']>;
  reminder?: Maybe<Scalars['Int']['output']>;
  reviewed?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationSettingsInput = {
  deviation?: InputMaybe<Scalars['Boolean']['input']>;
  measurement?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['Boolean']['input']>;
  reminder?: InputMaybe<Scalars['Int']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NovoEventInput = {
  cha?: InputMaybe<Scalars['String']['input']>;
  cid?: InputMaybe<Scalars['String']['input']>;
  crd?: InputMaybe<Scalars['String']['input']>;
  did?: InputMaybe<Scalars['String']['input']>;
  dte?: InputMaybe<Scalars['String']['input']>;
  dty?: InputMaybe<Scalars['String']['input']>;
  dty_description?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  ite?: InputMaybe<Scalars['String']['input']>;
  lco?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mty?: InputMaybe<Scalars['String']['input']>;
  ref?: InputMaybe<Scalars['String']['input']>;
  stc?: InputMaybe<Scalars['String']['input']>;
  stc_description?: InputMaybe<Scalars['String']['input']>;
  system?: InputMaybe<Scalars['String']['input']>;
};

export type Observation = {
  basedOn?: Maybe<Array<Maybe<Reference>>>;
  code?: Maybe<CodeableConcept>;
  component?: Maybe<Array<Maybe<ObservationComponent>>>;
  device?: Maybe<Reference>;
  effectiveDateTime?: Maybe<Scalars['dateTime']['output']>;
  effectiveTiming?: Maybe<Timing>;
  fromTemplate?: Maybe<Reference>;
  gateway?: Maybe<Reference>;
  handlingStatuses: Array<AlarmHandlingStatus>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  instantiates?: Maybe<Array<Maybe<Reference>>>;
  interpretation?: Maybe<Array<Maybe<CodeableConcept>>>;
  manual?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Array<Maybe<Annotation>>>;
  performer?: Maybe<Array<Maybe<Reference>>>;
  received?: Maybe<Scalars['dateTime']['output']>;
  status: Scalars['String']['output'];
  subject?: Maybe<Reference>;
  systemDefined?: Maybe<Scalars['Boolean']['output']>;
  task?: Maybe<Reference>;
  taskPriority?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ObservationComponent = {
  code: CodeableConcept;
  dataAbsentReason?: Maybe<CodeableConcept>;
  extension?: Maybe<Array<Extension>>;
  interpretation?: Maybe<Array<Maybe<CodeableConcept>>>;
  referenceRange?: Maybe<Array<Maybe<ReferenceRange>>>;
  valueQuantity?: Maybe<ValueQuantity>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type ObservationComponentInput = {
  code?: InputMaybe<CodeableConceptInput>;
  dataAbsentReason?: InputMaybe<CodeableConceptInput>;
  extension?: InputMaybe<Array<ExtensionInput>>;
  referenceRange?: InputMaybe<Array<InputMaybe<ReferenceRangeInput>>>;
  valueQuantity?: InputMaybe<ValueQuantityInput>;
};

export type ObservationInput = {
  basedOn?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  code?: InputMaybe<CodeableConceptInput>;
  component?: InputMaybe<Array<InputMaybe<ObservationComponentInput>>>;
  effectiveDateTime?: InputMaybe<Scalars['dateTime']['input']>;
  effectiveTiming?: InputMaybe<TimingInput>;
  fromTemplate?: InputMaybe<ReferenceInput>;
  identifier?: InputMaybe<Array<InputMaybe<IdentifierInput>>>;
  instantiates?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  interpretation?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>>>;
  performer?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  subject?: InputMaybe<ReferenceInput>;
};

export type ObservationMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Observation>;
  success: Scalars['Boolean']['output'];
};

export enum ObservationTemplateStatus {
  Cancelled = 'cancelled',
  Final = 'final',
  Preliminary = 'preliminary',
}

export type ObservationsCsv = {
  csv?: Maybe<Scalars['String']['output']>;
};

export type OptionCoding = {
  code?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
};

export type OptionCodingInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
};

export type OptionCodingSimulatorInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
};

export type PaginationNext = {
  skip?: Maybe<Scalars['Int']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
};

export type PasswordPolicy = {
  digits?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  lowerCase?: Maybe<Scalars['Int']['output']>;
  regexPattern?: Maybe<Scalars['String']['output']>;
  upperCase?: Maybe<Scalars['Int']['output']>;
};

export type Patient = {
  active: Scalars['Boolean']['output'];
  address?: Maybe<Array<Maybe<Address>>>;
  addressNote?: Maybe<Scalars['String']['output']>;
  alarmRoutes?: Maybe<Array<AlarmRoute>>;
  birthDate?: Maybe<Scalars['date']['output']>;
  cameras?: Maybe<Array<Maybe<CameraWithStatus>>>;
  carePlans?: Maybe<Array<Maybe<CarePlan>>>;
  contacts?: Maybe<CombinedPatientContacts>;
  dialoggUser?: Maybe<DialoggUser>;
  documents?: Maybe<Array<Maybe<DocumentReference>>>;
  externalPatientIds?: Maybe<Array<ExternalHumanId>>;
  gender?: Maybe<AdministrativeGender>;
  hasSkyresponseSyncFailed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  identifier: Array<Maybe<Identifier>>;
  isAlarmHandlingPlanActive?: Maybe<Scalars['Boolean']['output']>;
  isMemberOfUnaccessiblePatientGroups?: Maybe<Scalars['Boolean']['output']>;
  journalConfigForPatient?: Maybe<JournalConfigForPatient>;
  keyCode?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<Language>>;
  lastActive?: Maybe<Scalars['dateTime']['output']>;
  lastSupervisionPerformedByUserId?: Maybe<Scalars['String']['output']>;
  lastSupervisionTimestamp?: Maybe<Scalars['dateTime']['output']>;
  link?: Maybe<Array<Link>>;
  maritalStatus?: Maybe<CodeableConcept>;
  name?: Maybe<Array<HumanName>>;
  nextOfKin?: Maybe<Array<NextOfKin>>;
  note?: Maybe<Scalars['String']['output']>;
  notification?: Maybe<Notification>;
  patientGroups?: Maybe<Array<Maybe<PatientGroupLess>>>;
  photo?: Maybe<Array<Maybe<Attachment>>>;
  referenceRange?: Maybe<Array<Maybe<Observation>>>;
  rpmGateways?: Maybe<Array<RpmGateway>>;
  rpmMedicalDevices?: Maybe<Array<RpmMedicalDevice>>;
  secretAddress?: Maybe<Scalars['Boolean']['output']>;
  shareAlarmWith?: Maybe<Array<ShareAlarmWidth>>;
  skyresponseDetails?: Maybe<SkyresponseConfig>;
  skyresponseSyncOpenAlarms?: Maybe<Array<Maybe<SkyresponseSyncAlarm>>>;
  skyresponseSyncStatus?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  userReservations?: Maybe<Array<Maybe<UserReservation>>>;
  welfareDevices?: Maybe<Array<WelfareDevice>>;
};

export type PatientCarePlansArgs = {
  carePlanStatus?: InputMaybe<CarePlanStatus>;
};

export type PatientBundle = {
  bundle: Scalars['String']['output'];
};

export type PatientByIdentityResponse = {
  found?: Maybe<Scalars['Boolean']['output']>;
  inputValidation?: Maybe<InputValidationResult>;
  patient?: Maybe<PatientLess>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PatientEmbeddedRequestResponse = {
  link?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PatientExport = {
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Array<Maybe<Address>>>;
  addressNote?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['date']['output']>;
  contacts?: Maybe<Array<ContactsExport>>;
  createdAt?: Maybe<Scalars['dateTime']['output']>;
  devices: Array<DeviceExport>;
  externalIds: Array<ExternalIdExport>;
  fhirId: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<AdministrativeGender>;
  isAlarmHandlingPlanActive?: Maybe<Scalars['Boolean']['output']>;
  keyCode?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  nextOfKins?: Maybe<Array<NextOfKinExport>>;
  patientGroupName?: Maybe<Scalars['String']['output']>;
  patientNote?: Maybe<Scalars['String']['output']>;
  secretAddress?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  updatedAt?: Maybe<Scalars['dateTime']['output']>;
};

export type PatientForImport = {
  contacts?: Maybe<Array<ContactsImport>>;
  externalIds: Array<ExternalIdExport>;
  id: Scalars['ID']['output'];
  nextOfKins: Array<NextOfKinImport>;
  patientGroups: Array<PatientGroupPatientsWithoutAuditLog>;
};

export type PatientGroup = {
  alarmRoutes: Array<AlarmRoute>;
  availableAlarmRoutingOptions: AlarmRouteOptions;
  enableDistanceEstimation?: Maybe<Scalars['Boolean']['output']>;
  enableOnSiteRegistration?: Maybe<Scalars['Boolean']['output']>;
  hideTechnicalAlarmNotifications?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  patientsCount?: Maybe<Scalars['Int']['output']>;
};

export type PatientGroupIdAndName = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PatientGroupInput = {
  name: Scalars['String']['input'];
};

export type PatientGroupLess = {
  enableDistanceEstimation: Scalars['Boolean']['output'];
  enableOnSiteRegistration: Scalars['Boolean']['output'];
  hideTechnicalAlarmNotifications: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PatientGroupMutationOutcome = {
  message: Scalars['String']['output'];
  patientGroupId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type PatientGroupMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  patientGroup?: Maybe<PatientGroup>;
  success: Scalars['Boolean']['output'];
};

export type PatientGroupPatientsWithoutAuditLog = {
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PatientGroupsMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  outcomes?: Maybe<Array<Maybe<PatientGroupMutationOutcome>>>;
  success: Scalars['Boolean']['output'];
};

export type PatientLess = {
  active: Scalars['Boolean']['output'];
  address: Array<Maybe<Address>>;
  addressNote?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['date']['output']>;
  gender?: Maybe<AdministrativeGender>;
  id?: Maybe<Scalars['String']['output']>;
  identityNumber?: Maybe<Scalars['String']['output']>;
  keyCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Array<HumanName>>;
  patientGroups?: Maybe<Array<Maybe<PatientGroupLess>>>;
  secretAddress?: Maybe<Scalars['Boolean']['output']>;
  telecom: Array<Maybe<ContactPoint>>;
};

export type PatientLinkData = {
  patientId: Scalars['String']['output'];
  patientName?: Maybe<Scalars['String']['output']>;
  userHasAccessToPatient: Scalars['Boolean']['output'];
};

export type PatientListDevice = {
  deviceType?: Maybe<Scalars['String']['output']>;
  isSharedDevice?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PatientListExternalIds = {
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PatientMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  success: Scalars['Boolean']['output'];
};

export type PatientReferenceRangeInput = {
  code?: InputMaybe<CodeableConceptInput>;
  component: Array<InputMaybe<ObservationComponentInput>>;
  fromTemplate: ReferenceInput;
  identifier: Array<InputMaybe<IdentifierInput>>;
  subject: ReferenceInput;
};

export type PatientStats = {
  alarmEvents?: Maybe<Scalars['Int']['output']>;
  alarms?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['dateTime']['output']>;
};

export type PatientStatsPaginated = {
  count?: Maybe<Scalars['Int']['output']>;
  stats: Array<PatientStats>;
};

export type PatientStatsPaginatedCountArgs = {
  countFrom?: InputMaybe<Scalars['dateTime']['input']>;
  countTo?: InputMaybe<Scalars['dateTime']['input']>;
};

export type PatientSupervisionCamera = {
  deviceGroupName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  macAddress: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PatientTaskAndHpTasks = {
  hpTasks: Array<Scalars['String']['output']>;
  task: Task;
};

export type PatientVkp = {
  address?: Maybe<Array<Address>>;
  addressNote?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['date']['output']>;
  externalPatientIds?: Maybe<Array<ExternalHumanId>>;
  gender?: Maybe<AdministrativeGender>;
  hasSecretAddress?: Maybe<Scalars['Boolean']['output']>;
  keyCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Array<HumanName>>;
  telecom?: Maybe<Array<ContactPoint>>;
};

export type PatientVkpResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<PatientVkp>;
  success: Scalars['Boolean']['output'];
};

export type PatientWithAlarms = {
  openPatientAlarms: Array<Task>;
  openTechnicalAlarms: Array<Task>;
  patient: Patient;
};

export type PatientsWithoutAuditLog = {
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Array<Maybe<Address>>>;
  addressNote?: Maybe<Scalars['String']['output']>;
  cameras?: Maybe<Array<Maybe<CamerasPatientsWithoutAuditLog>>>;
  id: Scalars['String']['output'];
  keyCode?: Maybe<Scalars['String']['output']>;
  lastSupervisionPerformedByUserId?: Maybe<Scalars['String']['output']>;
  lastSupervisionTimestamp?: Maybe<Scalars['dateTime']['output']>;
  name?: Maybe<Array<Maybe<NamePatientsWithoutAuditLog>>>;
  patientGroups?: Maybe<Array<Maybe<PatientGroupPatientsWithoutAuditLog>>>;
};

export type Period = {
  end?: Maybe<Scalars['dateTime']['output']>;
  start?: Maybe<Scalars['dateTime']['output']>;
};

export type PeriodInput = {
  end: Scalars['dateTime']['input'];
  start: Scalars['dateTime']['input'];
};

export type PersonnelCommunicationInput = {
  payload?: InputMaybe<Array<InputMaybe<CommunicationPayloadInput>>>;
  subject: ReferenceOnlyInput;
};

export type PersonnelCommunicationToSeveralInput = {
  payload?: InputMaybe<Array<InputMaybe<CommunicationPayloadInput>>>;
  subjects: Array<InputMaybe<ReferenceOnlyInput>>;
};

export type PlannedSupervision = {
  alarmActivity: AlarmActivity;
  scheduledTiming: Timing;
};

export type PlannedSupervisionCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayText?: InputMaybe<Scalars['String']['input']>;
  interpretation?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  scheduledTiming: TimingInput;
};

export type PlannedSupervisionMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  plannedSupervision?: Maybe<PlannedSupervision>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PlannedSupervisionUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayText?: InputMaybe<Scalars['String']['input']>;
  interpretation?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  scheduledTiming?: InputMaybe<TimingInput>;
};

export type PlannedVideoMeeting = {
  activity: AlarmActivity;
  durationInMinutes: Scalars['Int']['output'];
  scheduledTiming: Timing;
};

export type PlannedVideoMeetingCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayText?: InputMaybe<Scalars['String']['input']>;
  durationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  interpretation?: InputMaybe<Array<CodeableConceptInput>>;
  scheduledTiming: TimingInput;
};

export type PlannedVideoMeetingMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  plannedVideoMeeting?: Maybe<PlannedVideoMeeting>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PlannedVideoMeetingUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayText?: InputMaybe<Scalars['String']['input']>;
  durationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  interpretation?: InputMaybe<Array<CodeableConceptInput>>;
  scheduledTiming?: InputMaybe<TimingInput>;
};

export type PlayerStatus = {
  autoplayBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  broken?: InputMaybe<Scalars['Boolean']['input']>;
  delay?: InputMaybe<Scalars['Float']['input']>;
  delayed?: InputMaybe<Scalars['Boolean']['input']>;
  errorCode?: InputMaybe<Scalars['Int']['input']>;
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  html5VideoAccumulatedWaiting?: InputMaybe<Scalars['Float']['input']>;
  html5VideoSetup?: InputMaybe<Scalars['Float']['input']>;
  html5VideoWaiting?: InputMaybe<Scalars['Float']['input']>;
  keepAliveShown?: InputMaybe<Scalars['Boolean']['input']>;
  keepAliveTTL?: InputMaybe<Scalars['Int']['input']>;
  lastSelectedPreset?: InputMaybe<Scalars['String']['input']>;
  latency?: InputMaybe<Scalars['Float']['input']>;
  loading?: InputMaybe<Scalars['Boolean']['input']>;
  mediaSourceSetup?: InputMaybe<Scalars['Float']['input']>;
  playButtonShown?: InputMaybe<Scalars['Boolean']['input']>;
  presetStatus?: InputMaybe<Scalars['String']['input']>;
  restarts?: InputMaybe<Scalars['Int']['input']>;
  soundAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  soundMuted?: InputMaybe<Scalars['Boolean']['input']>;
  stalled?: InputMaybe<Scalars['Boolean']['input']>;
  startStreamDuration?: InputMaybe<Scalars['Float']['input']>;
  startingDuration?: InputMaybe<Scalars['Float']['input']>;
  stopButtonShown?: InputMaybe<Scalars['Boolean']['input']>;
  supportedBrowser?: InputMaybe<Scalars['Boolean']['input']>;
  unavailable?: InputMaybe<Scalars['Boolean']['input']>;
  videoRatio?: InputMaybe<Scalars['Float']['input']>;
  waitedTooLong?: InputMaybe<Scalars['Boolean']['input']>;
  waiting?: InputMaybe<Scalars['Boolean']['input']>;
  websocketFirstMessageDuration?: InputMaybe<Scalars['Float']['input']>;
  websocketStartDuration?: InputMaybe<Scalars['Float']['input']>;
  wslatency?: InputMaybe<Scalars['Float']['input']>;
};

export type PtzManagementStatus = {
  enabled: Scalars['Boolean']['output'];
  locked: Scalars['Boolean']['output'];
  returnToOverviewawait?: Maybe<Scalars['String']['output']>;
};

export type PushNotificationSettings = {
  createdAt: Scalars['dateTime']['output'];
  device: Scalars['String']['output'];
  type: PushNotificationType;
};

export type PushNotificationSettingsInput = {
  device: Scalars['String']['input'];
  key: Scalars['String']['input'];
  type: PushNotificationType;
};

export enum PushNotificationType {
  AndroidPush = 'androidPush',
  IosPush = 'iosPush',
}

export type PushSubscriptionInput = {
  deviceName: Scalars['String']['input'];
  os?: InputMaybe<Scalars['String']['input']>;
  pushId: Scalars['String']['input'];
};

export type Quantity = {
  code?: Maybe<Scalars['code']['output']>;
  system?: Maybe<Scalars['uri']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  _?: Maybe<Scalars['ID']['output']>;
  allExternalAccess: Array<ExternalAccess>;
  allShiftSessions: Array<ShiftSessionWithUser>;
  allTelluCareIntegrations: Array<TelluCareIntegration>;
  almaForwarders: Array<AlmaForwarder>;
  ascomForwarders: Array<AscomForwarder>;
  azureAccounts: Array<Maybe<AzureAccount>>;
  badges: Badges;
  cameraProvisioningBatchTelluSupport: Array<CameraManagementStatus>;
  cmpAccount: CmpAccount;
  cmpAccounts?: Maybe<Array<CmpAccount>>;
  concreteObservation?: Maybe<Observation>;
  customers: Array<Customer>;
  dailyAuditLogStats?: Maybe<DailyAuditLogStatsPaginated>;
  dailyDeviceStats?: Maybe<DailyDeviceStatsPaginated>;
  dailyPatientStats?: Maybe<DailyPatientStatsPaginated>;
  dailyUserStats?: Maybe<DailyUserStatsPaginated>;
  defaultRoleDefinitions?: Maybe<Array<RoleDefinition>>;
  defaultTemplates: DefaultTemplates;
  deviceGroup: DeviceGroup;
  deviceGroups: Array<DeviceGroup>;
  deviceStats: DeviceStatsPaginated;
  dialoggUsers: Array<DialoggUser>;
  dialoggUsersWithAccessToPatient: Array<DialoggUser>;
  exportFhirPatientBundle: PatientBundle;
  externalAccesses: Array<ExternalAccessLess>;
  externalHumanIdTypes: Array<ExternalHumanIdType>;
  externalIdentityProviderRedirectorsForHealthProvider?: Maybe<Array<ExternalIdentityProviderRedirector>>;
  externalIdentityProviders: Array<ExternalIdentityProvider>;
  externalIdentityProvidersForHealthProvider: Array<ExternalIdentityProviderForHealthProvider>;
  fhirAlarmTemplates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fhirObservationTemplates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getAlarmById: Task;
  getAlarmHandlingPlanAlarms: Array<AlarmActivity>;
  getAlarmHandlingRulesForUserGroup?: Maybe<Array<SkyresponseAlarmHandlingRule>>;
  getAlarmHistoryDetailById: AlarmDetail;
  getAlarmHistoryForPatient: Array<AlarmHistory>;
  getAlarmHistoryForResponseOperator: Array<Task>;
  getAlarmStatus: AlarmStatus;
  getAlarmSubscriptionById?: Maybe<AlarmSubscription>;
  getAlarmTemplate: AlarmTemplate;
  getAlarmTemplates: Array<AlarmTemplate>;
  getAllAlarmEventsForPatient: Array<Observation>;
  getAllAlarmEventsForPatientPaginated: AlarmEventsPaginated;
  getAllAlarmHistory: Array<AlarmHistory>;
  getAllAlarmSubscriptions: Array<AlarmSubscription>;
  getAllCarePlanObservations: Array<Observation>;
  getAllCarePlanTemplateQuestionnaires: Array<Questionnaire>;
  getAllCarePlanTemplates: Array<CarePlan>;
  getAllConcreteObservationsAsCsv?: Maybe<ObservationsCsv>;
  getAllExternalAccessForPatient: Array<ExternalAccessLess>;
  getAllFinishedHealthProviderDeletionFlowStatuses: Array<FlowStatus>;
  getAllHealthProviderDeletionFlowStatuses: Array<FlowStatus>;
  getAllObservationTemplates: Array<Maybe<Observation>>;
  getAllPatientAlarms: Array<Task>;
  getAllPatientAlarmsForPatient: Array<Task>;
  getAllQuestionnaireTemplates: Array<Questionnaire>;
  getAllRpmGateways: Array<RpmGateway>;
  getAllRpmMedicalDevices: Array<RpmMedicalDevice>;
  getAllSelfTreatmentPlanTemplates?: Maybe<Array<SelfTreatmentPlan>>;
  getAllTechnicalAlarmEventsForDevicePaginated?: Maybe<AlarmEventsPaginated>;
  getAllTechnicalAlarms: Array<Task>;
  getAllTechnicalAlarmsForDevices: Array<Task>;
  getAllUserGroupChildren: Array<UserGroupChild>;
  getAllUsersAlarmSubscriptions: Array<AlarmSubscription>;
  getAppDevicesForPatient: Array<AppDevice>;
  getAuditEntitySummary: Array<AuditEntitySummaryEntry>;
  getAuditLogEventForPatientById?: Maybe<AuditEvent>;
  getAuditLogEventForUserGroupById?: Maybe<AuditEvent>;
  getAuditLogForPatientPaginated: AuditLogPaginated;
  getAuditLogForUserPaginated: AuditLogPaginated;
  getAuditLogPaginated: AuditLogPaginated;
  getAuditLogSummaries: AuditLogSummaries;
  getAuditLogSummary: Array<AuditLogSummaryEntry>;
  getAuditRoleSummary: Array<AuditRoleSummaryEntry>;
  getAvailableCamerasInInventory: Array<CameraInInventory>;
  getAvailableDevicesInSafematePro: GetExternalDevicesResponse;
  getAvailableWelfareDevicesInInventory: Array<WelfareDeviceInInventory>;
  /**
   * Retrieves a single camera.
   *
   * Required access scopes: ['user/Camera.read']
   *
   * The operation is audit logged.
   */
  getCamera: Camera;
  /**
   * Retrieves administration information regarding the camera, herein connection status, firmware, as well as the URL for the administration interface of the camera.
   *
   * Required access scopes: ['user/Camera.read', 'user/Camera.write']
   *
   * The operation is audit logged.
   */
  getCameraAdmin: CameraAdmin;
  /**
   * Retrieves all cameras.
   *
   * Required access scopes: ['user/Camera.read']
   *
   * The operation is NOT audit logged.
   */
  getCameraList: Array<ListCamera>;
  /**
   * Retrieves camera statuses from the invoicing microservices
   * for all the cameras in the account
   * ⚠️⚠️⚠️
   * ⚠️ - This status is not live, as the invoicing runs early morning (before 06:00AM CET)
   * ⚠️
   * ⚠️ - It will only return the statuses for cameras that are both in registry and in the account DB
   * ⚠️⚠️⚠️
   */
  getCameraManagementList: Array<CameraStatus>;
  getCarePlanByID: CarePlan;
  getCarePlanObservation: Observation;
  getCarePlanQuestionnaire: Questionnaire;
  getCarePlanTemplate: CarePlan;
  getCarePlanTemplateQuestionnaire: Questionnaire;
  getCompletedPatientAlarms: Array<Task>;
  getConcreteObservationsForPatient: Array<Maybe<Observation>>;
  getConcreteObservationsForPatientAsCsv?: Maybe<ObservationsCsv>;
  getContinuousSupervisionCandidates?: Maybe<Array<ContinuousSupervisionCandidate>>;
  getCoordinateOfAddress: CoordinateOfAddressResponse;
  getDeleteOldServiceResponsibleRoleFullStatus?: Maybe<Scalars['String']['output']>;
  getDeviceGroupExternalUrl?: Maybe<Scalars['String']['output']>;
  getDevicesByGroup: Array<DeviceInList>;
  getDistanceToPositions: DistanceToPositionsResponse;
  getEquipmentList: Array<Equipment>;
  getExternalAccessNames: Array<ExternalAccessNames>;
  getExternalUrlForWelfareDevice?: Maybe<Scalars['String']['output']>;
  getGeofencesForSafemateDevice?: Maybe<Array<DeviceGeofence>>;
  getHealthProviderDeletionFlowStatus?: Maybe<FlowStatus>;
  getHealthProviderMarkedForDeletionFlowStatus?: Maybe<FlowStatus>;
  getHealthProvidersMarkedForDeletion?: Maybe<Array<HealthProvider>>;
  getInconsistentHealthProviderReports: Array<InconsistentHealthProviderReport>;
  getIotcommsLogs: IotCommsLogs;
  getJournalConfigForUserGroup?: Maybe<JournalConfigForUserGroup>;
  getListOfUnallocatedCameras: Array<Camera>;
  getListOfUnallocatedRpmGateways: Array<RpmGateway>;
  getListOfUnallocatedRpmMedicalDevices: Array<RpmMedicalDevice>;
  getListOfUnallocatedWelfareDevices: Array<WelfareDevice>;
  getMedicalDeviceForMeasurement?: Maybe<MeasurementDevice>;
  getMigrations: Array<Migration>;
  getMyPersonalProfile: User;
  getMyUserProfile: User;
  getNextOfKin: Array<NextOfKin>;
  getNextOfKinById: NextOfKin;
  getNotificationLogs: Array<NotificationLog>;
  getNumberOfAccessiblePatients: Scalars['Int']['output'];
  getObservationTemplate?: Maybe<Observation>;
  getOpenPatientAlarms: Array<ListAlarm>;
  getOpenPatientAlarmsForPatient: Array<Task>;
  getOpenTechnicalAlarms: Array<Task>;
  getOpenTechnicalAlarmsForDevices: Array<Task>;
  getOpenTechnicalAlarmsForPatients: Array<Task>;
  getOwnerAuditEntitySummary: Array<AuditEntitySummaryEntry>;
  getOwnerAuditLogPaginated: AuditLogPaginated;
  getOwnerAuditLogSummaries: AuditLogSummaries;
  getOwnerAuditLogSummary: Array<AuditLogSummaryEntry>;
  getOwnerAuditRoleSummary: Array<AuditRoleSummaryEntry>;
  getPatientAuditEntitySummary: Array<AuditEntitySummaryEntry>;
  getPatientAuditLogSummary: Array<AuditLogSummaryEntry>;
  getPatientAuditRoleSummary: Array<AuditRoleSummaryEntry>;
  getPatientByExternalId: PatientByIdentityResponse;
  getPatientCmpDevices?: Maybe<Array<CmpDevice>>;
  getPatientFromVkp: PatientVkpResponse;
  getPatientSelfTreatmentPlans?: Maybe<SelfTreatmentPlan>;
  getPatientTasksNotCompleted: Array<Maybe<HpTaskAndPatientTasks>>;
  getPatientWithAlarms?: Maybe<PatientWithAlarms>;
  getPatientsWithoutAuditLog: Array<Maybe<PatientsWithoutAuditLog>>;
  getQuestionnaireResponseById?: Maybe<QuestionnaireResponse>;
  getQuestionnaireResponsesForPatient: Array<Maybe<QuestionnaireResponse>>;
  getQuestionnaireTemplate: Questionnaire;
  getReadyTaskCount: ReadyCount;
  getRestoreHealthProviderMarkedForDeletionFlowStatus?: Maybe<FlowStatus>;
  getRoleDefinition?: Maybe<RoleDefinition>;
  getRpmGateway?: Maybe<RpmGateway>;
  getRpmGatewayByhostname?: Maybe<RpmGateway>;
  getRpmMedicalDevice?: Maybe<RpmMedicalDevice>;
  getSelfTreatmentPlanTemplateById: SelfTreatmentPlan;
  getServiceResponsibleRoleFullMigrationStatus?: Maybe<Scalars['String']['output']>;
  getServiceResponsibleRoleMigrationStatus?: Maybe<Scalars['String']['output']>;
  getSharedSkyResponseAlarmsPatientCandidates: Array<Maybe<SharedAlarmCandidates>>;
  getSkyresponseStatusesForPatient?: Maybe<Array<SkyresponseSyncStatus>>;
  getSkyresponseStatusesForUserGroup?: Maybe<Array<SkyresponseSyncStatus>>;
  getSkyresponseSyncJobsCount: Scalars['Int']['output'];
  getSupervisionCarePlan?: Maybe<Array<Maybe<PlannedSupervision>>>;
  getSupportedLanguages?: Maybe<Array<LanguageCode>>;
  getTaskById?: Maybe<Task>;
  getTasks: Array<Maybe<Task>>;
  getTasksForPatient: Array<Maybe<Task>>;
  getTasksForPatientByDateRange: Array<Maybe<PatientTaskAndHpTasks>>;
  getTechnicalAlarmById: Task;
  getUserAuditEntitySummary: Array<AuditEntitySummaryEntry>;
  getUserAuditLogSummary: Array<AuditLogSummaryEntry>;
  getUserAuditRoleSummary: Array<AuditRoleSummaryEntry>;
  getVideoMeetingById?: Maybe<VideoMeeting>;
  getVideoMeetingCarePlan: Array<PlannedVideoMeeting>;
  getVideoMeetingTemplates: Array<AlarmTemplate>;
  getVideoMeetingsForPatient?: Maybe<Array<Maybe<VideoMeeting>>>;
  getWelfareDevice?: Maybe<WelfareDevice>;
  globalStats: Array<GlobalStats>;
  googlemapsAccounts?: Maybe<Array<GooglemapsAccount>>;
  healthProvider: HealthProvider;
  healthProviderSettings: HealthProviderSettings;
  healthProviders: Array<HealthProviderLess>;
  helseIdAccounts?: Maybe<Array<HelseIdAccount>>;
  hourlyPatientStats?: Maybe<HourlyPatientStatsPaginated>;
  hourlyUserStats?: Maybe<HourlyUserStatsPaginated>;
  iotcommsConfig?: Maybe<IotcommsConfig>;
  iotcommsNotificationSettings?: Maybe<IotcommsNotificationSettingsResponse>;
  iotcommsSipConfigs: Array<IotcommsSipConfig>;
  lastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatient: Array<Observation>;
  morpheanAccounts?: Maybe<Array<MorpheanAccount>>;
  /** Camera provisioning (Tellu Support only). */
  morpheanSitesPerMorpheanCustomerTelluSupport: Array<MorpheanSitesForMorpheanCustomer>;
  passwordPolicy?: Maybe<PasswordPolicy>;
  patient?: Maybe<Patient>;
  patientCommunications: Array<Communication>;
  patientCommunicationsPaginated: CommunicationPaginated;
  patientExportData?: Maybe<Array<PatientExport>>;
  patientGroup?: Maybe<PatientGroup>;
  patientGroups: Array<Maybe<PatientGroup>>;
  patientList: Array<ListPatient>;
  patientStats: PatientStatsPaginated;
  patients: Array<Patient>;
  patientsForImport: Array<PatientForImport>;
  registryDeviceTypes?: Maybe<Array<Maybe<RegistryDeviceType>>>;
  registryDevices: Array<RegistryDevice>;
  requestSinglePatientUrl?: Maybe<Scalars['String']['output']>;
  roleDefinitions?: Maybe<Array<RoleDefinition>>;
  roleTypes: Array<RoleType>;
  rpmGatewayAlerts: Array<RpmGatewayAlert>;
  rpmPatientExportData?: Maybe<Array<RpmPatientExport>>;
  safemateAccounts?: Maybe<Array<SafemateAccount>>;
  sendGridAccounts?: Maybe<Array<SendGridAccount>>;
  services?: Maybe<Array<Maybe<Service>>>;
  setOfPatients: Array<Maybe<Patient>>;
  shiftSession?: Maybe<ShiftSession>;
  singlePatientAccessTokenFromExternalPatientId?: Maybe<TokenWithApiEndpoint>;
  sipConfigs: Array<SipConfig>;
  skyresponseAccounts?: Maybe<Array<SkyresponseAccount>>;
  skyresponseForwarderConfigs: Array<SkyresponseForwarderConfig>;
  supportTeamLinkedHealthProviders?: Maybe<Array<LinkedHealthProvider>>;
  supportTeamsForHealthProvider: Array<SupportTeamForHealthProvider>;
  supportTeamsWithLinkedHealthProviders: Array<SupportTeamWithLinkedHealthProviders>;
  supportedCameraApps: Array<SupportedCameraApp>;
  supportedCameraModelsTelluSupport: Array<CameraModelWithCapabilities>;
  supportedTasksForJournaling?: Maybe<Array<Scalars['String']['output']>>;
  tcifAccounts?: Maybe<Array<TcifAccount>>;
  twilioAccounts?: Maybe<Array<TwilioAccount>>;
  unmanagedAccounts: Array<HealthProviderLess>;
  unreadCommunications: Array<Communication>;
  unreadCommunicationsCount: Scalars['Int']['output'];
  userGroup: UserGroup;
  userGroupPatientAccessList?: Maybe<Array<Maybe<UserWithUserGroupAccess>>>;
  userManuals: Array<UserManual>;
  users: Array<Maybe<User>>;
  validatePatientInSkyresponse?: Maybe<ValidatePatientInSkyresponseResponse>;
  videoMeetingTasks?: Maybe<Array<Maybe<Task>>>;
  videoMeetingTasksForPatient?: Maybe<Array<Maybe<Task>>>;
  videonorAccounts?: Maybe<Array<VideonorAccount>>;
  vkpAccounts?: Maybe<Array<VkpAccount>>;
  vkpPatientCareplan?: Maybe<VkpResponse>;
  vkpPatientEpisodesOfCare?: Maybe<VkpResponse>;
};

export type QueryAllExternalAccessArgs = {
  healthProviderName?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAllTelluCareIntegrationsArgs = {
  healthProviderName?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAzureAccountsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCmpAccountArgs = {
  id: Scalars['String']['input'];
};

export type QueryConcreteObservationArgs = {
  observationId: Scalars['ID']['input'];
};

export type QueryDailyAuditLogStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryDailyDeviceStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryDailyPatientStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryDailyUserStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryDefaultRoleDefinitionsArgs = {
  isDefaultType?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDefaultTemplatesArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type QueryDeviceGroupArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDeviceStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryDialoggUsersArgs = {
  username?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryDialoggUsersWithAccessToPatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryExportFhirPatientBundleArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryExternalHumanIdTypesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryExternalIdentityProviderRedirectorsForHealthProviderArgs = {
  healthProviderName: Scalars['String']['input'];
  includePatientRealm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryExternalIdentityProvidersArgs = {
  provider?: InputMaybe<Scalars['String']['input']>;
};

export type QueryExternalIdentityProvidersForHealthProviderArgs = {
  healthProviderName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFhirAlarmTemplatesArgs = {
  healthProviderName: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryFhirObservationTemplatesArgs = {
  healthProviderName: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetAlarmByIdArgs = {
  taskId: Scalars['ID']['input'];
};

export type QueryGetAlarmHandlingPlanAlarmsArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetAlarmHandlingRulesForUserGroupArgs = {
  userGroupId: Scalars['ID']['input'];
};

export type QueryGetAlarmHistoryDetailByIdArgs = {
  skyresponseAlarmId?: InputMaybe<Scalars['ID']['input']>;
  telluAlarmId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetAlarmHistoryForPatientArgs = {
  from: Scalars['dateTime']['input'];
  patientId: Scalars['ID']['input'];
  to: Scalars['dateTime']['input'];
};

export type QueryGetAlarmHistoryForResponseOperatorArgs = {
  from?: InputMaybe<Scalars['dateTime']['input']>;
  onlyClosedByResponseOperator?: InputMaybe<Scalars['Boolean']['input']>;
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAlarmStatusArgs = {
  taskId: Scalars['ID']['input'];
};

export type QueryGetAlarmTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetAllAlarmEventsForPatientArgs = {
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAllAlarmEventsForPatientPaginatedArgs = {
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAllAlarmHistoryArgs = {
  from: Scalars['dateTime']['input'];
  patientGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  to: Scalars['dateTime']['input'];
};

export type QueryGetAllCarePlanObservationsArgs = {
  carePlanId: Scalars['ID']['input'];
};

export type QueryGetAllCarePlanTemplateQuestionnairesArgs = {
  carePlanTemplateId: Scalars['ID']['input'];
};

export type QueryGetAllCarePlanTemplatesArgs = {
  withStatus?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetAllExternalAccessForPatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetAllPatientAlarmsArgs = {
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAllPatientAlarmsForPatientArgs = {
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAllTechnicalAlarmEventsForDevicePaginatedArgs = {
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  deviceId: Scalars['String']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAllTechnicalAlarmsArgs = {
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetAllTechnicalAlarmsForDevicesArgs = {
  deviceIds: Array<InputMaybe<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAllUserGroupChildrenArgs = {
  userGroupId: Scalars['ID']['input'];
};

export type QueryGetAppDevicesForPatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetAuditEntitySummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAuditLogEventForPatientByIdArgs = {
  id: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type QueryGetAuditLogEventForUserGroupByIdArgs = {
  id: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type QueryGetAuditLogForPatientPaginatedArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  operations?: InputMaybe<Array<AuditLogOperationSelector>>;
  patientId: Scalars['ID']['input'];
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAuditLogForUserPaginatedArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  operations?: InputMaybe<Array<AuditLogOperationSelector>>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type QueryGetAuditLogPaginatedArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  operations?: InputMaybe<Array<AuditLogOperationSelector>>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAuditLogSummariesArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetAuditLogSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetAuditRoleSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetCameraArgs = {
  cameraId: Scalars['ID']['input'];
};

export type QueryGetCameraAdminArgs = {
  cameraId: Scalars['ID']['input'];
};

export type QueryGetCarePlanByIdArgs = {
  carePlanId: Scalars['ID']['input'];
};

export type QueryGetCarePlanObservationArgs = {
  carePlanId: Scalars['ID']['input'];
  observationId: Scalars['ID']['input'];
};

export type QueryGetCarePlanQuestionnaireArgs = {
  carePlanId: Scalars['ID']['input'];
  questionnaireId: Scalars['ID']['input'];
};

export type QueryGetCarePlanTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetCarePlanTemplateQuestionnaireArgs = {
  carePlanTemplateId: Scalars['ID']['input'];
  questionnaireId: Scalars['ID']['input'];
};

export type QueryGetCompletedPatientAlarmsArgs = {
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetConcreteObservationsForPatientArgs = {
  carePlan?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetConcreteObservationsForPatientAsCsvArgs = {
  patientIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type QueryGetCoordinateOfAddressArgs = {
  address: Scalars['String']['input'];
};

export type QueryGetDeviceGroupExternalUrlArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetDevicesByGroupArgs = {
  deviceGroupId: Scalars['ID']['input'];
};

export type QueryGetDistanceToPositionsArgs = {
  destinations: Array<GpsPositionOrStringInput>;
  origins: Array<GpsPositionOrStringInput>;
};

export type QueryGetExternalUrlForWelfareDeviceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetGeofencesForSafemateDeviceArgs = {
  serialNumber: Scalars['String']['input'];
};

export type QueryGetHealthProviderDeletionFlowStatusArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type QueryGetHealthProviderMarkedForDeletionFlowStatusArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type QueryGetHealthProvidersMarkedForDeletionArgs = {
  healthProviderName?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetIotcommsLogsArgs = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  observationId: Scalars['String']['input'];
};

export type QueryGetJournalConfigForUserGroupArgs = {
  userGroupId: Scalars['ID']['input'];
};

export type QueryGetMedicalDeviceForMeasurementArgs = {
  measurementId: Scalars['ID']['input'];
  medicalDeviceId: Scalars['ID']['input'];
};

export type QueryGetNextOfKinArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetNextOfKinByIdArgs = {
  nokId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type QueryGetObservationTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetOpenPatientAlarmsArgs = {
  hideAssignedToOtherUsers?: InputMaybe<Scalars['Boolean']['input']>;
  patientGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetOpenPatientAlarmsForPatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetOpenTechnicalAlarmsArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetOpenTechnicalAlarmsForDevicesArgs = {
  deviceIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type QueryGetOpenTechnicalAlarmsForPatientsArgs = {
  patientIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type QueryGetOwnerAuditEntitySummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetOwnerAuditLogPaginatedArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  operations?: InputMaybe<Array<AuditLogOperationSelector>>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetOwnerAuditLogSummariesArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetOwnerAuditLogSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetOwnerAuditRoleSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetPatientAuditEntitySummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetPatientAuditLogSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetPatientAuditRoleSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetPatientByExternalIdArgs = {
  externalHumanIdTypeId: Scalars['String']['input'];
  externalPatientId: Scalars['String']['input'];
};

export type QueryGetPatientCmpDevicesArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetPatientFromVkpArgs = {
  norwegianId: Scalars['String']['input'];
};

export type QueryGetPatientSelfTreatmentPlansArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetPatientTasksNotCompletedArgs = {
  tasks: Array<Scalars['String']['input']>;
};

export type QueryGetPatientWithAlarmsArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetPatientsWithoutAuditLogArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetQuestionnaireResponseByIdArgs = {
  questionnaireResponseId: Scalars['ID']['input'];
};

export type QueryGetQuestionnaireResponsesForPatientArgs = {
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetQuestionnaireTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetReadyTaskCountArgs = {
  code?: InputMaybe<TaskCode>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  onlyUpcomingVideoMeetings?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetRestoreHealthProviderMarkedForDeletionFlowStatusArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type QueryGetRoleDefinitionArgs = {
  healthProviderName: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QueryGetRpmGatewayArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetRpmGatewayByhostnameArgs = {
  hostname: Scalars['String']['input'];
};

export type QueryGetRpmMedicalDeviceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetSelfTreatmentPlanTemplateByIdArgs = {
  selfTreatmentPlanId: Scalars['ID']['input'];
};

export type QueryGetServiceResponsibleRoleMigrationStatusArgs = {
  healthProviderName: Scalars['String']['input'];
};

export type QueryGetSharedSkyResponseAlarmsPatientCandidatesArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetSkyresponseStatusesForPatientArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetSkyresponseStatusesForUserGroupArgs = {
  userGroupId: Scalars['ID']['input'];
};

export type QueryGetSupervisionCarePlanArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetTaskByIdArgs = {
  taskId: Scalars['ID']['input'];
};

export type QueryGetTasksArgs = {
  code?: InputMaybe<TaskCode>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetTasksForPatientArgs = {
  code?: InputMaybe<TaskCode>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetTasksForPatientByDateRangeArgs = {
  fromDate?: InputMaybe<Scalars['dateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  toDate?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryGetTechnicalAlarmByIdArgs = {
  taskId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetUserAuditEntitySummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type QueryGetUserAuditLogSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type QueryGetUserAuditRoleSummaryArgs = {
  actions?: InputMaybe<Array<AuditEventAction>>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type QueryGetVideoMeetingByIdArgs = {
  videoMeetingId: Scalars['ID']['input'];
};

export type QueryGetVideoMeetingCarePlanArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryGetVideoMeetingsForPatientArgs = {
  patientId: Scalars['ID']['input'];
  startAtLeast?: InputMaybe<Scalars['dateTime']['input']>;
  startAtMost?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<AppointmentStatus>;
};

export type QueryGetWelfareDeviceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGlobalStatsArgs = {
  date: Scalars['date']['input'];
};

export type QueryHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type QueryHourlyPatientStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryHourlyUserStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  healthProvider: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryIotcommsSipConfigsArgs = {
  healthProviderName: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryLastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientArgs = {
  carePlanId?: InputMaybe<Scalars['ID']['input']>;
  loincCode?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
};

export type QueryPatientArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPatientCommunicationsArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryPatientCommunicationsPaginatedArgs = {
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryPatientExportDataArgs = {
  patientIds: Array<Scalars['ID']['input']>;
};

export type QueryPatientGroupArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPatientListArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  patientGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QueryPatientStatsArgs = {
  cursor?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
};

export type QueryPatientsArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryRegistryDevicesArgs = {
  healthProviderName?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryRequestSinglePatientUrlArgs = {
  externalAccessId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type QueryRoleDefinitionsArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type QueryRpmPatientExportDataArgs = {
  patientIds: Array<Scalars['ID']['input']>;
};

export type QuerySetOfPatientsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type QuerySinglePatientAccessTokenFromExternalPatientIdArgs = {
  externalHumanIdTypeId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
};

export type QuerySipConfigsArgs = {
  healthProviderName: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerySkyresponseForwarderConfigsArgs = {
  healthProviderName: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerySupportTeamsForHealthProviderArgs = {
  healthProviderName: Scalars['ID']['input'];
};

export type QueryUnreadCommunicationsArgs = {
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUnreadCommunicationsCountArgs = {
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUserGroupArgs = {
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUserGroupPatientAccessListArgs = {
  userGroupId: Scalars['ID']['input'];
};

export type QueryUserManualsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUsersArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryValidatePatientInSkyresponseArgs = {
  patientId: Scalars['ID']['input'];
};

export type QueryVideoMeetingTasksArgs = {
  startAtLeast?: InputMaybe<Scalars['dateTime']['input']>;
  startAtMost?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<AppointmentStatus>;
};

export type QueryVideoMeetingTasksForPatientArgs = {
  patientId: Scalars['ID']['input'];
  startAtLeast?: InputMaybe<Scalars['dateTime']['input']>;
  startAtMost?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<AppointmentStatus>;
};

export type QueryVkpPatientCareplanArgs = {
  id: Scalars['ID']['input'];
};

export type QueryVkpPatientEpisodesOfCareArgs = {
  id: Scalars['ID']['input'];
};

export type Questionnaire = {
  approvalDate?: Maybe<Scalars['dateTime']['output']>;
  carePlan?: Maybe<Scalars['ID']['output']>;
  carePlanObject?: Maybe<CarePlan>;
  derivedFrom?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  effectivePeriod?: Maybe<Period>;
  experimental: Scalars['Boolean']['output'];
  extension?: Maybe<Array<Maybe<Extension>>>;
  id: Scalars['ID']['output'];
  item?: Maybe<Array<Maybe<QuestionnaireItem>>>;
  json?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  patient?: Maybe<Scalars['ID']['output']>;
  patientObject?: Maybe<Patient>;
  priorities?: Maybe<QuestionnairePriorities>;
  publisher?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  status: QuestionnaireStatus;
  template: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type QuestionnaireInput = {
  carePlan?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectivePeriod?: InputMaybe<PeriodInput>;
  experimental?: InputMaybe<Scalars['Boolean']['input']>;
  item?: InputMaybe<Array<InputMaybe<QuestionnaireItemInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<Scalars['ID']['input']>;
  priorities?: InputMaybe<QuestionnairePrioritiesInput>;
  publisher?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<QuestionnaireStatus>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionnaireItem = {
  answerOption?: Maybe<Array<Maybe<QuestionnaireItemOption>>>;
  linkId: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  type: QuestionnaireItemType;
};

export type QuestionnaireItemInput = {
  answerOption?: InputMaybe<Array<InputMaybe<QuestionnaireItemOptionInput>>>;
  linkId: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  type: QuestionnaireItemType;
};

export type QuestionnaireItemOption = {
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueCoding?: Maybe<OptionCoding>;
  valueDecimal?: Maybe<Scalars['Float']['output']>;
  valueInteger?: Maybe<Scalars['Int']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireItemOptionInput = {
  valueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  valueCoding?: InputMaybe<OptionCodingInput>;
  valueDecimal?: InputMaybe<Scalars['Float']['input']>;
  valueInteger?: InputMaybe<Scalars['Int']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export enum QuestionnaireItemType {
  Boolean = 'boolean',
  Choice = 'choice',
  Decimal = 'decimal',
  Integer = 'integer',
  String = 'string',
}

export type QuestionnaireMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  questionnaire?: Maybe<Questionnaire>;
  success: Scalars['Boolean']['output'];
};

export type QuestionnairePriorities = {
  mode?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Array<Maybe<QuestionnairePrioritiesCode>>>;
  thresholds?: Maybe<Array<Maybe<QuestionnairePrioritiesCode>>>;
};

export type QuestionnairePrioritiesCode = {
  code?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type QuestionnairePrioritiesCodeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionnairePrioritiesInput = {
  mode?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Array<InputMaybe<QuestionnairePrioritiesCodeInput>>>;
  thresholds?: InputMaybe<Array<InputMaybe<QuestionnairePrioritiesCodeInput>>>;
};

export type QuestionnaireResponse = {
  authored: Scalars['dateTime']['output'];
  displayItem: Array<Maybe<QuestionnaireResponseDisplayItem>>;
  displaySummary?: Maybe<DisplaySummary>;
  extension?: Maybe<Array<Maybe<Extension>>>;
  id: Scalars['ID']['output'];
  item: Array<Maybe<QuestionnaireResponseItem>>;
  questionnaire: Scalars['String']['output'];
  questionnaireObject?: Maybe<Questionnaire>;
  received?: Maybe<Scalars['dateTime']['output']>;
  source: Reference;
  subject: Reference;
  taskPriority?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireResponseDisplayItem = {
  answer?: Maybe<Array<Maybe<QuestionnaireItemOption>>>;
  answerOption?: Maybe<Array<Maybe<QuestionnaireItemOption>>>;
  answerText?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  code?: Maybe<Scalars['String']['output']>;
  linkId?: Maybe<Scalars['String']['output']>;
  questionText?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  type: QuestionnaireItemType;
};

export type QuestionnaireResponseItem = {
  answer?: Maybe<Array<Maybe<QuestionnaireItemOption>>>;
  linkId?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireResponseMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  questionnaireResponse?: Maybe<QuestionnaireResponse>;
  success: Scalars['Boolean']['output'];
};

export type QuestionnaireResponseSimulatorInput = {
  authored?: InputMaybe<Scalars['dateTime']['input']>;
  item: Array<QuestionnaireResponseSimulatorItemInput>;
  questionnaire: Scalars['String']['input'];
  source?: InputMaybe<ReferenceInput>;
  subject: ReferenceInput;
};

export type QuestionnaireResponseSimulatorItemInput = {
  answer: Array<QuestionnaireSimulatorItemOptionInput>;
  linkId?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionnaireSimulatorItemOptionInput = {
  valueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  valueCoding?: InputMaybe<OptionCodingSimulatorInput>;
  valueDecimal?: InputMaybe<Scalars['Float']['input']>;
  valueInteger?: InputMaybe<Scalars['Int']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
};

export enum QuestionnaireStatus {
  Active = 'active',
  Draft = 'draft',
  Retired = 'retired',
  Unknown = 'unknown',
}

export type ReadyCount = {
  asap: Scalars['Int']['output'];
  routine: Scalars['Int']['output'];
  stat: Scalars['Int']['output'];
  upcomingVideo: Scalars['Int']['output'];
  urgent: Scalars['Int']['output'];
  video: Scalars['Int']['output'];
};

export type Reference = {
  display?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Identifier>;
  reference?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ReferenceInput = {
  display?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<IdentifierInput>;
  reference?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceOnlyInput = {
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceRange = {
  high?: Maybe<ValueQuantity>;
  low?: Maybe<ValueQuantity>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CodeableConcept>;
};

export type ReferenceRangeInput = {
  high?: InputMaybe<ValueQuantityInput>;
  low?: InputMaybe<ValueQuantityInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CodeableConceptInput>;
};

export type RegistryDevice = {
  arch?: Maybe<Scalars['String']['output']>;
  deviceGroup?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  healthProviderName?: Maybe<Scalars['String']['output']>;
  heartbeatCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastBatteryStatus?: Maybe<Scalars['Int']['output']>;
  lastBatteryTimestamp?: Maybe<Scalars['dateTime']['output']>;
  lastHeartbeat?: Maybe<Scalars['dateTime']['output']>;
  lastObservation?: Maybe<Scalars['dateTime']['output']>;
  lastStatus?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  observationCount?: Maybe<Scalars['Int']['output']>;
  online?: Maybe<Scalars['Boolean']['output']>;
  routerMac?: Maybe<Scalars['String']['output']>;
  routerVendor?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type RegistryDeviceInput = {
  createFhirDeviceInput?: InputMaybe<CreateFhirDeviceInput>;
  healthProviderName?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type RegistryDeviceMutationResponse = {
  message?: Maybe<Scalars['String']['output']>;
  registryDevice?: Maybe<RegistryDevice>;
  success: Scalars['Boolean']['output'];
};

export type RegistryDeviceType = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ReminderStatus = {
  date: Scalars['Float']['output'];
  objectReference: Reference;
  success: Scalars['Boolean']['output'];
};

export type RemotePatientMonitoringConfigForPatient = {
  enabled: Scalars['Boolean']['output'];
  taskCodesForJournaling: Array<Scalars['String']['output']>;
};

export type RemoteSupervisionConfigForPatient = {
  enabled: Scalars['Boolean']['output'];
};

export type ReplaceWelfareDeviceIdentifierInput = {
  modelNumber: Scalars['String']['input'];
  uniqueIdentifier: Scalars['String']['input'];
};

export type Role = {
  abilities?: Maybe<Array<Maybe<Ability>>>;
  basedOn?: Maybe<Scalars['String']['output']>;
  dashboardRouteName?: Maybe<Scalars['String']['output']>;
  display: Array<Maybe<LocaleDefinition>>;
  id: Scalars['ID']['output'];
  protected?: Maybe<Scalars['Boolean']['output']>;
  roleDefinitionId: Scalars['ID']['output'];
  userGroup?: Maybe<UserGroup>;
};

export type RoleDefinition = {
  abilities?: Maybe<Array<Maybe<Ability>>>;
  accessScopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  basedOn?: Maybe<Scalars['ID']['output']>;
  dashboardRouteName?: Maybe<Scalars['String']['output']>;
  display: Array<Maybe<LocaleDefinition>>;
  id: Scalars['ID']['output'];
  isDefaultType?: Maybe<Scalars['String']['output']>;
};

export type RoleDefinitionCreateInput = {
  abilities?: InputMaybe<Array<InputMaybe<AbilityInput>>>;
  accessScopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dashboardRouteName?: InputMaybe<Scalars['String']['input']>;
  display: Array<InputMaybe<LocaleDefinitionInput>>;
  protected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoleDefinitionMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  roleDefinition?: Maybe<RoleDefinition>;
  success: Scalars['Boolean']['output'];
};

export type RoleDefinitionUpdateInput = {
  abilities?: InputMaybe<Array<InputMaybe<AbilityInput>>>;
  accessScopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dashboardRouteName?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Array<InputMaybe<LocaleDefinitionInput>>>;
  protected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoleMutationResponse = {
  message?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RoleType = {
  basedOn_fk: Scalars['String']['output'];
  display: Array<Maybe<LocaleDefinition>>;
  id: Scalars['ID']['output'];
};

export type RouterInfo = {
  mac?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type RpmDevice = {
  btAddress?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Array<Annotation>>;
};

export type RpmGwMonitoringStatus = {
  ble_service_running?: Maybe<Scalars['Int']['output']>;
  cputemp?: Maybe<Scalars['Int']['output']>;
  uptime?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type RpmGateway = Device &
  RpmDevice & {
    btAddress?: Maybe<Scalars['String']['output']>;
    children?: Maybe<Array<RpmMedicalDevice>>;
    deviceGroup?: Maybe<DeviceGroup>;
    deviceName?: Maybe<Array<DeviceName>>;
    gatewayHostname: Scalars['String']['output'];
    gatewayStatus?: Maybe<RpmGatewayStatus>;
    id: Scalars['ID']['output'];
    identifier?: Maybe<Array<Identifier>>;
    isAttachedToPatient?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Not supported for this device. Will always return false. */
    isDeviceBtPaired?: Maybe<Scalars['Boolean']['output']>;
    manufacturer?: Maybe<Scalars['String']['output']>;
    modelName?: Maybe<Scalars['String']['output']>;
    modelNumber?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Array<Annotation>>;
    patient?: Maybe<Reference>;
    serialNumber?: Maybe<Scalars['String']['output']>;
    /** @deprecated Not supported for this device. Will always return active. */
    status?: Maybe<Scalars['String']['output']>;
    tags?: Maybe<Array<Scalars['String']['output']>>;
    type?: Maybe<CodeableConcept>;
    userFriendlyName?: Maybe<Scalars['String']['output']>;
    userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
  };

export type RpmGatewayAlert = {
  alert?: Maybe<Scalars['String']['output']>;
  gateway?: Maybe<RpmGateway>;
};

export type RpmGatewayCreateInput = {
  deviceGroupId?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  hostname: Scalars['String']['input'];
  modelNumber: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RpmGatewayMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  rpmGateway?: Maybe<RpmGateway>;
  success: Scalars['Boolean']['output'];
};

export type RpmGatewayStatus = DeviceStatus & {
  connected?: Maybe<Scalars['Boolean']['output']>;
  heartbeatCount?: Maybe<Scalars['Int']['output']>;
  lastBatteryStatus?: Maybe<Scalars['Int']['output']>;
  lastBatteryTimestamp?: Maybe<Scalars['dateTime']['output']>;
  lastMeasurements?: Maybe<Array<LastMeasurement>>;
  lastSeen?: Maybe<Scalars['dateTime']['output']>;
  lastStatus?: Maybe<RpmGwMonitoringStatus>;
};

export type RpmGatewayUpdateInput = {
  deviceGroupId?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  hostname?: InputMaybe<Scalars['String']['input']>;
  modelNumber?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RpmMedicalDevice = Device &
  RpmDevice & {
    batteryLevel?: Maybe<Scalars['Int']['output']>;
    btAddress?: Maybe<Scalars['String']['output']>;
    deviceGroup?: Maybe<DeviceGroup>;
    deviceName?: Maybe<Array<DeviceName>>;
    firmwareVersion?: Maybe<Scalars['String']['output']>;
    gatewayHostname?: Maybe<Scalars['String']['output']>;
    hardwareVersion?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    identifier?: Maybe<Array<Identifier>>;
    isAttachedToPatient?: Maybe<Scalars['Boolean']['output']>;
    isDeviceBtPaired?: Maybe<Scalars['Boolean']['output']>;
    manufacturer?: Maybe<Scalars['String']['output']>;
    modelName?: Maybe<Scalars['String']['output']>;
    modelNumber?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Array<Annotation>>;
    parent?: Maybe<Reference>;
    parentDevice?: Maybe<RpmGateway>;
    patient?: Maybe<Reference>;
    sensorType?: Maybe<Scalars['String']['output']>;
    serialNumber?: Maybe<Scalars['String']['output']>;
    softwareVersion?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    tags?: Maybe<Array<Scalars['String']['output']>>;
    type?: Maybe<CodeableConcept>;
    userFriendlyName?: Maybe<Scalars['String']['output']>;
    userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
  };

export type RpmMedicalDeviceCreateInput = {
  btAddress?: InputMaybe<Scalars['String']['input']>;
  deviceGroupId?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  modelName: Scalars['String']['input'];
  modelNumber?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<AnnotationInput>;
  sensorType: Scalars['String']['input'];
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum RpmMedicalDeviceModelNumber {
  AndUa651Ble = 'AND_UA651BLE',
  AndUa656Ble = 'AND_UA656BLE',
  AndUc352Ble = 'AND_UC352BLE',
  AndUt201Ble = 'AND_UT201BLE',
  ContourNextOne = 'CONTOUR_NEXT_ONE',
  Nonin_3230 = 'NONIN_3230',
}

export type RpmMedicalDeviceMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  rpmMedicalDevice?: Maybe<RpmMedicalDevice>;
  success: Scalars['Boolean']['output'];
};

export enum RpmMedicalDeviceSensorType {
  BloodPressureMonitor = 'bloodPressureMonitor',
  Glucometer = 'glucometer',
  InEar = 'inEar',
  Oximeter = 'oximeter',
  Scale = 'scale',
  Smartwatch = 'smartwatch',
  Spirometer = 'spirometer',
  Thermometer = 'thermometer',
  Unknown = 'unknown',
}

export type RpmMedicalDeviceUpdateInput = {
  btAddress?: InputMaybe<Scalars['String']['input']>;
  deviceGroupId?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  modelNumber?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<AnnotationInput>;
  sensorType?: InputMaybe<Scalars['String']['input']>;
};

export type RpmPatientExport = {
  active?: Maybe<Scalars['Boolean']['output']>;
  birthDate?: Maybe<Scalars['date']['output']>;
  createdAt?: Maybe<Scalars['dateTime']['output']>;
  externalIds: Array<ExternalIdExport>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<AdministrativeGender>;
  lastActive?: Maybe<Scalars['dateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  patientGroupName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['dateTime']['output']>;
};

export type SafemateAccount = {
  accountDisplayName?: Maybe<Scalars['String']['output']>;
  apiUrl?: Maybe<Scalars['String']['output']>;
  apiUsername?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  observationUsername?: Maybe<Scalars['String']['output']>;
};

export type SafemateAccountCreateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  apiPassword?: InputMaybe<Scalars['String']['input']>;
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  apiUsername?: InputMaybe<Scalars['String']['input']>;
  observationPassword?: InputMaybe<Scalars['String']['input']>;
  observationUsername?: InputMaybe<Scalars['String']['input']>;
};

export type SafemateAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  safemateAccount?: Maybe<SafemateAccount>;
  success: Scalars['Boolean']['output'];
};

export type SafemateAccountUpdateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  apiPassword?: InputMaybe<Scalars['String']['input']>;
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  apiUsername?: InputMaybe<Scalars['String']['input']>;
  observationPassword?: InputMaybe<Scalars['String']['input']>;
  observationUsername?: InputMaybe<Scalars['String']['input']>;
};

export type SafemateEventInput = {
  battery?: InputMaybe<Scalars['Int']['input']>;
  deviceNumber?: InputMaybe<Scalars['String']['input']>;
  deviceSNNum?: InputMaybe<Scalars['String']['input']>;
  escalated?: InputMaybe<Scalars['Int']['input']>;
  geofenceName?: InputMaybe<Scalars['String']['input']>;
  marketId?: InputMaybe<Scalars['String']['input']>;
  messageTime?: InputMaybe<Scalars['String']['input']>;
  messageType?: InputMaybe<Scalars['Int']['input']>;
  msgId?: InputMaybe<Scalars['String']['input']>;
  posLat?: InputMaybe<Scalars['String']['input']>;
  posLon?: InputMaybe<Scalars['String']['input']>;
  posTime?: InputMaybe<Scalars['String']['input']>;
  refPoint?: InputMaybe<Scalars['String']['input']>;
};

export type SafemateExternalDevice = {
  countryCode?: Maybe<Scalars['Int']['output']>;
  custId?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  lastMessageFromDevice?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNum?: Maybe<Scalars['String']['output']>;
  serial: Scalars['String']['output'];
  simStatus?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  topLevelCustomerId?: Maybe<Scalars['Int']['output']>;
  topLevelCustomerName?: Maybe<Scalars['String']['output']>;
};

export type SafemateProDevice = {
  customerName?: Maybe<Scalars['String']['output']>;
  healthProviderName?: Maybe<Scalars['String']['output']>;
  isInRegistry: Scalars['Boolean']['output'];
  isInWrongHealthProvider: Scalars['Boolean']['output'];
  lastMessageFromDevice?: Maybe<Scalars['dateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNum?: Maybe<Scalars['String']['output']>;
  serial?: Maybe<Scalars['String']['output']>;
  simStatus?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type SelfTreatmentPlan = {
  goals: Array<Goal>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['String']['output']>;
  medicalStates?: Maybe<MedicalStates>;
  status: CarePlanStatus;
  subject: Reference;
  title?: Maybe<Scalars['String']['output']>;
};

export type SelfTreatmentPlanMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  selfTreatmentPlan?: Maybe<SelfTreatmentPlan>;
  success: Scalars['Boolean']['output'];
};

export type SelfTreatmentPlanTemplateInput = {
  goal?: InputMaybe<GoalInput>;
  medicalStates?: InputMaybe<MedicalStatesInput>;
  title: Scalars['String']['input'];
};

export type SelfTreatmentPlanTemplateUpdateInput = {
  goal?: InputMaybe<UpdateGoalInput>;
  medicalStates?: InputMaybe<MedicalStatesInput>;
  title: Scalars['String']['input'];
};

export type SendGridAccount = {
  accountDisplayName: Scalars['String']['output'];
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SendGridAccountCreateInput = {
  accountDisplayName: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
};

export type SendGridAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  sendGridAccount?: Maybe<SendGridAccount>;
  success: Scalars['Boolean']['output'];
};

export type SendGridAccountUpdateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
};

export type Service = {
  applications?: Maybe<Applications>;
  configuration?: Maybe<AccountConfiguration>;
  features?: Maybe<AccountFeatures>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Maybe<ServiceRole>>>;
};

export type ServiceRole = {
  abilities?: Maybe<Array<Maybe<Ability>>>;
  basedOn?: Maybe<Scalars['String']['output']>;
  canAssignRoles?: Maybe<Array<Scalars['String']['output']>>;
  dashboardRouteName?: Maybe<Scalars['String']['output']>;
  display: Array<Maybe<LocaleDefinition>>;
  id: Scalars['ID']['output'];
  roleDefinitionId: Scalars['ID']['output'];
  userGroup?: Maybe<ServiceUserGroup>;
  userManuals?: Maybe<Array<UserManual>>;
};

export type ServiceUserGroup = {
  id: Scalars['ID']['output'];
  isTopLevel?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type SessionNotificationSettings = {
  email?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  sendEmail?: Maybe<Scalars['Boolean']['output']>;
  sendSms?: Maybe<Scalars['Boolean']['output']>;
};

export type SessionNotificationSettingsInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  sendEmail: Scalars['Boolean']['input'];
  sendSms: Scalars['Boolean']['input'];
};

export type ShareAlarmWidth = {
  id: Scalars['ID']['output'];
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  norwegianId?: Maybe<Scalars['String']['output']>;
};

export type SharedAlarmCandidates = {
  externalPatientIds?: Maybe<Array<PatientListExternalIds>>;
  id: Scalars['String']['output'];
  name?: Maybe<Array<HumanName>>;
};

export type SharedAlarmPatients = {
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ShiftSession = {
  createdAt: Scalars['dateTime']['output'];
  lastUpdated: Scalars['dateTime']['output'];
  notificationSettings: SessionNotificationSettings;
  patientGroupIdsAndNames: Array<PatientGroupIdAndName>;
  pushNotificationSettings: Array<PushNotificationSettings>;
};

export type ShiftSessionWithUser = {
  session?: Maybe<ShiftSession>;
  user?: Maybe<User>;
};

export type SimpleAlarm = {
  authoredOn: Scalars['dateTime']['output'];
  id: Scalars['String']['output'];
};

export type SimpleAlarmTemplate = {
  code: Scalars['String']['output'];
  direction: Scalars['String']['output'];
  displayText?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  isPresentInAccount?: Maybe<Scalars['Boolean']['output']>;
  system: Scalars['String']['output'];
  technical: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type SimpleMeasurementTemplate = {
  code: Scalars['String']['output'];
  displayText?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  isPresentInAccount?: Maybe<Scalars['Boolean']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SimulateSyncEventPayloadInput = {
  _type?: InputMaybe<Scalars['String']['input']>;
  flowLogs?: InputMaybe<Scalars['String']['input']>;
  flowName?: InputMaybe<Scalars['String']['input']>;
  stepName?: InputMaybe<Scalars['String']['input']>;
};

export type SipConfig = {
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  primaryUrl: Scalars['String']['output'];
  secondaryUrl?: Maybe<Scalars['String']['output']>;
};

export type SipConfigCreateInput = {
  displayName: Scalars['String']['input'];
  primaryUrl: Scalars['String']['input'];
  secondaryUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SkyresponseAccount = {
  accountDisplayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  privateResponseCenterId?: Maybe<Scalars['String']['output']>;
  privateResponseCenterName?: Maybe<Scalars['String']['output']>;
  publicResponseCenterObjectId?: Maybe<Scalars['String']['output']>;
  responseCenterName?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type SkyresponseAccountCreateInput = {
  accountDisplayName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  privateResponseCenterId?: InputMaybe<Scalars['String']['input']>;
  privateResponseCenterName?: InputMaybe<Scalars['String']['input']>;
  publicResponseCenterObjectId?: InputMaybe<Scalars['String']['input']>;
  responseCenterName?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type SkyresponseAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  skyresponseAccount?: Maybe<SkyresponseAccount>;
  success: Scalars['Boolean']['output'];
};

export type SkyresponseAccountUpdateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  privateResponseCenterId?: InputMaybe<Scalars['String']['input']>;
  privateResponseCenterName?: InputMaybe<Scalars['String']['input']>;
  publicResponseCenterObjectId?: InputMaybe<Scalars['String']['input']>;
  responseCenterName?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SkyresponseAlarmDetail = {
  acceptedAt?: Maybe<Scalars['String']['output']>;
  action?: Maybe<Scalars['String']['output']>;
  alarmCode: Scalars['Int']['output'];
  deactivationTime?: Maybe<Scalars['String']['output']>;
  globalAlarmId: Scalars['String']['output'];
  group: Scalars['String']['output'];
  id: Scalars['String']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  logs?: Maybe<Array<SkyresponseAlarmLogs>>;
  messages?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  responseCenter: Scalars['String']['output'];
  serverAlarmTime: Scalars['String']['output'];
  textMessage?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type SkyresponseAlarmHandlingRule = {
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  primaryRespondentGroup?: Maybe<Scalars['String']['output']>;
};

export type SkyresponseAlarmLogs = {
  created: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subType: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  type: Scalars['Int']['output'];
};

export type SkyresponseConfig = {
  allowedAlarmHandlingRuleIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  hasSkyresponseCredentials?: Maybe<Scalars['Boolean']['output']>;
  hasSkyresponseExternalId?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  privateArcObjectId?: Maybe<Scalars['Int']['output']>;
  publicArcObjectId?: Maybe<Scalars['Int']['output']>;
  skyresponseAlarmHandlingRuleId?: Maybe<Scalars['Int']['output']>;
};

export type SkyresponseConfigInput = {
  allowedAlarmHandlingRuleIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  privateArcObjectId?: InputMaybe<Scalars['Int']['input']>;
  publicArcObjectId?: InputMaybe<Scalars['Int']['input']>;
  skyresponseAlarmHandlingRuleId?: InputMaybe<Scalars['Int']['input']>;
};

export type SkyresponseEventInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  alarmCodeText?: InputMaybe<Scalars['String']['input']>;
  alarmTextMessage?: InputMaybe<Scalars['String']['input']>;
  criticality?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  responseCenterComment?: InputMaybe<Scalars['String']['input']>;
};

export type SkyresponseForwarderConfig = {
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  primaryUrl: Scalars['String']['output'];
};

export type SkyresponseForwarderConfigCreateInput = {
  displayName: Scalars['String']['input'];
  primaryUrl: Scalars['String']['input'];
};

export type SkyresponseSyncAlarm = {
  id: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type SkyresponseSyncLogEntry = {
  auditLogReferences: Array<FlowAuditLogReference>;
  details: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type SkyresponseSyncStatus = {
  flowName: Scalars['String']['output'];
  logs: Array<SkyresponseSyncLogEntry>;
  patientId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type SkyresponseValidationCheck = {
  differences: Array<SkyresponseValidationDifference>;
  name: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SkyresponseValidationDifference = {
  description: Scalars['String']['output'];
  skyresponse?: Maybe<Scalars['String']['output']>;
  tellu?: Maybe<Scalars['String']['output']>;
};

export type StepStatus = {
  attempts: Scalars['Int']['output'];
  lastActivity?: Maybe<Scalars['dateTime']['output']>;
  lastLocalePath?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum StreamQuality {
  Didnotstart = 'DIDNOTSTART',
  Frozen = 'FROZEN',
  Interrutped = 'INTERRUTPED',
  Other = 'OTHER',
  Slowtostart = 'SLOWTOSTART',
  Working = 'WORKING',
}

export type SupportTeamForHealthProvider = {
  displayName: Scalars['String']['output'];
  linked?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['ID']['output'];
};

export type SupportTeamWithLinkedHealthProviders = {
  displayName: Scalars['String']['output'];
  linkedHealthProviders: Array<Scalars['String']['output']>;
  name: Scalars['ID']['output'];
  unlinkedHealthProviders?: Maybe<Array<Scalars['String']['output']>>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SupportedCameraApp = {
  default: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  supportedModels: Array<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type SyncAlarmDetails = {
  entityName?: Maybe<Scalars['String']['output']>;
  userGroupId?: Maybe<Scalars['String']['output']>;
};

export type SyncEventDetails = {
  fhirId?: Maybe<Scalars['String']['output']>;
  flowLogs?: Maybe<Array<SkyresponseSyncLogEntry>>;
  flowName?: Maybe<Scalars['String']['output']>;
  skyresponseId?: Maybe<Scalars['String']['output']>;
  stepName?: Maybe<Scalars['String']['output']>;
  transmitterIdsToDelete?: Maybe<Scalars['String']['output']>;
};

export type SyncStatus = {
  openAlarms?: Maybe<Array<SimpleAlarm>>;
  status: Scalars['String']['output'];
};

export type SystemStatus = {
  needSetup: Scalars['Boolean']['output'];
  systemReady: Scalars['Boolean']['output'];
};

export type Tag = {
  label?: Maybe<Scalars['String']['output']>;
};

export type TagAction = {
  label?: Maybe<Scalars['String']['output']>;
  target?: Maybe<TagTarget>;
  type?: Maybe<TagActionType>;
};

export type TagActionInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TagTarget>;
  type?: InputMaybe<TagActionType>;
};

export enum TagActionType {
  Add = 'add',
  Remove = 'remove',
}

export type TagInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export enum TagTarget {
  Device = 'Device',
  Observation = 'Observation',
  Patient = 'Patient',
  Task = 'Task',
}

export type TakeCallInput = {
  phoneNumber: Scalars['String']['input'];
};

export type Task = {
  acceptedAt?: Maybe<Scalars['dateTime']['output']>;
  authoredOn: Scalars['dateTime']['output'];
  basedOn?: Maybe<Array<Maybe<Reference>>>;
  canRetryJournaling?: Maybe<Scalars['Boolean']['output']>;
  carePlan?: Maybe<CarePlan>;
  code?: Maybe<CodeableConcept>;
  completedAt?: Maybe<Scalars['dateTime']['output']>;
  completionOptions?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  directRoutingDetails?: Maybe<DirectRoutingDetails>;
  executionPeriod?: Maybe<Period>;
  firstEventTimestamp?: Maybe<Scalars['dateTime']['output']>;
  focus?: Maybe<Reference>;
  for: Reference;
  forDeviceName?: Maybe<Scalars['String']['output']>;
  forDeviceType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  input?: Maybe<Array<Maybe<TaskInput>>>;
  intent?: Maybe<Scalars['String']['output']>;
  isJournalNoteRequired?: Maybe<Scalars['Boolean']['output']>;
  isSupervisionAlarm?: Maybe<Scalars['Boolean']['output']>;
  isSupervisionAlarmWithAnOpenedCameraStream?: Maybe<Scalars['Boolean']['output']>;
  journalWorkflow?: Maybe<Array<JournalWorkflow>>;
  lastCompleted?: Maybe<Scalars['dateTime']['output']>;
  lastModified: Scalars['dateTime']['output'];
  locationTraces?: Maybe<Array<LocationTrace>>;
  note?: Maybe<Array<Maybe<Annotation>>>;
  observation?: Maybe<Observation>;
  output?: Maybe<Array<Maybe<TaskOutput>>>;
  owner?: Maybe<Reference>;
  partOf?: Maybe<Array<Maybe<Reference>>>;
  patient?: Maybe<Patient>;
  patientLink?: Maybe<PatientLinkData>;
  presentAt?: Maybe<Scalars['dateTime']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  priorityInput?: Maybe<TaskInput>;
  questionnaire?: Maybe<Questionnaire>;
  reminderDate?: Maybe<Scalars['dateTime']['output']>;
  reminderSent?: Maybe<Scalars['Boolean']['output']>;
  restriction?: Maybe<TaskRestriction>;
  status: Scalars['String']['output'];
  subTasks?: Maybe<Array<Maybe<Task>>>;
  syncAlarmDetails?: Maybe<SyncAlarmDetails>;
  syncPending?: Maybe<Scalars['Boolean']['output']>;
  videoMeeting?: Maybe<VideoMeeting>;
  vkpConfiguration?: Maybe<AlarmVkpConfiguration>;
};

export enum TaskCode {
  All = 'ALL',
  HpCheckInactivePatient = 'HP_CHECK_INACTIVE_PATIENT',
  HpPatientVideoMeetingRequest = 'HP_PATIENT_VIDEO_MEETING_REQUEST',
  HpReviewPatientData = 'HP_REVIEW_PATIENT_DATA',
}

export type TaskInput = {
  icon?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  syncEventDetails?: Maybe<SyncEventDetails>;
  templateCode?: Maybe<Scalars['String']['output']>;
  templateDisplayName?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CodeableConcept>;
  valueReference?: Maybe<Reference>;
  valueString?: Maybe<Scalars['String']['output']>;
  values: Array<TaskInputValue>;
};

export type TaskInputValue = {
  name: Scalars['String']['output'];
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  valueNumber?: Maybe<Scalars['Float']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type TaskMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  task?: Maybe<Task>;
};

export type TaskOutput = {
  type?: Maybe<CodeableConcept>;
  valueReference?: Maybe<Reference>;
};

export type TaskRestriction = {
  period?: Maybe<Period>;
  recipient?: Maybe<Array<Maybe<Reference>>>;
};

export type TcifAccount = {
  accountDisplayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  prefixUrl: Scalars['String']['output'];
};

export type TcifAccountCreateInput = {
  accountDisplayName: Scalars['String']['input'];
  prefixUrl: Scalars['String']['input'];
};

export type TcifAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  tcifAccount?: Maybe<TcifAccount>;
};

export type TcifAccountUpdateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  prefixUrl?: InputMaybe<Scalars['String']['input']>;
};

export type TelluCareIntegration = {
  apiEndpoint: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  healthProviderName: Scalars['String']['output'];
  hpName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  tested?: Maybe<TelluCareintegrationTest>;
};

export type TelluCareIntegrationCreateResponse = {
  id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type TelluCareIntegrationUpdateResponse = {
  id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type TelluCareintegrationTest = {
  lastTimeTested: Scalars['dateTime']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type TestAzureAccountCredentialsMutationResponse = {
  code?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TestTellucareIntegrationSetupInput = {
  apiEndpoint: Scalars['String']['input'];
  fhirId?: InputMaybe<Scalars['String']['input']>;
  hpName: Scalars['String']['input'];
};

export type TestTellucareIntegrationSetupResponse = {
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TimeManagementStatus = {
  obtainFromDHCP: Scalars['Boolean']['output'];
  timezone: Scalars['String']['output'];
};

export type TimedCepConfig = {
  alarmTime: Timing;
  events: Array<Scalars['String']['output']>;
  mode: TimedCepMode;
  periodLengthSec: Scalars['Int']['output'];
};

export type TimedCepConfigInput = {
  alarmTime: TimingInput;
  events: Array<Scalars['String']['input']>;
  mode: TimedCepMode;
  periodLengthSec: Scalars['Int']['input'];
};

export enum TimedCepMode {
  AllAbsent = 'ALL_ABSENT',
  SomePresent = 'SOME_PRESENT',
}

export type Timing = {
  event?: Maybe<Array<Maybe<Scalars['dateTime']['output']>>>;
  repeat?: Maybe<TimingRepeat>;
};

export type TimingInput = {
  event?: InputMaybe<Array<InputMaybe<Scalars['dateTime']['input']>>>;
  repeat?: InputMaybe<TimingRepeatInput>;
};

export type TimingRepeat = {
  boundsPeriod?: Maybe<Period>;
  dayOfWeek?: Maybe<Array<DayOfWeek>>;
  period?: Maybe<Scalars['Int']['output']>;
  periodUnit?: Maybe<Scalars['String']['output']>;
  timeOfDay: Array<Scalars['String']['output']>;
};

export type TimingRepeatInput = {
  boundsPeriod?: InputMaybe<PeriodInput>;
  dayOfWeek?: InputMaybe<Array<DayOfWeek>>;
  period?: InputMaybe<Scalars['Int']['input']>;
  periodUnit?: InputMaybe<Scalars['String']['input']>;
  timeOfDay: Array<Scalars['String']['input']>;
};

export type TokenWithApiEndpoint = {
  apiEndpoint: Scalars['String']['output'];
  fhirPatientId: Scalars['String']['output'];
  hpName: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type TwilioAccount = {
  accountDisplayName: Scalars['String']['output'];
  accountSid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type TwilioAccountCreateInput = {
  accountAuthToken: Scalars['String']['input'];
  accountDisplayName: Scalars['String']['input'];
  accountSid: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type TwilioAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  twilioAccount?: Maybe<TwilioAccount>;
};

export type TwilioAccountUpdateInput = {
  accountAuthToken?: InputMaybe<Scalars['String']['input']>;
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  accountSid?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAlarmRouteInput = {
  configId?: InputMaybe<Scalars['String']['input']>;
  configType?: InputMaybe<Scalars['String']['input']>;
  createPatientAlarmOnFail?: InputMaybe<Scalars['Boolean']['input']>;
  idMappingStrategy?: InputMaybe<Scalars['ID']['input']>;
  incomingTemplate?: InputMaybe<Scalars['String']['input']>;
  outgoingTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAlmaForwarder = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  primaryUrl?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAscomForwarder = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  ascomIntegrationId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  heartbeatRate?: InputMaybe<Scalars['Int']['input']>;
  primaryUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCameraInput = {
  deviceGroupId?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCareTeamInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  telecom: Array<InputMaybe<ContactPointInput>>;
};

export type UpdateContactInput = {
  availableHours: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  telecom: Array<ContactPointInput>;
};

export type UpdateDialoggUser = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExternalAccessInput = {
  id: Scalars['ID']['input'];
  patientGroupIds: Array<Scalars['String']['input']>;
};

export type UpdateGoalInput = {
  goal?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateNameOrIpRestrictionForExternalAccessInput = {
  allowedAccess?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  ipRestrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNextOfKinInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Array<AddressInput>>;
  name?: InputMaybe<HumanNameInput>;
  notifyNextOfKin?: InputMaybe<Scalars['Boolean']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  telecom?: InputMaybe<Array<InputMaybe<ContactPointInput>>>;
};

export type UpdatePatientInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  addressNote?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['date']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  keyCode?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<LanguageInput>>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<HumanNameInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<NotificationInput>;
  secretAddress?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  telecom?: InputMaybe<Array<InputMaybe<ContactPointInput>>>;
};

export type UpdateRoleInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTellucareIntegrationInput = {
  apiEndpoint?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  hpName?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserGroupInput = {
  name: Scalars['String']['input'];
  skyresponseConfig?: InputMaybe<SkyresponseConfigInput>;
};

export type UpdateUserManualInput = {
  applications?: InputMaybe<UserManualApplicationsInput>;
  icon?: InputMaybe<Scalars['String']['input']>;
  localeEntries?: InputMaybe<Array<UserManualLocaleEntryInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  roleDefinitionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type User = {
  autoCreatedSupportUser?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['dateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  externalIdP?: Maybe<Scalars['String']['output']>;
  externalIdentities?: Maybe<Array<ExternalIdentity>>;
  externalUserIds?: Maybe<Array<ExternalHumanId>>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ipRestrictions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastActive?: Maybe<Scalars['dateTime']['output']>;
  lastName: Scalars['String']['output'];
  mobileNumber?: Maybe<Scalars['String']['output']>;
  otpStatus?: Maybe<Scalars['String']['output']>;
  passwordStatus?: Maybe<Scalars['String']['output']>;
  pendingEmailInvitation?: Maybe<Scalars['Boolean']['output']>;
  requestedExternalIds?: Maybe<Array<ExternalIdRequest>>;
  roles?: Maybe<Array<Maybe<Role>>>;
  smsOtpPhoneNumber?: Maybe<Scalars['String']['output']>;
  smsOtpStatus?: Maybe<Scalars['String']['output']>;
  timeLimitedAccess?: Maybe<Period>;
  username?: Maybe<Scalars['String']['output']>;
};

export type UserCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalIdP?: InputMaybe<Scalars['String']['input']>;
  externalUserId?: InputMaybe<ExternalHumanIdInput>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
  temporaryPassword?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserGroup = {
  allowedRoleDefinitionIds?: Maybe<Array<Scalars['String']['output']>>;
  careTeams?: Maybe<Array<Maybe<CareTeam>>>;
  contacts?: Maybe<Array<Contact>>;
  deviceGroupIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  deviceGroups?: Maybe<Array<Maybe<DeviceGroup>>>;
  escalationDelay?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  linkedPatientGroupIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  linkedPatientGroups?: Maybe<Array<Maybe<PatientGroup>>>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  patientGroupIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  patientGroups?: Maybe<Array<Maybe<PatientGroup>>>;
  protected?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<Array<Maybe<Role>>>;
  rules?: Maybe<Array<Scalars['String']['output']>>;
  skyresponse?: Maybe<SkyresponseConfig>;
  skyresponseSyncStatus?: Maybe<SyncStatus>;
  subGroups?: Maybe<Array<Maybe<UserGroup>>>;
  subTree?: Maybe<Array<Maybe<UserGroup>>>;
  templateGroupId?: Maybe<Scalars['ID']['output']>;
  type: Scalars['String']['output'];
};

export type UserGroupAccessRole = {
  display: Array<LocaleDefinition>;
  id: Scalars['String']['output'];
  userGroupId: Scalars['ID']['output'];
  userGroupName: Scalars['String']['output'];
};

export type UserGroupChild = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserGroupMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  userGroup?: Maybe<UserGroup>;
};

export type UserManual = {
  applications?: Maybe<UserManualApplications>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  localeEntries: Array<UserManualLocaleEntry>;
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  roleDefinitions?: Maybe<Array<RoleDefinition>>;
};

export type UserManualLocaleEntry = {
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  localeId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UserManualLocaleEntryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  localeId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UserManualMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userManual?: Maybe<UserManual>;
};

export type UserMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type UserReservation = {
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type UserUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UserWithUserGroupAccess = {
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  roles: Array<UserGroupAccessRole>;
  username?: Maybe<Scalars['String']['output']>;
};

export type ValidateCustomerGroupTowardsCmpResponse = {
  device?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  totalDevices?: Maybe<Scalars['Int']['output']>;
};

export type ValidatePatientInSkyresponseResponse = {
  checks: Array<Maybe<SkyresponseValidationCheck>>;
  success: Scalars['Boolean']['output'];
};

export type ValidationError = {
  message?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type ValueQuantity = {
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ValueQuantityInput = {
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type VideoManagementStatus = {
  captureFrequency: Scalars['String']['output'];
  compression: Scalars['String']['output'];
  dayNight: DayNightManagementStatus;
  enabled: Scalars['Boolean']['output'];
  exposureMode: Scalars['String']['output'];
  fps: Scalars['String']['output'];
  iCount: Scalars['String']['output'];
  mirrored: Scalars['Boolean']['output'];
  pCount: Scalars['String']['output'];
  rateControlPriority: Scalars['String']['output'];
  resolution: Scalars['String']['output'];
  rotation: Scalars['String']['output'];
  rtsp: Scalars['Boolean']['output'];
  targetBitRate: Scalars['String']['output'];
  whiteBalanceMode: Scalars['String']['output'];
};

export type VideoMeeting = {
  appointment: Appointment;
  carePlan?: Maybe<CarePlan>;
  id: Scalars['ID']['output'];
  videonor?: Maybe<VideoNorMeeting>;
};

export type VideoMeetingInput = {
  basedOnRequest?: InputMaybe<ReferenceInput>;
  carePlanReference?: InputMaybe<ReferenceInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['dateTime']['input'];
  start: Scalars['dateTime']['input'];
};

export type VideoMeetingMutationResponse = {
  calendarInvitation?: Maybe<Scalars['String']['output']>;
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  videoMeeting?: Maybe<VideoMeeting>;
};

export type VideoNorMeeting = {
  endDate?: Maybe<Scalars['dateTime']['output']>;
  hostRoomUrl?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  participantRoomUrl?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['dateTime']['output']>;
};

export type VideonorAccount = {
  accountDisplayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  prefixUrl: Scalars['String']['output'];
  roomNamePrefix?: Maybe<Scalars['String']['output']>;
};

export type VideonorAccountCreateInput = {
  accountDisplayName: Scalars['String']['input'];
  bearer: Scalars['String']['input'];
  prefixUrl: Scalars['String']['input'];
  roomNamePrefix: Scalars['String']['input'];
};

export type VideonorAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  videonorAccount?: Maybe<VideonorAccount>;
};

export type VideonorAccountUpdateInput = {
  accountDisplayName?: InputMaybe<Scalars['String']['input']>;
  bearer?: InputMaybe<Scalars['String']['input']>;
  prefixUrl?: InputMaybe<Scalars['String']['input']>;
  roomNamePrefix?: InputMaybe<Scalars['String']['input']>;
};

export type VkpAccount = {
  accountDisplayName: Scalars['String']['output'];
  helseIdAccount?: Maybe<HelseIdAccount>;
  helseIdAccountId: Scalars['ID']['output'];
  id: Scalars['String']['output'];
};

export type VkpAccountInput = {
  accountDisplayName: Scalars['String']['input'];
  helseIdAccountId: Scalars['String']['input'];
};

export type VkpAccountMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  vkpAccount?: Maybe<VkpAccount>;
};

export type VkpEncounter = {
  reason?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type VkpEncounterInput = {
  reason?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
};

export type VkpResponse = {
  fnr: Scalars['ID']['output'];
  responseAsJson?: Maybe<Scalars['String']['output']>;
};

export type WelfareDevice = Device & {
  configuration?: Maybe<Configuration>;
  deviceGroup?: Maybe<DeviceGroup>;
  deviceName?: Maybe<Array<DeviceName>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<Identifier>>;
  isAttachedToPatient?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  modelNumber?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Reference>;
  property?: Maybe<DeviceProperty>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<WelfareDeviceStatus>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<CodeableConcept>;
  uniqueIdentifier: Scalars['String']['output'];
  userFriendlyName?: Maybe<Scalars['String']['output']>;
  userHasAccessToPatient?: Maybe<Scalars['Boolean']['output']>;
};

export type WelfareDeviceCreateInput = {
  deviceGroupId?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  modelNumber: Scalars['String']['input'];
  property?: InputMaybe<DevicePropertyInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  uniqueIdentifier: Scalars['String']['input'];
};

export type WelfareDeviceInInventory = {
  modelNumber: Scalars['String']['output'];
  uniqueIdentifier: Scalars['String']['output'];
};

export type WelfareDeviceMutationResponse = {
  inputValidation?: Maybe<InputValidationResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  welfareDevice?: Maybe<WelfareDevice>;
};

export type WelfareDeviceStatus = DeviceStatus & {
  connected?: Maybe<Scalars['Boolean']['output']>;
  heartbeatCount?: Maybe<Scalars['Int']['output']>;
  lastBatteryStatus?: Maybe<Scalars['Int']['output']>;
  lastBatteryTimestamp?: Maybe<Scalars['dateTime']['output']>;
  lastSeen?: Maybe<Scalars['dateTime']['output']>;
};

export type WelfareDeviceUpdateInput = {
  deviceGroupId?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  modelNumber?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<DevicePropertyInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Ability = {
  operation?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
};

export type AbilityInput = {
  operation?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
};

export type AppDeviceMeasurementDeviceInput = {
  appDeviceId: Scalars['String']['input'];
  medicalDevice: AppDeviceMeasurementMedicalDeviceInput;
};

export type AppDeviceMeasurementMedicalDeviceInput = {
  btAddress?: InputMaybe<Scalars['String']['input']>;
  firmwareVersion?: InputMaybe<Scalars['String']['input']>;
  hardwareVersion?: InputMaybe<Scalars['String']['input']>;
  manufacturer: Scalars['String']['input'];
  modelName: Scalars['String']['input'];
  modelNumber: Scalars['String']['input'];
  sensorType?: InputMaybe<RpmMedicalDeviceSensorType>;
  serialNumber: Scalars['String']['input'];
  softwareVersion?: InputMaybe<Scalars['String']['input']>;
};

export type ContactsImport = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type InheritedJournalConfigForUserGroupInput = {
  disableRemotePatientMonitoringForPatientGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  disableRemoteSupervisionForPatientGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LocaleDefinition = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LocaleDefinitionInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type OnBehalf = {
  accessiblePatients?: Maybe<Array<Scalars['ID']['output']>>;
  otherPatientIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type UserManualApplications = {
  dho?: Maybe<Scalars['Boolean']['output']>;
  tilsyn?: Maybe<Scalars['Boolean']['output']>;
};

export type UserManualApplicationsInput = {
  dho?: InputMaybe<Scalars['Boolean']['input']>;
  tilsyn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetAllQuestionnaireTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllQuestionnaireTemplatesQuery = {
  getAllQuestionnaireTemplates: Array<{
    id: string;
    title?: string | null;
    purpose?: string | null;
    experimental: boolean;
    version: string;
    status: QuestionnaireStatus;
    effectivePeriod?: { start?: any | null; end?: any | null } | null;
  }>;
};

export type UpdateAppDeviceForPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  appDeviceId: Scalars['ID']['input'];
  input: AppDeviceForPatientUpdateInput;
}>;

export type UpdateAppDeviceForPatientMutation = { updateAppDeviceForPatient: { success: boolean } };

export type DeviceGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type DeviceGroupsQuery = { deviceGroups: Array<{ id: string; name?: string | null }> };

export type GetMedicalDeviceForMeasurementQueryVariables = Exact<{
  measurementId: Scalars['ID']['input'];
  medicalDeviceId: Scalars['ID']['input'];
}>;

export type GetMedicalDeviceForMeasurementQuery = {
  getMedicalDeviceForMeasurement?: {
    id: string;
    serialNumber?: string | null;
    modelNumber?: string | null;
    manufacturer?: string | null;
  } | null;
};

export type ReadySubTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type ReadySubTasksQuery = {
  readySubTasks: Array<{
    id: string;
    subTasks?: Array<{
      id: string;
      status: string;
      priority?: string | null;
      code?: { text?: string | null } | null;
    } | null> | null;
  } | null>;
};

export type ReadyTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type ReadyTasksQuery = {
  readyTasks: Array<{
    id: string;
    status: string;
    priority?: string | null;
    authoredOn: any;
    code?: { text?: string | null } | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: { reference?: string | null; display?: string | null } | null;
    } | null> | null;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    carePlan?: { title?: string | null } | null;
    patient?: {
      id: string;
      birthDate?: any | null;
      name?: Array<{ text?: string | null }> | null;
      identifier: Array<{ value?: string | null } | null>;
    } | null;
  } | null>;
};

export type InProgressSubTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type InProgressSubTasksQuery = {
  inProgressSubTasks: Array<{
    id: string;
    subTasks?: Array<{
      id: string;
      status: string;
      priority?: string | null;
      code?: { text?: string | null } | null;
    } | null> | null;
  } | null>;
};

export type InProgressTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type InProgressTasksQuery = {
  inProgressTasks: Array<{
    id: string;
    status: string;
    priority?: string | null;
    authoredOn: any;
    code?: { text?: string | null } | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: { reference?: string | null; display?: string | null } | null;
    } | null> | null;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    carePlan?: { title?: string | null } | null;
    patient?: {
      id: string;
      birthDate?: any | null;
      name?: Array<{ text?: string | null }> | null;
      identifier: Array<{ value?: string | null } | null>;
    } | null;
  } | null>;
};

export type RejectedSubTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type RejectedSubTasksQuery = {
  rejectedSubTasks: Array<{
    id: string;
    subTasks?: Array<{
      id: string;
      status: string;
      priority?: string | null;
      code?: { text?: string | null } | null;
    } | null> | null;
  } | null>;
};

export type RejectedTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type RejectedTasksQuery = {
  rejectedTasks: Array<{
    id: string;
    status: string;
    priority?: string | null;
    authoredOn: any;
    code?: { text?: string | null } | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: { reference?: string | null; display?: string | null } | null;
    } | null> | null;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    carePlan?: { title?: string | null } | null;
    patient?: {
      id: string;
      birthDate?: any | null;
      name?: Array<{ text?: string | null }> | null;
      identifier: Array<{ value?: string | null } | null>;
    } | null;
  } | null>;
};

export type CompletedSubTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type CompletedSubTasksQuery = {
  completedSubTasks: Array<{
    id: string;
    subTasks?: Array<{
      id: string;
      status: string;
      priority?: string | null;
      code?: { text?: string | null } | null;
    } | null> | null;
  } | null>;
};

export type CompletedTasksQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type CompletedTasksQuery = {
  completedTasks: Array<{
    id: string;
    status: string;
    priority?: string | null;
    authoredOn: any;
    code?: { text?: string | null } | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: { reference?: string | null; display?: string | null } | null;
    } | null> | null;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    carePlan?: { title?: string | null } | null;
    patient?: {
      id: string;
      birthDate?: any | null;
      name?: Array<{ text?: string | null }> | null;
      identifier: Array<{ value?: string | null } | null>;
    } | null;
  } | null>;
};

export type GetPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetPatientQuery = { getPatient?: { id: string; name?: Array<{ text?: string | null }> | null } | null };

export type RemoveReferenceRangeFromPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  referenceRangeId: Scalars['ID']['input'];
}>;

export type RemoveReferenceRangeFromPatientMutation = {
  removeReferenceRangeFromPatient?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type UpdatePatientReferenceRangeMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  referenceRangeId: Scalars['ID']['input'];
  referenceRange: Array<InputMaybe<ObservationComponentInput>> | InputMaybe<ObservationComponentInput>;
}>;

export type UpdatePatientReferenceRangeMutation = {
  updatePatientReferenceRange?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type AddReferenceRangeToPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  referenceRange: PatientReferenceRangeInput;
}>;

export type AddReferenceRangeToPatientMutation = {
  addReferenceRangeToPatient?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type AcceptVideoMeetingTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type AcceptVideoMeetingTaskMutation = { acceptVideoMeetingTask?: { success: boolean } | null };

export type ReleaseVideoMeetingTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type ReleaseVideoMeetingTaskMutation = { releaseVideoMeetingTask?: { success: boolean } | null };

export type BookedMeetingsQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  startAtLeast?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type BookedMeetingsQuery = {
  bookedMeetings?: Array<{ appointment: { status: AppointmentStatus; start: any } } | null> | null;
};

export type ActivateCarePlanMutationVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
}>;

export type ActivateCarePlanMutation = {
  activateCarePlan: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string; status: CarePlanStatus } | null;
  };
};

export type ActivateCarePlanTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ActivateCarePlanTemplateMutation = {
  activateCarePlanTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string; status: CarePlanStatus } | null;
  };
};

export type ActivateObservationTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ActivateObservationTemplateMutation = {
  activateObservationTemplate?: {
    success: boolean;
    message?: string | null;
    observation?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type ActivateQuestionnaireTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ActivateQuestionnaireTemplateMutation = {
  activateQuestionnaireTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: { valid: boolean; errors?: Array<{ path?: string | null } | null> | null } | null;
  };
};

export type CreateObservationForActivityInCarePlanTemplateMutationVariables = Exact<{
  observationActivityInput?: InputMaybe<ObservationInput>;
}>;

export type CreateObservationForActivityInCarePlanTemplateMutation = {
  createObservationForActivityInCarePlanTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    observation?: {
      id: string;
      identifier?: Array<{ value?: string | null } | null> | null;
      code?: { text?: string | null; coding?: Array<{ code?: any | null } | null> | null } | null;
    } | null;
  };
};

export type CreateObservationForActivityInCarePlanMutationVariables = Exact<{
  observationActivityInput?: InputMaybe<ObservationInput>;
}>;

export type CreateObservationForActivityInCarePlanMutation = {
  createObservationForActivityInCarePlan: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    observation?: {
      id: string;
      identifier?: Array<{ value?: string | null } | null> | null;
      code?: { text?: string | null; coding?: Array<{ code?: any | null } | null> | null } | null;
    } | null;
  };
};

export type CreateCarePlanBasedOnExistingMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  newCarePlanTitle: Scalars['String']['input'];
  existingCarePlanId: Scalars['ID']['input'];
}>;

export type CreateCarePlanBasedOnExistingMutation = {
  createCarePlanBasedOnExisting: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string } | null;
  };
};

export type CreateCarePlanForPatientMutationVariables = Exact<{
  createInput?: InputMaybe<CarePlanInput>;
}>;

export type CreateCarePlanForPatientMutation = {
  createCarePlanForPatient: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string } | null;
  };
};

export type CreateCarePlanTemplateMutationVariables = Exact<{
  createInput: CarePlanTemplateInput;
}>;

export type CreateCarePlanTemplateMutation = {
  createCarePlanTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string } | null;
  };
};

export type CreateCarePlanTemplateBasedOnExistingMutationVariables = Exact<{
  newTitle: Scalars['String']['input'];
  basedOn: Scalars['ID']['input'];
}>;

export type CreateCarePlanTemplateBasedOnExistingMutation = {
  createCarePlanTemplateBasedOnExisting: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string } | null;
  };
};

export type CreateCommunicationMutationVariables = Exact<{
  communication: PersonnelCommunicationInput;
}>;

export type CreateCommunicationMutation = {
  createCommunication: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    communication?: { id: string } | null;
  };
};

export type CreateCommunicationToSeveralMutationVariables = Exact<{
  communication: PersonnelCommunicationToSeveralInput;
}>;

export type CreateCommunicationToSeveralMutation = {
  createCommunicationToSeveral: Array<{
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    communication?: { id: string } | null;
  }>;
};

export type CreateDocumentMutationVariables = Exact<{
  createInput: DocumentReferenceInput;
}>;

export type CreateDocumentMutation = {
  createDocument?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    documentReference?: {
      id: string;
      content?: Array<{ attachment?: { url?: string | null } | null } | null> | null;
    } | null;
  } | null;
};

export type CreateObservationTemplateMutationVariables = Exact<{
  observationInput: ObservationInput;
}>;

export type CreateObservationTemplateMutation = {
  createObservationTemplate?: {
    success: boolean;
    message?: string | null;
    observation?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type CreateQuestionnaireForActivityInCarePlanMutationVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
  questionnaireTemplateId: Scalars['ID']['input'];
}>;

export type CreateQuestionnaireForActivityInCarePlanMutation = {
  createQuestionnaireForActivityInCarePlan: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    questionnaire?: { id: string; title?: string | null; derivedFrom?: Array<string | null> | null } | null;
  };
};

export type CreateQuestionnaireForActivityInCarePlanTemplateMutationVariables = Exact<{
  carePlanTemplateId: Scalars['ID']['input'];
  questionnaireTemplateId: Scalars['ID']['input'];
}>;

export type CreateQuestionnaireForActivityInCarePlanTemplateMutation = {
  createQuestionnaireForActivityInCarePlanTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    questionnaire?: { id: string; title?: string | null; derivedFrom?: Array<string | null> | null } | null;
  };
};

export type CreateQuestionnaireTemplateMutationVariables = Exact<{
  questionnaireInput: QuestionnaireInput;
}>;

export type CreateQuestionnaireTemplateMutation = {
  createQuestionnaireTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    questionnaire?: {
      id: string;
      version: string;
      name: string;
      status: QuestionnaireStatus;
      experimental: boolean;
      title?: string | null;
      description?: string | null;
      publisher?: string | null;
      patient?: string | null;
      purpose?: string | null;
      carePlan?: string | null;
      template: boolean;
      effectivePeriod?: { start?: any | null; end?: any | null } | null;
      item?: Array<{
        linkId: string;
        text: string;
        type: QuestionnaireItemType;
        answerOption?: Array<{
          valueInteger?: number | null;
          valueDecimal?: number | null;
          valueString?: string | null;
          valueCoding?: { code?: string | null; display?: string | null } | null;
        } | null> | null;
      } | null> | null;
    } | null;
  };
};

export type DeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;

export type DeleteDocumentMutation = { deleteDocument?: { success: boolean; message?: string | null } | null };

export type DeleteDraftCarePlanMutationVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
}>;

export type DeleteDraftCarePlanMutation = { deleteDraftCarePlan: { success: boolean; message?: string | null } };

export type DeleteObservationTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteObservationTemplateMutation = { deleteObservationTemplate?: { success: boolean } | null };

export type DeleteAppDeviceForPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  appDeviceId: Scalars['ID']['input'];
}>;

export type DeleteAppDeviceForPatientMutation = {
  deleteAppDeviceForPatient: { success: boolean; message?: string | null };
};

export type MarkCommunicationAsReadMutationVariables = Exact<{
  communicationId: Scalars['ID']['input'];
}>;

export type MarkCommunicationAsReadMutation = {
  markCommunicationAsRead: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    communication?: { id: string } | null;
  };
};

export type CompleteCarePlanMutationVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
}>;

export type CompleteCarePlanMutation = {
  completeCarePlan: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string; status: CarePlanStatus } | null;
  };
};

export type CompleteCarePlanTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CompleteCarePlanTemplateMutation = {
  completeCarePlanTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    carePlan?: { id: string; status: CarePlanStatus } | null;
  };
};

export type RetireObservationTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RetireObservationTemplateMutation = {
  retireObservationTemplate?: {
    success: boolean;
    message?: string | null;
    observation?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type RetireQuestionnaireTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RetireQuestionnaireTemplateMutation = {
  retireQuestionnaireTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: { valid: boolean; errors?: Array<{ path?: string | null } | null> | null } | null;
  };
};

export type StartCompositeTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type StartCompositeTaskMutation = { startCompositeTask?: { success: boolean; message?: string | null } | null };

export type CompleteCompositeTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  journal?: InputMaybe<JournalInput>;
}>;

export type CompleteCompositeTaskMutation = {
  completeCompositeTask?: { success: boolean; message?: string | null } | null;
};

export type CompleteCompositeTaskAndItsSubTasksMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  journal?: InputMaybe<JournalInput>;
}>;

export type CompleteCompositeTaskAndItsSubTasksMutation = {
  completeCompositeTaskAndItsSubTasks?: { success: boolean; message?: string | null } | null;
};

export type RejectCompositeTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type RejectCompositeTaskMutation = {
  rejectCompositeTask?: { success: boolean; message?: string | null } | null;
};

export type CompleteSubTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type CompleteSubTaskMutation = { completeSubTask?: { success: boolean; message?: string | null } | null };

export type RejectSubTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type RejectSubTaskMutation = { rejectSubTask?: { success: boolean; message?: string | null } | null };

export type UpdateSubTaskPriorityMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateSubTaskPriorityMutation = {
  updateSubTaskPriority?: { success: boolean; message?: string | null } | null;
};

export type UpdateCompositeTaskPriorityMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateCompositeTaskPriorityMutation = {
  updateCompositeTaskPriority?: { success: boolean; message?: string | null } | null;
};

export type RetryTaskJournalingMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type RetryTaskJournalingMutation = {
  retryTaskJournaling?: { success: boolean; message?: string | null } | null;
};

export type TestPushNotificationMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  appDeviceId: Scalars['ID']['input'];
}>;

export type TestPushNotificationMutation = {
  testPushNotification: { success: boolean; date: number; objectReference: { reference?: string | null } };
};

export type UpdateCarePlanTemplateQuestionnaireMutationVariables = Exact<{
  carePlanTemplateId: Scalars['ID']['input'];
  questionnaireId: Scalars['ID']['input'];
  updateInput: QuestionnaireInput;
}>;

export type UpdateCarePlanTemplateQuestionnaireMutation = {
  updateCarePlanTemplateQuestionnaire: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    questionnaire?: {
      id: string;
      version: string;
      name: string;
      status: QuestionnaireStatus;
      experimental: boolean;
      title?: string | null;
      description?: string | null;
      publisher?: string | null;
      patient?: string | null;
      purpose?: string | null;
      carePlan?: string | null;
      template: boolean;
      effectivePeriod?: { start?: any | null; end?: any | null } | null;
      item?: Array<{
        linkId: string;
        text: string;
        type: QuestionnaireItemType;
        answerOption?: Array<{
          valueInteger?: number | null;
          valueDecimal?: number | null;
          valueString?: string | null;
          valueCoding?: { code?: string | null; display?: string | null } | null;
        } | null> | null;
      } | null> | null;
    } | null;
  };
};

export type UpdateDraftCarePlanMutationVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
  updateInput?: InputMaybe<CarePlanInput>;
}>;

export type UpdateDraftCarePlanMutation = {
  updateDraftCarePlan: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateDraftCarePlanTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput?: InputMaybe<CarePlanTemplateUpdateInput>;
}>;

export type UpdateDraftCarePlanTemplateMutation = {
  updateDraftCarePlanTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateObservationTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput: ObservationInput;
}>;

export type UpdateObservationTemplateMutation = {
  updateObservationTemplate?: {
    success: boolean;
    message?: string | null;
    observation?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type UpdateQuestionnaireMutationVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  updateInput?: InputMaybe<QuestionnaireInput>;
}>;

export type UpdateQuestionnaireMutation = {
  updateCarePlanQuestionnaire: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    questionnaire?: {
      id: string;
      version: string;
      name: string;
      status: QuestionnaireStatus;
      experimental: boolean;
      title?: string | null;
      description?: string | null;
      publisher?: string | null;
      patient?: string | null;
      purpose?: string | null;
      carePlan?: string | null;
      template: boolean;
      effectivePeriod?: { start?: any | null; end?: any | null } | null;
      item?: Array<{
        linkId: string;
        text: string;
        type: QuestionnaireItemType;
        answerOption?: Array<{
          valueInteger?: number | null;
          valueDecimal?: number | null;
          valueString?: string | null;
          valueCoding?: { code?: string | null; display?: string | null } | null;
        } | null> | null;
      } | null> | null;
    } | null;
  };
};

export type UpdateQuestionnaireTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput?: InputMaybe<QuestionnaireInput>;
}>;

export type UpdateQuestionnaireTemplateMutation = {
  updateQuestionnaireTemplate: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    questionnaire?: {
      id: string;
      version: string;
      name: string;
      status: QuestionnaireStatus;
      experimental: boolean;
      title?: string | null;
      description?: string | null;
      publisher?: string | null;
      patient?: string | null;
      purpose?: string | null;
      carePlan?: string | null;
      template: boolean;
      effectivePeriod?: { start?: any | null; end?: any | null } | null;
      item?: Array<{
        linkId: string;
        text: string;
        type: QuestionnaireItemType;
        answerOption?: Array<{
          valueInteger?: number | null;
          valueDecimal?: number | null;
          valueString?: string | null;
          valueCoding?: { code?: string | null; display?: string | null } | null;
        } | null> | null;
      } | null> | null;
    } | null;
  };
};

export type AddMyExternalIdMutationVariables = Exact<{
  externalUserId: ExternalHumanIdInput;
}>;

export type AddMyExternalIdMutation = {
  addMyExternalId: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type AddRpmGatewayToPatientWithInputValidationMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  rpmGatewayId: Scalars['ID']['input'];
}>;

export type AddRpmGatewayToPatientWithInputValidationMutation = {
  addRpmGatewayToPatient: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    rpmGateway?: { id: string; gatewayHostname: string; modelNumber?: string | null } | null;
  };
};

export type AddRpmMedicalDeviceToPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  rpmMedicalDeviceId: Scalars['ID']['input'];
}>;

export type AddRpmMedicalDeviceToPatientMutation = {
  addRpmMedicalDeviceToPatient: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    rpmMedicalDevice?: { modelName?: string | null; id: string } | null;
  };
};

export type AddRpmMedicalDeviceToRpmGatewayMutationVariables = Exact<{
  rpmGatewayId: Scalars['ID']['input'];
  rpmMedicalDeviceId: Scalars['ID']['input'];
}>;

export type AddRpmMedicalDeviceToRpmGatewayMutation = {
  addRpmMedicalDeviceToRpmGateway: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    rpmGateway?: {
      id: string;
      manufacturer?: string | null;
      serialNumber?: string | null;
      modelNumber?: string | null;
      btAddress?: string | null;
    } | null;
  };
};

export type ClearRpmMedicalDeviceFromRpmGatewayMutationVariables = Exact<{
  rpmGatewayId: Scalars['ID']['input'];
  rpmMedicalDeviceId: Scalars['ID']['input'];
}>;

export type ClearRpmMedicalDeviceFromRpmGatewayMutation = {
  clearRpmMedicalDeviceFromRpmGateway: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type ClearRpmMedicalDevicePairingWithRpmGatewayMutationVariables = Exact<{
  rpmGatewayId: Scalars['ID']['input'];
  rpmMedicalDeviceId: Scalars['ID']['input'];
}>;

export type ClearRpmMedicalDevicePairingWithRpmGatewayMutation = {
  clearRpmMedicalDevicePairingWithRpmGateway: { success: boolean; message?: string | null };
};

export type CreateRpmGatewayMutationVariables = Exact<{
  createInput: RpmGatewayCreateInput;
}>;

export type CreateRpmGatewayMutation = {
  createRpmGateway: {
    success: boolean;
    message?: string | null;
    rpmGateway?: { id: string; gatewayHostname: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type CreateRpmMedicalDeviceMutationVariables = Exact<{
  createInput: RpmMedicalDeviceCreateInput;
}>;

export type CreateRpmMedicalDeviceMutation = {
  createRpmMedicalDevice: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    rpmMedicalDevice?: {
      id: string;
      manufacturer?: string | null;
      serialNumber?: string | null;
      modelNumber?: string | null;
      btAddress?: string | null;
    } | null;
  };
};

export type DeleteRpmGatewayMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteRpmGatewayMutation = {
  deleteRpmGateway: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type DeleteRpmMedicalDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteRpmMedicalDeviceMutation = { deleteRpmMedicalDevice: { success: boolean } };

export type RemoveRpmGatewayFromPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  rpmGatewayId: Scalars['ID']['input'];
}>;

export type RemoveRpmGatewayFromPatientMutation = { removeRpmGatewayFromPatient: { success: boolean } };

export type RemoveRpmMedicalDeviceFromPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  rpmMedicalDeviceId: Scalars['ID']['input'];
}>;

export type RemoveRpmMedicalDeviceFromPatientMutation = {
  removeRpmMedicalDeviceFromPatient: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateRpmGatewayMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput: RpmGatewayUpdateInput;
}>;

export type UpdateRpmGatewayMutation = {
  updateRpmGateway: {
    success: boolean;
    message?: string | null;
    rpmGateway?: { id: string; gatewayHostname: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type ConcreteObservationQueryVariables = Exact<{
  observationId: Scalars['ID']['input'];
}>;

export type ConcreteObservationQuery = {
  concreteObservation?: {
    id: string;
    manual?: boolean | null;
    status: string;
    effectiveDateTime?: any | null;
    received?: any | null;
    gateway?: { display?: string | null } | null;
    identifier?: Array<{ value?: string | null } | null> | null;
    basedOn?: Array<{ reference?: string | null; identifier?: { value?: string | null } | null } | null> | null;
    code?: {
      text?: string | null;
      coding?: Array<{ system?: any | null; code?: any | null; display?: string | null } | null> | null;
    } | null;
    device?: { reference?: string | null; display?: string | null } | null;
    subject?: { reference?: string | null } | null;
    performer?: Array<{ reference?: string | null; display?: string | null } | null> | null;
    component?: Array<{
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; code?: any | null; display?: string | null } | null> | null;
      };
      valueQuantity?: { value?: number | null; unit?: string | null } | null;
      referenceRange?: Array<{
        text?: string | null;
        low?: { value?: number | null; unit?: string | null } | null;
        high?: { value?: number | null; unit?: string | null } | null;
        type?: {
          text?: string | null;
          coding?: Array<{
            system?: any | null;
            version?: string | null;
            code?: any | null;
            display?: string | null;
            userSelected?: boolean | null;
          } | null> | null;
        } | null;
      } | null> | null;
      interpretation?: Array<{
        text?: string | null;
        coding?: Array<{
          system?: any | null;
          version?: string | null;
          code?: any | null;
          display?: string | null;
          userSelected?: boolean | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
    instantiates?: Array<{ reference?: string | null } | null> | null;
  } | null;
};

export type GetCarePlanByIdQueryVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
}>;

export type GetCarePlanByIdQuery = {
  getCarePlanByID: {
    id: string;
    status: CarePlanStatus;
    title?: string | null;
    description?: string | null;
    created?: any | null;
    subject: { reference?: string | null };
    period?: { start?: any | null; end?: any | null } | null;
    activity: Array<{
      outcomeReference?: Array<{
        reference?: string | null;
        display?: string | null;
        type?: string | null;
        identifier?: { value?: string | null } | null;
      } | null> | null;
      observations?: Array<{
        id: string;
        text?: string | null;
        status: string;
        identifier?: Array<{ value?: string | null } | null> | null;
        basedOn?: Array<{ reference?: string | null } | null> | null;
        note?: Array<{ text?: string | null } | null> | null;
        fromTemplate?: { reference?: string | null } | null;
        code?: {
          text?: string | null;
          coding?: Array<{
            system?: any | null;
            version?: string | null;
            code?: any | null;
            display?: string | null;
          } | null> | null;
        } | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{
              system?: any | null;
              version?: string | null;
              code?: any | null;
              display?: string | null;
            } | null> | null;
          };
          valueQuantity?: { value?: number | null; unit?: string | null } | null;
          referenceRange?: Array<{
            text?: string | null;
            low?: { value?: number | null; unit?: string | null } | null;
            high?: { value?: number | null; unit?: string | null } | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
              } | null> | null;
            } | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
      detail: {
        instantiatesCanonical?: Array<string | null> | null;
        status: string;
        questionnaires?: Array<{
          id: string;
          title?: string | null;
          derivedFrom?: Array<string | null> | null;
        } | null> | null;
        scheduledTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
      };
    } | null>;
    documents?: Array<{
      id: string;
      content?: Array<{
        attachment?: {
          title?: string | null;
          contentType?: string | null;
          url?: string | null;
          size?: number | null;
          creation?: any | null;
        } | null;
      } | null> | null;
    } | null> | null;
  };
};

export type GetCarePlanTitleQueryQueryVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
}>;

export type GetCarePlanTitleQueryQuery = { getCarePlanByID: { title?: string | null } };

export type GetCarePlanDocumentsQueryQueryVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
}>;

export type GetCarePlanDocumentsQueryQuery = {
  getCarePlanByID: {
    documents?: Array<{
      id: string;
      content?: Array<{
        attachment?: {
          title?: string | null;
          contentType?: string | null;
          url?: string | null;
          size?: number | null;
          creation?: any | null;
        } | null;
      } | null> | null;
    } | null> | null;
  };
};

export type GetCarePlanTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetCarePlanTemplateQuery = {
  getCarePlanTemplate: {
    id: string;
    status: CarePlanStatus;
    title?: string | null;
    description?: string | null;
    created?: any | null;
    carePlanType?: string | null;
    period?: { start?: any | null; end?: any | null } | null;
    activity: Array<{
      outcomeReference?: Array<{
        reference?: string | null;
        display?: string | null;
        type?: string | null;
        identifier?: { value?: string | null } | null;
      } | null> | null;
      observations?: Array<{
        id: string;
        text?: string | null;
        status: string;
        identifier?: Array<{ value?: string | null } | null> | null;
        basedOn?: Array<{ reference?: string | null } | null> | null;
        note?: Array<{ text?: string | null } | null> | null;
        fromTemplate?: { reference?: string | null } | null;
        code?: {
          text?: string | null;
          coding?: Array<{
            system?: any | null;
            version?: string | null;
            code?: any | null;
            display?: string | null;
          } | null> | null;
        } | null;
        component?: Array<{
          code: {
            text?: string | null;
            coding?: Array<{
              system?: any | null;
              version?: string | null;
              code?: any | null;
              display?: string | null;
            } | null> | null;
          };
          valueQuantity?: { value?: number | null; unit?: string | null } | null;
          referenceRange?: Array<{
            text?: string | null;
            low?: { value?: number | null; unit?: string | null } | null;
            high?: { value?: number | null; unit?: string | null } | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
              } | null> | null;
            } | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
      detail: {
        instantiatesCanonical?: Array<string | null> | null;
        status: string;
        questionnaires?: Array<{
          id: string;
          title?: string | null;
          derivedFrom?: Array<string | null> | null;
        } | null> | null;
        scheduledTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
      };
    } | null>;
    documents?: Array<{
      id: string;
      content?: Array<{
        attachment?: {
          title?: string | null;
          contentType?: string | null;
          url?: string | null;
          size?: number | null;
          creation?: any | null;
        } | null;
      } | null> | null;
    } | null> | null;
  };
};

export type GetObservationTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetObservationTemplateQuery = {
  getObservationTemplate?: {
    id: string;
    systemDefined?: boolean | null;
    status: string;
    identifier?: Array<{ value?: string | null } | null> | null;
    code?: {
      text?: string | null;
      coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
    } | null;
    component?: Array<{
      valueQuantity?: { unit?: string | null } | null;
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
      };
      referenceRange?: Array<{
        text?: string | null;
        low?: { value?: number | null } | null;
        high?: { value?: number | null } | null;
        type?: {
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null;
      } | null> | null;
      dataAbsentReason?: { text?: string | null } | null;
    } | null> | null;
  } | null;
};

export type GetPatientTasksNotCompletedQueryVariables = Exact<{
  tasks: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type GetPatientTasksNotCompletedQuery = {
  getPatientTasksNotCompleted: Array<{
    task: { id: string; authoredOn: any };
    patientTasks: Array<{
      id: string;
      code?: { text?: string | null } | null;
      restriction?: { period?: { start?: any | null; end?: any | null } | null } | null;
    } | null>;
  } | null>;
};

export type GetQuestionnaireResponseByIdQueryVariables = Exact<{
  questionnaireResponseId: Scalars['ID']['input'];
}>;

export type GetQuestionnaireResponseByIdQuery = {
  getQuestionnaireResponseById?: {
    id: string;
    authored: any;
    received?: any | null;
    subject: { reference?: string | null };
    source: { reference?: string | null; display?: string | null };
    displayItem: Array<{
      linkId?: string | null;
      type: QuestionnaireItemType;
      questionText?: string | null;
      answerText?: Array<string | null> | null;
      code?: string | null;
      score?: number | null;
    } | null>;
    displaySummary?: {
      score?: number | null;
      priorities?: {
        mode?: string | null;
        thresholds?: Array<{ code?: string | null; value?: number | null } | null> | null;
        points?: Array<{ code?: string | null; value?: number | null } | null> | null;
      } | null;
      computedTaskPriority?: { code?: string | null; value?: number | null } | null;
    } | null;
    questionnaireObject?: {
      id: string;
      title?: string | null;
      carePlanObject?: { title?: string | null } | null;
      patientObject?: { name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null } | null;
    } | null;
  } | null;
};

export type GetQuestionnaireResponsesForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type GetQuestionnaireResponsesForPatientQuery = {
  getQuestionnaireResponsesForPatient: Array<{
    id: string;
    authored: any;
    displayItem: Array<{
      answerText?: Array<string | null> | null;
      code?: string | null;
      linkId?: string | null;
      questionText?: string | null;
      score?: number | null;
      type: QuestionnaireItemType;
    } | null>;
    questionnaireObject?: {
      id: string;
      title?: string | null;
      carePlanObject?: { title?: string | null } | null;
      patientObject?: { name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null } | null;
    } | null;
  } | null>;
};

export type GetTasksForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type GetTasksForPatientQuery = {
  getTasksForPatient: Array<{
    id: string;
    status: string;
    priority?: string | null;
    authoredOn: any;
    code?: { text?: string | null } | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    carePlan?: { id: string; title?: string | null } | null;
    patient?: {
      id: string;
      name?: Array<{ text?: string | null }> | null;
      identifier: Array<{ value?: string | null } | null>;
    } | null;
    subTasks?: Array<{
      id: string;
      authoredOn: any;
      intent?: string | null;
      priority?: string | null;
      status: string;
      code?: { text?: string | null } | null;
      partOf?: Array<{ reference?: string | null } | null> | null;
      note?: Array<{
        authorString?: string | null;
        time?: any | null;
        text?: string | null;
        authorReference?: { display?: string | null; reference?: string | null } | null;
      } | null> | null;
      focus?: { reference?: string | null } | null;
    } | null> | null;
  } | null>;
};

export type GetTasksForPatientByDateRangeQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  fromDate?: InputMaybe<Scalars['dateTime']['input']>;
  toDate?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type GetTasksForPatientByDateRangeQuery = {
  getTasksForPatientByDateRange: Array<{
    hpTasks: Array<string>;
    task: {
      id: string;
      status: string;
      description?: string | null;
      priority?: string | null;
      authoredOn: any;
      lastModified: any;
      reminderDate?: any | null;
      reminderSent?: boolean | null;
      code?: { text?: string | null } | null;
      restriction?: { period?: { start?: any | null; end?: any | null } | null } | null;
      carePlan?: { id: string; title?: string | null } | null;
    };
  } | null>;
};

export type LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  carePlanId?: InputMaybe<Scalars['ID']['input']>;
  loincCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery = {
  lastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatient: Array<{
    manual?: boolean | null;
    id: string;
    text?: string | null;
    status: string;
    effectiveDateTime?: any | null;
    identifier?: Array<{ value?: string | null } | null> | null;
    basedOn?: Array<{ reference?: string | null; identifier?: { value?: string | null } | null } | null> | null;
    code?: {
      text?: string | null;
      coding?: Array<{ system?: any | null; code?: any | null; display?: string | null } | null> | null;
    } | null;
    subject?: { reference?: string | null } | null;
    performer?: Array<{ reference?: string | null; display?: string | null } | null> | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: {
          system?: string | null;
          use?: IdentifierUse | null;
          value?: string | null;
          type?: {
            text?: string | null;
            coding?: Array<{
              system?: any | null;
              version?: string | null;
              code?: any | null;
              display?: string | null;
              userSelected?: boolean | null;
            } | null> | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
    component?: Array<{
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; code?: any | null; display?: string | null } | null> | null;
      };
      valueQuantity?: { value?: number | null; unit?: string | null } | null;
      referenceRange?: Array<{
        text?: string | null;
        low?: { value?: number | null; unit?: string | null } | null;
        high?: { value?: number | null; unit?: string | null } | null;
        type?: {
          text?: string | null;
          coding?: Array<{
            system?: any | null;
            version?: string | null;
            code?: any | null;
            display?: string | null;
            userSelected?: boolean | null;
          } | null> | null;
        } | null;
      } | null> | null;
      interpretation?: Array<{
        text?: string | null;
        coding?: Array<{
          system?: any | null;
          version?: string | null;
          code?: any | null;
          display?: string | null;
          userSelected?: boolean | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
    instantiates?: Array<{ reference?: string | null } | null> | null;
  }>;
};

export type GetAllObservationTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllObservationTemplatesQuery = {
  getAllObservationTemplates: Array<{
    id: string;
    systemDefined?: boolean | null;
    status: string;
    identifier?: Array<{ value?: string | null } | null> | null;
    code?: {
      text?: string | null;
      coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
    } | null;
    component?: Array<{
      valueQuantity?: { unit?: string | null } | null;
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
      };
      referenceRange?: Array<{
        text?: string | null;
        low?: { value?: number | null; unit?: string | null } | null;
        high?: { value?: number | null; unit?: string | null } | null;
        type?: {
          text?: string | null;
          coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null>;
};

export type GetConcreteObservationsForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  carePlan?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type GetConcreteObservationsForPatientQuery = {
  getConcreteObservationsForPatient: Array<{
    manual?: boolean | null;
    id: string;
    text?: string | null;
    status: string;
    effectiveDateTime?: any | null;
    identifier?: Array<{ value?: string | null } | null> | null;
    basedOn?: Array<{ reference?: string | null; identifier?: { value?: string | null } | null } | null> | null;
    code?: {
      text?: string | null;
      coding?: Array<{ system?: any | null; code?: any | null; display?: string | null } | null> | null;
    } | null;
    subject?: { reference?: string | null } | null;
    performer?: Array<{ reference?: string | null; display?: string | null } | null> | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: {
          system?: string | null;
          use?: IdentifierUse | null;
          value?: string | null;
          type?: {
            text?: string | null;
            coding?: Array<{
              system?: any | null;
              version?: string | null;
              code?: any | null;
              display?: string | null;
              userSelected?: boolean | null;
            } | null> | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
    component?: Array<{
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; code?: any | null; display?: string | null } | null> | null;
      };
      valueQuantity?: { value?: number | null; unit?: string | null } | null;
      referenceRange?: Array<{
        text?: string | null;
        low?: { value?: number | null; unit?: string | null } | null;
        high?: { value?: number | null; unit?: string | null } | null;
        type?: {
          text?: string | null;
          coding?: Array<{
            system?: any | null;
            version?: string | null;
            code?: any | null;
            display?: string | null;
            userSelected?: boolean | null;
          } | null> | null;
        } | null;
      } | null> | null;
      interpretation?: Array<{
        text?: string | null;
        coding?: Array<{
          system?: any | null;
          version?: string | null;
          code?: any | null;
          display?: string | null;
          userSelected?: boolean | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
    instantiates?: Array<{ reference?: string | null } | null> | null;
  } | null>;
};

export type GetConcreteObservationsForPatientAsCsvQueryVariables = Exact<{
  patientIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;

export type GetConcreteObservationsForPatientAsCsvQuery = {
  getConcreteObservationsForPatientAsCsv?: { csv?: string | null } | null;
};

export type GetAppDevicesForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetAppDevicesForPatientQuery = {
  getAppDevicesForPatient: Array<{
    id: string;
    username: string;
    deviceName: string;
    os: string;
    lastActive?: any | null;
    appSettings?: { appLocale?: string | null; appName?: string | null; pushId?: string | null } | null;
    notificationSettings?: {
      message?: boolean | null;
      deviation?: boolean | null;
      measurement?: boolean | null;
      reviewed?: boolean | null;
      reminder?: number | null;
    } | null;
    remindedTasks?: Array<{ success: boolean; date: number; objectReference: { reference?: string | null } }> | null;
  }>;
};

export type PatientCommunicationsPaginatedQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
}>;

export type PatientCommunicationsPaginatedQuery = {
  patientCommunicationsPaginated: {
    cursor?: any | null;
    events?: Array<{
      id: string;
      status?: string | null;
      sent?: any | null;
      received?: any | null;
      payload?: Array<{
        contentString?: string | null;
        picture?: {
          id: string;
          deleted?: boolean | null;
          deletedAt?: string | null;
          deletedBy?: { display?: string | null; reference?: string | null } | null;
          content?: Array<{
            attachment?: {
              title?: string | null;
              contentType?: string | null;
              url?: string | null;
              size?: number | null;
              creation?: any | null;
            } | null;
          } | null> | null;
        } | null;
      } | null> | null;
      sender?: { reference?: string | null; display?: string | null } | null;
      subject?: { reference?: string | null } | null;
    } | null> | null;
  };
};

export type GetQuestionnaireTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetQuestionnaireTemplateQuery = {
  getQuestionnaireTemplate: {
    id: string;
    version: string;
    name: string;
    status: QuestionnaireStatus;
    experimental: boolean;
    purpose?: string | null;
    title?: string | null;
    description?: string | null;
    patient?: string | null;
    carePlan?: string | null;
    publisher?: string | null;
    effectivePeriod?: { start?: any | null; end?: any | null } | null;
    item?: Array<{
      linkId: string;
      text: string;
      type: QuestionnaireItemType;
      answerOption?: Array<{
        valueInteger?: number | null;
        valueDecimal?: number | null;
        valueString?: string | null;
        valueCoding?: { code?: string | null; display?: string | null } | null;
      } | null> | null;
    } | null> | null;
    priorities?: {
      mode?: string | null;
      thresholds?: Array<{ code?: string | null; value?: number | null } | null> | null;
      points?: Array<{ code?: string | null; value?: number | null } | null> | null;
    } | null;
  };
};

export type GetCarePlanQuestionnaireQueryVariables = Exact<{
  carePlanId: Scalars['ID']['input'];
  questionnaireId: Scalars['ID']['input'];
}>;

export type GetCarePlanQuestionnaireQuery = {
  getCarePlanQuestionnaire: {
    id: string;
    version: string;
    name: string;
    status: QuestionnaireStatus;
    experimental: boolean;
    purpose?: string | null;
    title?: string | null;
    description?: string | null;
    patient?: string | null;
    carePlan?: string | null;
    publisher?: string | null;
    effectivePeriod?: { start?: any | null; end?: any | null } | null;
    item?: Array<{
      linkId: string;
      text: string;
      type: QuestionnaireItemType;
      answerOption?: Array<{
        valueInteger?: number | null;
        valueDecimal?: number | null;
        valueString?: string | null;
        valueCoding?: { code?: string | null; display?: string | null } | null;
      } | null> | null;
    } | null> | null;
    priorities?: {
      mode?: string | null;
      thresholds?: Array<{ code?: string | null; value?: number | null } | null> | null;
      points?: Array<{ code?: string | null; value?: number | null } | null> | null;
    } | null;
  };
};

export type GetCarePlanTemplateQuestionnaireQueryVariables = Exact<{
  carePlanTemplateId: Scalars['ID']['input'];
  questionnaireId: Scalars['ID']['input'];
}>;

export type GetCarePlanTemplateQuestionnaireQuery = {
  getCarePlanTemplateQuestionnaire: {
    id: string;
    version: string;
    name: string;
    status: QuestionnaireStatus;
    experimental: boolean;
    purpose?: string | null;
    title?: string | null;
    description?: string | null;
    patient?: string | null;
    carePlan?: string | null;
    publisher?: string | null;
    effectivePeriod?: { start?: any | null; end?: any | null } | null;
    item?: Array<{
      linkId: string;
      text: string;
      type: QuestionnaireItemType;
      answerOption?: Array<{
        valueInteger?: number | null;
        valueDecimal?: number | null;
        valueString?: string | null;
        valueCoding?: { code?: string | null; display?: string | null } | null;
      } | null> | null;
    } | null> | null;
    priorities?: {
      mode?: string | null;
      thresholds?: Array<{ code?: string | null; value?: number | null } | null> | null;
      points?: Array<{ code?: string | null; value?: number | null } | null> | null;
    } | null;
  };
};

export type GetReadyTaskCountQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  code?: InputMaybe<TaskCode>;
  onlyUpcomingVideoMeetings?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetReadyTaskCountQuery = {
  getReadyTaskCount: {
    routine: number;
    urgent: number;
    asap: number;
    stat: number;
    video: number;
    upcomingVideo: number;
  };
};

export type UnreadCommunicationsQueryVariables = Exact<{
  patientId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UnreadCommunicationsQuery = {
  unreadCommunications: Array<{
    id: string;
    sent?: any | null;
    patient?: {
      id: string;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null;
    } | null;
    payload?: Array<{ contentString?: string | null } | null> | null;
  }>;
};

export type UnreadCommunicationsCountQueryVariables = Exact<{
  patientId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UnreadCommunicationsCountQuery = { unreadCommunicationsCount: number };

export type BookedMeetingsForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  startAtMost: Scalars['dateTime']['input'];
  startAtLeast: Scalars['dateTime']['input'];
}>;

export type BookedMeetingsForPatientQuery = {
  bookedMeetingsForPatient?: Array<{
    id: string;
    status: string;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    videoMeeting?: {
      id: string;
      appointment: { description?: string | null; status: AppointmentStatus; start: any; end: any };
    } | null;
  } | null> | null;
};

export type BookedMeetingsForEveryoneQueryVariables = Exact<{
  startAtMost: Scalars['dateTime']['input'];
  startAtLeast: Scalars['dateTime']['input'];
}>;

export type BookedMeetingsForEveryoneQuery = {
  bookedMeetingsForEveryone?: Array<{
    id: string;
    status: string;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    patient?: { id: string; name?: Array<{ text?: string | null }> | null } | null;
    videoMeeting?: {
      id: string;
      appointment: { description?: string | null; status: AppointmentStatus; start: any; end: any };
    } | null;
  } | null> | null;
};

export type AllMeetingsForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  startAtMost: Scalars['dateTime']['input'];
  startAtLeast: Scalars['dateTime']['input'];
}>;

export type AllMeetingsForPatientQuery = {
  allMeetingsForPatient?: Array<{
    id: string;
    status: string;
    videoMeeting?: {
      id: string;
      appointment: { description?: string | null; status: AppointmentStatus; start: any; end: any };
    } | null;
  } | null> | null;
};

export type AllMeetingsForEveryoneQueryVariables = Exact<{
  startAtMost: Scalars['dateTime']['input'];
  startAtLeast: Scalars['dateTime']['input'];
}>;

export type AllMeetingsForEveryoneQuery = {
  allMeetingsForEveryone?: Array<{
    id: string;
    status: string;
    owner?: { display?: string | null; identifier?: { value?: string | null } | null } | null;
    patient?: { id: string; name?: Array<{ text?: string | null }> | null } | null;
    videoMeeting?: {
      id: string;
      appointment: { description?: string | null; status: AppointmentStatus; start: any; end: any };
    } | null;
  } | null> | null;
};

export type DialoggUsersListQueryVariables = Exact<{ [key: string]: never }>;

export type DialoggUsersListQuery = {
  dialoggUsers: Array<{
    username: string;
    firstName?: string | null;
    lastName?: string | null;
    enabled?: boolean | null;
    lastActive?: any | null;
    email?: string | null;
    externalUserIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
  }>;
};

export type DialoggUsersQueryVariables = Exact<{
  username?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DialoggUsersQuery = {
  dialoggUsers: Array<{
    username: string;
    firstName?: string | null;
    lastName?: string | null;
    enabled?: boolean | null;
    lastActive?: any | null;
    email?: string | null;
    picturePermission?: boolean | null;
    otpStatus?: string | null;
    ipRestrictions?: Array<string> | null;
    smsOtpStatus?: string | null;
    smsOtpPhoneNumber?: string | null;
    passwordStatus?: string | null;
    externalUserIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
    onBehalf?: { accessiblePatients?: Array<string> | null; otherPatientIds?: Array<string> | null } | null;
    timeLimitedAccess?: { start?: any | null; end?: any | null } | null;
    externalIdentities?: Array<{ provider: string }> | null;
  }>;
};

export type DialoggUsersDeleteQueryVariables = Exact<{
  username?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DialoggUsersDeleteQuery = {
  dialoggUsers: Array<{
    username: string;
    firstName?: string | null;
    lastName?: string | null;
    enabled?: boolean | null;
    lastActive?: any | null;
    email?: string | null;
    onBehalf?: { accessiblePatients?: Array<string> | null; otherPatientIds?: Array<string> | null } | null;
  }>;
};

export type DialoggUsersForCreateDialogQueryVariables = Exact<{
  username?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DialoggUsersForCreateDialogQuery = {
  dialoggUsers: Array<{
    username: string;
    firstName?: string | null;
    lastName?: string | null;
    enabled?: boolean | null;
    lastActive?: any | null;
    email?: string | null;
    externalIdentities?: Array<{ provider: string }> | null;
  }>;
};

export type DialoggUserCommonFieldsFragment = {
  username: string;
  firstName?: string | null;
  lastName?: string | null;
  enabled?: boolean | null;
  lastActive?: any | null;
  email?: string | null;
};

export type GetAllCarePlanTemplatesQueryVariables = Exact<{
  withStatus?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetAllCarePlanTemplatesQuery = {
  getAllCarePlanTemplates: Array<{
    id: string;
    title?: string | null;
    status: CarePlanStatus;
    carePlanType?: string | null;
  }>;
};

export type GetAllRpmGatewaysQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllRpmGatewaysQuery = {
  getAllRpmGateways: Array<{
    id: string;
    manufacturer?: string | null;
    serialNumber?: string | null;
    modelNumber?: string | null;
    gatewayHostname: string;
    deviceName?: Array<{ name?: string | null; type: string }> | null;
    note?: Array<{ text?: string | null }> | null;
    identifier?: Array<{ value?: string | null }> | null;
    gatewayStatus?: {
      connected?: boolean | null;
      lastSeen?: any | null;
      lastMeasurements?: Array<{ type?: string | null; time?: any | null }> | null;
      lastStatus?: {
        version?: string | null;
        ble_service_running?: number | null;
        cputemp?: number | null;
        uptime?: number | null;
      } | null;
    } | null;
    patient?: { reference?: string | null } | null;
    deviceGroup?: { id: string; name?: string | null } | null;
  }>;
};

export type GetAllRpmMedicalDevicesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllRpmMedicalDevicesQuery = {
  getAllRpmMedicalDevices: Array<{
    id: string;
    status?: string | null;
    manufacturer?: string | null;
    serialNumber?: string | null;
    modelNumber?: string | null;
    modelName?: string | null;
    btAddress?: string | null;
    sensorType?: string | null;
    isDeviceBtPaired?: boolean | null;
    batteryLevel?: number | null;
    deviceName?: Array<{ name?: string | null; type: string }> | null;
    patient?: { reference?: string | null } | null;
    parent?: { reference?: string | null } | null;
    parentDevice?: { gatewayHostname: string } | null;
    note?: Array<{ text?: string | null }> | null;
    identifier?: Array<{ value?: string | null }> | null;
    deviceGroup?: { name?: string | null; id: string } | null;
  }>;
};

export type GetListOfUnallocatedRpmGatewaysQueryVariables = Exact<{ [key: string]: never }>;

export type GetListOfUnallocatedRpmGatewaysQuery = {
  getListOfUnallocatedRpmGateways: Array<{
    id: string;
    gatewayHostname: string;
    modelNumber?: string | null;
    userFriendlyName?: string | null;
  }>;
};

export type GetListOfUnallocatedRpmMedicalDevicesQueryVariables = Exact<{ [key: string]: never }>;

export type GetListOfUnallocatedRpmMedicalDevicesQuery = {
  getListOfUnallocatedRpmMedicalDevices: Array<{
    id: string;
    status?: string | null;
    manufacturer?: string | null;
    serialNumber?: string | null;
    modelNumber?: string | null;
    modelName?: string | null;
    btAddress?: string | null;
    sensorType?: string | null;
    isDeviceBtPaired?: boolean | null;
    batteryLevel?: number | null;
    deviceName?: Array<{ name?: string | null; type: string }> | null;
    patient?: { reference?: string | null } | null;
    parent?: { reference?: string | null } | null;
    parentDevice?: { gatewayHostname: string } | null;
    note?: Array<{ text?: string | null }> | null;
    identifier?: Array<{ value?: string | null }> | null;
    deviceGroup?: { name?: string | null; id: string } | null;
  }>;
};

export type GetPatientNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetPatientNameQuery = {
  patient?: {
    id: string;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
  } | null;
};

export type GetRpmGatewayQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetRpmGatewayQuery = {
  getRpmGateway?: {
    id: string;
    manufacturer?: string | null;
    serialNumber?: string | null;
    modelNumber?: string | null;
    gatewayHostname: string;
    deviceName?: Array<{ name?: string | null; type: string }> | null;
    deviceGroup?: { id: string } | null;
    note?: Array<{ text?: string | null }> | null;
    identifier?: Array<{ value?: string | null }> | null;
    gatewayStatus?: { connected?: boolean | null; lastSeen?: any | null } | null;
    patient?: { reference?: string | null } | null;
    children?: Array<{
      id: string;
      sensorType?: string | null;
      modelName?: string | null;
      isDeviceBtPaired?: boolean | null;
      batteryLevel?: number | null;
    }> | null;
  } | null;
};

export type GetRpmMedicalDeviceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetRpmMedicalDeviceQuery = {
  getRpmMedicalDevice?: {
    id: string;
    status?: string | null;
    manufacturer?: string | null;
    serialNumber?: string | null;
    modelNumber?: string | null;
    modelName?: string | null;
    btAddress?: string | null;
    sensorType?: string | null;
    isDeviceBtPaired?: boolean | null;
    batteryLevel?: number | null;
    deviceName?: Array<{ name?: string | null; type: string }> | null;
    patient?: { reference?: string | null } | null;
    parent?: { reference?: string | null } | null;
    parentDevice?: { gatewayHostname: string } | null;
    note?: Array<{ text?: string | null }> | null;
    identifier?: Array<{ value?: string | null }> | null;
    deviceGroup?: { name?: string | null; id: string } | null;
  } | null;
};

export type GetTaskByIdQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type GetTaskByIdQuery = {
  getTaskById?: {
    id: string;
    status: string;
    priority?: string | null;
    authoredOn: any;
    description?: string | null;
    code?: { text?: string | null } | null;
    journalWorkflow?: Array<{ status: string }> | null;
    executionPeriod?: { start?: any | null; end?: any | null } | null;
    carePlan?: { id: string; title?: string | null } | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: { display?: string | null; reference?: string | null } | null;
    } | null> | null;
    subTasks?: Array<{
      id: string;
      authoredOn: any;
      intent?: string | null;
      priority?: string | null;
      status: string;
      code?: { text?: string | null } | null;
      partOf?: Array<{ reference?: string | null } | null> | null;
      note?: Array<{
        authorString?: string | null;
        time?: any | null;
        text?: string | null;
        authorReference?: { display?: string | null; reference?: string | null } | null;
      } | null> | null;
      focus?: { reference?: string | null } | null;
    } | null> | null;
    videoMeeting?: {
      id: string;
      appointment: { description?: string | null; status: AppointmentStatus; start: any };
      videonor?: { meetingId?: string | null } | null;
    } | null;
  } | null;
};

export type GetTaskByIdWithJournalRetryQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type GetTaskByIdWithJournalRetryQuery = {
  getTaskById?: {
    id: string;
    status: string;
    priority?: string | null;
    authoredOn: any;
    description?: string | null;
    canRetryJournaling?: boolean | null;
    isJournalNoteRequired?: boolean | null;
    code?: { text?: string | null } | null;
    journalWorkflow?: Array<{
      type: string;
      status: string;
      userGroupId?: string | null;
      retriedAt?: Array<any | null> | null;
      nextRetry?: any | null;
      completedAt?: any | null;
      freeTextNote?: string | null;
      completionOptions?: Array<string> | null;
      debugDetails?: string | null;
    }> | null;
    executionPeriod?: { start?: any | null; end?: any | null } | null;
    carePlan?: { id: string; title?: string | null } | null;
    note?: Array<{
      authorString?: string | null;
      time?: any | null;
      text?: string | null;
      authorReference?: { display?: string | null; reference?: string | null } | null;
    } | null> | null;
    subTasks?: Array<{
      id: string;
      authoredOn: any;
      intent?: string | null;
      priority?: string | null;
      status: string;
      code?: { text?: string | null } | null;
      partOf?: Array<{ reference?: string | null } | null> | null;
      note?: Array<{
        authorString?: string | null;
        time?: any | null;
        text?: string | null;
        authorReference?: { display?: string | null; reference?: string | null } | null;
      } | null> | null;
      focus?: { reference?: string | null } | null;
    } | null> | null;
    videoMeeting?: {
      id: string;
      appointment: { description?: string | null; status: AppointmentStatus; start: any };
      videonor?: { meetingId?: string | null } | null;
    } | null;
  } | null;
};

export type ParentRpmGatewayQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ParentRpmGatewayQuery = { parentRpmGateway?: { id: string; gatewayHostname: string } | null };

export type RpmGatewayAlertsQueryVariables = Exact<{ [key: string]: never }>;

export type RpmGatewayAlertsQuery = {
  rpmGatewayAlerts: Array<{ alert?: string | null; gateway?: { id: string; gatewayHostname: string } | null }>;
};

export type CreateSelfTreatmentPlanTemplateMutationVariables = Exact<{
  selfTreatmentPlanTemplateInput: SelfTreatmentPlanTemplateInput;
}>;

export type CreateSelfTreatmentPlanTemplateMutation = {
  createSelfTreatmentPlanTemplate: {
    success: boolean;
    message?: string | null;
    selfTreatmentPlan?: { id: string } | null;
  };
};

export type UpdateSelfTreatmentPlanTemplateMutationVariables = Exact<{
  selfTreatmentPlanTemplateUpdateInput: SelfTreatmentPlanTemplateUpdateInput;
  selfTreatmentPlanTemplateId: Scalars['ID']['input'];
}>;

export type UpdateSelfTreatmentPlanTemplateMutation = {
  updateSelfTreatmentPlanTemplate: {
    success: boolean;
    message?: string | null;
    selfTreatmentPlan?: { id: string } | null;
  };
};

export type PatientNamesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientNamesQuery = {
  patient?: { id: string; name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null } | null;
};

export type PatientNamesWithCarePlansQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientNamesWithCarePlansQuery = {
  patient?: {
    id: string;
    carePlans?: Array<{ id: string; title?: string | null; status: CarePlanStatus } | null> | null;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null;
  } | null;
};

export type SimulateCarePlanObservationResponseMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  activityId: Scalars['ID']['input'];
  observation: ObservationInput;
}>;

export type SimulateCarePlanObservationResponseMutation = {
  simulateCarePlanObservationResponse: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type SimulateCarePlanQuestionnaireResponseMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  questionnaireResponseInput: QuestionnaireResponseSimulatorInput;
}>;

export type SimulateCarePlanQuestionnaireResponseMutation = {
  simulateCarePlanQuestionnaireResponse: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateRpmMedicalDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput: RpmMedicalDeviceUpdateInput;
}>;

export type UpdateRpmMedicalDeviceMutation = { updateRpmMedicalDevice: { success: boolean; message?: string | null } };

export type AddExternalDialoggUserIdMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  externalUserId: ExternalHumanIdInput;
}>;

export type AddExternalDialoggUserIdMutation = { addExternalDialoggUserId: { success: boolean } };

export type ChangePicturePermissionMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;

export type ChangePicturePermissionMutation = { changePicturePermission: { success: boolean } };

export type RemovePatientFromDialoggUserMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
}>;

export type RemovePatientFromDialoggUserMutation = {
  removePatientFromDialoggUser: { success: boolean; dialoggUser?: { username: string } | null };
};

export type SetOfPatientsQueryVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;

export type SetOfPatientsQuery = {
  setOfPatients: Array<{
    id: string;
    identifier: Array<{ use?: IdentifierUse | null; value?: string | null } | null>;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null;
  } | null>;
};

export type CreateDialoggUserMutationVariables = Exact<{
  dialoggUser: CreateDialoggUserInput;
}>;

export type CreateDialoggUserMutation = { createDialoggUser: { success: boolean; message?: string | null } };

export type UpdateDialoggUserMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  dialoggUser: UpdateDialoggUser;
}>;

export type UpdateDialoggUserMutation = { updateDialoggUser: { success: boolean; message?: string | null } };

export type ForceDeleteDialoggUserMutationVariables = Exact<{
  username: Scalars['ID']['input'];
}>;

export type ForceDeleteDialoggUserMutation = { forceDeleteDialoggUser: { success: boolean; message?: string | null } };

export type DeleteDialoggUserMutationVariables = Exact<{
  username: Scalars['ID']['input'];
}>;

export type DeleteDialoggUserMutation = { deleteDialoggUser: { success: boolean; message?: string | null } };

export type UpdateDialoggUserPasswordMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  password: Scalars['String']['input'];
}>;

export type UpdateDialoggUserPasswordMutation = {
  updateDialoggUserPassword: { success: boolean; message?: string | null };
};

export type RemoveDialoggUserPasswordMutationVariables = Exact<{
  username: Scalars['ID']['input'];
}>;

export type RemoveDialoggUserPasswordMutation = {
  removeDialoggUserPassword: { success: boolean; message?: string | null };
};

export type AssignPatientToDialoggUserMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
}>;

export type AssignPatientToDialoggUserMutation = {
  assignPatientToDialoggUser: { success: boolean; message?: string | null };
};

export type ActivateDialoggUserSmsOtpMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
}>;

export type ActivateDialoggUserSmsOtpMutation = { activateDialoggUserSmsOtp: boolean };

export type DeactivateDialoggUserSmsOtpMutationVariables = Exact<{
  username: Scalars['ID']['input'];
}>;

export type DeactivateDialoggUserSmsOtpMutation = { deactivateDialoggUserSmsOtp: boolean };

export type ActivateDialoggUserOtpMutationVariables = Exact<{
  username: Scalars['ID']['input'];
}>;

export type ActivateDialoggUserOtpMutation = { activateDialoggUserOtp: boolean };

export type DeleteDialoggUserOtpMutationVariables = Exact<{
  username: Scalars['ID']['input'];
}>;

export type DeleteDialoggUserOtpMutation = { deleteDialoggUserOtp: boolean };

export type CancelDialoggUserOtpMutationVariables = Exact<{
  username: Scalars['ID']['input'];
}>;

export type CancelDialoggUserOtpMutation = { cancelDialoggUserOtp: boolean };

export type UpdateDialoggUserIpRestrictionsMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  ipRestrictions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type UpdateDialoggUserIpRestrictionsMutation = { updateDialoggUserIPRestrictions: { success: boolean } };

export type UpdateDialggUserTimeLimitedAccessMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  timeLimitedAccess?: InputMaybe<PeriodInput>;
}>;

export type UpdateDialggUserTimeLimitedAccessMutation = {
  updateDialoggUserTimeLimitedAccess: { success: boolean; inputValidation?: { message?: string | null } | null };
};

export type SetDialoggUserExternalIdPMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  identities?: InputMaybe<Array<InputMaybe<ExternalIdentityInput>> | InputMaybe<ExternalIdentityInput>>;
}>;

export type SetDialoggUserExternalIdPMutation = { setDialoggUserExternalIdP: boolean };

export type UpdateObservationStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
}>;

export type UpdateObservationStatusMutation = { updateObservationStatus?: { success: boolean } | null };

export type RemovePatientFromDialoggUserInPatientMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
}>;

export type RemovePatientFromDialoggUserInPatientMutation = {
  removePatientFromDialoggUser: {
    success: boolean;
    dialoggUser?: {
      username: string;
      onBehalf?: { accessiblePatients?: Array<string> | null; otherPatientIds?: Array<string> | null } | null;
    } | null;
  };
};

export type DialoggUsersWithAccessToPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type DialoggUsersWithAccessToPatientQuery = {
  dialoggUsersWithAccessToPatient: Array<{
    username: string;
    firstName?: string | null;
    lastName?: string | null;
    lastActive?: any | null;
    role?: string | null;
  }>;
};

export type GetPatientSelfTreatmentPlansQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetPatientSelfTreatmentPlansQuery = {
  getPatientSelfTreatmentPlans?: {
    id: string;
    status: CarePlanStatus;
    lastUpdated?: string | null;
    subject: { display?: string | null };
    goals: Array<{ id: string; goal?: string | null }>;
    medicalStates?: {
      green: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
      yellow: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
      red: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
    } | null;
  } | null;
};

export type CreatePatientGoalsMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  goalInput: GoalInput;
}>;

export type CreatePatientGoalsMutation = {
  createPatientGoals: { success: boolean; message?: string | null; selfTreatmentPlan?: { id: string } | null };
};

export type CreatePatientMedicalStatesMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  medicalStateInput: MedicalStatesInput;
}>;

export type CreatePatientMedicalStatesMutation = {
  createPatientMedicalStates: { success: boolean; message?: string | null; selfTreatmentPlan?: { id: string } | null };
};

export type ActivateSelfTreatmentPlanMutationVariables = Exact<{
  selfTreatmentPlanId: Scalars['ID']['input'];
}>;

export type ActivateSelfTreatmentPlanMutation = {
  activateSelfTreatmentPlan: { success: boolean; message?: string | null };
};

export type DeactivateSelfTreatmentPlanMutationVariables = Exact<{
  selfTreatmentPlanId: Scalars['ID']['input'];
}>;

export type DeactivateSelfTreatmentPlanMutation = {
  deactivateSelfTreatmentPlan: { success: boolean; message?: string | null };
};

export type UpdatePatientGoalsMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  goalInput: UpdateGoalInput;
}>;

export type UpdatePatientGoalsMutation = { updatePatientGoals: { success: boolean; message?: string | null } };

export type UpdatePatientMedicalStatesMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  medicalStateInput: MedicalStatesInput;
}>;

export type UpdatePatientMedicalStatesMutation = {
  updatePatientMedicalStates: { success: boolean; message?: string | null };
};

export type GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery = {
  getAllQuestionnaireTemplates: Array<{
    id: string;
    title?: string | null;
    version: string;
    status: QuestionnaireStatus;
  }>;
};

export type QuestionnaireTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type QuestionnaireTemplatesQuery = {
  getAllQuestionnaireTemplates: Array<{
    id: string;
    title?: string | null;
    purpose?: string | null;
    experimental: boolean;
    version: string;
    status: QuestionnaireStatus;
    effectivePeriod?: { start?: any | null; end?: any | null } | null;
  }>;
};

export type PatientWithJournalConfigQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type PatientWithJournalConfigQuery = {
  patient?: {
    id: string;
    name?: Array<{ text?: string | null }> | null;
    journalConfigForPatient?: {
      remotePatientMonitoring: { enabled: boolean; taskCodesForJournaling: Array<string> };
    } | null;
  } | null;
};

export type PlanVideoMeetingMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  createInput: VideoMeetingInput;
}>;

export type PlanVideoMeetingMutation = {
  planVideoMeeting?: {
    success: boolean;
    calendarInvitation?: string | null;
    videoMeeting?: { id: string } | null;
  } | null;
};

export type PatientRequestQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type PatientRequestQuery = {
  patientRequest?: {
    id: string;
    status: string;
    priority?: string | null;
    description?: string | null;
    authoredOn: any;
    note?: Array<{
      time?: any | null;
      text?: string | null;
      authorString?: string | null;
      authorReference?: { display?: string | null; reference?: string | null } | null;
    } | null> | null;
  } | null;
};

export type RescheduleVideoMeetingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  start: Scalars['dateTime']['input'];
  end: Scalars['dateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;

export type RescheduleVideoMeetingMutation = {
  rescheduleVideoMeeting?: { success: boolean; calendarInvitation?: string | null } | null;
};

export type GetRescheduleVideoMeetingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetRescheduleVideoMeetingQuery = {
  videoMeeting?: {
    appointment: {
      status: AppointmentStatus;
      start: any;
      description?: string | null;
      patient?: { id: string; name?: Array<{ text?: string | null }> | null } | null;
    };
  } | null;
};

export type StartJoinVideoMeetingMutationVariables = Exact<{
  videoMeetingId: Scalars['ID']['input'];
  videoMeetingURL?: InputMaybe<Scalars['String']['input']>;
}>;

export type StartJoinVideoMeetingMutation = {
  startJoinVideoMeeting?: { success: boolean; message?: string | null } | null;
};

export type StartVideoMeetingMutationVariables = Exact<{
  videoMeetingId: Scalars['ID']['input'];
}>;

export type StartVideoMeetingMutation = { startVideoMeeting?: { success: boolean; message?: string | null } | null };

export type EndJoinVideoMeetingMutationVariables = Exact<{
  videoMeetingId: Scalars['ID']['input'];
}>;

export type EndJoinVideoMeetingMutation = { endVideoMeeting?: { success: boolean; message?: string | null } | null };

export type EndVideoMeetingMutationVariables = Exact<{
  videoMeetingId: Scalars['ID']['input'];
}>;

export type EndVideoMeetingMutation = { endVideoMeeting?: { success: boolean; message?: string | null } | null };

export type CancelVideoMeetingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CancelVideoMeetingMutation = { cancelVideoMeeting?: { success: boolean; message?: string | null } | null };

export type VideoMeetingQueryVariables = Exact<{
  videoMeetingId: Scalars['ID']['input'];
}>;

export type VideoMeetingQuery = {
  videoMeeting?: {
    appointment: {
      status: AppointmentStatus;
      start: any;
      description?: string | null;
      participant?: Array<{
        actor?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: { value?: string | null } | null;
        } | null;
      } | null> | null;
      patient?: { id: string; name?: Array<{ text?: string | null }> | null } | null;
    };
    videonor?: {
      meetingId?: string | null;
      participantRoomUrl?: string | null;
      hostRoomUrl?: string | null;
      startDate?: any | null;
      endDate?: any | null;
    } | null;
  } | null;
};

export type SetExternalIdRequestMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  externalHumanIdType: Scalars['String']['input'];
  requested: Scalars['Boolean']['input'];
}>;

export type SetExternalIdRequestMutation = { setExternalIdRequest: boolean };

export type RemoveExternalDialoggUserIdMutationVariables = Exact<{
  username: Scalars['ID']['input'];
  externalUserId: ExternalHumanIdInput;
}>;

export type RemoveExternalDialoggUserIdMutation = { removeExternalDialoggUserId: { success: boolean } };

export type RemoveExternalUserIdMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  externalUserId: ExternalHumanIdInput;
}>;

export type RemoveExternalUserIdMutation = { removeExternalUserId: { success: boolean } };

export type RemoveExternalPatientIdFromPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  externalPatientId: ExternalHumanIdInput;
}>;

export type RemoveExternalPatientIdFromPatientMutation = { removeExternalPatientIdFromPatient: { success: boolean } };

export type AddExternalUserIdMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  externalUserId: ExternalHumanIdInput;
}>;

export type AddExternalUserIdMutation = { addExternalUserId: { success: boolean } };

export type AddExternalPatientIdToPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  externalPatientId: ExternalHumanIdInput;
}>;

export type AddExternalPatientIdToPatientMutation = { addExternalPatientIdToPatient: { success: boolean } };

export type DeletePatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type DeletePatientMutation = {
  deletePatient?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type GetGeofencesForSafemateDeviceQueryVariables = Exact<{
  serialNumber: Scalars['String']['input'];
}>;

export type GetGeofencesForSafemateDeviceQuery = {
  getGeofencesForSafemateDevice?: Array<{
    name?: string | null;
    polygon?: boolean | null;
    radius?: number | null;
    vertices?: Array<{ lat?: number | null; lng?: number | null } | null> | null;
  }> | null;
};

export type HealthProviderSettingsForPatientFormQueryVariables = Exact<{ [key: string]: never }>;

export type HealthProviderSettingsForPatientFormQuery = {
  healthProviderSettings: { externalHumanIdTypes?: Array<{ id: string }> | null };
};

export type RemoveUserReservationMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;

export type RemoveUserReservationMutation = { removeUserReservation?: boolean | null };

export type AddUserReservationMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;

export type AddUserReservationMutation = { addUserReservation?: boolean | null };

export type PatientWithUserReservationsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientWithUserReservationsQuery = {
  patient?: {
    id: string;
    userReservations?: Array<{ userId: string; firstName?: string | null; lastName?: string | null } | null> | null;
  } | null;
};

export type SubmitAlarmHandlingFeedbackMutationVariables = Exact<{
  alarmHandlingFeedback: AlarmHandlingFeedbackInput;
}>;

export type SubmitAlarmHandlingFeedbackMutation = { submitAlarmHandlingFeedback: boolean };

export type RoleTypesForAuditEventAgentQueryVariables = Exact<{ [key: string]: never }>;

export type RoleTypesForAuditEventAgentQuery = {
  roleTypes: Array<{ id: string; display: Array<{ key: string; value: string } | null> }>;
};

export type DeleteAlarmRouteMutationVariables = Exact<{
  routeId: Scalars['ID']['input'];
}>;

export type DeleteAlarmRouteMutation = { deleteAlarmRoute?: boolean | null };

export type DeleteUserGroupMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type DeleteUserGroupMutation = { deleteUserGroup: { success?: boolean | null; message?: string | null } };

export type UpdateUserGroupMutationVariables = Exact<{
  userGroup: UpdateUserGroupInput;
  userGroupId: Scalars['ID']['input'];
}>;

export type UpdateUserGroupMutation = { updateUserGroup: { success?: boolean | null; message?: string | null } };

export type CreateUserGroupMutationVariables = Exact<{
  newUserGroup: CreateUserGroupInput;
  parentUserGroupId: Scalars['ID']['input'];
}>;

export type CreateUserGroupMutation = {
  createUserGroup: { success?: boolean | null; message?: string | null; userGroup?: { id: string } | null };
};

export type GetDevicesByGroupQueryVariables = Exact<{
  deviceGroupId: Scalars['ID']['input'];
}>;

export type GetDevicesByGroupQuery = {
  getDevicesByGroup: Array<{
    id: string;
    modelNumber?: string | null;
    manufacturer?: string | null;
    patientId?: string | null;
    registeredInInventory?: boolean | null;
    childDeviceIds?: Array<string> | null;
    deviceName?: Array<{ name?: string | null; type: string }> | null;
  }>;
};

export type PatientGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientGroupQuery = {
  patientGroup?: {
    id: string;
    name?: string | null;
    patientsCount?: number | null;
    enableDistanceEstimation?: boolean | null;
    enableOnSiteRegistration?: boolean | null;
    hideTechnicalAlarmNotifications?: boolean | null;
    alarmRoutes: Array<{
      routeId: string;
      configId: string;
      configType: string;
      configName: string;
      idMappingStrategy: string;
      createPatientAlarmOnFail: boolean;
      incomingTemplate: {
        isPresentInAccount?: boolean | null;
        code: string;
        title: string;
        system: string;
        displayText?: string | null;
        icon?: string | null;
        technical: boolean;
      };
      outgoingTemplate: {
        isPresentInAccount?: boolean | null;
        code: string;
        title: string;
        system: string;
        displayText?: string | null;
        icon?: string | null;
        technical: boolean;
      };
    }>;
    availableAlarmRoutingOptions: {
      configs: Array<{ configId: string; configType: string; configName: string }>;
      templates: Array<{
        code: string;
        title: string;
        system: string;
        displayText?: string | null;
        icon?: string | null;
        direction: string;
        technical: boolean;
      }>;
      idMappingStrategies: Array<{ id: string }>;
    };
  } | null;
};

export type UserGroupTypeQueryVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type UserGroupTypeQuery = { userGroup: { id: string; type: string } };

export type CreateAlarmRouteMutationVariables = Exact<{
  inputs: AlarmRouteInput;
}>;

export type CreateAlarmRouteMutation = { createAlarmRoute?: { routeId: string } | null };

export type UpdateAlarmRouteMutationVariables = Exact<{
  routeId: Scalars['ID']['input'];
  patientGroupId: Scalars['ID']['input'];
  updateInput: UpdateAlarmRouteInput;
}>;

export type UpdateAlarmRouteMutation = { updateAlarmRoute?: { success: boolean } | null };

export type PatientGroupForAlarmForwardingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientGroupForAlarmForwardingQuery = {
  patientGroup?: {
    id: string;
    name?: string | null;
    alarmRoutes: Array<{
      configName: string;
      idMappingStrategy: string;
      createPatientAlarmOnFail: boolean;
      incomingTemplate: {
        isPresentInAccount?: boolean | null;
        code: string;
        title: string;
        system: string;
        icon?: string | null;
      };
      outgoingTemplate: {
        isPresentInAccount?: boolean | null;
        code: string;
        title: string;
        system: string;
        icon?: string | null;
      };
    }>;
  } | null;
};

export type GetSkyresponseSyncJobsCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetSkyresponseSyncJobsCountQuery = { getSkyresponseSyncJobsCount: number };

export type SyncPatientInfoWithSkyresponseForSyncModalMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  syncScenario?: InputMaybe<Scalars['String']['input']>;
}>;

export type SyncPatientInfoWithSkyresponseForSyncModalMutation = {
  syncPatientInfoWithSkyresponse: {
    success?: boolean | null;
    message?: string | null;
    total?: number | null;
    take?: number | null;
    skip?: number | null;
    next?: { skip?: number | null; take?: number | null } | null;
  };
};

export type UserGroupPatientAccessListQueryVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type UserGroupPatientAccessListQuery = {
  userGroupPatientAccessList?: Array<{
    id: string;
    username?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    roles: Array<{ id: string; userGroupName: string; display: Array<{ key: string; value: string }> }>;
  } | null> | null;
};

export type RoleTypesQueryVariables = Exact<{ [key: string]: never }>;

export type RoleTypesQuery = {
  roleTypes: Array<{ id: string; basedOn_fk: string; display: Array<{ key: string; value: string } | null> }>;
};

export type GetAlarmHandlingRulesForUserGroupQueryVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type GetAlarmHandlingRulesForUserGroupQuery = {
  getAlarmHandlingRulesForUserGroup?: Array<{ id: number; name: string }> | null;
};

export type CreatePatientGroupMutationVariables = Exact<{
  createInput: PatientGroupInput;
  userGroupId: Scalars['ID']['input'];
}>;

export type CreatePatientGroupMutation = { createPatientGroup?: { success: boolean; message?: string | null } | null };

export type UpdatePatientGroupMutationVariables = Exact<{
  patientGroupId: Scalars['ID']['input'];
  patientGroup: PatientGroupInput;
}>;

export type UpdatePatientGroupMutation = { updatePatientGroup?: { success: boolean; message?: string | null } | null };

export type SetDistanceEstimationToPatientGroupMutationVariables = Exact<{
  patientGroupId: Scalars['ID']['input'];
  enableDistanceEstimation: Scalars['Boolean']['input'];
}>;

export type SetDistanceEstimationToPatientGroupMutation = {
  setDistanceEstimationToPatientGroup?: { success: boolean; message?: string | null } | null;
};

export type HideTechnicalAlarmNotificationsForPatientGroupMutationVariables = Exact<{
  patientGroupId: Scalars['ID']['input'];
  hideTechnicalAlarmNotifications: Scalars['Boolean']['input'];
}>;

export type HideTechnicalAlarmNotificationsForPatientGroupMutation = {
  hideTechnicalAlarmNotificationsForPatientGroup?: { success: boolean; message?: string | null } | null;
};

export type SetOnSiteRegistrationToPatientGroupMutationVariables = Exact<{
  patientGroupId: Scalars['ID']['input'];
  enableOnSiteRegistration: Scalars['Boolean']['input'];
}>;

export type SetOnSiteRegistrationToPatientGroupMutation = {
  setOnSiteRegistrationToPatientGroup?: { success: boolean; message?: string | null } | null;
};

export type RemovePatientGroupFromUserGroupMutationVariables = Exact<{
  patientGroupId: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
}>;

export type RemovePatientGroupFromUserGroupMutation = {
  removePatientGroupFromUserGroup?: { success: boolean; message?: string | null } | null;
};

export type CreateDeviceGroupMutationVariables = Exact<{
  createInput: DeviceGroupCreateInput;
  userGroupId: Scalars['ID']['input'];
}>;

export type CreateDeviceGroupMutation = { createDeviceGroup: { success: boolean; message?: string | null } };

export type UpdateDeviceGroupMutationVariables = Exact<{
  deviceGroupId: Scalars['ID']['input'];
  deviceGroup: DeviceGroupUpdateInput;
}>;

export type UpdateDeviceGroupMutation = { updateDeviceGroup: { success: boolean; message?: string | null } };

export type DeleteDeviceGroupMutationVariables = Exact<{
  deviceGroupId: Scalars['ID']['input'];
}>;

export type DeleteDeviceGroupMutation = { deleteDeviceGroup: { success: boolean; message?: string | null } };

export type CreateRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
}>;

export type CreateRoleMutation = { createRole: { success?: boolean | null; message?: string | null } };

export type DeleteRoleMutationVariables = Exact<{
  roleId: Scalars['ID']['input'];
}>;

export type DeleteRoleMutation = { deleteRole: { success: boolean; message?: string | null } };

export type UpdateSkyresponseConfigMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  skyresponseConfig: SkyresponseConfigInput;
}>;

export type UpdateSkyresponseConfigMutation = {
  updateSkyresponseConfig: { success: boolean; message?: string | null };
};

export type UpdateEscalationDelayMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  escalationDelay: Scalars['Int']['input'];
}>;

export type UpdateEscalationDelayMutation = { updateEscalationDelay: { success: boolean; message?: string | null } };

export type DeleteEscalationDelayMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type DeleteEscalationDelayMutation = { deleteEscalationDelay: { success: boolean; message?: string | null } };

export type UpdateCareTeamMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  careTeam: UpdateCareTeamInput;
}>;

export type UpdateCareTeamMutation = { updateCareTeam: { success: boolean; message?: string | null } };

export type AddCareTeamMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  careTeam: CreateCareTeamInput;
}>;

export type AddCareTeamMutation = { addCareTeam: { success: boolean; message?: string | null } };

export type RemoveCareTeamMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  careTeamId: Scalars['ID']['input'];
}>;

export type RemoveCareTeamMutation = { removeCareTeam: { success: boolean; message?: string | null } };

export type CreateHelseIdAccountMutationVariables = Exact<{
  input: HelseIdAccountCreateInput;
}>;

export type CreateHelseIdAccountMutation = {
  createHelseIdAccount: { success: boolean; message?: string | null; helseIdAccount?: { id: string } | null };
};

export type UpdateHelseIdAccountMutationVariables = Exact<{
  helseIdAccountId: Scalars['ID']['input'];
  input: HelseIdAccountUpdateInput;
}>;

export type UpdateHelseIdAccountMutation = { updateHelseIdAccount: { success: boolean; message?: string | null } };

export type CreateVkpAccountMutationVariables = Exact<{
  input: VkpAccountInput;
}>;

export type CreateVkpAccountMutation = { createVkpAccount: { success: boolean; message?: string | null } };

export type UpdateVkpAccountMutationVariables = Exact<{
  vkpAccountId: Scalars['ID']['input'];
  input: VkpAccountInput;
}>;

export type UpdateVkpAccountMutation = { updateVkpAccount: { success: boolean; message?: string | null } };

export type DeleteVkpAccountMutationVariables = Exact<{
  vkpAccountId: Scalars['ID']['input'];
}>;

export type DeleteVkpAccountMutation = { deleteVkpAccount: { success: boolean; message?: string | null } };

export type DeleteHelseIdAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteHelseIdAccountMutation = { deleteHelseIdAccount: { success: boolean; message?: string | null } };

export type TestHelseIdCredentialsMutationVariables = Exact<{
  helseIdAccountId: Scalars['ID']['input'];
}>;

export type TestHelseIdCredentialsMutation = { testHelseIdCredentials: boolean };

export type HelseIdAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type HelseIdAccountsQuery = {
  helseIdAccounts?: Array<{
    id: string;
    accountDisplayName: string;
    organizationNumber: string;
    credentials?: {
      authority: string;
      clientId: string;
      grantTypes: Array<string>;
      maskedPrivateJwk: string;
      rsaKeyExpiryDate: any;
      rsaKeySizeBits: number;
      maskedRsaPrivateKey: string;
      scopes: Array<string>;
      secretType: string;
    } | null;
  }> | null;
};

export type VkpAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type VkpAccountsQuery = {
  vkpAccounts?: Array<{
    id: string;
    accountDisplayName: string;
    helseIdAccountId: string;
    helseIdAccount?: { credentials?: { scopes: Array<string> } | null } | null;
  }> | null;
};

export type CreateJournalConfigForUserGroupMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  input: JournalConfigForUserGroupInput;
}>;

export type CreateJournalConfigForUserGroupMutation = {
  createJournalConfigForUserGroup: { success: boolean; message?: string | null };
};

export type UpdateJournalConfigForUserGroupMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  input: JournalConfigForUserGroupInput;
}>;

export type UpdateJournalConfigForUserGroupMutation = {
  updateJournalConfigForUserGroup: { success: boolean; message?: string | null };
};

export type UpdateInheritedJournalConfigForUserGroupMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  input: InheritedJournalConfigForUserGroupInput;
}>;

export type UpdateInheritedJournalConfigForUserGroupMutation = {
  updateInheritedJournalConfigForUserGroup: { success: boolean; message?: string | null };
};

export type DeleteJournalConfigForUserGroupMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type DeleteJournalConfigForUserGroupMutation = {
  deleteJournalConfigForUserGroup: { success: boolean; message?: string | null };
};

export type GetJournalConfigForUserGroupQueryVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type GetJournalConfigForUserGroupQuery = {
  getJournalConfigForUserGroup?: {
    vkpAccountId: string;
    forUserGroupId: string;
    monitoringEmailAddresses: Array<string>;
    inheritedFromUserGroup?: string | null;
    remotePatientMonitoring: {
      enabled: boolean;
      apiUrl?: string | null;
      journalingDisabledForPatientGroupIds: Array<string>;
      isLabModuleEnabled?: boolean | null;
      taskCodesForJournaling?: Array<string> | null;
    };
    remoteSupervision: {
      enabled: boolean;
      apiUrl?: string | null;
      journalingDisabledForPatientGroupIds: Array<string>;
    };
    read: {
      enabled: boolean;
      apiUrl?: string | null;
      features?: {
        hasCreatePatientFromVkp: boolean;
        responseCenter: { hasCarePlanRead: boolean; hasEpisodesOfCareRead: boolean; hasPatientRead: boolean };
      } | null;
    };
  } | null;
};

export type GetSupportedLanguagesQueryVariables = Exact<{ [key: string]: never }>;

export type GetSupportedLanguagesQuery = { getSupportedLanguages?: Array<{ code: string }> | null };

export type GetPatientFromVkpQueryVariables = Exact<{
  norwegianId: Scalars['String']['input'];
}>;

export type GetPatientFromVkpQuery = {
  getPatientFromVkp: {
    success: boolean;
    patient?: {
      birthDate?: any | null;
      gender?: AdministrativeGender | null;
      hasSecretAddress?: boolean | null;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
      telecom?: Array<{
        value?: string | null;
        system?: ContactPointSystem | null;
        use?: ContactPointUse | null;
      }> | null;
      address?: Array<{
        use?: AddressUse | null;
        line?: Array<string | null> | null;
        city?: string | null;
        postalCode?: string | null;
        country?: string | null;
        text?: string | null;
      }> | null;
      externalPatientIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
    } | null;
  };
};

export type UpdateIpRestrictionsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  ipRestrictions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type UpdateIpRestrictionsMutation = { updateIPRestrictions?: { success: boolean } | null };

export type GetOpenPatientAlarmsForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetOpenPatientAlarmsForPatientQuery = {
  getOpenPatientAlarmsForPatient: Array<{
    id: string;
    status: string;
    priority?: string | null;
    for: { reference?: string | null };
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
  }>;
};

export type SubmitSupervisionFeebackMutationVariables = Exact<{
  feedback: CameraSupervisionFeedback;
}>;

export type SubmitSupervisionFeebackMutation = { submitSupervisionFeeback: FeedbackSeverity };

export type GetCameraQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type GetCameraQuery = {
  getCamera: {
    id: string;
    name: string;
    macAddress: string;
    description?: string | null;
    presets: Array<string | null>;
    anonymization?: { supports?: boolean | null; requirement?: boolean | null; status?: boolean | null } | null;
  };
};

export type LoadQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type LoadQuery = {
  camera: {
    view?: {
      pan?: number | null;
      minPan?: number | null;
      maxPan?: number | null;
      tilt?: number | null;
      minTilt?: number | null;
      maxTilt?: number | null;
      zoom?: number | null;
      minZoom?: number | null;
      maxZoom?: number | null;
    } | null;
  };
};

export type SetCameraViewWithPresetMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  preset: Scalars['String']['input'];
}>;

export type SetCameraViewWithPresetMutation = { setCameraViewWithPreset: boolean };

export type SetCameraViewWithAnglesMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  pan: Scalars['Float']['input'];
  tilt: Scalars['Float']['input'];
  zoom: Scalars['Float']['input'];
}>;

export type SetCameraViewWithAnglesMutation = { setCameraViewWithAngles: boolean };

export type CreateCameraViewPresetMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;

export type CreateCameraViewPresetMutation = { createCameraViewPreset: boolean };

export type DeleteCameraViewPresetMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  preset: Scalars['String']['input'];
}>;

export type DeleteCameraViewPresetMutation = { deleteCameraViewPreset: boolean };

export type SwitchAnonymizationMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type SwitchAnonymizationMutation = { switchAnonymization: boolean };

export type StartStreamMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type StartStreamMutation = { stream: { id: string; url: string; type?: string | null; ttl?: number | null } };

export type KeepStreamAliveMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
}>;

export type KeepStreamAliveMutation = {
  stream: { id: string; url: string; type?: string | null; expires?: any | null; ttl?: number | null };
};

export type StopStreamMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  streamId: Scalars['ID']['input'];
}>;

export type StopStreamMutation = { stream: boolean };

export type PatientReferenceQueryQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type PatientReferenceQueryQuery = {
  patientReferenceQuery: { patientReference?: { reference?: string | null } | null };
};

export type PatientWelfareDevicesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientWelfareDevicesQuery = {
  patientWelfareDevices?: {
    welfareDevices?: Array<{
      id: string;
      uniqueIdentifier: string;
      modelNumber?: string | null;
      deviceName?: Array<{ name?: string | null }> | null;
    }> | null;
  } | null;
};

export type AddCameraToSetupBatchTelluSupportMutationVariables = Exact<{
  cameraSetupInput: CameraSetupInput;
}>;

export type AddCameraToSetupBatchTelluSupportMutation = { addCameraToSetupBatchTelluSupport: boolean };

export type RedoCameraSetupTelluSupportMutationVariables = Exact<{
  serial: Scalars['String']['input'];
}>;

export type RedoCameraSetupTelluSupportMutation = { redoCameraSetupTelluSupport: boolean };

export type ResetCameraSetupTelluSupportMutationVariables = Exact<{
  serial: Scalars['String']['input'];
}>;

export type ResetCameraSetupTelluSupportMutation = { resetCameraSetupTelluSupport: boolean };

export type ResetCameraSetupBatchTelluSupportMutationVariables = Exact<{ [key: string]: never }>;

export type ResetCameraSetupBatchTelluSupportMutation = { resetCameraSetupBatchTelluSupport: boolean };

export type ResetMorpheanCacheTelluSupportMutationVariables = Exact<{ [key: string]: never }>;

export type ResetMorpheanCacheTelluSupportMutation = { resetMorpheanCacheTelluSupport: boolean };

export type CameraAppBulkUpdateMutationVariables = Exact<{
  cameras: Array<CameraManagementInput> | CameraManagementInput;
  appUpdates: Array<CameraAppUpdateInput> | CameraAppUpdateInput;
}>;

export type CameraAppBulkUpdateMutation = { cameraAppBulkUpdate: boolean };

export type CameraFirmwareBulkUpgradeMutationVariables = Exact<{
  cameras: Array<CameraManagementInput> | CameraManagementInput;
  firmwareUpgradeOptions: CameraFirmwareUpgradeInput;
}>;

export type CameraFirmwareBulkUpgradeMutation = { cameraFirmwareBulkUpgrade: boolean };

export type DecommissionCamerasMutationVariables = Exact<{
  cameras: Array<CameraManagementInputWithOptionalId> | CameraManagementInputWithOptionalId;
}>;

export type DecommissionCamerasMutation = { decommissionCameras: boolean };

export type DecommissionCamerasLimitedMutationVariables = Exact<{
  cameras: Array<CameraManagementInputWithOptionalId> | CameraManagementInputWithOptionalId;
}>;

export type DecommissionCamerasLimitedMutation = { decommissionCamerasLimited: boolean };

export type CameraNetworkingBulkUpdateMutationVariables = Exact<{
  cameras: Array<CameraManagementInput> | CameraManagementInput;
}>;

export type CameraNetworkingBulkUpdateMutation = { cameraNetworkingBulkUpdate: boolean };

export type TerminateShiftSessionOnDeviceMutationVariables = Exact<{
  device: Scalars['String']['input'];
}>;

export type TerminateShiftSessionOnDeviceMutation = {
  terminateShiftSessionOnDevice?: { createdAt: any; lastUpdated: any } | null;
};

export type TerminateShiftSessionOnAllDevicesMutationVariables = Exact<{ [key: string]: never }>;

export type TerminateShiftSessionOnAllDevicesMutation = { terminateShiftSessionOnAllDevices?: boolean | null };

export type TakeCallMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  takeCallInput?: InputMaybe<TakeCallInput>;
}>;

export type TakeCallMutation = {
  takeCall: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type AddNotesToTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  note: Array<InputMaybe<AnnotationInput>> | InputMaybe<AnnotationInput>;
}>;

export type AddNotesToTaskMutation = {
  addNotesToTask?: {
    success: boolean;
    message?: string | null;
    inputValidation?: { message?: string | null } | null;
  } | null;
};

export type AddWelfareDeviceToPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  welfareDeviceId: Scalars['ID']['input'];
}>;

export type AddWelfareDeviceToPatientMutation = { addWelfareDeviceToPatient: { success: boolean } };

export type CreateWelfareDeviceMutationVariables = Exact<{
  createInput: WelfareDeviceCreateInput;
}>;

export type CreateWelfareDeviceMutation = {
  createWelfareDevice: {
    success: boolean;
    message?: string | null;
    welfareDevice?: { id: string; uniqueIdentifier: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type DeleteWelfareDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteWelfareDeviceMutation = {
  deleteWelfareDevice: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type LogLocalExportMutationVariables = Exact<{
  resourceType: Scalars['String']['input'];
  count: Scalars['Int']['input'];
}>;

export type LogLocalExportMutation = { logLocalExport: { success: boolean } };

export type MoveAccessGroupMutationVariables = Exact<{
  attachToUserGroup: Scalars['String']['input'];
  userGroupToMove: Scalars['String']['input'];
}>;

export type MoveAccessGroupMutation = { moveAccessGroup: { success: boolean; message: string } };

export type AddPatientByExternalIdMutationVariables = Exact<{
  patientGroupId: Scalars['ID']['input'];
  externalPatientId: ExternalHumanIdInput;
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AddPatientByExternalIdMutation = {
  addPatientByExternalId?: { success: boolean; message?: string | null; patient?: { id: string } | null } | null;
};

export type CreatePatientMutationVariables = Exact<{
  patientGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  patientInput: CreatePatientInput;
}>;

export type CreatePatientMutation = {
  createPatient?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    patient?: { id: string } | null;
  } | null;
};

export type UpdateLinkedPatientGroupsMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  addPatientGroups: Array<Scalars['String']['input']> | Scalars['String']['input'];
  removePatientGroups: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type UpdateLinkedPatientGroupsMutation = {
  updateLinkedPatientGroups: {
    success?: boolean | null;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdatePatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  patientInput: UpdatePatientInput;
}>;

export type UpdatePatientMutation = {
  updatePatient?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type UpdateWelfareDeviceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput: WelfareDeviceUpdateInput;
}>;

export type UpdateWelfareDeviceMutation = {
  updateWelfareDevice: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type AddUserToRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
}>;

export type AddUserToRoleMutation = { addUserToRole?: { success: boolean; message?: string | null } | null };

export type RemoveUserFromRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
}>;

export type RemoveUserFromRoleMutation = { removeUserFromRole?: { success: boolean; message?: string | null } | null };

export type UpdateUserTimeLimitedAccessMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  timeLimitedAccess?: InputMaybe<PeriodInput>;
}>;

export type UpdateUserTimeLimitedAccessMutation = {
  updateUserTimeLimitedAccess?: { success: boolean; inputValidation?: { message?: string | null } | null } | null;
};

export type CameraProvisioningBatchTelluSupportQueryVariables = Exact<{ [key: string]: never }>;

export type CameraProvisioningBatchTelluSupportQuery = {
  cameraProvisioningBatchTelluSupport: Array<{
    type: CameraManagementType;
    serial: string;
    cameraName: string;
    logs?: Array<string> | null;
    cameraSetup?: {
      model: string;
      serial: string;
      oak: string;
      cameraName: string;
      customerId: number;
      siteId: number;
      deviceGroupId: string;
      installVMD: boolean;
      installFG: boolean;
      installPS: boolean;
      installOA: boolean;
      enableAudio: boolean;
      firmwareUpgrade: boolean;
      installApps: boolean;
    } | null;
    apps?: Array<{ id: string; install: boolean; activate: boolean; deactivate: boolean; uninstall: boolean }> | null;
    status?: Array<{ step: string; status: string; timestamp: any }> | null;
  }>;
};

export type CameraSetupQueryVariables = Exact<{ [key: string]: never }>;

export type CameraSetupQuery = {
  deviceGroups: Array<{ id: string; name?: string | null }>;
  morpheanSitesPerMorpheanCustomerTelluSupport: Array<{
    customerId: number;
    customerName: string;
    morpheanSites: Array<{ siteId: number; siteName: string }>;
  }>;
  supportedCameraModelsTelluSupport: Array<{
    model: string;
    apps: Array<{ id: string; name: string; version: string; supportedModels: Array<string>; default: boolean }>;
  }>;
};

export type SupportedCameraAppsQueryVariables = Exact<{ [key: string]: never }>;

export type SupportedCameraAppsQuery = {
  supportedCameraApps: Array<{
    id: string;
    name: string;
    version: string;
    supportedModels: Array<string>;
    default: boolean;
  }>;
};

export type GetCameraManagementListQueryVariables = Exact<{ [key: string]: never }>;

export type GetCameraManagementListQuery = {
  getCameraManagementList: Array<{
    id?: string | null;
    name?: string | null;
    macAddress: string;
    model?: string | null;
    arch?: string | null;
    soc?: string | null;
    firmware?: string | null;
    latestFirmware?: string | null;
    deviceGroupId?: string | null;
    deviceGroup?: string | null;
    inRegistry: boolean;
    inAccount: boolean;
    isAttachedToPatient: boolean;
    inMorphean: boolean;
    connectedToMorphean: boolean;
    lastSeen?: any | null;
    routerVendor?: string | null;
    routerMac?: string | null;
    mqttConfig?: { url: string; state: string; connectionStatus: string } | null;
    time?: { timezone: string; obtainFromDHCP: boolean } | null;
    apps?: Array<{
      id: string;
      name: string;
      version: string;
      latestVersion: string;
      status: string;
      profileCount?: number | null;
    } | null> | null;
    network?: {
      bonjour: boolean;
      dot1x: boolean;
      ftp: boolean;
      ssh: boolean;
      upnp: boolean;
      zeroConf: boolean;
      allowOldTLS: boolean;
      https: boolean;
      bandwidthLimit: boolean;
      isHardened: boolean;
    } | null;
    audio?: {
      enabled: boolean;
      audioSupported?: boolean | null;
      inputGain?: string | null;
      inputType?: string | null;
      microphonePowerType?: string | null;
      microphonePowered?: boolean | null;
    } | null;
    ptz?: { enabled: boolean; locked: boolean; returnToOverviewawait?: string | null } | null;
    video?: {
      enabled: boolean;
      rtsp: boolean;
      compression: string;
      mirrored: boolean;
      resolution: string;
      rotation: string;
      iCount: string;
      pCount: string;
      rateControlPriority: string;
      targetBitRate: string;
      fps: string;
      captureFrequency: string;
      exposureMode: string;
      whiteBalanceMode: string;
      dayNight: { cutFilterMode: string; shiftLevel: string; manualIrOverriden: boolean };
    } | null;
  }>;
};

export type HealthProviderSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type HealthProviderSettingsQuery = {
  healthProviderSettings: {
    patientAuth?: {
      twoFactorSms?: boolean | null;
      ipRestriction?: boolean | null;
      timeLimitedAccess?: boolean | null;
      externalIdP?: Array<{
        alias?: string | null;
        displayName?: string | null;
        enabled?: boolean | null;
        usernamePolicy?: string | null;
        default?: boolean | null;
        support?: boolean | null;
      }> | null;
    } | null;
    userAuth?: {
      twoFactorSms?: boolean | null;
      ipRestriction?: boolean | null;
      timeLimitedAccess?: boolean | null;
      externalIdP?: Array<{
        alias?: string | null;
        displayName?: string | null;
        enabled?: boolean | null;
        usernamePolicy?: string | null;
        default?: boolean | null;
        support?: boolean | null;
      }> | null;
    } | null;
    externalHumanIdTypes?: Array<{
      id: string;
      use: {
        patientUse?: { applicable?: boolean | null; immutable?: boolean | null } | null;
        personnelUse?: { applicable?: boolean | null } | null;
      };
    }> | null;
  };
};

export type GetAuditEntitySummaryQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetAuditEntitySummaryQuery = { getAuditEntitySummary: Array<{ entityType: string; count: number }> };

export type GetAuditLogPaginatedQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  operations?: InputMaybe<Array<AuditLogOperationSelector> | AuditLogOperationSelector>;
}>;

export type GetAuditLogPaginatedQuery = {
  getAuditLogPaginated: {
    cursor?: any | null;
    events?: Array<{
      id: string;
      action?: string | null;
      recorded?: any | null;
      outcome?: string | null;
      outcomeDesc?: string | null;
      session?: string | null;
      operation?: string | null;
      patientName?: string | null;
      userName?: string | null;
      agent?: Array<{
        requestor: boolean;
        name?: string | null;
        altId?: string | null;
        role?: Array<{ text?: string | null }> | null;
        who?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        network?: { type?: string | null; address?: string | null } | null;
      }> | null;
      source?: {
        observer: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        };
      } | null;
      entity?: Array<{
        name?: string | null;
        what?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        role?: { display?: string | null } | null;
        detail?: Array<{ type?: string | null; valueString?: string | null }> | null;
      }> | null;
    }> | null;
  };
};

export type GetAuditLogEventForPatientByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
}>;

export type GetAuditLogEventForPatientByIdQuery = {
  getAuditLogEventForPatientById?: {
    id: string;
    action?: string | null;
    recorded?: any | null;
    outcome?: string | null;
    outcomeDesc?: string | null;
    session?: string | null;
    operation?: string | null;
    patientName?: string | null;
    userName?: string | null;
    agent?: Array<{ name?: string | null }> | null;
    entity?: Array<{
      name?: string | null;
      what?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { value?: string | null } | null;
      } | null;
      role?: {
        system?: any | null;
        version?: string | null;
        code?: any | null;
        display?: string | null;
        userSelected?: boolean | null;
      } | null;
      detail?: Array<{ type?: string | null; valueString?: string | null }> | null;
    }> | null;
  } | null;
};

export type GetAuditLogEventForUserGroupByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  userGroupId: Scalars['ID']['input'];
}>;

export type GetAuditLogEventForUserGroupByIdQuery = {
  getAuditLogEventForUserGroupById?: {
    id: string;
    action?: string | null;
    recorded?: any | null;
    outcome?: string | null;
    outcomeDesc?: string | null;
    session?: string | null;
    operation?: string | null;
    patientName?: string | null;
    userName?: string | null;
    agent?: Array<{ name?: string | null }> | null;
    entity?: Array<{
      name?: string | null;
      what?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { value?: string | null } | null;
      } | null;
      type?: {
        system?: any | null;
        version?: string | null;
        code?: any | null;
        display?: string | null;
        userSelected?: boolean | null;
      } | null;
      role?: {
        system?: any | null;
        version?: string | null;
        code?: any | null;
        display?: string | null;
        userSelected?: boolean | null;
      } | null;
      detail?: Array<{ type?: string | null; valueString?: string | null }> | null;
    }> | null;
  } | null;
};

export type GetAuditLogForPatientPaginatedQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
  operations?: InputMaybe<Array<AuditLogOperationSelector> | AuditLogOperationSelector>;
}>;

export type GetAuditLogForPatientPaginatedQuery = {
  getAuditLogForPatientPaginated: {
    cursor?: any | null;
    events?: Array<{
      id: string;
      action?: string | null;
      recorded?: any | null;
      outcome?: string | null;
      outcomeDesc?: string | null;
      session?: string | null;
      operation?: string | null;
      patientName?: string | null;
      userName?: string | null;
      agent?: Array<{
        requestor: boolean;
        name?: string | null;
        altId?: string | null;
        role?: Array<{ text?: string | null }> | null;
        who?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        network?: { type?: string | null; address?: string | null } | null;
      }> | null;
      source?: {
        observer: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        };
      } | null;
      entity?: Array<{
        name?: string | null;
        what?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        role?: { display?: string | null } | null;
        detail?: Array<{ type?: string | null; valueString?: string | null }> | null;
      }> | null;
    }> | null;
  };
};

export type GetAuditLogForUserPaginatedQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  operations?: InputMaybe<Array<AuditLogOperationSelector> | AuditLogOperationSelector>;
}>;

export type GetAuditLogForUserPaginatedQuery = {
  getAuditLogForUserPaginated: {
    cursor?: any | null;
    events?: Array<{
      id: string;
      action?: string | null;
      recorded?: any | null;
      outcome?: string | null;
      outcomeDesc?: string | null;
      session?: string | null;
      operation?: string | null;
      patientName?: string | null;
      userName?: string | null;
      agent?: Array<{
        requestor: boolean;
        name?: string | null;
        altId?: string | null;
        role?: Array<{ text?: string | null }> | null;
        who?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        network?: { type?: string | null; address?: string | null } | null;
      }> | null;
      source?: {
        observer: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        };
      } | null;
      entity?: Array<{
        name?: string | null;
        what?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        role?: { display?: string | null } | null;
        detail?: Array<{ type?: string | null; valueString?: string | null }> | null;
      }> | null;
    }> | null;
  };
};

export type GetAuditLogSummaryQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetAuditLogSummaryQuery = {
  getAuditLogSummary: Array<{ operation: string; outcome: string; count: number }>;
};

export type GetAuditRoleSummaryQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetAuditRoleSummaryQuery = {
  getAuditRoleSummary: Array<{ operation: string; role: string; count: number }>;
};

export type GetOwnerAuditEntitySummaryQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetOwnerAuditEntitySummaryQuery = {
  getOwnerAuditEntitySummary: Array<{ entityType: string; count: number }>;
};

export type GetOwnerAuditLogPaginatedQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  operations?: InputMaybe<Array<AuditLogOperationSelector> | AuditLogOperationSelector>;
}>;

export type GetOwnerAuditLogPaginatedQuery = {
  getOwnerAuditLogPaginated: {
    cursor?: any | null;
    events?: Array<{
      id: string;
      action?: string | null;
      recorded?: any | null;
      outcome?: string | null;
      outcomeDesc?: string | null;
      session?: string | null;
      operation?: string | null;
      patientName?: string | null;
      userName?: string | null;
      type: { code: string };
      period?: { start?: any | null; end?: any | null } | null;
      agent?: Array<{
        requestor: boolean;
        name?: string | null;
        altId?: string | null;
        role?: Array<{ text?: string | null }> | null;
        who?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        network?: { type?: string | null; address?: string | null } | null;
      }> | null;
      source?: {
        observer: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        };
      } | null;
      entity?: Array<{
        name?: string | null;
        what?: {
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: {
            system?: string | null;
            use?: IdentifierUse | null;
            value?: string | null;
            type?: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
                userSelected?: boolean | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        role?: { display?: string | null } | null;
        detail?: Array<{ type?: string | null; valueString?: string | null }> | null;
      }> | null;
    }> | null;
  };
};

export type GetOwnerAuditLogSummaryQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetOwnerAuditLogSummaryQuery = {
  getOwnerAuditLogSummary: Array<{ operation: string; outcome: string; count: number }>;
};

export type GetOwnerAuditRoleSummaryQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetOwnerAuditRoleSummaryQuery = {
  getOwnerAuditRoleSummary: Array<{ operation: string; role: string; count: number }>;
};

export type GetPatientAuditEntitySummaryQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetPatientAuditEntitySummaryQuery = {
  getPatientAuditEntitySummary: Array<{ entityType: string; count: number }>;
};

export type GetPatientAuditLogSummaryQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetPatientAuditLogSummaryQuery = {
  getPatientAuditLogSummary: Array<{ operation: string; outcome: string; count: number }>;
};

export type GetPatientAuditRoleSummaryQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetPatientAuditRoleSummaryQuery = {
  getPatientAuditRoleSummary: Array<{ operation: string; role: string; count: number }>;
};

export type GetUserAuditEntitySummaryQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetUserAuditEntitySummaryQuery = {
  getUserAuditEntitySummary: Array<{ entityType: string; count: number }>;
};

export type GetUserAuditLogSummaryQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetUserAuditLogSummaryQuery = {
  getUserAuditLogSummary: Array<{ operation: string; outcome: string; count: number }>;
};

export type GetUserAuditRoleSummaryQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetUserAuditRoleSummaryQuery = {
  getUserAuditRoleSummary: Array<{ operation: string; role: string; count: number }>;
};

export type AllShiftSessionsQueryVariables = Exact<{ [key: string]: never }>;

export type AllShiftSessionsQuery = {
  allShiftSessions: Array<{
    user?: { id: string; firstName: string; lastName: string; username?: string | null } | null;
    session?: {
      createdAt: any;
      lastUpdated: any;
      patientGroupIdsAndNames: Array<{ id: string; name: string }>;
      notificationSettings: { sendEmail?: boolean | null; sendSms?: boolean | null; locale?: string | null };
      pushNotificationSettings: Array<{ type: PushNotificationType; device: string; createdAt: any }>;
    } | null;
  }>;
};

export type GetPatientForCarePlanSimulatorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetPatientForCarePlanSimulatorQuery = {
  patient?: {
    id: string;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    carePlans?: Array<{
      id: string;
      status: CarePlanStatus;
      title?: string | null;
      description?: string | null;
      created?: any | null;
      subject: { reference?: string | null };
      period?: { start?: any | null; end?: any | null } | null;
      activity: Array<{
        detail: {
          scheduledTiming?: {
            event?: Array<any | null> | null;
            repeat?: {
              dayOfWeek?: Array<DayOfWeek> | null;
              timeOfDay: Array<string>;
              periodUnit?: string | null;
              period?: number | null;
              boundsPeriod?: { start?: any | null; end?: any | null } | null;
            } | null;
          } | null;
          scheduledPeriod?: { start?: any | null; end?: any | null } | null;
          code?: {
            text?: string | null;
            coding?: Array<{
              system?: any | null;
              version?: string | null;
              code?: any | null;
              display?: string | null;
            } | null> | null;
          } | null;
          questionnaires?: Array<{
            id: string;
            name: string;
            title?: string | null;
            purpose?: string | null;
            status: QuestionnaireStatus;
            publisher?: string | null;
            description?: string | null;
            effectivePeriod?: { end?: any | null; start?: any | null } | null;
            item?: Array<{
              linkId: string;
              text: string;
              type: QuestionnaireItemType;
              required: boolean;
              answerOption?: Array<{
                valueBoolean?: boolean | null;
                valueInteger?: number | null;
                valueString?: string | null;
                valueDecimal?: number | null;
                valueCoding?: { code?: string | null; display?: string | null } | null;
              } | null> | null;
            } | null> | null;
          } | null> | null;
        };
        outcomeReference?: Array<{
          reference?: string | null;
          display?: string | null;
          type?: string | null;
          identifier?: { value?: string | null } | null;
        } | null> | null;
        observations?: Array<{
          id: string;
          text?: string | null;
          status: string;
          identifier?: Array<{ value?: string | null } | null> | null;
          basedOn?: Array<{ reference?: string | null } | null> | null;
          note?: Array<{ text?: string | null } | null> | null;
          fromTemplate?: { reference?: string | null } | null;
          code?: {
            text?: string | null;
            coding?: Array<{
              system?: any | null;
              version?: string | null;
              code?: any | null;
              display?: string | null;
            } | null> | null;
          } | null;
          component?: Array<{
            code: {
              text?: string | null;
              coding?: Array<{
                system?: any | null;
                version?: string | null;
                code?: any | null;
                display?: string | null;
              } | null> | null;
            };
            valueQuantity?: { value?: number | null; unit?: string | null } | null;
            referenceRange?: Array<{
              text?: string | null;
              low?: { value?: number | null; unit?: string | null } | null;
              high?: { value?: number | null; unit?: string | null } | null;
              type?: {
                text?: string | null;
                coding?: Array<{
                  system?: any | null;
                  version?: string | null;
                  code?: any | null;
                  display?: string | null;
                } | null> | null;
              } | null;
            } | null> | null;
          } | null> | null;
        } | null> | null;
      } | null>;
    } | null> | null;
    referenceRange?: Array<{
      id: string;
      identifier?: Array<{ value?: string | null } | null> | null;
      code?: {
        text?: string | null;
        coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
      } | null;
      component?: Array<{
        code: { text?: string | null; coding?: Array<{ code?: any | null; display?: string | null } | null> | null };
        referenceRange?: Array<{
          low?: { unit?: string | null; value?: number | null } | null;
          high?: { unit?: string | null; value?: number | null } | null;
          type?: {
            text?: string | null;
            coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ContinuousSupervisionCandidatesQueryVariables = Exact<{ [key: string]: never }>;

export type ContinuousSupervisionCandidatesQuery = {
  getContinuousSupervisionCandidates?: Array<{
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    cameras: Array<{ id: string; name: string; macAddress: string; deviceGroupName: string }>;
  }> | null;
};

export type DeviceStatsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type DeviceStatsQuery = {
  deviceStats: {
    stats: Array<{
      timestamp?: any | null;
      technicalAlarms?: number | null;
      technicalAlarmEvents?: number | null;
      deviceType?: string | null;
    }>;
  };
};

export type GetCameraListQueryVariables = Exact<{ [key: string]: never }>;

export type GetCameraListQuery = {
  getCameraList: Array<{
    id: string;
    name?: string | null;
    model?: string | null;
    serialNumber?: string | null;
    patientId?: string | null;
    patientName?: string | null;
    userHasAccessToPatient?: boolean | null;
    registeredInInventory?: boolean | null;
    deviceGroup?: string | null;
    lastSeen?: any | null;
    ttl?: number | null;
    privacyMode?: boolean | null;
    privacyModeUntil?: any | null;
    topPriorityAlarm?: { priority?: string | null } | null;
  }>;
};

export type GetEquipmentListQueryVariables = Exact<{ [key: string]: never }>;

export type GetEquipmentListQuery = {
  getEquipmentList: Array<{
    id: string;
    createdAt: any;
    identifier?: string | null;
    type?: string | null;
    deviceGroup?: string | null;
    name?: string | null;
    patientId?: string | null;
    patientName?: string | null;
    tags?: Array<string> | null;
    userHasAccessToPatient?: boolean | null;
    registeredInInventory?: boolean | null;
    lastSeen?: any | null;
    hasExternalUrl?: boolean | null;
    lastBatteryStatus?: number | null;
    topPriorityAlarm?: { priority?: string | null } | null;
  }>;
};

export type GetAuditLogSummariesQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetAuditLogSummariesQuery = {
  getAuditLogSummaries: {
    auditLogSummary: Array<{ operation: string; outcome: string; count: number }>;
    auditEntitySummary: Array<{ entityType: string; count: number }>;
    auditRoleSummary: Array<{ operation: string; role: string; count: number }>;
  };
};

export type GetListOfUnallocatedWelfareDevicesQueryVariables = Exact<{ [key: string]: never }>;

export type GetListOfUnallocatedWelfareDevicesQuery = {
  getListOfUnallocatedWelfareDevices: Array<{
    id: string;
    uniqueIdentifier: string;
    modelNumber?: string | null;
    userFriendlyName?: string | null;
  }>;
};

export type GetMyPersonalProfileQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyPersonalProfileQuery = {
  getMyPersonalProfile: {
    id: string;
    firstName: string;
    lastName: string;
    email?: string | null;
    username?: string | null;
    mobileNumber?: string | null;
    lastActive?: any | null;
    requestedExternalIds?: Array<{ externalHumanIdType: string; requested: boolean }> | null;
    externalUserIds?: Array<{
      externalId: string;
      externalHumanIdType: {
        id: string;
        localeEntries: Array<{ localeId: string; displayName: string; description?: string | null }>;
      };
    }> | null;
  };
};

export type GetMyPersonalProfileForUserDetailsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyPersonalProfileForUserDetailsQuery = {
  getMyPersonalProfile: {
    id: string;
    username?: string | null;
    externalUserIds?: Array<{
      externalId: string;
      externalHumanIdType: {
        id: string;
        localeEntries: Array<{ localeId: string; displayName: string; description?: string | null }>;
      };
    }> | null;
    requestedExternalIds?: Array<{ externalHumanIdType: string; requested: boolean }> | null;
  };
};

export type GetOpenTechnicalAlarmsQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetOpenTechnicalAlarmsQuery = {
  getOpenTechnicalAlarms: Array<{
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    authoredOn: any;
    description?: string | null;
    lastModified: any;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    forDeviceName?: string | null;
    forDeviceType?: string | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      valueString?: string | null;
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      type?: { text?: string | null } | null;
      valueReference?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { value?: string | null } | null;
      } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
    syncAlarmDetails?: { userGroupId?: string | null } | null;
    patientLink?: { patientId: string; patientName?: string | null; userHasAccessToPatient: boolean } | null;
  }>;
};

export type GetOwnerAuditLogSummariesQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  actions?: InputMaybe<Array<AuditEventAction> | AuditEventAction>;
}>;

export type GetOwnerAuditLogSummariesQuery = {
  getOwnerAuditLogSummaries: {
    auditLogSummary: Array<{ operation: string; outcome: string; count: number }>;
    auditEntitySummary: Array<{ entityType: string; count: number }>;
    auditRoleSummary: Array<{ operation: string; role: string; count: number }>;
  };
};

export type GetDeviceByIdFullQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetDeviceByIdFullQuery = {
  getWelfareDevice?: {
    id: string;
    uniqueIdentifier: string;
    manufacturer?: string | null;
    serialNumber?: string | null;
    modelNumber?: string | null;
    deviceName?: Array<{ name?: string | null; type: string }> | null;
    deviceGroup?: { id: string } | null;
    identifier?: Array<{ value?: string | null }> | null;
    status?: { connected?: boolean | null; lastSeen?: any | null } | null;
    patient?: { reference?: string | null } | null;
  } | null;
};

export type HealthProviderSettingsForUserTableQueryVariables = Exact<{ [key: string]: never }>;

export type HealthProviderSettingsForUserTableQuery = {
  healthProviderSettings: {
    externalHumanIdTypes?: Array<{
      id: string;
      localeEntries: Array<{ localeId: string; displayName: string; description?: string | null }>;
    }> | null;
    userAuth?: { externalIdP?: Array<{ alias?: string | null; displayName?: string | null }> | null } | null;
  };
};

export type HealthProviderSettingsForPatientRegistrationQueryVariables = Exact<{ [key: string]: never }>;

export type HealthProviderSettingsForPatientRegistrationQuery = {
  healthProviderSettings: {
    patientAuth?: {
      externalIdP?: Array<{
        alias?: string | null;
        displayName?: string | null;
        enabled?: boolean | null;
        usernamePolicy?: string | null;
        default?: boolean | null;
      }> | null;
    } | null;
    externalHumanIdTypes?: Array<{ id: string }> | null;
  };
};

export type RpmPatientExportDataQueryVariables = Exact<{
  patientIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type RpmPatientExportDataQuery = {
  rpmPatientExportData?: Array<{
    active?: boolean | null;
    birthDate?: any | null;
    createdAt?: any | null;
    firstName?: string | null;
    gender?: AdministrativeGender | null;
    lastActive?: any | null;
    lastName?: string | null;
    patientGroupName?: string | null;
    updatedAt?: any | null;
    externalIds: Array<{ id: string; type: string }>;
  }> | null;
};

export type GetAllConcreteObservationsAsCsvQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllConcreteObservationsAsCsvQuery = { getAllConcreteObservationsAsCsv?: { csv?: string | null } | null };

export type PatientExportDataQueryVariables = Exact<{
  patientIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type PatientExportDataQuery = {
  patientExportData?: Array<{
    firstName?: string | null;
    lastName?: string | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    tags?: Array<string> | null;
    patientNote?: string | null;
    fhirId: string;
    isAlarmHandlingPlanActive?: boolean | null;
    active?: boolean | null;
    birthDate?: any | null;
    gender?: AdministrativeGender | null;
    patientGroupName?: string | null;
    addressNote?: string | null;
    keyCode?: string | null;
    externalIds: Array<{ id: string; type: string }>;
    devices: Array<{ identifier?: string | null; modelNumber?: string | null }>;
    telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
    address?: Array<{
      line?: Array<string | null> | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      text?: string | null;
    } | null> | null;
    nextOfKins?: Array<{
      name?: string | null;
      relationship?: string | null;
      telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
    }> | null;
    contacts?: Array<{
      name?: string | null;
      telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
    }> | null;
  }> | null;
};

export type PatientGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type PatientGroupsQuery = { patientGroups: Array<{ id: string; name?: string | null } | null> };

export type GetAllSelfTreatmentPlanTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllSelfTreatmentPlanTemplatesQuery = {
  getAllSelfTreatmentPlanTemplates?: Array<{
    id: string;
    status: CarePlanStatus;
    lastUpdated?: string | null;
    title?: string | null;
    subject: { display?: string | null };
    goals: Array<{ id: string; goal?: string | null }>;
    medicalStates?: {
      green: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
      yellow: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
      red: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
    } | null;
  }> | null;
};

export type GetSelfTreatmentPlanTemplateByIdQueryVariables = Exact<{
  selfTreatmentPlanId: Scalars['ID']['input'];
}>;

export type GetSelfTreatmentPlanTemplateByIdQuery = {
  getSelfTreatmentPlanTemplateById: {
    id: string;
    status: CarePlanStatus;
    lastUpdated?: string | null;
    title?: string | null;
    subject: { display?: string | null };
    goals: Array<{ id: string; goal?: string | null }>;
    medicalStates?: {
      green: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
      yellow: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
      red: { symptoms?: Array<string> | null; treatments?: Array<string> | null };
    } | null;
  };
};

export type SupportTeamLinkedHealthProvidersQueryVariables = Exact<{ [key: string]: never }>;

export type SupportTeamLinkedHealthProvidersQuery = {
  supportTeamLinkedHealthProviders?: Array<{ name: string; displayName: string; url?: string | null }> | null;
};

export type UserGroupForTreeQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupForTreeQuery = {
  userGroup: {
    id: string;
    name: string;
    type: string;
    rules?: Array<string> | null;
    parentId?: string | null;
    protected?: boolean | null;
    subTree?: Array<{
      id: string;
      name: string;
      type: string;
      rules?: Array<string> | null;
      parentId?: string | null;
      roles?: Array<{
        basedOn?: string | null;
        protected?: boolean | null;
        id: string;
        roleDefinitionId: string;
        display: Array<{ key: string; value: string } | null>;
      } | null> | null;
      linkedPatientGroups?: Array<{
        id: string;
        name?: string | null;
        patientsCount?: number | null;
        alarmRoutes: Array<{
          configName: string;
          configType: string;
          idMappingStrategy: string;
          incomingTemplate: {
            isPresentInAccount?: boolean | null;
            code: string;
            title: string;
            system: string;
            displayText?: string | null;
            icon?: string | null;
          };
          outgoingTemplate: {
            isPresentInAccount?: boolean | null;
            code: string;
            title: string;
            system: string;
            displayText?: string | null;
            icon?: string | null;
          };
        }>;
      } | null> | null;
      patientGroups?: Array<{
        id: string;
        name?: string | null;
        patientsCount?: number | null;
        alarmRoutes: Array<{
          configName: string;
          configType: string;
          idMappingStrategy: string;
          incomingTemplate: {
            isPresentInAccount?: boolean | null;
            code: string;
            title: string;
            system: string;
            displayText?: string | null;
            icon?: string | null;
          };
          outgoingTemplate: {
            isPresentInAccount?: boolean | null;
            code: string;
            title: string;
            system: string;
            displayText?: string | null;
            icon?: string | null;
          };
        }>;
      } | null> | null;
      skyresponse?: { skyresponseAlarmHandlingRuleId?: number | null } | null;
      deviceGroups?: Array<{ id: string; name?: string | null } | null> | null;
    } | null> | null;
    roles?: Array<{
      basedOn?: string | null;
      protected?: boolean | null;
      id: string;
      roleDefinitionId: string;
      display: Array<{ key: string; value: string } | null>;
    } | null> | null;
    linkedPatientGroups?: Array<{
      id: string;
      name?: string | null;
      patientsCount?: number | null;
      alarmRoutes: Array<{
        configName: string;
        configType: string;
        idMappingStrategy: string;
        incomingTemplate: {
          isPresentInAccount?: boolean | null;
          code: string;
          title: string;
          system: string;
          displayText?: string | null;
          icon?: string | null;
        };
        outgoingTemplate: {
          isPresentInAccount?: boolean | null;
          code: string;
          title: string;
          system: string;
          displayText?: string | null;
          icon?: string | null;
        };
      }>;
    } | null> | null;
    patientGroups?: Array<{
      id: string;
      name?: string | null;
      patientsCount?: number | null;
      alarmRoutes: Array<{
        configName: string;
        configType: string;
        idMappingStrategy: string;
        incomingTemplate: {
          isPresentInAccount?: boolean | null;
          code: string;
          title: string;
          system: string;
          displayText?: string | null;
          icon?: string | null;
        };
        outgoingTemplate: {
          isPresentInAccount?: boolean | null;
          code: string;
          title: string;
          system: string;
          displayText?: string | null;
          icon?: string | null;
        };
      }>;
    } | null> | null;
    deviceGroups?: Array<{ id: string; name?: string | null } | null> | null;
    skyresponse?: { skyresponseAlarmHandlingRuleId?: number | null } | null;
  };
};

export type UserGroupForMoveButtonQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupForMoveButtonQuery = {
  userGroup: {
    id: string;
    name: string;
    type: string;
    rules?: Array<string> | null;
    parentId?: string | null;
    subTree?: Array<{
      id: string;
      name: string;
      parentId?: string | null;
      subGroups?: Array<{ id: string; name: string; type: string; rules?: Array<string> | null } | null> | null;
      roles?: Array<{ id: string } | null> | null;
    } | null> | null;
    subGroups?: Array<{ id: string; name: string } | null> | null;
    roles?: Array<{
      id: string;
      roleDefinitionId: string;
      display: Array<{ key: string; value: string } | null>;
    } | null> | null;
  };
};

export type UserGroupQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupQuery = {
  userGroup: {
    id: string;
    name: string;
    subTree?: Array<{ id: string; name: string; roles?: Array<{ id: string } | null> | null } | null> | null;
    roles?: Array<{
      id: string;
      roleDefinitionId: string;
      display: Array<{ key: string; value: string } | null>;
    } | null> | null;
  };
};

export type UserGroupCompleteQueryVariables = Exact<{
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupCompleteQuery = {
  userGroup: {
    id: string;
    name: string;
    type: string;
    rules?: Array<string> | null;
    parentId?: string | null;
    protected?: boolean | null;
    escalationDelay?: number | null;
    allowedRoleDefinitionIds?: Array<string> | null;
    skyresponse?: {
      enabled?: boolean | null;
      organizationId?: string | null;
      hasSkyresponseExternalId?: boolean | null;
      hasSkyresponseCredentials?: boolean | null;
      skyresponseAlarmHandlingRuleId?: number | null;
      allowedAlarmHandlingRuleIds?: Array<number | null> | null;
      publicArcObjectId?: number | null;
      privateArcObjectId?: number | null;
    } | null;
    careTeams?: Array<{
      id: string;
      name?: string | null;
      telecom?: Array<{
        value?: string | null;
        system?: ContactPointSystem | null;
        use?: ContactPointUse | null;
      } | null> | null;
    } | null> | null;
    subGroups?: Array<{
      id: string;
      name: string;
      type: string;
      parentId?: string | null;
      skyresponse?: { skyresponseAlarmHandlingRuleId?: number | null } | null;
    } | null> | null;
    roles?: Array<{
      protected?: boolean | null;
      id: string;
      roleDefinitionId: string;
      display: Array<{ key: string; value: string } | null>;
    } | null> | null;
    contacts?: Array<{
      id: string;
      name: string;
      availableHours: string;
      telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
      skyresponseConfig?: { callMethod?: number | null } | null;
    }> | null;
    linkedPatientGroups?: Array<{
      id: string;
      name?: string | null;
      patientsCount?: number | null;
      enableDistanceEstimation?: boolean | null;
      enableOnSiteRegistration?: boolean | null;
      hideTechnicalAlarmNotifications?: boolean | null;
    } | null> | null;
    patientGroups?: Array<{
      id: string;
      name?: string | null;
      patientsCount?: number | null;
      enableDistanceEstimation?: boolean | null;
      enableOnSiteRegistration?: boolean | null;
      hideTechnicalAlarmNotifications?: boolean | null;
    } | null> | null;
    deviceGroups?: Array<{
      id: string;
      name?: string | null;
      hasCmpCredentials?: boolean | null;
      streamTTL?: number | null;
    } | null> | null;
  };
};

export type GetAllUserGroupChildrenQueryVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type GetAllUserGroupChildrenQuery = { getAllUserGroupChildren: Array<{ id: string; name: string }> };

export type SubGroupsFragment = {
  id: string;
  name: string;
  type: string;
  parentId?: string | null;
  skyresponse?: { skyresponseAlarmHandlingRuleId?: number | null } | null;
};

export type SubTreeFragment = {
  id: string;
  name: string;
  type: string;
  rules?: Array<string> | null;
  parentId?: string | null;
  roles?: Array<{
    basedOn?: string | null;
    protected?: boolean | null;
    id: string;
    roleDefinitionId: string;
    display: Array<{ key: string; value: string } | null>;
  } | null> | null;
  linkedPatientGroups?: Array<{
    id: string;
    name?: string | null;
    patientsCount?: number | null;
    alarmRoutes: Array<{
      configName: string;
      configType: string;
      idMappingStrategy: string;
      incomingTemplate: {
        isPresentInAccount?: boolean | null;
        code: string;
        title: string;
        system: string;
        displayText?: string | null;
        icon?: string | null;
      };
      outgoingTemplate: {
        isPresentInAccount?: boolean | null;
        code: string;
        title: string;
        system: string;
        displayText?: string | null;
        icon?: string | null;
      };
    }>;
  } | null> | null;
  patientGroups?: Array<{
    id: string;
    name?: string | null;
    patientsCount?: number | null;
    alarmRoutes: Array<{
      configName: string;
      configType: string;
      idMappingStrategy: string;
      incomingTemplate: {
        isPresentInAccount?: boolean | null;
        code: string;
        title: string;
        system: string;
        displayText?: string | null;
        icon?: string | null;
      };
      outgoingTemplate: {
        isPresentInAccount?: boolean | null;
        code: string;
        title: string;
        system: string;
        displayText?: string | null;
        icon?: string | null;
      };
    }>;
  } | null> | null;
  skyresponse?: { skyresponseAlarmHandlingRuleId?: number | null } | null;
  deviceGroups?: Array<{ id: string; name?: string | null } | null> | null;
};

export type PatientGroupFragment = {
  id: string;
  name?: string | null;
  patientsCount?: number | null;
  alarmRoutes: Array<{
    configName: string;
    configType: string;
    idMappingStrategy: string;
    incomingTemplate: {
      isPresentInAccount?: boolean | null;
      code: string;
      title: string;
      system: string;
      displayText?: string | null;
      icon?: string | null;
    };
    outgoingTemplate: {
      isPresentInAccount?: boolean | null;
      code: string;
      title: string;
      system: string;
      displayText?: string | null;
      icon?: string | null;
    };
  }>;
};

export type RoleFragment = {
  id: string;
  roleDefinitionId: string;
  display: Array<{ key: string; value: string } | null>;
};

export type UserGroupForDashboardQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupForDashboardQuery = {
  userGroup: {
    id: string;
    subTree?: Array<{ patientGroups?: Array<{ id: string; name?: string | null } | null> | null } | null> | null;
    patientGroups?: Array<{ id: string; name?: string | null } | null> | null;
  };
};

export type UsersQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UsersQuery = {
  users: Array<{
    id: string;
    firstName: string;
    lastName: string;
    pendingEmailInvitation?: boolean | null;
    enabled?: boolean | null;
    email?: string | null;
    username?: string | null;
    ipRestrictions?: Array<string | null> | null;
    otpStatus?: string | null;
    smsOtpStatus?: string | null;
    smsOtpPhoneNumber?: string | null;
    externalIdP?: string | null;
    passwordStatus?: string | null;
    created?: any | null;
    lastActive?: any | null;
    requestedExternalIds?: Array<{ externalHumanIdType: string; requested: boolean }> | null;
    roles?: Array<{
      id: string;
      roleDefinitionId: string;
      display: Array<{ key: string; value: string } | null>;
      userGroup?: { id: string; name: string } | null;
    } | null> | null;
    externalIdentities?: Array<{ provider: string }> | null;
    externalUserIds?: Array<{
      externalId: string;
      externalHumanIdType: {
        id: string;
        localeEntries: Array<{ localeId: string; displayName: string; description?: string | null }>;
      };
    }> | null;
    timeLimitedAccess?: { start?: any | null; end?: any | null } | null;
  } | null>;
};

export type UserNotificationsDataQueryVariables = Exact<{ [key: string]: never }>;

export type UserNotificationsDataQuery = {
  getMyUserProfile: { id: string; email?: string | null; mobileNumber?: string | null };
};

export type UserForEditFormQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserForEditFormQuery = {
  users: Array<{
    id: string;
    firstName: string;
    lastName: string;
    email?: string | null;
    enabled?: boolean | null;
    username?: string | null;
    mobileNumber?: string | null;
    otpStatus?: string | null;
    pendingEmailInvitation?: boolean | null;
    ipRestrictions?: Array<string | null> | null;
    smsOtpStatus?: string | null;
    smsOtpPhoneNumber?: string | null;
    externalIdP?: string | null;
    passwordStatus?: string | null;
    requestedExternalIds?: Array<{ externalHumanIdType: string; requested: boolean }> | null;
    externalUserIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
    roles?: Array<{
      id: string;
      roleDefinitionId: string;
      display: Array<{ key: string; value: string } | null>;
    } | null> | null;
    timeLimitedAccess?: { start?: any | null; end?: any | null } | null;
  } | null>;
};

export type UsersNamesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UsersNamesQuery = {
  users: Array<{
    pendingEmailInvitation?: boolean | null;
    id: string;
    username?: string | null;
    firstName: string;
    lastName: string;
    email?: string | null;
    enabled?: boolean | null;
  } | null>;
};

export type AllUsersQueryVariables = Exact<{ [key: string]: never }>;

export type AllUsersQuery = {
  users: Array<{
    id: string;
    firstName: string;
    lastName: string;
    pendingEmailInvitation?: boolean | null;
    enabled?: boolean | null;
    email?: string | null;
    username?: string | null;
    ipRestrictions?: Array<string | null> | null;
    otpStatus?: string | null;
    smsOtpStatus?: string | null;
    smsOtpPhoneNumber?: string | null;
    externalIdP?: string | null;
    passwordStatus?: string | null;
    lastActive?: any | null;
    externalIdentities?: Array<{ provider: string }> | null;
    externalUserIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
  } | null>;
};

export type CreateUserMutationVariables = Exact<{
  userInput: UserCreateInput;
}>;

export type CreateUserMutation = {
  createUser?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    user?: { id: string } | null;
  } | null;
};

export type UpdateUserBeforeDeletionMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  userInput: UserUpdateInput;
}>;

export type UpdateUserBeforeDeletionMutation = {
  updateUser?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type DeleteUserMutation = {
  deleteUser?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  userInput: UserUpdateInput;
}>;

export type UpdateUserMutation = { updateUser?: { success: boolean; message?: string | null } | null };

export type ResetUserPasswordMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type ResetUserPasswordMutation = { resetUserPassword?: boolean | null };

export type DisableUserPasswordMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type DisableUserPasswordMutation = { disableUserPassword?: boolean | null };

export type UpdateUserPasswordMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  password: Scalars['String']['input'];
}>;

export type UpdateUserPasswordMutation = { updateUserPassword?: boolean | null };

export type ActivateOtpMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type ActivateOtpMutation = { activateOtp?: boolean | null };

export type DeleteOtpMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type DeleteOtpMutation = { deleteOtp?: boolean | null };

export type CancelOtpMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type CancelOtpMutation = { cancelOtp?: boolean | null };

export type ActivateSmsOtpMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
}>;

export type ActivateSmsOtpMutation = { activateSmsOtp?: boolean | null };

export type DeactivateSmsOtpMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type DeactivateSmsOtpMutation = { deactivateSmsOtp?: boolean | null };

export type SetExternalIdentitiesMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  identities?: InputMaybe<Array<InputMaybe<ExternalIdentityInput>> | InputMaybe<ExternalIdentityInput>>;
}>;

export type SetExternalIdentitiesMutation = { setExternalIdentities?: boolean | null };

export type SetExternalIdPMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  idP: Scalars['String']['input'];
}>;

export type SetExternalIdPMutation = { setExternalIdP?: boolean | null };

export type EnableUserPasswordMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type EnableUserPasswordMutation = { enableUserPassword?: boolean | null };

export type VkpPatientCareplanQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type VkpPatientCareplanQuery = { vkpPatientCareplan?: { fnr: string; responseAsJson?: string | null } | null };

export type VkpPatientEpisodesOfCareQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type VkpPatientEpisodesOfCareQuery = {
  vkpPatientEpisodesOfCare?: { fnr: string; responseAsJson?: string | null } | null;
};

export type ServicesQueryVariables = Exact<{ [key: string]: never }>;

export type ServicesQuery = {
  services?: Array<{
    id?: string | null;
    name?: string | null;
    roles?: Array<{
      basedOn?: string | null;
      id: string;
      roleDefinitionId: string;
      dashboardRouteName?: string | null;
      canAssignRoles?: Array<string> | null;
      userGroup?: { isTopLevel?: boolean | null; id: string; name: string } | null;
      userManuals?: Array<{
        id: string;
        name: string;
        icon?: string | null;
        applications?: { tilsyn?: boolean | null; dho?: boolean | null } | null;
        localeEntries: Array<{ localeId: string; description?: string | null; displayName: string; url: string }>;
        roleDefinitions?: Array<{ id: string }> | null;
      }> | null;
      display: Array<{ key: string; value: string } | null>;
      abilities?: Array<{ operation?: string | null; resource?: string | null } | null> | null;
    } | null> | null;
    applications?: { dialogg?: boolean | null; tilsyn?: boolean | null; dho?: boolean | null } | null;
    features?: {
      distanceApi?: boolean | null;
      externalHumanIdTypeIdForPatient?: string | null;
      externalHumanIdTypeIdForUser?: string | null;
      externalHumanIdTypeIdForDialoggUser?: string | null;
      videoMeetings?: boolean | null;
      defaultLocale?: string | null;
      axisCameras?: boolean | null;
      disablePasswordForDialoggUsers?: boolean | null;
      smsNotifications?: boolean | null;
      emailNotifications?: boolean | null;
      continuousSupervision?: boolean | null;
      vkpSearchEnabled?: boolean | null;
      hasKomp?: boolean | null;
      joinNhnMeeting?: boolean | null;
      sendNotificationToNextOfKin?: boolean | null;
      selfTreatmentPlan?: boolean | null;
      hasJournalConfig?: boolean | null;
      hasSkyresponseCustomerGroup?: boolean | null;
      hasCmpAccount?: boolean | null;
      safemateIntegration?: boolean | null;
      tcifIntegration?: boolean | null;
      skyresponse?: boolean | null;
    } | null;
    configuration?: {
      alarmAckTemplates?: Array<{ template?: string | null; status?: string | null } | null> | null;
    } | null;
  } | null> | null;
};

export type RegisterPushIdForShiftSessionMutationVariables = Exact<{
  pushNotificationSettings: PushNotificationSettingsInput;
}>;

export type RegisterPushIdForShiftSessionMutation = {
  registerPushIdForShiftSession?: { success: boolean; message?: string | null } | null;
};

export type CreateShiftSessionForPatientGroupsMutationVariables = Exact<{
  patientGroupIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type CreateShiftSessionForPatientGroupsMutation = {
  createShiftSessionForPatientGroups?: {
    createdAt: any;
    lastUpdated: any;
    patientGroupIdsAndNames: Array<{ id: string; name: string }>;
    pushNotificationSettings: Array<{ type: PushNotificationType; device: string }>;
    notificationSettings: { sendEmail?: boolean | null; sendSms?: boolean | null; locale?: string | null };
  } | null;
};

export type SetEmailAndSmsNotificationSettingsForShiftSessionMutationVariables = Exact<{
  notificationSettings: SessionNotificationSettingsInput;
}>;

export type SetEmailAndSmsNotificationSettingsForShiftSessionMutation = {
  setEmailAndSmsNotificationSettingsForShiftSession?: {
    createdAt: any;
    lastUpdated: any;
    patientGroupIdsAndNames: Array<{ id: string; name: string }>;
    pushNotificationSettings: Array<{ type: PushNotificationType; device: string }>;
    notificationSettings: {
      sendEmail?: boolean | null;
      sendSms?: boolean | null;
      locale?: string | null;
      mobileNumber?: string | null;
      email?: string | null;
    };
  } | null;
};

export type ShiftSessionQueryVariables = Exact<{ [key: string]: never }>;

export type ShiftSessionQuery = {
  shiftSession?: {
    patientGroupIdsAndNames: Array<{ id: string; name: string }>;
    pushNotificationSettings: Array<{ type: PushNotificationType; device: string; createdAt: any }>;
    notificationSettings: {
      sendEmail?: boolean | null;
      sendSms?: boolean | null;
      mobileNumber?: string | null;
      email?: string | null;
    };
  } | null;
};

export type AddPatientAlarmHandlingMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  fromTemplate: Scalars['ID']['input'];
  input: AlarmActivityInput;
}>;

export type AddPatientAlarmHandlingMutation = {
  addPatientAlarmHandling: {
    success?: boolean | null;
    message?: string | null;
    inputValidation?: { message?: string | null } | null;
  };
};

export type UpdatePatientAlarmHandlingMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  alarmId: Scalars['ID']['input'];
  input: AlarmActivityInput;
}>;

export type UpdatePatientAlarmHandlingMutation = { updatePatientAlarmHandling: { success?: boolean | null } };

export type RemovePatientAlarmHandlingMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  alarmId: Scalars['ID']['input'];
}>;

export type RemovePatientAlarmHandlingMutation = { removePatientAlarmHandling: { success?: boolean | null } };

export type GetAlarmHandlingPlanAlarmsQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetAlarmHandlingPlanAlarmsQuery = {
  getAlarmHandlingPlanAlarms: Array<{
    id: string;
    alarmIcon?: string | null;
    callbackMinutes?: number | null;
    technical?: boolean | null;
    generatesAlarm?: boolean | null;
    noCarePlanRequired?: boolean | null;
    resolveAction?: Array<string | null> | null;
    description?: string | null;
    tagAction?: Array<{ target?: TagTarget | null; type?: TagActionType | null; label?: string | null } | null> | null;
    identifier: Array<{ value?: string | null } | null>;
    code: {
      text?: string | null;
      coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
    };
    effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
    interpretation?: Array<{
      text?: string | null;
      coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
    } | null> | null;
    component?: Array<{
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
      };
    } | null> | null;
    cep?: { trigger?: Array<string> | null; cancelledBy?: Array<string> | null; after?: number | null } | null;
  }>;
};

export type GetAlarmTemplatesForAlarmHandlingQueryVariables = Exact<{ [key: string]: never }>;

export type GetAlarmTemplatesForAlarmHandlingQuery = {
  getAlarmTemplates: Array<{
    id: string;
    description?: string | null;
    status: string;
    alarmIcon?: string | null;
    callbackMinutes?: number | null;
    technical?: boolean | null;
    generatesAlarm?: boolean | null;
    noCarePlanRequired?: boolean | null;
    resolveAction?: Array<string | null> | null;
    identifier: Array<{ value?: string | null } | null>;
    code: {
      text?: string | null;
      coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
    };
    component?: Array<{
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
      };
    } | null> | null;
    tagAction?: Array<{ target?: TagTarget | null; type?: TagActionType | null; label?: string | null } | null> | null;
    effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
    interpretation?: Array<{
      text?: string | null;
      coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
    } | null> | null;
    cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
  }>;
};

export type GetAlarmTemplatesForAlarmWizardQueryVariables = Exact<{ [key: string]: never }>;

export type GetAlarmTemplatesForAlarmWizardQuery = {
  getAlarmTemplates: Array<{
    id: string;
    description?: string | null;
    status: string;
    alarmIcon?: string | null;
    callbackMinutes?: number | null;
    technical?: boolean | null;
    generatesAlarm?: boolean | null;
    noCarePlanRequired?: boolean | null;
    resolveAction?: Array<string | null> | null;
    identifier: Array<{ value?: string | null } | null>;
    code: {
      text?: string | null;
      coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
    };
    component?: Array<{
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
      };
    } | null> | null;
    tagAction?: Array<{ target?: TagTarget | null; type?: TagActionType | null; label?: string | null } | null> | null;
    effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
    interpretation?: Array<{
      text?: string | null;
      coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
    } | null> | null;
    cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
  }>;
};

export type DeleteAlarmTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteAlarmTemplateMutation = {
  deleteAlarmTemplate: { success?: boolean | null; message?: string | null };
};

export type ConfigureCameraEventsMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type ConfigureCameraEventsMutation = { configureCameraEvents: { success: boolean } };

export type SetAnonymizationRequirementMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  anonymizationRequirement: Scalars['Boolean']['input'];
}>;

export type SetAnonymizationRequirementMutation = { setAnonymizationRequirement: boolean };

export type StartAppMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  appId: Scalars['String']['input'];
}>;

export type StartAppMutation = { startApp: boolean };

export type StopAppMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  appId: Scalars['String']['input'];
}>;

export type StopAppMutation = { stopApp: boolean };

export type RebootMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type RebootMutation = { reboot: boolean };

export type GetCameraAdminAppsQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type GetCameraAdminAppsQuery = {
  getCameraAdmin: { adminApps?: Array<{ id: string; url?: string | null } | null> | null };
};

export type GetAvailableCamerasInInventoryQueryVariables = Exact<{ [key: string]: never }>;

export type GetAvailableCamerasInInventoryQuery = {
  getAvailableCamerasInInventory: Array<{ macAddress?: string | null; modelNumber?: string | null }>;
};

export type GetCameraForFormQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type GetCameraForFormQuery = {
  getCamera: {
    id: string;
    isConfiguredInRegistry?: boolean | null;
    name: string;
    macAddress: string;
    modelName?: string | null;
    manufacturer?: string | null;
    deviceGroup?: { id: string; name?: string | null } | null;
    anonymization?: { supports?: boolean | null; requirement?: boolean | null } | null;
  };
};

export type GetCameraAdminQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type GetCameraAdminQuery = {
  getCameraAdmin: {
    id: string;
    online?: boolean | null;
    firmware?: string | null;
    adminApps?: Array<{
      id: string;
      name?: string | null;
      status?: string | null;
      profiles?: Array<{
        id?: number | null;
        name?: string | null;
        cameraTopic?: string | null;
        accountTemplate?: { code: string; title: string; displayText?: string | null; icon?: string | null } | null;
        patientTemplate?: { code: string; title: string; displayText?: string | null; icon?: string | null } | null;
      }> | null;
    } | null> | null;
    router?: { mac?: string | null; vendor?: string | null } | null;
    mqttClientStatus?: { state: string; connectionStatus: string } | null;
  };
};

export type SetPatientCamerasInPrivacyModeMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  seconds?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SetPatientCamerasInPrivacyModeMutation = {
  setPatientCamerasInPrivacyMode?: Array<{ success: boolean }> | null;
};

export type UnsetPatientCamerasFromPrivacyModeMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type UnsetPatientCamerasFromPrivacyModeMutation = {
  unsetPatientCamerasFromPrivacyMode?: Array<{ success: boolean }> | null;
};

export type GetDeviceModelNumberByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetDeviceModelNumberByIdQuery = { getWelfareDevice?: { id: string; modelNumber?: string | null } | null };

export type GetDeviceNameByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetDeviceNameByIdQuery = {
  getWelfareDevice?: { id: string; deviceName?: Array<{ name?: string | null }> | null } | null;
};

export type GetWelfareDeviceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetWelfareDeviceQuery = {
  getWelfareDevice?: {
    id: string;
    uniqueIdentifier: string;
    modelNumber?: string | null;
    tags?: Array<string> | null;
    property?: { callbackPhoneNumber?: string | null; pin?: string | null } | null;
    deviceName?: Array<{ name?: string | null }> | null;
    deviceGroup?: { name?: string | null; id: string } | null;
  } | null;
};

export type GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
}>;

export type GetAllTechnicalAlarmEventsForDevicePaginatedQuery = {
  getAllTechnicalAlarmEventsForDevicePaginated?: {
    cursor?: any | null;
    events: Array<{
      id: string;
      effectiveDateTime?: any | null;
      status: string;
      code?: {
        coding?: Array<{ code?: any | null; display?: string | null; system?: any | null } | null> | null;
      } | null;
      handlingStatuses: Array<{
        handler: string;
        initiatedAt: any;
        attempts: Array<{
          startedAt: any;
          doneAt: any;
          status: string;
          handledBy?: Array<string> | null;
          payload?: string | null;
          rawResponse?: string | null;
          rawStatus?: string | null;
          details?: string | null;
        }>;
      }>;
    }>;
  } | null;
};

export type AddNextOfKinInImportComponentMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  nextOfKinInput: CreateNextOfKinInput;
}>;

export type AddNextOfKinInImportComponentMutation = {
  addNextOfKin: { success: boolean; message?: string | null; nextOfKin?: { id: string } | null };
};

export type UpdateNextOfKinInImportComponentMutationVariables = Exact<{
  nokId: Scalars['ID']['input'];
  nextOfKinInput: UpdateNextOfKinInput;
}>;

export type UpdateNextOfKinInImportComponentMutation = {
  updateNextOfKin: { success: boolean; message?: string | null };
};

export type MarkNextOfKinAsMainMutationVariables = Exact<{
  nokId: Scalars['ID']['input'];
}>;

export type MarkNextOfKinAsMainMutation = {
  markNextOfKinAsMain?: { success: boolean; message?: string | null } | null;
};

export type AddPatientContactMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  contact: CreateContactInput;
}>;

export type AddPatientContactMutation = { addPatientContact: { success: boolean } };

export type AddUserGroupContactMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  contact: CreateContactInput;
}>;

export type AddUserGroupContactMutation = { addUserGroupContact: { success: boolean } };

export type CreateUserGroupForImportComponentMutationVariables = Exact<{
  newUserGroup: CreateUserGroupInput;
  parentUserGroupId: Scalars['ID']['input'];
}>;

export type CreateUserGroupForImportComponentMutation = {
  createUserGroup: { success?: boolean | null; message?: string | null; userGroup?: { id: string } | null };
};

export type UpdateUserGroupForImportComponentMutationVariables = Exact<{
  userGroup: UpdateUserGroupInput;
  userGroupId: Scalars['ID']['input'];
}>;

export type UpdateUserGroupForImportComponentMutation = {
  updateUserGroup: { success?: boolean | null; userGroup?: { id: string } | null };
};

export type UpdateUserGroupContactMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  contact: UpdateContactInput;
}>;

export type UpdateUserGroupContactMutation = { updateUserGroupContact: { success: boolean } };

export type UpdatePatientGroupsOfPatientMutationVariables = Exact<{
  addPatientGroups?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  removePatientGroups?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
}>;

export type UpdatePatientGroupsOfPatientMutation = { updatePatientGroupsOfPatient?: { success: boolean } | null };

export type PatientsForImportQueryVariables = Exact<{ [key: string]: never }>;

export type PatientsForImportQuery = {
  patientsForImport: Array<{
    id: string;
    externalIds: Array<{ type: string; id: string }>;
    contacts?: Array<{ id: string; name?: string | null }> | null;
    nextOfKins: Array<{
      id: string;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    }>;
    patientGroups: Array<{ id: string; name?: string | null }>;
  }>;
};

export type UserGroupForImportComponentQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupForImportComponentQuery = {
  userGroup: {
    id: string;
    name: string;
    type: string;
    patientGroups?: Array<{ id: string; name?: string | null; patientsCount?: number | null } | null> | null;
    subTree?: Array<{
      id: string;
      name: string;
      type: string;
      rules?: Array<string> | null;
      parentId?: string | null;
      roles?: Array<{
        id: string;
        roleDefinitionId: string;
        protected?: boolean | null;
        display: Array<{ key: string; value: string } | null>;
      } | null> | null;
      patientGroups?: Array<{ id: string; name?: string | null; patientsCount?: number | null } | null> | null;
      contacts?: Array<{
        id: string;
        name: string;
        telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
      }> | null;
    } | null> | null;
    contacts?: Array<{
      id: string;
      name: string;
      telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
    }> | null;
  };
};

export type GetIotcommsLogsQueryVariables = Exact<{
  fields?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  observationId: Scalars['String']['input'];
}>;

export type GetIotcommsLogsQuery = {
  getIotcommsLogs: { success: boolean; message?: string | null; logs?: Array<string | null> | null };
};

export type SimulateNovoEventMutationVariables = Exact<{
  event: NovoEventInput;
}>;

export type SimulateNovoEventMutation = { simulateNovoEvent: { success: boolean; message?: string | null } };

export type GetDeviceByIdForOpenTechnicalAlarmQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetDeviceByIdForOpenTechnicalAlarmQuery = {
  getWelfareDevice?: {
    id: string;
    uniqueIdentifier: string;
    modelNumber?: string | null;
    userFriendlyName?: string | null;
    serialNumber?: string | null;
    tags?: Array<string> | null;
    deviceName?: Array<{ name?: string | null }> | null;
    deviceGroup?: { name?: string | null; id: string } | null;
  } | null;
};

export type GetCameraForOpenTechnicalAlarmQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type GetCameraForOpenTechnicalAlarmQuery = {
  getCamera: {
    id: string;
    isConfiguredInRegistry?: boolean | null;
    name: string;
    macAddress: string;
    modelName?: string | null;
    manufacturer?: string | null;
    deviceGroup?: { id: string; name?: string | null } | null;
  };
};

export type PutPatientAlarmHandlingPlanOnHoldMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type PutPatientAlarmHandlingPlanOnHoldMutation = { putPatientAlarmHandlingPlanOnHold: { success: boolean } };

export type ResumePatientAlarmHandlingPlanMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type ResumePatientAlarmHandlingPlanMutation = { resumePatientAlarmHandlingPlan: { success: boolean } };

export type CreateUnplannedSupervisionMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type CreateUnplannedSupervisionMutation = {
  createUnplannedSupervision: { success: boolean; message?: string | null; task?: { id: string } | null };
};

export type SimulateSafemateEventMutationVariables = Exact<{
  event: SafemateEventInput;
}>;

export type SimulateSafemateEventMutation = { simulateSafemateEvent: { success: boolean; message?: string | null } };

export type SimulateSkyResponseEventMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  externalAccessId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  event: SkyresponseEventInput;
}>;

export type SimulateSkyResponseEventMutation = {
  simulateSkyResponseEvent: { success: boolean; message?: string | null };
};

export type GetAvailableWelfareDevicesInInventoryQueryVariables = Exact<{ [key: string]: never }>;

export type GetAvailableWelfareDevicesInInventoryQuery = {
  getAvailableWelfareDevicesInInventory: Array<{ uniqueIdentifier: string; modelNumber: string }>;
};

export type GetAlarmTemplatesForTemplateCepQueryVariables = Exact<{ [key: string]: never }>;

export type GetAlarmTemplatesForTemplateCepQuery = {
  getAlarmTemplates: Array<{
    id: string;
    technical?: boolean | null;
    alarmIcon?: string | null;
    status: string;
    identifier: Array<{ value?: string | null } | null>;
    code: {
      text?: string | null;
      coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
    };
  }>;
};

export type NotifyNextOfKinsMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}>;

export type NotifyNextOfKinsMutation = {
  notifyNextOfKins?: Array<{ phoneNumber: string; messageStatus: string }> | null;
};

export type GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables = Exact<{ [key: string]: never }>;

export type GetAlarmTemplatesForSyncAlarmSimulatorQuery = {
  getAlarmTemplates: Array<{
    id: string;
    status: string;
    alarmIcon?: string | null;
    description?: string | null;
    identifier: Array<{ value?: string | null } | null>;
    code: { coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null };
    interpretation?: Array<{
      text?: string | null;
      coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
    } | null> | null;
  }>;
};

export type GetOpenPatientAlarmsQueryVariables = Exact<{
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  hideAssignedToOtherUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetOpenPatientAlarmsQuery = {
  getOpenPatientAlarms: Array<{
    id: string;
    status: string;
    priority?: string | null;
    authoredOn: any;
    code?: { text?: string | null } | null;
    directRoutingDetails?: { hasActiveCall: boolean; escalationStatus?: string | null } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
      valueReference?: { reference?: string | null } | null;
    } | null;
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    input?: Array<{
      timestamp?: string | null;
      priority?: string | null;
      icon?: string | null;
      valueReference?: { reference?: string | null } | null;
      values: Array<{
        name: string;
        valueString?: string | null;
        valueBoolean?: boolean | null;
        valueNumber?: number | null;
      }>;
      type?: { text?: string | null; coding?: Array<{ code?: any | null } | null> | null } | null;
    } | null> | null;
    locationTraces?: Array<{
      forDeviceId: string;
      gpsLocations: Array<{
        description?: string | null;
        gpsTimestamp?: any | null;
        receivedTimestamp?: any | null;
        position?: { longitude: number; latitude: number; altitude?: number | null } | null;
        address?: {
          use?: AddressUse | null;
          line?: Array<string | null> | null;
          city?: string | null;
          postalCode?: string | null;
          country?: string | null;
          text?: string | null;
        } | null;
      }>;
      latestGpsLocation?: {
        description?: string | null;
        gpsTimestamp?: any | null;
        receivedTimestamp?: any | null;
        position?: { longitude: number; latitude: number; altitude?: number | null } | null;
        address?: {
          use?: AddressUse | null;
          line?: Array<string | null> | null;
          city?: string | null;
          postalCode?: string | null;
          country?: string | null;
          text?: string | null;
        } | null;
      } | null;
    }> | null;
    patient?: {
      id: string;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null;
      patientGroups?: Array<{
        id: string;
        name: string;
        enableDistanceEstimation: boolean;
        enableOnSiteRegistration: boolean;
      } | null> | null;
      address?: Array<{
        line?: Array<string | null> | null;
        postalCode?: string | null;
        city?: string | null;
        country?: string | null;
        text?: string | null;
      } | null> | null;
      skyresponseDetails?: {
        enabled?: boolean | null;
        organizationId?: string | null;
        hasSkyresponseExternalId?: boolean | null;
        hasSkyresponseCredentials?: boolean | null;
      } | null;
    } | null;
  }>;
};

export type GetPatientWithAlarmsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetPatientWithAlarmsQuery = {
  getPatientWithAlarms?: {
    patient: { id: string; active: boolean };
    openTechnicalAlarms: Array<{
      forDeviceType?: string | null;
      forDeviceName?: string | null;
      id: string;
      status: string;
      acceptedAt?: any | null;
      presentAt?: any | null;
      completedAt?: any | null;
      description?: string | null;
      intent?: string | null;
      priority?: string | null;
      authoredOn: any;
      firstEventTimestamp?: any | null;
      lastModified: any;
      code?: { text?: string | null } | null;
      for: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { system?: string | null; use?: IdentifierUse | null; value?: string | null } | null;
      };
      basedOn?: Array<{ reference?: string | null; type?: string | null; display?: string | null } | null> | null;
      focus?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { system?: string | null; use?: IdentifierUse | null; value?: string | null } | null;
      } | null;
      priorityInput?: {
        timestamp?: string | null;
        icon?: string | null;
        priority?: string | null;
        templateCode?: string | null;
        templateDisplayName?: string | null;
      } | null;
      partOf?: Array<{
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { system?: string | null; use?: IdentifierUse | null; value?: string | null } | null;
      } | null> | null;
      executionPeriod?: { start?: any | null; end?: any | null } | null;
      note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
      restriction?: {
        period?: { start?: any | null; end?: any | null } | null;
        recipient?: Array<{
          reference?: string | null;
          type?: string | null;
          display?: string | null;
          identifier?: { system?: string | null; use?: IdentifierUse | null; value?: string | null } | null;
        } | null> | null;
      } | null;
    }>;
    openPatientAlarms: Array<{
      forDeviceType?: string | null;
      forDeviceName?: string | null;
      id: string;
      status: string;
      description?: string | null;
      intent?: string | null;
      priority?: string | null;
      authoredOn: any;
      firstEventTimestamp?: any | null;
      lastModified: any;
      acceptedAt?: any | null;
      presentAt?: any | null;
      completedAt?: any | null;
      code?: { text?: string | null } | null;
      for: { reference?: string | null; type?: string | null; display?: string | null };
      basedOn?: Array<{ reference?: string | null; type?: string | null; display?: string | null } | null> | null;
      focus?: { reference?: string | null; type?: string | null; display?: string | null } | null;
      partOf?: Array<{ reference?: string | null; type?: string | null; display?: string | null } | null> | null;
      executionPeriod?: { start?: any | null; end?: any | null } | null;
      note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
      priorityInput?: {
        timestamp?: string | null;
        icon?: string | null;
        priority?: string | null;
        templateCode?: string | null;
        templateDisplayName?: string | null;
      } | null;
      owner?: { reference?: string | null; type?: string | null; display?: string | null } | null;
    }>;
  } | null;
};

export type GetCoordinateOfAddressQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;

export type GetCoordinateOfAddressQuery = {
  getCoordinateOfAddress: { status: string; latLng?: { latitude: number; longitude: number } | null };
};

export type GetAlarmStatusQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type GetAlarmStatusQuery = {
  getAlarmStatus: {
    id: string;
    status: string;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
      valueReference?: { reference?: string | null } | null;
    } | null;
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    input?: Array<{
      icon?: string | null;
      priority?: string | null;
      timestamp?: string | null;
      values: Array<{
        name: string;
        valueString?: string | null;
        valueBoolean?: boolean | null;
        valueNumber?: number | null;
      }>;
      valueReference?: { reference?: string | null } | null;
      type?: { text?: string | null; coding?: Array<{ system?: any | null; code?: any | null } | null> | null } | null;
    } | null> | null;
    directRoutingDetails?: { hasActiveCall: boolean; escalationStatus?: string | null } | null;
  };
};

export type GetAlarmByIdQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type GetAlarmByIdQuery = {
  getAlarmById: {
    id: string;
    status: string;
    intent?: string | null;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    lastModified: any;
    priority?: string | null;
    description?: string | null;
    authoredOn: any;
    firstEventTimestamp?: any | null;
    completionOptions?: Array<string> | null;
    isSupervisionAlarmWithAnOpenedCameraStream?: boolean | null;
    isSupervisionAlarm?: boolean | null;
    code?: { text?: string | null } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
      valueReference?: { reference?: string | null } | null;
    } | null;
    for: { reference?: string | null };
    subTasks?: Array<{ id: string } | null> | null;
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    input?: Array<{
      icon?: string | null;
      priority?: string | null;
      timestamp?: string | null;
      values: Array<{
        name: string;
        valueString?: string | null;
        valueBoolean?: boolean | null;
        valueNumber?: number | null;
      }>;
      valueReference?: { reference?: string | null } | null;
      type?: { text?: string | null; coding?: Array<{ system?: any | null; code?: any | null } | null> | null } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
    vkpConfiguration?: { enabled: boolean } | null;
    directRoutingDetails?: { hasActiveCall: boolean; escalationStatus?: string | null } | null;
    patient?: {
      id: string;
      keyCode?: string | null;
      addressNote?: string | null;
      note?: string | null;
      secretAddress?: boolean | null;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null;
      telecom?: Array<{
        value?: string | null;
        system?: ContactPointSystem | null;
        use?: ContactPointUse | null;
      } | null> | null;
      photo?: Array<{ url?: string | null } | null> | null;
      address?: Array<{
        line?: Array<string | null> | null;
        postalCode?: string | null;
        city?: string | null;
        country?: string | null;
        text?: string | null;
      } | null> | null;
      cameras?: Array<{
        id: string;
        name?: string | null;
        macAddress?: string | null;
        serialNumber?: string | null;
        availableHours?: string | null;
        isConfiguredInRegistry?: boolean | null;
        hasOfflineAlarm?: boolean | null;
        userHasAccessToPatient?: boolean | null;
        isAttachedToPatient?: boolean | null;
        detailedStatus?: {
          lastSeen?: any | null;
          heartbeatCount?: number | null;
          isAssociatedToPatient?: boolean | null;
          ttl?: number | null;
          privacyMode?: boolean | null;
        } | null;
      } | null> | null;
      welfareDevices?: Array<{
        id: string;
        uniqueIdentifier: string;
        modelNumber?: string | null;
        deviceName?: Array<{ name?: string | null }> | null;
        configuration?: { registeredInInventory?: boolean | null } | null;
      }> | null;
      patientGroups?: Array<{
        id: string;
        name: string;
        enableDistanceEstimation: boolean;
        enableOnSiteRegistration: boolean;
      } | null> | null;
      skyresponseDetails?: {
        enabled?: boolean | null;
        organizationId?: string | null;
        hasSkyresponseExternalId?: boolean | null;
        hasSkyresponseCredentials?: boolean | null;
      } | null;
    } | null;
    locationTraces?: Array<{
      forDeviceId: string;
      gpsLocations: Array<{
        description?: string | null;
        gpsTimestamp?: any | null;
        receivedTimestamp?: any | null;
        position?: { longitude: number; latitude: number; altitude?: number | null } | null;
        address?: {
          use?: AddressUse | null;
          line?: Array<string | null> | null;
          city?: string | null;
          postalCode?: string | null;
          country?: string | null;
          text?: string | null;
        } | null;
      }>;
      latestGpsLocation?: {
        description?: string | null;
        gpsTimestamp?: any | null;
        receivedTimestamp?: any | null;
        position?: { longitude: number; latitude: number; altitude?: number | null } | null;
        address?: {
          use?: AddressUse | null;
          line?: Array<string | null> | null;
          city?: string | null;
          postalCode?: string | null;
          country?: string | null;
          text?: string | null;
        } | null;
      } | null;
    }> | null;
  };
};

export type GetAllTechnicalAlarmsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetAllTechnicalAlarmsQuery = {
  getAllTechnicalAlarms: Array<{
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    authoredOn: any;
    description?: string | null;
    lastModified: any;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    forDeviceName?: string | null;
    forDeviceType?: string | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      valueString?: string | null;
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      type?: { text?: string | null } | null;
      valueReference?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { value?: string | null } | null;
      } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
    syncAlarmDetails?: { userGroupId?: string | null; entityName?: string | null } | null;
    patientLink?: { patientId: string; userHasAccessToPatient: boolean } | null;
  }>;
};

export type GetAllTechnicalAlarmsForDevicesQueryVariables = Exact<{
  deviceIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type GetAllTechnicalAlarmsForDevicesQuery = {
  getAllTechnicalAlarmsForDevices: Array<{
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    description?: string | null;
    authoredOn: any;
    firstEventTimestamp?: any | null;
    lastModified: any;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    forDeviceName?: string | null;
    forDeviceType?: string | null;
    code?: { text?: string | null } | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      valueReference?: { reference?: string | null } | null;
      type?: { text?: string | null } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
  }>;
};

export type GetOpenTechnicalAlarmsForDevicesQueryVariables = Exact<{
  deviceIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;

export type GetOpenTechnicalAlarmsForDevicesQuery = {
  getOpenTechnicalAlarmsForDevices: Array<{
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    description?: string | null;
    authoredOn: any;
    firstEventTimestamp?: any | null;
    lastModified: any;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    forDeviceName?: string | null;
    forDeviceType?: string | null;
    code?: { text?: string | null } | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      valueReference?: { reference?: string | null } | null;
      type?: { text?: string | null } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
  }>;
};

export type GetOpenSyncAlarmsQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetOpenSyncAlarmsQuery = {
  getOpenTechnicalAlarms: Array<{
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    authoredOn: any;
    lastModified: any;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    syncPending?: boolean | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      valueString?: string | null;
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      type?: { text?: string | null } | null;
      valueReference?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { value?: string | null } | null;
      } | null;
    } | null> | null;
    syncAlarmDetails?: { userGroupId?: string | null; entityName?: string | null } | null;
  }>;
};

export type GetTechnicalAlarmByIdQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetTechnicalAlarmByIdQuery = {
  getTechnicalAlarmById: {
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    description?: string | null;
    authoredOn: any;
    firstEventTimestamp?: any | null;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    forDeviceName?: string | null;
    forDeviceType?: string | null;
    code?: { text?: string | null } | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      valueString?: string | null;
      templateDisplayName?: string | null;
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      type?: { text?: string | null; coding?: Array<{ system?: any | null; code?: any | null } | null> | null } | null;
      valueReference?: { reference?: string | null; display?: string | null; type?: string | null } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
  };
};

export type GetSyncAlarmByIdQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetSyncAlarmByIdQuery = {
  getTechnicalAlarmById: {
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    description?: string | null;
    authoredOn: any;
    firstEventTimestamp?: any | null;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    syncPending?: boolean | null;
    code?: { text?: string | null } | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      valueString?: string | null;
      templateDisplayName?: string | null;
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      type?: { text?: string | null; coding?: Array<{ system?: any | null; code?: any | null } | null> | null } | null;
      valueReference?: { reference?: string | null; display?: string | null; type?: string | null } | null;
      syncEventDetails?: {
        flowName?: string | null;
        stepName?: string | null;
        flowLogs?: Array<{
          timestamp: string;
          details: string;
          auditLogReferences: Array<{ auditEventId: string; description: string }>;
        }> | null;
      } | null;
    } | null> | null;
    syncAlarmDetails?: { userGroupId?: string | null; entityName?: string | null } | null;
  };
};

export type UpdateTaskAcceptedAtMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  when?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type UpdateTaskAcceptedAtMutation = {
  updateTaskAcceptedAt: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateTaskPresenceAtMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  when?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type UpdateTaskPresenceAtMutation = {
  updateTaskPresenceAt: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateAlarmStatusMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
}>;

export type UpdateAlarmStatusMutation = {
  updateAlarmStatus: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type CompleteAlarmMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  completionInput: CompleteAlarmInput;
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CompleteAlarmMutation = {
  completeAlarm: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateTechnicalAlarmStatusMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpdateTechnicalAlarmStatusMutation = {
  updateTechnicalAlarmStatus: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      message?: string | null;
      valid: boolean;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type AddNotesToAlarmMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>> | InputMaybe<AnnotationInput>>;
}>;

export type AddNotesToAlarmMutation = { addNotesToAlarm: { success: boolean; message?: string | null } };

export type AddNotesToTechnicalAlarmMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>> | InputMaybe<AnnotationInput>>;
}>;

export type AddNotesToTechnicalAlarmMutation = {
  addNotesToTechnicalAlarm: { success: boolean; message?: string | null };
};

export type TriggerResolveActionsForSyncAlarmsMutationVariables = Exact<{
  alarmIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type TriggerResolveActionsForSyncAlarmsMutation = {
  triggerResolveActionsForSyncAlarms: { success: boolean; message?: string | null };
};

export type CancelSkyresponseSyncAlarmMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type CancelSkyresponseSyncAlarmMutation = {
  cancelSkyresponseSyncAlarm: { success: boolean; message?: string | null };
};

export type SimulateSyncEventMutationVariables = Exact<{
  patientId?: InputMaybe<Scalars['ID']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
  eventCode: Scalars['String']['input'];
  payload?: InputMaybe<SimulateSyncEventPayloadInput>;
}>;

export type SimulateSyncEventMutation = { simulateSyncEvent: { success: boolean; message?: string | null } };

export type TriggerEventInCameraMutationVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  profileId: Scalars['Int']['input'];
  appName: Scalars['String']['input'];
}>;

export type TriggerEventInCameraMutation = { triggerEventInCamera: boolean };

export type RemovePatientContactMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
}>;

export type RemovePatientContactMutation = { removePatientContact: { success: boolean } };

export type UpdatePatientContactMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  contact: UpdateContactInput;
}>;

export type UpdatePatientContactMutation = { updatePatientContact: { success: boolean } };

export type PatientContactsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientContactsQuery = {
  patient?: {
    id: string;
    contacts?: {
      patientContacts: Array<{
        id: string;
        name: string;
        availableHours: string;
        priority?: number | null;
        telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
        skyresponseConfig?: { callMethod?: number | null } | null;
      }>;
      groupContacts: Array<{
        id: string;
        name: string;
        availableHours: string;
        priority?: number | null;
        telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
        skyresponseConfig?: { callMethod?: number | null } | null;
      }>;
    } | null;
  } | null;
};

export type OrderPatientContactsMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  orderedContactIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type OrderPatientContactsMutation = { orderPatientContacts: { success: boolean } };

export type OrderUserGroupContactsMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  orderedContactIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type OrderUserGroupContactsMutation = { orderUserGroupContacts: { success: boolean } };

export type RemoveUserGroupContactMutationVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
}>;

export type RemoveUserGroupContactMutation = { removeUserGroupContact: { success: boolean } };

export type UserGroupContactsAndSkyresponseSyncStatusQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupContactsAndSkyresponseSyncStatusQuery = {
  userGroup: {
    id: string;
    contacts?: Array<{
      id: string;
      name: string;
      availableHours: string;
      priority?: number | null;
      telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
      skyresponseConfig?: { callMethod?: number | null } | null;
    }> | null;
    skyresponseSyncStatus?: { status: string; openAlarms?: Array<{ id: string; authoredOn: any }> | null } | null;
  };
};

export type PatientStatsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type PatientStatsQuery = {
  patientStats: { stats: Array<{ timestamp?: any | null; alarms?: number | null; alarmEvents?: number | null }> };
};

export type GetPatientsWithoutAuditLogQueryVariables = Exact<{
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetPatientsWithoutAuditLogQuery = {
  getPatientsWithoutAuditLog: Array<{
    id: string;
    lastSupervisionTimestamp?: any | null;
    lastSupervisionPerformedByUserId?: string | null;
    addressNote?: string | null;
    keyCode?: string | null;
    name?: Array<{ text?: string | null } | null> | null;
    address?: Array<{
      text?: string | null;
      line?: Array<string | null> | null;
      city?: string | null;
      postalCode?: string | null;
    } | null> | null;
    patientGroups?: Array<{ id: string; name?: string | null } | null> | null;
    cameras?: Array<{
      id: string;
      name?: string | null;
      isConfiguredInRegistry?: boolean | null;
      hasOfflineAlarm?: boolean | null;
      userHasAccessToPatient?: boolean | null;
      detailedStatus?: { ttl?: string | null; privacyMode?: boolean | null } | null;
    } | null> | null;
  } | null>;
};

export type GetSkyresponseStatusesForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetSkyresponseStatusesForPatientQuery = {
  getSkyresponseStatusesForPatient?: Array<{
    patientId: string;
    flowName: string;
    status: string;
    timestamp: string;
    logs: Array<{
      timestamp: string;
      details: string;
      auditLogReferences: Array<{ auditEventId: string; description: string }>;
    }>;
  }> | null;
};

export type PatientSyncStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientSyncStatusQuery = {
  patient?: {
    id: string;
    skyresponseSyncStatus?: string | null;
    skyresponseSyncOpenAlarms?: Array<{ id: string; timestamp: string } | null> | null;
  } | null;
};

export type SyncSpecificPatientWithSkyresponseMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type SyncSpecificPatientWithSkyresponseMutation = { syncSpecificPatientWithSkyresponse: { success: boolean } };

export type GetSkyresponseStatusesForUserGroupQueryVariables = Exact<{
  userGroupId: Scalars['ID']['input'];
}>;

export type GetSkyresponseStatusesForUserGroupQuery = {
  getSkyresponseStatusesForUserGroup?: Array<{
    flowName: string;
    status: string;
    timestamp: string;
    logs: Array<{
      timestamp: string;
      details: string;
      auditLogReferences: Array<{ auditEventId: string; description: string }>;
    }>;
  }> | null;
};

export type PatientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientQuery = {
  patient?: {
    id: string;
    active: boolean;
    patientGroups?: Array<{ name: string; id: string } | null> | null;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    identifier: Array<{ value?: string | null; use?: IdentifierUse | null } | null>;
    welfareDevices?: Array<{
      id: string;
      uniqueIdentifier: string;
      modelNumber?: string | null;
      userFriendlyName?: string | null;
      configuration?: { registeredInInventory?: boolean | null } | null;
    }> | null;
    cameras?: Array<{
      id: string;
      name?: string | null;
      modelName?: string | null;
      manufacturer?: string | null;
      macAddress?: string | null;
      availableHours?: string | null;
      isConfiguredInRegistry?: boolean | null;
      hasOfflineAlarm?: boolean | null;
      detailedStatus?: {
        lastSeen?: any | null;
        heartbeatCount?: number | null;
        isAssociatedToPatient?: boolean | null;
        ttl?: number | null;
        privacyMode?: boolean | null;
      } | null;
    } | null> | null;
    journalConfigForPatient?: { remoteSupervision: { enabled: boolean } } | null;
  } | null;
};

export type ActivateAlarmTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ActivateAlarmTemplateMutation = {
  activateAlarmTemplate: {
    success?: boolean | null;
    message?: string | null;
    alarmTemplate?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type CreatePatientInGroupMutationVariables = Exact<{
  patientGroup: Scalars['ID']['input'];
  patientInput: CreatePatientInput;
}>;

export type CreatePatientInGroupMutation = {
  createPatientInGroup?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    patient?: { id: string } | null;
  } | null;
};

export type AddShareSkyresponseAlarmWithPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  shareWithPatientIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;

export type AddShareSkyresponseAlarmWithPatientMutation = {
  addShareSkyresponseAlarmWithPatient?: { success: boolean; message?: string | null } | null;
};

export type CreateAlarmTemplateMutationVariables = Exact<{
  input: AlarmTemplateCreateInput;
}>;

export type CreateAlarmTemplateMutation = {
  createAlarmTemplate: {
    success?: boolean | null;
    message?: string | null;
    alarmTemplate?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type RetireAlarmTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RetireAlarmTemplateMutation = {
  retireAlarmTemplate: {
    success?: boolean | null;
    message?: string | null;
    alarmTemplate?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateAlarmTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AlarmTemplateUpdateInput;
}>;

export type UpdateAlarmTemplateMutation = {
  updateAlarmTemplate: {
    success?: boolean | null;
    message?: string | null;
    alarmTemplate?: { id: string } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type CreateAlarmSubscriptionMutationVariables = Exact<{
  createInput: AlarmSubscriptionCreateInput;
}>;

export type CreateAlarmSubscriptionMutation = {
  createAlarmSubscription?: {
    success?: boolean | null;
    message?: string | null;
    inputValidation?: { valid: boolean; errors?: Array<{ message?: string | null } | null> | null } | null;
    alarmSubscription?: { id: string } | null;
  } | null;
};

export type DeleteAlarmSubscriptionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteAlarmSubscriptionMutation = {
  deleteAlarmSubscription?: { success?: boolean | null; message?: string | null } | null;
};

export type UpdatePatientProfileMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  patientInput: UpdatePatientInput;
}>;

export type UpdatePatientProfileMutation = {
  updatePatient?: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  } | null;
};

export type GetAlarmTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetAlarmTemplateQuery = {
  getAlarmTemplate: {
    id: string;
    status: string;
    alarmIcon?: string | null;
    callbackMinutes?: number | null;
    debounceDelay?: number | null;
    technical?: boolean | null;
    generatesAlarm?: boolean | null;
    locationTraceOnly?: boolean | null;
    forwardingOnly?: boolean | null;
    noCarePlanRequired?: boolean | null;
    resolveAction?: Array<string | null> | null;
    description?: string | null;
    direction?: string | null;
    cep?: { trigger?: Array<string> | null; after?: number | null; cancelledBy?: Array<string> | null } | null;
    tagAction?: Array<{ target?: TagTarget | null; type?: TagActionType | null; label?: string | null } | null> | null;
    vkpEncounter?: { type?: number | null; reason?: number | null } | null;
    identifier: Array<{ value?: string | null } | null>;
    code: {
      text?: string | null;
      coding?: Array<{ display?: string | null; code?: any | null; system?: any | null } | null> | null;
    };
    effectiveTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
    interpretation?: Array<{
      text?: string | null;
      coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
    } | null> | null;
    component?: Array<{
      code: {
        text?: string | null;
        coding?: Array<{ system?: any | null; display?: string | null; code?: any | null } | null> | null;
      };
      extension?: Array<{
        url?: string | null;
        valueBoolean?: boolean | null;
        valueInteger?: number | null;
        valueString?: string | null;
        ValueId?: string | null;
      }> | null;
    } | null> | null;
  };
};

export type HealthProviderSettingsForExternalIdHumanInputQueryVariables = Exact<{ [key: string]: never }>;

export type HealthProviderSettingsForExternalIdHumanInputQuery = {
  healthProviderSettings: {
    userAuth?: {
      twoFactorSms?: boolean | null;
      externalIdP?: Array<{
        alias?: string | null;
        default?: boolean | null;
        displayName?: string | null;
        enabled?: boolean | null;
        support?: boolean | null;
      }> | null;
    } | null;
    patientAuth?: { twoFactorSms?: boolean | null } | null;
    externalHumanIdTypes?: Array<{ id: string }> | null;
  };
};

export type DeleteAscomForwarderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteAscomForwarderMutation = {
  deleteAscomForwarder: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateAscomForwarderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput: UpdateAscomForwarder;
}>;

export type UpdateAscomForwarderMutation = {
  updateAscomForwarder: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type CreateAscomForwarderMutationVariables = Exact<{
  input: CreateAscomForwarder;
}>;

export type CreateAscomForwarderMutation = {
  createAscomForwarder: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type GetAscomForwardersQueryVariables = Exact<{ [key: string]: never }>;

export type GetAscomForwardersQuery = {
  ascomForwarders: Array<{
    id: string;
    primaryUrl?: string | null;
    displayName?: string | null;
    apiKey?: string | null;
    ascomIntegrationId?: string | null;
    heartbeatRate?: number | null;
    active?: boolean | null;
    connectionStatus?: { httpStatus: string; details?: string | null; timestamp?: string | null } | null;
  }>;
};

export type GetAlmaForwardersQueryVariables = Exact<{ [key: string]: never }>;

export type GetAlmaForwardersQuery = {
  almaForwarders: Array<{
    id: string;
    primaryUrl?: string | null;
    displayName?: string | null;
    username?: string | null;
    password?: string | null;
  }>;
};

export type CreateAlmaForwarderMutationVariables = Exact<{
  input: CreateAlmaForwarder;
}>;

export type CreateAlmaForwarderMutation = {
  createAlmaForwarder: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateAlmaForwarderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput: UpdateAlmaForwarder;
}>;

export type UpdateAlmaForwarderMutation = {
  updateAlmaForwarder: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type DeleteAlmaForwarderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteAlmaForwarderMutation = {
  deleteAlmaForwarder: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type GetAllAlarmHistoryQueryVariables = Exact<{
  from: Scalars['dateTime']['input'];
  to: Scalars['dateTime']['input'];
  patientGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type GetAllAlarmHistoryQuery = {
  getAllAlarmHistory: Array<{
    telluAlarmId?: string | null;
    responseCenterAlarmId?: string | null;
    tag: string;
    alarmEvent?: string | null;
    serverAlarmTime?: any | null;
    deactivationTime?: any | null;
    patientId?: string | null;
    alarmHandling?: string | null;
    journalWorkflowStatus?: string | null;
    alarmReason?: string | null;
    acceptedAt?: any | null;
    alarmCode?: string | null;
    priority: string;
    organization?: string | null;
    group?: string | null;
    alarmAction?: string | null;
    timeUntilVisible?: string | null;
    responseCenter?: string | null;
    textMessage?: string | null;
    globalAlarmId?: string | null;
    identifier?: string | null;
    name?: { display?: string | null } | null;
    owner?: { display?: string | null } | null;
    patientName?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
  }>;
};

export type GetAlarmHistoryForPatientQueryVariables = Exact<{
  from: Scalars['dateTime']['input'];
  to: Scalars['dateTime']['input'];
  patientId: Scalars['ID']['input'];
}>;

export type GetAlarmHistoryForPatientQuery = {
  getAlarmHistoryForPatient: Array<{
    telluAlarmId?: string | null;
    responseCenterAlarmId?: string | null;
    tag: string;
    alarmEvent?: string | null;
    serverAlarmTime?: any | null;
    deactivationTime?: any | null;
    patientId?: string | null;
    alarmHandling?: string | null;
    journalWorkflowStatus?: string | null;
    alarmReason?: string | null;
    acceptedAt?: any | null;
    alarmCode?: string | null;
    priority: string;
    organization?: string | null;
    group?: string | null;
    alarmAction?: string | null;
    timeUntilVisible?: string | null;
    responseCenter?: string | null;
    textMessage?: string | null;
    identifier?: string | null;
    globalAlarmId?: string | null;
    name?: { display?: string | null } | null;
    owner?: { display?: string | null } | null;
    patientName?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
  }>;
};

export type UserGroupForAlarmHistoryQueryVariables = Exact<{
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupForAlarmHistoryQuery = {
  userGroup: {
    id: string;
    name: string;
    skyresponse?: {
      enabled?: boolean | null;
      organizationId?: string | null;
      hasSkyresponseExternalId?: boolean | null;
      hasSkyresponseCredentials?: boolean | null;
    } | null;
  };
};

export type GetAlarmHistoryDetailByIdQueryVariables = Exact<{
  telluAlarmId?: InputMaybe<Scalars['ID']['input']>;
  skyresponseAlarmId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetAlarmHistoryDetailByIdQuery = {
  getAlarmHistoryDetailById: {
    skyresponseAlarmDetail?: {
      id: string;
      userId: string;
      name: string;
      messages?: Array<string> | null;
      serverAlarmTime: string;
      deactivationTime?: string | null;
      responseCenter: string;
      globalAlarmId: string;
      reason?: string | null;
      identifier?: string | null;
      action?: string | null;
      acceptedAt?: string | null;
      textMessage?: string | null;
      alarmCode: number;
      logs?: Array<{ created: string; type: number; subType: number; text: string; name: string }> | null;
    } | null;
    telluAlarmDetail?: {
      id: string;
      description?: string | null;
      priority?: string | null;
      authoredOn: any;
      acceptedAt?: any | null;
      presentAt?: any | null;
      completedAt?: any | null;
      input?: Array<{
        icon?: string | null;
        priority?: string | null;
        timestamp?: string | null;
        values: Array<{
          name: string;
          valueString?: string | null;
          valueBoolean?: boolean | null;
          valueNumber?: number | null;
        }>;
        valueReference?: { reference?: string | null } | null;
        type?: {
          text?: string | null;
          coding?: Array<{ system?: any | null; code?: any | null } | null> | null;
        } | null;
      } | null> | null;
      priorityInput?: {
        timestamp?: string | null;
        icon?: string | null;
        priority?: string | null;
        templateCode?: string | null;
        templateDisplayName?: string | null;
      } | null;
      patient?: {
        id: string;
        name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
        patientGroups?: Array<{ id: string; name: string } | null> | null;
      } | null;
      for: { display?: string | null };
      note?: Array<{
        authorString?: string | null;
        time?: any | null;
        text?: string | null;
        authorReference?: { display?: string | null } | null;
      } | null> | null;
      journalWorkflow?: Array<{
        type: string;
        status: string;
        userGroupId?: string | null;
        retriedAt?: Array<any | null> | null;
        nextRetry?: any | null;
        completedAt?: any | null;
        freeTextNote?: string | null;
        completionOptions?: Array<string> | null;
        debugDetails?: string | null;
      }> | null;
    } | null;
  };
};

export type GetAlarmHistoryForResponseOperatorQueryVariables = Exact<{
  sessionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  onlyClosedByResponseOperator?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetAlarmHistoryForResponseOperatorQuery = {
  getAlarmHistoryForResponseOperator: Array<{
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    acceptedAt?: any | null;
    presentAt?: any | null;
    completedAt?: any | null;
    description?: string | null;
    authoredOn: any;
    firstEventTimestamp?: any | null;
    code?: { text?: string | null } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
      valueReference?: { reference?: string | null } | null;
    } | null;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    input?: Array<{
      timestamp?: string | null;
      priority?: string | null;
      icon?: string | null;
      valueReference?: { reference?: string | null } | null;
      values: Array<{
        name: string;
        valueString?: string | null;
        valueBoolean?: boolean | null;
        valueNumber?: number | null;
      }>;
      type?: { text?: string | null; coding?: Array<{ code?: any | null } | null> | null } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
    locationTraces?: Array<{
      forDeviceId: string;
      gpsLocations: Array<{
        description?: string | null;
        gpsTimestamp?: any | null;
        receivedTimestamp?: any | null;
        position?: { longitude: number; latitude: number; altitude?: number | null } | null;
        address?: {
          use?: AddressUse | null;
          line?: Array<string | null> | null;
          city?: string | null;
          postalCode?: string | null;
          country?: string | null;
          text?: string | null;
        } | null;
      }>;
      latestGpsLocation?: {
        description?: string | null;
        gpsTimestamp?: any | null;
        receivedTimestamp?: any | null;
        position?: { longitude: number; latitude: number; altitude?: number | null } | null;
        address?: {
          use?: AddressUse | null;
          line?: Array<string | null> | null;
          city?: string | null;
          postalCode?: string | null;
          country?: string | null;
          text?: string | null;
        } | null;
      } | null;
    }> | null;
    journalWorkflow?: Array<{
      type: string;
      status: string;
      userGroupId?: string | null;
      retriedAt?: Array<any | null> | null;
      nextRetry?: any | null;
      completedAt?: any | null;
      freeTextNote?: string | null;
      completionOptions?: Array<string> | null;
      debugDetails?: string | null;
    }> | null;
    patient?: {
      id: string;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null;
      patientGroups?: Array<{
        id: string;
        name: string;
        enableDistanceEstimation: boolean;
        enableOnSiteRegistration: boolean;
      } | null> | null;
      address?: Array<{
        line?: Array<string | null> | null;
        postalCode?: string | null;
        city?: string | null;
        country?: string | null;
        text?: string | null;
      } | null> | null;
      photo?: Array<{ url?: string | null } | null> | null;
      skyresponseDetails?: {
        enabled?: boolean | null;
        organizationId?: string | null;
        hasSkyresponseExternalId?: boolean | null;
        hasSkyresponseCredentials?: boolean | null;
      } | null;
    } | null;
  }>;
};

export type CmpAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type CmpAccountsQuery = {
  cmpAccounts?: Array<{ id: string; clientId: string; clientSecret: string; customerGroup?: string | null }> | null;
};

export type ValidateCustomerGroupTowardsCmpMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ValidateCustomerGroupTowardsCmpMutation = {
  validateCustomerGroupTowardsCmp: {
    success: boolean;
    message?: string | null;
    device?: string | null;
    totalDevices?: number | null;
  };
};

export type DeleteCmpAccountMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteCmpAccountMutation = { deleteCmpAccount: { success: boolean; message?: string | null } };

export type ValidateCmpAccountTowardsCmpMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type ValidateCmpAccountTowardsCmpMutation = {
  validateCmpAccountTowardsCmp: { success: boolean; message?: string | null };
};

export type CreateCmpAccountMutationVariables = Exact<{
  input: CmpAccountCreateInput;
}>;

export type CreateCmpAccountMutation = {
  createCmpAccount: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateCmpAccountMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: CmpAccountUpdateInput;
}>;

export type UpdateCmpAccountMutation = {
  updateCmpAccount: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type GetPatientCmpDevicesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetPatientCmpDevicesQuery = {
  getPatientCmpDevices?: Array<{
    id: string;
    alarmCode?: string | null;
    groupName?: string | null;
    url?: string | null;
    portalConnection?: { name?: string | null; value?: number | null; time?: any | null } | null;
    batteryStatus?: { name?: string | null; value?: number | null; time?: any | null } | null;
    powerSupply?: { name?: string | null; value?: number | null; time?: any | null } | null;
    operationalStatus?: { name?: string | null; value?: number | null } | null;
    children?: Array<{
      radioIdCode?: string | null;
      activeTimeSpan?: { hasTimeSpan?: boolean | null; timeSpan?: string | null } | null;
      equipmentType?: { name?: string | null; value?: number | null } | null;
      locationCode?: { name?: string | null; value?: number | null } | null;
      batteryStatus?: { name?: string | null; value?: number | null } | null;
      supervisionStatus?: { name?: string | null; value?: number | null; time?: any | null } | null;
    }> | null;
  }> | null;
};

export type GetAllAlarmSubscriptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllAlarmSubscriptionsQuery = {
  getAllAlarmSubscriptions: Array<{
    id: string;
    userId: string;
    type: string;
    targetEmails?: Array<string> | null;
    targetPhoneNumbers?: Array<string> | null;
    deviceGroupIds?: Array<string> | null;
    patientGroupIds?: Array<string> | null;
  }>;
};

export type GetAllUsersAlarmSubscriptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllUsersAlarmSubscriptionsQuery = {
  getAllUsersAlarmSubscriptions: Array<{
    id: string;
    userId: string;
    type: string;
    targetEmails?: Array<string> | null;
    targetPhoneNumbers?: Array<string> | null;
    deviceGroupIds?: Array<string> | null;
    patientGroupIds?: Array<string> | null;
  }>;
};

export type GetCameraAdminUrlQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;

export type GetCameraAdminUrlQuery = { getCameraAdmin: { adminUrl?: string | null } };

export type GetExternalUrlForWelfareDeviceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetExternalUrlForWelfareDeviceQuery = { getExternalUrlForWelfareDevice?: string | null };

export type GetNextOfKinQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetNextOfKinQuery = {
  getNextOfKin: Array<{
    id: string;
    notifyNextOfKin?: boolean | null;
    name?: Array<{ text?: string | null }> | null;
    telecom?: Array<{ value?: string | null }> | null;
  }>;
};

export type PatientForViewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientForViewQuery = {
  patient?: {
    id: string;
    active: boolean;
    birthDate?: any | null;
    gender?: AdministrativeGender | null;
    secretAddress?: boolean | null;
    addressNote?: string | null;
    keyCode?: string | null;
    tags?: Array<string | null> | null;
    note?: string | null;
    externalPatientIds?: Array<{
      externalId: string;
      externalHumanIdType: { id: string; use: { patientUse?: { immutable?: boolean | null } | null } };
    }> | null;
    userReservations?: Array<{ userId: string; firstName?: string | null; lastName?: string | null } | null> | null;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    languages?: Array<{ language: string; preferred: boolean }> | null;
    identifier: Array<{ value?: string | null; use?: IdentifierUse | null } | null>;
    telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
    skyresponseDetails?: {
      organizationId?: string | null;
      hasSkyresponseExternalId?: boolean | null;
      hasSkyresponseCredentials?: boolean | null;
    } | null;
    address?: Array<{
      line?: Array<string | null> | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      text?: string | null;
    } | null> | null;
    photo?: Array<{ url?: string | null } | null> | null;
    patientGroups?: Array<{ name: string; id: string } | null> | null;
    notification?: { inactiveDays?: number | null; inactiveDaysSetBy?: string | null } | null;
    documents?: Array<{
      id: string;
      content?: Array<{
        attachment?: {
          title?: string | null;
          contentType?: string | null;
          url?: string | null;
          size?: number | null;
          creation?: any | null;
        } | null;
      } | null> | null;
      context?: { carePlan?: { id: string; title?: string | null } | null } | null;
    } | null> | null;
    carePlans?: Array<{
      id: string;
      status: CarePlanStatus;
      title?: string | null;
      description?: string | null;
      created?: any | null;
      subject: { reference?: string | null };
      period?: { start?: any | null; end?: any | null } | null;
      activity: Array<{
        detail: {
          instantiatesCanonical?: Array<string | null> | null;
          status: string;
          questionnaires?: Array<{ title?: string | null } | null> | null;
          scheduledTiming?: {
            repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null;
          } | null;
          scheduledPeriod?: { start?: any | null; end?: any | null } | null;
        };
      } | null>;
    } | null> | null;
    rpmMedicalDevices?: Array<{
      id: string;
      btAddress?: string | null;
      isDeviceBtPaired?: boolean | null;
      manufacturer?: string | null;
      modelName?: string | null;
      modelNumber?: string | null;
      sensorType?: string | null;
      serialNumber?: string | null;
      status?: string | null;
      deviceGroup?: { id: string; name?: string | null } | null;
      deviceName?: Array<{ name?: string | null; type: string }> | null;
      identifier?: Array<{ value?: string | null }> | null;
      patient?: { reference?: string | null } | null;
    }> | null;
    welfareDevices?: Array<{
      id: string;
      uniqueIdentifier: string;
      modelNumber?: string | null;
      status?: { connected?: boolean | null; lastSeen?: any | null } | null;
      patient?: { reference?: string | null } | null;
    }> | null;
    rpmGateways?: Array<{
      id: string;
      modelNumber?: string | null;
      gatewayHostname: string;
      identifier?: Array<{ value?: string | null }> | null;
      children?: Array<{
        id: string;
        btAddress?: string | null;
        modelNumber?: string | null;
        modelName?: string | null;
        serialNumber?: string | null;
        manufacturer?: string | null;
        status?: string | null;
        sensorType?: string | null;
        isDeviceBtPaired?: boolean | null;
        batteryLevel?: number | null;
      }> | null;
      gatewayStatus?: {
        connected?: boolean | null;
        lastSeen?: any | null;
        lastMeasurements?: Array<{ type?: string | null; time?: any | null }> | null;
        lastStatus?: {
          version?: string | null;
          ble_service_running?: number | null;
          cputemp?: number | null;
          uptime?: number | null;
        } | null;
      } | null;
      patient?: { reference?: string | null } | null;
    }> | null;
    dialoggUser?: {
      username: string;
      enabled?: boolean | null;
      onBehalf?: { accessiblePatients?: Array<string> | null } | null;
    } | null;
    referenceRange?: Array<{
      id: string;
      code?: {
        text?: string | null;
        coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
      } | null;
      identifier?: Array<{ value?: string | null } | null> | null;
      fromTemplate?: { reference?: string | null } | null;
      component?: Array<{
        code: { text?: string | null; coding?: Array<{ code?: any | null; display?: string | null } | null> | null };
        valueQuantity?: { unit?: string | null; value?: number | null } | null;
        referenceRange?: Array<{
          text?: string | null;
          low?: { unit?: string | null; value?: number | null } | null;
          high?: { unit?: string | null; value?: number | null } | null;
          type?: {
            text?: string | null;
            coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ExternalPatientIdsFragment = {
  externalId: string;
  externalHumanIdType: { id: string; use: { patientUse?: { immutable?: boolean | null } | null } };
};

export type AddressFragment = {
  line?: Array<string | null> | null;
  postalCode?: string | null;
  city?: string | null;
  country?: string | null;
  text?: string | null;
};

export type PatientGroupsFragment = { name: string; id: string };

export type NotificationFragment = { inactiveDays?: number | null; inactiveDaysSetBy?: string | null };

export type DocumentsFragment = {
  id: string;
  content?: Array<{
    attachment?: {
      title?: string | null;
      contentType?: string | null;
      url?: string | null;
      size?: number | null;
      creation?: any | null;
    } | null;
  } | null> | null;
  context?: { carePlan?: { id: string; title?: string | null } | null } | null;
};

export type CarePlansFragment = {
  id: string;
  status: CarePlanStatus;
  title?: string | null;
  description?: string | null;
  created?: any | null;
  subject: { reference?: string | null };
  period?: { start?: any | null; end?: any | null } | null;
  activity: Array<{
    detail: {
      instantiatesCanonical?: Array<string | null> | null;
      status: string;
      questionnaires?: Array<{ title?: string | null } | null> | null;
      scheduledTiming?: { repeat?: { dayOfWeek?: Array<DayOfWeek> | null; timeOfDay: Array<string> } | null } | null;
      scheduledPeriod?: { start?: any | null; end?: any | null } | null;
    };
  } | null>;
};

export type RpmMedicalDevicesFragment = {
  id: string;
  btAddress?: string | null;
  isDeviceBtPaired?: boolean | null;
  manufacturer?: string | null;
  modelName?: string | null;
  modelNumber?: string | null;
  sensorType?: string | null;
  serialNumber?: string | null;
  status?: string | null;
  deviceGroup?: { id: string; name?: string | null } | null;
  deviceName?: Array<{ name?: string | null; type: string }> | null;
  identifier?: Array<{ value?: string | null }> | null;
  patient?: { reference?: string | null } | null;
};

export type RpmGatewaysFragment = {
  id: string;
  modelNumber?: string | null;
  gatewayHostname: string;
  identifier?: Array<{ value?: string | null }> | null;
  children?: Array<{
    id: string;
    btAddress?: string | null;
    modelNumber?: string | null;
    modelName?: string | null;
    serialNumber?: string | null;
    manufacturer?: string | null;
    status?: string | null;
    sensorType?: string | null;
    isDeviceBtPaired?: boolean | null;
    batteryLevel?: number | null;
  }> | null;
  gatewayStatus?: {
    connected?: boolean | null;
    lastSeen?: any | null;
    lastMeasurements?: Array<{ type?: string | null; time?: any | null }> | null;
    lastStatus?: {
      version?: string | null;
      ble_service_running?: number | null;
      cputemp?: number | null;
      uptime?: number | null;
    } | null;
  } | null;
  patient?: { reference?: string | null } | null;
};

export type WelfareDevicesFragment = {
  id: string;
  uniqueIdentifier: string;
  modelNumber?: string | null;
  status?: { connected?: boolean | null; lastSeen?: any | null } | null;
  patient?: { reference?: string | null } | null;
};

export type DialoggUserFragment = {
  username: string;
  enabled?: boolean | null;
  onBehalf?: { accessiblePatients?: Array<string> | null } | null;
};

export type ReferenceRangeFragment = {
  id: string;
  code?: { text?: string | null; coding?: Array<{ code?: any | null; display?: string | null } | null> | null } | null;
  identifier?: Array<{ value?: string | null } | null> | null;
  fromTemplate?: { reference?: string | null } | null;
  component?: Array<{
    code: { text?: string | null; coding?: Array<{ code?: any | null; display?: string | null } | null> | null };
    valueQuantity?: { unit?: string | null; value?: number | null } | null;
    referenceRange?: Array<{
      text?: string | null;
      low?: { unit?: string | null; value?: number | null } | null;
      high?: { unit?: string | null; value?: number | null } | null;
      type?: {
        text?: string | null;
        coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type PatientForSharedAlarmsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientForSharedAlarmsQuery = {
  patient?: {
    id: string;
    shareAlarmWith?: Array<{
      id: string;
      name?: string | null;
      norwegianId?: string | null;
      isPrimary?: boolean | null;
    }> | null;
  } | null;
};

export type GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetSharedSkyResponseAlarmsPatientCandidatesQuery = {
  getSharedSkyResponseAlarmsPatientCandidates: Array<{
    id: string;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    externalPatientIds?: Array<{ type: string; id: string }> | null;
  } | null>;
};

export type RetryAlarmJournalingMutationVariables = Exact<{
  alarmId: Scalars['ID']['input'];
}>;

export type RetryAlarmJournalingMutation = { retryAlarmJournaling: { success: boolean; message?: string | null } };

export type BadgesQueryVariables = Exact<{ [key: string]: never }>;

export type BadgesQuery = { badges: { technicalAlarms: number; syncAlarms: number } };

export type GetDistanceToPositionsQueryVariables = Exact<{
  origins: Array<GpsPositionOrStringInput> | GpsPositionOrStringInput;
  destinations: Array<GpsPositionOrStringInput> | GpsPositionOrStringInput;
}>;

export type GetDistanceToPositionsQuery = {
  getDistanceToPositions: {
    status: string;
    rows?: Array<{
      elements: Array<{
        status: string;
        duration?: { value: number; text: string } | null;
        durationInTraffic?: { value: number; text: string } | null;
        distance?: { value: number; text: string } | null;
      }>;
    }> | null;
  };
};

export type GetAllPatientAlarmsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
}>;

export type GetAllPatientAlarmsQuery = {
  getAllPatientAlarms: Array<{
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    description?: string | null;
    lastModified: any;
    for: { reference?: string | null };
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      valueString?: string | null;
      timestamp?: string | null;
      type?: { text?: string | null } | null;
      valueReference?: {
        reference?: string | null;
        type?: string | null;
        display?: string | null;
        identifier?: { value?: string | null } | null;
      } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
    patient?: {
      id: string;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null }> | null;
      address?: Array<{
        line?: Array<string | null> | null;
        postalCode?: string | null;
        city?: string | null;
        country?: string | null;
        text?: string | null;
      } | null> | null;
      telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
      photo?: Array<{ url?: string | null } | null> | null;
    } | null;
  }>;
};

export type GetDeviceByIdForTechnicalAlarmQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetDeviceByIdForTechnicalAlarmQuery = {
  getWelfareDevice?: { id: string; modelNumber?: string | null } | null;
};

export type CreateCameraMutationVariables = Exact<{
  createInput: CreateCameraInput;
}>;

export type CreateCameraMutation = {
  createCamera: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type UpdateCameraMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateInput: UpdateCameraInput;
}>;

export type UpdateCameraMutation = {
  updateCamera: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type GetDeviceGroupExternalUrlQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetDeviceGroupExternalUrlQuery = { getDeviceGroupExternalUrl?: string | null };

export type UserGroupForCmpQueryVariables = Exact<{
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupForCmpQuery = {
  userGroup: {
    name: string;
    deviceGroups?: Array<{ id: string; name?: string | null } | null> | null;
    subTree?: Array<{
      name: string;
      deviceGroups?: Array<{ id: string; name?: string | null } | null> | null;
    } | null> | null;
  };
};

export type GetDeviceByIdForSimulatorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetDeviceByIdForSimulatorQuery = {
  getWelfareDevice?: {
    id: string;
    uniqueIdentifier: string;
    modelNumber?: string | null;
    tags?: Array<string> | null;
    deviceName?: Array<{ name?: string | null }> | null;
    deviceGroup?: { name?: string | null; id: string } | null;
  } | null;
};

export type GetAvailableDevicesInSafemateProQueryVariables = Exact<{ [key: string]: never }>;

export type GetAvailableDevicesInSafemateProQuery = {
  getAvailableDevicesInSafematePro: {
    hasSafemateIntegration: boolean;
    safemateDevices: Array<{
      serial?: string | null;
      name?: string | null;
      status?: number | null;
      lastMessageFromDevice?: any | null;
      customerName?: string | null;
      isInRegistry: boolean;
      isInWrongHealthProvider: boolean;
      healthProviderName?: string | null;
    }>;
  };
};

export type ImportDevicesFromSafemateProMutationVariables = Exact<{
  createInput: ImportDevicesInput;
}>;

export type ImportDevicesFromSafemateProMutation = {
  importDevicesFromSafematePro: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    devices: Array<{ id: string }>;
  };
};

export type GetListOfUnallocatedCamerasQueryVariables = Exact<{ [key: string]: never }>;

export type GetListOfUnallocatedCamerasQuery = {
  getListOfUnallocatedCameras: Array<{
    id: string;
    name: string;
    macAddress: string;
    active?: boolean | null;
    modelName?: string | null;
  }>;
};

export type AddCameraToPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  cameraId: Scalars['ID']['input'];
}>;

export type AddCameraToPatientMutation = { addCameraToPatient: { success: boolean } };

export type UpdateAvailableHoursMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  cameraId: Scalars['ID']['input'];
  availableHours: Scalars['String']['input'];
}>;

export type UpdateAvailableHoursMutation = { updateAvailableHours: { success: boolean } };

export type RemoveCameraFromPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  cameraId: Scalars['ID']['input'];
}>;

export type RemoveCameraFromPatientMutation = { removeCameraFromPatient: { success: boolean } };

export type RequestSinglePatientUrlQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  externalAccessId: Scalars['ID']['input'];
}>;

export type RequestSinglePatientUrlQuery = { requestSinglePatientUrl?: string | null };

export type UpdatePatientNoteMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  patientInput: UpdatePatientInput;
}>;

export type UpdatePatientNoteMutation = { updatePatient?: { success: boolean } | null };

export type PatientForPatientDashboardQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type PatientForPatientDashboardQuery = {
  patient?: {
    id: string;
    active: boolean;
    birthDate?: any | null;
    addressNote?: string | null;
    keyCode?: string | null;
    gender?: AdministrativeGender | null;
    note?: string | null;
    isAlarmHandlingPlanActive?: boolean | null;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    externalPatientIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
    identifier: Array<{ value?: string | null; use?: IdentifierUse | null } | null>;
    languages?: Array<{ language: string; preferred: boolean }> | null;
    telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
    address?: Array<{
      line?: Array<string | null> | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      text?: string | null;
    } | null> | null;
    patientGroups?: Array<{ id: string; name: string } | null> | null;
    alarmRoutes?: Array<{
      configName: string;
      configType: string;
      idMappingStrategy: string;
      incomingTemplate: {
        isPresentInAccount?: boolean | null;
        code: string;
        title: string;
        system: string;
        displayText?: string | null;
        icon?: string | null;
      };
      outgoingTemplate: {
        isPresentInAccount?: boolean | null;
        code: string;
        title: string;
        system: string;
        displayText?: string | null;
        icon?: string | null;
      };
    }> | null;
    welfareDevices?: Array<{
      id: string;
      uniqueIdentifier: string;
      modelNumber?: string | null;
      userFriendlyName?: string | null;
    }> | null;
    cameras?: Array<{
      id: string;
      name?: string | null;
      modelName?: string | null;
      manufacturer?: string | null;
      macAddress?: string | null;
      availableHours?: string | null;
      isConfiguredInRegistry?: boolean | null;
      hasOfflineAlarm?: boolean | null;
      detailedStatus?: {
        lastSeen?: any | null;
        heartbeatCount?: number | null;
        isAssociatedToPatient?: boolean | null;
        ttl?: number | null;
        privacyMode?: boolean | null;
        privacyModeUntil?: any | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetAllExternalAccessForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetAllExternalAccessForPatientQuery = {
  getAllExternalAccessForPatient: Array<{ id: string; name: string }>;
};

export type RemoveWelfareDeviceFromPatientMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  welfareDeviceId: Scalars['ID']['input'];
}>;

export type RemoveWelfareDeviceFromPatientMutation = { removeWelfareDeviceFromPatient: { success: boolean } };

export type DeleteNextOfKinMutationVariables = Exact<{
  nokId: Scalars['ID']['input'];
}>;

export type DeleteNextOfKinMutation = { deleteNextOfKin: { success: boolean; message?: string | null } };

export type GetPatientNextOfKinQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetPatientNextOfKinQuery = {
  getNextOfKin: Array<{
    id: string;
    notifyNextOfKin?: boolean | null;
    active: boolean;
    isMain: boolean;
    relationship?: string | null;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
    address?: Array<{
      line?: Array<string | null> | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      text?: string | null;
    }> | null;
  }>;
};

export type AddNextOfKinMutationVariables = Exact<{
  patientId: Scalars['ID']['input'];
  nextOfKinInput: CreateNextOfKinInput;
}>;

export type AddNextOfKinMutation = {
  addNextOfKin: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    nextOfKin?: { id: string } | null;
  };
};

export type UpdateNextOfKinMutationVariables = Exact<{
  nokId: Scalars['ID']['input'];
  nextOfKinInput: UpdateNextOfKinInput;
}>;

export type UpdateNextOfKinMutation = {
  updateNextOfKin: {
    success: boolean;
    message?: string | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
    nextOfKin?: { id: string } | null;
  };
};

export type GetNextOfKinByIdQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  nokId: Scalars['ID']['input'];
}>;

export type GetNextOfKinByIdQuery = {
  getNextOfKinById: {
    id: string;
    notifyNextOfKin?: boolean | null;
    active: boolean;
    isMain: boolean;
    relationship?: string | null;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null }> | null;
    address?: Array<{
      line?: Array<string | null> | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      text?: string | null;
    }> | null;
  };
};

export type GetNumberOfAccessiblePatientsQueryVariables = Exact<{ [key: string]: never }>;

export type GetNumberOfAccessiblePatientsQuery = { getNumberOfAccessiblePatients: number };

export type PatientForSimpleViewQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type PatientForSimpleViewQuery = {
  patient?: {
    id: string;
    active: boolean;
    birthDate?: any | null;
    addressNote?: string | null;
    keyCode?: string | null;
    note?: string | null;
    isAlarmHandlingPlanActive?: boolean | null;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    identifier: Array<{ value?: string | null; use?: IdentifierUse | null } | null>;
    photo?: Array<{ url?: string | null } | null> | null;
    address?: Array<{
      line?: Array<string | null> | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      text?: string | null;
    } | null> | null;
    patientGroups?: Array<{ id: string; name: string } | null> | null;
    telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
    cameras?: Array<{
      id: string;
      name?: string | null;
      isConfiguredInRegistry?: boolean | null;
      detailedStatus?: { privacyMode?: boolean | null; privacyModeUntil?: any | null } | null;
    } | null> | null;
  } | null;
};

export type GetAllPatientAlarmsForPatientQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type GetAllPatientAlarmsForPatientQuery = {
  getAllPatientAlarmsForPatient: Array<{
    id: string;
    status: string;
    intent?: string | null;
    priority?: string | null;
    description?: string | null;
    authoredOn: any;
    code?: { text?: string | null } | null;
    for: { reference?: string | null };
    subTasks?: Array<{ id: string } | null> | null;
    owner?: {
      reference?: string | null;
      display?: string | null;
      identifier?: { value?: string | null } | null;
    } | null;
    priorityInput?: {
      timestamp?: string | null;
      icon?: string | null;
      priority?: string | null;
      templateCode?: string | null;
      templateDisplayName?: string | null;
    } | null;
    input?: Array<{
      icon?: string | null;
      priority?: string | null;
      timestamp?: string | null;
      valueReference?: { reference?: string | null } | null;
      type?: { text?: string | null } | null;
    } | null> | null;
    note?: Array<{ authorString?: string | null; time?: any | null; text?: string | null } | null> | null;
  }>;
};

export type PatientWithCamerasQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientWithCamerasQuery = {
  patient?: {
    id: string;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    identifier: Array<{ value?: string | null; use?: IdentifierUse | null } | null>;
    welfareDevices?: Array<{
      id: string;
      uniqueIdentifier: string;
      modelNumber?: string | null;
      userFriendlyName?: string | null;
      configuration?: { hasExternalUrl?: boolean | null; registeredInInventory?: boolean | null } | null;
    }> | null;
    cameras?: Array<{
      id: string;
      name?: string | null;
      modelName?: string | null;
      manufacturer?: string | null;
      macAddress?: string | null;
      availableHours?: string | null;
      isConfiguredInRegistry?: boolean | null;
      hasOfflineAlarm?: boolean | null;
      userHasAccessToPatient?: boolean | null;
      detailedStatus?: {
        lastSeen?: any | null;
        heartbeatCount?: number | null;
        isAssociatedToPatient?: boolean | null;
        ttl?: number | null;
        privacyMode?: boolean | null;
        privacyModeUntil?: any | null;
      } | null;
      anonymization?: { supports?: boolean | null; requirement?: boolean | null } | null;
      deviceGroup?: { name?: string | null; id: string } | null;
      patientReference?: { reference?: string | null } | null;
    } | null> | null;
  } | null;
};

export type PatientWithWelfareDevicesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientWithWelfareDevicesQuery = {
  patient?: {
    id: string;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    identifier: Array<{ value?: string | null; use?: IdentifierUse | null } | null>;
    patientGroups?: Array<{ id: string; name: string } | null> | null;
    welfareDevices?: Array<{
      id: string;
      uniqueIdentifier: string;
      tags?: Array<string> | null;
      modelNumber?: string | null;
      userFriendlyName?: string | null;
      deviceGroup?: { name?: string | null; id: string } | null;
      deviceName?: Array<{ name?: string | null }> | null;
      configuration?: { hasExternalUrl?: boolean | null; registeredInInventory?: boolean | null } | null;
      status?: { lastSeen?: any | null; lastBatteryStatus?: number | null; lastBatteryTimestamp?: any | null } | null;
    }> | null;
    skyresponseDetails?: {
      enabled?: boolean | null;
      organizationId?: string | null;
      hasSkyresponseExternalId?: boolean | null;
      hasSkyresponseCredentials?: boolean | null;
    } | null;
  } | null;
};

export type PatientListQueryVariables = Exact<{
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type PatientListQuery = {
  patientList: Array<{
    id: string;
    createdAt: any;
    tags?: Array<string> | null;
    openSyncAlarmId?: string | null;
    active: boolean;
    firstName?: string | null;
    lastName?: string | null;
    patientGroupNames: Array<string>;
    location?: string | null;
    secretAddress: boolean;
    rpmLastActive?: any | null;
    externalIds: Array<{ type: string; id: string }>;
    shareAlarmWithPatients?: Array<{ isPrimary: boolean; id: string; name?: string | null }> | null;
    devices: Array<{ name: string; type: string; deviceType?: string | null; isSharedDevice?: boolean | null }>;
    primaryAddress?: {
      addressLine?: string | null;
      postalCode?: string | null;
      city?: string | null;
      room?: string | null;
    } | null;
  }>;
};

export type PatientsByActivityQueryVariables = Exact<{
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type PatientsByActivityQuery = {
  patients: Array<{
    id: string;
    active: boolean;
    isAlarmHandlingPlanActive?: boolean | null;
    gender?: AdministrativeGender | null;
    birthDate?: any | null;
    addressNote?: string | null;
    keyCode?: string | null;
    tags?: Array<string | null> | null;
    hasSkyresponseSyncFailed?: boolean | null;
    externalPatientIds?: Array<{ externalId: string; externalHumanIdType: { id: string } }> | null;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
    telecom?: Array<{ system?: ContactPointSystem | null; value?: string | null } | null> | null;
    address?: Array<{
      line?: Array<string | null> | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      text?: string | null;
    } | null> | null;
    patientGroups?: Array<{ id: string; name: string } | null> | null;
    cameras?: Array<{
      modelName?: string | null;
      manufacturer?: string | null;
      id: string;
      name?: string | null;
    } | null> | null;
    welfareDevices?: Array<{
      id: string;
      uniqueIdentifier: string;
      modelNumber?: string | null;
      deviceName?: Array<{ name?: string | null }> | null;
    }> | null;
  }>;
};

export type ExportFhirPatientBundleQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
}>;

export type ExportFhirPatientBundleQuery = { exportFhirPatientBundle: { bundle: string } };

export type HealthProviderSettingsWithExternalHumanIdTypesQueryVariables = Exact<{ [key: string]: never }>;

export type HealthProviderSettingsWithExternalHumanIdTypesQuery = {
  healthProviderSettings: { externalHumanIdTypes?: Array<{ id: string }> | null };
};

export type GetPatientByExternalIdQueryVariables = Exact<{
  externalPatientId: Scalars['String']['input'];
  externalHumanIdTypeId: Scalars['String']['input'];
}>;

export type GetPatientByExternalIdQuery = {
  getPatientByExternalId: {
    success?: boolean | null;
    found?: boolean | null;
    patient?: {
      id?: string | null;
      identityNumber?: string | null;
      active: boolean;
      gender?: AdministrativeGender | null;
      birthDate?: any | null;
      addressNote?: string | null;
      keyCode?: string | null;
      name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
      telecom: Array<{ system?: ContactPointSystem | null; value?: string | null } | null>;
      address: Array<{
        line?: Array<string | null> | null;
        postalCode?: string | null;
        city?: string | null;
        country?: string | null;
        text?: string | null;
      } | null>;
      patientGroups?: Array<{ id: string; name: string } | null> | null;
    } | null;
    inputValidation?: {
      valid: boolean;
      message?: string | null;
      errors?: Array<{ path?: string | null; message?: string | null } | null> | null;
    } | null;
  };
};

export type PatientNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PatientNameQuery = {
  patient?: {
    id: string;
    name?: Array<{ given?: Array<string | null> | null; family?: string | null; text?: string | null }> | null;
  } | null;
};

export type GetAllAlarmEventsForPatientPaginatedQueryVariables = Exact<{
  patientId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['dateTime']['input']>;
  to?: InputMaybe<Scalars['dateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['cursor']['input']>;
}>;

export type GetAllAlarmEventsForPatientPaginatedQuery = {
  getAllAlarmEventsForPatientPaginated: {
    cursor?: any | null;
    events: Array<{
      effectiveDateTime?: any | null;
      id: string;
      status: string;
      code?: {
        text?: string | null;
        coding?: Array<{ code?: any | null; display?: string | null } | null> | null;
      } | null;
      handlingStatuses: Array<{
        handler: string;
        initiatedAt: any;
        attempts: Array<{
          startedAt: any;
          doneAt: any;
          status: string;
          handledBy?: Array<string> | null;
          payload?: string | null;
          rawResponse?: string | null;
          rawStatus?: string | null;
          details?: string | null;
        }>;
      }>;
      component?: Array<{ valueString?: string | null; code: { text?: string | null } } | null> | null;
    }>;
  };
};

export type OpenPatientGroupsForExternalAccessMutationVariables = Exact<{
  input: UpdateExternalAccessInput;
}>;

export type OpenPatientGroupsForExternalAccessMutation = {
  openPatientGroupsForExternalAccess?: { success: boolean } | null;
};

export type UserGroupForExternalAccessQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UserGroupForExternalAccessQuery = {
  userGroup: {
    id: string;
    name: string;
    parentId?: string | null;
    protected?: boolean | null;
    subTree?: Array<{
      id: string;
      name: string;
      parentId?: string | null;
      patientGroups?: Array<{ id: string; name?: string | null } | null> | null;
    } | null> | null;
    patientGroups?: Array<{ id: string; name?: string | null } | null> | null;
  };
};

export type ExternalAccessesQueryVariables = Exact<{ [key: string]: never }>;

export type ExternalAccessesQuery = {
  externalAccesses: Array<{ id: string; name: string; patientGroupIds: Array<string>; scim?: boolean | null }>;
};

export const DialoggUserCommonFieldsFragmentDoc = gql`
  fragment dialoggUserCommonFields on DialoggUser {
    username
    firstName
    lastName
    enabled
    lastActive
    email
  }
`;
export const SubGroupsFragmentDoc = gql`
  fragment subGroups on UserGroup {
    id
    name
    type
    parentId
    skyresponse {
      skyresponseAlarmHandlingRuleId
    }
  }
`;
export const RoleFragmentDoc = gql`
  fragment Role on Role {
    id
    roleDefinitionId
    display {
      key
      value
    }
  }
`;
export const PatientGroupFragmentDoc = gql`
  fragment PatientGroup on PatientGroup {
    id
    name
    patientsCount
    alarmRoutes {
      configName
      configType
      incomingTemplate {
        isPresentInAccount
        code
        title
        system
        displayText
        icon
      }
      outgoingTemplate {
        isPresentInAccount
        code
        title
        system
        displayText
        icon
      }
      idMappingStrategy
    }
  }
`;
export const SubTreeFragmentDoc = gql`
  fragment subTree on UserGroup {
    id
    name
    type
    rules
    parentId
    roles {
      basedOn
      protected
      ...Role
    }
    linkedPatientGroups {
      ...PatientGroup
    }
    patientGroups {
      ...PatientGroup
    }
    skyresponse {
      skyresponseAlarmHandlingRuleId
    }
    deviceGroups {
      id
      name
    }
  }
  ${RoleFragmentDoc}
  ${PatientGroupFragmentDoc}
`;
export const ExternalPatientIdsFragmentDoc = gql`
  fragment externalPatientIds on ExternalHumanId {
    externalId
    externalHumanIdType {
      id
      use {
        patientUse {
          immutable
        }
      }
    }
  }
`;
export const AddressFragmentDoc = gql`
  fragment address on Address {
    line
    postalCode
    city
    country
    text
  }
`;
export const PatientGroupsFragmentDoc = gql`
  fragment patientGroups on PatientGroupLess {
    name
    id
  }
`;
export const NotificationFragmentDoc = gql`
  fragment notification on Notification {
    inactiveDays
    inactiveDaysSetBy
  }
`;
export const DocumentsFragmentDoc = gql`
  fragment documents on DocumentReference {
    id
    content {
      attachment {
        title
        contentType
        url
        size
        creation
      }
    }
    context {
      carePlan {
        id
        title
      }
    }
  }
`;
export const CarePlansFragmentDoc = gql`
  fragment carePlans on CarePlan {
    id
    status
    subject {
      reference
    }
    title
    description
    created
    period {
      start
      end
    }
    activity {
      detail {
        instantiatesCanonical
        questionnaires {
          title
        }
        status
        scheduledTiming {
          repeat {
            dayOfWeek
            timeOfDay
          }
        }
        scheduledPeriod {
          start
          end
        }
      }
    }
  }
`;
export const RpmMedicalDevicesFragmentDoc = gql`
  fragment rpmMedicalDevices on RpmMedicalDevice {
    id
    btAddress
    deviceGroup {
      id
      name
    }
    deviceName {
      name
      type
    }
    identifier {
      value
    }
    patient {
      reference
    }
    isDeviceBtPaired
    manufacturer
    modelName
    modelNumber
    sensorType
    serialNumber
    status
  }
`;
export const RpmGatewaysFragmentDoc = gql`
  fragment rpmGateways on RpmGateway {
    id
    identifier {
      value
    }
    modelNumber
    children {
      id
      btAddress
      modelNumber
      modelName
      serialNumber
      manufacturer
      status
      sensorType
      isDeviceBtPaired
      batteryLevel
    }
    gatewayStatus {
      connected
      lastSeen
      lastMeasurements {
        type
        time
      }
      lastStatus {
        version
        ble_service_running
        cputemp
        uptime
      }
    }
    patient {
      reference
    }
    gatewayHostname
  }
`;
export const WelfareDevicesFragmentDoc = gql`
  fragment welfareDevices on WelfareDevice {
    id
    uniqueIdentifier
    modelNumber
    status {
      connected
      lastSeen
    }
    patient {
      reference
    }
  }
`;
export const DialoggUserFragmentDoc = gql`
  fragment dialoggUser on DialoggUser {
    username
    enabled
    onBehalf {
      accessiblePatients
    }
  }
`;
export const ReferenceRangeFragmentDoc = gql`
  fragment referenceRange on Observation {
    id
    code {
      text
      coding {
        code
        display
      }
    }
    identifier {
      value
    }
    fromTemplate {
      reference
    }
    component {
      code {
        text
        coding {
          code
          display
        }
      }
      valueQuantity {
        unit
        value
      }
      referenceRange {
        low {
          unit
          value
        }
        high {
          unit
          value
        }
        text
        type {
          text
          coding {
            code
            display
          }
        }
      }
    }
  }
`;
export const GetAllQuestionnaireTemplatesDocument = gql`
  query getAllQuestionnaireTemplates {
    getAllQuestionnaireTemplates {
      id
      title
      purpose
      experimental
      version
      effectivePeriod {
        start
        end
      }
      status
    }
  }
`;

/**
 * __useGetAllQuestionnaireTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetAllQuestionnaireTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllQuestionnaireTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllQuestionnaireTemplatesQuery();
 */
export function useGetAllQuestionnaireTemplatesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllQuestionnaireTemplatesQuery, GetAllQuestionnaireTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesQuery,
          GetAllQuestionnaireTemplatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesQuery,
          GetAllQuestionnaireTemplatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllQuestionnaireTemplatesQuery, GetAllQuestionnaireTemplatesQueryVariables>(
    GetAllQuestionnaireTemplatesDocument,
    {},
    options,
  );
}
export function useGetAllQuestionnaireTemplatesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllQuestionnaireTemplatesQuery, GetAllQuestionnaireTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesQuery,
          GetAllQuestionnaireTemplatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesQuery,
          GetAllQuestionnaireTemplatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllQuestionnaireTemplatesQuery,
    GetAllQuestionnaireTemplatesQueryVariables
  >(GetAllQuestionnaireTemplatesDocument, {}, options);
}
export type GetAllQuestionnaireTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllQuestionnaireTemplatesQuery,
  GetAllQuestionnaireTemplatesQueryVariables
>;
export const UpdateAppDeviceForPatientDocument = gql`
  mutation updateAppDeviceForPatient($patientId: ID!, $appDeviceId: ID!, $input: AppDeviceForPatientUpdateInput!) {
    updateAppDeviceForPatient(patientId: $patientId, appDeviceId: $appDeviceId, input: $input) {
      success
    }
  }
`;

/**
 * __useUpdateAppDeviceForPatientMutation__
 *
 * To run a mutation, you first call `useUpdateAppDeviceForPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppDeviceForPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAppDeviceForPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     appDeviceId: // value for 'appDeviceId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAppDeviceForPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateAppDeviceForPatientMutation,
        UpdateAppDeviceForPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateAppDeviceForPatientMutation,
          UpdateAppDeviceForPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateAppDeviceForPatientMutation, UpdateAppDeviceForPatientMutationVariables>(
    UpdateAppDeviceForPatientDocument,
    options,
  );
}
export type UpdateAppDeviceForPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAppDeviceForPatientMutation,
  UpdateAppDeviceForPatientMutationVariables
>;
export const DeviceGroupsDocument = gql`
  query deviceGroups {
    deviceGroups {
      id
      name
    }
  }
`;

/**
 * __useDeviceGroupsQuery__
 *
 * To run a query within a Vue component, call `useDeviceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceGroupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDeviceGroupsQuery();
 */
export function useDeviceGroupsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<DeviceGroupsQuery, DeviceGroupsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeviceGroupsQuery, DeviceGroupsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeviceGroupsQuery, DeviceGroupsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<DeviceGroupsQuery, DeviceGroupsQueryVariables>(DeviceGroupsDocument, {}, options);
}
export function useDeviceGroupsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<DeviceGroupsQuery, DeviceGroupsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeviceGroupsQuery, DeviceGroupsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeviceGroupsQuery, DeviceGroupsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<DeviceGroupsQuery, DeviceGroupsQueryVariables>(
    DeviceGroupsDocument,
    {},
    options,
  );
}
export type DeviceGroupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DeviceGroupsQuery,
  DeviceGroupsQueryVariables
>;
export const GetMedicalDeviceForMeasurementDocument = gql`
  query getMedicalDeviceForMeasurement($measurementId: ID!, $medicalDeviceId: ID!) {
    getMedicalDeviceForMeasurement(measurementId: $measurementId, medicalDeviceId: $medicalDeviceId) {
      id
      serialNumber
      modelNumber
      manufacturer
    }
  }
`;

/**
 * __useGetMedicalDeviceForMeasurementQuery__
 *
 * To run a query within a Vue component, call `useGetMedicalDeviceForMeasurementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMedicalDeviceForMeasurementQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMedicalDeviceForMeasurementQuery({
 *   measurementId: // value for 'measurementId'
 *   medicalDeviceId: // value for 'medicalDeviceId'
 * });
 */
export function useGetMedicalDeviceForMeasurementQuery(
  variables:
    | GetMedicalDeviceForMeasurementQueryVariables
    | VueCompositionApi.Ref<GetMedicalDeviceForMeasurementQueryVariables>
    | ReactiveFunction<GetMedicalDeviceForMeasurementQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetMedicalDeviceForMeasurementQuery,
        GetMedicalDeviceForMeasurementQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetMedicalDeviceForMeasurementQuery,
          GetMedicalDeviceForMeasurementQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetMedicalDeviceForMeasurementQuery,
          GetMedicalDeviceForMeasurementQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetMedicalDeviceForMeasurementQuery,
    GetMedicalDeviceForMeasurementQueryVariables
  >(GetMedicalDeviceForMeasurementDocument, variables, options);
}
export function useGetMedicalDeviceForMeasurementLazyQuery(
  variables?:
    | GetMedicalDeviceForMeasurementQueryVariables
    | VueCompositionApi.Ref<GetMedicalDeviceForMeasurementQueryVariables>
    | ReactiveFunction<GetMedicalDeviceForMeasurementQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetMedicalDeviceForMeasurementQuery,
        GetMedicalDeviceForMeasurementQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetMedicalDeviceForMeasurementQuery,
          GetMedicalDeviceForMeasurementQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetMedicalDeviceForMeasurementQuery,
          GetMedicalDeviceForMeasurementQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetMedicalDeviceForMeasurementQuery,
    GetMedicalDeviceForMeasurementQueryVariables
  >(GetMedicalDeviceForMeasurementDocument, variables, options);
}
export type GetMedicalDeviceForMeasurementQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetMedicalDeviceForMeasurementQuery,
  GetMedicalDeviceForMeasurementQueryVariables
>;
export const ReadySubTasksDocument = gql`
  query readySubTasks($from: dateTime, $to: dateTime, $status: String) {
    readySubTasks: getTasks(from: $from, to: $to, status: $status) {
      id
      subTasks {
        id
        code {
          text
        }
        status
        priority
      }
    }
  }
`;

/**
 * __useReadySubTasksQuery__
 *
 * To run a query within a Vue component, call `useReadySubTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadySubTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReadySubTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useReadySubTasksQuery(
  variables:
    | ReadySubTasksQueryVariables
    | VueCompositionApi.Ref<ReadySubTasksQueryVariables>
    | ReactiveFunction<ReadySubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<ReadySubTasksQuery, ReadySubTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReadySubTasksQuery, ReadySubTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReadySubTasksQuery, ReadySubTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReadySubTasksQuery, ReadySubTasksQueryVariables>(
    ReadySubTasksDocument,
    variables,
    options,
  );
}
export function useReadySubTasksLazyQuery(
  variables:
    | ReadySubTasksQueryVariables
    | VueCompositionApi.Ref<ReadySubTasksQueryVariables>
    | ReactiveFunction<ReadySubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<ReadySubTasksQuery, ReadySubTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReadySubTasksQuery, ReadySubTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReadySubTasksQuery, ReadySubTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReadySubTasksQuery, ReadySubTasksQueryVariables>(
    ReadySubTasksDocument,
    variables,
    options,
  );
}
export type ReadySubTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReadySubTasksQuery,
  ReadySubTasksQueryVariables
>;
export const ReadyTasksDocument = gql`
  query readyTasks($from: dateTime, $to: dateTime, $status: String) {
    readyTasks: getTasks(from: $from, to: $to, status: $status) {
      id
      status
      priority
      authoredOn
      code {
        text
      }
      note {
        authorString
        time
        text
        authorReference {
          reference
          display
        }
      }
      owner {
        identifier {
          value
        }
        display
      }
      carePlan {
        title
      }
      patient {
        id
        name {
          text
        }
        identifier {
          value
        }
        birthDate
      }
    }
  }
`;

/**
 * __useReadyTasksQuery__
 *
 * To run a query within a Vue component, call `useReadyTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadyTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReadyTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useReadyTasksQuery(
  variables:
    | ReadyTasksQueryVariables
    | VueCompositionApi.Ref<ReadyTasksQueryVariables>
    | ReactiveFunction<ReadyTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<ReadyTasksQuery, ReadyTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReadyTasksQuery, ReadyTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReadyTasksQuery, ReadyTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ReadyTasksQuery, ReadyTasksQueryVariables>(
    ReadyTasksDocument,
    variables,
    options,
  );
}
export function useReadyTasksLazyQuery(
  variables:
    | ReadyTasksQueryVariables
    | VueCompositionApi.Ref<ReadyTasksQueryVariables>
    | ReactiveFunction<ReadyTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<ReadyTasksQuery, ReadyTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ReadyTasksQuery, ReadyTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ReadyTasksQuery, ReadyTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ReadyTasksQuery, ReadyTasksQueryVariables>(
    ReadyTasksDocument,
    variables,
    options,
  );
}
export type ReadyTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ReadyTasksQuery,
  ReadyTasksQueryVariables
>;
export const InProgressSubTasksDocument = gql`
  query inProgressSubTasks($from: dateTime, $to: dateTime, $status: String) {
    inProgressSubTasks: getTasks(from: $from, to: $to, status: $status) {
      id
      subTasks {
        id
        code {
          text
        }
        status
        priority
      }
    }
  }
`;

/**
 * __useInProgressSubTasksQuery__
 *
 * To run a query within a Vue component, call `useInProgressSubTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useInProgressSubTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useInProgressSubTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useInProgressSubTasksQuery(
  variables:
    | InProgressSubTasksQueryVariables
    | VueCompositionApi.Ref<InProgressSubTasksQueryVariables>
    | ReactiveFunction<InProgressSubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>(
    InProgressSubTasksDocument,
    variables,
    options,
  );
}
export function useInProgressSubTasksLazyQuery(
  variables:
    | InProgressSubTasksQueryVariables
    | VueCompositionApi.Ref<InProgressSubTasksQueryVariables>
    | ReactiveFunction<InProgressSubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<InProgressSubTasksQuery, InProgressSubTasksQueryVariables>(
    InProgressSubTasksDocument,
    variables,
    options,
  );
}
export type InProgressSubTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  InProgressSubTasksQuery,
  InProgressSubTasksQueryVariables
>;
export const InProgressTasksDocument = gql`
  query inProgressTasks($from: dateTime, $to: dateTime, $status: String) {
    inProgressTasks: getTasks(from: $from, to: $to, status: $status) {
      id
      status
      priority
      authoredOn
      code {
        text
      }
      note {
        authorString
        time
        text
        authorReference {
          reference
          display
        }
      }
      owner {
        identifier {
          value
        }
        display
      }
      carePlan {
        title
      }
      patient {
        id
        name {
          text
        }
        identifier {
          value
        }
        birthDate
      }
    }
  }
`;

/**
 * __useInProgressTasksQuery__
 *
 * To run a query within a Vue component, call `useInProgressTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useInProgressTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useInProgressTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useInProgressTasksQuery(
  variables:
    | InProgressTasksQueryVariables
    | VueCompositionApi.Ref<InProgressTasksQueryVariables>
    | ReactiveFunction<InProgressTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<InProgressTasksQuery, InProgressTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InProgressTasksQuery, InProgressTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<InProgressTasksQuery, InProgressTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<InProgressTasksQuery, InProgressTasksQueryVariables>(
    InProgressTasksDocument,
    variables,
    options,
  );
}
export function useInProgressTasksLazyQuery(
  variables:
    | InProgressTasksQueryVariables
    | VueCompositionApi.Ref<InProgressTasksQueryVariables>
    | ReactiveFunction<InProgressTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<InProgressTasksQuery, InProgressTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<InProgressTasksQuery, InProgressTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<InProgressTasksQuery, InProgressTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<InProgressTasksQuery, InProgressTasksQueryVariables>(
    InProgressTasksDocument,
    variables,
    options,
  );
}
export type InProgressTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  InProgressTasksQuery,
  InProgressTasksQueryVariables
>;
export const RejectedSubTasksDocument = gql`
  query rejectedSubTasks($from: dateTime, $to: dateTime, $status: String) {
    rejectedSubTasks: getTasks(from: $from, to: $to, status: $status) {
      id
      subTasks {
        id
        code {
          text
        }
        status
        priority
      }
    }
  }
`;

/**
 * __useRejectedSubTasksQuery__
 *
 * To run a query within a Vue component, call `useRejectedSubTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRejectedSubTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRejectedSubTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useRejectedSubTasksQuery(
  variables:
    | RejectedSubTasksQueryVariables
    | VueCompositionApi.Ref<RejectedSubTasksQueryVariables>
    | ReactiveFunction<RejectedSubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>(
    RejectedSubTasksDocument,
    variables,
    options,
  );
}
export function useRejectedSubTasksLazyQuery(
  variables:
    | RejectedSubTasksQueryVariables
    | VueCompositionApi.Ref<RejectedSubTasksQueryVariables>
    | ReactiveFunction<RejectedSubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<RejectedSubTasksQuery, RejectedSubTasksQueryVariables>(
    RejectedSubTasksDocument,
    variables,
    options,
  );
}
export type RejectedSubTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RejectedSubTasksQuery,
  RejectedSubTasksQueryVariables
>;
export const RejectedTasksDocument = gql`
  query rejectedTasks($from: dateTime, $to: dateTime, $status: String) {
    rejectedTasks: getTasks(from: $from, to: $to, status: $status) {
      id
      status
      priority
      authoredOn
      code {
        text
      }
      note {
        authorString
        time
        text
        authorReference {
          reference
          display
        }
      }
      owner {
        identifier {
          value
        }
        display
      }
      carePlan {
        title
      }
      patient {
        id
        name {
          text
        }
        identifier {
          value
        }
        birthDate
      }
    }
  }
`;

/**
 * __useRejectedTasksQuery__
 *
 * To run a query within a Vue component, call `useRejectedTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRejectedTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRejectedTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useRejectedTasksQuery(
  variables:
    | RejectedTasksQueryVariables
    | VueCompositionApi.Ref<RejectedTasksQueryVariables>
    | ReactiveFunction<RejectedTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<RejectedTasksQuery, RejectedTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RejectedTasksQuery, RejectedTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RejectedTasksQuery, RejectedTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<RejectedTasksQuery, RejectedTasksQueryVariables>(
    RejectedTasksDocument,
    variables,
    options,
  );
}
export function useRejectedTasksLazyQuery(
  variables:
    | RejectedTasksQueryVariables
    | VueCompositionApi.Ref<RejectedTasksQueryVariables>
    | ReactiveFunction<RejectedTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<RejectedTasksQuery, RejectedTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RejectedTasksQuery, RejectedTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RejectedTasksQuery, RejectedTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<RejectedTasksQuery, RejectedTasksQueryVariables>(
    RejectedTasksDocument,
    variables,
    options,
  );
}
export type RejectedTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RejectedTasksQuery,
  RejectedTasksQueryVariables
>;
export const CompletedSubTasksDocument = gql`
  query completedSubTasks($from: dateTime, $to: dateTime, $status: String) {
    completedSubTasks: getTasks(from: $from, to: $to, status: $status) {
      id
      subTasks {
        id
        code {
          text
        }
        status
        priority
      }
    }
  }
`;

/**
 * __useCompletedSubTasksQuery__
 *
 * To run a query within a Vue component, call `useCompletedSubTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedSubTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCompletedSubTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useCompletedSubTasksQuery(
  variables:
    | CompletedSubTasksQueryVariables
    | VueCompositionApi.Ref<CompletedSubTasksQueryVariables>
    | ReactiveFunction<CompletedSubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>(
    CompletedSubTasksDocument,
    variables,
    options,
  );
}
export function useCompletedSubTasksLazyQuery(
  variables:
    | CompletedSubTasksQueryVariables
    | VueCompositionApi.Ref<CompletedSubTasksQueryVariables>
    | ReactiveFunction<CompletedSubTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<CompletedSubTasksQuery, CompletedSubTasksQueryVariables>(
    CompletedSubTasksDocument,
    variables,
    options,
  );
}
export type CompletedSubTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CompletedSubTasksQuery,
  CompletedSubTasksQueryVariables
>;
export const CompletedTasksDocument = gql`
  query completedTasks($from: dateTime, $to: dateTime, $status: String) {
    completedTasks: getTasks(from: $from, to: $to, status: $status) {
      id
      status
      priority
      authoredOn
      code {
        text
      }
      note {
        authorString
        time
        text
        authorReference {
          reference
          display
        }
      }
      owner {
        identifier {
          value
        }
        display
      }
      carePlan {
        title
      }
      patient {
        id
        name {
          text
        }
        identifier {
          value
        }
        birthDate
      }
    }
  }
`;

/**
 * __useCompletedTasksQuery__
 *
 * To run a query within a Vue component, call `useCompletedTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedTasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCompletedTasksQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   status: // value for 'status'
 * });
 */
export function useCompletedTasksQuery(
  variables:
    | CompletedTasksQueryVariables
    | VueCompositionApi.Ref<CompletedTasksQueryVariables>
    | ReactiveFunction<CompletedTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<CompletedTasksQuery, CompletedTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CompletedTasksQuery, CompletedTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CompletedTasksQuery, CompletedTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<CompletedTasksQuery, CompletedTasksQueryVariables>(
    CompletedTasksDocument,
    variables,
    options,
  );
}
export function useCompletedTasksLazyQuery(
  variables:
    | CompletedTasksQueryVariables
    | VueCompositionApi.Ref<CompletedTasksQueryVariables>
    | ReactiveFunction<CompletedTasksQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<CompletedTasksQuery, CompletedTasksQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CompletedTasksQuery, CompletedTasksQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CompletedTasksQuery, CompletedTasksQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<CompletedTasksQuery, CompletedTasksQueryVariables>(
    CompletedTasksDocument,
    variables,
    options,
  );
}
export type CompletedTasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CompletedTasksQuery,
  CompletedTasksQueryVariables
>;
export const GetPatientDocument = gql`
  query getPatient($patientId: ID!) {
    getPatient: patient(id: $patientId) {
      id
      name {
        text
      }
    }
  }
`;

/**
 * __useGetPatientQuery__
 *
 * To run a query within a Vue component, call `useGetPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetPatientQuery(
  variables:
    | GetPatientQueryVariables
    | VueCompositionApi.Ref<GetPatientQueryVariables>
    | ReactiveFunction<GetPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientQuery, GetPatientQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientQuery, GetPatientQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientQuery, GetPatientQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetPatientQuery, GetPatientQueryVariables>(
    GetPatientDocument,
    variables,
    options,
  );
}
export function useGetPatientLazyQuery(
  variables?:
    | GetPatientQueryVariables
    | VueCompositionApi.Ref<GetPatientQueryVariables>
    | ReactiveFunction<GetPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientQuery, GetPatientQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientQuery, GetPatientQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientQuery, GetPatientQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientQuery, GetPatientQueryVariables>(
    GetPatientDocument,
    variables,
    options,
  );
}
export type GetPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientQuery,
  GetPatientQueryVariables
>;
export const RemoveReferenceRangeFromPatientDocument = gql`
  mutation removeReferenceRangeFromPatient($patientId: ID!, $referenceRangeId: ID!) {
    removeReferenceRangeFromPatient(patientId: $patientId, referenceRangeId: $referenceRangeId) {
      success
      message
      inputValidation {
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useRemoveReferenceRangeFromPatientMutation__
 *
 * To run a mutation, you first call `useRemoveReferenceRangeFromPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveReferenceRangeFromPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveReferenceRangeFromPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     referenceRangeId: // value for 'referenceRangeId'
 *   },
 * });
 */
export function useRemoveReferenceRangeFromPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveReferenceRangeFromPatientMutation,
        RemoveReferenceRangeFromPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveReferenceRangeFromPatientMutation,
          RemoveReferenceRangeFromPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveReferenceRangeFromPatientMutation,
    RemoveReferenceRangeFromPatientMutationVariables
  >(RemoveReferenceRangeFromPatientDocument, options);
}
export type RemoveReferenceRangeFromPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveReferenceRangeFromPatientMutation,
  RemoveReferenceRangeFromPatientMutationVariables
>;
export const UpdatePatientReferenceRangeDocument = gql`
  mutation updatePatientReferenceRange(
    $patientId: ID!
    $referenceRangeId: ID!
    $referenceRange: [ObservationComponentInput]!
  ) {
    updatePatientReferenceRange(
      patientId: $patientId
      referenceRangeId: $referenceRangeId
      referenceRange: $referenceRange
    ) {
      success
      message
      inputValidation {
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdatePatientReferenceRangeMutation__
 *
 * To run a mutation, you first call `useUpdatePatientReferenceRangeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientReferenceRangeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientReferenceRangeMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     referenceRangeId: // value for 'referenceRangeId'
 *     referenceRange: // value for 'referenceRange'
 *   },
 * });
 */
export function useUpdatePatientReferenceRangeMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdatePatientReferenceRangeMutation,
        UpdatePatientReferenceRangeMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdatePatientReferenceRangeMutation,
          UpdatePatientReferenceRangeMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdatePatientReferenceRangeMutation,
    UpdatePatientReferenceRangeMutationVariables
  >(UpdatePatientReferenceRangeDocument, options);
}
export type UpdatePatientReferenceRangeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientReferenceRangeMutation,
  UpdatePatientReferenceRangeMutationVariables
>;
export const AddReferenceRangeToPatientDocument = gql`
  mutation addReferenceRangeToPatient($patientId: ID!, $referenceRange: PatientReferenceRangeInput!) {
    addReferenceRangeToPatient(patientId: $patientId, referenceRange: $referenceRange) {
      success
      message
      inputValidation {
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useAddReferenceRangeToPatientMutation__
 *
 * To run a mutation, you first call `useAddReferenceRangeToPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddReferenceRangeToPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddReferenceRangeToPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     referenceRange: // value for 'referenceRange'
 *   },
 * });
 */
export function useAddReferenceRangeToPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddReferenceRangeToPatientMutation,
        AddReferenceRangeToPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddReferenceRangeToPatientMutation,
          AddReferenceRangeToPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddReferenceRangeToPatientMutation,
    AddReferenceRangeToPatientMutationVariables
  >(AddReferenceRangeToPatientDocument, options);
}
export type AddReferenceRangeToPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddReferenceRangeToPatientMutation,
  AddReferenceRangeToPatientMutationVariables
>;
export const AcceptVideoMeetingTaskDocument = gql`
  mutation acceptVideoMeetingTask($taskId: ID!) {
    acceptVideoMeetingTask(taskId: $taskId) {
      success
    }
  }
`;

/**
 * __useAcceptVideoMeetingTaskMutation__
 *
 * To run a mutation, you first call `useAcceptVideoMeetingTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptVideoMeetingTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptVideoMeetingTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useAcceptVideoMeetingTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AcceptVideoMeetingTaskMutation, AcceptVideoMeetingTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AcceptVideoMeetingTaskMutation, AcceptVideoMeetingTaskMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AcceptVideoMeetingTaskMutation, AcceptVideoMeetingTaskMutationVariables>(
    AcceptVideoMeetingTaskDocument,
    options,
  );
}
export type AcceptVideoMeetingTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AcceptVideoMeetingTaskMutation,
  AcceptVideoMeetingTaskMutationVariables
>;
export const ReleaseVideoMeetingTaskDocument = gql`
  mutation releaseVideoMeetingTask($taskId: ID!) {
    releaseVideoMeetingTask(taskId: $taskId) {
      success
    }
  }
`;

/**
 * __useReleaseVideoMeetingTaskMutation__
 *
 * To run a mutation, you first call `useReleaseVideoMeetingTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReleaseVideoMeetingTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReleaseVideoMeetingTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useReleaseVideoMeetingTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ReleaseVideoMeetingTaskMutation, ReleaseVideoMeetingTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ReleaseVideoMeetingTaskMutation,
          ReleaseVideoMeetingTaskMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ReleaseVideoMeetingTaskMutation, ReleaseVideoMeetingTaskMutationVariables>(
    ReleaseVideoMeetingTaskDocument,
    options,
  );
}
export type ReleaseVideoMeetingTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ReleaseVideoMeetingTaskMutation,
  ReleaseVideoMeetingTaskMutationVariables
>;
export const BookedMeetingsDocument = gql`
  query bookedMeetings($patientId: ID!, $startAtLeast: dateTime) {
    bookedMeetings: getVideoMeetingsForPatient(patientId: $patientId, startAtLeast: $startAtLeast, status: booked) {
      appointment {
        status
        start
      }
    }
  }
`;

/**
 * __useBookedMeetingsQuery__
 *
 * To run a query within a Vue component, call `useBookedMeetingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookedMeetingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBookedMeetingsQuery({
 *   patientId: // value for 'patientId'
 *   startAtLeast: // value for 'startAtLeast'
 * });
 */
export function useBookedMeetingsQuery(
  variables:
    | BookedMeetingsQueryVariables
    | VueCompositionApi.Ref<BookedMeetingsQueryVariables>
    | ReactiveFunction<BookedMeetingsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<BookedMeetingsQuery, BookedMeetingsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BookedMeetingsQuery, BookedMeetingsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<BookedMeetingsQuery, BookedMeetingsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<BookedMeetingsQuery, BookedMeetingsQueryVariables>(
    BookedMeetingsDocument,
    variables,
    options,
  );
}
export function useBookedMeetingsLazyQuery(
  variables?:
    | BookedMeetingsQueryVariables
    | VueCompositionApi.Ref<BookedMeetingsQueryVariables>
    | ReactiveFunction<BookedMeetingsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<BookedMeetingsQuery, BookedMeetingsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BookedMeetingsQuery, BookedMeetingsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<BookedMeetingsQuery, BookedMeetingsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<BookedMeetingsQuery, BookedMeetingsQueryVariables>(
    BookedMeetingsDocument,
    variables,
    options,
  );
}
export type BookedMeetingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  BookedMeetingsQuery,
  BookedMeetingsQueryVariables
>;
export const ActivateCarePlanDocument = gql`
  mutation activateCarePlan($carePlanId: ID!) {
    activateCarePlan(carePlanId: $carePlanId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
        status
      }
    }
  }
`;

/**
 * __useActivateCarePlanMutation__
 *
 * To run a mutation, you first call `useActivateCarePlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateCarePlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateCarePlanMutation({
 *   variables: {
 *     carePlanId: // value for 'carePlanId'
 *   },
 * });
 */
export function useActivateCarePlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ActivateCarePlanMutation, ActivateCarePlanMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ActivateCarePlanMutation, ActivateCarePlanMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ActivateCarePlanMutation, ActivateCarePlanMutationVariables>(
    ActivateCarePlanDocument,
    options,
  );
}
export type ActivateCarePlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateCarePlanMutation,
  ActivateCarePlanMutationVariables
>;
export const ActivateCarePlanTemplateDocument = gql`
  mutation activateCarePlanTemplate($id: ID!) {
    activateCarePlanTemplate(id: $id) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
        status
      }
    }
  }
`;

/**
 * __useActivateCarePlanTemplateMutation__
 *
 * To run a mutation, you first call `useActivateCarePlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateCarePlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateCarePlanTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useActivateCarePlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ActivateCarePlanTemplateMutation,
        ActivateCarePlanTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ActivateCarePlanTemplateMutation,
          ActivateCarePlanTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ActivateCarePlanTemplateMutation, ActivateCarePlanTemplateMutationVariables>(
    ActivateCarePlanTemplateDocument,
    options,
  );
}
export type ActivateCarePlanTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateCarePlanTemplateMutation,
  ActivateCarePlanTemplateMutationVariables
>;
export const ActivateObservationTemplateDocument = gql`
  mutation activateObservationTemplate($id: ID!) {
    activateObservationTemplate(id: $id) {
      observation {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useActivateObservationTemplateMutation__
 *
 * To run a mutation, you first call `useActivateObservationTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateObservationTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateObservationTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useActivateObservationTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ActivateObservationTemplateMutation,
        ActivateObservationTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ActivateObservationTemplateMutation,
          ActivateObservationTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ActivateObservationTemplateMutation,
    ActivateObservationTemplateMutationVariables
  >(ActivateObservationTemplateDocument, options);
}
export type ActivateObservationTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateObservationTemplateMutation,
  ActivateObservationTemplateMutationVariables
>;
export const ActivateQuestionnaireTemplateDocument = gql`
  mutation activateQuestionnaireTemplate($id: ID!) {
    activateQuestionnaireTemplate(id: $id) {
      success
      inputValidation {
        errors {
          path
        }
        valid
      }
      message
    }
  }
`;

/**
 * __useActivateQuestionnaireTemplateMutation__
 *
 * To run a mutation, you first call `useActivateQuestionnaireTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateQuestionnaireTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateQuestionnaireTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useActivateQuestionnaireTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ActivateQuestionnaireTemplateMutation,
        ActivateQuestionnaireTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ActivateQuestionnaireTemplateMutation,
          ActivateQuestionnaireTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ActivateQuestionnaireTemplateMutation,
    ActivateQuestionnaireTemplateMutationVariables
  >(ActivateQuestionnaireTemplateDocument, options);
}
export type ActivateQuestionnaireTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateQuestionnaireTemplateMutation,
  ActivateQuestionnaireTemplateMutationVariables
>;
export const CreateObservationForActivityInCarePlanTemplateDocument = gql`
  mutation createObservationForActivityInCarePlanTemplate($observationActivityInput: ObservationInput) {
    createObservationForActivityInCarePlanTemplate(observationActivityInput: $observationActivityInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      observation {
        id
        identifier {
          value
        }
        code {
          coding {
            code
          }
          text
        }
      }
    }
  }
`;

/**
 * __useCreateObservationForActivityInCarePlanTemplateMutation__
 *
 * To run a mutation, you first call `useCreateObservationForActivityInCarePlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateObservationForActivityInCarePlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateObservationForActivityInCarePlanTemplateMutation({
 *   variables: {
 *     observationActivityInput: // value for 'observationActivityInput'
 *   },
 * });
 */
export function useCreateObservationForActivityInCarePlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateObservationForActivityInCarePlanTemplateMutation,
        CreateObservationForActivityInCarePlanTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateObservationForActivityInCarePlanTemplateMutation,
          CreateObservationForActivityInCarePlanTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateObservationForActivityInCarePlanTemplateMutation,
    CreateObservationForActivityInCarePlanTemplateMutationVariables
  >(CreateObservationForActivityInCarePlanTemplateDocument, options);
}
export type CreateObservationForActivityInCarePlanTemplateMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateObservationForActivityInCarePlanTemplateMutation,
    CreateObservationForActivityInCarePlanTemplateMutationVariables
  >;
export const CreateObservationForActivityInCarePlanDocument = gql`
  mutation createObservationForActivityInCarePlan($observationActivityInput: ObservationInput) {
    createObservationForActivityInCarePlan(observationActivityInput: $observationActivityInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      observation {
        id
        identifier {
          value
        }
        code {
          coding {
            code
          }
          text
        }
      }
    }
  }
`;

/**
 * __useCreateObservationForActivityInCarePlanMutation__
 *
 * To run a mutation, you first call `useCreateObservationForActivityInCarePlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateObservationForActivityInCarePlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateObservationForActivityInCarePlanMutation({
 *   variables: {
 *     observationActivityInput: // value for 'observationActivityInput'
 *   },
 * });
 */
export function useCreateObservationForActivityInCarePlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateObservationForActivityInCarePlanMutation,
        CreateObservationForActivityInCarePlanMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateObservationForActivityInCarePlanMutation,
          CreateObservationForActivityInCarePlanMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateObservationForActivityInCarePlanMutation,
    CreateObservationForActivityInCarePlanMutationVariables
  >(CreateObservationForActivityInCarePlanDocument, options);
}
export type CreateObservationForActivityInCarePlanMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateObservationForActivityInCarePlanMutation,
    CreateObservationForActivityInCarePlanMutationVariables
  >;
export const CreateCarePlanBasedOnExistingDocument = gql`
  mutation createCarePlanBasedOnExisting($patientId: ID!, $newCarePlanTitle: String!, $existingCarePlanId: ID!) {
    createCarePlanBasedOnExisting(
      patientId: $patientId
      newCarePlanTitle: $newCarePlanTitle
      existingCarePlanId: $existingCarePlanId
    ) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
      }
    }
  }
`;

/**
 * __useCreateCarePlanBasedOnExistingMutation__
 *
 * To run a mutation, you first call `useCreateCarePlanBasedOnExistingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarePlanBasedOnExistingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCarePlanBasedOnExistingMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     newCarePlanTitle: // value for 'newCarePlanTitle'
 *     existingCarePlanId: // value for 'existingCarePlanId'
 *   },
 * });
 */
export function useCreateCarePlanBasedOnExistingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateCarePlanBasedOnExistingMutation,
        CreateCarePlanBasedOnExistingMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateCarePlanBasedOnExistingMutation,
          CreateCarePlanBasedOnExistingMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateCarePlanBasedOnExistingMutation,
    CreateCarePlanBasedOnExistingMutationVariables
  >(CreateCarePlanBasedOnExistingDocument, options);
}
export type CreateCarePlanBasedOnExistingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCarePlanBasedOnExistingMutation,
  CreateCarePlanBasedOnExistingMutationVariables
>;
export const CreateCarePlanForPatientDocument = gql`
  mutation createCarePlanForPatient($createInput: CarePlanInput) {
    createCarePlanForPatient(createInput: $createInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
      }
    }
  }
`;

/**
 * __useCreateCarePlanForPatientMutation__
 *
 * To run a mutation, you first call `useCreateCarePlanForPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarePlanForPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCarePlanForPatientMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateCarePlanForPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateCarePlanForPatientMutation,
        CreateCarePlanForPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateCarePlanForPatientMutation,
          CreateCarePlanForPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCarePlanForPatientMutation, CreateCarePlanForPatientMutationVariables>(
    CreateCarePlanForPatientDocument,
    options,
  );
}
export type CreateCarePlanForPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCarePlanForPatientMutation,
  CreateCarePlanForPatientMutationVariables
>;
export const CreateCarePlanTemplateDocument = gql`
  mutation createCarePlanTemplate($createInput: CarePlanTemplateInput!) {
    createCarePlanTemplate(createInput: $createInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
      }
    }
  }
`;

/**
 * __useCreateCarePlanTemplateMutation__
 *
 * To run a mutation, you first call `useCreateCarePlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarePlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCarePlanTemplateMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateCarePlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCarePlanTemplateMutation, CreateCarePlanTemplateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateCarePlanTemplateMutation, CreateCarePlanTemplateMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCarePlanTemplateMutation, CreateCarePlanTemplateMutationVariables>(
    CreateCarePlanTemplateDocument,
    options,
  );
}
export type CreateCarePlanTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCarePlanTemplateMutation,
  CreateCarePlanTemplateMutationVariables
>;
export const CreateCarePlanTemplateBasedOnExistingDocument = gql`
  mutation createCarePlanTemplateBasedOnExisting($newTitle: String!, $basedOn: ID!) {
    createCarePlanTemplateBasedOnExisting(newTitle: $newTitle, basedOn: $basedOn) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
      }
    }
  }
`;

/**
 * __useCreateCarePlanTemplateBasedOnExistingMutation__
 *
 * To run a mutation, you first call `useCreateCarePlanTemplateBasedOnExistingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarePlanTemplateBasedOnExistingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCarePlanTemplateBasedOnExistingMutation({
 *   variables: {
 *     newTitle: // value for 'newTitle'
 *     basedOn: // value for 'basedOn'
 *   },
 * });
 */
export function useCreateCarePlanTemplateBasedOnExistingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateCarePlanTemplateBasedOnExistingMutation,
        CreateCarePlanTemplateBasedOnExistingMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateCarePlanTemplateBasedOnExistingMutation,
          CreateCarePlanTemplateBasedOnExistingMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateCarePlanTemplateBasedOnExistingMutation,
    CreateCarePlanTemplateBasedOnExistingMutationVariables
  >(CreateCarePlanTemplateBasedOnExistingDocument, options);
}
export type CreateCarePlanTemplateBasedOnExistingMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateCarePlanTemplateBasedOnExistingMutation,
    CreateCarePlanTemplateBasedOnExistingMutationVariables
  >;
export const CreateCommunicationDocument = gql`
  mutation createCommunication($communication: PersonnelCommunicationInput!) {
    createCommunication(communication: $communication) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      communication {
        id
      }
    }
  }
`;

/**
 * __useCreateCommunicationMutation__
 *
 * To run a mutation, you first call `useCreateCommunicationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunicationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCommunicationMutation({
 *   variables: {
 *     communication: // value for 'communication'
 *   },
 * });
 */
export function useCreateCommunicationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCommunicationMutation, CreateCommunicationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateCommunicationMutation, CreateCommunicationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCommunicationMutation, CreateCommunicationMutationVariables>(
    CreateCommunicationDocument,
    options,
  );
}
export type CreateCommunicationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCommunicationMutation,
  CreateCommunicationMutationVariables
>;
export const CreateCommunicationToSeveralDocument = gql`
  mutation createCommunicationToSeveral($communication: PersonnelCommunicationToSeveralInput!) {
    createCommunicationToSeveral(communication: $communication) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      communication {
        id
      }
    }
  }
`;

/**
 * __useCreateCommunicationToSeveralMutation__
 *
 * To run a mutation, you first call `useCreateCommunicationToSeveralMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunicationToSeveralMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCommunicationToSeveralMutation({
 *   variables: {
 *     communication: // value for 'communication'
 *   },
 * });
 */
export function useCreateCommunicationToSeveralMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateCommunicationToSeveralMutation,
        CreateCommunicationToSeveralMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateCommunicationToSeveralMutation,
          CreateCommunicationToSeveralMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateCommunicationToSeveralMutation,
    CreateCommunicationToSeveralMutationVariables
  >(CreateCommunicationToSeveralDocument, options);
}
export type CreateCommunicationToSeveralMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCommunicationToSeveralMutation,
  CreateCommunicationToSeveralMutationVariables
>;
export const CreateDocumentDocument = gql`
  mutation createDocument($createInput: DocumentReferenceInput!) {
    createDocument(createInput: $createInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      documentReference {
        id
        content {
          attachment {
            url
          }
        }
      }
    }
  }
`;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDocumentMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateDocumentMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateDocumentMutation, CreateDocumentMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateDocumentMutation, CreateDocumentMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(
    CreateDocumentDocument,
    options,
  );
}
export type CreateDocumentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateDocumentMutation,
  CreateDocumentMutationVariables
>;
export const CreateObservationTemplateDocument = gql`
  mutation createObservationTemplate($observationInput: ObservationInput!) {
    createObservationTemplate(observationInput: $observationInput) {
      observation {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useCreateObservationTemplateMutation__
 *
 * To run a mutation, you first call `useCreateObservationTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateObservationTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateObservationTemplateMutation({
 *   variables: {
 *     observationInput: // value for 'observationInput'
 *   },
 * });
 */
export function useCreateObservationTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateObservationTemplateMutation,
        CreateObservationTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateObservationTemplateMutation,
          CreateObservationTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<CreateObservationTemplateMutation, CreateObservationTemplateMutationVariables>(
    CreateObservationTemplateDocument,
    options,
  );
}
export type CreateObservationTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateObservationTemplateMutation,
  CreateObservationTemplateMutationVariables
>;
export const CreateQuestionnaireForActivityInCarePlanDocument = gql`
  mutation createQuestionnaireForActivityInCarePlan($carePlanId: ID!, $questionnaireTemplateId: ID!) {
    createQuestionnaireForActivityInCarePlan(
      carePlanId: $carePlanId
      questionnaireTemplateId: $questionnaireTemplateId
    ) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      questionnaire {
        id
        title
        derivedFrom
      }
    }
  }
`;

/**
 * __useCreateQuestionnaireForActivityInCarePlanMutation__
 *
 * To run a mutation, you first call `useCreateQuestionnaireForActivityInCarePlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionnaireForActivityInCarePlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateQuestionnaireForActivityInCarePlanMutation({
 *   variables: {
 *     carePlanId: // value for 'carePlanId'
 *     questionnaireTemplateId: // value for 'questionnaireTemplateId'
 *   },
 * });
 */
export function useCreateQuestionnaireForActivityInCarePlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateQuestionnaireForActivityInCarePlanMutation,
        CreateQuestionnaireForActivityInCarePlanMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateQuestionnaireForActivityInCarePlanMutation,
          CreateQuestionnaireForActivityInCarePlanMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateQuestionnaireForActivityInCarePlanMutation,
    CreateQuestionnaireForActivityInCarePlanMutationVariables
  >(CreateQuestionnaireForActivityInCarePlanDocument, options);
}
export type CreateQuestionnaireForActivityInCarePlanMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateQuestionnaireForActivityInCarePlanMutation,
    CreateQuestionnaireForActivityInCarePlanMutationVariables
  >;
export const CreateQuestionnaireForActivityInCarePlanTemplateDocument = gql`
  mutation createQuestionnaireForActivityInCarePlanTemplate($carePlanTemplateId: ID!, $questionnaireTemplateId: ID!) {
    createQuestionnaireForActivityInCarePlanTemplate(
      carePlanTemplateId: $carePlanTemplateId
      questionnaireTemplateId: $questionnaireTemplateId
    ) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      questionnaire {
        id
        title
        derivedFrom
      }
    }
  }
`;

/**
 * __useCreateQuestionnaireForActivityInCarePlanTemplateMutation__
 *
 * To run a mutation, you first call `useCreateQuestionnaireForActivityInCarePlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionnaireForActivityInCarePlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateQuestionnaireForActivityInCarePlanTemplateMutation({
 *   variables: {
 *     carePlanTemplateId: // value for 'carePlanTemplateId'
 *     questionnaireTemplateId: // value for 'questionnaireTemplateId'
 *   },
 * });
 */
export function useCreateQuestionnaireForActivityInCarePlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateQuestionnaireForActivityInCarePlanTemplateMutation,
        CreateQuestionnaireForActivityInCarePlanTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateQuestionnaireForActivityInCarePlanTemplateMutation,
          CreateQuestionnaireForActivityInCarePlanTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateQuestionnaireForActivityInCarePlanTemplateMutation,
    CreateQuestionnaireForActivityInCarePlanTemplateMutationVariables
  >(CreateQuestionnaireForActivityInCarePlanTemplateDocument, options);
}
export type CreateQuestionnaireForActivityInCarePlanTemplateMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CreateQuestionnaireForActivityInCarePlanTemplateMutation,
    CreateQuestionnaireForActivityInCarePlanTemplateMutationVariables
  >;
export const CreateQuestionnaireTemplateDocument = gql`
  mutation createQuestionnaireTemplate($questionnaireInput: QuestionnaireInput!) {
    createQuestionnaireTemplate(createInput: $questionnaireInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      questionnaire {
        id
        version
        name
        status
        experimental
        title
        description
        effectivePeriod {
          start
          end
        }
        publisher
        patient
        purpose
        carePlan
        template
        item {
          linkId
          text
          type
          answerOption {
            valueInteger
            valueDecimal
            valueString
            valueCoding {
              code
              display
            }
          }
        }
      }
    }
  }
`;

/**
 * __useCreateQuestionnaireTemplateMutation__
 *
 * To run a mutation, you first call `useCreateQuestionnaireTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionnaireTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateQuestionnaireTemplateMutation({
 *   variables: {
 *     questionnaireInput: // value for 'questionnaireInput'
 *   },
 * });
 */
export function useCreateQuestionnaireTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateQuestionnaireTemplateMutation,
        CreateQuestionnaireTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateQuestionnaireTemplateMutation,
          CreateQuestionnaireTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateQuestionnaireTemplateMutation,
    CreateQuestionnaireTemplateMutationVariables
  >(CreateQuestionnaireTemplateDocument, options);
}
export type CreateQuestionnaireTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateQuestionnaireTemplateMutation,
  CreateQuestionnaireTemplateMutationVariables
>;
export const DeleteDocumentDocument = gql`
  mutation deleteDocument($documentId: ID!) {
    deleteDocument(documentId: $documentId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDocumentMutation({
 *   variables: {
 *     documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteDocumentMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(
    DeleteDocumentDocument,
    options,
  );
}
export type DeleteDocumentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteDocumentMutation,
  DeleteDocumentMutationVariables
>;
export const DeleteDraftCarePlanDocument = gql`
  mutation deleteDraftCarePlan($carePlanId: ID!) {
    deleteDraftCarePlan(carePlanId: $carePlanId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteDraftCarePlanMutation__
 *
 * To run a mutation, you first call `useDeleteDraftCarePlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftCarePlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDraftCarePlanMutation({
 *   variables: {
 *     carePlanId: // value for 'carePlanId'
 *   },
 * });
 */
export function useDeleteDraftCarePlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteDraftCarePlanMutation, DeleteDraftCarePlanMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteDraftCarePlanMutation, DeleteDraftCarePlanMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteDraftCarePlanMutation, DeleteDraftCarePlanMutationVariables>(
    DeleteDraftCarePlanDocument,
    options,
  );
}
export type DeleteDraftCarePlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteDraftCarePlanMutation,
  DeleteDraftCarePlanMutationVariables
>;
export const DeleteObservationTemplateDocument = gql`
  mutation deleteObservationTemplate($id: ID!) {
    deleteObservationTemplate(id: $id) {
      success
    }
  }
`;

/**
 * __useDeleteObservationTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteObservationTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteObservationTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteObservationTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteObservationTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteObservationTemplateMutation,
        DeleteObservationTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteObservationTemplateMutation,
          DeleteObservationTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteObservationTemplateMutation, DeleteObservationTemplateMutationVariables>(
    DeleteObservationTemplateDocument,
    options,
  );
}
export type DeleteObservationTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteObservationTemplateMutation,
  DeleteObservationTemplateMutationVariables
>;
export const DeleteAppDeviceForPatientDocument = gql`
  mutation deleteAppDeviceForPatient($patientId: ID!, $appDeviceId: ID!) {
    deleteAppDeviceForPatient(patientId: $patientId, appDeviceId: $appDeviceId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteAppDeviceForPatientMutation__
 *
 * To run a mutation, you first call `useDeleteAppDeviceForPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppDeviceForPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAppDeviceForPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     appDeviceId: // value for 'appDeviceId'
 *   },
 * });
 */
export function useDeleteAppDeviceForPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteAppDeviceForPatientMutation,
        DeleteAppDeviceForPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteAppDeviceForPatientMutation,
          DeleteAppDeviceForPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteAppDeviceForPatientMutation, DeleteAppDeviceForPatientMutationVariables>(
    DeleteAppDeviceForPatientDocument,
    options,
  );
}
export type DeleteAppDeviceForPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteAppDeviceForPatientMutation,
  DeleteAppDeviceForPatientMutationVariables
>;
export const MarkCommunicationAsReadDocument = gql`
  mutation markCommunicationAsRead($communicationId: ID!) {
    markCommunicationAsRead(communicationId: $communicationId) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      communication {
        id
      }
    }
  }
`;

/**
 * __useMarkCommunicationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkCommunicationAsReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkCommunicationAsReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkCommunicationAsReadMutation({
 *   variables: {
 *     communicationId: // value for 'communicationId'
 *   },
 * });
 */
export function useMarkCommunicationAsReadMutation(
  options:
    | VueApolloComposable.UseMutationOptions<MarkCommunicationAsReadMutation, MarkCommunicationAsReadMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          MarkCommunicationAsReadMutation,
          MarkCommunicationAsReadMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<MarkCommunicationAsReadMutation, MarkCommunicationAsReadMutationVariables>(
    MarkCommunicationAsReadDocument,
    options,
  );
}
export type MarkCommunicationAsReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  MarkCommunicationAsReadMutation,
  MarkCommunicationAsReadMutationVariables
>;
export const CompleteCarePlanDocument = gql`
  mutation completeCarePlan($carePlanId: ID!) {
    completeCarePlan(carePlanId: $carePlanId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
        status
      }
    }
  }
`;

/**
 * __useCompleteCarePlanMutation__
 *
 * To run a mutation, you first call `useCompleteCarePlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCarePlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteCarePlanMutation({
 *   variables: {
 *     carePlanId: // value for 'carePlanId'
 *   },
 * });
 */
export function useCompleteCarePlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CompleteCarePlanMutation, CompleteCarePlanMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CompleteCarePlanMutation, CompleteCarePlanMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CompleteCarePlanMutation, CompleteCarePlanMutationVariables>(
    CompleteCarePlanDocument,
    options,
  );
}
export type CompleteCarePlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CompleteCarePlanMutation,
  CompleteCarePlanMutationVariables
>;
export const CompleteCarePlanTemplateDocument = gql`
  mutation completeCarePlanTemplate($id: ID!) {
    completeCarePlanTemplate(id: $id) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      carePlan {
        id
        status
      }
    }
  }
`;

/**
 * __useCompleteCarePlanTemplateMutation__
 *
 * To run a mutation, you first call `useCompleteCarePlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCarePlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteCarePlanTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useCompleteCarePlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CompleteCarePlanTemplateMutation,
        CompleteCarePlanTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CompleteCarePlanTemplateMutation,
          CompleteCarePlanTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<CompleteCarePlanTemplateMutation, CompleteCarePlanTemplateMutationVariables>(
    CompleteCarePlanTemplateDocument,
    options,
  );
}
export type CompleteCarePlanTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CompleteCarePlanTemplateMutation,
  CompleteCarePlanTemplateMutationVariables
>;
export const RetireObservationTemplateDocument = gql`
  mutation retireObservationTemplate($id: ID!) {
    retireObservationTemplate(id: $id) {
      observation {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useRetireObservationTemplateMutation__
 *
 * To run a mutation, you first call `useRetireObservationTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetireObservationTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetireObservationTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRetireObservationTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RetireObservationTemplateMutation,
        RetireObservationTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RetireObservationTemplateMutation,
          RetireObservationTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<RetireObservationTemplateMutation, RetireObservationTemplateMutationVariables>(
    RetireObservationTemplateDocument,
    options,
  );
}
export type RetireObservationTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RetireObservationTemplateMutation,
  RetireObservationTemplateMutationVariables
>;
export const RetireQuestionnaireTemplateDocument = gql`
  mutation retireQuestionnaireTemplate($id: ID!) {
    retireQuestionnaireTemplate(id: $id) {
      success
      inputValidation {
        errors {
          path
        }
        valid
      }
      message
    }
  }
`;

/**
 * __useRetireQuestionnaireTemplateMutation__
 *
 * To run a mutation, you first call `useRetireQuestionnaireTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetireQuestionnaireTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetireQuestionnaireTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRetireQuestionnaireTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RetireQuestionnaireTemplateMutation,
        RetireQuestionnaireTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RetireQuestionnaireTemplateMutation,
          RetireQuestionnaireTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RetireQuestionnaireTemplateMutation,
    RetireQuestionnaireTemplateMutationVariables
  >(RetireQuestionnaireTemplateDocument, options);
}
export type RetireQuestionnaireTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RetireQuestionnaireTemplateMutation,
  RetireQuestionnaireTemplateMutationVariables
>;
export const StartCompositeTaskDocument = gql`
  mutation startCompositeTask($taskId: ID!) {
    startCompositeTask(taskId: $taskId) {
      success
      message
    }
  }
`;

/**
 * __useStartCompositeTaskMutation__
 *
 * To run a mutation, you first call `useStartCompositeTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartCompositeTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartCompositeTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useStartCompositeTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StartCompositeTaskMutation, StartCompositeTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<StartCompositeTaskMutation, StartCompositeTaskMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<StartCompositeTaskMutation, StartCompositeTaskMutationVariables>(
    StartCompositeTaskDocument,
    options,
  );
}
export type StartCompositeTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartCompositeTaskMutation,
  StartCompositeTaskMutationVariables
>;
export const CompleteCompositeTaskDocument = gql`
  mutation completeCompositeTask($taskId: ID!, $journal: JournalInput) {
    completeCompositeTask(taskId: $taskId, journal: $journal) {
      success
      message
    }
  }
`;

/**
 * __useCompleteCompositeTaskMutation__
 *
 * To run a mutation, you first call `useCompleteCompositeTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCompositeTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteCompositeTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     journal: // value for 'journal'
 *   },
 * });
 */
export function useCompleteCompositeTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CompleteCompositeTaskMutation, CompleteCompositeTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CompleteCompositeTaskMutation, CompleteCompositeTaskMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CompleteCompositeTaskMutation, CompleteCompositeTaskMutationVariables>(
    CompleteCompositeTaskDocument,
    options,
  );
}
export type CompleteCompositeTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CompleteCompositeTaskMutation,
  CompleteCompositeTaskMutationVariables
>;
export const CompleteCompositeTaskAndItsSubTasksDocument = gql`
  mutation completeCompositeTaskAndItsSubTasks($taskId: ID!, $journal: JournalInput) {
    completeCompositeTaskAndItsSubTasks(taskId: $taskId, journal: $journal) {
      success
      message
    }
  }
`;

/**
 * __useCompleteCompositeTaskAndItsSubTasksMutation__
 *
 * To run a mutation, you first call `useCompleteCompositeTaskAndItsSubTasksMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCompositeTaskAndItsSubTasksMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteCompositeTaskAndItsSubTasksMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     journal: // value for 'journal'
 *   },
 * });
 */
export function useCompleteCompositeTaskAndItsSubTasksMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CompleteCompositeTaskAndItsSubTasksMutation,
        CompleteCompositeTaskAndItsSubTasksMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CompleteCompositeTaskAndItsSubTasksMutation,
          CompleteCompositeTaskAndItsSubTasksMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CompleteCompositeTaskAndItsSubTasksMutation,
    CompleteCompositeTaskAndItsSubTasksMutationVariables
  >(CompleteCompositeTaskAndItsSubTasksDocument, options);
}
export type CompleteCompositeTaskAndItsSubTasksMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    CompleteCompositeTaskAndItsSubTasksMutation,
    CompleteCompositeTaskAndItsSubTasksMutationVariables
  >;
export const RejectCompositeTaskDocument = gql`
  mutation rejectCompositeTask($taskId: ID!) {
    rejectCompositeTask(taskId: $taskId) {
      success
      message
    }
  }
`;

/**
 * __useRejectCompositeTaskMutation__
 *
 * To run a mutation, you first call `useRejectCompositeTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectCompositeTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectCompositeTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useRejectCompositeTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RejectCompositeTaskMutation, RejectCompositeTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RejectCompositeTaskMutation, RejectCompositeTaskMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RejectCompositeTaskMutation, RejectCompositeTaskMutationVariables>(
    RejectCompositeTaskDocument,
    options,
  );
}
export type RejectCompositeTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RejectCompositeTaskMutation,
  RejectCompositeTaskMutationVariables
>;
export const CompleteSubTaskDocument = gql`
  mutation completeSubTask($taskId: ID!) {
    completeSubTask(taskId: $taskId) {
      success
      message
    }
  }
`;

/**
 * __useCompleteSubTaskMutation__
 *
 * To run a mutation, you first call `useCompleteSubTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSubTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteSubTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useCompleteSubTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CompleteSubTaskMutation, CompleteSubTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CompleteSubTaskMutation, CompleteSubTaskMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CompleteSubTaskMutation, CompleteSubTaskMutationVariables>(
    CompleteSubTaskDocument,
    options,
  );
}
export type CompleteSubTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CompleteSubTaskMutation,
  CompleteSubTaskMutationVariables
>;
export const RejectSubTaskDocument = gql`
  mutation rejectSubTask($taskId: ID!) {
    rejectSubTask(taskId: $taskId) {
      success
      message
    }
  }
`;

/**
 * __useRejectSubTaskMutation__
 *
 * To run a mutation, you first call `useRejectSubTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectSubTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectSubTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useRejectSubTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RejectSubTaskMutation, RejectSubTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RejectSubTaskMutation, RejectSubTaskMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RejectSubTaskMutation, RejectSubTaskMutationVariables>(
    RejectSubTaskDocument,
    options,
  );
}
export type RejectSubTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RejectSubTaskMutation,
  RejectSubTaskMutationVariables
>;
export const UpdateSubTaskPriorityDocument = gql`
  mutation updateSubTaskPriority($taskId: ID!, $priority: String) {
    updateSubTaskPriority(taskId: $taskId, priority: $priority) {
      success
      message
    }
  }
`;

/**
 * __useUpdateSubTaskPriorityMutation__
 *
 * To run a mutation, you first call `useUpdateSubTaskPriorityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubTaskPriorityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSubTaskPriorityMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     priority: // value for 'priority'
 *   },
 * });
 */
export function useUpdateSubTaskPriorityMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateSubTaskPriorityMutation, UpdateSubTaskPriorityMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateSubTaskPriorityMutation, UpdateSubTaskPriorityMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateSubTaskPriorityMutation, UpdateSubTaskPriorityMutationVariables>(
    UpdateSubTaskPriorityDocument,
    options,
  );
}
export type UpdateSubTaskPriorityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateSubTaskPriorityMutation,
  UpdateSubTaskPriorityMutationVariables
>;
export const UpdateCompositeTaskPriorityDocument = gql`
  mutation updateCompositeTaskPriority($taskId: ID!, $priority: String) {
    updateCompositeTaskPriority(taskId: $taskId, priority: $priority) {
      success
      message
    }
  }
`;

/**
 * __useUpdateCompositeTaskPriorityMutation__
 *
 * To run a mutation, you first call `useUpdateCompositeTaskPriorityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompositeTaskPriorityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCompositeTaskPriorityMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     priority: // value for 'priority'
 *   },
 * });
 */
export function useUpdateCompositeTaskPriorityMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateCompositeTaskPriorityMutation,
        UpdateCompositeTaskPriorityMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateCompositeTaskPriorityMutation,
          UpdateCompositeTaskPriorityMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateCompositeTaskPriorityMutation,
    UpdateCompositeTaskPriorityMutationVariables
  >(UpdateCompositeTaskPriorityDocument, options);
}
export type UpdateCompositeTaskPriorityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateCompositeTaskPriorityMutation,
  UpdateCompositeTaskPriorityMutationVariables
>;
export const RetryTaskJournalingDocument = gql`
  mutation retryTaskJournaling($taskId: ID!) {
    retryTaskJournaling(taskId: $taskId) {
      success
      message
    }
  }
`;

/**
 * __useRetryTaskJournalingMutation__
 *
 * To run a mutation, you first call `useRetryTaskJournalingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetryTaskJournalingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetryTaskJournalingMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useRetryTaskJournalingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RetryTaskJournalingMutation, RetryTaskJournalingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RetryTaskJournalingMutation, RetryTaskJournalingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RetryTaskJournalingMutation, RetryTaskJournalingMutationVariables>(
    RetryTaskJournalingDocument,
    options,
  );
}
export type RetryTaskJournalingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RetryTaskJournalingMutation,
  RetryTaskJournalingMutationVariables
>;
export const TestPushNotificationDocument = gql`
  mutation testPushNotification($patientId: ID!, $appDeviceId: ID!) {
    testPushNotification(patientId: $patientId, appDeviceId: $appDeviceId) {
      objectReference {
        reference
      }
      success
      date
    }
  }
`;

/**
 * __useTestPushNotificationMutation__
 *
 * To run a mutation, you first call `useTestPushNotificationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTestPushNotificationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTestPushNotificationMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     appDeviceId: // value for 'appDeviceId'
 *   },
 * });
 */
export function useTestPushNotificationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<TestPushNotificationMutation, TestPushNotificationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<TestPushNotificationMutation, TestPushNotificationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<TestPushNotificationMutation, TestPushNotificationMutationVariables>(
    TestPushNotificationDocument,
    options,
  );
}
export type TestPushNotificationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  TestPushNotificationMutation,
  TestPushNotificationMutationVariables
>;
export const UpdateCarePlanTemplateQuestionnaireDocument = gql`
  mutation updateCarePlanTemplateQuestionnaire(
    $carePlanTemplateId: ID!
    $questionnaireId: ID!
    $updateInput: QuestionnaireInput!
  ) {
    updateCarePlanTemplateQuestionnaire(
      carePlanTemplateId: $carePlanTemplateId
      questionnaireId: $questionnaireId
      updateInput: $updateInput
    ) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      questionnaire {
        id
        version
        name
        status
        experimental
        title
        description
        effectivePeriod {
          start
          end
        }
        publisher
        patient
        purpose
        carePlan
        template
        item {
          linkId
          text
          type
          answerOption {
            valueInteger
            valueDecimal
            valueString
            valueCoding {
              code
              display
            }
          }
        }
      }
    }
  }
`;

/**
 * __useUpdateCarePlanTemplateQuestionnaireMutation__
 *
 * To run a mutation, you first call `useUpdateCarePlanTemplateQuestionnaireMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarePlanTemplateQuestionnaireMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCarePlanTemplateQuestionnaireMutation({
 *   variables: {
 *     carePlanTemplateId: // value for 'carePlanTemplateId'
 *     questionnaireId: // value for 'questionnaireId'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateCarePlanTemplateQuestionnaireMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateCarePlanTemplateQuestionnaireMutation,
        UpdateCarePlanTemplateQuestionnaireMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateCarePlanTemplateQuestionnaireMutation,
          UpdateCarePlanTemplateQuestionnaireMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateCarePlanTemplateQuestionnaireMutation,
    UpdateCarePlanTemplateQuestionnaireMutationVariables
  >(UpdateCarePlanTemplateQuestionnaireDocument, options);
}
export type UpdateCarePlanTemplateQuestionnaireMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateCarePlanTemplateQuestionnaireMutation,
    UpdateCarePlanTemplateQuestionnaireMutationVariables
  >;
export const UpdateDraftCarePlanDocument = gql`
  mutation updateDraftCarePlan($carePlanId: ID!, $updateInput: CarePlanInput) {
    updateDraftCarePlan(carePlanId: $carePlanId, updateInput: $updateInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useUpdateDraftCarePlanMutation__
 *
 * To run a mutation, you first call `useUpdateDraftCarePlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftCarePlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDraftCarePlanMutation({
 *   variables: {
 *     carePlanId: // value for 'carePlanId'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateDraftCarePlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateDraftCarePlanMutation, UpdateDraftCarePlanMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateDraftCarePlanMutation, UpdateDraftCarePlanMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateDraftCarePlanMutation, UpdateDraftCarePlanMutationVariables>(
    UpdateDraftCarePlanDocument,
    options,
  );
}
export type UpdateDraftCarePlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDraftCarePlanMutation,
  UpdateDraftCarePlanMutationVariables
>;
export const UpdateDraftCarePlanTemplateDocument = gql`
  mutation updateDraftCarePlanTemplate($id: ID!, $updateInput: CarePlanTemplateUpdateInput) {
    updateDraftCarePlanTemplate(id: $id, updateInput: $updateInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useUpdateDraftCarePlanTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateDraftCarePlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftCarePlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDraftCarePlanTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateDraftCarePlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateDraftCarePlanTemplateMutation,
        UpdateDraftCarePlanTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateDraftCarePlanTemplateMutation,
          UpdateDraftCarePlanTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateDraftCarePlanTemplateMutation,
    UpdateDraftCarePlanTemplateMutationVariables
  >(UpdateDraftCarePlanTemplateDocument, options);
}
export type UpdateDraftCarePlanTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDraftCarePlanTemplateMutation,
  UpdateDraftCarePlanTemplateMutationVariables
>;
export const UpdateObservationTemplateDocument = gql`
  mutation updateObservationTemplate($id: ID!, $updateInput: ObservationInput!) {
    updateObservationTemplate(id: $id, updateInput: $updateInput) {
      observation {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useUpdateObservationTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateObservationTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObservationTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateObservationTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateObservationTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateObservationTemplateMutation,
        UpdateObservationTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateObservationTemplateMutation,
          UpdateObservationTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateObservationTemplateMutation, UpdateObservationTemplateMutationVariables>(
    UpdateObservationTemplateDocument,
    options,
  );
}
export type UpdateObservationTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateObservationTemplateMutation,
  UpdateObservationTemplateMutationVariables
>;
export const UpdateQuestionnaireDocument = gql`
  mutation updateQuestionnaire($carePlanId: ID!, $id: ID!, $updateInput: QuestionnaireInput) {
    updateCarePlanQuestionnaire(carePlanId: $carePlanId, questionnaireId: $id, updateInput: $updateInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      questionnaire {
        id
        version
        name
        status
        experimental
        title
        description
        effectivePeriod {
          start
          end
        }
        publisher
        patient
        purpose
        carePlan
        template
        item {
          linkId
          text
          type
          answerOption {
            valueInteger
            valueDecimal
            valueString
            valueCoding {
              code
              display
            }
          }
        }
      }
    }
  }
`;

/**
 * __useUpdateQuestionnaireMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionnaireMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionnaireMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateQuestionnaireMutation({
 *   variables: {
 *     carePlanId: // value for 'carePlanId'
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateQuestionnaireMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateQuestionnaireMutation, UpdateQuestionnaireMutationVariables>(
    UpdateQuestionnaireDocument,
    options,
  );
}
export type UpdateQuestionnaireMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateQuestionnaireMutation,
  UpdateQuestionnaireMutationVariables
>;
export const UpdateQuestionnaireTemplateDocument = gql`
  mutation updateQuestionnaireTemplate($id: ID!, $updateInput: QuestionnaireInput) {
    updateQuestionnaireTemplate(id: $id, updateInput: $updateInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      questionnaire {
        id
        version
        name
        status
        experimental
        title
        description
        effectivePeriod {
          start
          end
        }
        publisher
        patient
        purpose
        carePlan
        template
        item {
          linkId
          text
          type
          answerOption {
            valueInteger
            valueDecimal
            valueString
            valueCoding {
              code
              display
            }
          }
        }
      }
    }
  }
`;

/**
 * __useUpdateQuestionnaireTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionnaireTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionnaireTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateQuestionnaireTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateQuestionnaireTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateQuestionnaireTemplateMutation,
        UpdateQuestionnaireTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateQuestionnaireTemplateMutation,
          UpdateQuestionnaireTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateQuestionnaireTemplateMutation,
    UpdateQuestionnaireTemplateMutationVariables
  >(UpdateQuestionnaireTemplateDocument, options);
}
export type UpdateQuestionnaireTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateQuestionnaireTemplateMutation,
  UpdateQuestionnaireTemplateMutationVariables
>;
export const AddMyExternalIdDocument = gql`
  mutation addMyExternalId($externalUserId: ExternalHumanIdInput!) {
    addMyExternalId(externalUserId: $externalUserId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useAddMyExternalIdMutation__
 *
 * To run a mutation, you first call `useAddMyExternalIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddMyExternalIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddMyExternalIdMutation({
 *   variables: {
 *     externalUserId: // value for 'externalUserId'
 *   },
 * });
 */
export function useAddMyExternalIdMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddMyExternalIdMutation, AddMyExternalIdMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddMyExternalIdMutation, AddMyExternalIdMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddMyExternalIdMutation, AddMyExternalIdMutationVariables>(
    AddMyExternalIdDocument,
    options,
  );
}
export type AddMyExternalIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddMyExternalIdMutation,
  AddMyExternalIdMutationVariables
>;
export const AddRpmGatewayToPatientWithInputValidationDocument = gql`
  mutation addRpmGatewayToPatientWithInputValidation($patientId: ID!, $rpmGatewayId: ID!) {
    addRpmGatewayToPatient(patientId: $patientId, rpmGatewayId: $rpmGatewayId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      rpmGateway {
        id
        gatewayHostname
        modelNumber
      }
    }
  }
`;

/**
 * __useAddRpmGatewayToPatientWithInputValidationMutation__
 *
 * To run a mutation, you first call `useAddRpmGatewayToPatientWithInputValidationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddRpmGatewayToPatientWithInputValidationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddRpmGatewayToPatientWithInputValidationMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     rpmGatewayId: // value for 'rpmGatewayId'
 *   },
 * });
 */
export function useAddRpmGatewayToPatientWithInputValidationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddRpmGatewayToPatientWithInputValidationMutation,
        AddRpmGatewayToPatientWithInputValidationMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddRpmGatewayToPatientWithInputValidationMutation,
          AddRpmGatewayToPatientWithInputValidationMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddRpmGatewayToPatientWithInputValidationMutation,
    AddRpmGatewayToPatientWithInputValidationMutationVariables
  >(AddRpmGatewayToPatientWithInputValidationDocument, options);
}
export type AddRpmGatewayToPatientWithInputValidationMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    AddRpmGatewayToPatientWithInputValidationMutation,
    AddRpmGatewayToPatientWithInputValidationMutationVariables
  >;
export const AddRpmMedicalDeviceToPatientDocument = gql`
  mutation addRpmMedicalDeviceToPatient($patientId: ID!, $rpmMedicalDeviceId: ID!) {
    addRpmMedicalDeviceToPatient(patientId: $patientId, rpmMedicalDeviceId: $rpmMedicalDeviceId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      rpmMedicalDevice {
        modelName
        id
      }
    }
  }
`;

/**
 * __useAddRpmMedicalDeviceToPatientMutation__
 *
 * To run a mutation, you first call `useAddRpmMedicalDeviceToPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddRpmMedicalDeviceToPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddRpmMedicalDeviceToPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     rpmMedicalDeviceId: // value for 'rpmMedicalDeviceId'
 *   },
 * });
 */
export function useAddRpmMedicalDeviceToPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddRpmMedicalDeviceToPatientMutation,
        AddRpmMedicalDeviceToPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddRpmMedicalDeviceToPatientMutation,
          AddRpmMedicalDeviceToPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddRpmMedicalDeviceToPatientMutation,
    AddRpmMedicalDeviceToPatientMutationVariables
  >(AddRpmMedicalDeviceToPatientDocument, options);
}
export type AddRpmMedicalDeviceToPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddRpmMedicalDeviceToPatientMutation,
  AddRpmMedicalDeviceToPatientMutationVariables
>;
export const AddRpmMedicalDeviceToRpmGatewayDocument = gql`
  mutation addRpmMedicalDeviceToRpmGateway($rpmGatewayId: ID!, $rpmMedicalDeviceId: ID!) {
    addRpmMedicalDeviceToRpmGateway(rpmGatewayId: $rpmGatewayId, rpmMedicalDeviceId: $rpmMedicalDeviceId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      rpmGateway {
        id
        manufacturer
        serialNumber
        modelNumber
        btAddress
      }
    }
  }
`;

/**
 * __useAddRpmMedicalDeviceToRpmGatewayMutation__
 *
 * To run a mutation, you first call `useAddRpmMedicalDeviceToRpmGatewayMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddRpmMedicalDeviceToRpmGatewayMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddRpmMedicalDeviceToRpmGatewayMutation({
 *   variables: {
 *     rpmGatewayId: // value for 'rpmGatewayId'
 *     rpmMedicalDeviceId: // value for 'rpmMedicalDeviceId'
 *   },
 * });
 */
export function useAddRpmMedicalDeviceToRpmGatewayMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddRpmMedicalDeviceToRpmGatewayMutation,
        AddRpmMedicalDeviceToRpmGatewayMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddRpmMedicalDeviceToRpmGatewayMutation,
          AddRpmMedicalDeviceToRpmGatewayMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddRpmMedicalDeviceToRpmGatewayMutation,
    AddRpmMedicalDeviceToRpmGatewayMutationVariables
  >(AddRpmMedicalDeviceToRpmGatewayDocument, options);
}
export type AddRpmMedicalDeviceToRpmGatewayMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddRpmMedicalDeviceToRpmGatewayMutation,
  AddRpmMedicalDeviceToRpmGatewayMutationVariables
>;
export const ClearRpmMedicalDeviceFromRpmGatewayDocument = gql`
  mutation clearRpmMedicalDeviceFromRpmGateway($rpmGatewayId: ID!, $rpmMedicalDeviceId: ID!) {
    clearRpmMedicalDeviceFromRpmGateway(rpmGatewayId: $rpmGatewayId, rpmMedicalDeviceId: $rpmMedicalDeviceId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useClearRpmMedicalDeviceFromRpmGatewayMutation__
 *
 * To run a mutation, you first call `useClearRpmMedicalDeviceFromRpmGatewayMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useClearRpmMedicalDeviceFromRpmGatewayMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useClearRpmMedicalDeviceFromRpmGatewayMutation({
 *   variables: {
 *     rpmGatewayId: // value for 'rpmGatewayId'
 *     rpmMedicalDeviceId: // value for 'rpmMedicalDeviceId'
 *   },
 * });
 */
export function useClearRpmMedicalDeviceFromRpmGatewayMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ClearRpmMedicalDeviceFromRpmGatewayMutation,
        ClearRpmMedicalDeviceFromRpmGatewayMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ClearRpmMedicalDeviceFromRpmGatewayMutation,
          ClearRpmMedicalDeviceFromRpmGatewayMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ClearRpmMedicalDeviceFromRpmGatewayMutation,
    ClearRpmMedicalDeviceFromRpmGatewayMutationVariables
  >(ClearRpmMedicalDeviceFromRpmGatewayDocument, options);
}
export type ClearRpmMedicalDeviceFromRpmGatewayMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    ClearRpmMedicalDeviceFromRpmGatewayMutation,
    ClearRpmMedicalDeviceFromRpmGatewayMutationVariables
  >;
export const ClearRpmMedicalDevicePairingWithRpmGatewayDocument = gql`
  mutation clearRpmMedicalDevicePairingWithRpmGateway($rpmGatewayId: ID!, $rpmMedicalDeviceId: ID!) {
    clearRpmMedicalDevicePairingWithRpmGateway(rpmGatewayId: $rpmGatewayId, rpmMedicalDeviceId: $rpmMedicalDeviceId) {
      success
      message
    }
  }
`;

/**
 * __useClearRpmMedicalDevicePairingWithRpmGatewayMutation__
 *
 * To run a mutation, you first call `useClearRpmMedicalDevicePairingWithRpmGatewayMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useClearRpmMedicalDevicePairingWithRpmGatewayMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useClearRpmMedicalDevicePairingWithRpmGatewayMutation({
 *   variables: {
 *     rpmGatewayId: // value for 'rpmGatewayId'
 *     rpmMedicalDeviceId: // value for 'rpmMedicalDeviceId'
 *   },
 * });
 */
export function useClearRpmMedicalDevicePairingWithRpmGatewayMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ClearRpmMedicalDevicePairingWithRpmGatewayMutation,
        ClearRpmMedicalDevicePairingWithRpmGatewayMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ClearRpmMedicalDevicePairingWithRpmGatewayMutation,
          ClearRpmMedicalDevicePairingWithRpmGatewayMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ClearRpmMedicalDevicePairingWithRpmGatewayMutation,
    ClearRpmMedicalDevicePairingWithRpmGatewayMutationVariables
  >(ClearRpmMedicalDevicePairingWithRpmGatewayDocument, options);
}
export type ClearRpmMedicalDevicePairingWithRpmGatewayMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    ClearRpmMedicalDevicePairingWithRpmGatewayMutation,
    ClearRpmMedicalDevicePairingWithRpmGatewayMutationVariables
  >;
export const CreateRpmGatewayDocument = gql`
  mutation createRpmGateway($createInput: RpmGatewayCreateInput!) {
    createRpmGateway(createInput: $createInput) {
      success
      message
      rpmGateway {
        id
        gatewayHostname
      }
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useCreateRpmGatewayMutation__
 *
 * To run a mutation, you first call `useCreateRpmGatewayMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateRpmGatewayMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateRpmGatewayMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateRpmGatewayMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateRpmGatewayMutation, CreateRpmGatewayMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateRpmGatewayMutation, CreateRpmGatewayMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateRpmGatewayMutation, CreateRpmGatewayMutationVariables>(
    CreateRpmGatewayDocument,
    options,
  );
}
export type CreateRpmGatewayMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateRpmGatewayMutation,
  CreateRpmGatewayMutationVariables
>;
export const CreateRpmMedicalDeviceDocument = gql`
  mutation createRpmMedicalDevice($createInput: RpmMedicalDeviceCreateInput!) {
    createRpmMedicalDevice(createInput: $createInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      rpmMedicalDevice {
        id
        manufacturer
        serialNumber
        modelNumber
        btAddress
      }
    }
  }
`;

/**
 * __useCreateRpmMedicalDeviceMutation__
 *
 * To run a mutation, you first call `useCreateRpmMedicalDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateRpmMedicalDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateRpmMedicalDeviceMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateRpmMedicalDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateRpmMedicalDeviceMutation, CreateRpmMedicalDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateRpmMedicalDeviceMutation, CreateRpmMedicalDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateRpmMedicalDeviceMutation, CreateRpmMedicalDeviceMutationVariables>(
    CreateRpmMedicalDeviceDocument,
    options,
  );
}
export type CreateRpmMedicalDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateRpmMedicalDeviceMutation,
  CreateRpmMedicalDeviceMutationVariables
>;
export const DeleteRpmGatewayDocument = gql`
  mutation deleteRpmGateway($id: ID!) {
    deleteRpmGateway(id: $id) {
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
      }
    }
  }
`;

/**
 * __useDeleteRpmGatewayMutation__
 *
 * To run a mutation, you first call `useDeleteRpmGatewayMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRpmGatewayMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteRpmGatewayMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRpmGatewayMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteRpmGatewayMutation, DeleteRpmGatewayMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteRpmGatewayMutation, DeleteRpmGatewayMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteRpmGatewayMutation, DeleteRpmGatewayMutationVariables>(
    DeleteRpmGatewayDocument,
    options,
  );
}
export type DeleteRpmGatewayMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteRpmGatewayMutation,
  DeleteRpmGatewayMutationVariables
>;
export const DeleteRpmMedicalDeviceDocument = gql`
  mutation deleteRpmMedicalDevice($id: ID!) {
    deleteRpmMedicalDevice(id: $id) {
      success
    }
  }
`;

/**
 * __useDeleteRpmMedicalDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteRpmMedicalDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRpmMedicalDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteRpmMedicalDeviceMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRpmMedicalDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteRpmMedicalDeviceMutation, DeleteRpmMedicalDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteRpmMedicalDeviceMutation, DeleteRpmMedicalDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteRpmMedicalDeviceMutation, DeleteRpmMedicalDeviceMutationVariables>(
    DeleteRpmMedicalDeviceDocument,
    options,
  );
}
export type DeleteRpmMedicalDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteRpmMedicalDeviceMutation,
  DeleteRpmMedicalDeviceMutationVariables
>;
export const RemoveRpmGatewayFromPatientDocument = gql`
  mutation removeRpmGatewayFromPatient($patientId: ID!, $rpmGatewayId: ID!) {
    removeRpmGatewayFromPatient(patientId: $patientId, rpmGatewayId: $rpmGatewayId) {
      success
    }
  }
`;

/**
 * __useRemoveRpmGatewayFromPatientMutation__
 *
 * To run a mutation, you first call `useRemoveRpmGatewayFromPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRpmGatewayFromPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveRpmGatewayFromPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     rpmGatewayId: // value for 'rpmGatewayId'
 *   },
 * });
 */
export function useRemoveRpmGatewayFromPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveRpmGatewayFromPatientMutation,
        RemoveRpmGatewayFromPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveRpmGatewayFromPatientMutation,
          RemoveRpmGatewayFromPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveRpmGatewayFromPatientMutation,
    RemoveRpmGatewayFromPatientMutationVariables
  >(RemoveRpmGatewayFromPatientDocument, options);
}
export type RemoveRpmGatewayFromPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveRpmGatewayFromPatientMutation,
  RemoveRpmGatewayFromPatientMutationVariables
>;
export const RemoveRpmMedicalDeviceFromPatientDocument = gql`
  mutation removeRpmMedicalDeviceFromPatient($patientId: ID!, $rpmMedicalDeviceId: ID!) {
    removeRpmMedicalDeviceFromPatient(patientId: $patientId, rpmMedicalDeviceId: $rpmMedicalDeviceId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useRemoveRpmMedicalDeviceFromPatientMutation__
 *
 * To run a mutation, you first call `useRemoveRpmMedicalDeviceFromPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRpmMedicalDeviceFromPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveRpmMedicalDeviceFromPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     rpmMedicalDeviceId: // value for 'rpmMedicalDeviceId'
 *   },
 * });
 */
export function useRemoveRpmMedicalDeviceFromPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveRpmMedicalDeviceFromPatientMutation,
        RemoveRpmMedicalDeviceFromPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveRpmMedicalDeviceFromPatientMutation,
          RemoveRpmMedicalDeviceFromPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveRpmMedicalDeviceFromPatientMutation,
    RemoveRpmMedicalDeviceFromPatientMutationVariables
  >(RemoveRpmMedicalDeviceFromPatientDocument, options);
}
export type RemoveRpmMedicalDeviceFromPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveRpmMedicalDeviceFromPatientMutation,
  RemoveRpmMedicalDeviceFromPatientMutationVariables
>;
export const UpdateRpmGatewayDocument = gql`
  mutation updateRpmGateway($id: ID!, $updateInput: RpmGatewayUpdateInput!) {
    updateRpmGateway(id: $id, updateInput: $updateInput) {
      success
      message
      rpmGateway {
        id
        gatewayHostname
      }
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdateRpmGatewayMutation__
 *
 * To run a mutation, you first call `useUpdateRpmGatewayMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRpmGatewayMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRpmGatewayMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateRpmGatewayMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateRpmGatewayMutation, UpdateRpmGatewayMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateRpmGatewayMutation, UpdateRpmGatewayMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateRpmGatewayMutation, UpdateRpmGatewayMutationVariables>(
    UpdateRpmGatewayDocument,
    options,
  );
}
export type UpdateRpmGatewayMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateRpmGatewayMutation,
  UpdateRpmGatewayMutationVariables
>;
export const ConcreteObservationDocument = gql`
  query concreteObservation($observationId: ID!) {
    concreteObservation(observationId: $observationId) {
      id
      manual
      gateway {
        display
      }
      identifier {
        value
      }
      basedOn {
        reference
        identifier {
          value
        }
      }
      status
      code {
        coding {
          system
          code
          display
        }
        text
      }
      device {
        reference
        display
      }
      subject {
        reference
      }
      performer {
        reference
        display
      }
      effectiveDateTime
      received
      component {
        code {
          coding {
            system
            code
            display
          }
          text
        }
        valueQuantity {
          value
          unit
        }
        referenceRange {
          low {
            value
            unit
          }
          high {
            value
            unit
          }
          text
          type {
            coding {
              system
              version
              code
              display
              userSelected
            }
            text
          }
        }
        interpretation {
          coding {
            system
            version
            code
            display
            userSelected
          }
          text
        }
      }
      instantiates {
        reference
      }
    }
  }
`;

/**
 * __useConcreteObservationQuery__
 *
 * To run a query within a Vue component, call `useConcreteObservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConcreteObservationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useConcreteObservationQuery({
 *   observationId: // value for 'observationId'
 * });
 */
export function useConcreteObservationQuery(
  variables:
    | ConcreteObservationQueryVariables
    | VueCompositionApi.Ref<ConcreteObservationQueryVariables>
    | ReactiveFunction<ConcreteObservationQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ConcreteObservationQuery, ConcreteObservationQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ConcreteObservationQuery, ConcreteObservationQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ConcreteObservationQuery, ConcreteObservationQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ConcreteObservationQuery, ConcreteObservationQueryVariables>(
    ConcreteObservationDocument,
    variables,
    options,
  );
}
export function useConcreteObservationLazyQuery(
  variables?:
    | ConcreteObservationQueryVariables
    | VueCompositionApi.Ref<ConcreteObservationQueryVariables>
    | ReactiveFunction<ConcreteObservationQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ConcreteObservationQuery, ConcreteObservationQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ConcreteObservationQuery, ConcreteObservationQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ConcreteObservationQuery, ConcreteObservationQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ConcreteObservationQuery, ConcreteObservationQueryVariables>(
    ConcreteObservationDocument,
    variables,
    options,
  );
}
export type ConcreteObservationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ConcreteObservationQuery,
  ConcreteObservationQueryVariables
>;
export const GetCarePlanByIdDocument = gql`
  query getCarePlanByID($carePlanId: ID!) {
    getCarePlanByID(carePlanId: $carePlanId) {
      id
      status
      subject {
        reference
      }
      title
      description
      created
      period {
        start
        end
      }
      activity {
        outcomeReference {
          reference
          identifier {
            value
          }
          display
          type
        }
        observations {
          id
          identifier {
            value
          }
          text
          basedOn {
            reference
          }
          status
          note {
            text
          }
          fromTemplate {
            reference
          }
          code {
            coding {
              system
              version
              code
              display
            }
            text
          }
          component {
            code {
              coding {
                system
                version
                code
                display
              }
              text
            }
            valueQuantity {
              value
              unit
            }
            referenceRange {
              low {
                value
                unit
              }
              high {
                value
                unit
              }
              text
              type {
                coding {
                  system
                  version
                  code
                  display
                }
                text
              }
            }
          }
        }
        detail {
          instantiatesCanonical
          questionnaires {
            id
            title
            derivedFrom
          }
          status
          scheduledTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
        }
      }
      documents {
        id
        content {
          attachment {
            title
            contentType
            url
            size
            creation
          }
        }
      }
    }
  }
`;

/**
 * __useGetCarePlanByIdQuery__
 *
 * To run a query within a Vue component, call `useGetCarePlanByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarePlanByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCarePlanByIdQuery({
 *   carePlanId: // value for 'carePlanId'
 * });
 */
export function useGetCarePlanByIdQuery(
  variables:
    | GetCarePlanByIdQueryVariables
    | VueCompositionApi.Ref<GetCarePlanByIdQueryVariables>
    | ReactiveFunction<GetCarePlanByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>(
    GetCarePlanByIdDocument,
    variables,
    options,
  );
}
export function useGetCarePlanByIdLazyQuery(
  variables?:
    | GetCarePlanByIdQueryVariables
    | VueCompositionApi.Ref<GetCarePlanByIdQueryVariables>
    | ReactiveFunction<GetCarePlanByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetCarePlanByIdQuery, GetCarePlanByIdQueryVariables>(
    GetCarePlanByIdDocument,
    variables,
    options,
  );
}
export type GetCarePlanByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCarePlanByIdQuery,
  GetCarePlanByIdQueryVariables
>;
export const GetCarePlanTitleQueryDocument = gql`
  query getCarePlanTitleQuery($carePlanId: ID!) {
    getCarePlanByID(carePlanId: $carePlanId) {
      title
    }
  }
`;

/**
 * __useGetCarePlanTitleQueryQuery__
 *
 * To run a query within a Vue component, call `useGetCarePlanTitleQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarePlanTitleQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCarePlanTitleQueryQuery({
 *   carePlanId: // value for 'carePlanId'
 * });
 */
export function useGetCarePlanTitleQueryQuery(
  variables:
    | GetCarePlanTitleQueryQueryVariables
    | VueCompositionApi.Ref<GetCarePlanTitleQueryQueryVariables>
    | ReactiveFunction<GetCarePlanTitleQueryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>(
    GetCarePlanTitleQueryDocument,
    variables,
    options,
  );
}
export function useGetCarePlanTitleQueryLazyQuery(
  variables?:
    | GetCarePlanTitleQueryQueryVariables
    | VueCompositionApi.Ref<GetCarePlanTitleQueryQueryVariables>
    | ReactiveFunction<GetCarePlanTitleQueryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCarePlanTitleQueryQuery, GetCarePlanTitleQueryQueryVariables>(
    GetCarePlanTitleQueryDocument,
    variables,
    options,
  );
}
export type GetCarePlanTitleQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCarePlanTitleQueryQuery,
  GetCarePlanTitleQueryQueryVariables
>;
export const GetCarePlanDocumentsQueryDocument = gql`
  query getCarePlanDocumentsQuery($carePlanId: ID!) {
    getCarePlanByID(carePlanId: $carePlanId) {
      documents {
        id
        content {
          attachment {
            title
            contentType
            url
            size
            creation
          }
        }
      }
    }
  }
`;

/**
 * __useGetCarePlanDocumentsQueryQuery__
 *
 * To run a query within a Vue component, call `useGetCarePlanDocumentsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarePlanDocumentsQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCarePlanDocumentsQueryQuery({
 *   carePlanId: // value for 'carePlanId'
 * });
 */
export function useGetCarePlanDocumentsQueryQuery(
  variables:
    | GetCarePlanDocumentsQueryQueryVariables
    | VueCompositionApi.Ref<GetCarePlanDocumentsQueryQueryVariables>
    | ReactiveFunction<GetCarePlanDocumentsQueryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>(
    GetCarePlanDocumentsQueryDocument,
    variables,
    options,
  );
}
export function useGetCarePlanDocumentsQueryLazyQuery(
  variables?:
    | GetCarePlanDocumentsQueryQueryVariables
    | VueCompositionApi.Ref<GetCarePlanDocumentsQueryQueryVariables>
    | ReactiveFunction<GetCarePlanDocumentsQueryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCarePlanDocumentsQueryQuery, GetCarePlanDocumentsQueryQueryVariables>(
    GetCarePlanDocumentsQueryDocument,
    variables,
    options,
  );
}
export type GetCarePlanDocumentsQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCarePlanDocumentsQueryQuery,
  GetCarePlanDocumentsQueryQueryVariables
>;
export const GetCarePlanTemplateDocument = gql`
  query getCarePlanTemplate($id: ID!) {
    getCarePlanTemplate(id: $id) {
      id
      status
      title
      description
      created
      carePlanType
      period {
        start
        end
      }
      activity {
        outcomeReference {
          reference
          identifier {
            value
          }
          display
          type
        }
        observations {
          id
          identifier {
            value
          }
          text
          basedOn {
            reference
          }
          status
          note {
            text
          }
          fromTemplate {
            reference
          }
          code {
            coding {
              system
              version
              code
              display
            }
            text
          }
          component {
            code {
              coding {
                system
                version
                code
                display
              }
              text
            }
            valueQuantity {
              value
              unit
            }
            referenceRange {
              low {
                value
                unit
              }
              high {
                value
                unit
              }
              text
              type {
                coding {
                  system
                  version
                  code
                  display
                }
                text
              }
            }
          }
        }
        detail {
          instantiatesCanonical
          questionnaires {
            id
            title
            derivedFrom
          }
          status
          scheduledTiming {
            repeat {
              dayOfWeek
              timeOfDay
            }
          }
        }
      }
      documents {
        id
        content {
          attachment {
            title
            contentType
            url
            size
            creation
          }
        }
      }
    }
  }
`;

/**
 * __useGetCarePlanTemplateQuery__
 *
 * To run a query within a Vue component, call `useGetCarePlanTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarePlanTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCarePlanTemplateQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCarePlanTemplateQuery(
  variables:
    | GetCarePlanTemplateQueryVariables
    | VueCompositionApi.Ref<GetCarePlanTemplateQueryVariables>
    | ReactiveFunction<GetCarePlanTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>(
    GetCarePlanTemplateDocument,
    variables,
    options,
  );
}
export function useGetCarePlanTemplateLazyQuery(
  variables?:
    | GetCarePlanTemplateQueryVariables
    | VueCompositionApi.Ref<GetCarePlanTemplateQueryVariables>
    | ReactiveFunction<GetCarePlanTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCarePlanTemplateQuery, GetCarePlanTemplateQueryVariables>(
    GetCarePlanTemplateDocument,
    variables,
    options,
  );
}
export type GetCarePlanTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCarePlanTemplateQuery,
  GetCarePlanTemplateQueryVariables
>;
export const GetObservationTemplateDocument = gql`
  query getObservationTemplate($id: ID!) {
    getObservationTemplate(id: $id) {
      id
      systemDefined
      identifier {
        value
      }
      status
      code {
        coding {
          system
          display
          code
        }
        text
      }
      component {
        valueQuantity {
          unit
        }
        code {
          coding {
            system
            display
            code
          }
          text
        }
        referenceRange {
          low {
            value
          }
          high {
            value
          }
          text
          type {
            text
            coding {
              code
              display
            }
          }
        }
        dataAbsentReason {
          text
        }
      }
    }
  }
`;

/**
 * __useGetObservationTemplateQuery__
 *
 * To run a query within a Vue component, call `useGetObservationTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObservationTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetObservationTemplateQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetObservationTemplateQuery(
  variables:
    | GetObservationTemplateQueryVariables
    | VueCompositionApi.Ref<GetObservationTemplateQueryVariables>
    | ReactiveFunction<GetObservationTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>(
    GetObservationTemplateDocument,
    variables,
    options,
  );
}
export function useGetObservationTemplateLazyQuery(
  variables?:
    | GetObservationTemplateQueryVariables
    | VueCompositionApi.Ref<GetObservationTemplateQueryVariables>
    | ReactiveFunction<GetObservationTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetObservationTemplateQuery, GetObservationTemplateQueryVariables>(
    GetObservationTemplateDocument,
    variables,
    options,
  );
}
export type GetObservationTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetObservationTemplateQuery,
  GetObservationTemplateQueryVariables
>;
export const GetPatientTasksNotCompletedDocument = gql`
  query getPatientTasksNotCompleted($tasks: [String!]!) {
    getPatientTasksNotCompleted(tasks: $tasks) {
      task {
        id
        authoredOn
      }
      patientTasks {
        id
        code {
          text
        }
        restriction {
          period {
            start
            end
          }
        }
      }
    }
  }
`;

/**
 * __useGetPatientTasksNotCompletedQuery__
 *
 * To run a query within a Vue component, call `useGetPatientTasksNotCompletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientTasksNotCompletedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientTasksNotCompletedQuery({
 *   tasks: // value for 'tasks'
 * });
 */
export function useGetPatientTasksNotCompletedQuery(
  variables:
    | GetPatientTasksNotCompletedQueryVariables
    | VueCompositionApi.Ref<GetPatientTasksNotCompletedQueryVariables>
    | ReactiveFunction<GetPatientTasksNotCompletedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>(
    GetPatientTasksNotCompletedDocument,
    variables,
    options,
  );
}
export function useGetPatientTasksNotCompletedLazyQuery(
  variables?:
    | GetPatientTasksNotCompletedQueryVariables
    | VueCompositionApi.Ref<GetPatientTasksNotCompletedQueryVariables>
    | ReactiveFunction<GetPatientTasksNotCompletedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientTasksNotCompletedQuery, GetPatientTasksNotCompletedQueryVariables>(
    GetPatientTasksNotCompletedDocument,
    variables,
    options,
  );
}
export type GetPatientTasksNotCompletedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientTasksNotCompletedQuery,
  GetPatientTasksNotCompletedQueryVariables
>;
export const GetQuestionnaireResponseByIdDocument = gql`
  query getQuestionnaireResponseById($questionnaireResponseId: ID!) {
    getQuestionnaireResponseById(questionnaireResponseId: $questionnaireResponseId) {
      id
      authored
      received
      subject {
        reference
      }
      source {
        reference
        display
      }
      displayItem {
        linkId
        type
        questionText
        answerText
        code
        score
      }
      displaySummary {
        priorities {
          mode
          thresholds {
            code
            value
          }
          points {
            code
            value
          }
        }
        score
        computedTaskPriority {
          code
          value
        }
      }
      questionnaireObject {
        id
        title
        carePlanObject {
          title
        }
        patientObject {
          name {
            given
            family
          }
        }
      }
    }
  }
`;

/**
 * __useGetQuestionnaireResponseByIdQuery__
 *
 * To run a query within a Vue component, call `useGetQuestionnaireResponseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireResponseByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQuestionnaireResponseByIdQuery({
 *   questionnaireResponseId: // value for 'questionnaireResponseId'
 * });
 */
export function useGetQuestionnaireResponseByIdQuery(
  variables:
    | GetQuestionnaireResponseByIdQueryVariables
    | VueCompositionApi.Ref<GetQuestionnaireResponseByIdQueryVariables>
    | ReactiveFunction<GetQuestionnaireResponseByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetQuestionnaireResponseByIdQuery, GetQuestionnaireResponseByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponseByIdQuery,
          GetQuestionnaireResponseByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponseByIdQuery,
          GetQuestionnaireResponseByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetQuestionnaireResponseByIdQuery, GetQuestionnaireResponseByIdQueryVariables>(
    GetQuestionnaireResponseByIdDocument,
    variables,
    options,
  );
}
export function useGetQuestionnaireResponseByIdLazyQuery(
  variables?:
    | GetQuestionnaireResponseByIdQueryVariables
    | VueCompositionApi.Ref<GetQuestionnaireResponseByIdQueryVariables>
    | ReactiveFunction<GetQuestionnaireResponseByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetQuestionnaireResponseByIdQuery, GetQuestionnaireResponseByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponseByIdQuery,
          GetQuestionnaireResponseByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponseByIdQuery,
          GetQuestionnaireResponseByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetQuestionnaireResponseByIdQuery,
    GetQuestionnaireResponseByIdQueryVariables
  >(GetQuestionnaireResponseByIdDocument, variables, options);
}
export type GetQuestionnaireResponseByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetQuestionnaireResponseByIdQuery,
  GetQuestionnaireResponseByIdQueryVariables
>;
export const GetQuestionnaireResponsesForPatientDocument = gql`
  query getQuestionnaireResponsesForPatient($patientId: ID!, $from: dateTime, $to: dateTime) {
    getQuestionnaireResponsesForPatient(patientId: $patientId, from: $from, to: $to) {
      id
      authored
      displayItem {
        answerText
        code
        linkId
        questionText
        score
        type
      }
      questionnaireObject {
        id
        title
        carePlanObject {
          title
        }
        patientObject {
          name {
            given
            family
          }
        }
      }
    }
  }
`;

/**
 * __useGetQuestionnaireResponsesForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetQuestionnaireResponsesForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireResponsesForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQuestionnaireResponsesForPatientQuery({
 *   patientId: // value for 'patientId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useGetQuestionnaireResponsesForPatientQuery(
  variables:
    | GetQuestionnaireResponsesForPatientQueryVariables
    | VueCompositionApi.Ref<GetQuestionnaireResponsesForPatientQueryVariables>
    | ReactiveFunction<GetQuestionnaireResponsesForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetQuestionnaireResponsesForPatientQuery,
        GetQuestionnaireResponsesForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponsesForPatientQuery,
          GetQuestionnaireResponsesForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponsesForPatientQuery,
          GetQuestionnaireResponsesForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetQuestionnaireResponsesForPatientQuery,
    GetQuestionnaireResponsesForPatientQueryVariables
  >(GetQuestionnaireResponsesForPatientDocument, variables, options);
}
export function useGetQuestionnaireResponsesForPatientLazyQuery(
  variables?:
    | GetQuestionnaireResponsesForPatientQueryVariables
    | VueCompositionApi.Ref<GetQuestionnaireResponsesForPatientQueryVariables>
    | ReactiveFunction<GetQuestionnaireResponsesForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetQuestionnaireResponsesForPatientQuery,
        GetQuestionnaireResponsesForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponsesForPatientQuery,
          GetQuestionnaireResponsesForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetQuestionnaireResponsesForPatientQuery,
          GetQuestionnaireResponsesForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetQuestionnaireResponsesForPatientQuery,
    GetQuestionnaireResponsesForPatientQueryVariables
  >(GetQuestionnaireResponsesForPatientDocument, variables, options);
}
export type GetQuestionnaireResponsesForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetQuestionnaireResponsesForPatientQuery,
  GetQuestionnaireResponsesForPatientQueryVariables
>;
export const GetTasksForPatientDocument = gql`
  query getTasksForPatient($patientId: ID!, $from: dateTime, $to: dateTime) {
    getTasksForPatient(patientId: $patientId, from: $from, to: $to) {
      id
      code {
        text
      }
      status
      priority
      authoredOn
      note {
        authorString
        time
        text
      }
      owner {
        identifier {
          value
        }
        display
      }
      carePlan {
        id
        title
      }
      patient {
        id
        name {
          text
        }
        identifier {
          value
        }
      }
      subTasks {
        id
        code {
          text
        }
        authoredOn
        intent
        priority
        status
        partOf {
          reference
        }
        note {
          authorString
          time
          text
          authorReference {
            display
            reference
          }
        }
        focus {
          reference
        }
      }
    }
  }
`;

/**
 * __useGetTasksForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetTasksForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTasksForPatientQuery({
 *   patientId: // value for 'patientId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useGetTasksForPatientQuery(
  variables:
    | GetTasksForPatientQueryVariables
    | VueCompositionApi.Ref<GetTasksForPatientQueryVariables>
    | ReactiveFunction<GetTasksForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>(
    GetTasksForPatientDocument,
    variables,
    options,
  );
}
export function useGetTasksForPatientLazyQuery(
  variables?:
    | GetTasksForPatientQueryVariables
    | VueCompositionApi.Ref<GetTasksForPatientQueryVariables>
    | ReactiveFunction<GetTasksForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetTasksForPatientQuery, GetTasksForPatientQueryVariables>(
    GetTasksForPatientDocument,
    variables,
    options,
  );
}
export type GetTasksForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetTasksForPatientQuery,
  GetTasksForPatientQueryVariables
>;
export const GetTasksForPatientByDateRangeDocument = gql`
  query getTasksForPatientByDateRange($id: ID, $fromDate: dateTime, $toDate: dateTime) {
    getTasksForPatientByDateRange(id: $id, fromDate: $fromDate, toDate: $toDate) {
      task {
        id
        status
        code {
          text
        }
        description
        priority
        authoredOn
        lastModified
        restriction {
          period {
            start
            end
          }
        }
        reminderDate
        reminderSent
        carePlan {
          id
          title
        }
      }
      hpTasks
    }
  }
`;

/**
 * __useGetTasksForPatientByDateRangeQuery__
 *
 * To run a query within a Vue component, call `useGetTasksForPatientByDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksForPatientByDateRangeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTasksForPatientByDateRangeQuery({
 *   id: // value for 'id'
 *   fromDate: // value for 'fromDate'
 *   toDate: // value for 'toDate'
 * });
 */
export function useGetTasksForPatientByDateRangeQuery(
  variables:
    | GetTasksForPatientByDateRangeQueryVariables
    | VueCompositionApi.Ref<GetTasksForPatientByDateRangeQueryVariables>
    | ReactiveFunction<GetTasksForPatientByDateRangeQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        GetTasksForPatientByDateRangeQuery,
        GetTasksForPatientByDateRangeQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetTasksForPatientByDateRangeQuery,
          GetTasksForPatientByDateRangeQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetTasksForPatientByDateRangeQuery,
          GetTasksForPatientByDateRangeQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetTasksForPatientByDateRangeQuery, GetTasksForPatientByDateRangeQueryVariables>(
    GetTasksForPatientByDateRangeDocument,
    variables,
    options,
  );
}
export function useGetTasksForPatientByDateRangeLazyQuery(
  variables:
    | GetTasksForPatientByDateRangeQueryVariables
    | VueCompositionApi.Ref<GetTasksForPatientByDateRangeQueryVariables>
    | ReactiveFunction<GetTasksForPatientByDateRangeQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        GetTasksForPatientByDateRangeQuery,
        GetTasksForPatientByDateRangeQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetTasksForPatientByDateRangeQuery,
          GetTasksForPatientByDateRangeQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetTasksForPatientByDateRangeQuery,
          GetTasksForPatientByDateRangeQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetTasksForPatientByDateRangeQuery,
    GetTasksForPatientByDateRangeQueryVariables
  >(GetTasksForPatientByDateRangeDocument, variables, options);
}
export type GetTasksForPatientByDateRangeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetTasksForPatientByDateRangeQuery,
  GetTasksForPatientByDateRangeQueryVariables
>;
export const LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientDocument = gql`
  query lastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatient(
    $patientId: ID!
    $carePlanId: ID
    $loincCode: String
  ) {
    lastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatient(
      patientId: $patientId
      carePlanId: $carePlanId
      loincCode: $loincCode
    ) {
      manual
      id
      identifier {
        value
      }
      text
      basedOn {
        reference
        identifier {
          value
        }
      }
      status
      code {
        coding {
          system
          code
          display
        }
        text
      }
      subject {
        reference
      }
      performer {
        reference
        display
      }
      effectiveDateTime
      note {
        authorString
        authorReference {
          reference
          identifier {
            system
            use
            value
            type {
              coding {
                system
                version
                code
                display
                userSelected
              }
              text
            }
          }
          type
          display
        }
        time
        text
      }
      component {
        code {
          coding {
            system
            code
            display
          }
          text
        }
        valueQuantity {
          value
          unit
        }
        referenceRange {
          low {
            value
            unit
          }
          high {
            value
            unit
          }
          text
          type {
            coding {
              system
              version
              code
              display
              userSelected
            }
            text
          }
        }
        interpretation {
          coding {
            system
            version
            code
            display
            userSelected
          }
          text
        }
      }
      instantiates {
        reference
      }
    }
  }
`;

/**
 * __useLastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery__
 *
 * To run a query within a Vue component, call `useLastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery({
 *   patientId: // value for 'patientId'
 *   carePlanId: // value for 'carePlanId'
 *   loincCode: // value for 'loincCode'
 * });
 */
export function useLastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery(
  variables:
    | LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
    | VueCompositionApi.Ref<LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables>
    | ReactiveFunction<LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
        LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
    LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
  >(LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientDocument, variables, options);
}
export function useLastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientLazyQuery(
  variables?:
    | LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
    | VueCompositionApi.Ref<LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables>
    | ReactiveFunction<LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
        LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
          LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
    LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
  >(LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientDocument, variables, options);
}
export type LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQuery,
    LastOneHundredConcreteMeasurementsSinceLastSixtyDaysForPatientQueryVariables
  >;
export const GetAllObservationTemplatesDocument = gql`
  query getAllObservationTemplates {
    getAllObservationTemplates {
      id
      systemDefined
      identifier {
        value
      }
      status
      code {
        coding {
          system
          display
          code
        }
        text
      }
      component {
        valueQuantity {
          unit
        }
        code {
          coding {
            system
            display
            code
          }
          text
        }
        referenceRange {
          low {
            value
            unit
          }
          high {
            value
            unit
          }
          text
          type {
            text
            coding {
              code
              display
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetAllObservationTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetAllObservationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllObservationTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllObservationTemplatesQuery();
 */
export function useGetAllObservationTemplatesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>(
    GetAllObservationTemplatesDocument,
    {},
    options,
  );
}
export function useGetAllObservationTemplatesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllObservationTemplatesQuery, GetAllObservationTemplatesQueryVariables>(
    GetAllObservationTemplatesDocument,
    {},
    options,
  );
}
export type GetAllObservationTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllObservationTemplatesQuery,
  GetAllObservationTemplatesQueryVariables
>;
export const GetConcreteObservationsForPatientDocument = gql`
  query getConcreteObservationsForPatient($patientId: ID!, $carePlan: ID, $from: dateTime, $to: dateTime) {
    getConcreteObservationsForPatient(patientId: $patientId, carePlan: $carePlan, from: $from, to: $to) {
      manual
      id
      identifier {
        value
      }
      text
      basedOn {
        reference
        identifier {
          value
        }
      }
      status
      code {
        coding {
          system
          code
          display
        }
        text
      }
      subject {
        reference
      }
      performer {
        reference
        display
      }
      effectiveDateTime
      note {
        authorString
        authorReference {
          reference
          identifier {
            system
            use
            value
            type {
              coding {
                system
                version
                code
                display
                userSelected
              }
              text
            }
          }
          type
          display
        }
        time
        text
      }
      component {
        code {
          coding {
            system
            code
            display
          }
          text
        }
        valueQuantity {
          value
          unit
        }
        referenceRange {
          low {
            value
            unit
          }
          high {
            value
            unit
          }
          text
          type {
            coding {
              system
              version
              code
              display
              userSelected
            }
            text
          }
        }
        interpretation {
          coding {
            system
            version
            code
            display
            userSelected
          }
          text
        }
      }
      instantiates {
        reference
      }
    }
  }
`;

/**
 * __useGetConcreteObservationsForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetConcreteObservationsForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConcreteObservationsForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConcreteObservationsForPatientQuery({
 *   patientId: // value for 'patientId'
 *   carePlan: // value for 'carePlan'
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useGetConcreteObservationsForPatientQuery(
  variables:
    | GetConcreteObservationsForPatientQueryVariables
    | VueCompositionApi.Ref<GetConcreteObservationsForPatientQueryVariables>
    | ReactiveFunction<GetConcreteObservationsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetConcreteObservationsForPatientQuery,
        GetConcreteObservationsForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientQuery,
          GetConcreteObservationsForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientQuery,
          GetConcreteObservationsForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetConcreteObservationsForPatientQuery,
    GetConcreteObservationsForPatientQueryVariables
  >(GetConcreteObservationsForPatientDocument, variables, options);
}
export function useGetConcreteObservationsForPatientLazyQuery(
  variables?:
    | GetConcreteObservationsForPatientQueryVariables
    | VueCompositionApi.Ref<GetConcreteObservationsForPatientQueryVariables>
    | ReactiveFunction<GetConcreteObservationsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetConcreteObservationsForPatientQuery,
        GetConcreteObservationsForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientQuery,
          GetConcreteObservationsForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientQuery,
          GetConcreteObservationsForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetConcreteObservationsForPatientQuery,
    GetConcreteObservationsForPatientQueryVariables
  >(GetConcreteObservationsForPatientDocument, variables, options);
}
export type GetConcreteObservationsForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetConcreteObservationsForPatientQuery,
  GetConcreteObservationsForPatientQueryVariables
>;
export const GetConcreteObservationsForPatientAsCsvDocument = gql`
  query getConcreteObservationsForPatientAsCsv($patientIds: [ID]!) {
    getConcreteObservationsForPatientAsCsv(patientIds: $patientIds) {
      csv
    }
  }
`;

/**
 * __useGetConcreteObservationsForPatientAsCsvQuery__
 *
 * To run a query within a Vue component, call `useGetConcreteObservationsForPatientAsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConcreteObservationsForPatientAsCsvQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConcreteObservationsForPatientAsCsvQuery({
 *   patientIds: // value for 'patientIds'
 * });
 */
export function useGetConcreteObservationsForPatientAsCsvQuery(
  variables:
    | GetConcreteObservationsForPatientAsCsvQueryVariables
    | VueCompositionApi.Ref<GetConcreteObservationsForPatientAsCsvQueryVariables>
    | ReactiveFunction<GetConcreteObservationsForPatientAsCsvQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetConcreteObservationsForPatientAsCsvQuery,
        GetConcreteObservationsForPatientAsCsvQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientAsCsvQuery,
          GetConcreteObservationsForPatientAsCsvQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientAsCsvQuery,
          GetConcreteObservationsForPatientAsCsvQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetConcreteObservationsForPatientAsCsvQuery,
    GetConcreteObservationsForPatientAsCsvQueryVariables
  >(GetConcreteObservationsForPatientAsCsvDocument, variables, options);
}
export function useGetConcreteObservationsForPatientAsCsvLazyQuery(
  variables?:
    | GetConcreteObservationsForPatientAsCsvQueryVariables
    | VueCompositionApi.Ref<GetConcreteObservationsForPatientAsCsvQueryVariables>
    | ReactiveFunction<GetConcreteObservationsForPatientAsCsvQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetConcreteObservationsForPatientAsCsvQuery,
        GetConcreteObservationsForPatientAsCsvQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientAsCsvQuery,
          GetConcreteObservationsForPatientAsCsvQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetConcreteObservationsForPatientAsCsvQuery,
          GetConcreteObservationsForPatientAsCsvQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetConcreteObservationsForPatientAsCsvQuery,
    GetConcreteObservationsForPatientAsCsvQueryVariables
  >(GetConcreteObservationsForPatientAsCsvDocument, variables, options);
}
export type GetConcreteObservationsForPatientAsCsvQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetConcreteObservationsForPatientAsCsvQuery,
  GetConcreteObservationsForPatientAsCsvQueryVariables
>;
export const GetAppDevicesForPatientDocument = gql`
  query getAppDevicesForPatient($patientId: ID!) {
    getAppDevicesForPatient(patientId: $patientId) {
      id
      username
      deviceName
      os
      lastActive
      appSettings {
        appLocale
        appName
        pushId
      }
      notificationSettings {
        message
        deviation
        measurement
        reviewed
        reminder
      }
      remindedTasks {
        objectReference {
          reference
        }
        success
        date
      }
    }
  }
`;

/**
 * __useGetAppDevicesForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetAppDevicesForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppDevicesForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAppDevicesForPatientQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetAppDevicesForPatientQuery(
  variables:
    | GetAppDevicesForPatientQueryVariables
    | VueCompositionApi.Ref<GetAppDevicesForPatientQueryVariables>
    | ReactiveFunction<GetAppDevicesForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>(
    GetAppDevicesForPatientDocument,
    variables,
    options,
  );
}
export function useGetAppDevicesForPatientLazyQuery(
  variables?:
    | GetAppDevicesForPatientQueryVariables
    | VueCompositionApi.Ref<GetAppDevicesForPatientQueryVariables>
    | ReactiveFunction<GetAppDevicesForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAppDevicesForPatientQuery, GetAppDevicesForPatientQueryVariables>(
    GetAppDevicesForPatientDocument,
    variables,
    options,
  );
}
export type GetAppDevicesForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAppDevicesForPatientQuery,
  GetAppDevicesForPatientQueryVariables
>;
export const PatientCommunicationsPaginatedDocument = gql`
  query patientCommunicationsPaginated($patientId: ID!, $to: dateTime, $limit: Int, $cursor: cursor) {
    patientCommunicationsPaginated(patientId: $patientId, to: $to, limit: $limit, cursor: $cursor) {
      cursor
      events {
        id
        status
        payload {
          contentString
          picture {
            id
            deleted
            deletedAt
            deletedBy {
              display
              reference
            }
            content {
              attachment {
                title
                contentType
                url
                size
                creation
              }
            }
          }
        }
        sender {
          reference
          display
        }
        subject {
          reference
        }
        sent
        received
      }
    }
  }
`;

/**
 * __usePatientCommunicationsPaginatedQuery__
 *
 * To run a query within a Vue component, call `usePatientCommunicationsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientCommunicationsPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientCommunicationsPaginatedQuery({
 *   patientId: // value for 'patientId'
 *   to: // value for 'to'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 * });
 */
export function usePatientCommunicationsPaginatedQuery(
  variables:
    | PatientCommunicationsPaginatedQueryVariables
    | VueCompositionApi.Ref<PatientCommunicationsPaginatedQueryVariables>
    | ReactiveFunction<PatientCommunicationsPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        PatientCommunicationsPaginatedQuery,
        PatientCommunicationsPaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          PatientCommunicationsPaginatedQuery,
          PatientCommunicationsPaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          PatientCommunicationsPaginatedQuery,
          PatientCommunicationsPaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    PatientCommunicationsPaginatedQuery,
    PatientCommunicationsPaginatedQueryVariables
  >(PatientCommunicationsPaginatedDocument, variables, options);
}
export function usePatientCommunicationsPaginatedLazyQuery(
  variables?:
    | PatientCommunicationsPaginatedQueryVariables
    | VueCompositionApi.Ref<PatientCommunicationsPaginatedQueryVariables>
    | ReactiveFunction<PatientCommunicationsPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        PatientCommunicationsPaginatedQuery,
        PatientCommunicationsPaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          PatientCommunicationsPaginatedQuery,
          PatientCommunicationsPaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          PatientCommunicationsPaginatedQuery,
          PatientCommunicationsPaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    PatientCommunicationsPaginatedQuery,
    PatientCommunicationsPaginatedQueryVariables
  >(PatientCommunicationsPaginatedDocument, variables, options);
}
export type PatientCommunicationsPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientCommunicationsPaginatedQuery,
  PatientCommunicationsPaginatedQueryVariables
>;
export const GetQuestionnaireTemplateDocument = gql`
  query getQuestionnaireTemplate($id: ID!) {
    getQuestionnaireTemplate(id: $id) {
      id
      version
      name
      status
      experimental
      purpose
      title
      description
      patient
      carePlan
      publisher
      effectivePeriod {
        start
        end
      }
      item {
        linkId
        text
        type
        answerOption {
          valueInteger
          valueDecimal
          valueString
          valueCoding {
            code
            display
          }
        }
      }
      priorities {
        mode
        thresholds {
          code
          value
        }
        points {
          code
          value
        }
      }
    }
  }
`;

/**
 * __useGetQuestionnaireTemplateQuery__
 *
 * To run a query within a Vue component, call `useGetQuestionnaireTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionnaireTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQuestionnaireTemplateQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetQuestionnaireTemplateQuery(
  variables:
    | GetQuestionnaireTemplateQueryVariables
    | VueCompositionApi.Ref<GetQuestionnaireTemplateQueryVariables>
    | ReactiveFunction<GetQuestionnaireTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>(
    GetQuestionnaireTemplateDocument,
    variables,
    options,
  );
}
export function useGetQuestionnaireTemplateLazyQuery(
  variables?:
    | GetQuestionnaireTemplateQueryVariables
    | VueCompositionApi.Ref<GetQuestionnaireTemplateQueryVariables>
    | ReactiveFunction<GetQuestionnaireTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetQuestionnaireTemplateQuery, GetQuestionnaireTemplateQueryVariables>(
    GetQuestionnaireTemplateDocument,
    variables,
    options,
  );
}
export type GetQuestionnaireTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetQuestionnaireTemplateQuery,
  GetQuestionnaireTemplateQueryVariables
>;
export const GetCarePlanQuestionnaireDocument = gql`
  query getCarePlanQuestionnaire($carePlanId: ID!, $questionnaireId: ID!) {
    getCarePlanQuestionnaire(carePlanId: $carePlanId, questionnaireId: $questionnaireId) {
      id
      version
      name
      status
      experimental
      purpose
      title
      description
      patient
      carePlan
      publisher
      effectivePeriod {
        start
        end
      }
      item {
        linkId
        text
        type
        answerOption {
          valueInteger
          valueDecimal
          valueString
          valueCoding {
            code
            display
          }
        }
      }
      priorities {
        mode
        thresholds {
          code
          value
        }
        points {
          code
          value
        }
      }
    }
  }
`;

/**
 * __useGetCarePlanQuestionnaireQuery__
 *
 * To run a query within a Vue component, call `useGetCarePlanQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarePlanQuestionnaireQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCarePlanQuestionnaireQuery({
 *   carePlanId: // value for 'carePlanId'
 *   questionnaireId: // value for 'questionnaireId'
 * });
 */
export function useGetCarePlanQuestionnaireQuery(
  variables:
    | GetCarePlanQuestionnaireQueryVariables
    | VueCompositionApi.Ref<GetCarePlanQuestionnaireQueryVariables>
    | ReactiveFunction<GetCarePlanQuestionnaireQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>(
    GetCarePlanQuestionnaireDocument,
    variables,
    options,
  );
}
export function useGetCarePlanQuestionnaireLazyQuery(
  variables?:
    | GetCarePlanQuestionnaireQueryVariables
    | VueCompositionApi.Ref<GetCarePlanQuestionnaireQueryVariables>
    | ReactiveFunction<GetCarePlanQuestionnaireQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCarePlanQuestionnaireQuery, GetCarePlanQuestionnaireQueryVariables>(
    GetCarePlanQuestionnaireDocument,
    variables,
    options,
  );
}
export type GetCarePlanQuestionnaireQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCarePlanQuestionnaireQuery,
  GetCarePlanQuestionnaireQueryVariables
>;
export const GetCarePlanTemplateQuestionnaireDocument = gql`
  query getCarePlanTemplateQuestionnaire($carePlanTemplateId: ID!, $questionnaireId: ID!) {
    getCarePlanTemplateQuestionnaire(carePlanTemplateId: $carePlanTemplateId, questionnaireId: $questionnaireId) {
      id
      version
      name
      status
      experimental
      purpose
      title
      description
      patient
      carePlan
      publisher
      effectivePeriod {
        start
        end
      }
      item {
        linkId
        text
        type
        answerOption {
          valueInteger
          valueDecimal
          valueString
          valueCoding {
            code
            display
          }
        }
      }
      priorities {
        mode
        thresholds {
          code
          value
        }
        points {
          code
          value
        }
      }
    }
  }
`;

/**
 * __useGetCarePlanTemplateQuestionnaireQuery__
 *
 * To run a query within a Vue component, call `useGetCarePlanTemplateQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarePlanTemplateQuestionnaireQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCarePlanTemplateQuestionnaireQuery({
 *   carePlanTemplateId: // value for 'carePlanTemplateId'
 *   questionnaireId: // value for 'questionnaireId'
 * });
 */
export function useGetCarePlanTemplateQuestionnaireQuery(
  variables:
    | GetCarePlanTemplateQuestionnaireQueryVariables
    | VueCompositionApi.Ref<GetCarePlanTemplateQuestionnaireQueryVariables>
    | ReactiveFunction<GetCarePlanTemplateQuestionnaireQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetCarePlanTemplateQuestionnaireQuery,
        GetCarePlanTemplateQuestionnaireQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetCarePlanTemplateQuestionnaireQuery,
          GetCarePlanTemplateQuestionnaireQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetCarePlanTemplateQuestionnaireQuery,
          GetCarePlanTemplateQuestionnaireQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetCarePlanTemplateQuestionnaireQuery,
    GetCarePlanTemplateQuestionnaireQueryVariables
  >(GetCarePlanTemplateQuestionnaireDocument, variables, options);
}
export function useGetCarePlanTemplateQuestionnaireLazyQuery(
  variables?:
    | GetCarePlanTemplateQuestionnaireQueryVariables
    | VueCompositionApi.Ref<GetCarePlanTemplateQuestionnaireQueryVariables>
    | ReactiveFunction<GetCarePlanTemplateQuestionnaireQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetCarePlanTemplateQuestionnaireQuery,
        GetCarePlanTemplateQuestionnaireQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetCarePlanTemplateQuestionnaireQuery,
          GetCarePlanTemplateQuestionnaireQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetCarePlanTemplateQuestionnaireQuery,
          GetCarePlanTemplateQuestionnaireQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetCarePlanTemplateQuestionnaireQuery,
    GetCarePlanTemplateQuestionnaireQueryVariables
  >(GetCarePlanTemplateQuestionnaireDocument, variables, options);
}
export type GetCarePlanTemplateQuestionnaireQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCarePlanTemplateQuestionnaireQuery,
  GetCarePlanTemplateQuestionnaireQueryVariables
>;
export const GetReadyTaskCountDocument = gql`
  query getReadyTaskCount($from: dateTime, $to: dateTime, $code: TaskCode, $onlyUpcomingVideoMeetings: Boolean) {
    getReadyTaskCount(from: $from, to: $to, code: $code, onlyUpcomingVideoMeetings: $onlyUpcomingVideoMeetings) {
      routine
      urgent
      asap
      stat
      video
      upcomingVideo
    }
  }
`;

/**
 * __useGetReadyTaskCountQuery__
 *
 * To run a query within a Vue component, call `useGetReadyTaskCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReadyTaskCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetReadyTaskCountQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   code: // value for 'code'
 *   onlyUpcomingVideoMeetings: // value for 'onlyUpcomingVideoMeetings'
 * });
 */
export function useGetReadyTaskCountQuery(
  variables:
    | GetReadyTaskCountQueryVariables
    | VueCompositionApi.Ref<GetReadyTaskCountQueryVariables>
    | ReactiveFunction<GetReadyTaskCountQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>(
    GetReadyTaskCountDocument,
    variables,
    options,
  );
}
export function useGetReadyTaskCountLazyQuery(
  variables:
    | GetReadyTaskCountQueryVariables
    | VueCompositionApi.Ref<GetReadyTaskCountQueryVariables>
    | ReactiveFunction<GetReadyTaskCountQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetReadyTaskCountQuery, GetReadyTaskCountQueryVariables>(
    GetReadyTaskCountDocument,
    variables,
    options,
  );
}
export type GetReadyTaskCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetReadyTaskCountQuery,
  GetReadyTaskCountQueryVariables
>;
export const UnreadCommunicationsDocument = gql`
  query unreadCommunications($patientId: ID) {
    unreadCommunications(patientId: $patientId) {
      id
      patient {
        id
        name {
          given
          family
        }
      }
      payload {
        contentString
      }
      sent
    }
  }
`;

/**
 * __useUnreadCommunicationsQuery__
 *
 * To run a query within a Vue component, call `useUnreadCommunicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadCommunicationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUnreadCommunicationsQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useUnreadCommunicationsQuery(
  variables:
    | UnreadCommunicationsQueryVariables
    | VueCompositionApi.Ref<UnreadCommunicationsQueryVariables>
    | ReactiveFunction<UnreadCommunicationsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>(
    UnreadCommunicationsDocument,
    variables,
    options,
  );
}
export function useUnreadCommunicationsLazyQuery(
  variables:
    | UnreadCommunicationsQueryVariables
    | VueCompositionApi.Ref<UnreadCommunicationsQueryVariables>
    | ReactiveFunction<UnreadCommunicationsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UnreadCommunicationsQuery, UnreadCommunicationsQueryVariables>(
    UnreadCommunicationsDocument,
    variables,
    options,
  );
}
export type UnreadCommunicationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UnreadCommunicationsQuery,
  UnreadCommunicationsQueryVariables
>;
export const UnreadCommunicationsCountDocument = gql`
  query unreadCommunicationsCount($patientId: ID) {
    unreadCommunicationsCount(patientId: $patientId)
  }
`;

/**
 * __useUnreadCommunicationsCountQuery__
 *
 * To run a query within a Vue component, call `useUnreadCommunicationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadCommunicationsCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUnreadCommunicationsCountQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useUnreadCommunicationsCountQuery(
  variables:
    | UnreadCommunicationsCountQueryVariables
    | VueCompositionApi.Ref<UnreadCommunicationsCountQueryVariables>
    | ReactiveFunction<UnreadCommunicationsCountQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>(
    UnreadCommunicationsCountDocument,
    variables,
    options,
  );
}
export function useUnreadCommunicationsCountLazyQuery(
  variables:
    | UnreadCommunicationsCountQueryVariables
    | VueCompositionApi.Ref<UnreadCommunicationsCountQueryVariables>
    | ReactiveFunction<UnreadCommunicationsCountQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UnreadCommunicationsCountQuery, UnreadCommunicationsCountQueryVariables>(
    UnreadCommunicationsCountDocument,
    variables,
    options,
  );
}
export type UnreadCommunicationsCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UnreadCommunicationsCountQuery,
  UnreadCommunicationsCountQueryVariables
>;
export const BookedMeetingsForPatientDocument = gql`
  query bookedMeetingsForPatient($patientId: ID!, $startAtMost: dateTime!, $startAtLeast: dateTime!) {
    bookedMeetingsForPatient: videoMeetingTasksForPatient(
      patientId: $patientId
      startAtMost: $startAtMost
      startAtLeast: $startAtLeast
      status: booked
    ) {
      id
      status
      owner {
        display
        identifier {
          value
        }
      }
      videoMeeting {
        id
        appointment {
          description
          status
          start
          end
        }
      }
    }
  }
`;

/**
 * __useBookedMeetingsForPatientQuery__
 *
 * To run a query within a Vue component, call `useBookedMeetingsForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookedMeetingsForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBookedMeetingsForPatientQuery({
 *   patientId: // value for 'patientId'
 *   startAtMost: // value for 'startAtMost'
 *   startAtLeast: // value for 'startAtLeast'
 * });
 */
export function useBookedMeetingsForPatientQuery(
  variables:
    | BookedMeetingsForPatientQueryVariables
    | VueCompositionApi.Ref<BookedMeetingsForPatientQueryVariables>
    | ReactiveFunction<BookedMeetingsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>(
    BookedMeetingsForPatientDocument,
    variables,
    options,
  );
}
export function useBookedMeetingsForPatientLazyQuery(
  variables?:
    | BookedMeetingsForPatientQueryVariables
    | VueCompositionApi.Ref<BookedMeetingsForPatientQueryVariables>
    | ReactiveFunction<BookedMeetingsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<BookedMeetingsForPatientQuery, BookedMeetingsForPatientQueryVariables>(
    BookedMeetingsForPatientDocument,
    variables,
    options,
  );
}
export type BookedMeetingsForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  BookedMeetingsForPatientQuery,
  BookedMeetingsForPatientQueryVariables
>;
export const BookedMeetingsForEveryoneDocument = gql`
  query bookedMeetingsForEveryone($startAtMost: dateTime!, $startAtLeast: dateTime!) {
    bookedMeetingsForEveryone: videoMeetingTasks(
      startAtMost: $startAtMost
      startAtLeast: $startAtLeast
      status: booked
    ) {
      id
      status
      owner {
        display
        identifier {
          value
        }
      }
      patient {
        id
        name {
          text
        }
      }
      videoMeeting {
        id
        appointment {
          description
          status
          start
          end
        }
      }
    }
  }
`;

/**
 * __useBookedMeetingsForEveryoneQuery__
 *
 * To run a query within a Vue component, call `useBookedMeetingsForEveryoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookedMeetingsForEveryoneQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBookedMeetingsForEveryoneQuery({
 *   startAtMost: // value for 'startAtMost'
 *   startAtLeast: // value for 'startAtLeast'
 * });
 */
export function useBookedMeetingsForEveryoneQuery(
  variables:
    | BookedMeetingsForEveryoneQueryVariables
    | VueCompositionApi.Ref<BookedMeetingsForEveryoneQueryVariables>
    | ReactiveFunction<BookedMeetingsForEveryoneQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>(
    BookedMeetingsForEveryoneDocument,
    variables,
    options,
  );
}
export function useBookedMeetingsForEveryoneLazyQuery(
  variables?:
    | BookedMeetingsForEveryoneQueryVariables
    | VueCompositionApi.Ref<BookedMeetingsForEveryoneQueryVariables>
    | ReactiveFunction<BookedMeetingsForEveryoneQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<BookedMeetingsForEveryoneQuery, BookedMeetingsForEveryoneQueryVariables>(
    BookedMeetingsForEveryoneDocument,
    variables,
    options,
  );
}
export type BookedMeetingsForEveryoneQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  BookedMeetingsForEveryoneQuery,
  BookedMeetingsForEveryoneQueryVariables
>;
export const AllMeetingsForPatientDocument = gql`
  query allMeetingsForPatient($patientId: ID!, $startAtMost: dateTime!, $startAtLeast: dateTime!) {
    allMeetingsForPatient: videoMeetingTasksForPatient(
      patientId: $patientId
      startAtMost: $startAtMost
      startAtLeast: $startAtLeast
    ) {
      id
      status
      videoMeeting {
        id
        appointment {
          description
          status
          start
          end
        }
      }
    }
  }
`;

/**
 * __useAllMeetingsForPatientQuery__
 *
 * To run a query within a Vue component, call `useAllMeetingsForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMeetingsForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllMeetingsForPatientQuery({
 *   patientId: // value for 'patientId'
 *   startAtMost: // value for 'startAtMost'
 *   startAtLeast: // value for 'startAtLeast'
 * });
 */
export function useAllMeetingsForPatientQuery(
  variables:
    | AllMeetingsForPatientQueryVariables
    | VueCompositionApi.Ref<AllMeetingsForPatientQueryVariables>
    | ReactiveFunction<AllMeetingsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>(
    AllMeetingsForPatientDocument,
    variables,
    options,
  );
}
export function useAllMeetingsForPatientLazyQuery(
  variables?:
    | AllMeetingsForPatientQueryVariables
    | VueCompositionApi.Ref<AllMeetingsForPatientQueryVariables>
    | ReactiveFunction<AllMeetingsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<AllMeetingsForPatientQuery, AllMeetingsForPatientQueryVariables>(
    AllMeetingsForPatientDocument,
    variables,
    options,
  );
}
export type AllMeetingsForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AllMeetingsForPatientQuery,
  AllMeetingsForPatientQueryVariables
>;
export const AllMeetingsForEveryoneDocument = gql`
  query allMeetingsForEveryone($startAtMost: dateTime!, $startAtLeast: dateTime!) {
    allMeetingsForEveryone: videoMeetingTasks(startAtMost: $startAtMost, startAtLeast: $startAtLeast) {
      id
      status
      owner {
        display
        identifier {
          value
        }
      }
      patient {
        id
        name {
          text
        }
      }
      videoMeeting {
        id
        appointment {
          description
          status
          start
          end
        }
      }
    }
  }
`;

/**
 * __useAllMeetingsForEveryoneQuery__
 *
 * To run a query within a Vue component, call `useAllMeetingsForEveryoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMeetingsForEveryoneQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllMeetingsForEveryoneQuery({
 *   startAtMost: // value for 'startAtMost'
 *   startAtLeast: // value for 'startAtLeast'
 * });
 */
export function useAllMeetingsForEveryoneQuery(
  variables:
    | AllMeetingsForEveryoneQueryVariables
    | VueCompositionApi.Ref<AllMeetingsForEveryoneQueryVariables>
    | ReactiveFunction<AllMeetingsForEveryoneQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>(
    AllMeetingsForEveryoneDocument,
    variables,
    options,
  );
}
export function useAllMeetingsForEveryoneLazyQuery(
  variables?:
    | AllMeetingsForEveryoneQueryVariables
    | VueCompositionApi.Ref<AllMeetingsForEveryoneQueryVariables>
    | ReactiveFunction<AllMeetingsForEveryoneQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<AllMeetingsForEveryoneQuery, AllMeetingsForEveryoneQueryVariables>(
    AllMeetingsForEveryoneDocument,
    variables,
    options,
  );
}
export type AllMeetingsForEveryoneQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AllMeetingsForEveryoneQuery,
  AllMeetingsForEveryoneQueryVariables
>;
export const DialoggUsersListDocument = gql`
  query dialoggUsersList {
    dialoggUsers {
      username
      firstName
      lastName
      enabled
      lastActive
      email
      externalUserIds {
        externalHumanIdType {
          id
        }
        externalId
      }
    }
  }
`;

/**
 * __useDialoggUsersListQuery__
 *
 * To run a query within a Vue component, call `useDialoggUsersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDialoggUsersListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDialoggUsersListQuery();
 */
export function useDialoggUsersListQuery(
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersListQuery, DialoggUsersListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DialoggUsersListQuery, DialoggUsersListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DialoggUsersListQuery, DialoggUsersListQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<DialoggUsersListQuery, DialoggUsersListQueryVariables>(
    DialoggUsersListDocument,
    {},
    options,
  );
}
export function useDialoggUsersListLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersListQuery, DialoggUsersListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DialoggUsersListQuery, DialoggUsersListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DialoggUsersListQuery, DialoggUsersListQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<DialoggUsersListQuery, DialoggUsersListQueryVariables>(
    DialoggUsersListDocument,
    {},
    options,
  );
}
export type DialoggUsersListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DialoggUsersListQuery,
  DialoggUsersListQueryVariables
>;
export const DialoggUsersDocument = gql`
  query dialoggUsers($username: ID) {
    dialoggUsers(username: $username) {
      username
      firstName
      lastName
      enabled
      lastActive
      email
      picturePermission
      externalUserIds {
        externalHumanIdType {
          id
        }
        externalId
      }
      onBehalf {
        accessiblePatients
        otherPatientIds
      }
      otpStatus
      ipRestrictions
      timeLimitedAccess {
        start
        end
      }
      smsOtpStatus
      smsOtpPhoneNumber
      passwordStatus
      email
      externalIdentities {
        provider
      }
    }
  }
`;

/**
 * __useDialoggUsersQuery__
 *
 * To run a query within a Vue component, call `useDialoggUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDialoggUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDialoggUsersQuery({
 *   username: // value for 'username'
 * });
 */
export function useDialoggUsersQuery(
  variables:
    | DialoggUsersQueryVariables
    | VueCompositionApi.Ref<DialoggUsersQueryVariables>
    | ReactiveFunction<DialoggUsersQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersQuery, DialoggUsersQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DialoggUsersQuery, DialoggUsersQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DialoggUsersQuery, DialoggUsersQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<DialoggUsersQuery, DialoggUsersQueryVariables>(
    DialoggUsersDocument,
    variables,
    options,
  );
}
export function useDialoggUsersLazyQuery(
  variables:
    | DialoggUsersQueryVariables
    | VueCompositionApi.Ref<DialoggUsersQueryVariables>
    | ReactiveFunction<DialoggUsersQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersQuery, DialoggUsersQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DialoggUsersQuery, DialoggUsersQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DialoggUsersQuery, DialoggUsersQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<DialoggUsersQuery, DialoggUsersQueryVariables>(
    DialoggUsersDocument,
    variables,
    options,
  );
}
export type DialoggUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DialoggUsersQuery,
  DialoggUsersQueryVariables
>;
export const DialoggUsersDeleteDocument = gql`
  query dialoggUsersDelete($username: ID) {
    dialoggUsers(username: $username) {
      username
      firstName
      lastName
      enabled
      lastActive
      email
      onBehalf {
        accessiblePatients
        otherPatientIds
      }
    }
  }
`;

/**
 * __useDialoggUsersDeleteQuery__
 *
 * To run a query within a Vue component, call `useDialoggUsersDeleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDialoggUsersDeleteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDialoggUsersDeleteQuery({
 *   username: // value for 'username'
 * });
 */
export function useDialoggUsersDeleteQuery(
  variables:
    | DialoggUsersDeleteQueryVariables
    | VueCompositionApi.Ref<DialoggUsersDeleteQueryVariables>
    | ReactiveFunction<DialoggUsersDeleteQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>(
    DialoggUsersDeleteDocument,
    variables,
    options,
  );
}
export function useDialoggUsersDeleteLazyQuery(
  variables:
    | DialoggUsersDeleteQueryVariables
    | VueCompositionApi.Ref<DialoggUsersDeleteQueryVariables>
    | ReactiveFunction<DialoggUsersDeleteQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<DialoggUsersDeleteQuery, DialoggUsersDeleteQueryVariables>(
    DialoggUsersDeleteDocument,
    variables,
    options,
  );
}
export type DialoggUsersDeleteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DialoggUsersDeleteQuery,
  DialoggUsersDeleteQueryVariables
>;
export const DialoggUsersForCreateDialogDocument = gql`
  query dialoggUsersForCreateDialog($username: ID) {
    dialoggUsers(username: $username) {
      username
      firstName
      lastName
      enabled
      lastActive
      email
      externalIdentities {
        provider
      }
    }
  }
`;

/**
 * __useDialoggUsersForCreateDialogQuery__
 *
 * To run a query within a Vue component, call `useDialoggUsersForCreateDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useDialoggUsersForCreateDialogQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDialoggUsersForCreateDialogQuery({
 *   username: // value for 'username'
 * });
 */
export function useDialoggUsersForCreateDialogQuery(
  variables:
    | DialoggUsersForCreateDialogQueryVariables
    | VueCompositionApi.Ref<DialoggUsersForCreateDialogQueryVariables>
    | ReactiveFunction<DialoggUsersForCreateDialogQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>(
    DialoggUsersForCreateDialogDocument,
    variables,
    options,
  );
}
export function useDialoggUsersForCreateDialogLazyQuery(
  variables:
    | DialoggUsersForCreateDialogQueryVariables
    | VueCompositionApi.Ref<DialoggUsersForCreateDialogQueryVariables>
    | ReactiveFunction<DialoggUsersForCreateDialogQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<DialoggUsersForCreateDialogQuery, DialoggUsersForCreateDialogQueryVariables>(
    DialoggUsersForCreateDialogDocument,
    variables,
    options,
  );
}
export type DialoggUsersForCreateDialogQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DialoggUsersForCreateDialogQuery,
  DialoggUsersForCreateDialogQueryVariables
>;
export const GetAllCarePlanTemplatesDocument = gql`
  query getAllCarePlanTemplates($withStatus: String) {
    getAllCarePlanTemplates(withStatus: $withStatus) {
      id
      title
      status
      carePlanType
    }
  }
`;

/**
 * __useGetAllCarePlanTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetAllCarePlanTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCarePlanTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllCarePlanTemplatesQuery({
 *   withStatus: // value for 'withStatus'
 * });
 */
export function useGetAllCarePlanTemplatesQuery(
  variables:
    | GetAllCarePlanTemplatesQueryVariables
    | VueCompositionApi.Ref<GetAllCarePlanTemplatesQueryVariables>
    | ReactiveFunction<GetAllCarePlanTemplatesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>(
    GetAllCarePlanTemplatesDocument,
    variables,
    options,
  );
}
export function useGetAllCarePlanTemplatesLazyQuery(
  variables:
    | GetAllCarePlanTemplatesQueryVariables
    | VueCompositionApi.Ref<GetAllCarePlanTemplatesQueryVariables>
    | ReactiveFunction<GetAllCarePlanTemplatesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllCarePlanTemplatesQuery, GetAllCarePlanTemplatesQueryVariables>(
    GetAllCarePlanTemplatesDocument,
    variables,
    options,
  );
}
export type GetAllCarePlanTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllCarePlanTemplatesQuery,
  GetAllCarePlanTemplatesQueryVariables
>;
export const GetAllRpmGatewaysDocument = gql`
  query getAllRpmGateways {
    getAllRpmGateways {
      id
      deviceName {
        name
        type
      }
      manufacturer
      serialNumber
      modelNumber
      note {
        text
      }
      identifier {
        value
      }
      gatewayHostname
      gatewayStatus {
        connected
        lastSeen
        lastMeasurements {
          type
          time
        }
        lastStatus {
          version
          ble_service_running
          cputemp
          uptime
        }
      }
      patient {
        reference
      }
      deviceGroup {
        id
        name
      }
    }
  }
`;

/**
 * __useGetAllRpmGatewaysQuery__
 *
 * To run a query within a Vue component, call `useGetAllRpmGatewaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRpmGatewaysQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllRpmGatewaysQuery();
 */
export function useGetAllRpmGatewaysQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllRpmGatewaysQuery, GetAllRpmGatewaysQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllRpmGatewaysQuery, GetAllRpmGatewaysQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllRpmGatewaysQuery, GetAllRpmGatewaysQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllRpmGatewaysQuery, GetAllRpmGatewaysQueryVariables>(
    GetAllRpmGatewaysDocument,
    {},
    options,
  );
}
export function useGetAllRpmGatewaysLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllRpmGatewaysQuery, GetAllRpmGatewaysQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllRpmGatewaysQuery, GetAllRpmGatewaysQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllRpmGatewaysQuery, GetAllRpmGatewaysQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllRpmGatewaysQuery, GetAllRpmGatewaysQueryVariables>(
    GetAllRpmGatewaysDocument,
    {},
    options,
  );
}
export type GetAllRpmGatewaysQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllRpmGatewaysQuery,
  GetAllRpmGatewaysQueryVariables
>;
export const GetAllRpmMedicalDevicesDocument = gql`
  query getAllRpmMedicalDevices {
    getAllRpmMedicalDevices {
      id
      deviceName {
        name
        type
      }
      patient {
        reference
      }
      status
      manufacturer
      serialNumber
      modelNumber
      modelName
      parent {
        reference
      }
      parentDevice {
        gatewayHostname
      }
      note {
        text
      }
      identifier {
        value
      }
      btAddress
      sensorType
      isDeviceBtPaired
      batteryLevel
      deviceGroup {
        name
        id
      }
    }
  }
`;

/**
 * __useGetAllRpmMedicalDevicesQuery__
 *
 * To run a query within a Vue component, call `useGetAllRpmMedicalDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRpmMedicalDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllRpmMedicalDevicesQuery();
 */
export function useGetAllRpmMedicalDevicesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>(
    GetAllRpmMedicalDevicesDocument,
    {},
    options,
  );
}
export function useGetAllRpmMedicalDevicesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllRpmMedicalDevicesQuery, GetAllRpmMedicalDevicesQueryVariables>(
    GetAllRpmMedicalDevicesDocument,
    {},
    options,
  );
}
export type GetAllRpmMedicalDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllRpmMedicalDevicesQuery,
  GetAllRpmMedicalDevicesQueryVariables
>;
export const GetListOfUnallocatedRpmGatewaysDocument = gql`
  query getListOfUnallocatedRpmGateways {
    getListOfUnallocatedRpmGateways {
      id
      gatewayHostname
      modelNumber
      userFriendlyName
    }
  }
`;

/**
 * __useGetListOfUnallocatedRpmGatewaysQuery__
 *
 * To run a query within a Vue component, call `useGetListOfUnallocatedRpmGatewaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListOfUnallocatedRpmGatewaysQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetListOfUnallocatedRpmGatewaysQuery();
 */
export function useGetListOfUnallocatedRpmGatewaysQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetListOfUnallocatedRpmGatewaysQuery,
        GetListOfUnallocatedRpmGatewaysQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedRpmGatewaysQuery,
          GetListOfUnallocatedRpmGatewaysQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedRpmGatewaysQuery,
          GetListOfUnallocatedRpmGatewaysQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetListOfUnallocatedRpmGatewaysQuery,
    GetListOfUnallocatedRpmGatewaysQueryVariables
  >(GetListOfUnallocatedRpmGatewaysDocument, {}, options);
}
export function useGetListOfUnallocatedRpmGatewaysLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetListOfUnallocatedRpmGatewaysQuery,
        GetListOfUnallocatedRpmGatewaysQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedRpmGatewaysQuery,
          GetListOfUnallocatedRpmGatewaysQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedRpmGatewaysQuery,
          GetListOfUnallocatedRpmGatewaysQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetListOfUnallocatedRpmGatewaysQuery,
    GetListOfUnallocatedRpmGatewaysQueryVariables
  >(GetListOfUnallocatedRpmGatewaysDocument, {}, options);
}
export type GetListOfUnallocatedRpmGatewaysQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetListOfUnallocatedRpmGatewaysQuery,
  GetListOfUnallocatedRpmGatewaysQueryVariables
>;
export const GetListOfUnallocatedRpmMedicalDevicesDocument = gql`
  query getListOfUnallocatedRpmMedicalDevices {
    getListOfUnallocatedRpmMedicalDevices {
      id
      deviceName {
        name
        type
      }
      patient {
        reference
      }
      status
      manufacturer
      serialNumber
      modelNumber
      modelName
      parent {
        reference
      }
      parentDevice {
        gatewayHostname
      }
      note {
        text
      }
      identifier {
        value
      }
      btAddress
      sensorType
      isDeviceBtPaired
      batteryLevel
      deviceGroup {
        name
        id
      }
    }
  }
`;

/**
 * __useGetListOfUnallocatedRpmMedicalDevicesQuery__
 *
 * To run a query within a Vue component, call `useGetListOfUnallocatedRpmMedicalDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListOfUnallocatedRpmMedicalDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetListOfUnallocatedRpmMedicalDevicesQuery();
 */
export function useGetListOfUnallocatedRpmMedicalDevicesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetListOfUnallocatedRpmMedicalDevicesQuery,
        GetListOfUnallocatedRpmMedicalDevicesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedRpmMedicalDevicesQuery,
          GetListOfUnallocatedRpmMedicalDevicesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedRpmMedicalDevicesQuery,
          GetListOfUnallocatedRpmMedicalDevicesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetListOfUnallocatedRpmMedicalDevicesQuery,
    GetListOfUnallocatedRpmMedicalDevicesQueryVariables
  >(GetListOfUnallocatedRpmMedicalDevicesDocument, {}, options);
}
export function useGetListOfUnallocatedRpmMedicalDevicesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetListOfUnallocatedRpmMedicalDevicesQuery,
        GetListOfUnallocatedRpmMedicalDevicesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedRpmMedicalDevicesQuery,
          GetListOfUnallocatedRpmMedicalDevicesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedRpmMedicalDevicesQuery,
          GetListOfUnallocatedRpmMedicalDevicesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetListOfUnallocatedRpmMedicalDevicesQuery,
    GetListOfUnallocatedRpmMedicalDevicesQueryVariables
  >(GetListOfUnallocatedRpmMedicalDevicesDocument, {}, options);
}
export type GetListOfUnallocatedRpmMedicalDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetListOfUnallocatedRpmMedicalDevicesQuery,
  GetListOfUnallocatedRpmMedicalDevicesQueryVariables
>;
export const GetPatientNameDocument = gql`
  query getPatientName($id: ID!) {
    patient(id: $id) {
      id
      name {
        given
        family
        text
      }
    }
  }
`;

/**
 * __useGetPatientNameQuery__
 *
 * To run a query within a Vue component, call `useGetPatientNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientNameQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientNameQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPatientNameQuery(
  variables:
    | GetPatientNameQueryVariables
    | VueCompositionApi.Ref<GetPatientNameQueryVariables>
    | ReactiveFunction<GetPatientNameQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientNameQuery, GetPatientNameQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientNameQuery, GetPatientNameQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientNameQuery, GetPatientNameQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetPatientNameQuery, GetPatientNameQueryVariables>(
    GetPatientNameDocument,
    variables,
    options,
  );
}
export function useGetPatientNameLazyQuery(
  variables?:
    | GetPatientNameQueryVariables
    | VueCompositionApi.Ref<GetPatientNameQueryVariables>
    | ReactiveFunction<GetPatientNameQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientNameQuery, GetPatientNameQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetPatientNameQuery, GetPatientNameQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetPatientNameQuery, GetPatientNameQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientNameQuery, GetPatientNameQueryVariables>(
    GetPatientNameDocument,
    variables,
    options,
  );
}
export type GetPatientNameQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientNameQuery,
  GetPatientNameQueryVariables
>;
export const GetRpmGatewayDocument = gql`
  query getRpmGateway($id: ID!) {
    getRpmGateway(id: $id) {
      id
      deviceName {
        name
        type
      }
      deviceGroup {
        id
      }
      manufacturer
      serialNumber
      modelNumber
      note {
        text
      }
      identifier {
        value
      }
      gatewayHostname
      gatewayStatus {
        connected
        lastSeen
      }
      patient {
        reference
      }
      children {
        id
        sensorType
        modelName
        isDeviceBtPaired
        batteryLevel
      }
    }
  }
`;

/**
 * __useGetRpmGatewayQuery__
 *
 * To run a query within a Vue component, call `useGetRpmGatewayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRpmGatewayQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRpmGatewayQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetRpmGatewayQuery(
  variables:
    | GetRpmGatewayQueryVariables
    | VueCompositionApi.Ref<GetRpmGatewayQueryVariables>
    | ReactiveFunction<GetRpmGatewayQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetRpmGatewayQuery, GetRpmGatewayQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRpmGatewayQuery, GetRpmGatewayQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRpmGatewayQuery, GetRpmGatewayQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetRpmGatewayQuery, GetRpmGatewayQueryVariables>(
    GetRpmGatewayDocument,
    variables,
    options,
  );
}
export function useGetRpmGatewayLazyQuery(
  variables?:
    | GetRpmGatewayQueryVariables
    | VueCompositionApi.Ref<GetRpmGatewayQueryVariables>
    | ReactiveFunction<GetRpmGatewayQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetRpmGatewayQuery, GetRpmGatewayQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRpmGatewayQuery, GetRpmGatewayQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRpmGatewayQuery, GetRpmGatewayQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetRpmGatewayQuery, GetRpmGatewayQueryVariables>(
    GetRpmGatewayDocument,
    variables,
    options,
  );
}
export type GetRpmGatewayQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetRpmGatewayQuery,
  GetRpmGatewayQueryVariables
>;
export const GetRpmMedicalDeviceDocument = gql`
  query getRpmMedicalDevice($id: ID!) {
    getRpmMedicalDevice(id: $id) {
      id
      deviceName {
        name
        type
      }
      patient {
        reference
      }
      status
      manufacturer
      serialNumber
      modelNumber
      modelName
      parent {
        reference
      }
      parentDevice {
        gatewayHostname
      }
      note {
        text
      }
      identifier {
        value
      }
      btAddress
      sensorType
      isDeviceBtPaired
      batteryLevel
      deviceGroup {
        name
        id
      }
    }
  }
`;

/**
 * __useGetRpmMedicalDeviceQuery__
 *
 * To run a query within a Vue component, call `useGetRpmMedicalDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRpmMedicalDeviceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRpmMedicalDeviceQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetRpmMedicalDeviceQuery(
  variables:
    | GetRpmMedicalDeviceQueryVariables
    | VueCompositionApi.Ref<GetRpmMedicalDeviceQueryVariables>
    | ReactiveFunction<GetRpmMedicalDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>(
    GetRpmMedicalDeviceDocument,
    variables,
    options,
  );
}
export function useGetRpmMedicalDeviceLazyQuery(
  variables?:
    | GetRpmMedicalDeviceQueryVariables
    | VueCompositionApi.Ref<GetRpmMedicalDeviceQueryVariables>
    | ReactiveFunction<GetRpmMedicalDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetRpmMedicalDeviceQuery, GetRpmMedicalDeviceQueryVariables>(
    GetRpmMedicalDeviceDocument,
    variables,
    options,
  );
}
export type GetRpmMedicalDeviceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetRpmMedicalDeviceQuery,
  GetRpmMedicalDeviceQueryVariables
>;
export const GetTaskByIdDocument = gql`
  query getTaskById($taskId: ID!) {
    getTaskById(taskId: $taskId) {
      id
      code {
        text
      }
      status
      priority
      authoredOn
      description
      journalWorkflow {
        status
      }
      executionPeriod {
        start
        end
      }
      carePlan {
        id
        title
      }
      note {
        authorString
        time
        text
        authorReference {
          display
          reference
        }
      }
      subTasks {
        id
        code {
          text
        }
        authoredOn
        intent
        priority
        status
        partOf {
          reference
        }
        note {
          authorString
          time
          text
          authorReference {
            display
            reference
          }
        }
        focus {
          reference
        }
      }
      videoMeeting {
        id
        appointment {
          description
          status
          start
        }
        videonor {
          meetingId
        }
      }
    }
  }
`;

/**
 * __useGetTaskByIdQuery__
 *
 * To run a query within a Vue component, call `useGetTaskByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTaskByIdQuery({
 *   taskId: // value for 'taskId'
 * });
 */
export function useGetTaskByIdQuery(
  variables:
    | GetTaskByIdQueryVariables
    | VueCompositionApi.Ref<GetTaskByIdQueryVariables>
    | ReactiveFunction<GetTaskByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetTaskByIdQuery, GetTaskByIdQueryVariables>(
    GetTaskByIdDocument,
    variables,
    options,
  );
}
export function useGetTaskByIdLazyQuery(
  variables?:
    | GetTaskByIdQueryVariables
    | VueCompositionApi.Ref<GetTaskByIdQueryVariables>
    | ReactiveFunction<GetTaskByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetTaskByIdQuery, GetTaskByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetTaskByIdQuery, GetTaskByIdQueryVariables>(
    GetTaskByIdDocument,
    variables,
    options,
  );
}
export type GetTaskByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetTaskByIdQuery,
  GetTaskByIdQueryVariables
>;
export const GetTaskByIdWithJournalRetryDocument = gql`
  query getTaskByIdWithJournalRetry($taskId: ID!) {
    getTaskById(taskId: $taskId) {
      id
      code {
        text
      }
      status
      priority
      authoredOn
      description
      journalWorkflow {
        type
        status
        userGroupId
        retriedAt
        nextRetry
        completedAt
        freeTextNote
        completionOptions
        debugDetails
      }
      executionPeriod {
        start
        end
      }
      carePlan {
        id
        title
      }
      note {
        authorString
        time
        text
        authorReference {
          display
          reference
        }
      }
      subTasks {
        id
        code {
          text
        }
        authoredOn
        intent
        priority
        status
        partOf {
          reference
        }
        note {
          authorString
          time
          text
          authorReference {
            display
            reference
          }
        }
        focus {
          reference
        }
      }
      videoMeeting {
        id
        appointment {
          description
          status
          start
        }
        videonor {
          meetingId
        }
      }
      canRetryJournaling
      isJournalNoteRequired
    }
  }
`;

/**
 * __useGetTaskByIdWithJournalRetryQuery__
 *
 * To run a query within a Vue component, call `useGetTaskByIdWithJournalRetryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskByIdWithJournalRetryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTaskByIdWithJournalRetryQuery({
 *   taskId: // value for 'taskId'
 * });
 */
export function useGetTaskByIdWithJournalRetryQuery(
  variables:
    | GetTaskByIdWithJournalRetryQueryVariables
    | VueCompositionApi.Ref<GetTaskByIdWithJournalRetryQueryVariables>
    | ReactiveFunction<GetTaskByIdWithJournalRetryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>(
    GetTaskByIdWithJournalRetryDocument,
    variables,
    options,
  );
}
export function useGetTaskByIdWithJournalRetryLazyQuery(
  variables?:
    | GetTaskByIdWithJournalRetryQueryVariables
    | VueCompositionApi.Ref<GetTaskByIdWithJournalRetryQueryVariables>
    | ReactiveFunction<GetTaskByIdWithJournalRetryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetTaskByIdWithJournalRetryQuery, GetTaskByIdWithJournalRetryQueryVariables>(
    GetTaskByIdWithJournalRetryDocument,
    variables,
    options,
  );
}
export type GetTaskByIdWithJournalRetryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetTaskByIdWithJournalRetryQuery,
  GetTaskByIdWithJournalRetryQueryVariables
>;
export const ParentRpmGatewayDocument = gql`
  query parentRpmGateway($id: ID!) {
    parentRpmGateway: getRpmGateway(id: $id) {
      id
      gatewayHostname
    }
  }
`;

/**
 * __useParentRpmGatewayQuery__
 *
 * To run a query within a Vue component, call `useParentRpmGatewayQuery` and pass it any options that fit your needs.
 * When your component renders, `useParentRpmGatewayQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useParentRpmGatewayQuery({
 *   id: // value for 'id'
 * });
 */
export function useParentRpmGatewayQuery(
  variables:
    | ParentRpmGatewayQueryVariables
    | VueCompositionApi.Ref<ParentRpmGatewayQueryVariables>
    | ReactiveFunction<ParentRpmGatewayQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ParentRpmGatewayQuery, ParentRpmGatewayQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ParentRpmGatewayQuery, ParentRpmGatewayQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ParentRpmGatewayQuery, ParentRpmGatewayQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ParentRpmGatewayQuery, ParentRpmGatewayQueryVariables>(
    ParentRpmGatewayDocument,
    variables,
    options,
  );
}
export function useParentRpmGatewayLazyQuery(
  variables?:
    | ParentRpmGatewayQueryVariables
    | VueCompositionApi.Ref<ParentRpmGatewayQueryVariables>
    | ReactiveFunction<ParentRpmGatewayQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ParentRpmGatewayQuery, ParentRpmGatewayQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ParentRpmGatewayQuery, ParentRpmGatewayQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ParentRpmGatewayQuery, ParentRpmGatewayQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ParentRpmGatewayQuery, ParentRpmGatewayQueryVariables>(
    ParentRpmGatewayDocument,
    variables,
    options,
  );
}
export type ParentRpmGatewayQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ParentRpmGatewayQuery,
  ParentRpmGatewayQueryVariables
>;
export const RpmGatewayAlertsDocument = gql`
  query rpmGatewayAlerts {
    rpmGatewayAlerts {
      gateway {
        id
        gatewayHostname
      }
      alert
    }
  }
`;

/**
 * __useRpmGatewayAlertsQuery__
 *
 * To run a query within a Vue component, call `useRpmGatewayAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRpmGatewayAlertsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRpmGatewayAlertsQuery();
 */
export function useRpmGatewayAlertsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<RpmGatewayAlertsQuery, RpmGatewayAlertsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RpmGatewayAlertsQuery, RpmGatewayAlertsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RpmGatewayAlertsQuery, RpmGatewayAlertsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<RpmGatewayAlertsQuery, RpmGatewayAlertsQueryVariables>(
    RpmGatewayAlertsDocument,
    {},
    options,
  );
}
export function useRpmGatewayAlertsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<RpmGatewayAlertsQuery, RpmGatewayAlertsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RpmGatewayAlertsQuery, RpmGatewayAlertsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RpmGatewayAlertsQuery, RpmGatewayAlertsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<RpmGatewayAlertsQuery, RpmGatewayAlertsQueryVariables>(
    RpmGatewayAlertsDocument,
    {},
    options,
  );
}
export type RpmGatewayAlertsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RpmGatewayAlertsQuery,
  RpmGatewayAlertsQueryVariables
>;
export const CreateSelfTreatmentPlanTemplateDocument = gql`
  mutation createSelfTreatmentPlanTemplate($selfTreatmentPlanTemplateInput: SelfTreatmentPlanTemplateInput!) {
    createSelfTreatmentPlanTemplate(selfTreatmentPlanTemplateInput: $selfTreatmentPlanTemplateInput) {
      success
      message
      selfTreatmentPlan {
        id
      }
    }
  }
`;

/**
 * __useCreateSelfTreatmentPlanTemplateMutation__
 *
 * To run a mutation, you first call `useCreateSelfTreatmentPlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSelfTreatmentPlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSelfTreatmentPlanTemplateMutation({
 *   variables: {
 *     selfTreatmentPlanTemplateInput: // value for 'selfTreatmentPlanTemplateInput'
 *   },
 * });
 */
export function useCreateSelfTreatmentPlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateSelfTreatmentPlanTemplateMutation,
        CreateSelfTreatmentPlanTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateSelfTreatmentPlanTemplateMutation,
          CreateSelfTreatmentPlanTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateSelfTreatmentPlanTemplateMutation,
    CreateSelfTreatmentPlanTemplateMutationVariables
  >(CreateSelfTreatmentPlanTemplateDocument, options);
}
export type CreateSelfTreatmentPlanTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateSelfTreatmentPlanTemplateMutation,
  CreateSelfTreatmentPlanTemplateMutationVariables
>;
export const UpdateSelfTreatmentPlanTemplateDocument = gql`
  mutation updateSelfTreatmentPlanTemplate(
    $selfTreatmentPlanTemplateUpdateInput: SelfTreatmentPlanTemplateUpdateInput!
    $selfTreatmentPlanTemplateId: ID!
  ) {
    updateSelfTreatmentPlanTemplate(
      selfTreatmentPlanTemplateUpdateInput: $selfTreatmentPlanTemplateUpdateInput
      selfTreatmentPlanTemplateId: $selfTreatmentPlanTemplateId
    ) {
      success
      message
      selfTreatmentPlan {
        id
      }
    }
  }
`;

/**
 * __useUpdateSelfTreatmentPlanTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateSelfTreatmentPlanTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSelfTreatmentPlanTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSelfTreatmentPlanTemplateMutation({
 *   variables: {
 *     selfTreatmentPlanTemplateUpdateInput: // value for 'selfTreatmentPlanTemplateUpdateInput'
 *     selfTreatmentPlanTemplateId: // value for 'selfTreatmentPlanTemplateId'
 *   },
 * });
 */
export function useUpdateSelfTreatmentPlanTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateSelfTreatmentPlanTemplateMutation,
        UpdateSelfTreatmentPlanTemplateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateSelfTreatmentPlanTemplateMutation,
          UpdateSelfTreatmentPlanTemplateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateSelfTreatmentPlanTemplateMutation,
    UpdateSelfTreatmentPlanTemplateMutationVariables
  >(UpdateSelfTreatmentPlanTemplateDocument, options);
}
export type UpdateSelfTreatmentPlanTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateSelfTreatmentPlanTemplateMutation,
  UpdateSelfTreatmentPlanTemplateMutationVariables
>;
export const PatientNamesDocument = gql`
  query patientNames($id: ID!) {
    patient(id: $id) {
      id
      name {
        given
        family
      }
    }
  }
`;

/**
 * __usePatientNamesQuery__
 *
 * To run a query within a Vue component, call `usePatientNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientNamesQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientNamesQuery(
  variables:
    | PatientNamesQueryVariables
    | VueCompositionApi.Ref<PatientNamesQueryVariables>
    | ReactiveFunction<PatientNamesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientNamesQuery, PatientNamesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientNamesQuery, PatientNamesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientNamesQuery, PatientNamesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientNamesQuery, PatientNamesQueryVariables>(
    PatientNamesDocument,
    variables,
    options,
  );
}
export function usePatientNamesLazyQuery(
  variables?:
    | PatientNamesQueryVariables
    | VueCompositionApi.Ref<PatientNamesQueryVariables>
    | ReactiveFunction<PatientNamesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientNamesQuery, PatientNamesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientNamesQuery, PatientNamesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientNamesQuery, PatientNamesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientNamesQuery, PatientNamesQueryVariables>(
    PatientNamesDocument,
    variables,
    options,
  );
}
export type PatientNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientNamesQuery,
  PatientNamesQueryVariables
>;
export const PatientNamesWithCarePlansDocument = gql`
  query patientNamesWithCarePlans($id: ID!) {
    patient(id: $id) {
      id
      carePlans {
        id
        title
        status
      }
      name {
        given
        family
      }
    }
  }
`;

/**
 * __usePatientNamesWithCarePlansQuery__
 *
 * To run a query within a Vue component, call `usePatientNamesWithCarePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientNamesWithCarePlansQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientNamesWithCarePlansQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientNamesWithCarePlansQuery(
  variables:
    | PatientNamesWithCarePlansQueryVariables
    | VueCompositionApi.Ref<PatientNamesWithCarePlansQueryVariables>
    | ReactiveFunction<PatientNamesWithCarePlansQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>(
    PatientNamesWithCarePlansDocument,
    variables,
    options,
  );
}
export function usePatientNamesWithCarePlansLazyQuery(
  variables?:
    | PatientNamesWithCarePlansQueryVariables
    | VueCompositionApi.Ref<PatientNamesWithCarePlansQueryVariables>
    | ReactiveFunction<PatientNamesWithCarePlansQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientNamesWithCarePlansQuery, PatientNamesWithCarePlansQueryVariables>(
    PatientNamesWithCarePlansDocument,
    variables,
    options,
  );
}
export type PatientNamesWithCarePlansQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientNamesWithCarePlansQuery,
  PatientNamesWithCarePlansQueryVariables
>;
export const SimulateCarePlanObservationResponseDocument = gql`
  mutation simulateCarePlanObservationResponse($patientId: ID!, $activityId: ID!, $observation: ObservationInput!) {
    simulateCarePlanObservationResponse(patientId: $patientId, activityId: $activityId, observation: $observation) {
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useSimulateCarePlanObservationResponseMutation__
 *
 * To run a mutation, you first call `useSimulateCarePlanObservationResponseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSimulateCarePlanObservationResponseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSimulateCarePlanObservationResponseMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     activityId: // value for 'activityId'
 *     observation: // value for 'observation'
 *   },
 * });
 */
export function useSimulateCarePlanObservationResponseMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SimulateCarePlanObservationResponseMutation,
        SimulateCarePlanObservationResponseMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SimulateCarePlanObservationResponseMutation,
          SimulateCarePlanObservationResponseMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SimulateCarePlanObservationResponseMutation,
    SimulateCarePlanObservationResponseMutationVariables
  >(SimulateCarePlanObservationResponseDocument, options);
}
export type SimulateCarePlanObservationResponseMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    SimulateCarePlanObservationResponseMutation,
    SimulateCarePlanObservationResponseMutationVariables
  >;
export const SimulateCarePlanQuestionnaireResponseDocument = gql`
  mutation simulateCarePlanQuestionnaireResponse(
    $patientId: ID!
    $questionnaireResponseInput: QuestionnaireResponseSimulatorInput!
  ) {
    simulateCarePlanQuestionnaireResponse(
      patientId: $patientId
      questionnaireResponseInput: $questionnaireResponseInput
    ) {
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useSimulateCarePlanQuestionnaireResponseMutation__
 *
 * To run a mutation, you first call `useSimulateCarePlanQuestionnaireResponseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSimulateCarePlanQuestionnaireResponseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSimulateCarePlanQuestionnaireResponseMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     questionnaireResponseInput: // value for 'questionnaireResponseInput'
 *   },
 * });
 */
export function useSimulateCarePlanQuestionnaireResponseMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SimulateCarePlanQuestionnaireResponseMutation,
        SimulateCarePlanQuestionnaireResponseMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SimulateCarePlanQuestionnaireResponseMutation,
          SimulateCarePlanQuestionnaireResponseMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SimulateCarePlanQuestionnaireResponseMutation,
    SimulateCarePlanQuestionnaireResponseMutationVariables
  >(SimulateCarePlanQuestionnaireResponseDocument, options);
}
export type SimulateCarePlanQuestionnaireResponseMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    SimulateCarePlanQuestionnaireResponseMutation,
    SimulateCarePlanQuestionnaireResponseMutationVariables
  >;
export const UpdateRpmMedicalDeviceDocument = gql`
  mutation updateRpmMedicalDevice($id: ID!, $updateInput: RpmMedicalDeviceUpdateInput!) {
    updateRpmMedicalDevice(id: $id, updateInput: $updateInput) {
      success
      message
    }
  }
`;

/**
 * __useUpdateRpmMedicalDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateRpmMedicalDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRpmMedicalDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRpmMedicalDeviceMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateRpmMedicalDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateRpmMedicalDeviceMutation, UpdateRpmMedicalDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateRpmMedicalDeviceMutation, UpdateRpmMedicalDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateRpmMedicalDeviceMutation, UpdateRpmMedicalDeviceMutationVariables>(
    UpdateRpmMedicalDeviceDocument,
    options,
  );
}
export type UpdateRpmMedicalDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateRpmMedicalDeviceMutation,
  UpdateRpmMedicalDeviceMutationVariables
>;
export const AddExternalDialoggUserIdDocument = gql`
  mutation addExternalDialoggUserId($username: ID!, $externalUserId: ExternalHumanIdInput!) {
    addExternalDialoggUserId(username: $username, externalUserId: $externalUserId) {
      success
    }
  }
`;

/**
 * __useAddExternalDialoggUserIdMutation__
 *
 * To run a mutation, you first call `useAddExternalDialoggUserIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddExternalDialoggUserIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddExternalDialoggUserIdMutation({
 *   variables: {
 *     username: // value for 'username'
 *     externalUserId: // value for 'externalUserId'
 *   },
 * });
 */
export function useAddExternalDialoggUserIdMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddExternalDialoggUserIdMutation,
        AddExternalDialoggUserIdMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddExternalDialoggUserIdMutation,
          AddExternalDialoggUserIdMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<AddExternalDialoggUserIdMutation, AddExternalDialoggUserIdMutationVariables>(
    AddExternalDialoggUserIdDocument,
    options,
  );
}
export type AddExternalDialoggUserIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddExternalDialoggUserIdMutation,
  AddExternalDialoggUserIdMutationVariables
>;
export const ChangePicturePermissionDocument = gql`
  mutation changePicturePermission($username: ID!, $enabled: Boolean!) {
    changePicturePermission(username: $username, enabled: $enabled) {
      success
    }
  }
`;

/**
 * __useChangePicturePermissionMutation__
 *
 * To run a mutation, you first call `useChangePicturePermissionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangePicturePermissionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangePicturePermissionMutation({
 *   variables: {
 *     username: // value for 'username'
 *     enabled: // value for 'enabled'
 *   },
 * });
 */
export function useChangePicturePermissionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ChangePicturePermissionMutation, ChangePicturePermissionMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ChangePicturePermissionMutation,
          ChangePicturePermissionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ChangePicturePermissionMutation, ChangePicturePermissionMutationVariables>(
    ChangePicturePermissionDocument,
    options,
  );
}
export type ChangePicturePermissionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ChangePicturePermissionMutation,
  ChangePicturePermissionMutationVariables
>;
export const RemovePatientFromDialoggUserDocument = gql`
  mutation removePatientFromDialoggUser($username: ID!, $patientId: ID!) {
    removePatientFromDialoggUser(username: $username, patientId: $patientId) {
      success
      dialoggUser {
        username
      }
    }
  }
`;

/**
 * __useRemovePatientFromDialoggUserMutation__
 *
 * To run a mutation, you first call `useRemovePatientFromDialoggUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemovePatientFromDialoggUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemovePatientFromDialoggUserMutation({
 *   variables: {
 *     username: // value for 'username'
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useRemovePatientFromDialoggUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemovePatientFromDialoggUserMutation,
        RemovePatientFromDialoggUserMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemovePatientFromDialoggUserMutation,
          RemovePatientFromDialoggUserMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemovePatientFromDialoggUserMutation,
    RemovePatientFromDialoggUserMutationVariables
  >(RemovePatientFromDialoggUserDocument, options);
}
export type RemovePatientFromDialoggUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemovePatientFromDialoggUserMutation,
  RemovePatientFromDialoggUserMutationVariables
>;
export const SetOfPatientsDocument = gql`
  query setOfPatients($ids: [ID]!) {
    setOfPatients(ids: $ids) {
      id
      identifier {
        use
        value
      }
      name {
        given
        family
      }
    }
  }
`;

/**
 * __useSetOfPatientsQuery__
 *
 * To run a query within a Vue component, call `useSetOfPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetOfPatientsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSetOfPatientsQuery({
 *   ids: // value for 'ids'
 * });
 */
export function useSetOfPatientsQuery(
  variables:
    | SetOfPatientsQueryVariables
    | VueCompositionApi.Ref<SetOfPatientsQueryVariables>
    | ReactiveFunction<SetOfPatientsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<SetOfPatientsQuery, SetOfPatientsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SetOfPatientsQuery, SetOfPatientsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<SetOfPatientsQuery, SetOfPatientsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<SetOfPatientsQuery, SetOfPatientsQueryVariables>(
    SetOfPatientsDocument,
    variables,
    options,
  );
}
export function useSetOfPatientsLazyQuery(
  variables?:
    | SetOfPatientsQueryVariables
    | VueCompositionApi.Ref<SetOfPatientsQueryVariables>
    | ReactiveFunction<SetOfPatientsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<SetOfPatientsQuery, SetOfPatientsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SetOfPatientsQuery, SetOfPatientsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<SetOfPatientsQuery, SetOfPatientsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<SetOfPatientsQuery, SetOfPatientsQueryVariables>(
    SetOfPatientsDocument,
    variables,
    options,
  );
}
export type SetOfPatientsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  SetOfPatientsQuery,
  SetOfPatientsQueryVariables
>;
export const CreateDialoggUserDocument = gql`
  mutation createDialoggUser($dialoggUser: CreateDialoggUserInput!) {
    createDialoggUser(dialoggUser: $dialoggUser) {
      success
      message
    }
  }
`;

/**
 * __useCreateDialoggUserMutation__
 *
 * To run a mutation, you first call `useCreateDialoggUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDialoggUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDialoggUserMutation({
 *   variables: {
 *     dialoggUser: // value for 'dialoggUser'
 *   },
 * });
 */
export function useCreateDialoggUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateDialoggUserMutation, CreateDialoggUserMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateDialoggUserMutation, CreateDialoggUserMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateDialoggUserMutation, CreateDialoggUserMutationVariables>(
    CreateDialoggUserDocument,
    options,
  );
}
export type CreateDialoggUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateDialoggUserMutation,
  CreateDialoggUserMutationVariables
>;
export const UpdateDialoggUserDocument = gql`
  mutation updateDialoggUser($username: ID!, $dialoggUser: UpdateDialoggUser!) {
    updateDialoggUser(username: $username, dialoggUser: $dialoggUser) {
      success
      message
    }
  }
`;

/**
 * __useUpdateDialoggUserMutation__
 *
 * To run a mutation, you first call `useUpdateDialoggUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDialoggUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDialoggUserMutation({
 *   variables: {
 *     username: // value for 'username'
 *     dialoggUser: // value for 'dialoggUser'
 *   },
 * });
 */
export function useUpdateDialoggUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateDialoggUserMutation, UpdateDialoggUserMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateDialoggUserMutation, UpdateDialoggUserMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateDialoggUserMutation, UpdateDialoggUserMutationVariables>(
    UpdateDialoggUserDocument,
    options,
  );
}
export type UpdateDialoggUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDialoggUserMutation,
  UpdateDialoggUserMutationVariables
>;
export const ForceDeleteDialoggUserDocument = gql`
  mutation forceDeleteDialoggUser($username: ID!) {
    forceDeleteDialoggUser(username: $username) {
      success
      message
    }
  }
`;

/**
 * __useForceDeleteDialoggUserMutation__
 *
 * To run a mutation, you first call `useForceDeleteDialoggUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useForceDeleteDialoggUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useForceDeleteDialoggUserMutation({
 *   variables: {
 *     username: // value for 'username'
 *   },
 * });
 */
export function useForceDeleteDialoggUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ForceDeleteDialoggUserMutation, ForceDeleteDialoggUserMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ForceDeleteDialoggUserMutation, ForceDeleteDialoggUserMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ForceDeleteDialoggUserMutation, ForceDeleteDialoggUserMutationVariables>(
    ForceDeleteDialoggUserDocument,
    options,
  );
}
export type ForceDeleteDialoggUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ForceDeleteDialoggUserMutation,
  ForceDeleteDialoggUserMutationVariables
>;
export const DeleteDialoggUserDocument = gql`
  mutation deleteDialoggUser($username: ID!) {
    deleteDialoggUser(username: $username) {
      success
      message
    }
  }
`;

/**
 * __useDeleteDialoggUserMutation__
 *
 * To run a mutation, you first call `useDeleteDialoggUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDialoggUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDialoggUserMutation({
 *   variables: {
 *     username: // value for 'username'
 *   },
 * });
 */
export function useDeleteDialoggUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteDialoggUserMutation, DeleteDialoggUserMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteDialoggUserMutation, DeleteDialoggUserMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteDialoggUserMutation, DeleteDialoggUserMutationVariables>(
    DeleteDialoggUserDocument,
    options,
  );
}
export type DeleteDialoggUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteDialoggUserMutation,
  DeleteDialoggUserMutationVariables
>;
export const UpdateDialoggUserPasswordDocument = gql`
  mutation updateDialoggUserPassword($username: ID!, $password: String!) {
    updateDialoggUserPassword(username: $username, password: $password) {
      success
      message
    }
  }
`;

/**
 * __useUpdateDialoggUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateDialoggUserPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDialoggUserPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDialoggUserPasswordMutation({
 *   variables: {
 *     username: // value for 'username'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useUpdateDialoggUserPasswordMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateDialoggUserPasswordMutation,
        UpdateDialoggUserPasswordMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateDialoggUserPasswordMutation,
          UpdateDialoggUserPasswordMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateDialoggUserPasswordMutation, UpdateDialoggUserPasswordMutationVariables>(
    UpdateDialoggUserPasswordDocument,
    options,
  );
}
export type UpdateDialoggUserPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDialoggUserPasswordMutation,
  UpdateDialoggUserPasswordMutationVariables
>;
export const RemoveDialoggUserPasswordDocument = gql`
  mutation removeDialoggUserPassword($username: ID!) {
    removeDialoggUserPassword(username: $username) {
      success
      message
    }
  }
`;

/**
 * __useRemoveDialoggUserPasswordMutation__
 *
 * To run a mutation, you first call `useRemoveDialoggUserPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDialoggUserPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveDialoggUserPasswordMutation({
 *   variables: {
 *     username: // value for 'username'
 *   },
 * });
 */
export function useRemoveDialoggUserPasswordMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveDialoggUserPasswordMutation,
        RemoveDialoggUserPasswordMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveDialoggUserPasswordMutation,
          RemoveDialoggUserPasswordMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<RemoveDialoggUserPasswordMutation, RemoveDialoggUserPasswordMutationVariables>(
    RemoveDialoggUserPasswordDocument,
    options,
  );
}
export type RemoveDialoggUserPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveDialoggUserPasswordMutation,
  RemoveDialoggUserPasswordMutationVariables
>;
export const AssignPatientToDialoggUserDocument = gql`
  mutation assignPatientToDialoggUser($username: ID!, $patientId: ID!) {
    assignPatientToDialoggUser(username: $username, patientId: $patientId) {
      success
      message
    }
  }
`;

/**
 * __useAssignPatientToDialoggUserMutation__
 *
 * To run a mutation, you first call `useAssignPatientToDialoggUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignPatientToDialoggUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignPatientToDialoggUserMutation({
 *   variables: {
 *     username: // value for 'username'
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useAssignPatientToDialoggUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AssignPatientToDialoggUserMutation,
        AssignPatientToDialoggUserMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AssignPatientToDialoggUserMutation,
          AssignPatientToDialoggUserMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AssignPatientToDialoggUserMutation,
    AssignPatientToDialoggUserMutationVariables
  >(AssignPatientToDialoggUserDocument, options);
}
export type AssignPatientToDialoggUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AssignPatientToDialoggUserMutation,
  AssignPatientToDialoggUserMutationVariables
>;
export const ActivateDialoggUserSmsOtpDocument = gql`
  mutation activateDialoggUserSmsOtp($username: ID!, $phoneNumber: String!) {
    activateDialoggUserSmsOtp(username: $username, phoneNumber: $phoneNumber)
  }
`;

/**
 * __useActivateDialoggUserSmsOtpMutation__
 *
 * To run a mutation, you first call `useActivateDialoggUserSmsOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateDialoggUserSmsOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateDialoggUserSmsOtpMutation({
 *   variables: {
 *     username: // value for 'username'
 *     phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useActivateDialoggUserSmsOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ActivateDialoggUserSmsOtpMutation,
        ActivateDialoggUserSmsOtpMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ActivateDialoggUserSmsOtpMutation,
          ActivateDialoggUserSmsOtpMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ActivateDialoggUserSmsOtpMutation, ActivateDialoggUserSmsOtpMutationVariables>(
    ActivateDialoggUserSmsOtpDocument,
    options,
  );
}
export type ActivateDialoggUserSmsOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateDialoggUserSmsOtpMutation,
  ActivateDialoggUserSmsOtpMutationVariables
>;
export const DeactivateDialoggUserSmsOtpDocument = gql`
  mutation deactivateDialoggUserSmsOtp($username: ID!) {
    deactivateDialoggUserSmsOtp(username: $username)
  }
`;

/**
 * __useDeactivateDialoggUserSmsOtpMutation__
 *
 * To run a mutation, you first call `useDeactivateDialoggUserSmsOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateDialoggUserSmsOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeactivateDialoggUserSmsOtpMutation({
 *   variables: {
 *     username: // value for 'username'
 *   },
 * });
 */
export function useDeactivateDialoggUserSmsOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeactivateDialoggUserSmsOtpMutation,
        DeactivateDialoggUserSmsOtpMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeactivateDialoggUserSmsOtpMutation,
          DeactivateDialoggUserSmsOtpMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DeactivateDialoggUserSmsOtpMutation,
    DeactivateDialoggUserSmsOtpMutationVariables
  >(DeactivateDialoggUserSmsOtpDocument, options);
}
export type DeactivateDialoggUserSmsOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeactivateDialoggUserSmsOtpMutation,
  DeactivateDialoggUserSmsOtpMutationVariables
>;
export const ActivateDialoggUserOtpDocument = gql`
  mutation activateDialoggUserOtp($username: ID!) {
    activateDialoggUserOtp(username: $username)
  }
`;

/**
 * __useActivateDialoggUserOtpMutation__
 *
 * To run a mutation, you first call `useActivateDialoggUserOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateDialoggUserOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateDialoggUserOtpMutation({
 *   variables: {
 *     username: // value for 'username'
 *   },
 * });
 */
export function useActivateDialoggUserOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ActivateDialoggUserOtpMutation, ActivateDialoggUserOtpMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ActivateDialoggUserOtpMutation, ActivateDialoggUserOtpMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ActivateDialoggUserOtpMutation, ActivateDialoggUserOtpMutationVariables>(
    ActivateDialoggUserOtpDocument,
    options,
  );
}
export type ActivateDialoggUserOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateDialoggUserOtpMutation,
  ActivateDialoggUserOtpMutationVariables
>;
export const DeleteDialoggUserOtpDocument = gql`
  mutation deleteDialoggUserOtp($username: ID!) {
    deleteDialoggUserOtp(username: $username)
  }
`;

/**
 * __useDeleteDialoggUserOtpMutation__
 *
 * To run a mutation, you first call `useDeleteDialoggUserOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDialoggUserOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDialoggUserOtpMutation({
 *   variables: {
 *     username: // value for 'username'
 *   },
 * });
 */
export function useDeleteDialoggUserOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteDialoggUserOtpMutation, DeleteDialoggUserOtpMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteDialoggUserOtpMutation, DeleteDialoggUserOtpMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteDialoggUserOtpMutation, DeleteDialoggUserOtpMutationVariables>(
    DeleteDialoggUserOtpDocument,
    options,
  );
}
export type DeleteDialoggUserOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteDialoggUserOtpMutation,
  DeleteDialoggUserOtpMutationVariables
>;
export const CancelDialoggUserOtpDocument = gql`
  mutation cancelDialoggUserOtp($username: ID!) {
    cancelDialoggUserOtp(username: $username)
  }
`;

/**
 * __useCancelDialoggUserOtpMutation__
 *
 * To run a mutation, you first call `useCancelDialoggUserOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelDialoggUserOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelDialoggUserOtpMutation({
 *   variables: {
 *     username: // value for 'username'
 *   },
 * });
 */
export function useCancelDialoggUserOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CancelDialoggUserOtpMutation, CancelDialoggUserOtpMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CancelDialoggUserOtpMutation, CancelDialoggUserOtpMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CancelDialoggUserOtpMutation, CancelDialoggUserOtpMutationVariables>(
    CancelDialoggUserOtpDocument,
    options,
  );
}
export type CancelDialoggUserOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CancelDialoggUserOtpMutation,
  CancelDialoggUserOtpMutationVariables
>;
export const UpdateDialoggUserIpRestrictionsDocument = gql`
  mutation updateDialoggUserIPRestrictions($username: ID!, $ipRestrictions: [String]) {
    updateDialoggUserIPRestrictions(username: $username, ipRestrictions: $ipRestrictions) {
      success
    }
  }
`;

/**
 * __useUpdateDialoggUserIpRestrictionsMutation__
 *
 * To run a mutation, you first call `useUpdateDialoggUserIpRestrictionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDialoggUserIpRestrictionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDialoggUserIpRestrictionsMutation({
 *   variables: {
 *     username: // value for 'username'
 *     ipRestrictions: // value for 'ipRestrictions'
 *   },
 * });
 */
export function useUpdateDialoggUserIpRestrictionsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateDialoggUserIpRestrictionsMutation,
        UpdateDialoggUserIpRestrictionsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateDialoggUserIpRestrictionsMutation,
          UpdateDialoggUserIpRestrictionsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateDialoggUserIpRestrictionsMutation,
    UpdateDialoggUserIpRestrictionsMutationVariables
  >(UpdateDialoggUserIpRestrictionsDocument, options);
}
export type UpdateDialoggUserIpRestrictionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDialoggUserIpRestrictionsMutation,
  UpdateDialoggUserIpRestrictionsMutationVariables
>;
export const UpdateDialggUserTimeLimitedAccessDocument = gql`
  mutation updateDialggUserTimeLimitedAccess($username: ID!, $timeLimitedAccess: PeriodInput) {
    updateDialoggUserTimeLimitedAccess(username: $username, timeLimitedAccess: $timeLimitedAccess) {
      success
      inputValidation {
        message
      }
    }
  }
`;

/**
 * __useUpdateDialggUserTimeLimitedAccessMutation__
 *
 * To run a mutation, you first call `useUpdateDialggUserTimeLimitedAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDialggUserTimeLimitedAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDialggUserTimeLimitedAccessMutation({
 *   variables: {
 *     username: // value for 'username'
 *     timeLimitedAccess: // value for 'timeLimitedAccess'
 *   },
 * });
 */
export function useUpdateDialggUserTimeLimitedAccessMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateDialggUserTimeLimitedAccessMutation,
        UpdateDialggUserTimeLimitedAccessMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateDialggUserTimeLimitedAccessMutation,
          UpdateDialggUserTimeLimitedAccessMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateDialggUserTimeLimitedAccessMutation,
    UpdateDialggUserTimeLimitedAccessMutationVariables
  >(UpdateDialggUserTimeLimitedAccessDocument, options);
}
export type UpdateDialggUserTimeLimitedAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDialggUserTimeLimitedAccessMutation,
  UpdateDialggUserTimeLimitedAccessMutationVariables
>;
export const SetDialoggUserExternalIdPDocument = gql`
  mutation setDialoggUserExternalIdP($username: ID!, $identities: [ExternalIdentityInput]) {
    setDialoggUserExternalIdP(username: $username, identities: $identities)
  }
`;

/**
 * __useSetDialoggUserExternalIdPMutation__
 *
 * To run a mutation, you first call `useSetDialoggUserExternalIdPMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetDialoggUserExternalIdPMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetDialoggUserExternalIdPMutation({
 *   variables: {
 *     username: // value for 'username'
 *     identities: // value for 'identities'
 *   },
 * });
 */
export function useSetDialoggUserExternalIdPMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SetDialoggUserExternalIdPMutation,
        SetDialoggUserExternalIdPMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetDialoggUserExternalIdPMutation,
          SetDialoggUserExternalIdPMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<SetDialoggUserExternalIdPMutation, SetDialoggUserExternalIdPMutationVariables>(
    SetDialoggUserExternalIdPDocument,
    options,
  );
}
export type SetDialoggUserExternalIdPMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetDialoggUserExternalIdPMutation,
  SetDialoggUserExternalIdPMutationVariables
>;
export const UpdateObservationStatusDocument = gql`
  mutation updateObservationStatus($id: ID!, $status: String!) {
    updateObservationStatus(id: $id, status: $status) {
      success
    }
  }
`;

/**
 * __useUpdateObservationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateObservationStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObservationStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateObservationStatusMutation({
 *   variables: {
 *     id: // value for 'id'
 *     status: // value for 'status'
 *   },
 * });
 */
export function useUpdateObservationStatusMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateObservationStatusMutation, UpdateObservationStatusMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateObservationStatusMutation,
          UpdateObservationStatusMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateObservationStatusMutation, UpdateObservationStatusMutationVariables>(
    UpdateObservationStatusDocument,
    options,
  );
}
export type UpdateObservationStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateObservationStatusMutation,
  UpdateObservationStatusMutationVariables
>;
export const RemovePatientFromDialoggUserInPatientDocument = gql`
  mutation removePatientFromDialoggUserInPatient($username: ID!, $patientId: ID!) {
    removePatientFromDialoggUser(username: $username, patientId: $patientId) {
      success
      dialoggUser {
        username
        onBehalf {
          accessiblePatients
          otherPatientIds
        }
      }
    }
  }
`;

/**
 * __useRemovePatientFromDialoggUserInPatientMutation__
 *
 * To run a mutation, you first call `useRemovePatientFromDialoggUserInPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemovePatientFromDialoggUserInPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemovePatientFromDialoggUserInPatientMutation({
 *   variables: {
 *     username: // value for 'username'
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useRemovePatientFromDialoggUserInPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemovePatientFromDialoggUserInPatientMutation,
        RemovePatientFromDialoggUserInPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemovePatientFromDialoggUserInPatientMutation,
          RemovePatientFromDialoggUserInPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemovePatientFromDialoggUserInPatientMutation,
    RemovePatientFromDialoggUserInPatientMutationVariables
  >(RemovePatientFromDialoggUserInPatientDocument, options);
}
export type RemovePatientFromDialoggUserInPatientMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    RemovePatientFromDialoggUserInPatientMutation,
    RemovePatientFromDialoggUserInPatientMutationVariables
  >;
export const DialoggUsersWithAccessToPatientDocument = gql`
  query dialoggUsersWithAccessToPatient($patientId: ID!) {
    dialoggUsersWithAccessToPatient(patientId: $patientId) {
      username
      firstName
      lastName
      lastActive
      role
    }
  }
`;

/**
 * __useDialoggUsersWithAccessToPatientQuery__
 *
 * To run a query within a Vue component, call `useDialoggUsersWithAccessToPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useDialoggUsersWithAccessToPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDialoggUsersWithAccessToPatientQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useDialoggUsersWithAccessToPatientQuery(
  variables:
    | DialoggUsersWithAccessToPatientQueryVariables
    | VueCompositionApi.Ref<DialoggUsersWithAccessToPatientQueryVariables>
    | ReactiveFunction<DialoggUsersWithAccessToPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        DialoggUsersWithAccessToPatientQuery,
        DialoggUsersWithAccessToPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          DialoggUsersWithAccessToPatientQuery,
          DialoggUsersWithAccessToPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          DialoggUsersWithAccessToPatientQuery,
          DialoggUsersWithAccessToPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    DialoggUsersWithAccessToPatientQuery,
    DialoggUsersWithAccessToPatientQueryVariables
  >(DialoggUsersWithAccessToPatientDocument, variables, options);
}
export function useDialoggUsersWithAccessToPatientLazyQuery(
  variables?:
    | DialoggUsersWithAccessToPatientQueryVariables
    | VueCompositionApi.Ref<DialoggUsersWithAccessToPatientQueryVariables>
    | ReactiveFunction<DialoggUsersWithAccessToPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        DialoggUsersWithAccessToPatientQuery,
        DialoggUsersWithAccessToPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          DialoggUsersWithAccessToPatientQuery,
          DialoggUsersWithAccessToPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          DialoggUsersWithAccessToPatientQuery,
          DialoggUsersWithAccessToPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    DialoggUsersWithAccessToPatientQuery,
    DialoggUsersWithAccessToPatientQueryVariables
  >(DialoggUsersWithAccessToPatientDocument, variables, options);
}
export type DialoggUsersWithAccessToPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DialoggUsersWithAccessToPatientQuery,
  DialoggUsersWithAccessToPatientQueryVariables
>;
export const GetPatientSelfTreatmentPlansDocument = gql`
  query getPatientSelfTreatmentPlans($patientId: ID!) {
    getPatientSelfTreatmentPlans(patientId: $patientId) {
      id
      status
      lastUpdated
      subject {
        display
      }
      goals {
        id
        goal
      }
      medicalStates {
        green {
          symptoms
          treatments
        }
        yellow {
          symptoms
          treatments
        }
        red {
          symptoms
          treatments
        }
      }
    }
  }
`;

/**
 * __useGetPatientSelfTreatmentPlansQuery__
 *
 * To run a query within a Vue component, call `useGetPatientSelfTreatmentPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientSelfTreatmentPlansQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientSelfTreatmentPlansQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetPatientSelfTreatmentPlansQuery(
  variables:
    | GetPatientSelfTreatmentPlansQueryVariables
    | VueCompositionApi.Ref<GetPatientSelfTreatmentPlansQueryVariables>
    | ReactiveFunction<GetPatientSelfTreatmentPlansQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientSelfTreatmentPlansQuery, GetPatientSelfTreatmentPlansQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPatientSelfTreatmentPlansQuery,
          GetPatientSelfTreatmentPlansQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPatientSelfTreatmentPlansQuery,
          GetPatientSelfTreatmentPlansQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientSelfTreatmentPlansQuery, GetPatientSelfTreatmentPlansQueryVariables>(
    GetPatientSelfTreatmentPlansDocument,
    variables,
    options,
  );
}
export function useGetPatientSelfTreatmentPlansLazyQuery(
  variables?:
    | GetPatientSelfTreatmentPlansQueryVariables
    | VueCompositionApi.Ref<GetPatientSelfTreatmentPlansQueryVariables>
    | ReactiveFunction<GetPatientSelfTreatmentPlansQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientSelfTreatmentPlansQuery, GetPatientSelfTreatmentPlansQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPatientSelfTreatmentPlansQuery,
          GetPatientSelfTreatmentPlansQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPatientSelfTreatmentPlansQuery,
          GetPatientSelfTreatmentPlansQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetPatientSelfTreatmentPlansQuery,
    GetPatientSelfTreatmentPlansQueryVariables
  >(GetPatientSelfTreatmentPlansDocument, variables, options);
}
export type GetPatientSelfTreatmentPlansQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientSelfTreatmentPlansQuery,
  GetPatientSelfTreatmentPlansQueryVariables
>;
export const CreatePatientGoalsDocument = gql`
  mutation createPatientGoals($patientId: ID!, $goalInput: GoalInput!) {
    createPatientGoals(patientId: $patientId, goalInput: $goalInput) {
      success
      message
      selfTreatmentPlan {
        id
      }
    }
  }
`;

/**
 * __useCreatePatientGoalsMutation__
 *
 * To run a mutation, you first call `useCreatePatientGoalsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientGoalsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePatientGoalsMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     goalInput: // value for 'goalInput'
 *   },
 * });
 */
export function useCreatePatientGoalsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreatePatientGoalsMutation, CreatePatientGoalsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreatePatientGoalsMutation, CreatePatientGoalsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreatePatientGoalsMutation, CreatePatientGoalsMutationVariables>(
    CreatePatientGoalsDocument,
    options,
  );
}
export type CreatePatientGoalsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreatePatientGoalsMutation,
  CreatePatientGoalsMutationVariables
>;
export const CreatePatientMedicalStatesDocument = gql`
  mutation createPatientMedicalStates($patientId: ID!, $medicalStateInput: MedicalStatesInput!) {
    createPatientMedicalStates(patientId: $patientId, medicalStateInput: $medicalStateInput) {
      success
      message
      selfTreatmentPlan {
        id
      }
    }
  }
`;

/**
 * __useCreatePatientMedicalStatesMutation__
 *
 * To run a mutation, you first call `useCreatePatientMedicalStatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientMedicalStatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePatientMedicalStatesMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     medicalStateInput: // value for 'medicalStateInput'
 *   },
 * });
 */
export function useCreatePatientMedicalStatesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreatePatientMedicalStatesMutation,
        CreatePatientMedicalStatesMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreatePatientMedicalStatesMutation,
          CreatePatientMedicalStatesMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreatePatientMedicalStatesMutation,
    CreatePatientMedicalStatesMutationVariables
  >(CreatePatientMedicalStatesDocument, options);
}
export type CreatePatientMedicalStatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreatePatientMedicalStatesMutation,
  CreatePatientMedicalStatesMutationVariables
>;
export const ActivateSelfTreatmentPlanDocument = gql`
  mutation activateSelfTreatmentPlan($selfTreatmentPlanId: ID!) {
    activateSelfTreatmentPlan(selfTreatmentPlanId: $selfTreatmentPlanId) {
      success
      message
    }
  }
`;

/**
 * __useActivateSelfTreatmentPlanMutation__
 *
 * To run a mutation, you first call `useActivateSelfTreatmentPlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateSelfTreatmentPlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateSelfTreatmentPlanMutation({
 *   variables: {
 *     selfTreatmentPlanId: // value for 'selfTreatmentPlanId'
 *   },
 * });
 */
export function useActivateSelfTreatmentPlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ActivateSelfTreatmentPlanMutation,
        ActivateSelfTreatmentPlanMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ActivateSelfTreatmentPlanMutation,
          ActivateSelfTreatmentPlanMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<ActivateSelfTreatmentPlanMutation, ActivateSelfTreatmentPlanMutationVariables>(
    ActivateSelfTreatmentPlanDocument,
    options,
  );
}
export type ActivateSelfTreatmentPlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateSelfTreatmentPlanMutation,
  ActivateSelfTreatmentPlanMutationVariables
>;
export const DeactivateSelfTreatmentPlanDocument = gql`
  mutation deactivateSelfTreatmentPlan($selfTreatmentPlanId: ID!) {
    deactivateSelfTreatmentPlan(selfTreatmentPlanId: $selfTreatmentPlanId) {
      success
      message
    }
  }
`;

/**
 * __useDeactivateSelfTreatmentPlanMutation__
 *
 * To run a mutation, you first call `useDeactivateSelfTreatmentPlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateSelfTreatmentPlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeactivateSelfTreatmentPlanMutation({
 *   variables: {
 *     selfTreatmentPlanId: // value for 'selfTreatmentPlanId'
 *   },
 * });
 */
export function useDeactivateSelfTreatmentPlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeactivateSelfTreatmentPlanMutation,
        DeactivateSelfTreatmentPlanMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeactivateSelfTreatmentPlanMutation,
          DeactivateSelfTreatmentPlanMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DeactivateSelfTreatmentPlanMutation,
    DeactivateSelfTreatmentPlanMutationVariables
  >(DeactivateSelfTreatmentPlanDocument, options);
}
export type DeactivateSelfTreatmentPlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeactivateSelfTreatmentPlanMutation,
  DeactivateSelfTreatmentPlanMutationVariables
>;
export const UpdatePatientGoalsDocument = gql`
  mutation updatePatientGoals($patientId: ID!, $goalInput: UpdateGoalInput!) {
    updatePatientGoals(patientId: $patientId, goalInput: $goalInput) {
      success
      message
    }
  }
`;

/**
 * __useUpdatePatientGoalsMutation__
 *
 * To run a mutation, you first call `useUpdatePatientGoalsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientGoalsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientGoalsMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     goalInput: // value for 'goalInput'
 *   },
 * });
 */
export function useUpdatePatientGoalsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdatePatientGoalsMutation, UpdatePatientGoalsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdatePatientGoalsMutation, UpdatePatientGoalsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePatientGoalsMutation, UpdatePatientGoalsMutationVariables>(
    UpdatePatientGoalsDocument,
    options,
  );
}
export type UpdatePatientGoalsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientGoalsMutation,
  UpdatePatientGoalsMutationVariables
>;
export const UpdatePatientMedicalStatesDocument = gql`
  mutation updatePatientMedicalStates($patientId: ID!, $medicalStateInput: MedicalStatesInput!) {
    updatePatientMedicalStates(patientId: $patientId, medicalStateInput: $medicalStateInput) {
      success
      message
    }
  }
`;

/**
 * __useUpdatePatientMedicalStatesMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMedicalStatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMedicalStatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientMedicalStatesMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     medicalStateInput: // value for 'medicalStateInput'
 *   },
 * });
 */
export function useUpdatePatientMedicalStatesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdatePatientMedicalStatesMutation,
        UpdatePatientMedicalStatesMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdatePatientMedicalStatesMutation,
          UpdatePatientMedicalStatesMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdatePatientMedicalStatesMutation,
    UpdatePatientMedicalStatesMutationVariables
  >(UpdatePatientMedicalStatesDocument, options);
}
export type UpdatePatientMedicalStatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientMedicalStatesMutation,
  UpdatePatientMedicalStatesMutationVariables
>;
export const GetAllQuestionnaireTemplatesToCreateBasedOnExistingDocument = gql`
  query getAllQuestionnaireTemplatesToCreateBasedOnExisting {
    getAllQuestionnaireTemplates {
      id
      title
      version
      status
    }
  }
`;

/**
 * __useGetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery__
 *
 * To run a query within a Vue component, call `useGetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery();
 */
export function useGetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
        GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
    GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
  >(GetAllQuestionnaireTemplatesToCreateBasedOnExistingDocument, {}, options);
}
export function useGetAllQuestionnaireTemplatesToCreateBasedOnExistingLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
        GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
          GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
    GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
  >(GetAllQuestionnaireTemplatesToCreateBasedOnExistingDocument, {}, options);
}
export type GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetAllQuestionnaireTemplatesToCreateBasedOnExistingQuery,
    GetAllQuestionnaireTemplatesToCreateBasedOnExistingQueryVariables
  >;
export const QuestionnaireTemplatesDocument = gql`
  query questionnaireTemplates {
    getAllQuestionnaireTemplates {
      id
      title
      purpose
      experimental
      version
      effectivePeriod {
        start
        end
      }
      status
    }
  }
`;

/**
 * __useQuestionnaireTemplatesQuery__
 *
 * To run a query within a Vue component, call `useQuestionnaireTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionnaireTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQuestionnaireTemplatesQuery();
 */
export function useQuestionnaireTemplatesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>(
    QuestionnaireTemplatesDocument,
    {},
    options,
  );
}
export function useQuestionnaireTemplatesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<QuestionnaireTemplatesQuery, QuestionnaireTemplatesQueryVariables>(
    QuestionnaireTemplatesDocument,
    {},
    options,
  );
}
export type QuestionnaireTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  QuestionnaireTemplatesQuery,
  QuestionnaireTemplatesQueryVariables
>;
export const PatientWithJournalConfigDocument = gql`
  query patientWithJournalConfig($patientId: ID!) {
    patient(id: $patientId) {
      id
      name {
        text
      }
      journalConfigForPatient {
        remotePatientMonitoring {
          enabled
          taskCodesForJournaling
        }
      }
    }
  }
`;

/**
 * __usePatientWithJournalConfigQuery__
 *
 * To run a query within a Vue component, call `usePatientWithJournalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientWithJournalConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientWithJournalConfigQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function usePatientWithJournalConfigQuery(
  variables:
    | PatientWithJournalConfigQueryVariables
    | VueCompositionApi.Ref<PatientWithJournalConfigQueryVariables>
    | ReactiveFunction<PatientWithJournalConfigQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>(
    PatientWithJournalConfigDocument,
    variables,
    options,
  );
}
export function usePatientWithJournalConfigLazyQuery(
  variables?:
    | PatientWithJournalConfigQueryVariables
    | VueCompositionApi.Ref<PatientWithJournalConfigQueryVariables>
    | ReactiveFunction<PatientWithJournalConfigQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientWithJournalConfigQuery, PatientWithJournalConfigQueryVariables>(
    PatientWithJournalConfigDocument,
    variables,
    options,
  );
}
export type PatientWithJournalConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientWithJournalConfigQuery,
  PatientWithJournalConfigQueryVariables
>;
export const PlanVideoMeetingDocument = gql`
  mutation planVideoMeeting($patientId: ID!, $createInput: VideoMeetingInput!) {
    planVideoMeeting(patientId: $patientId, createInput: $createInput) {
      success
      videoMeeting {
        id
      }
      calendarInvitation
    }
  }
`;

/**
 * __usePlanVideoMeetingMutation__
 *
 * To run a mutation, you first call `usePlanVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePlanVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePlanVideoMeetingMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function usePlanVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<PlanVideoMeetingMutation, PlanVideoMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<PlanVideoMeetingMutation, PlanVideoMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<PlanVideoMeetingMutation, PlanVideoMeetingMutationVariables>(
    PlanVideoMeetingDocument,
    options,
  );
}
export type PlanVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  PlanVideoMeetingMutation,
  PlanVideoMeetingMutationVariables
>;
export const PatientRequestDocument = gql`
  query patientRequest($taskId: ID!) {
    patientRequest: getTaskById(taskId: $taskId) {
      id
      status
      priority
      note {
        time
        text
        authorString
        authorReference {
          display
          reference
        }
      }
      description
      authoredOn
    }
  }
`;

/**
 * __usePatientRequestQuery__
 *
 * To run a query within a Vue component, call `usePatientRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientRequestQuery({
 *   taskId: // value for 'taskId'
 * });
 */
export function usePatientRequestQuery(
  variables:
    | PatientRequestQueryVariables
    | VueCompositionApi.Ref<PatientRequestQueryVariables>
    | ReactiveFunction<PatientRequestQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientRequestQuery, PatientRequestQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientRequestQuery, PatientRequestQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientRequestQuery, PatientRequestQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientRequestQuery, PatientRequestQueryVariables>(
    PatientRequestDocument,
    variables,
    options,
  );
}
export function usePatientRequestLazyQuery(
  variables?:
    | PatientRequestQueryVariables
    | VueCompositionApi.Ref<PatientRequestQueryVariables>
    | ReactiveFunction<PatientRequestQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientRequestQuery, PatientRequestQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientRequestQuery, PatientRequestQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientRequestQuery, PatientRequestQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientRequestQuery, PatientRequestQueryVariables>(
    PatientRequestDocument,
    variables,
    options,
  );
}
export type PatientRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientRequestQuery,
  PatientRequestQueryVariables
>;
export const RescheduleVideoMeetingDocument = gql`
  mutation rescheduleVideoMeeting($id: ID!, $start: dateTime!, $end: dateTime!, $description: String) {
    rescheduleVideoMeeting(videoMeetingId: $id, start: $start, end: $end, description: $description) {
      success
      calendarInvitation
    }
  }
`;

/**
 * __useRescheduleVideoMeetingMutation__
 *
 * To run a mutation, you first call `useRescheduleVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRescheduleVideoMeetingMutation({
 *   variables: {
 *     id: // value for 'id'
 *     start: // value for 'start'
 *     end: // value for 'end'
 *     description: // value for 'description'
 *   },
 * });
 */
export function useRescheduleVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RescheduleVideoMeetingMutation, RescheduleVideoMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RescheduleVideoMeetingMutation, RescheduleVideoMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RescheduleVideoMeetingMutation, RescheduleVideoMeetingMutationVariables>(
    RescheduleVideoMeetingDocument,
    options,
  );
}
export type RescheduleVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RescheduleVideoMeetingMutation,
  RescheduleVideoMeetingMutationVariables
>;
export const GetRescheduleVideoMeetingDocument = gql`
  query getRescheduleVideoMeeting($id: ID!) {
    videoMeeting: getVideoMeetingById(videoMeetingId: $id) {
      appointment {
        status
        start
        description
        patient {
          id
          name {
            text
          }
        }
      }
    }
  }
`;

/**
 * __useGetRescheduleVideoMeetingQuery__
 *
 * To run a query within a Vue component, call `useGetRescheduleVideoMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRescheduleVideoMeetingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRescheduleVideoMeetingQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetRescheduleVideoMeetingQuery(
  variables:
    | GetRescheduleVideoMeetingQueryVariables
    | VueCompositionApi.Ref<GetRescheduleVideoMeetingQueryVariables>
    | ReactiveFunction<GetRescheduleVideoMeetingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetRescheduleVideoMeetingQuery, GetRescheduleVideoMeetingQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetRescheduleVideoMeetingQuery, GetRescheduleVideoMeetingQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetRescheduleVideoMeetingQuery, GetRescheduleVideoMeetingQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetRescheduleVideoMeetingQuery, GetRescheduleVideoMeetingQueryVariables>(
    GetRescheduleVideoMeetingDocument,
    variables,
    options,
  );
}
export function useGetRescheduleVideoMeetingLazyQuery(
  variables?:
    | GetRescheduleVideoMeetingQueryVariables
    | VueCompositionApi.Ref<GetRescheduleVideoMeetingQueryVariables>
    | ReactiveFunction<GetRescheduleVideoMeetingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetRescheduleVideoMeetingQuery, GetRescheduleVideoMeetingQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetRescheduleVideoMeetingQuery, GetRescheduleVideoMeetingQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetRescheduleVideoMeetingQuery, GetRescheduleVideoMeetingQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetRescheduleVideoMeetingQuery, GetRescheduleVideoMeetingQueryVariables>(
    GetRescheduleVideoMeetingDocument,
    variables,
    options,
  );
}
export type GetRescheduleVideoMeetingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetRescheduleVideoMeetingQuery,
  GetRescheduleVideoMeetingQueryVariables
>;
export const StartJoinVideoMeetingDocument = gql`
  mutation startJoinVideoMeeting($videoMeetingId: ID!, $videoMeetingURL: String) {
    startJoinVideoMeeting(videoMeetingId: $videoMeetingId, videoMeetingURL: $videoMeetingURL) {
      success
      message
    }
  }
`;

/**
 * __useStartJoinVideoMeetingMutation__
 *
 * To run a mutation, you first call `useStartJoinVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartJoinVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartJoinVideoMeetingMutation({
 *   variables: {
 *     videoMeetingId: // value for 'videoMeetingId'
 *     videoMeetingURL: // value for 'videoMeetingURL'
 *   },
 * });
 */
export function useStartJoinVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StartJoinVideoMeetingMutation, StartJoinVideoMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<StartJoinVideoMeetingMutation, StartJoinVideoMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<StartJoinVideoMeetingMutation, StartJoinVideoMeetingMutationVariables>(
    StartJoinVideoMeetingDocument,
    options,
  );
}
export type StartJoinVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartJoinVideoMeetingMutation,
  StartJoinVideoMeetingMutationVariables
>;
export const StartVideoMeetingDocument = gql`
  mutation startVideoMeeting($videoMeetingId: ID!) {
    startVideoMeeting(videoMeetingId: $videoMeetingId) {
      success
      message
    }
  }
`;

/**
 * __useStartVideoMeetingMutation__
 *
 * To run a mutation, you first call `useStartVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartVideoMeetingMutation({
 *   variables: {
 *     videoMeetingId: // value for 'videoMeetingId'
 *   },
 * });
 */
export function useStartVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StartVideoMeetingMutation, StartVideoMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<StartVideoMeetingMutation, StartVideoMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<StartVideoMeetingMutation, StartVideoMeetingMutationVariables>(
    StartVideoMeetingDocument,
    options,
  );
}
export type StartVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartVideoMeetingMutation,
  StartVideoMeetingMutationVariables
>;
export const EndJoinVideoMeetingDocument = gql`
  mutation endJoinVideoMeeting($videoMeetingId: ID!) {
    endVideoMeeting(videoMeetingId: $videoMeetingId) {
      success
      message
    }
  }
`;

/**
 * __useEndJoinVideoMeetingMutation__
 *
 * To run a mutation, you first call `useEndJoinVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEndJoinVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEndJoinVideoMeetingMutation({
 *   variables: {
 *     videoMeetingId: // value for 'videoMeetingId'
 *   },
 * });
 */
export function useEndJoinVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EndJoinVideoMeetingMutation, EndJoinVideoMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EndJoinVideoMeetingMutation, EndJoinVideoMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EndJoinVideoMeetingMutation, EndJoinVideoMeetingMutationVariables>(
    EndJoinVideoMeetingDocument,
    options,
  );
}
export type EndJoinVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EndJoinVideoMeetingMutation,
  EndJoinVideoMeetingMutationVariables
>;
export const EndVideoMeetingDocument = gql`
  mutation endVideoMeeting($videoMeetingId: ID!) {
    endVideoMeeting(videoMeetingId: $videoMeetingId) {
      success
      message
    }
  }
`;

/**
 * __useEndVideoMeetingMutation__
 *
 * To run a mutation, you first call `useEndVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEndVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEndVideoMeetingMutation({
 *   variables: {
 *     videoMeetingId: // value for 'videoMeetingId'
 *   },
 * });
 */
export function useEndVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EndVideoMeetingMutation, EndVideoMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EndVideoMeetingMutation, EndVideoMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EndVideoMeetingMutation, EndVideoMeetingMutationVariables>(
    EndVideoMeetingDocument,
    options,
  );
}
export type EndVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EndVideoMeetingMutation,
  EndVideoMeetingMutationVariables
>;
export const CancelVideoMeetingDocument = gql`
  mutation cancelVideoMeeting($id: ID!) {
    cancelVideoMeeting(videoMeetingId: $id) {
      success
      message
    }
  }
`;

/**
 * __useCancelVideoMeetingMutation__
 *
 * To run a mutation, you first call `useCancelVideoMeetingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelVideoMeetingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelVideoMeetingMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useCancelVideoMeetingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CancelVideoMeetingMutation, CancelVideoMeetingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CancelVideoMeetingMutation, CancelVideoMeetingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CancelVideoMeetingMutation, CancelVideoMeetingMutationVariables>(
    CancelVideoMeetingDocument,
    options,
  );
}
export type CancelVideoMeetingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CancelVideoMeetingMutation,
  CancelVideoMeetingMutationVariables
>;
export const VideoMeetingDocument = gql`
  query videoMeeting($videoMeetingId: ID!) {
    videoMeeting: getVideoMeetingById(videoMeetingId: $videoMeetingId) {
      appointment {
        status
        start
        description
        participant {
          actor {
            reference
            identifier {
              value
            }
            type
            display
          }
        }
        patient {
          id
          name {
            text
          }
        }
      }
      videonor {
        meetingId
        participantRoomUrl
        hostRoomUrl
        startDate
        endDate
      }
    }
  }
`;

/**
 * __useVideoMeetingQuery__
 *
 * To run a query within a Vue component, call `useVideoMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoMeetingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVideoMeetingQuery({
 *   videoMeetingId: // value for 'videoMeetingId'
 * });
 */
export function useVideoMeetingQuery(
  variables:
    | VideoMeetingQueryVariables
    | VueCompositionApi.Ref<VideoMeetingQueryVariables>
    | ReactiveFunction<VideoMeetingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<VideoMeetingQuery, VideoMeetingQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VideoMeetingQuery, VideoMeetingQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<VideoMeetingQuery, VideoMeetingQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<VideoMeetingQuery, VideoMeetingQueryVariables>(
    VideoMeetingDocument,
    variables,
    options,
  );
}
export function useVideoMeetingLazyQuery(
  variables?:
    | VideoMeetingQueryVariables
    | VueCompositionApi.Ref<VideoMeetingQueryVariables>
    | ReactiveFunction<VideoMeetingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<VideoMeetingQuery, VideoMeetingQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VideoMeetingQuery, VideoMeetingQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<VideoMeetingQuery, VideoMeetingQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<VideoMeetingQuery, VideoMeetingQueryVariables>(
    VideoMeetingDocument,
    variables,
    options,
  );
}
export type VideoMeetingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  VideoMeetingQuery,
  VideoMeetingQueryVariables
>;
export const SetExternalIdRequestDocument = gql`
  mutation setExternalIdRequest($userId: ID!, $externalHumanIdType: String!, $requested: Boolean!) {
    setExternalIdRequest(userId: $userId, externalHumanIdType: $externalHumanIdType, requested: $requested)
  }
`;

/**
 * __useSetExternalIdRequestMutation__
 *
 * To run a mutation, you first call `useSetExternalIdRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetExternalIdRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetExternalIdRequestMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     externalHumanIdType: // value for 'externalHumanIdType'
 *     requested: // value for 'requested'
 *   },
 * });
 */
export function useSetExternalIdRequestMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SetExternalIdRequestMutation, SetExternalIdRequestMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SetExternalIdRequestMutation, SetExternalIdRequestMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SetExternalIdRequestMutation, SetExternalIdRequestMutationVariables>(
    SetExternalIdRequestDocument,
    options,
  );
}
export type SetExternalIdRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetExternalIdRequestMutation,
  SetExternalIdRequestMutationVariables
>;
export const RemoveExternalDialoggUserIdDocument = gql`
  mutation removeExternalDialoggUserId($username: ID!, $externalUserId: ExternalHumanIdInput!) {
    removeExternalDialoggUserId(username: $username, externalUserId: $externalUserId) {
      success
    }
  }
`;

/**
 * __useRemoveExternalDialoggUserIdMutation__
 *
 * To run a mutation, you first call `useRemoveExternalDialoggUserIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExternalDialoggUserIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveExternalDialoggUserIdMutation({
 *   variables: {
 *     username: // value for 'username'
 *     externalUserId: // value for 'externalUserId'
 *   },
 * });
 */
export function useRemoveExternalDialoggUserIdMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveExternalDialoggUserIdMutation,
        RemoveExternalDialoggUserIdMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveExternalDialoggUserIdMutation,
          RemoveExternalDialoggUserIdMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveExternalDialoggUserIdMutation,
    RemoveExternalDialoggUserIdMutationVariables
  >(RemoveExternalDialoggUserIdDocument, options);
}
export type RemoveExternalDialoggUserIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveExternalDialoggUserIdMutation,
  RemoveExternalDialoggUserIdMutationVariables
>;
export const RemoveExternalUserIdDocument = gql`
  mutation removeExternalUserId($userId: ID!, $externalUserId: ExternalHumanIdInput!) {
    removeExternalUserId(userId: $userId, externalUserId: $externalUserId) {
      success
    }
  }
`;

/**
 * __useRemoveExternalUserIdMutation__
 *
 * To run a mutation, you first call `useRemoveExternalUserIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExternalUserIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveExternalUserIdMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     externalUserId: // value for 'externalUserId'
 *   },
 * });
 */
export function useRemoveExternalUserIdMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RemoveExternalUserIdMutation, RemoveExternalUserIdMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RemoveExternalUserIdMutation, RemoveExternalUserIdMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RemoveExternalUserIdMutation, RemoveExternalUserIdMutationVariables>(
    RemoveExternalUserIdDocument,
    options,
  );
}
export type RemoveExternalUserIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveExternalUserIdMutation,
  RemoveExternalUserIdMutationVariables
>;
export const RemoveExternalPatientIdFromPatientDocument = gql`
  mutation removeExternalPatientIdFromPatient($patientId: ID!, $externalPatientId: ExternalHumanIdInput!) {
    removeExternalPatientIdFromPatient(patientId: $patientId, externalPatientId: $externalPatientId) {
      success
    }
  }
`;

/**
 * __useRemoveExternalPatientIdFromPatientMutation__
 *
 * To run a mutation, you first call `useRemoveExternalPatientIdFromPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExternalPatientIdFromPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveExternalPatientIdFromPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     externalPatientId: // value for 'externalPatientId'
 *   },
 * });
 */
export function useRemoveExternalPatientIdFromPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveExternalPatientIdFromPatientMutation,
        RemoveExternalPatientIdFromPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveExternalPatientIdFromPatientMutation,
          RemoveExternalPatientIdFromPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveExternalPatientIdFromPatientMutation,
    RemoveExternalPatientIdFromPatientMutationVariables
  >(RemoveExternalPatientIdFromPatientDocument, options);
}
export type RemoveExternalPatientIdFromPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveExternalPatientIdFromPatientMutation,
  RemoveExternalPatientIdFromPatientMutationVariables
>;
export const AddExternalUserIdDocument = gql`
  mutation addExternalUserId($userId: ID!, $externalUserId: ExternalHumanIdInput!) {
    addExternalUserId(userId: $userId, externalUserId: $externalUserId) {
      success
    }
  }
`;

/**
 * __useAddExternalUserIdMutation__
 *
 * To run a mutation, you first call `useAddExternalUserIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddExternalUserIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddExternalUserIdMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     externalUserId: // value for 'externalUserId'
 *   },
 * });
 */
export function useAddExternalUserIdMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddExternalUserIdMutation, AddExternalUserIdMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddExternalUserIdMutation, AddExternalUserIdMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddExternalUserIdMutation, AddExternalUserIdMutationVariables>(
    AddExternalUserIdDocument,
    options,
  );
}
export type AddExternalUserIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddExternalUserIdMutation,
  AddExternalUserIdMutationVariables
>;
export const AddExternalPatientIdToPatientDocument = gql`
  mutation addExternalPatientIdToPatient($patientId: ID!, $externalPatientId: ExternalHumanIdInput!) {
    addExternalPatientIdToPatient(patientId: $patientId, externalPatientId: $externalPatientId) {
      success
    }
  }
`;

/**
 * __useAddExternalPatientIdToPatientMutation__
 *
 * To run a mutation, you first call `useAddExternalPatientIdToPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddExternalPatientIdToPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddExternalPatientIdToPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     externalPatientId: // value for 'externalPatientId'
 *   },
 * });
 */
export function useAddExternalPatientIdToPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddExternalPatientIdToPatientMutation,
        AddExternalPatientIdToPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddExternalPatientIdToPatientMutation,
          AddExternalPatientIdToPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddExternalPatientIdToPatientMutation,
    AddExternalPatientIdToPatientMutationVariables
  >(AddExternalPatientIdToPatientDocument, options);
}
export type AddExternalPatientIdToPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddExternalPatientIdToPatientMutation,
  AddExternalPatientIdToPatientMutationVariables
>;
export const DeletePatientDocument = gql`
  mutation deletePatient($patientId: ID!) {
    deletePatient(patientId: $patientId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
      }
      message
    }
  }
`;

/**
 * __useDeletePatientMutation__
 *
 * To run a mutation, you first call `useDeletePatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeletePatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeletePatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDeletePatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeletePatientMutation, DeletePatientMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeletePatientMutation, DeletePatientMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeletePatientMutation, DeletePatientMutationVariables>(
    DeletePatientDocument,
    options,
  );
}
export type DeletePatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeletePatientMutation,
  DeletePatientMutationVariables
>;
export const GetGeofencesForSafemateDeviceDocument = gql`
  query getGeofencesForSafemateDevice($serialNumber: String!) {
    getGeofencesForSafemateDevice(serialNumber: $serialNumber) {
      name
      polygon
      radius
      vertices {
        lat
        lng
      }
    }
  }
`;

/**
 * __useGetGeofencesForSafemateDeviceQuery__
 *
 * To run a query within a Vue component, call `useGetGeofencesForSafemateDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeofencesForSafemateDeviceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGeofencesForSafemateDeviceQuery({
 *   serialNumber: // value for 'serialNumber'
 * });
 */
export function useGetGeofencesForSafemateDeviceQuery(
  variables:
    | GetGeofencesForSafemateDeviceQueryVariables
    | VueCompositionApi.Ref<GetGeofencesForSafemateDeviceQueryVariables>
    | ReactiveFunction<GetGeofencesForSafemateDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetGeofencesForSafemateDeviceQuery,
        GetGeofencesForSafemateDeviceQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetGeofencesForSafemateDeviceQuery,
          GetGeofencesForSafemateDeviceQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetGeofencesForSafemateDeviceQuery,
          GetGeofencesForSafemateDeviceQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetGeofencesForSafemateDeviceQuery, GetGeofencesForSafemateDeviceQueryVariables>(
    GetGeofencesForSafemateDeviceDocument,
    variables,
    options,
  );
}
export function useGetGeofencesForSafemateDeviceLazyQuery(
  variables?:
    | GetGeofencesForSafemateDeviceQueryVariables
    | VueCompositionApi.Ref<GetGeofencesForSafemateDeviceQueryVariables>
    | ReactiveFunction<GetGeofencesForSafemateDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetGeofencesForSafemateDeviceQuery,
        GetGeofencesForSafemateDeviceQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetGeofencesForSafemateDeviceQuery,
          GetGeofencesForSafemateDeviceQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetGeofencesForSafemateDeviceQuery,
          GetGeofencesForSafemateDeviceQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetGeofencesForSafemateDeviceQuery,
    GetGeofencesForSafemateDeviceQueryVariables
  >(GetGeofencesForSafemateDeviceDocument, variables, options);
}
export type GetGeofencesForSafemateDeviceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetGeofencesForSafemateDeviceQuery,
  GetGeofencesForSafemateDeviceQueryVariables
>;
export const HealthProviderSettingsForPatientFormDocument = gql`
  query healthProviderSettingsForPatientForm {
    healthProviderSettings {
      externalHumanIdTypes {
        id
      }
    }
  }
`;

/**
 * __useHealthProviderSettingsForPatientFormQuery__
 *
 * To run a query within a Vue component, call `useHealthProviderSettingsForPatientFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthProviderSettingsForPatientFormQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHealthProviderSettingsForPatientFormQuery();
 */
export function useHealthProviderSettingsForPatientFormQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsForPatientFormQuery,
        HealthProviderSettingsForPatientFormQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForPatientFormQuery,
          HealthProviderSettingsForPatientFormQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForPatientFormQuery,
          HealthProviderSettingsForPatientFormQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    HealthProviderSettingsForPatientFormQuery,
    HealthProviderSettingsForPatientFormQueryVariables
  >(HealthProviderSettingsForPatientFormDocument, {}, options);
}
export function useHealthProviderSettingsForPatientFormLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsForPatientFormQuery,
        HealthProviderSettingsForPatientFormQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForPatientFormQuery,
          HealthProviderSettingsForPatientFormQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForPatientFormQuery,
          HealthProviderSettingsForPatientFormQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    HealthProviderSettingsForPatientFormQuery,
    HealthProviderSettingsForPatientFormQueryVariables
  >(HealthProviderSettingsForPatientFormDocument, {}, options);
}
export type HealthProviderSettingsForPatientFormQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  HealthProviderSettingsForPatientFormQuery,
  HealthProviderSettingsForPatientFormQueryVariables
>;
export const RemoveUserReservationDocument = gql`
  mutation removeUserReservation($patientId: ID!, $userId: ID!) {
    removeUserReservation(patientId: $patientId, userId: $userId)
  }
`;

/**
 * __useRemoveUserReservationMutation__
 *
 * To run a mutation, you first call `useRemoveUserReservationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserReservationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveUserReservationMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserReservationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RemoveUserReservationMutation, RemoveUserReservationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RemoveUserReservationMutation, RemoveUserReservationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RemoveUserReservationMutation, RemoveUserReservationMutationVariables>(
    RemoveUserReservationDocument,
    options,
  );
}
export type RemoveUserReservationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveUserReservationMutation,
  RemoveUserReservationMutationVariables
>;
export const AddUserReservationDocument = gql`
  mutation addUserReservation($patientId: ID!, $userId: ID!) {
    addUserReservation(patientId: $patientId, userId: $userId)
  }
`;

/**
 * __useAddUserReservationMutation__
 *
 * To run a mutation, you first call `useAddUserReservationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddUserReservationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddUserReservationMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useAddUserReservationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddUserReservationMutation, AddUserReservationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddUserReservationMutation, AddUserReservationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddUserReservationMutation, AddUserReservationMutationVariables>(
    AddUserReservationDocument,
    options,
  );
}
export type AddUserReservationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddUserReservationMutation,
  AddUserReservationMutationVariables
>;
export const PatientWithUserReservationsDocument = gql`
  query patientWithUserReservations($id: ID!) {
    patient(id: $id) {
      id
      userReservations {
        userId
        firstName
        lastName
      }
    }
  }
`;

/**
 * __usePatientWithUserReservationsQuery__
 *
 * To run a query within a Vue component, call `usePatientWithUserReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientWithUserReservationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientWithUserReservationsQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientWithUserReservationsQuery(
  variables:
    | PatientWithUserReservationsQueryVariables
    | VueCompositionApi.Ref<PatientWithUserReservationsQueryVariables>
    | ReactiveFunction<PatientWithUserReservationsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>(
    PatientWithUserReservationsDocument,
    variables,
    options,
  );
}
export function usePatientWithUserReservationsLazyQuery(
  variables?:
    | PatientWithUserReservationsQueryVariables
    | VueCompositionApi.Ref<PatientWithUserReservationsQueryVariables>
    | ReactiveFunction<PatientWithUserReservationsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientWithUserReservationsQuery, PatientWithUserReservationsQueryVariables>(
    PatientWithUserReservationsDocument,
    variables,
    options,
  );
}
export type PatientWithUserReservationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientWithUserReservationsQuery,
  PatientWithUserReservationsQueryVariables
>;
export const SubmitAlarmHandlingFeedbackDocument = gql`
  mutation submitAlarmHandlingFeedback($alarmHandlingFeedback: AlarmHandlingFeedbackInput!) {
    submitAlarmHandlingFeedback(alarmHandlingFeedback: $alarmHandlingFeedback)
  }
`;

/**
 * __useSubmitAlarmHandlingFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitAlarmHandlingFeedbackMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAlarmHandlingFeedbackMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitAlarmHandlingFeedbackMutation({
 *   variables: {
 *     alarmHandlingFeedback: // value for 'alarmHandlingFeedback'
 *   },
 * });
 */
export function useSubmitAlarmHandlingFeedbackMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SubmitAlarmHandlingFeedbackMutation,
        SubmitAlarmHandlingFeedbackMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SubmitAlarmHandlingFeedbackMutation,
          SubmitAlarmHandlingFeedbackMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SubmitAlarmHandlingFeedbackMutation,
    SubmitAlarmHandlingFeedbackMutationVariables
  >(SubmitAlarmHandlingFeedbackDocument, options);
}
export type SubmitAlarmHandlingFeedbackMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SubmitAlarmHandlingFeedbackMutation,
  SubmitAlarmHandlingFeedbackMutationVariables
>;
export const RoleTypesForAuditEventAgentDocument = gql`
  query roleTypesForAuditEventAgent {
    roleTypes {
      id
      display {
        key
        value
      }
    }
  }
`;

/**
 * __useRoleTypesForAuditEventAgentQuery__
 *
 * To run a query within a Vue component, call `useRoleTypesForAuditEventAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleTypesForAuditEventAgentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRoleTypesForAuditEventAgentQuery();
 */
export function useRoleTypesForAuditEventAgentQuery(
  options:
    | VueApolloComposable.UseQueryOptions<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>(
    RoleTypesForAuditEventAgentDocument,
    {},
    options,
  );
}
export function useRoleTypesForAuditEventAgentLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<RoleTypesForAuditEventAgentQuery, RoleTypesForAuditEventAgentQueryVariables>(
    RoleTypesForAuditEventAgentDocument,
    {},
    options,
  );
}
export type RoleTypesForAuditEventAgentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RoleTypesForAuditEventAgentQuery,
  RoleTypesForAuditEventAgentQueryVariables
>;
export const DeleteAlarmRouteDocument = gql`
  mutation deleteAlarmRoute($routeId: ID!) {
    deleteAlarmRoute(routeId: $routeId)
  }
`;

/**
 * __useDeleteAlarmRouteMutation__
 *
 * To run a mutation, you first call `useDeleteAlarmRouteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlarmRouteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAlarmRouteMutation({
 *   variables: {
 *     routeId: // value for 'routeId'
 *   },
 * });
 */
export function useDeleteAlarmRouteMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteAlarmRouteMutation, DeleteAlarmRouteMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteAlarmRouteMutation, DeleteAlarmRouteMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteAlarmRouteMutation, DeleteAlarmRouteMutationVariables>(
    DeleteAlarmRouteDocument,
    options,
  );
}
export type DeleteAlarmRouteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteAlarmRouteMutation,
  DeleteAlarmRouteMutationVariables
>;
export const DeleteUserGroupDocument = gql`
  mutation deleteUserGroup($userGroupId: ID!, $forceDelete: Boolean) {
    deleteUserGroup(userGroupId: $userGroupId, forceDelete: $forceDelete) {
      success
      message
    }
  }
`;

/**
 * __useDeleteUserGroupMutation__
 *
 * To run a mutation, you first call `useDeleteUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUserGroupMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     forceDelete: // value for 'forceDelete'
 *   },
 * });
 */
export function useDeleteUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>(
    DeleteUserGroupDocument,
    options,
  );
}
export type DeleteUserGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteUserGroupMutation,
  DeleteUserGroupMutationVariables
>;
export const UpdateUserGroupDocument = gql`
  mutation updateUserGroup($userGroup: UpdateUserGroupInput!, $userGroupId: ID!) {
    updateUserGroup(userGroupId: $userGroupId, userGroup: $userGroup) {
      success
      message
    }
  }
`;

/**
 * __useUpdateUserGroupMutation__
 *
 * To run a mutation, you first call `useUpdateUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserGroupMutation({
 *   variables: {
 *     userGroup: // value for 'userGroup'
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useUpdateUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>(
    UpdateUserGroupDocument,
    options,
  );
}
export type UpdateUserGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateUserGroupMutation,
  UpdateUserGroupMutationVariables
>;
export const CreateUserGroupDocument = gql`
  mutation createUserGroup($newUserGroup: CreateUserGroupInput!, $parentUserGroupId: ID!) {
    createUserGroup(parentId: $parentUserGroupId, userGroup: $newUserGroup) {
      success
      message
      userGroup {
        id
      }
    }
  }
`;

/**
 * __useCreateUserGroupMutation__
 *
 * To run a mutation, you first call `useCreateUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUserGroupMutation({
 *   variables: {
 *     newUserGroup: // value for 'newUserGroup'
 *     parentUserGroupId: // value for 'parentUserGroupId'
 *   },
 * });
 */
export function useCreateUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateUserGroupMutation, CreateUserGroupMutationVariables>(
    CreateUserGroupDocument,
    options,
  );
}
export type CreateUserGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateUserGroupMutation,
  CreateUserGroupMutationVariables
>;
export const GetDevicesByGroupDocument = gql`
  query getDevicesByGroup($deviceGroupId: ID!) {
    getDevicesByGroup(deviceGroupId: $deviceGroupId) {
      id
      deviceName {
        name
        type
      }
      modelNumber
      manufacturer
      patientId
      registeredInInventory
      childDeviceIds
    }
  }
`;

/**
 * __useGetDevicesByGroupQuery__
 *
 * To run a query within a Vue component, call `useGetDevicesByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevicesByGroupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDevicesByGroupQuery({
 *   deviceGroupId: // value for 'deviceGroupId'
 * });
 */
export function useGetDevicesByGroupQuery(
  variables:
    | GetDevicesByGroupQueryVariables
    | VueCompositionApi.Ref<GetDevicesByGroupQueryVariables>
    | ReactiveFunction<GetDevicesByGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>(
    GetDevicesByGroupDocument,
    variables,
    options,
  );
}
export function useGetDevicesByGroupLazyQuery(
  variables?:
    | GetDevicesByGroupQueryVariables
    | VueCompositionApi.Ref<GetDevicesByGroupQueryVariables>
    | ReactiveFunction<GetDevicesByGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetDevicesByGroupQuery, GetDevicesByGroupQueryVariables>(
    GetDevicesByGroupDocument,
    variables,
    options,
  );
}
export type GetDevicesByGroupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDevicesByGroupQuery,
  GetDevicesByGroupQueryVariables
>;
export const PatientGroupDocument = gql`
  query patientGroup($id: ID!) {
    patientGroup(id: $id) {
      id
      name
      patientsCount
      enableDistanceEstimation
      enableOnSiteRegistration
      hideTechnicalAlarmNotifications
      alarmRoutes {
        routeId
        configId
        configType
        configName
        incomingTemplate {
          isPresentInAccount
          code
          title
          system
          displayText
          icon
          technical
        }
        outgoingTemplate {
          isPresentInAccount
          code
          title
          system
          displayText
          icon
          technical
        }
        idMappingStrategy
        createPatientAlarmOnFail
      }
      availableAlarmRoutingOptions {
        configs {
          configId
          configType
          configName
        }
        templates {
          code
          title
          system
          displayText
          icon
          direction
          technical
        }
        idMappingStrategies {
          id
        }
      }
    }
  }
`;

/**
 * __usePatientGroupQuery__
 *
 * To run a query within a Vue component, call `usePatientGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientGroupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientGroupQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientGroupQuery(
  variables:
    | PatientGroupQueryVariables
    | VueCompositionApi.Ref<PatientGroupQueryVariables>
    | ReactiveFunction<PatientGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientGroupQuery, PatientGroupQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientGroupQuery, PatientGroupQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientGroupQuery, PatientGroupQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientGroupQuery, PatientGroupQueryVariables>(
    PatientGroupDocument,
    variables,
    options,
  );
}
export function usePatientGroupLazyQuery(
  variables?:
    | PatientGroupQueryVariables
    | VueCompositionApi.Ref<PatientGroupQueryVariables>
    | ReactiveFunction<PatientGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientGroupQuery, PatientGroupQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientGroupQuery, PatientGroupQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientGroupQuery, PatientGroupQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientGroupQuery, PatientGroupQueryVariables>(
    PatientGroupDocument,
    variables,
    options,
  );
}
export type PatientGroupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientGroupQuery,
  PatientGroupQueryVariables
>;
export const UserGroupTypeDocument = gql`
  query userGroupType($userGroupId: ID!) {
    userGroup(userGroupId: $userGroupId) {
      id
      type
    }
  }
`;

/**
 * __useUserGroupTypeQuery__
 *
 * To run a query within a Vue component, call `useUserGroupTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupTypeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupTypeQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useUserGroupTypeQuery(
  variables:
    | UserGroupTypeQueryVariables
    | VueCompositionApi.Ref<UserGroupTypeQueryVariables>
    | ReactiveFunction<UserGroupTypeQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupTypeQuery, UserGroupTypeQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupTypeQuery, UserGroupTypeQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupTypeQuery, UserGroupTypeQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UserGroupTypeQuery, UserGroupTypeQueryVariables>(
    UserGroupTypeDocument,
    variables,
    options,
  );
}
export function useUserGroupTypeLazyQuery(
  variables?:
    | UserGroupTypeQueryVariables
    | VueCompositionApi.Ref<UserGroupTypeQueryVariables>
    | ReactiveFunction<UserGroupTypeQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupTypeQuery, UserGroupTypeQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupTypeQuery, UserGroupTypeQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupTypeQuery, UserGroupTypeQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupTypeQuery, UserGroupTypeQueryVariables>(
    UserGroupTypeDocument,
    variables,
    options,
  );
}
export type UserGroupTypeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupTypeQuery,
  UserGroupTypeQueryVariables
>;
export const CreateAlarmRouteDocument = gql`
  mutation createAlarmRoute($inputs: AlarmRouteInput!) {
    createAlarmRoute(inputs: $inputs) {
      routeId
    }
  }
`;

/**
 * __useCreateAlarmRouteMutation__
 *
 * To run a mutation, you first call `useCreateAlarmRouteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlarmRouteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAlarmRouteMutation({
 *   variables: {
 *     inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateAlarmRouteMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateAlarmRouteMutation, CreateAlarmRouteMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateAlarmRouteMutation, CreateAlarmRouteMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateAlarmRouteMutation, CreateAlarmRouteMutationVariables>(
    CreateAlarmRouteDocument,
    options,
  );
}
export type CreateAlarmRouteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateAlarmRouteMutation,
  CreateAlarmRouteMutationVariables
>;
export const UpdateAlarmRouteDocument = gql`
  mutation updateAlarmRoute($routeId: ID!, $patientGroupId: ID!, $updateInput: UpdateAlarmRouteInput!) {
    updateAlarmRoute(routeId: $routeId, patientGroupId: $patientGroupId, updateInput: $updateInput) {
      success
    }
  }
`;

/**
 * __useUpdateAlarmRouteMutation__
 *
 * To run a mutation, you first call `useUpdateAlarmRouteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlarmRouteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAlarmRouteMutation({
 *   variables: {
 *     routeId: // value for 'routeId'
 *     patientGroupId: // value for 'patientGroupId'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateAlarmRouteMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateAlarmRouteMutation, UpdateAlarmRouteMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateAlarmRouteMutation, UpdateAlarmRouteMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateAlarmRouteMutation, UpdateAlarmRouteMutationVariables>(
    UpdateAlarmRouteDocument,
    options,
  );
}
export type UpdateAlarmRouteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAlarmRouteMutation,
  UpdateAlarmRouteMutationVariables
>;
export const PatientGroupForAlarmForwardingDocument = gql`
  query patientGroupForAlarmForwarding($id: ID!) {
    patientGroup(id: $id) {
      id
      name
      alarmRoutes {
        configName
        incomingTemplate {
          isPresentInAccount
          code
          title
          system
          icon
        }
        outgoingTemplate {
          isPresentInAccount
          code
          title
          system
          icon
        }
        idMappingStrategy
        createPatientAlarmOnFail
      }
    }
  }
`;

/**
 * __usePatientGroupForAlarmForwardingQuery__
 *
 * To run a query within a Vue component, call `usePatientGroupForAlarmForwardingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientGroupForAlarmForwardingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientGroupForAlarmForwardingQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientGroupForAlarmForwardingQuery(
  variables:
    | PatientGroupForAlarmForwardingQueryVariables
    | VueCompositionApi.Ref<PatientGroupForAlarmForwardingQueryVariables>
    | ReactiveFunction<PatientGroupForAlarmForwardingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        PatientGroupForAlarmForwardingQuery,
        PatientGroupForAlarmForwardingQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          PatientGroupForAlarmForwardingQuery,
          PatientGroupForAlarmForwardingQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          PatientGroupForAlarmForwardingQuery,
          PatientGroupForAlarmForwardingQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    PatientGroupForAlarmForwardingQuery,
    PatientGroupForAlarmForwardingQueryVariables
  >(PatientGroupForAlarmForwardingDocument, variables, options);
}
export function usePatientGroupForAlarmForwardingLazyQuery(
  variables?:
    | PatientGroupForAlarmForwardingQueryVariables
    | VueCompositionApi.Ref<PatientGroupForAlarmForwardingQueryVariables>
    | ReactiveFunction<PatientGroupForAlarmForwardingQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        PatientGroupForAlarmForwardingQuery,
        PatientGroupForAlarmForwardingQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          PatientGroupForAlarmForwardingQuery,
          PatientGroupForAlarmForwardingQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          PatientGroupForAlarmForwardingQuery,
          PatientGroupForAlarmForwardingQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    PatientGroupForAlarmForwardingQuery,
    PatientGroupForAlarmForwardingQueryVariables
  >(PatientGroupForAlarmForwardingDocument, variables, options);
}
export type PatientGroupForAlarmForwardingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientGroupForAlarmForwardingQuery,
  PatientGroupForAlarmForwardingQueryVariables
>;
export const GetSkyresponseSyncJobsCountDocument = gql`
  query getSkyresponseSyncJobsCount {
    getSkyresponseSyncJobsCount
  }
`;

/**
 * __useGetSkyresponseSyncJobsCountQuery__
 *
 * To run a query within a Vue component, call `useGetSkyresponseSyncJobsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkyresponseSyncJobsCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSkyresponseSyncJobsCountQuery();
 */
export function useGetSkyresponseSyncJobsCountQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>(
    GetSkyresponseSyncJobsCountDocument,
    {},
    options,
  );
}
export function useGetSkyresponseSyncJobsCountLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetSkyresponseSyncJobsCountQuery, GetSkyresponseSyncJobsCountQueryVariables>(
    GetSkyresponseSyncJobsCountDocument,
    {},
    options,
  );
}
export type GetSkyresponseSyncJobsCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetSkyresponseSyncJobsCountQuery,
  GetSkyresponseSyncJobsCountQueryVariables
>;
export const SyncPatientInfoWithSkyresponseForSyncModalDocument = gql`
  mutation syncPatientInfoWithSkyresponseForSyncModal(
    $userGroupId: ID!
    $skip: Int
    $take: Int
    $syncScenario: String
  ) {
    syncPatientInfoWithSkyresponse(userGroupId: $userGroupId, skip: $skip, take: $take, syncScenario: $syncScenario) {
      success
      message
      total
      take
      skip
      next {
        skip
        take
      }
    }
  }
`;

/**
 * __useSyncPatientInfoWithSkyresponseForSyncModalMutation__
 *
 * To run a mutation, you first call `useSyncPatientInfoWithSkyresponseForSyncModalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSyncPatientInfoWithSkyresponseForSyncModalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSyncPatientInfoWithSkyresponseForSyncModalMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     skip: // value for 'skip'
 *     take: // value for 'take'
 *     syncScenario: // value for 'syncScenario'
 *   },
 * });
 */
export function useSyncPatientInfoWithSkyresponseForSyncModalMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SyncPatientInfoWithSkyresponseForSyncModalMutation,
        SyncPatientInfoWithSkyresponseForSyncModalMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SyncPatientInfoWithSkyresponseForSyncModalMutation,
          SyncPatientInfoWithSkyresponseForSyncModalMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SyncPatientInfoWithSkyresponseForSyncModalMutation,
    SyncPatientInfoWithSkyresponseForSyncModalMutationVariables
  >(SyncPatientInfoWithSkyresponseForSyncModalDocument, options);
}
export type SyncPatientInfoWithSkyresponseForSyncModalMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    SyncPatientInfoWithSkyresponseForSyncModalMutation,
    SyncPatientInfoWithSkyresponseForSyncModalMutationVariables
  >;
export const UserGroupPatientAccessListDocument = gql`
  query userGroupPatientAccessList($userGroupId: ID!) {
    userGroupPatientAccessList(userGroupId: $userGroupId) {
      id
      username
      firstName
      lastName
      roles {
        id
        userGroupName
        display {
          key
          value
        }
      }
    }
  }
`;

/**
 * __useUserGroupPatientAccessListQuery__
 *
 * To run a query within a Vue component, call `useUserGroupPatientAccessListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupPatientAccessListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupPatientAccessListQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useUserGroupPatientAccessListQuery(
  variables:
    | UserGroupPatientAccessListQueryVariables
    | VueCompositionApi.Ref<UserGroupPatientAccessListQueryVariables>
    | ReactiveFunction<UserGroupPatientAccessListQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>(
    UserGroupPatientAccessListDocument,
    variables,
    options,
  );
}
export function useUserGroupPatientAccessListLazyQuery(
  variables?:
    | UserGroupPatientAccessListQueryVariables
    | VueCompositionApi.Ref<UserGroupPatientAccessListQueryVariables>
    | ReactiveFunction<UserGroupPatientAccessListQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupPatientAccessListQuery, UserGroupPatientAccessListQueryVariables>(
    UserGroupPatientAccessListDocument,
    variables,
    options,
  );
}
export type UserGroupPatientAccessListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupPatientAccessListQuery,
  UserGroupPatientAccessListQueryVariables
>;
export const RoleTypesDocument = gql`
  query roleTypes {
    roleTypes {
      id
      display {
        key
        value
      }
      basedOn_fk
    }
  }
`;

/**
 * __useRoleTypesQuery__
 *
 * To run a query within a Vue component, call `useRoleTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRoleTypesQuery();
 */
export function useRoleTypesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<RoleTypesQuery, RoleTypesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RoleTypesQuery, RoleTypesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RoleTypesQuery, RoleTypesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<RoleTypesQuery, RoleTypesQueryVariables>(RoleTypesDocument, {}, options);
}
export function useRoleTypesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<RoleTypesQuery, RoleTypesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RoleTypesQuery, RoleTypesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<RoleTypesQuery, RoleTypesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<RoleTypesQuery, RoleTypesQueryVariables>(RoleTypesDocument, {}, options);
}
export type RoleTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RoleTypesQuery,
  RoleTypesQueryVariables
>;
export const GetAlarmHandlingRulesForUserGroupDocument = gql`
  query getAlarmHandlingRulesForUserGroup($userGroupId: ID!) {
    getAlarmHandlingRulesForUserGroup(userGroupId: $userGroupId) {
      id
      name
    }
  }
`;

/**
 * __useGetAlarmHandlingRulesForUserGroupQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmHandlingRulesForUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmHandlingRulesForUserGroupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmHandlingRulesForUserGroupQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useGetAlarmHandlingRulesForUserGroupQuery(
  variables:
    | GetAlarmHandlingRulesForUserGroupQueryVariables
    | VueCompositionApi.Ref<GetAlarmHandlingRulesForUserGroupQueryVariables>
    | ReactiveFunction<GetAlarmHandlingRulesForUserGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmHandlingRulesForUserGroupQuery,
        GetAlarmHandlingRulesForUserGroupQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmHandlingRulesForUserGroupQuery,
          GetAlarmHandlingRulesForUserGroupQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmHandlingRulesForUserGroupQuery,
          GetAlarmHandlingRulesForUserGroupQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAlarmHandlingRulesForUserGroupQuery,
    GetAlarmHandlingRulesForUserGroupQueryVariables
  >(GetAlarmHandlingRulesForUserGroupDocument, variables, options);
}
export function useGetAlarmHandlingRulesForUserGroupLazyQuery(
  variables?:
    | GetAlarmHandlingRulesForUserGroupQueryVariables
    | VueCompositionApi.Ref<GetAlarmHandlingRulesForUserGroupQueryVariables>
    | ReactiveFunction<GetAlarmHandlingRulesForUserGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmHandlingRulesForUserGroupQuery,
        GetAlarmHandlingRulesForUserGroupQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmHandlingRulesForUserGroupQuery,
          GetAlarmHandlingRulesForUserGroupQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmHandlingRulesForUserGroupQuery,
          GetAlarmHandlingRulesForUserGroupQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAlarmHandlingRulesForUserGroupQuery,
    GetAlarmHandlingRulesForUserGroupQueryVariables
  >(GetAlarmHandlingRulesForUserGroupDocument, variables, options);
}
export type GetAlarmHandlingRulesForUserGroupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmHandlingRulesForUserGroupQuery,
  GetAlarmHandlingRulesForUserGroupQueryVariables
>;
export const CreatePatientGroupDocument = gql`
  mutation createPatientGroup($createInput: PatientGroupInput!, $userGroupId: ID!) {
    createPatientGroup(userGroupId: $userGroupId, createInput: $createInput) {
      success
      message
    }
  }
`;

/**
 * __useCreatePatientGroupMutation__
 *
 * To run a mutation, you first call `useCreatePatientGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePatientGroupMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useCreatePatientGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreatePatientGroupMutation, CreatePatientGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreatePatientGroupMutation, CreatePatientGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreatePatientGroupMutation, CreatePatientGroupMutationVariables>(
    CreatePatientGroupDocument,
    options,
  );
}
export type CreatePatientGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreatePatientGroupMutation,
  CreatePatientGroupMutationVariables
>;
export const UpdatePatientGroupDocument = gql`
  mutation updatePatientGroup($patientGroupId: ID!, $patientGroup: PatientGroupInput!) {
    updatePatientGroup(id: $patientGroupId, updateInput: $patientGroup) {
      success
      message
    }
  }
`;

/**
 * __useUpdatePatientGroupMutation__
 *
 * To run a mutation, you first call `useUpdatePatientGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientGroupMutation({
 *   variables: {
 *     patientGroupId: // value for 'patientGroupId'
 *     patientGroup: // value for 'patientGroup'
 *   },
 * });
 */
export function useUpdatePatientGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdatePatientGroupMutation, UpdatePatientGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdatePatientGroupMutation, UpdatePatientGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePatientGroupMutation, UpdatePatientGroupMutationVariables>(
    UpdatePatientGroupDocument,
    options,
  );
}
export type UpdatePatientGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientGroupMutation,
  UpdatePatientGroupMutationVariables
>;
export const SetDistanceEstimationToPatientGroupDocument = gql`
  mutation setDistanceEstimationToPatientGroup($patientGroupId: ID!, $enableDistanceEstimation: Boolean!) {
    setDistanceEstimationToPatientGroup(id: $patientGroupId, enableDistanceEstimation: $enableDistanceEstimation) {
      success
      message
    }
  }
`;

/**
 * __useSetDistanceEstimationToPatientGroupMutation__
 *
 * To run a mutation, you first call `useSetDistanceEstimationToPatientGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetDistanceEstimationToPatientGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetDistanceEstimationToPatientGroupMutation({
 *   variables: {
 *     patientGroupId: // value for 'patientGroupId'
 *     enableDistanceEstimation: // value for 'enableDistanceEstimation'
 *   },
 * });
 */
export function useSetDistanceEstimationToPatientGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SetDistanceEstimationToPatientGroupMutation,
        SetDistanceEstimationToPatientGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetDistanceEstimationToPatientGroupMutation,
          SetDistanceEstimationToPatientGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SetDistanceEstimationToPatientGroupMutation,
    SetDistanceEstimationToPatientGroupMutationVariables
  >(SetDistanceEstimationToPatientGroupDocument, options);
}
export type SetDistanceEstimationToPatientGroupMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    SetDistanceEstimationToPatientGroupMutation,
    SetDistanceEstimationToPatientGroupMutationVariables
  >;
export const HideTechnicalAlarmNotificationsForPatientGroupDocument = gql`
  mutation hideTechnicalAlarmNotificationsForPatientGroup(
    $patientGroupId: ID!
    $hideTechnicalAlarmNotifications: Boolean!
  ) {
    hideTechnicalAlarmNotificationsForPatientGroup(
      id: $patientGroupId
      hideTechnicalAlarmNotifications: $hideTechnicalAlarmNotifications
    ) {
      success
      message
    }
  }
`;

/**
 * __useHideTechnicalAlarmNotificationsForPatientGroupMutation__
 *
 * To run a mutation, you first call `useHideTechnicalAlarmNotificationsForPatientGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useHideTechnicalAlarmNotificationsForPatientGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useHideTechnicalAlarmNotificationsForPatientGroupMutation({
 *   variables: {
 *     patientGroupId: // value for 'patientGroupId'
 *     hideTechnicalAlarmNotifications: // value for 'hideTechnicalAlarmNotifications'
 *   },
 * });
 */
export function useHideTechnicalAlarmNotificationsForPatientGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        HideTechnicalAlarmNotificationsForPatientGroupMutation,
        HideTechnicalAlarmNotificationsForPatientGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          HideTechnicalAlarmNotificationsForPatientGroupMutation,
          HideTechnicalAlarmNotificationsForPatientGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    HideTechnicalAlarmNotificationsForPatientGroupMutation,
    HideTechnicalAlarmNotificationsForPatientGroupMutationVariables
  >(HideTechnicalAlarmNotificationsForPatientGroupDocument, options);
}
export type HideTechnicalAlarmNotificationsForPatientGroupMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    HideTechnicalAlarmNotificationsForPatientGroupMutation,
    HideTechnicalAlarmNotificationsForPatientGroupMutationVariables
  >;
export const SetOnSiteRegistrationToPatientGroupDocument = gql`
  mutation setOnSiteRegistrationToPatientGroup($patientGroupId: ID!, $enableOnSiteRegistration: Boolean!) {
    setOnSiteRegistrationToPatientGroup(id: $patientGroupId, enableOnSiteRegistration: $enableOnSiteRegistration) {
      success
      message
    }
  }
`;

/**
 * __useSetOnSiteRegistrationToPatientGroupMutation__
 *
 * To run a mutation, you first call `useSetOnSiteRegistrationToPatientGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetOnSiteRegistrationToPatientGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetOnSiteRegistrationToPatientGroupMutation({
 *   variables: {
 *     patientGroupId: // value for 'patientGroupId'
 *     enableOnSiteRegistration: // value for 'enableOnSiteRegistration'
 *   },
 * });
 */
export function useSetOnSiteRegistrationToPatientGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SetOnSiteRegistrationToPatientGroupMutation,
        SetOnSiteRegistrationToPatientGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetOnSiteRegistrationToPatientGroupMutation,
          SetOnSiteRegistrationToPatientGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SetOnSiteRegistrationToPatientGroupMutation,
    SetOnSiteRegistrationToPatientGroupMutationVariables
  >(SetOnSiteRegistrationToPatientGroupDocument, options);
}
export type SetOnSiteRegistrationToPatientGroupMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    SetOnSiteRegistrationToPatientGroupMutation,
    SetOnSiteRegistrationToPatientGroupMutationVariables
  >;
export const RemovePatientGroupFromUserGroupDocument = gql`
  mutation removePatientGroupFromUserGroup($patientGroupId: ID!, $userGroupId: ID!) {
    removePatientGroupFromUserGroup(patientGroupId: $patientGroupId, userGroupId: $userGroupId) {
      success
      message
    }
  }
`;

/**
 * __useRemovePatientGroupFromUserGroupMutation__
 *
 * To run a mutation, you first call `useRemovePatientGroupFromUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemovePatientGroupFromUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemovePatientGroupFromUserGroupMutation({
 *   variables: {
 *     patientGroupId: // value for 'patientGroupId'
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useRemovePatientGroupFromUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemovePatientGroupFromUserGroupMutation,
        RemovePatientGroupFromUserGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemovePatientGroupFromUserGroupMutation,
          RemovePatientGroupFromUserGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemovePatientGroupFromUserGroupMutation,
    RemovePatientGroupFromUserGroupMutationVariables
  >(RemovePatientGroupFromUserGroupDocument, options);
}
export type RemovePatientGroupFromUserGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemovePatientGroupFromUserGroupMutation,
  RemovePatientGroupFromUserGroupMutationVariables
>;
export const CreateDeviceGroupDocument = gql`
  mutation createDeviceGroup($createInput: DeviceGroupCreateInput!, $userGroupId: ID!) {
    createDeviceGroup(userGroupId: $userGroupId, createInput: $createInput) {
      success
      message
    }
  }
`;

/**
 * __useCreateDeviceGroupMutation__
 *
 * To run a mutation, you first call `useCreateDeviceGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDeviceGroupMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useCreateDeviceGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateDeviceGroupMutation, CreateDeviceGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateDeviceGroupMutation, CreateDeviceGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateDeviceGroupMutation, CreateDeviceGroupMutationVariables>(
    CreateDeviceGroupDocument,
    options,
  );
}
export type CreateDeviceGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateDeviceGroupMutation,
  CreateDeviceGroupMutationVariables
>;
export const UpdateDeviceGroupDocument = gql`
  mutation updateDeviceGroup($deviceGroupId: ID!, $deviceGroup: DeviceGroupUpdateInput!) {
    updateDeviceGroup(id: $deviceGroupId, updateInput: $deviceGroup) {
      success
      message
    }
  }
`;

/**
 * __useUpdateDeviceGroupMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDeviceGroupMutation({
 *   variables: {
 *     deviceGroupId: // value for 'deviceGroupId'
 *     deviceGroup: // value for 'deviceGroup'
 *   },
 * });
 */
export function useUpdateDeviceGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateDeviceGroupMutation, UpdateDeviceGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateDeviceGroupMutation, UpdateDeviceGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateDeviceGroupMutation, UpdateDeviceGroupMutationVariables>(
    UpdateDeviceGroupDocument,
    options,
  );
}
export type UpdateDeviceGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateDeviceGroupMutation,
  UpdateDeviceGroupMutationVariables
>;
export const DeleteDeviceGroupDocument = gql`
  mutation deleteDeviceGroup($deviceGroupId: ID!) {
    deleteDeviceGroup(deviceGroupId: $deviceGroupId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteDeviceGroupMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDeviceGroupMutation({
 *   variables: {
 *     deviceGroupId: // value for 'deviceGroupId'
 *   },
 * });
 */
export function useDeleteDeviceGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteDeviceGroupMutation, DeleteDeviceGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteDeviceGroupMutation, DeleteDeviceGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteDeviceGroupMutation, DeleteDeviceGroupMutationVariables>(
    DeleteDeviceGroupDocument,
    options,
  );
}
export type DeleteDeviceGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteDeviceGroupMutation,
  DeleteDeviceGroupMutationVariables
>;
export const CreateRoleDocument = gql`
  mutation createRole($id: ID!, $userGroupId: ID!) {
    createRole(userGroupId: $userGroupId, id: $id) {
      success
      message
    }
  }
`;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateRoleMutation({
 *   variables: {
 *     id: // value for 'id'
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useCreateRoleMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
}
export type CreateRoleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateRoleMutation,
  CreateRoleMutationVariables
>;
export const DeleteRoleDocument = gql`
  mutation deleteRole($roleId: ID!) {
    deleteRole(roleId: $roleId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteRoleMutation({
 *   variables: {
 *     roleId: // value for 'roleId'
 *   },
 * });
 */
export function useDeleteRoleMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
}
export type DeleteRoleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteRoleMutation,
  DeleteRoleMutationVariables
>;
export const UpdateSkyresponseConfigDocument = gql`
  mutation updateSkyresponseConfig($userGroupId: ID!, $skyresponseConfig: SkyresponseConfigInput!) {
    updateSkyresponseConfig(userGroupId: $userGroupId, skyresponseConfig: $skyresponseConfig) {
      success
      message
    }
  }
`;

/**
 * __useUpdateSkyresponseConfigMutation__
 *
 * To run a mutation, you first call `useUpdateSkyresponseConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSkyresponseConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSkyresponseConfigMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     skyresponseConfig: // value for 'skyresponseConfig'
 *   },
 * });
 */
export function useUpdateSkyresponseConfigMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateSkyresponseConfigMutation, UpdateSkyresponseConfigMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateSkyresponseConfigMutation,
          UpdateSkyresponseConfigMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateSkyresponseConfigMutation, UpdateSkyresponseConfigMutationVariables>(
    UpdateSkyresponseConfigDocument,
    options,
  );
}
export type UpdateSkyresponseConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateSkyresponseConfigMutation,
  UpdateSkyresponseConfigMutationVariables
>;
export const UpdateEscalationDelayDocument = gql`
  mutation updateEscalationDelay($userGroupId: ID!, $escalationDelay: Int!) {
    updateEscalationDelay(userGroupId: $userGroupId, escalationDelay: $escalationDelay) {
      success
      message
    }
  }
`;

/**
 * __useUpdateEscalationDelayMutation__
 *
 * To run a mutation, you first call `useUpdateEscalationDelayMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEscalationDelayMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateEscalationDelayMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     escalationDelay: // value for 'escalationDelay'
 *   },
 * });
 */
export function useUpdateEscalationDelayMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateEscalationDelayMutation, UpdateEscalationDelayMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateEscalationDelayMutation, UpdateEscalationDelayMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateEscalationDelayMutation, UpdateEscalationDelayMutationVariables>(
    UpdateEscalationDelayDocument,
    options,
  );
}
export type UpdateEscalationDelayMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateEscalationDelayMutation,
  UpdateEscalationDelayMutationVariables
>;
export const DeleteEscalationDelayDocument = gql`
  mutation deleteEscalationDelay($userGroupId: ID!) {
    deleteEscalationDelay(userGroupId: $userGroupId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteEscalationDelayMutation__
 *
 * To run a mutation, you first call `useDeleteEscalationDelayMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEscalationDelayMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteEscalationDelayMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useDeleteEscalationDelayMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteEscalationDelayMutation, DeleteEscalationDelayMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteEscalationDelayMutation, DeleteEscalationDelayMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteEscalationDelayMutation, DeleteEscalationDelayMutationVariables>(
    DeleteEscalationDelayDocument,
    options,
  );
}
export type DeleteEscalationDelayMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteEscalationDelayMutation,
  DeleteEscalationDelayMutationVariables
>;
export const UpdateCareTeamDocument = gql`
  mutation updateCareTeam($userGroupId: ID!, $careTeam: UpdateCareTeamInput!) {
    updateCareTeam(userGroupId: $userGroupId, careTeam: $careTeam) {
      success
      message
    }
  }
`;

/**
 * __useUpdateCareTeamMutation__
 *
 * To run a mutation, you first call `useUpdateCareTeamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCareTeamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCareTeamMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     careTeam: // value for 'careTeam'
 *   },
 * });
 */
export function useUpdateCareTeamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateCareTeamMutation, UpdateCareTeamMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateCareTeamMutation, UpdateCareTeamMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateCareTeamMutation, UpdateCareTeamMutationVariables>(
    UpdateCareTeamDocument,
    options,
  );
}
export type UpdateCareTeamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateCareTeamMutation,
  UpdateCareTeamMutationVariables
>;
export const AddCareTeamDocument = gql`
  mutation addCareTeam($userGroupId: ID!, $careTeam: CreateCareTeamInput!) {
    addCareTeam(userGroupId: $userGroupId, careTeam: $careTeam) {
      success
      message
    }
  }
`;

/**
 * __useAddCareTeamMutation__
 *
 * To run a mutation, you first call `useAddCareTeamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCareTeamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCareTeamMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     careTeam: // value for 'careTeam'
 *   },
 * });
 */
export function useAddCareTeamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddCareTeamMutation, AddCareTeamMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddCareTeamMutation, AddCareTeamMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<AddCareTeamMutation, AddCareTeamMutationVariables>(
    AddCareTeamDocument,
    options,
  );
}
export type AddCareTeamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddCareTeamMutation,
  AddCareTeamMutationVariables
>;
export const RemoveCareTeamDocument = gql`
  mutation removeCareTeam($userGroupId: ID!, $careTeamId: ID!) {
    removeCareTeam(userGroupId: $userGroupId, careTeamId: $careTeamId) {
      success
      message
    }
  }
`;

/**
 * __useRemoveCareTeamMutation__
 *
 * To run a mutation, you first call `useRemoveCareTeamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCareTeamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveCareTeamMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     careTeamId: // value for 'careTeamId'
 *   },
 * });
 */
export function useRemoveCareTeamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RemoveCareTeamMutation, RemoveCareTeamMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RemoveCareTeamMutation, RemoveCareTeamMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RemoveCareTeamMutation, RemoveCareTeamMutationVariables>(
    RemoveCareTeamDocument,
    options,
  );
}
export type RemoveCareTeamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveCareTeamMutation,
  RemoveCareTeamMutationVariables
>;
export const CreateHelseIdAccountDocument = gql`
  mutation createHelseIdAccount($input: HelseIdAccountCreateInput!) {
    createHelseIdAccount(input: $input) {
      success
      message
      helseIdAccount {
        id
      }
    }
  }
`;

/**
 * __useCreateHelseIdAccountMutation__
 *
 * To run a mutation, you first call `useCreateHelseIdAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateHelseIdAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateHelseIdAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateHelseIdAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateHelseIdAccountMutation, CreateHelseIdAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateHelseIdAccountMutation, CreateHelseIdAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateHelseIdAccountMutation, CreateHelseIdAccountMutationVariables>(
    CreateHelseIdAccountDocument,
    options,
  );
}
export type CreateHelseIdAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateHelseIdAccountMutation,
  CreateHelseIdAccountMutationVariables
>;
export const UpdateHelseIdAccountDocument = gql`
  mutation updateHelseIdAccount($helseIdAccountId: ID!, $input: HelseIdAccountUpdateInput!) {
    updateHelseIdAccount(input: $input, helseIdAccountId: $helseIdAccountId) {
      success
      message
    }
  }
`;

/**
 * __useUpdateHelseIdAccountMutation__
 *
 * To run a mutation, you first call `useUpdateHelseIdAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHelseIdAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateHelseIdAccountMutation({
 *   variables: {
 *     helseIdAccountId: // value for 'helseIdAccountId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHelseIdAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateHelseIdAccountMutation, UpdateHelseIdAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateHelseIdAccountMutation, UpdateHelseIdAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateHelseIdAccountMutation, UpdateHelseIdAccountMutationVariables>(
    UpdateHelseIdAccountDocument,
    options,
  );
}
export type UpdateHelseIdAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateHelseIdAccountMutation,
  UpdateHelseIdAccountMutationVariables
>;
export const CreateVkpAccountDocument = gql`
  mutation createVkpAccount($input: VkpAccountInput!) {
    createVkpAccount(input: $input) {
      success
      message
    }
  }
`;

/**
 * __useCreateVkpAccountMutation__
 *
 * To run a mutation, you first call `useCreateVkpAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateVkpAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateVkpAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateVkpAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateVkpAccountMutation, CreateVkpAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateVkpAccountMutation, CreateVkpAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateVkpAccountMutation, CreateVkpAccountMutationVariables>(
    CreateVkpAccountDocument,
    options,
  );
}
export type CreateVkpAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateVkpAccountMutation,
  CreateVkpAccountMutationVariables
>;
export const UpdateVkpAccountDocument = gql`
  mutation updateVkpAccount($vkpAccountId: ID!, $input: VkpAccountInput!) {
    updateVkpAccount(vkpAccountId: $vkpAccountId, input: $input) {
      success
      message
    }
  }
`;

/**
 * __useUpdateVkpAccountMutation__
 *
 * To run a mutation, you first call `useUpdateVkpAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVkpAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateVkpAccountMutation({
 *   variables: {
 *     vkpAccountId: // value for 'vkpAccountId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVkpAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateVkpAccountMutation, UpdateVkpAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateVkpAccountMutation, UpdateVkpAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateVkpAccountMutation, UpdateVkpAccountMutationVariables>(
    UpdateVkpAccountDocument,
    options,
  );
}
export type UpdateVkpAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateVkpAccountMutation,
  UpdateVkpAccountMutationVariables
>;
export const DeleteVkpAccountDocument = gql`
  mutation deleteVkpAccount($vkpAccountId: ID!) {
    deleteVkpAccount(vkpAccountId: $vkpAccountId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteVkpAccountMutation__
 *
 * To run a mutation, you first call `useDeleteVkpAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVkpAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteVkpAccountMutation({
 *   variables: {
 *     vkpAccountId: // value for 'vkpAccountId'
 *   },
 * });
 */
export function useDeleteVkpAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteVkpAccountMutation, DeleteVkpAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteVkpAccountMutation, DeleteVkpAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteVkpAccountMutation, DeleteVkpAccountMutationVariables>(
    DeleteVkpAccountDocument,
    options,
  );
}
export type DeleteVkpAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteVkpAccountMutation,
  DeleteVkpAccountMutationVariables
>;
export const DeleteHelseIdAccountDocument = gql`
  mutation deleteHelseIdAccount($id: ID!) {
    deleteHelseIdAccount(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteHelseIdAccountMutation__
 *
 * To run a mutation, you first call `useDeleteHelseIdAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHelseIdAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteHelseIdAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHelseIdAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteHelseIdAccountMutation, DeleteHelseIdAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteHelseIdAccountMutation, DeleteHelseIdAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteHelseIdAccountMutation, DeleteHelseIdAccountMutationVariables>(
    DeleteHelseIdAccountDocument,
    options,
  );
}
export type DeleteHelseIdAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteHelseIdAccountMutation,
  DeleteHelseIdAccountMutationVariables
>;
export const TestHelseIdCredentialsDocument = gql`
  mutation testHelseIdCredentials($helseIdAccountId: ID!) {
    testHelseIdCredentials(helseIdAccountId: $helseIdAccountId)
  }
`;

/**
 * __useTestHelseIdCredentialsMutation__
 *
 * To run a mutation, you first call `useTestHelseIdCredentialsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTestHelseIdCredentialsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTestHelseIdCredentialsMutation({
 *   variables: {
 *     helseIdAccountId: // value for 'helseIdAccountId'
 *   },
 * });
 */
export function useTestHelseIdCredentialsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<TestHelseIdCredentialsMutation, TestHelseIdCredentialsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<TestHelseIdCredentialsMutation, TestHelseIdCredentialsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<TestHelseIdCredentialsMutation, TestHelseIdCredentialsMutationVariables>(
    TestHelseIdCredentialsDocument,
    options,
  );
}
export type TestHelseIdCredentialsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  TestHelseIdCredentialsMutation,
  TestHelseIdCredentialsMutationVariables
>;
export const HelseIdAccountsDocument = gql`
  query helseIdAccounts {
    helseIdAccounts {
      id
      accountDisplayName
      organizationNumber
      credentials {
        authority
        clientId
        grantTypes
        maskedPrivateJwk
        rsaKeyExpiryDate
        rsaKeySizeBits
        maskedRsaPrivateKey
        scopes
        secretType
      }
    }
  }
`;

/**
 * __useHelseIdAccountsQuery__
 *
 * To run a query within a Vue component, call `useHelseIdAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelseIdAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHelseIdAccountsQuery();
 */
export function useHelseIdAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>(
    HelseIdAccountsDocument,
    {},
    options,
  );
}
export function useHelseIdAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<HelseIdAccountsQuery, HelseIdAccountsQueryVariables>(
    HelseIdAccountsDocument,
    {},
    options,
  );
}
export type HelseIdAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  HelseIdAccountsQuery,
  HelseIdAccountsQueryVariables
>;
export const VkpAccountsDocument = gql`
  query vkpAccounts {
    vkpAccounts {
      id
      accountDisplayName
      helseIdAccountId
      helseIdAccount {
        credentials {
          scopes
        }
      }
    }
  }
`;

/**
 * __useVkpAccountsQuery__
 *
 * To run a query within a Vue component, call `useVkpAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVkpAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVkpAccountsQuery();
 */
export function useVkpAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<VkpAccountsQuery, VkpAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VkpAccountsQuery, VkpAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<VkpAccountsQuery, VkpAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<VkpAccountsQuery, VkpAccountsQueryVariables>(VkpAccountsDocument, {}, options);
}
export function useVkpAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<VkpAccountsQuery, VkpAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<VkpAccountsQuery, VkpAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<VkpAccountsQuery, VkpAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<VkpAccountsQuery, VkpAccountsQueryVariables>(
    VkpAccountsDocument,
    {},
    options,
  );
}
export type VkpAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  VkpAccountsQuery,
  VkpAccountsQueryVariables
>;
export const CreateJournalConfigForUserGroupDocument = gql`
  mutation createJournalConfigForUserGroup($userGroupId: ID!, $input: JournalConfigForUserGroupInput!) {
    createJournalConfigForUserGroup(userGroupId: $userGroupId, input: $input) {
      success
      message
    }
  }
`;

/**
 * __useCreateJournalConfigForUserGroupMutation__
 *
 * To run a mutation, you first call `useCreateJournalConfigForUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateJournalConfigForUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateJournalConfigForUserGroupMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateJournalConfigForUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateJournalConfigForUserGroupMutation,
        CreateJournalConfigForUserGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateJournalConfigForUserGroupMutation,
          CreateJournalConfigForUserGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateJournalConfigForUserGroupMutation,
    CreateJournalConfigForUserGroupMutationVariables
  >(CreateJournalConfigForUserGroupDocument, options);
}
export type CreateJournalConfigForUserGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateJournalConfigForUserGroupMutation,
  CreateJournalConfigForUserGroupMutationVariables
>;
export const UpdateJournalConfigForUserGroupDocument = gql`
  mutation updateJournalConfigForUserGroup($userGroupId: ID!, $input: JournalConfigForUserGroupInput!) {
    updateJournalConfigForUserGroup(userGroupId: $userGroupId, input: $input) {
      success
      message
    }
  }
`;

/**
 * __useUpdateJournalConfigForUserGroupMutation__
 *
 * To run a mutation, you first call `useUpdateJournalConfigForUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJournalConfigForUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateJournalConfigForUserGroupMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJournalConfigForUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateJournalConfigForUserGroupMutation,
        UpdateJournalConfigForUserGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateJournalConfigForUserGroupMutation,
          UpdateJournalConfigForUserGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateJournalConfigForUserGroupMutation,
    UpdateJournalConfigForUserGroupMutationVariables
  >(UpdateJournalConfigForUserGroupDocument, options);
}
export type UpdateJournalConfigForUserGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateJournalConfigForUserGroupMutation,
  UpdateJournalConfigForUserGroupMutationVariables
>;
export const UpdateInheritedJournalConfigForUserGroupDocument = gql`
  mutation updateInheritedJournalConfigForUserGroup(
    $userGroupId: ID!
    $input: inheritedJournalConfigForUserGroupInput!
  ) {
    updateInheritedJournalConfigForUserGroup(userGroupId: $userGroupId, input: $input) {
      success
      message
    }
  }
`;

/**
 * __useUpdateInheritedJournalConfigForUserGroupMutation__
 *
 * To run a mutation, you first call `useUpdateInheritedJournalConfigForUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInheritedJournalConfigForUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateInheritedJournalConfigForUserGroupMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInheritedJournalConfigForUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateInheritedJournalConfigForUserGroupMutation,
        UpdateInheritedJournalConfigForUserGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateInheritedJournalConfigForUserGroupMutation,
          UpdateInheritedJournalConfigForUserGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateInheritedJournalConfigForUserGroupMutation,
    UpdateInheritedJournalConfigForUserGroupMutationVariables
  >(UpdateInheritedJournalConfigForUserGroupDocument, options);
}
export type UpdateInheritedJournalConfigForUserGroupMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    UpdateInheritedJournalConfigForUserGroupMutation,
    UpdateInheritedJournalConfigForUserGroupMutationVariables
  >;
export const DeleteJournalConfigForUserGroupDocument = gql`
  mutation deleteJournalConfigForUserGroup($userGroupId: ID!) {
    deleteJournalConfigForUserGroup(userGroupId: $userGroupId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteJournalConfigForUserGroupMutation__
 *
 * To run a mutation, you first call `useDeleteJournalConfigForUserGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJournalConfigForUserGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteJournalConfigForUserGroupMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useDeleteJournalConfigForUserGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DeleteJournalConfigForUserGroupMutation,
        DeleteJournalConfigForUserGroupMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteJournalConfigForUserGroupMutation,
          DeleteJournalConfigForUserGroupMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DeleteJournalConfigForUserGroupMutation,
    DeleteJournalConfigForUserGroupMutationVariables
  >(DeleteJournalConfigForUserGroupDocument, options);
}
export type DeleteJournalConfigForUserGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteJournalConfigForUserGroupMutation,
  DeleteJournalConfigForUserGroupMutationVariables
>;
export const GetJournalConfigForUserGroupDocument = gql`
  query getJournalConfigForUserGroup($userGroupId: ID!) {
    getJournalConfigForUserGroup(userGroupId: $userGroupId) {
      vkpAccountId
      forUserGroupId
      monitoringEmailAddresses
      remotePatientMonitoring {
        enabled
        apiUrl
        journalingDisabledForPatientGroupIds
        isLabModuleEnabled
        taskCodesForJournaling
      }
      remoteSupervision {
        enabled
        apiUrl
        journalingDisabledForPatientGroupIds
      }
      read {
        enabled
        apiUrl
        features {
          hasCreatePatientFromVkp
          responseCenter {
            hasCarePlanRead
            hasEpisodesOfCareRead
            hasPatientRead
          }
        }
      }
      inheritedFromUserGroup
    }
  }
`;

/**
 * __useGetJournalConfigForUserGroupQuery__
 *
 * To run a query within a Vue component, call `useGetJournalConfigForUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJournalConfigForUserGroupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetJournalConfigForUserGroupQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useGetJournalConfigForUserGroupQuery(
  variables:
    | GetJournalConfigForUserGroupQueryVariables
    | VueCompositionApi.Ref<GetJournalConfigForUserGroupQueryVariables>
    | ReactiveFunction<GetJournalConfigForUserGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetJournalConfigForUserGroupQuery, GetJournalConfigForUserGroupQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetJournalConfigForUserGroupQuery,
          GetJournalConfigForUserGroupQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetJournalConfigForUserGroupQuery,
          GetJournalConfigForUserGroupQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetJournalConfigForUserGroupQuery, GetJournalConfigForUserGroupQueryVariables>(
    GetJournalConfigForUserGroupDocument,
    variables,
    options,
  );
}
export function useGetJournalConfigForUserGroupLazyQuery(
  variables?:
    | GetJournalConfigForUserGroupQueryVariables
    | VueCompositionApi.Ref<GetJournalConfigForUserGroupQueryVariables>
    | ReactiveFunction<GetJournalConfigForUserGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetJournalConfigForUserGroupQuery, GetJournalConfigForUserGroupQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetJournalConfigForUserGroupQuery,
          GetJournalConfigForUserGroupQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetJournalConfigForUserGroupQuery,
          GetJournalConfigForUserGroupQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetJournalConfigForUserGroupQuery,
    GetJournalConfigForUserGroupQueryVariables
  >(GetJournalConfigForUserGroupDocument, variables, options);
}
export type GetJournalConfigForUserGroupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetJournalConfigForUserGroupQuery,
  GetJournalConfigForUserGroupQueryVariables
>;
export const GetSupportedLanguagesDocument = gql`
  query getSupportedLanguages {
    getSupportedLanguages {
      code
    }
  }
`;

/**
 * __useGetSupportedLanguagesQuery__
 *
 * To run a query within a Vue component, call `useGetSupportedLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportedLanguagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSupportedLanguagesQuery();
 */
export function useGetSupportedLanguagesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>(
    GetSupportedLanguagesDocument,
    {},
    options,
  );
}
export function useGetSupportedLanguagesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>(
    GetSupportedLanguagesDocument,
    {},
    options,
  );
}
export type GetSupportedLanguagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetSupportedLanguagesQuery,
  GetSupportedLanguagesQueryVariables
>;
export const GetPatientFromVkpDocument = gql`
  query getPatientFromVkp($norwegianId: String!) {
    getPatientFromVkp(norwegianId: $norwegianId) {
      success
      patient {
        name {
          given
          family
          text
        }
        birthDate
        gender
        telecom {
          value
          system
          use
        }
        address {
          use
          line
          city
          postalCode
          country
          text
        }
        externalPatientIds {
          externalHumanIdType {
            id
          }
          externalId
        }
        hasSecretAddress
      }
    }
  }
`;

/**
 * __useGetPatientFromVkpQuery__
 *
 * To run a query within a Vue component, call `useGetPatientFromVkpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientFromVkpQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientFromVkpQuery({
 *   norwegianId: // value for 'norwegianId'
 * });
 */
export function useGetPatientFromVkpQuery(
  variables:
    | GetPatientFromVkpQueryVariables
    | VueCompositionApi.Ref<GetPatientFromVkpQueryVariables>
    | ReactiveFunction<GetPatientFromVkpQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>(
    GetPatientFromVkpDocument,
    variables,
    options,
  );
}
export function useGetPatientFromVkpLazyQuery(
  variables?:
    | GetPatientFromVkpQueryVariables
    | VueCompositionApi.Ref<GetPatientFromVkpQueryVariables>
    | ReactiveFunction<GetPatientFromVkpQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientFromVkpQuery, GetPatientFromVkpQueryVariables>(
    GetPatientFromVkpDocument,
    variables,
    options,
  );
}
export type GetPatientFromVkpQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientFromVkpQuery,
  GetPatientFromVkpQueryVariables
>;
export const UpdateIpRestrictionsDocument = gql`
  mutation updateIPRestrictions($userId: ID!, $ipRestrictions: [String]) {
    updateIPRestrictions(userId: $userId, ipRestrictions: $ipRestrictions) {
      success
    }
  }
`;

/**
 * __useUpdateIpRestrictionsMutation__
 *
 * To run a mutation, you first call `useUpdateIpRestrictionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIpRestrictionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateIpRestrictionsMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     ipRestrictions: // value for 'ipRestrictions'
 *   },
 * });
 */
export function useUpdateIpRestrictionsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateIpRestrictionsMutation, UpdateIpRestrictionsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateIpRestrictionsMutation, UpdateIpRestrictionsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateIpRestrictionsMutation, UpdateIpRestrictionsMutationVariables>(
    UpdateIpRestrictionsDocument,
    options,
  );
}
export type UpdateIpRestrictionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateIpRestrictionsMutation,
  UpdateIpRestrictionsMutationVariables
>;
export const GetOpenPatientAlarmsForPatientDocument = gql`
  query getOpenPatientAlarmsForPatient($patientId: ID!) {
    getOpenPatientAlarmsForPatient(patientId: $patientId) {
      id
      status
      priority
      for {
        reference
      }
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
    }
  }
`;

/**
 * __useGetOpenPatientAlarmsForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetOpenPatientAlarmsForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenPatientAlarmsForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOpenPatientAlarmsForPatientQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetOpenPatientAlarmsForPatientQuery(
  variables:
    | GetOpenPatientAlarmsForPatientQueryVariables
    | VueCompositionApi.Ref<GetOpenPatientAlarmsForPatientQueryVariables>
    | ReactiveFunction<GetOpenPatientAlarmsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetOpenPatientAlarmsForPatientQuery,
        GetOpenPatientAlarmsForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetOpenPatientAlarmsForPatientQuery,
          GetOpenPatientAlarmsForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetOpenPatientAlarmsForPatientQuery,
          GetOpenPatientAlarmsForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetOpenPatientAlarmsForPatientQuery,
    GetOpenPatientAlarmsForPatientQueryVariables
  >(GetOpenPatientAlarmsForPatientDocument, variables, options);
}
export function useGetOpenPatientAlarmsForPatientLazyQuery(
  variables?:
    | GetOpenPatientAlarmsForPatientQueryVariables
    | VueCompositionApi.Ref<GetOpenPatientAlarmsForPatientQueryVariables>
    | ReactiveFunction<GetOpenPatientAlarmsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetOpenPatientAlarmsForPatientQuery,
        GetOpenPatientAlarmsForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetOpenPatientAlarmsForPatientQuery,
          GetOpenPatientAlarmsForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetOpenPatientAlarmsForPatientQuery,
          GetOpenPatientAlarmsForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetOpenPatientAlarmsForPatientQuery,
    GetOpenPatientAlarmsForPatientQueryVariables
  >(GetOpenPatientAlarmsForPatientDocument, variables, options);
}
export type GetOpenPatientAlarmsForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOpenPatientAlarmsForPatientQuery,
  GetOpenPatientAlarmsForPatientQueryVariables
>;
export const SubmitSupervisionFeebackDocument = gql`
  mutation submitSupervisionFeeback($feedback: CameraSupervisionFeedback!) {
    submitSupervisionFeeback(feedback: $feedback)
  }
`;

/**
 * __useSubmitSupervisionFeebackMutation__
 *
 * To run a mutation, you first call `useSubmitSupervisionFeebackMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSupervisionFeebackMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitSupervisionFeebackMutation({
 *   variables: {
 *     feedback: // value for 'feedback'
 *   },
 * });
 */
export function useSubmitSupervisionFeebackMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SubmitSupervisionFeebackMutation,
        SubmitSupervisionFeebackMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SubmitSupervisionFeebackMutation,
          SubmitSupervisionFeebackMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<SubmitSupervisionFeebackMutation, SubmitSupervisionFeebackMutationVariables>(
    SubmitSupervisionFeebackDocument,
    options,
  );
}
export type SubmitSupervisionFeebackMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SubmitSupervisionFeebackMutation,
  SubmitSupervisionFeebackMutationVariables
>;
export const GetCameraDocument = gql`
  query getCamera($cameraId: ID!) {
    getCamera(cameraId: $cameraId) {
      id
      name
      macAddress
      description
      presets
      anonymization {
        supports
        requirement
        status
      }
    }
  }
`;

/**
 * __useGetCameraQuery__
 *
 * To run a query within a Vue component, call `useGetCameraQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useGetCameraQuery(
  variables:
    | GetCameraQueryVariables
    | VueCompositionApi.Ref<GetCameraQueryVariables>
    | ReactiveFunction<GetCameraQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraQuery, GetCameraQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraQuery, GetCameraQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraQuery, GetCameraQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetCameraQuery, GetCameraQueryVariables>(GetCameraDocument, variables, options);
}
export function useGetCameraLazyQuery(
  variables?:
    | GetCameraQueryVariables
    | VueCompositionApi.Ref<GetCameraQueryVariables>
    | ReactiveFunction<GetCameraQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraQuery, GetCameraQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraQuery, GetCameraQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraQuery, GetCameraQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraQuery, GetCameraQueryVariables>(
    GetCameraDocument,
    variables,
    options,
  );
}
export type GetCameraQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraQuery,
  GetCameraQueryVariables
>;
export const LoadDocument = gql`
  query load($cameraId: ID!) {
    camera: getCamera(cameraId: $cameraId) {
      view {
        pan
        minPan
        maxPan
        tilt
        minTilt
        maxTilt
        zoom
        minZoom
        maxZoom
      }
    }
  }
`;

/**
 * __useLoadQuery__
 *
 * To run a query within a Vue component, call `useLoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLoadQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useLoadQuery(
  variables: LoadQueryVariables | VueCompositionApi.Ref<LoadQueryVariables> | ReactiveFunction<LoadQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<LoadQuery, LoadQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoadQuery, LoadQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoadQuery, LoadQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<LoadQuery, LoadQueryVariables>(LoadDocument, variables, options);
}
export function useLoadLazyQuery(
  variables?: LoadQueryVariables | VueCompositionApi.Ref<LoadQueryVariables> | ReactiveFunction<LoadQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<LoadQuery, LoadQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LoadQuery, LoadQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<LoadQuery, LoadQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<LoadQuery, LoadQueryVariables>(LoadDocument, variables, options);
}
export type LoadQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LoadQuery, LoadQueryVariables>;
export const SetCameraViewWithPresetDocument = gql`
  mutation setCameraViewWithPreset($cameraId: ID!, $preset: String!) {
    setCameraViewWithPreset(cameraId: $cameraId, name: $preset)
  }
`;

/**
 * __useSetCameraViewWithPresetMutation__
 *
 * To run a mutation, you first call `useSetCameraViewWithPresetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetCameraViewWithPresetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetCameraViewWithPresetMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     preset: // value for 'preset'
 *   },
 * });
 */
export function useSetCameraViewWithPresetMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SetCameraViewWithPresetMutation, SetCameraViewWithPresetMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetCameraViewWithPresetMutation,
          SetCameraViewWithPresetMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<SetCameraViewWithPresetMutation, SetCameraViewWithPresetMutationVariables>(
    SetCameraViewWithPresetDocument,
    options,
  );
}
export type SetCameraViewWithPresetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetCameraViewWithPresetMutation,
  SetCameraViewWithPresetMutationVariables
>;
export const SetCameraViewWithAnglesDocument = gql`
  mutation setCameraViewWithAngles($cameraId: ID!, $pan: Float!, $tilt: Float!, $zoom: Float!) {
    setCameraViewWithAngles(cameraId: $cameraId, pan: $pan, tilt: $tilt, zoom: $zoom)
  }
`;

/**
 * __useSetCameraViewWithAnglesMutation__
 *
 * To run a mutation, you first call `useSetCameraViewWithAnglesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetCameraViewWithAnglesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetCameraViewWithAnglesMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     pan: // value for 'pan'
 *     tilt: // value for 'tilt'
 *     zoom: // value for 'zoom'
 *   },
 * });
 */
export function useSetCameraViewWithAnglesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SetCameraViewWithAnglesMutation, SetCameraViewWithAnglesMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetCameraViewWithAnglesMutation,
          SetCameraViewWithAnglesMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<SetCameraViewWithAnglesMutation, SetCameraViewWithAnglesMutationVariables>(
    SetCameraViewWithAnglesDocument,
    options,
  );
}
export type SetCameraViewWithAnglesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetCameraViewWithAnglesMutation,
  SetCameraViewWithAnglesMutationVariables
>;
export const CreateCameraViewPresetDocument = gql`
  mutation createCameraViewPreset($cameraId: ID!, $name: String!) {
    createCameraViewPreset(cameraId: $cameraId, name: $name)
  }
`;

/**
 * __useCreateCameraViewPresetMutation__
 *
 * To run a mutation, you first call `useCreateCameraViewPresetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCameraViewPresetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCameraViewPresetMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     name: // value for 'name'
 *   },
 * });
 */
export function useCreateCameraViewPresetMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCameraViewPresetMutation, CreateCameraViewPresetMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateCameraViewPresetMutation, CreateCameraViewPresetMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCameraViewPresetMutation, CreateCameraViewPresetMutationVariables>(
    CreateCameraViewPresetDocument,
    options,
  );
}
export type CreateCameraViewPresetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCameraViewPresetMutation,
  CreateCameraViewPresetMutationVariables
>;
export const DeleteCameraViewPresetDocument = gql`
  mutation deleteCameraViewPreset($cameraId: ID!, $preset: String!) {
    deleteCameraViewPreset(cameraId: $cameraId, name: $preset)
  }
`;

/**
 * __useDeleteCameraViewPresetMutation__
 *
 * To run a mutation, you first call `useDeleteCameraViewPresetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCameraViewPresetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCameraViewPresetMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     preset: // value for 'preset'
 *   },
 * });
 */
export function useDeleteCameraViewPresetMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteCameraViewPresetMutation, DeleteCameraViewPresetMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteCameraViewPresetMutation, DeleteCameraViewPresetMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteCameraViewPresetMutation, DeleteCameraViewPresetMutationVariables>(
    DeleteCameraViewPresetDocument,
    options,
  );
}
export type DeleteCameraViewPresetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteCameraViewPresetMutation,
  DeleteCameraViewPresetMutationVariables
>;
export const SwitchAnonymizationDocument = gql`
  mutation switchAnonymization($cameraId: ID!) {
    switchAnonymization(cameraId: $cameraId)
  }
`;

/**
 * __useSwitchAnonymizationMutation__
 *
 * To run a mutation, you first call `useSwitchAnonymizationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSwitchAnonymizationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSwitchAnonymizationMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useSwitchAnonymizationMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SwitchAnonymizationMutation, SwitchAnonymizationMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SwitchAnonymizationMutation, SwitchAnonymizationMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SwitchAnonymizationMutation, SwitchAnonymizationMutationVariables>(
    SwitchAnonymizationDocument,
    options,
  );
}
export type SwitchAnonymizationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SwitchAnonymizationMutation,
  SwitchAnonymizationMutationVariables
>;
export const StartStreamDocument = gql`
  mutation startStream($cameraId: ID!) {
    stream: startStream(cameraId: $cameraId) {
      id
      url
      type
      ttl
    }
  }
`;

/**
 * __useStartStreamMutation__
 *
 * To run a mutation, you first call `useStartStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartStreamMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useStartStreamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StartStreamMutation, StartStreamMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<StartStreamMutation, StartStreamMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<StartStreamMutation, StartStreamMutationVariables>(
    StartStreamDocument,
    options,
  );
}
export type StartStreamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartStreamMutation,
  StartStreamMutationVariables
>;
export const KeepStreamAliveDocument = gql`
  mutation keepStreamAlive($cameraId: ID!, $streamId: ID!) {
    stream: keepStreamAlive(cameraId: $cameraId, streamId: $streamId) {
      id
      url
      type
      expires
      ttl
    }
  }
`;

/**
 * __useKeepStreamAliveMutation__
 *
 * To run a mutation, you first call `useKeepStreamAliveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useKeepStreamAliveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useKeepStreamAliveMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useKeepStreamAliveMutation(
  options:
    | VueApolloComposable.UseMutationOptions<KeepStreamAliveMutation, KeepStreamAliveMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<KeepStreamAliveMutation, KeepStreamAliveMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<KeepStreamAliveMutation, KeepStreamAliveMutationVariables>(
    KeepStreamAliveDocument,
    options,
  );
}
export type KeepStreamAliveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  KeepStreamAliveMutation,
  KeepStreamAliveMutationVariables
>;
export const StopStreamDocument = gql`
  mutation stopStream($cameraId: ID!, $streamId: ID!) {
    stream: stopStream(cameraId: $cameraId, streamId: $streamId)
  }
`;

/**
 * __useStopStreamMutation__
 *
 * To run a mutation, you first call `useStopStreamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStopStreamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStopStreamMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     streamId: // value for 'streamId'
 *   },
 * });
 */
export function useStopStreamMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StopStreamMutation, StopStreamMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<StopStreamMutation, StopStreamMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<StopStreamMutation, StopStreamMutationVariables>(StopStreamDocument, options);
}
export type StopStreamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StopStreamMutation,
  StopStreamMutationVariables
>;
export const PatientReferenceQueryDocument = gql`
  query patientReferenceQuery($cameraId: ID!) {
    patientReferenceQuery: getCamera(cameraId: $cameraId) {
      patientReference {
        reference
      }
    }
  }
`;

/**
 * __usePatientReferenceQueryQuery__
 *
 * To run a query within a Vue component, call `usePatientReferenceQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientReferenceQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientReferenceQueryQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function usePatientReferenceQueryQuery(
  variables:
    | PatientReferenceQueryQueryVariables
    | VueCompositionApi.Ref<PatientReferenceQueryQueryVariables>
    | ReactiveFunction<PatientReferenceQueryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>(
    PatientReferenceQueryDocument,
    variables,
    options,
  );
}
export function usePatientReferenceQueryLazyQuery(
  variables?:
    | PatientReferenceQueryQueryVariables
    | VueCompositionApi.Ref<PatientReferenceQueryQueryVariables>
    | ReactiveFunction<PatientReferenceQueryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientReferenceQueryQuery, PatientReferenceQueryQueryVariables>(
    PatientReferenceQueryDocument,
    variables,
    options,
  );
}
export type PatientReferenceQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientReferenceQueryQuery,
  PatientReferenceQueryQueryVariables
>;
export const PatientWelfareDevicesDocument = gql`
  query patientWelfareDevices($id: ID!) {
    patientWelfareDevices: patient(id: $id) {
      welfareDevices {
        id
        uniqueIdentifier
        deviceName {
          name
        }
        modelNumber
      }
    }
  }
`;

/**
 * __usePatientWelfareDevicesQuery__
 *
 * To run a query within a Vue component, call `usePatientWelfareDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientWelfareDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientWelfareDevicesQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientWelfareDevicesQuery(
  variables:
    | PatientWelfareDevicesQueryVariables
    | VueCompositionApi.Ref<PatientWelfareDevicesQueryVariables>
    | ReactiveFunction<PatientWelfareDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>(
    PatientWelfareDevicesDocument,
    variables,
    options,
  );
}
export function usePatientWelfareDevicesLazyQuery(
  variables?:
    | PatientWelfareDevicesQueryVariables
    | VueCompositionApi.Ref<PatientWelfareDevicesQueryVariables>
    | ReactiveFunction<PatientWelfareDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientWelfareDevicesQuery, PatientWelfareDevicesQueryVariables>(
    PatientWelfareDevicesDocument,
    variables,
    options,
  );
}
export type PatientWelfareDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientWelfareDevicesQuery,
  PatientWelfareDevicesQueryVariables
>;
export const AddCameraToSetupBatchTelluSupportDocument = gql`
  mutation addCameraToSetupBatchTelluSupport($cameraSetupInput: CameraSetupInput!) {
    addCameraToSetupBatchTelluSupport(cameraSetupInput: $cameraSetupInput)
  }
`;

/**
 * __useAddCameraToSetupBatchTelluSupportMutation__
 *
 * To run a mutation, you first call `useAddCameraToSetupBatchTelluSupportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCameraToSetupBatchTelluSupportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCameraToSetupBatchTelluSupportMutation({
 *   variables: {
 *     cameraSetupInput: // value for 'cameraSetupInput'
 *   },
 * });
 */
export function useAddCameraToSetupBatchTelluSupportMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddCameraToSetupBatchTelluSupportMutation,
        AddCameraToSetupBatchTelluSupportMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddCameraToSetupBatchTelluSupportMutation,
          AddCameraToSetupBatchTelluSupportMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddCameraToSetupBatchTelluSupportMutation,
    AddCameraToSetupBatchTelluSupportMutationVariables
  >(AddCameraToSetupBatchTelluSupportDocument, options);
}
export type AddCameraToSetupBatchTelluSupportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddCameraToSetupBatchTelluSupportMutation,
  AddCameraToSetupBatchTelluSupportMutationVariables
>;
export const RedoCameraSetupTelluSupportDocument = gql`
  mutation redoCameraSetupTelluSupport($serial: String!) {
    redoCameraSetupTelluSupport(serial: $serial)
  }
`;

/**
 * __useRedoCameraSetupTelluSupportMutation__
 *
 * To run a mutation, you first call `useRedoCameraSetupTelluSupportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRedoCameraSetupTelluSupportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRedoCameraSetupTelluSupportMutation({
 *   variables: {
 *     serial: // value for 'serial'
 *   },
 * });
 */
export function useRedoCameraSetupTelluSupportMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RedoCameraSetupTelluSupportMutation,
        RedoCameraSetupTelluSupportMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RedoCameraSetupTelluSupportMutation,
          RedoCameraSetupTelluSupportMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RedoCameraSetupTelluSupportMutation,
    RedoCameraSetupTelluSupportMutationVariables
  >(RedoCameraSetupTelluSupportDocument, options);
}
export type RedoCameraSetupTelluSupportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RedoCameraSetupTelluSupportMutation,
  RedoCameraSetupTelluSupportMutationVariables
>;
export const ResetCameraSetupTelluSupportDocument = gql`
  mutation resetCameraSetupTelluSupport($serial: String!) {
    resetCameraSetupTelluSupport(serial: $serial)
  }
`;

/**
 * __useResetCameraSetupTelluSupportMutation__
 *
 * To run a mutation, you first call `useResetCameraSetupTelluSupportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetCameraSetupTelluSupportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetCameraSetupTelluSupportMutation({
 *   variables: {
 *     serial: // value for 'serial'
 *   },
 * });
 */
export function useResetCameraSetupTelluSupportMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ResetCameraSetupTelluSupportMutation,
        ResetCameraSetupTelluSupportMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ResetCameraSetupTelluSupportMutation,
          ResetCameraSetupTelluSupportMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ResetCameraSetupTelluSupportMutation,
    ResetCameraSetupTelluSupportMutationVariables
  >(ResetCameraSetupTelluSupportDocument, options);
}
export type ResetCameraSetupTelluSupportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ResetCameraSetupTelluSupportMutation,
  ResetCameraSetupTelluSupportMutationVariables
>;
export const ResetCameraSetupBatchTelluSupportDocument = gql`
  mutation resetCameraSetupBatchTelluSupport {
    resetCameraSetupBatchTelluSupport
  }
`;

/**
 * __useResetCameraSetupBatchTelluSupportMutation__
 *
 * To run a mutation, you first call `useResetCameraSetupBatchTelluSupportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetCameraSetupBatchTelluSupportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetCameraSetupBatchTelluSupportMutation();
 */
export function useResetCameraSetupBatchTelluSupportMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ResetCameraSetupBatchTelluSupportMutation,
        ResetCameraSetupBatchTelluSupportMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ResetCameraSetupBatchTelluSupportMutation,
          ResetCameraSetupBatchTelluSupportMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ResetCameraSetupBatchTelluSupportMutation,
    ResetCameraSetupBatchTelluSupportMutationVariables
  >(ResetCameraSetupBatchTelluSupportDocument, options);
}
export type ResetCameraSetupBatchTelluSupportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ResetCameraSetupBatchTelluSupportMutation,
  ResetCameraSetupBatchTelluSupportMutationVariables
>;
export const ResetMorpheanCacheTelluSupportDocument = gql`
  mutation resetMorpheanCacheTelluSupport {
    resetMorpheanCacheTelluSupport
  }
`;

/**
 * __useResetMorpheanCacheTelluSupportMutation__
 *
 * To run a mutation, you first call `useResetMorpheanCacheTelluSupportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetMorpheanCacheTelluSupportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetMorpheanCacheTelluSupportMutation();
 */
export function useResetMorpheanCacheTelluSupportMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ResetMorpheanCacheTelluSupportMutation,
        ResetMorpheanCacheTelluSupportMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ResetMorpheanCacheTelluSupportMutation,
          ResetMorpheanCacheTelluSupportMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ResetMorpheanCacheTelluSupportMutation,
    ResetMorpheanCacheTelluSupportMutationVariables
  >(ResetMorpheanCacheTelluSupportDocument, options);
}
export type ResetMorpheanCacheTelluSupportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ResetMorpheanCacheTelluSupportMutation,
  ResetMorpheanCacheTelluSupportMutationVariables
>;
export const CameraAppBulkUpdateDocument = gql`
  mutation cameraAppBulkUpdate($cameras: [CameraManagementInput!]!, $appUpdates: [CameraAppUpdateInput!]!) {
    cameraAppBulkUpdate(cameras: $cameras, appUpdates: $appUpdates)
  }
`;

/**
 * __useCameraAppBulkUpdateMutation__
 *
 * To run a mutation, you first call `useCameraAppBulkUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCameraAppBulkUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCameraAppBulkUpdateMutation({
 *   variables: {
 *     cameras: // value for 'cameras'
 *     appUpdates: // value for 'appUpdates'
 *   },
 * });
 */
export function useCameraAppBulkUpdateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CameraAppBulkUpdateMutation, CameraAppBulkUpdateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CameraAppBulkUpdateMutation, CameraAppBulkUpdateMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CameraAppBulkUpdateMutation, CameraAppBulkUpdateMutationVariables>(
    CameraAppBulkUpdateDocument,
    options,
  );
}
export type CameraAppBulkUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CameraAppBulkUpdateMutation,
  CameraAppBulkUpdateMutationVariables
>;
export const CameraFirmwareBulkUpgradeDocument = gql`
  mutation cameraFirmwareBulkUpgrade(
    $cameras: [CameraManagementInput!]!
    $firmwareUpgradeOptions: CameraFirmwareUpgradeInput!
  ) {
    cameraFirmwareBulkUpgrade(cameras: $cameras, firmwareUpgradeOptions: $firmwareUpgradeOptions)
  }
`;

/**
 * __useCameraFirmwareBulkUpgradeMutation__
 *
 * To run a mutation, you first call `useCameraFirmwareBulkUpgradeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCameraFirmwareBulkUpgradeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCameraFirmwareBulkUpgradeMutation({
 *   variables: {
 *     cameras: // value for 'cameras'
 *     firmwareUpgradeOptions: // value for 'firmwareUpgradeOptions'
 *   },
 * });
 */
export function useCameraFirmwareBulkUpgradeMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CameraFirmwareBulkUpgradeMutation,
        CameraFirmwareBulkUpgradeMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CameraFirmwareBulkUpgradeMutation,
          CameraFirmwareBulkUpgradeMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<CameraFirmwareBulkUpgradeMutation, CameraFirmwareBulkUpgradeMutationVariables>(
    CameraFirmwareBulkUpgradeDocument,
    options,
  );
}
export type CameraFirmwareBulkUpgradeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CameraFirmwareBulkUpgradeMutation,
  CameraFirmwareBulkUpgradeMutationVariables
>;
export const DecommissionCamerasDocument = gql`
  mutation decommissionCameras($cameras: [CameraManagementInputWithOptionalId!]!) {
    decommissionCameras(cameras: $cameras)
  }
`;

/**
 * __useDecommissionCamerasMutation__
 *
 * To run a mutation, you first call `useDecommissionCamerasMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDecommissionCamerasMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDecommissionCamerasMutation({
 *   variables: {
 *     cameras: // value for 'cameras'
 *   },
 * });
 */
export function useDecommissionCamerasMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DecommissionCamerasMutation, DecommissionCamerasMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DecommissionCamerasMutation, DecommissionCamerasMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DecommissionCamerasMutation, DecommissionCamerasMutationVariables>(
    DecommissionCamerasDocument,
    options,
  );
}
export type DecommissionCamerasMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DecommissionCamerasMutation,
  DecommissionCamerasMutationVariables
>;
export const DecommissionCamerasLimitedDocument = gql`
  mutation decommissionCamerasLimited($cameras: [CameraManagementInputWithOptionalId!]!) {
    decommissionCamerasLimited(cameras: $cameras)
  }
`;

/**
 * __useDecommissionCamerasLimitedMutation__
 *
 * To run a mutation, you first call `useDecommissionCamerasLimitedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDecommissionCamerasLimitedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDecommissionCamerasLimitedMutation({
 *   variables: {
 *     cameras: // value for 'cameras'
 *   },
 * });
 */
export function useDecommissionCamerasLimitedMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        DecommissionCamerasLimitedMutation,
        DecommissionCamerasLimitedMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DecommissionCamerasLimitedMutation,
          DecommissionCamerasLimitedMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    DecommissionCamerasLimitedMutation,
    DecommissionCamerasLimitedMutationVariables
  >(DecommissionCamerasLimitedDocument, options);
}
export type DecommissionCamerasLimitedMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DecommissionCamerasLimitedMutation,
  DecommissionCamerasLimitedMutationVariables
>;
export const CameraNetworkingBulkUpdateDocument = gql`
  mutation cameraNetworkingBulkUpdate($cameras: [CameraManagementInput!]!) {
    cameraNetworkingBulkUpdate(cameras: $cameras)
  }
`;

/**
 * __useCameraNetworkingBulkUpdateMutation__
 *
 * To run a mutation, you first call `useCameraNetworkingBulkUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCameraNetworkingBulkUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCameraNetworkingBulkUpdateMutation({
 *   variables: {
 *     cameras: // value for 'cameras'
 *   },
 * });
 */
export function useCameraNetworkingBulkUpdateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CameraNetworkingBulkUpdateMutation,
        CameraNetworkingBulkUpdateMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CameraNetworkingBulkUpdateMutation,
          CameraNetworkingBulkUpdateMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CameraNetworkingBulkUpdateMutation,
    CameraNetworkingBulkUpdateMutationVariables
  >(CameraNetworkingBulkUpdateDocument, options);
}
export type CameraNetworkingBulkUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CameraNetworkingBulkUpdateMutation,
  CameraNetworkingBulkUpdateMutationVariables
>;
export const TerminateShiftSessionOnDeviceDocument = gql`
  mutation terminateShiftSessionOnDevice($device: String!) {
    terminateShiftSessionOnDevice(device: $device) {
      createdAt
      lastUpdated
    }
  }
`;

/**
 * __useTerminateShiftSessionOnDeviceMutation__
 *
 * To run a mutation, you first call `useTerminateShiftSessionOnDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTerminateShiftSessionOnDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTerminateShiftSessionOnDeviceMutation({
 *   variables: {
 *     device: // value for 'device'
 *   },
 * });
 */
export function useTerminateShiftSessionOnDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        TerminateShiftSessionOnDeviceMutation,
        TerminateShiftSessionOnDeviceMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          TerminateShiftSessionOnDeviceMutation,
          TerminateShiftSessionOnDeviceMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    TerminateShiftSessionOnDeviceMutation,
    TerminateShiftSessionOnDeviceMutationVariables
  >(TerminateShiftSessionOnDeviceDocument, options);
}
export type TerminateShiftSessionOnDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  TerminateShiftSessionOnDeviceMutation,
  TerminateShiftSessionOnDeviceMutationVariables
>;
export const TerminateShiftSessionOnAllDevicesDocument = gql`
  mutation terminateShiftSessionOnAllDevices {
    terminateShiftSessionOnAllDevices
  }
`;

/**
 * __useTerminateShiftSessionOnAllDevicesMutation__
 *
 * To run a mutation, you first call `useTerminateShiftSessionOnAllDevicesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTerminateShiftSessionOnAllDevicesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTerminateShiftSessionOnAllDevicesMutation();
 */
export function useTerminateShiftSessionOnAllDevicesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        TerminateShiftSessionOnAllDevicesMutation,
        TerminateShiftSessionOnAllDevicesMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          TerminateShiftSessionOnAllDevicesMutation,
          TerminateShiftSessionOnAllDevicesMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    TerminateShiftSessionOnAllDevicesMutation,
    TerminateShiftSessionOnAllDevicesMutationVariables
  >(TerminateShiftSessionOnAllDevicesDocument, options);
}
export type TerminateShiftSessionOnAllDevicesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  TerminateShiftSessionOnAllDevicesMutation,
  TerminateShiftSessionOnAllDevicesMutationVariables
>;
export const TakeCallDocument = gql`
  mutation takeCall($taskId: ID!, $takeCallInput: TakeCallInput) {
    takeCall(taskId: $taskId, takeCallInput: $takeCallInput) {
      success
      message
      inputValidation {
        message
        valid
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useTakeCallMutation__
 *
 * To run a mutation, you first call `useTakeCallMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTakeCallMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTakeCallMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     takeCallInput: // value for 'takeCallInput'
 *   },
 * });
 */
export function useTakeCallMutation(
  options:
    | VueApolloComposable.UseMutationOptions<TakeCallMutation, TakeCallMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<TakeCallMutation, TakeCallMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<TakeCallMutation, TakeCallMutationVariables>(TakeCallDocument, options);
}
export type TakeCallMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  TakeCallMutation,
  TakeCallMutationVariables
>;
export const AddNotesToTaskDocument = gql`
  mutation addNotesToTask($taskId: ID!, $note: [AnnotationInput]!) {
    addNotesToTask(taskId: $taskId, note: $note) {
      success
      inputValidation {
        message
      }
      message
    }
  }
`;

/**
 * __useAddNotesToTaskMutation__
 *
 * To run a mutation, you first call `useAddNotesToTaskMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddNotesToTaskMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddNotesToTaskMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     note: // value for 'note'
 *   },
 * });
 */
export function useAddNotesToTaskMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddNotesToTaskMutation, AddNotesToTaskMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddNotesToTaskMutation, AddNotesToTaskMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddNotesToTaskMutation, AddNotesToTaskMutationVariables>(
    AddNotesToTaskDocument,
    options,
  );
}
export type AddNotesToTaskMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddNotesToTaskMutation,
  AddNotesToTaskMutationVariables
>;
export const AddWelfareDeviceToPatientDocument = gql`
  mutation addWelfareDeviceToPatient($patientId: ID!, $welfareDeviceId: ID!) {
    addWelfareDeviceToPatient(patientId: $patientId, welfareDeviceId: $welfareDeviceId) {
      success
    }
  }
`;

/**
 * __useAddWelfareDeviceToPatientMutation__
 *
 * To run a mutation, you first call `useAddWelfareDeviceToPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddWelfareDeviceToPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddWelfareDeviceToPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     welfareDeviceId: // value for 'welfareDeviceId'
 *   },
 * });
 */
export function useAddWelfareDeviceToPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddWelfareDeviceToPatientMutation,
        AddWelfareDeviceToPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddWelfareDeviceToPatientMutation,
          AddWelfareDeviceToPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<AddWelfareDeviceToPatientMutation, AddWelfareDeviceToPatientMutationVariables>(
    AddWelfareDeviceToPatientDocument,
    options,
  );
}
export type AddWelfareDeviceToPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddWelfareDeviceToPatientMutation,
  AddWelfareDeviceToPatientMutationVariables
>;
export const CreateWelfareDeviceDocument = gql`
  mutation createWelfareDevice($createInput: WelfareDeviceCreateInput!) {
    createWelfareDevice(createInput: $createInput) {
      success
      message
      welfareDevice {
        id
        uniqueIdentifier
      }
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useCreateWelfareDeviceMutation__
 *
 * To run a mutation, you first call `useCreateWelfareDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateWelfareDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateWelfareDeviceMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateWelfareDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateWelfareDeviceMutation, CreateWelfareDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateWelfareDeviceMutation, CreateWelfareDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateWelfareDeviceMutation, CreateWelfareDeviceMutationVariables>(
    CreateWelfareDeviceDocument,
    options,
  );
}
export type CreateWelfareDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateWelfareDeviceMutation,
  CreateWelfareDeviceMutationVariables
>;
export const DeleteWelfareDeviceDocument = gql`
  mutation deleteWelfareDevice($id: ID!) {
    deleteWelfareDevice(id: $id) {
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
      }
    }
  }
`;

/**
 * __useDeleteWelfareDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteWelfareDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWelfareDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteWelfareDeviceMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWelfareDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteWelfareDeviceMutation, DeleteWelfareDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteWelfareDeviceMutation, DeleteWelfareDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteWelfareDeviceMutation, DeleteWelfareDeviceMutationVariables>(
    DeleteWelfareDeviceDocument,
    options,
  );
}
export type DeleteWelfareDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteWelfareDeviceMutation,
  DeleteWelfareDeviceMutationVariables
>;
export const LogLocalExportDocument = gql`
  mutation logLocalExport($resourceType: String!, $count: Int!) {
    logLocalExport(resourceType: $resourceType, count: $count) {
      success
    }
  }
`;

/**
 * __useLogLocalExportMutation__
 *
 * To run a mutation, you first call `useLogLocalExportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLogLocalExportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLogLocalExportMutation({
 *   variables: {
 *     resourceType: // value for 'resourceType'
 *     count: // value for 'count'
 *   },
 * });
 */
export function useLogLocalExportMutation(
  options:
    | VueApolloComposable.UseMutationOptions<LogLocalExportMutation, LogLocalExportMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<LogLocalExportMutation, LogLocalExportMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<LogLocalExportMutation, LogLocalExportMutationVariables>(
    LogLocalExportDocument,
    options,
  );
}
export type LogLocalExportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  LogLocalExportMutation,
  LogLocalExportMutationVariables
>;
export const MoveAccessGroupDocument = gql`
  mutation moveAccessGroup($attachToUserGroup: String!, $userGroupToMove: String!) {
    moveAccessGroup(attachToUserGroup: $attachToUserGroup, userGroupToMove: $userGroupToMove) {
      success
      message
    }
  }
`;

/**
 * __useMoveAccessGroupMutation__
 *
 * To run a mutation, you first call `useMoveAccessGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMoveAccessGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMoveAccessGroupMutation({
 *   variables: {
 *     attachToUserGroup: // value for 'attachToUserGroup'
 *     userGroupToMove: // value for 'userGroupToMove'
 *   },
 * });
 */
export function useMoveAccessGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<MoveAccessGroupMutation, MoveAccessGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<MoveAccessGroupMutation, MoveAccessGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<MoveAccessGroupMutation, MoveAccessGroupMutationVariables>(
    MoveAccessGroupDocument,
    options,
  );
}
export type MoveAccessGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  MoveAccessGroupMutation,
  MoveAccessGroupMutationVariables
>;
export const AddPatientByExternalIdDocument = gql`
  mutation addPatientByExternalId($patientGroupId: ID!, $externalPatientId: ExternalHumanIdInput!, $active: Boolean) {
    addPatientByExternalId(patientGroupId: $patientGroupId, externalPatientId: $externalPatientId, active: $active) {
      success
      message
      patient {
        id
      }
    }
  }
`;

/**
 * __useAddPatientByExternalIdMutation__
 *
 * To run a mutation, you first call `useAddPatientByExternalIdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientByExternalIdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPatientByExternalIdMutation({
 *   variables: {
 *     patientGroupId: // value for 'patientGroupId'
 *     externalPatientId: // value for 'externalPatientId'
 *     active: // value for 'active'
 *   },
 * });
 */
export function useAddPatientByExternalIdMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddPatientByExternalIdMutation, AddPatientByExternalIdMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddPatientByExternalIdMutation, AddPatientByExternalIdMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddPatientByExternalIdMutation, AddPatientByExternalIdMutationVariables>(
    AddPatientByExternalIdDocument,
    options,
  );
}
export type AddPatientByExternalIdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddPatientByExternalIdMutation,
  AddPatientByExternalIdMutationVariables
>;
export const CreatePatientDocument = gql`
  mutation createPatient($patientGroupIds: [ID!]!, $patientInput: CreatePatientInput!) {
    createPatient(patientGroupIds: $patientGroupIds, patientInput: $patientInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      patient {
        id
      }
    }
  }
`;

/**
 * __useCreatePatientMutation__
 *
 * To run a mutation, you first call `useCreatePatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePatientMutation({
 *   variables: {
 *     patientGroupIds: // value for 'patientGroupIds'
 *     patientInput: // value for 'patientInput'
 *   },
 * });
 */
export function useCreatePatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreatePatientMutation, CreatePatientMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreatePatientMutation, CreatePatientMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreatePatientMutation, CreatePatientMutationVariables>(
    CreatePatientDocument,
    options,
  );
}
export type CreatePatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreatePatientMutation,
  CreatePatientMutationVariables
>;
export const UpdateLinkedPatientGroupsDocument = gql`
  mutation updateLinkedPatientGroups(
    $userGroupId: ID!
    $addPatientGroups: [String!]!
    $removePatientGroups: [String!]!
  ) {
    updateLinkedPatientGroups(
      userGroupId: $userGroupId
      addPatientGroups: $addPatientGroups
      removePatientGroups: $removePatientGroups
    ) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useUpdateLinkedPatientGroupsMutation__
 *
 * To run a mutation, you first call `useUpdateLinkedPatientGroupsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLinkedPatientGroupsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateLinkedPatientGroupsMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     addPatientGroups: // value for 'addPatientGroups'
 *     removePatientGroups: // value for 'removePatientGroups'
 *   },
 * });
 */
export function useUpdateLinkedPatientGroupsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateLinkedPatientGroupsMutation,
        UpdateLinkedPatientGroupsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateLinkedPatientGroupsMutation,
          UpdateLinkedPatientGroupsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateLinkedPatientGroupsMutation, UpdateLinkedPatientGroupsMutationVariables>(
    UpdateLinkedPatientGroupsDocument,
    options,
  );
}
export type UpdateLinkedPatientGroupsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateLinkedPatientGroupsMutation,
  UpdateLinkedPatientGroupsMutationVariables
>;
export const UpdatePatientDocument = gql`
  mutation updatePatient($patientId: ID!, $patientInput: UpdatePatientInput!) {
    updatePatient(patientId: $patientId, patientInput: $patientInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     patientInput: // value for 'patientInput'
 *   },
 * });
 */
export function useUpdatePatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdatePatientMutation, UpdatePatientMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdatePatientMutation, UpdatePatientMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePatientMutation, UpdatePatientMutationVariables>(
    UpdatePatientDocument,
    options,
  );
}
export type UpdatePatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientMutation,
  UpdatePatientMutationVariables
>;
export const UpdateWelfareDeviceDocument = gql`
  mutation updateWelfareDevice($id: ID!, $updateInput: WelfareDeviceUpdateInput!) {
    updateWelfareDevice(id: $id, updateInput: $updateInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdateWelfareDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateWelfareDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWelfareDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateWelfareDeviceMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateWelfareDeviceMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateWelfareDeviceMutation, UpdateWelfareDeviceMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateWelfareDeviceMutation, UpdateWelfareDeviceMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateWelfareDeviceMutation, UpdateWelfareDeviceMutationVariables>(
    UpdateWelfareDeviceDocument,
    options,
  );
}
export type UpdateWelfareDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateWelfareDeviceMutation,
  UpdateWelfareDeviceMutationVariables
>;
export const AddUserToRoleDocument = gql`
  mutation addUserToRole($userId: ID!, $roleId: ID!) {
    addUserToRole(userId: $userId, roleId: $roleId) {
      success
      message
    }
  }
`;

/**
 * __useAddUserToRoleMutation__
 *
 * To run a mutation, you first call `useAddUserToRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddUserToRoleMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     roleId: // value for 'roleId'
 *   },
 * });
 */
export function useAddUserToRoleMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddUserToRoleMutation, AddUserToRoleMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddUserToRoleMutation, AddUserToRoleMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddUserToRoleMutation, AddUserToRoleMutationVariables>(
    AddUserToRoleDocument,
    options,
  );
}
export type AddUserToRoleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddUserToRoleMutation,
  AddUserToRoleMutationVariables
>;
export const RemoveUserFromRoleDocument = gql`
  mutation removeUserFromRole($userId: ID!, $roleId: ID!) {
    removeUserFromRole(userId: $userId, roleId: $roleId) {
      success
      message
    }
  }
`;

/**
 * __useRemoveUserFromRoleMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveUserFromRoleMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     roleId: // value for 'roleId'
 *   },
 * });
 */
export function useRemoveUserFromRoleMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RemoveUserFromRoleMutation, RemoveUserFromRoleMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RemoveUserFromRoleMutation, RemoveUserFromRoleMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RemoveUserFromRoleMutation, RemoveUserFromRoleMutationVariables>(
    RemoveUserFromRoleDocument,
    options,
  );
}
export type RemoveUserFromRoleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveUserFromRoleMutation,
  RemoveUserFromRoleMutationVariables
>;
export const UpdateUserTimeLimitedAccessDocument = gql`
  mutation updateUserTimeLimitedAccess($userId: ID!, $timeLimitedAccess: PeriodInput) {
    updateUserTimeLimitedAccess(userId: $userId, timeLimitedAccess: $timeLimitedAccess) {
      success
      inputValidation {
        message
      }
    }
  }
`;

/**
 * __useUpdateUserTimeLimitedAccessMutation__
 *
 * To run a mutation, you first call `useUpdateUserTimeLimitedAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTimeLimitedAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserTimeLimitedAccessMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     timeLimitedAccess: // value for 'timeLimitedAccess'
 *   },
 * });
 */
export function useUpdateUserTimeLimitedAccessMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateUserTimeLimitedAccessMutation,
        UpdateUserTimeLimitedAccessMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateUserTimeLimitedAccessMutation,
          UpdateUserTimeLimitedAccessMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateUserTimeLimitedAccessMutation,
    UpdateUserTimeLimitedAccessMutationVariables
  >(UpdateUserTimeLimitedAccessDocument, options);
}
export type UpdateUserTimeLimitedAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateUserTimeLimitedAccessMutation,
  UpdateUserTimeLimitedAccessMutationVariables
>;
export const CameraProvisioningBatchTelluSupportDocument = gql`
  query cameraProvisioningBatchTelluSupport {
    cameraProvisioningBatchTelluSupport {
      type
      serial
      cameraName
      cameraSetup {
        model
        serial
        oak
        cameraName
        customerId
        siteId
        deviceGroupId
        installVMD
        installFG
        installPS
        installOA
        enableAudio
        firmwareUpgrade
        installApps
      }
      apps {
        id
        install
        activate
        deactivate
        uninstall
      }
      status {
        step
        status
        timestamp
      }
      logs
    }
  }
`;

/**
 * __useCameraProvisioningBatchTelluSupportQuery__
 *
 * To run a query within a Vue component, call `useCameraProvisioningBatchTelluSupportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraProvisioningBatchTelluSupportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCameraProvisioningBatchTelluSupportQuery();
 */
export function useCameraProvisioningBatchTelluSupportQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        CameraProvisioningBatchTelluSupportQuery,
        CameraProvisioningBatchTelluSupportQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          CameraProvisioningBatchTelluSupportQuery,
          CameraProvisioningBatchTelluSupportQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          CameraProvisioningBatchTelluSupportQuery,
          CameraProvisioningBatchTelluSupportQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    CameraProvisioningBatchTelluSupportQuery,
    CameraProvisioningBatchTelluSupportQueryVariables
  >(CameraProvisioningBatchTelluSupportDocument, {}, options);
}
export function useCameraProvisioningBatchTelluSupportLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        CameraProvisioningBatchTelluSupportQuery,
        CameraProvisioningBatchTelluSupportQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          CameraProvisioningBatchTelluSupportQuery,
          CameraProvisioningBatchTelluSupportQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          CameraProvisioningBatchTelluSupportQuery,
          CameraProvisioningBatchTelluSupportQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    CameraProvisioningBatchTelluSupportQuery,
    CameraProvisioningBatchTelluSupportQueryVariables
  >(CameraProvisioningBatchTelluSupportDocument, {}, options);
}
export type CameraProvisioningBatchTelluSupportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CameraProvisioningBatchTelluSupportQuery,
  CameraProvisioningBatchTelluSupportQueryVariables
>;
export const CameraSetupDocument = gql`
  query cameraSetup {
    deviceGroups {
      id
      name
    }
    morpheanSitesPerMorpheanCustomerTelluSupport {
      customerId
      customerName
      morpheanSites {
        siteId
        siteName
      }
    }
    supportedCameraModelsTelluSupport {
      model
      apps {
        id
        name
        version
        supportedModels
        default
      }
    }
  }
`;

/**
 * __useCameraSetupQuery__
 *
 * To run a query within a Vue component, call `useCameraSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCameraSetupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCameraSetupQuery();
 */
export function useCameraSetupQuery(
  options:
    | VueApolloComposable.UseQueryOptions<CameraSetupQuery, CameraSetupQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CameraSetupQuery, CameraSetupQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CameraSetupQuery, CameraSetupQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<CameraSetupQuery, CameraSetupQueryVariables>(CameraSetupDocument, {}, options);
}
export function useCameraSetupLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<CameraSetupQuery, CameraSetupQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CameraSetupQuery, CameraSetupQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CameraSetupQuery, CameraSetupQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<CameraSetupQuery, CameraSetupQueryVariables>(
    CameraSetupDocument,
    {},
    options,
  );
}
export type CameraSetupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CameraSetupQuery,
  CameraSetupQueryVariables
>;
export const SupportedCameraAppsDocument = gql`
  query supportedCameraApps {
    supportedCameraApps {
      id
      name
      version
      supportedModels
      default
    }
  }
`;

/**
 * __useSupportedCameraAppsQuery__
 *
 * To run a query within a Vue component, call `useSupportedCameraAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportedCameraAppsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSupportedCameraAppsQuery();
 */
export function useSupportedCameraAppsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>(
    SupportedCameraAppsDocument,
    {},
    options,
  );
}
export function useSupportedCameraAppsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<SupportedCameraAppsQuery, SupportedCameraAppsQueryVariables>(
    SupportedCameraAppsDocument,
    {},
    options,
  );
}
export type SupportedCameraAppsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  SupportedCameraAppsQuery,
  SupportedCameraAppsQueryVariables
>;
export const GetCameraManagementListDocument = gql`
  query getCameraManagementList {
    getCameraManagementList {
      id
      name
      macAddress
      model
      arch
      soc
      firmware
      latestFirmware
      deviceGroupId
      deviceGroup
      inRegistry
      inAccount
      isAttachedToPatient
      inMorphean
      connectedToMorphean
      lastSeen
      routerVendor
      routerMac
      mqttConfig {
        url
        state
        connectionStatus
      }
      time {
        timezone
        obtainFromDHCP
      }
      apps {
        id
        name
        version
        latestVersion
        status
        profileCount
      }
      network {
        bonjour
        dot1x
        ftp
        ssh
        upnp
        zeroConf
        allowOldTLS
        https
        bandwidthLimit
        isHardened
      }
      audio {
        enabled
        audioSupported
        inputGain
        inputType
        microphonePowerType
        microphonePowered
      }
      ptz {
        enabled
        locked
        returnToOverviewawait
      }
      video {
        enabled
        rtsp
        compression
        mirrored
        resolution
        rotation
        iCount
        pCount
        rateControlPriority
        targetBitRate
        fps
        captureFrequency
        exposureMode
        whiteBalanceMode
        dayNight {
          cutFilterMode
          shiftLevel
          manualIrOverriden
        }
      }
    }
  }
`;

/**
 * __useGetCameraManagementListQuery__
 *
 * To run a query within a Vue component, call `useGetCameraManagementListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraManagementListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraManagementListQuery();
 */
export function useGetCameraManagementListQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>(
    GetCameraManagementListDocument,
    {},
    options,
  );
}
export function useGetCameraManagementListLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraManagementListQuery, GetCameraManagementListQueryVariables>(
    GetCameraManagementListDocument,
    {},
    options,
  );
}
export type GetCameraManagementListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraManagementListQuery,
  GetCameraManagementListQueryVariables
>;
export const HealthProviderSettingsDocument = gql`
  query healthProviderSettings {
    healthProviderSettings {
      patientAuth {
        twoFactorSms
        ipRestriction
        timeLimitedAccess
        externalIdP {
          alias
          displayName
          enabled
          usernamePolicy
          default
          support
        }
      }
      userAuth {
        twoFactorSms
        ipRestriction
        timeLimitedAccess
        externalIdP {
          alias
          displayName
          enabled
          usernamePolicy
          default
          support
        }
      }
      externalHumanIdTypes {
        id
        use {
          patientUse {
            applicable
            immutable
          }
          personnelUse {
            applicable
          }
        }
      }
    }
  }
`;

/**
 * __useHealthProviderSettingsQuery__
 *
 * To run a query within a Vue component, call `useHealthProviderSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthProviderSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHealthProviderSettingsQuery();
 */
export function useHealthProviderSettingsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>(
    HealthProviderSettingsDocument,
    {},
    options,
  );
}
export function useHealthProviderSettingsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<HealthProviderSettingsQuery, HealthProviderSettingsQueryVariables>(
    HealthProviderSettingsDocument,
    {},
    options,
  );
}
export type HealthProviderSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  HealthProviderSettingsQuery,
  HealthProviderSettingsQueryVariables
>;
export const GetAuditEntitySummaryDocument = gql`
  query getAuditEntitySummary($from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getAuditEntitySummary(from: $from, to: $to, actions: $actions) {
      entityType
      count
    }
  }
`;

/**
 * __useGetAuditEntitySummaryQuery__
 *
 * To run a query within a Vue component, call `useGetAuditEntitySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditEntitySummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditEntitySummaryQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetAuditEntitySummaryQuery(
  variables:
    | GetAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetAuditEntitySummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>(
    GetAuditEntitySummaryDocument,
    variables,
    options,
  );
}
export function useGetAuditEntitySummaryLazyQuery(
  variables:
    | GetAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetAuditEntitySummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAuditEntitySummaryQuery, GetAuditEntitySummaryQueryVariables>(
    GetAuditEntitySummaryDocument,
    variables,
    options,
  );
}
export type GetAuditEntitySummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditEntitySummaryQuery,
  GetAuditEntitySummaryQueryVariables
>;
export const GetAuditLogPaginatedDocument = gql`
  query getAuditLogPaginated(
    $from: dateTime
    $to: dateTime
    $limit: Int
    $cursor: cursor
    $actions: [AuditEventAction!]
    $entityTypes: [String!]
    $operations: [AuditLogOperationSelector!]
  ) {
    getAuditLogPaginated(
      from: $from
      to: $to
      limit: $limit
      cursor: $cursor
      actions: $actions
      entityTypes: $entityTypes
      operations: $operations
    ) {
      cursor
      events {
        id
        action
        recorded
        outcome
        outcomeDesc
        agent {
          requestor
          name
          role {
            text
          }
          who {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          altId
          network {
            type
            address
          }
        }
        source {
          observer {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
        }
        entity {
          what {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          role {
            display
          }
          name
          detail {
            type
            valueString
          }
        }
        session
        operation
        patientName
        userName
      }
    }
  }
`;

/**
 * __useGetAuditLogPaginatedQuery__
 *
 * To run a query within a Vue component, call `useGetAuditLogPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditLogPaginatedQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 *   actions: // value for 'actions'
 *   entityTypes: // value for 'entityTypes'
 *   operations: // value for 'operations'
 * });
 */
export function useGetAuditLogPaginatedQuery(
  variables:
    | GetAuditLogPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAuditLogPaginatedQueryVariables>
    | ReactiveFunction<GetAuditLogPaginatedQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>(
    GetAuditLogPaginatedDocument,
    variables,
    options,
  );
}
export function useGetAuditLogPaginatedLazyQuery(
  variables:
    | GetAuditLogPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAuditLogPaginatedQueryVariables>
    | ReactiveFunction<GetAuditLogPaginatedQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAuditLogPaginatedQuery, GetAuditLogPaginatedQueryVariables>(
    GetAuditLogPaginatedDocument,
    variables,
    options,
  );
}
export type GetAuditLogPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditLogPaginatedQuery,
  GetAuditLogPaginatedQueryVariables
>;
export const GetAuditLogEventForPatientByIdDocument = gql`
  query getAuditLogEventForPatientById($id: ID!, $patientId: ID!) {
    getAuditLogEventForPatientById(id: $id, patientId: $patientId) {
      id
      action
      recorded
      outcome
      outcomeDesc
      agent {
        name
      }
      entity {
        what {
          reference
          identifier {
            value
          }
          type
          display
        }
        role {
          system
          version
          code
          display
          userSelected
        }
        name
        detail {
          type
          valueString
        }
      }
      session
      operation
      patientName
      userName
    }
  }
`;

/**
 * __useGetAuditLogEventForPatientByIdQuery__
 *
 * To run a query within a Vue component, call `useGetAuditLogEventForPatientByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogEventForPatientByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditLogEventForPatientByIdQuery({
 *   id: // value for 'id'
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetAuditLogEventForPatientByIdQuery(
  variables:
    | GetAuditLogEventForPatientByIdQueryVariables
    | VueCompositionApi.Ref<GetAuditLogEventForPatientByIdQueryVariables>
    | ReactiveFunction<GetAuditLogEventForPatientByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAuditLogEventForPatientByIdQuery,
        GetAuditLogEventForPatientByIdQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForPatientByIdQuery,
          GetAuditLogEventForPatientByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForPatientByIdQuery,
          GetAuditLogEventForPatientByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAuditLogEventForPatientByIdQuery,
    GetAuditLogEventForPatientByIdQueryVariables
  >(GetAuditLogEventForPatientByIdDocument, variables, options);
}
export function useGetAuditLogEventForPatientByIdLazyQuery(
  variables?:
    | GetAuditLogEventForPatientByIdQueryVariables
    | VueCompositionApi.Ref<GetAuditLogEventForPatientByIdQueryVariables>
    | ReactiveFunction<GetAuditLogEventForPatientByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAuditLogEventForPatientByIdQuery,
        GetAuditLogEventForPatientByIdQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForPatientByIdQuery,
          GetAuditLogEventForPatientByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForPatientByIdQuery,
          GetAuditLogEventForPatientByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAuditLogEventForPatientByIdQuery,
    GetAuditLogEventForPatientByIdQueryVariables
  >(GetAuditLogEventForPatientByIdDocument, variables, options);
}
export type GetAuditLogEventForPatientByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditLogEventForPatientByIdQuery,
  GetAuditLogEventForPatientByIdQueryVariables
>;
export const GetAuditLogEventForUserGroupByIdDocument = gql`
  query getAuditLogEventForUserGroupById($id: ID!, $userGroupId: ID!) {
    getAuditLogEventForUserGroupById(id: $id, userGroupId: $userGroupId) {
      id
      action
      recorded
      outcome
      outcomeDesc
      agent {
        name
      }
      entity {
        what {
          reference
          identifier {
            value
          }
          type
          display
        }
        type {
          system
          version
          code
          display
          userSelected
        }
        role {
          system
          version
          code
          display
          userSelected
        }
        name
        detail {
          type
          valueString
        }
      }
      session
      operation
      patientName
      userName
    }
  }
`;

/**
 * __useGetAuditLogEventForUserGroupByIdQuery__
 *
 * To run a query within a Vue component, call `useGetAuditLogEventForUserGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogEventForUserGroupByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditLogEventForUserGroupByIdQuery({
 *   id: // value for 'id'
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useGetAuditLogEventForUserGroupByIdQuery(
  variables:
    | GetAuditLogEventForUserGroupByIdQueryVariables
    | VueCompositionApi.Ref<GetAuditLogEventForUserGroupByIdQueryVariables>
    | ReactiveFunction<GetAuditLogEventForUserGroupByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAuditLogEventForUserGroupByIdQuery,
        GetAuditLogEventForUserGroupByIdQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForUserGroupByIdQuery,
          GetAuditLogEventForUserGroupByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForUserGroupByIdQuery,
          GetAuditLogEventForUserGroupByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAuditLogEventForUserGroupByIdQuery,
    GetAuditLogEventForUserGroupByIdQueryVariables
  >(GetAuditLogEventForUserGroupByIdDocument, variables, options);
}
export function useGetAuditLogEventForUserGroupByIdLazyQuery(
  variables?:
    | GetAuditLogEventForUserGroupByIdQueryVariables
    | VueCompositionApi.Ref<GetAuditLogEventForUserGroupByIdQueryVariables>
    | ReactiveFunction<GetAuditLogEventForUserGroupByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAuditLogEventForUserGroupByIdQuery,
        GetAuditLogEventForUserGroupByIdQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForUserGroupByIdQuery,
          GetAuditLogEventForUserGroupByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogEventForUserGroupByIdQuery,
          GetAuditLogEventForUserGroupByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAuditLogEventForUserGroupByIdQuery,
    GetAuditLogEventForUserGroupByIdQueryVariables
  >(GetAuditLogEventForUserGroupByIdDocument, variables, options);
}
export type GetAuditLogEventForUserGroupByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditLogEventForUserGroupByIdQuery,
  GetAuditLogEventForUserGroupByIdQueryVariables
>;
export const GetAuditLogForPatientPaginatedDocument = gql`
  query getAuditLogForPatientPaginated(
    $patientId: ID!
    $from: dateTime
    $to: dateTime
    $limit: Int
    $cursor: cursor
    $actions: [AuditEventAction!]
    $operations: [AuditLogOperationSelector!]
  ) {
    getAuditLogForPatientPaginated(
      patientId: $patientId
      from: $from
      to: $to
      limit: $limit
      cursor: $cursor
      actions: $actions
      operations: $operations
    ) {
      cursor
      events {
        id
        action
        recorded
        outcome
        outcomeDesc
        agent {
          requestor
          name
          role {
            text
          }
          who {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          altId
          network {
            type
            address
          }
        }
        source {
          observer {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
        }
        entity {
          what {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          role {
            display
          }
          name
          detail {
            type
            valueString
          }
        }
        session
        operation
        patientName
        userName
      }
    }
  }
`;

/**
 * __useGetAuditLogForPatientPaginatedQuery__
 *
 * To run a query within a Vue component, call `useGetAuditLogForPatientPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogForPatientPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditLogForPatientPaginatedQuery({
 *   patientId: // value for 'patientId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 *   actions: // value for 'actions'
 *   operations: // value for 'operations'
 * });
 */
export function useGetAuditLogForPatientPaginatedQuery(
  variables:
    | GetAuditLogForPatientPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAuditLogForPatientPaginatedQueryVariables>
    | ReactiveFunction<GetAuditLogForPatientPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAuditLogForPatientPaginatedQuery,
        GetAuditLogForPatientPaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogForPatientPaginatedQuery,
          GetAuditLogForPatientPaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogForPatientPaginatedQuery,
          GetAuditLogForPatientPaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAuditLogForPatientPaginatedQuery,
    GetAuditLogForPatientPaginatedQueryVariables
  >(GetAuditLogForPatientPaginatedDocument, variables, options);
}
export function useGetAuditLogForPatientPaginatedLazyQuery(
  variables?:
    | GetAuditLogForPatientPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAuditLogForPatientPaginatedQueryVariables>
    | ReactiveFunction<GetAuditLogForPatientPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAuditLogForPatientPaginatedQuery,
        GetAuditLogForPatientPaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogForPatientPaginatedQuery,
          GetAuditLogForPatientPaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAuditLogForPatientPaginatedQuery,
          GetAuditLogForPatientPaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAuditLogForPatientPaginatedQuery,
    GetAuditLogForPatientPaginatedQueryVariables
  >(GetAuditLogForPatientPaginatedDocument, variables, options);
}
export type GetAuditLogForPatientPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditLogForPatientPaginatedQuery,
  GetAuditLogForPatientPaginatedQueryVariables
>;
export const GetAuditLogForUserPaginatedDocument = gql`
  query getAuditLogForUserPaginated(
    $userId: ID!
    $from: dateTime
    $to: dateTime
    $limit: Int
    $cursor: cursor
    $actions: [AuditEventAction!]
    $entityTypes: [String!]
    $operations: [AuditLogOperationSelector!]
  ) {
    getAuditLogForUserPaginated(
      userId: $userId
      from: $from
      to: $to
      limit: $limit
      cursor: $cursor
      actions: $actions
      entityTypes: $entityTypes
      operations: $operations
    ) {
      cursor
      events {
        id
        action
        recorded
        outcome
        outcomeDesc
        agent {
          requestor
          name
          role {
            text
          }
          who {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          altId
          network {
            type
            address
          }
        }
        source {
          observer {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
        }
        entity {
          what {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          role {
            display
          }
          name
          detail {
            type
            valueString
          }
        }
        session
        operation
        patientName
        userName
      }
    }
  }
`;

/**
 * __useGetAuditLogForUserPaginatedQuery__
 *
 * To run a query within a Vue component, call `useGetAuditLogForUserPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogForUserPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditLogForUserPaginatedQuery({
 *   userId: // value for 'userId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 *   actions: // value for 'actions'
 *   entityTypes: // value for 'entityTypes'
 *   operations: // value for 'operations'
 * });
 */
export function useGetAuditLogForUserPaginatedQuery(
  variables:
    | GetAuditLogForUserPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAuditLogForUserPaginatedQueryVariables>
    | ReactiveFunction<GetAuditLogForUserPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>(
    GetAuditLogForUserPaginatedDocument,
    variables,
    options,
  );
}
export function useGetAuditLogForUserPaginatedLazyQuery(
  variables?:
    | GetAuditLogForUserPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAuditLogForUserPaginatedQueryVariables>
    | ReactiveFunction<GetAuditLogForUserPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAuditLogForUserPaginatedQuery, GetAuditLogForUserPaginatedQueryVariables>(
    GetAuditLogForUserPaginatedDocument,
    variables,
    options,
  );
}
export type GetAuditLogForUserPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditLogForUserPaginatedQuery,
  GetAuditLogForUserPaginatedQueryVariables
>;
export const GetAuditLogSummaryDocument = gql`
  query getAuditLogSummary($from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getAuditLogSummary(from: $from, to: $to, actions: $actions) {
      operation
      outcome
      count
    }
  }
`;

/**
 * __useGetAuditLogSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetAuditLogSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditLogSummaryQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetAuditLogSummaryQuery(
  variables:
    | GetAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetAuditLogSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>(
    GetAuditLogSummaryDocument,
    variables,
    options,
  );
}
export function useGetAuditLogSummaryLazyQuery(
  variables:
    | GetAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetAuditLogSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAuditLogSummaryQuery, GetAuditLogSummaryQueryVariables>(
    GetAuditLogSummaryDocument,
    variables,
    options,
  );
}
export type GetAuditLogSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditLogSummaryQuery,
  GetAuditLogSummaryQueryVariables
>;
export const GetAuditRoleSummaryDocument = gql`
  query getAuditRoleSummary($from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getAuditRoleSummary(from: $from, to: $to, actions: $actions) {
      operation
      role
      count
    }
  }
`;

/**
 * __useGetAuditRoleSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetAuditRoleSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditRoleSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditRoleSummaryQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetAuditRoleSummaryQuery(
  variables:
    | GetAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetAuditRoleSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>(
    GetAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export function useGetAuditRoleSummaryLazyQuery(
  variables:
    | GetAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetAuditRoleSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAuditRoleSummaryQuery, GetAuditRoleSummaryQueryVariables>(
    GetAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export type GetAuditRoleSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditRoleSummaryQuery,
  GetAuditRoleSummaryQueryVariables
>;
export const GetOwnerAuditEntitySummaryDocument = gql`
  query getOwnerAuditEntitySummary($from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getOwnerAuditEntitySummary(from: $from, to: $to, actions: $actions) {
      entityType
      count
    }
  }
`;

/**
 * __useGetOwnerAuditEntitySummaryQuery__
 *
 * To run a query within a Vue component, call `useGetOwnerAuditEntitySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerAuditEntitySummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOwnerAuditEntitySummaryQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetOwnerAuditEntitySummaryQuery(
  variables:
    | GetOwnerAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetOwnerAuditEntitySummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>(
    GetOwnerAuditEntitySummaryDocument,
    variables,
    options,
  );
}
export function useGetOwnerAuditEntitySummaryLazyQuery(
  variables:
    | GetOwnerAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetOwnerAuditEntitySummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOwnerAuditEntitySummaryQuery, GetOwnerAuditEntitySummaryQueryVariables>(
    GetOwnerAuditEntitySummaryDocument,
    variables,
    options,
  );
}
export type GetOwnerAuditEntitySummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOwnerAuditEntitySummaryQuery,
  GetOwnerAuditEntitySummaryQueryVariables
>;
export const GetOwnerAuditLogPaginatedDocument = gql`
  query getOwnerAuditLogPaginated(
    $from: dateTime
    $to: dateTime
    $limit: Int
    $cursor: cursor
    $actions: [AuditEventAction!]
    $entityTypes: [String!]
    $operations: [AuditLogOperationSelector!]
  ) {
    getOwnerAuditLogPaginated(
      from: $from
      to: $to
      limit: $limit
      cursor: $cursor
      actions: $actions
      entityTypes: $entityTypes
      operations: $operations
    ) {
      cursor
      events {
        id
        type {
          code
        }
        action
        period {
          start
          end
        }
        recorded
        outcome
        outcomeDesc
        agent {
          requestor
          name
          role {
            text
          }
          who {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          altId
          network {
            type
            address
          }
        }
        source {
          observer {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
        }
        entity {
          what {
            reference
            identifier {
              system
              use
              value
              type {
                coding {
                  system
                  version
                  code
                  display
                  userSelected
                }
                text
              }
            }
            type
            display
          }
          role {
            display
          }
          name
          detail {
            type
            valueString
          }
        }
        session
        operation
        patientName
        userName
      }
    }
  }
`;

/**
 * __useGetOwnerAuditLogPaginatedQuery__
 *
 * To run a query within a Vue component, call `useGetOwnerAuditLogPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerAuditLogPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOwnerAuditLogPaginatedQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 *   actions: // value for 'actions'
 *   entityTypes: // value for 'entityTypes'
 *   operations: // value for 'operations'
 * });
 */
export function useGetOwnerAuditLogPaginatedQuery(
  variables:
    | GetOwnerAuditLogPaginatedQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditLogPaginatedQueryVariables>
    | ReactiveFunction<GetOwnerAuditLogPaginatedQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>(
    GetOwnerAuditLogPaginatedDocument,
    variables,
    options,
  );
}
export function useGetOwnerAuditLogPaginatedLazyQuery(
  variables:
    | GetOwnerAuditLogPaginatedQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditLogPaginatedQueryVariables>
    | ReactiveFunction<GetOwnerAuditLogPaginatedQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOwnerAuditLogPaginatedQuery, GetOwnerAuditLogPaginatedQueryVariables>(
    GetOwnerAuditLogPaginatedDocument,
    variables,
    options,
  );
}
export type GetOwnerAuditLogPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOwnerAuditLogPaginatedQuery,
  GetOwnerAuditLogPaginatedQueryVariables
>;
export const GetOwnerAuditLogSummaryDocument = gql`
  query getOwnerAuditLogSummary($from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getOwnerAuditLogSummary(from: $from, to: $to, actions: $actions) {
      operation
      outcome
      count
    }
  }
`;

/**
 * __useGetOwnerAuditLogSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetOwnerAuditLogSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerAuditLogSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOwnerAuditLogSummaryQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetOwnerAuditLogSummaryQuery(
  variables:
    | GetOwnerAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetOwnerAuditLogSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>(
    GetOwnerAuditLogSummaryDocument,
    variables,
    options,
  );
}
export function useGetOwnerAuditLogSummaryLazyQuery(
  variables:
    | GetOwnerAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetOwnerAuditLogSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOwnerAuditLogSummaryQuery, GetOwnerAuditLogSummaryQueryVariables>(
    GetOwnerAuditLogSummaryDocument,
    variables,
    options,
  );
}
export type GetOwnerAuditLogSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOwnerAuditLogSummaryQuery,
  GetOwnerAuditLogSummaryQueryVariables
>;
export const GetOwnerAuditRoleSummaryDocument = gql`
  query getOwnerAuditRoleSummary($from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getOwnerAuditRoleSummary(from: $from, to: $to, actions: $actions) {
      operation
      role
      count
    }
  }
`;

/**
 * __useGetOwnerAuditRoleSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetOwnerAuditRoleSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerAuditRoleSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOwnerAuditRoleSummaryQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetOwnerAuditRoleSummaryQuery(
  variables:
    | GetOwnerAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetOwnerAuditRoleSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>(
    GetOwnerAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export function useGetOwnerAuditRoleSummaryLazyQuery(
  variables:
    | GetOwnerAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetOwnerAuditRoleSummaryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOwnerAuditRoleSummaryQuery, GetOwnerAuditRoleSummaryQueryVariables>(
    GetOwnerAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export type GetOwnerAuditRoleSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOwnerAuditRoleSummaryQuery,
  GetOwnerAuditRoleSummaryQueryVariables
>;
export const GetPatientAuditEntitySummaryDocument = gql`
  query getPatientAuditEntitySummary($patientId: ID!, $from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getPatientAuditEntitySummary(patientId: $patientId, from: $from, to: $to, actions: $actions) {
      entityType
      count
    }
  }
`;

/**
 * __useGetPatientAuditEntitySummaryQuery__
 *
 * To run a query within a Vue component, call `useGetPatientAuditEntitySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientAuditEntitySummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientAuditEntitySummaryQuery({
 *   patientId: // value for 'patientId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetPatientAuditEntitySummaryQuery(
  variables:
    | GetPatientAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetPatientAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetPatientAuditEntitySummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientAuditEntitySummaryQuery, GetPatientAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPatientAuditEntitySummaryQuery,
          GetPatientAuditEntitySummaryQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPatientAuditEntitySummaryQuery,
          GetPatientAuditEntitySummaryQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientAuditEntitySummaryQuery, GetPatientAuditEntitySummaryQueryVariables>(
    GetPatientAuditEntitySummaryDocument,
    variables,
    options,
  );
}
export function useGetPatientAuditEntitySummaryLazyQuery(
  variables?:
    | GetPatientAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetPatientAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetPatientAuditEntitySummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientAuditEntitySummaryQuery, GetPatientAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPatientAuditEntitySummaryQuery,
          GetPatientAuditEntitySummaryQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPatientAuditEntitySummaryQuery,
          GetPatientAuditEntitySummaryQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetPatientAuditEntitySummaryQuery,
    GetPatientAuditEntitySummaryQueryVariables
  >(GetPatientAuditEntitySummaryDocument, variables, options);
}
export type GetPatientAuditEntitySummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientAuditEntitySummaryQuery,
  GetPatientAuditEntitySummaryQueryVariables
>;
export const GetPatientAuditLogSummaryDocument = gql`
  query getPatientAuditLogSummary($patientId: ID!, $from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getPatientAuditLogSummary(patientId: $patientId, from: $from, to: $to, actions: $actions) {
      operation
      outcome
      count
    }
  }
`;

/**
 * __useGetPatientAuditLogSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetPatientAuditLogSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientAuditLogSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientAuditLogSummaryQuery({
 *   patientId: // value for 'patientId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetPatientAuditLogSummaryQuery(
  variables:
    | GetPatientAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetPatientAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetPatientAuditLogSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>(
    GetPatientAuditLogSummaryDocument,
    variables,
    options,
  );
}
export function useGetPatientAuditLogSummaryLazyQuery(
  variables?:
    | GetPatientAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetPatientAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetPatientAuditLogSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientAuditLogSummaryQuery, GetPatientAuditLogSummaryQueryVariables>(
    GetPatientAuditLogSummaryDocument,
    variables,
    options,
  );
}
export type GetPatientAuditLogSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientAuditLogSummaryQuery,
  GetPatientAuditLogSummaryQueryVariables
>;
export const GetPatientAuditRoleSummaryDocument = gql`
  query getPatientAuditRoleSummary($patientId: ID!, $from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getPatientAuditRoleSummary(patientId: $patientId, from: $from, to: $to, actions: $actions) {
      operation
      role
      count
    }
  }
`;

/**
 * __useGetPatientAuditRoleSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetPatientAuditRoleSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientAuditRoleSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientAuditRoleSummaryQuery({
 *   patientId: // value for 'patientId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetPatientAuditRoleSummaryQuery(
  variables:
    | GetPatientAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetPatientAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetPatientAuditRoleSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>(
    GetPatientAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export function useGetPatientAuditRoleSummaryLazyQuery(
  variables?:
    | GetPatientAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetPatientAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetPatientAuditRoleSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientAuditRoleSummaryQuery, GetPatientAuditRoleSummaryQueryVariables>(
    GetPatientAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export type GetPatientAuditRoleSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientAuditRoleSummaryQuery,
  GetPatientAuditRoleSummaryQueryVariables
>;
export const GetUserAuditEntitySummaryDocument = gql`
  query getUserAuditEntitySummary($userId: ID!, $from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getUserAuditEntitySummary(userId: $userId, from: $from, to: $to, actions: $actions) {
      entityType
      count
    }
  }
`;

/**
 * __useGetUserAuditEntitySummaryQuery__
 *
 * To run a query within a Vue component, call `useGetUserAuditEntitySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAuditEntitySummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserAuditEntitySummaryQuery({
 *   userId: // value for 'userId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetUserAuditEntitySummaryQuery(
  variables:
    | GetUserAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetUserAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetUserAuditEntitySummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>(
    GetUserAuditEntitySummaryDocument,
    variables,
    options,
  );
}
export function useGetUserAuditEntitySummaryLazyQuery(
  variables?:
    | GetUserAuditEntitySummaryQueryVariables
    | VueCompositionApi.Ref<GetUserAuditEntitySummaryQueryVariables>
    | ReactiveFunction<GetUserAuditEntitySummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetUserAuditEntitySummaryQuery, GetUserAuditEntitySummaryQueryVariables>(
    GetUserAuditEntitySummaryDocument,
    variables,
    options,
  );
}
export type GetUserAuditEntitySummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetUserAuditEntitySummaryQuery,
  GetUserAuditEntitySummaryQueryVariables
>;
export const GetUserAuditLogSummaryDocument = gql`
  query getUserAuditLogSummary($userId: ID!, $from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getUserAuditLogSummary(userId: $userId, from: $from, to: $to, actions: $actions) {
      operation
      outcome
      count
    }
  }
`;

/**
 * __useGetUserAuditLogSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetUserAuditLogSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAuditLogSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserAuditLogSummaryQuery({
 *   userId: // value for 'userId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetUserAuditLogSummaryQuery(
  variables:
    | GetUserAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetUserAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetUserAuditLogSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>(
    GetUserAuditLogSummaryDocument,
    variables,
    options,
  );
}
export function useGetUserAuditLogSummaryLazyQuery(
  variables?:
    | GetUserAuditLogSummaryQueryVariables
    | VueCompositionApi.Ref<GetUserAuditLogSummaryQueryVariables>
    | ReactiveFunction<GetUserAuditLogSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetUserAuditLogSummaryQuery, GetUserAuditLogSummaryQueryVariables>(
    GetUserAuditLogSummaryDocument,
    variables,
    options,
  );
}
export type GetUserAuditLogSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetUserAuditLogSummaryQuery,
  GetUserAuditLogSummaryQueryVariables
>;
export const GetUserAuditRoleSummaryDocument = gql`
  query getUserAuditRoleSummary($userId: ID!, $from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getUserAuditRoleSummary(userId: $userId, from: $from, to: $to, actions: $actions) {
      operation
      role
      count
    }
  }
`;

/**
 * __useGetUserAuditRoleSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetUserAuditRoleSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAuditRoleSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserAuditRoleSummaryQuery({
 *   userId: // value for 'userId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetUserAuditRoleSummaryQuery(
  variables:
    | GetUserAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetUserAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetUserAuditRoleSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>(
    GetUserAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export function useGetUserAuditRoleSummaryLazyQuery(
  variables?:
    | GetUserAuditRoleSummaryQueryVariables
    | VueCompositionApi.Ref<GetUserAuditRoleSummaryQueryVariables>
    | ReactiveFunction<GetUserAuditRoleSummaryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetUserAuditRoleSummaryQuery, GetUserAuditRoleSummaryQueryVariables>(
    GetUserAuditRoleSummaryDocument,
    variables,
    options,
  );
}
export type GetUserAuditRoleSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetUserAuditRoleSummaryQuery,
  GetUserAuditRoleSummaryQueryVariables
>;
export const AllShiftSessionsDocument = gql`
  query allShiftSessions {
    allShiftSessions {
      user {
        id
        firstName
        lastName
        username
      }
      session {
        patientGroupIdsAndNames {
          id
          name
        }
        notificationSettings {
          sendEmail
          sendSms
          locale
        }
        pushNotificationSettings {
          type
          device
          createdAt
        }
        createdAt
        lastUpdated
      }
    }
  }
`;

/**
 * __useAllShiftSessionsQuery__
 *
 * To run a query within a Vue component, call `useAllShiftSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllShiftSessionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllShiftSessionsQuery();
 */
export function useAllShiftSessionsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>(
    AllShiftSessionsDocument,
    {},
    options,
  );
}
export function useAllShiftSessionsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<AllShiftSessionsQuery, AllShiftSessionsQueryVariables>(
    AllShiftSessionsDocument,
    {},
    options,
  );
}
export type AllShiftSessionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AllShiftSessionsQuery,
  AllShiftSessionsQueryVariables
>;
export const GetPatientForCarePlanSimulatorDocument = gql`
  query getPatientForCarePlanSimulator($id: ID!) {
    patient(id: $id) {
      id
      name {
        given
        family
        text
      }
      carePlans {
        id
        status
        subject {
          reference
        }
        title
        description
        created
        period {
          start
          end
        }
        activity {
          detail {
            scheduledTiming {
              event
              repeat {
                dayOfWeek
                timeOfDay
                periodUnit
                period
                boundsPeriod {
                  start
                  end
                }
              }
            }
            scheduledPeriod {
              start
              end
            }
            code {
              coding {
                system
                version
                code
                display
              }
              text
            }
            questionnaires {
              id
              name
              title
              purpose
              status
              publisher
              description
              effectivePeriod {
                end
                start
              }
              item {
                linkId
                text
                type
                answerOption {
                  valueBoolean
                  valueInteger
                  valueString
                  valueDecimal
                  valueCoding {
                    code
                    display
                  }
                }
                required
              }
            }
          }
          outcomeReference {
            reference
            identifier {
              value
            }
            display
            type
          }
          observations {
            id
            identifier {
              value
            }
            text
            basedOn {
              reference
            }
            status
            note {
              text
            }
            fromTemplate {
              reference
            }
            code {
              coding {
                system
                version
                code
                display
              }
              text
            }
            component {
              code {
                coding {
                  system
                  version
                  code
                  display
                }
                text
              }
              valueQuantity {
                value
                unit
              }
              referenceRange {
                low {
                  value
                  unit
                }
                high {
                  value
                  unit
                }
                text
                type {
                  coding {
                    system
                    version
                    code
                    display
                  }
                  text
                }
              }
            }
          }
        }
      }
      referenceRange {
        id
        identifier {
          value
        }
        code {
          text
          coding {
            code
            display
          }
        }
        component {
          code {
            text
            coding {
              code
              display
            }
          }
          referenceRange {
            low {
              unit
              value
            }
            high {
              unit
              value
            }
            type {
              text
              coding {
                code
                display
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetPatientForCarePlanSimulatorQuery__
 *
 * To run a query within a Vue component, call `useGetPatientForCarePlanSimulatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientForCarePlanSimulatorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientForCarePlanSimulatorQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPatientForCarePlanSimulatorQuery(
  variables:
    | GetPatientForCarePlanSimulatorQueryVariables
    | VueCompositionApi.Ref<GetPatientForCarePlanSimulatorQueryVariables>
    | ReactiveFunction<GetPatientForCarePlanSimulatorQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetPatientForCarePlanSimulatorQuery,
        GetPatientForCarePlanSimulatorQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPatientForCarePlanSimulatorQuery,
          GetPatientForCarePlanSimulatorQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPatientForCarePlanSimulatorQuery,
          GetPatientForCarePlanSimulatorQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetPatientForCarePlanSimulatorQuery,
    GetPatientForCarePlanSimulatorQueryVariables
  >(GetPatientForCarePlanSimulatorDocument, variables, options);
}
export function useGetPatientForCarePlanSimulatorLazyQuery(
  variables?:
    | GetPatientForCarePlanSimulatorQueryVariables
    | VueCompositionApi.Ref<GetPatientForCarePlanSimulatorQueryVariables>
    | ReactiveFunction<GetPatientForCarePlanSimulatorQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetPatientForCarePlanSimulatorQuery,
        GetPatientForCarePlanSimulatorQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetPatientForCarePlanSimulatorQuery,
          GetPatientForCarePlanSimulatorQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetPatientForCarePlanSimulatorQuery,
          GetPatientForCarePlanSimulatorQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetPatientForCarePlanSimulatorQuery,
    GetPatientForCarePlanSimulatorQueryVariables
  >(GetPatientForCarePlanSimulatorDocument, variables, options);
}
export type GetPatientForCarePlanSimulatorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientForCarePlanSimulatorQuery,
  GetPatientForCarePlanSimulatorQueryVariables
>;
export const ContinuousSupervisionCandidatesDocument = gql`
  query continuousSupervisionCandidates {
    getContinuousSupervisionCandidates {
      id
      firstName
      lastName
      cameras {
        id
        name
        macAddress
        deviceGroupName
      }
    }
  }
`;

/**
 * __useContinuousSupervisionCandidatesQuery__
 *
 * To run a query within a Vue component, call `useContinuousSupervisionCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContinuousSupervisionCandidatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useContinuousSupervisionCandidatesQuery();
 */
export function useContinuousSupervisionCandidatesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        ContinuousSupervisionCandidatesQuery,
        ContinuousSupervisionCandidatesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ContinuousSupervisionCandidatesQuery,
          ContinuousSupervisionCandidatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ContinuousSupervisionCandidatesQuery,
          ContinuousSupervisionCandidatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    ContinuousSupervisionCandidatesQuery,
    ContinuousSupervisionCandidatesQueryVariables
  >(ContinuousSupervisionCandidatesDocument, {}, options);
}
export function useContinuousSupervisionCandidatesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        ContinuousSupervisionCandidatesQuery,
        ContinuousSupervisionCandidatesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          ContinuousSupervisionCandidatesQuery,
          ContinuousSupervisionCandidatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          ContinuousSupervisionCandidatesQuery,
          ContinuousSupervisionCandidatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    ContinuousSupervisionCandidatesQuery,
    ContinuousSupervisionCandidatesQueryVariables
  >(ContinuousSupervisionCandidatesDocument, {}, options);
}
export type ContinuousSupervisionCandidatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ContinuousSupervisionCandidatesQuery,
  ContinuousSupervisionCandidatesQueryVariables
>;
export const DeviceStatsDocument = gql`
  query deviceStats($from: dateTime, $to: dateTime) {
    deviceStats(from: $from, to: $to) {
      stats {
        timestamp
        technicalAlarms
        technicalAlarmEvents
        deviceType
      }
    }
  }
`;

/**
 * __useDeviceStatsQuery__
 *
 * To run a query within a Vue component, call `useDeviceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDeviceStatsQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useDeviceStatsQuery(
  variables:
    | DeviceStatsQueryVariables
    | VueCompositionApi.Ref<DeviceStatsQueryVariables>
    | ReactiveFunction<DeviceStatsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DeviceStatsQuery, DeviceStatsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeviceStatsQuery, DeviceStatsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeviceStatsQuery, DeviceStatsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<DeviceStatsQuery, DeviceStatsQueryVariables>(
    DeviceStatsDocument,
    variables,
    options,
  );
}
export function useDeviceStatsLazyQuery(
  variables:
    | DeviceStatsQueryVariables
    | VueCompositionApi.Ref<DeviceStatsQueryVariables>
    | ReactiveFunction<DeviceStatsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<DeviceStatsQuery, DeviceStatsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DeviceStatsQuery, DeviceStatsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<DeviceStatsQuery, DeviceStatsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<DeviceStatsQuery, DeviceStatsQueryVariables>(
    DeviceStatsDocument,
    variables,
    options,
  );
}
export type DeviceStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  DeviceStatsQuery,
  DeviceStatsQueryVariables
>;
export const GetCameraListDocument = gql`
  query getCameraList {
    getCameraList {
      id
      name
      model
      serialNumber
      patientId
      patientName
      userHasAccessToPatient
      registeredInInventory
      deviceGroup
      lastSeen
      ttl
      privacyMode
      privacyModeUntil
      topPriorityAlarm {
        priority
      }
    }
  }
`;

/**
 * __useGetCameraListQuery__
 *
 * To run a query within a Vue component, call `useGetCameraListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraListQuery();
 */
export function useGetCameraListQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraListQuery, GetCameraListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraListQuery, GetCameraListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraListQuery, GetCameraListQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetCameraListQuery, GetCameraListQueryVariables>(
    GetCameraListDocument,
    {},
    options,
  );
}
export function useGetCameraListLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraListQuery, GetCameraListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraListQuery, GetCameraListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraListQuery, GetCameraListQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraListQuery, GetCameraListQueryVariables>(
    GetCameraListDocument,
    {},
    options,
  );
}
export type GetCameraListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraListQuery,
  GetCameraListQueryVariables
>;
export const GetEquipmentListDocument = gql`
  query getEquipmentList {
    getEquipmentList {
      id
      createdAt
      identifier
      type
      deviceGroup
      name
      patientId
      patientName
      tags
      topPriorityAlarm {
        priority
      }
      userHasAccessToPatient
      registeredInInventory
      lastSeen
      hasExternalUrl
      lastBatteryStatus
    }
  }
`;

/**
 * __useGetEquipmentListQuery__
 *
 * To run a query within a Vue component, call `useGetEquipmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEquipmentListQuery();
 */
export function useGetEquipmentListQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetEquipmentListQuery, GetEquipmentListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEquipmentListQuery, GetEquipmentListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEquipmentListQuery, GetEquipmentListQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetEquipmentListQuery, GetEquipmentListQueryVariables>(
    GetEquipmentListDocument,
    {},
    options,
  );
}
export function useGetEquipmentListLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetEquipmentListQuery, GetEquipmentListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetEquipmentListQuery, GetEquipmentListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetEquipmentListQuery, GetEquipmentListQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetEquipmentListQuery, GetEquipmentListQueryVariables>(
    GetEquipmentListDocument,
    {},
    options,
  );
}
export type GetEquipmentListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetEquipmentListQuery,
  GetEquipmentListQueryVariables
>;
export const GetAuditLogSummariesDocument = gql`
  query getAuditLogSummaries(
    $from: dateTime
    $to: dateTime
    $actions: [AuditEventAction!]
    $patientId: ID
    $userId: ID
  ) {
    getAuditLogSummaries(from: $from, to: $to, actions: $actions, patientId: $patientId, userId: $userId) {
      auditLogSummary {
        operation
        outcome
        count
      }
      auditEntitySummary {
        entityType
        count
      }
      auditRoleSummary {
        operation
        role
        count
      }
    }
  }
`;

/**
 * __useGetAuditLogSummariesQuery__
 *
 * To run a query within a Vue component, call `useGetAuditLogSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogSummariesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuditLogSummariesQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 *   patientId: // value for 'patientId'
 *   userId: // value for 'userId'
 * });
 */
export function useGetAuditLogSummariesQuery(
  variables:
    | GetAuditLogSummariesQueryVariables
    | VueCompositionApi.Ref<GetAuditLogSummariesQueryVariables>
    | ReactiveFunction<GetAuditLogSummariesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>(
    GetAuditLogSummariesDocument,
    variables,
    options,
  );
}
export function useGetAuditLogSummariesLazyQuery(
  variables:
    | GetAuditLogSummariesQueryVariables
    | VueCompositionApi.Ref<GetAuditLogSummariesQueryVariables>
    | ReactiveFunction<GetAuditLogSummariesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAuditLogSummariesQuery, GetAuditLogSummariesQueryVariables>(
    GetAuditLogSummariesDocument,
    variables,
    options,
  );
}
export type GetAuditLogSummariesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAuditLogSummariesQuery,
  GetAuditLogSummariesQueryVariables
>;
export const GetListOfUnallocatedWelfareDevicesDocument = gql`
  query getListOfUnallocatedWelfareDevices {
    getListOfUnallocatedWelfareDevices {
      id
      uniqueIdentifier
      modelNumber
      userFriendlyName
    }
  }
`;

/**
 * __useGetListOfUnallocatedWelfareDevicesQuery__
 *
 * To run a query within a Vue component, call `useGetListOfUnallocatedWelfareDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListOfUnallocatedWelfareDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetListOfUnallocatedWelfareDevicesQuery();
 */
export function useGetListOfUnallocatedWelfareDevicesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetListOfUnallocatedWelfareDevicesQuery,
        GetListOfUnallocatedWelfareDevicesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedWelfareDevicesQuery,
          GetListOfUnallocatedWelfareDevicesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedWelfareDevicesQuery,
          GetListOfUnallocatedWelfareDevicesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetListOfUnallocatedWelfareDevicesQuery,
    GetListOfUnallocatedWelfareDevicesQueryVariables
  >(GetListOfUnallocatedWelfareDevicesDocument, {}, options);
}
export function useGetListOfUnallocatedWelfareDevicesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetListOfUnallocatedWelfareDevicesQuery,
        GetListOfUnallocatedWelfareDevicesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedWelfareDevicesQuery,
          GetListOfUnallocatedWelfareDevicesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetListOfUnallocatedWelfareDevicesQuery,
          GetListOfUnallocatedWelfareDevicesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetListOfUnallocatedWelfareDevicesQuery,
    GetListOfUnallocatedWelfareDevicesQueryVariables
  >(GetListOfUnallocatedWelfareDevicesDocument, {}, options);
}
export type GetListOfUnallocatedWelfareDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetListOfUnallocatedWelfareDevicesQuery,
  GetListOfUnallocatedWelfareDevicesQueryVariables
>;
export const GetMyPersonalProfileDocument = gql`
  query getMyPersonalProfile {
    getMyPersonalProfile {
      id
      firstName
      lastName
      email
      username
      mobileNumber
      requestedExternalIds {
        externalHumanIdType
        requested
      }
      externalUserIds {
        externalId
        externalHumanIdType {
          id
          localeEntries {
            localeId
            displayName
            description
          }
        }
      }
      lastActive
    }
  }
`;

/**
 * __useGetMyPersonalProfileQuery__
 *
 * To run a query within a Vue component, call `useGetMyPersonalProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPersonalProfileQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyPersonalProfileQuery();
 */
export function useGetMyPersonalProfileQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>(
    GetMyPersonalProfileDocument,
    {},
    options,
  );
}
export function useGetMyPersonalProfileLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetMyPersonalProfileQuery, GetMyPersonalProfileQueryVariables>(
    GetMyPersonalProfileDocument,
    {},
    options,
  );
}
export type GetMyPersonalProfileQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetMyPersonalProfileQuery,
  GetMyPersonalProfileQueryVariables
>;
export const GetMyPersonalProfileForUserDetailsDocument = gql`
  query getMyPersonalProfileForUserDetails {
    getMyPersonalProfile {
      id
      username
      externalUserIds {
        externalId
        externalHumanIdType {
          id
          localeEntries {
            localeId
            displayName
            description
          }
        }
      }
      requestedExternalIds {
        externalHumanIdType
        requested
      }
    }
  }
`;

/**
 * __useGetMyPersonalProfileForUserDetailsQuery__
 *
 * To run a query within a Vue component, call `useGetMyPersonalProfileForUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPersonalProfileForUserDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyPersonalProfileForUserDetailsQuery();
 */
export function useGetMyPersonalProfileForUserDetailsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetMyPersonalProfileForUserDetailsQuery,
        GetMyPersonalProfileForUserDetailsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetMyPersonalProfileForUserDetailsQuery,
          GetMyPersonalProfileForUserDetailsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetMyPersonalProfileForUserDetailsQuery,
          GetMyPersonalProfileForUserDetailsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetMyPersonalProfileForUserDetailsQuery,
    GetMyPersonalProfileForUserDetailsQueryVariables
  >(GetMyPersonalProfileForUserDetailsDocument, {}, options);
}
export function useGetMyPersonalProfileForUserDetailsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetMyPersonalProfileForUserDetailsQuery,
        GetMyPersonalProfileForUserDetailsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetMyPersonalProfileForUserDetailsQuery,
          GetMyPersonalProfileForUserDetailsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetMyPersonalProfileForUserDetailsQuery,
          GetMyPersonalProfileForUserDetailsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetMyPersonalProfileForUserDetailsQuery,
    GetMyPersonalProfileForUserDetailsQueryVariables
  >(GetMyPersonalProfileForUserDetailsDocument, {}, options);
}
export type GetMyPersonalProfileForUserDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetMyPersonalProfileForUserDetailsQuery,
  GetMyPersonalProfileForUserDetailsQueryVariables
>;
export const GetOpenTechnicalAlarmsDocument = gql`
  query getOpenTechnicalAlarms($type: String) {
    getOpenTechnicalAlarms(type: $type) {
      id
      status
      intent
      priority
      authoredOn
      for {
        reference
      }
      description
      lastModified
      owner {
        reference
        display
        identifier {
          value
        }
      }
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        type {
          text
        }
        valueReference {
          reference
          identifier {
            value
          }
          type
          display
        }
        valueString
        timestamp
        icon
        priority
      }
      note {
        authorString
        time
        text
      }
      forDeviceName
      forDeviceType
      syncAlarmDetails {
        userGroupId
      }
      patientLink {
        patientId
        patientName
        userHasAccessToPatient
      }
    }
  }
`;

/**
 * __useGetOpenTechnicalAlarmsQuery__
 *
 * To run a query within a Vue component, call `useGetOpenTechnicalAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenTechnicalAlarmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOpenTechnicalAlarmsQuery({
 *   type: // value for 'type'
 * });
 */
export function useGetOpenTechnicalAlarmsQuery(
  variables:
    | GetOpenTechnicalAlarmsQueryVariables
    | VueCompositionApi.Ref<GetOpenTechnicalAlarmsQueryVariables>
    | ReactiveFunction<GetOpenTechnicalAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>(
    GetOpenTechnicalAlarmsDocument,
    variables,
    options,
  );
}
export function useGetOpenTechnicalAlarmsLazyQuery(
  variables:
    | GetOpenTechnicalAlarmsQueryVariables
    | VueCompositionApi.Ref<GetOpenTechnicalAlarmsQueryVariables>
    | ReactiveFunction<GetOpenTechnicalAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOpenTechnicalAlarmsQuery, GetOpenTechnicalAlarmsQueryVariables>(
    GetOpenTechnicalAlarmsDocument,
    variables,
    options,
  );
}
export type GetOpenTechnicalAlarmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOpenTechnicalAlarmsQuery,
  GetOpenTechnicalAlarmsQueryVariables
>;
export const GetOwnerAuditLogSummariesDocument = gql`
  query getOwnerAuditLogSummaries($from: dateTime, $to: dateTime, $actions: [AuditEventAction!]) {
    getOwnerAuditLogSummaries(from: $from, to: $to, actions: $actions) {
      auditLogSummary {
        operation
        outcome
        count
      }
      auditEntitySummary {
        entityType
        count
      }
      auditRoleSummary {
        operation
        role
        count
      }
    }
  }
`;

/**
 * __useGetOwnerAuditLogSummariesQuery__
 *
 * To run a query within a Vue component, call `useGetOwnerAuditLogSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerAuditLogSummariesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOwnerAuditLogSummariesQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   actions: // value for 'actions'
 * });
 */
export function useGetOwnerAuditLogSummariesQuery(
  variables:
    | GetOwnerAuditLogSummariesQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditLogSummariesQueryVariables>
    | ReactiveFunction<GetOwnerAuditLogSummariesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>(
    GetOwnerAuditLogSummariesDocument,
    variables,
    options,
  );
}
export function useGetOwnerAuditLogSummariesLazyQuery(
  variables:
    | GetOwnerAuditLogSummariesQueryVariables
    | VueCompositionApi.Ref<GetOwnerAuditLogSummariesQueryVariables>
    | ReactiveFunction<GetOwnerAuditLogSummariesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOwnerAuditLogSummariesQuery, GetOwnerAuditLogSummariesQueryVariables>(
    GetOwnerAuditLogSummariesDocument,
    variables,
    options,
  );
}
export type GetOwnerAuditLogSummariesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOwnerAuditLogSummariesQuery,
  GetOwnerAuditLogSummariesQueryVariables
>;
export const GetDeviceByIdFullDocument = gql`
  query getDeviceByIdFull($id: ID!) {
    getWelfareDevice(id: $id) {
      id
      uniqueIdentifier
      deviceName {
        name
        type
      }
      deviceGroup {
        id
      }
      manufacturer
      serialNumber
      modelNumber
      identifier {
        value
      }
      status {
        connected
        lastSeen
      }
      patient {
        reference
      }
    }
  }
`;

/**
 * __useGetDeviceByIdFullQuery__
 *
 * To run a query within a Vue component, call `useGetDeviceByIdFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceByIdFullQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeviceByIdFullQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDeviceByIdFullQuery(
  variables:
    | GetDeviceByIdFullQueryVariables
    | VueCompositionApi.Ref<GetDeviceByIdFullQueryVariables>
    | ReactiveFunction<GetDeviceByIdFullQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>(
    GetDeviceByIdFullDocument,
    variables,
    options,
  );
}
export function useGetDeviceByIdFullLazyQuery(
  variables?:
    | GetDeviceByIdFullQueryVariables
    | VueCompositionApi.Ref<GetDeviceByIdFullQueryVariables>
    | ReactiveFunction<GetDeviceByIdFullQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetDeviceByIdFullQuery, GetDeviceByIdFullQueryVariables>(
    GetDeviceByIdFullDocument,
    variables,
    options,
  );
}
export type GetDeviceByIdFullQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDeviceByIdFullQuery,
  GetDeviceByIdFullQueryVariables
>;
export const HealthProviderSettingsForUserTableDocument = gql`
  query healthProviderSettingsForUserTable {
    healthProviderSettings {
      externalHumanIdTypes {
        id
        localeEntries {
          localeId
          displayName
          description
        }
      }
      userAuth {
        externalIdP {
          alias
          displayName
        }
      }
    }
  }
`;

/**
 * __useHealthProviderSettingsForUserTableQuery__
 *
 * To run a query within a Vue component, call `useHealthProviderSettingsForUserTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthProviderSettingsForUserTableQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHealthProviderSettingsForUserTableQuery();
 */
export function useHealthProviderSettingsForUserTableQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsForUserTableQuery,
        HealthProviderSettingsForUserTableQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForUserTableQuery,
          HealthProviderSettingsForUserTableQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForUserTableQuery,
          HealthProviderSettingsForUserTableQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    HealthProviderSettingsForUserTableQuery,
    HealthProviderSettingsForUserTableQueryVariables
  >(HealthProviderSettingsForUserTableDocument, {}, options);
}
export function useHealthProviderSettingsForUserTableLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsForUserTableQuery,
        HealthProviderSettingsForUserTableQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForUserTableQuery,
          HealthProviderSettingsForUserTableQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForUserTableQuery,
          HealthProviderSettingsForUserTableQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    HealthProviderSettingsForUserTableQuery,
    HealthProviderSettingsForUserTableQueryVariables
  >(HealthProviderSettingsForUserTableDocument, {}, options);
}
export type HealthProviderSettingsForUserTableQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  HealthProviderSettingsForUserTableQuery,
  HealthProviderSettingsForUserTableQueryVariables
>;
export const HealthProviderSettingsForPatientRegistrationDocument = gql`
  query healthProviderSettingsForPatientRegistration {
    healthProviderSettings {
      patientAuth {
        externalIdP {
          alias
          displayName
          enabled
          usernamePolicy
          default
        }
      }
      externalHumanIdTypes {
        id
      }
    }
  }
`;

/**
 * __useHealthProviderSettingsForPatientRegistrationQuery__
 *
 * To run a query within a Vue component, call `useHealthProviderSettingsForPatientRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthProviderSettingsForPatientRegistrationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHealthProviderSettingsForPatientRegistrationQuery();
 */
export function useHealthProviderSettingsForPatientRegistrationQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsForPatientRegistrationQuery,
        HealthProviderSettingsForPatientRegistrationQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForPatientRegistrationQuery,
          HealthProviderSettingsForPatientRegistrationQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForPatientRegistrationQuery,
          HealthProviderSettingsForPatientRegistrationQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    HealthProviderSettingsForPatientRegistrationQuery,
    HealthProviderSettingsForPatientRegistrationQueryVariables
  >(HealthProviderSettingsForPatientRegistrationDocument, {}, options);
}
export function useHealthProviderSettingsForPatientRegistrationLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsForPatientRegistrationQuery,
        HealthProviderSettingsForPatientRegistrationQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForPatientRegistrationQuery,
          HealthProviderSettingsForPatientRegistrationQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForPatientRegistrationQuery,
          HealthProviderSettingsForPatientRegistrationQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    HealthProviderSettingsForPatientRegistrationQuery,
    HealthProviderSettingsForPatientRegistrationQueryVariables
  >(HealthProviderSettingsForPatientRegistrationDocument, {}, options);
}
export type HealthProviderSettingsForPatientRegistrationQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    HealthProviderSettingsForPatientRegistrationQuery,
    HealthProviderSettingsForPatientRegistrationQueryVariables
  >;
export const RpmPatientExportDataDocument = gql`
  query rpmPatientExportData($patientIds: [ID!]!) {
    rpmPatientExportData(patientIds: $patientIds) {
      active
      birthDate
      createdAt
      externalIds {
        id
        type
      }
      firstName
      gender
      lastActive
      lastName
      patientGroupName
      updatedAt
    }
  }
`;

/**
 * __useRpmPatientExportDataQuery__
 *
 * To run a query within a Vue component, call `useRpmPatientExportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRpmPatientExportDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRpmPatientExportDataQuery({
 *   patientIds: // value for 'patientIds'
 * });
 */
export function useRpmPatientExportDataQuery(
  variables:
    | RpmPatientExportDataQueryVariables
    | VueCompositionApi.Ref<RpmPatientExportDataQueryVariables>
    | ReactiveFunction<RpmPatientExportDataQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>(
    RpmPatientExportDataDocument,
    variables,
    options,
  );
}
export function useRpmPatientExportDataLazyQuery(
  variables?:
    | RpmPatientExportDataQueryVariables
    | VueCompositionApi.Ref<RpmPatientExportDataQueryVariables>
    | ReactiveFunction<RpmPatientExportDataQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<RpmPatientExportDataQuery, RpmPatientExportDataQueryVariables>(
    RpmPatientExportDataDocument,
    variables,
    options,
  );
}
export type RpmPatientExportDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RpmPatientExportDataQuery,
  RpmPatientExportDataQueryVariables
>;
export const GetAllConcreteObservationsAsCsvDocument = gql`
  query getAllConcreteObservationsAsCsv {
    getAllConcreteObservationsAsCsv {
      csv
    }
  }
`;

/**
 * __useGetAllConcreteObservationsAsCsvQuery__
 *
 * To run a query within a Vue component, call `useGetAllConcreteObservationsAsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllConcreteObservationsAsCsvQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllConcreteObservationsAsCsvQuery();
 */
export function useGetAllConcreteObservationsAsCsvQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllConcreteObservationsAsCsvQuery,
        GetAllConcreteObservationsAsCsvQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllConcreteObservationsAsCsvQuery,
          GetAllConcreteObservationsAsCsvQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllConcreteObservationsAsCsvQuery,
          GetAllConcreteObservationsAsCsvQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllConcreteObservationsAsCsvQuery,
    GetAllConcreteObservationsAsCsvQueryVariables
  >(GetAllConcreteObservationsAsCsvDocument, {}, options);
}
export function useGetAllConcreteObservationsAsCsvLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllConcreteObservationsAsCsvQuery,
        GetAllConcreteObservationsAsCsvQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllConcreteObservationsAsCsvQuery,
          GetAllConcreteObservationsAsCsvQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllConcreteObservationsAsCsvQuery,
          GetAllConcreteObservationsAsCsvQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllConcreteObservationsAsCsvQuery,
    GetAllConcreteObservationsAsCsvQueryVariables
  >(GetAllConcreteObservationsAsCsvDocument, {}, options);
}
export type GetAllConcreteObservationsAsCsvQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllConcreteObservationsAsCsvQuery,
  GetAllConcreteObservationsAsCsvQueryVariables
>;
export const PatientExportDataDocument = gql`
  query patientExportData($patientIds: [ID!]!) {
    patientExportData(patientIds: $patientIds) {
      firstName
      lastName
      createdAt
      updatedAt
      tags
      patientNote
      fhirId
      externalIds {
        id
        type
      }
      devices {
        identifier
        modelNumber
      }
      isAlarmHandlingPlanActive
      active
      birthDate
      gender
      telecom {
        system
        value
      }
      patientGroupName
      address {
        line
        postalCode
        city
        country
        text
      }
      nextOfKins {
        name
        telecom {
          system
          value
        }
        relationship
      }
      contacts {
        name
        telecom {
          system
          value
        }
      }
      addressNote
      keyCode
    }
  }
`;

/**
 * __usePatientExportDataQuery__
 *
 * To run a query within a Vue component, call `usePatientExportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientExportDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientExportDataQuery({
 *   patientIds: // value for 'patientIds'
 * });
 */
export function usePatientExportDataQuery(
  variables:
    | PatientExportDataQueryVariables
    | VueCompositionApi.Ref<PatientExportDataQueryVariables>
    | ReactiveFunction<PatientExportDataQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientExportDataQuery, PatientExportDataQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientExportDataQuery, PatientExportDataQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientExportDataQuery, PatientExportDataQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientExportDataQuery, PatientExportDataQueryVariables>(
    PatientExportDataDocument,
    variables,
    options,
  );
}
export function usePatientExportDataLazyQuery(
  variables?:
    | PatientExportDataQueryVariables
    | VueCompositionApi.Ref<PatientExportDataQueryVariables>
    | ReactiveFunction<PatientExportDataQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientExportDataQuery, PatientExportDataQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientExportDataQuery, PatientExportDataQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientExportDataQuery, PatientExportDataQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientExportDataQuery, PatientExportDataQueryVariables>(
    PatientExportDataDocument,
    variables,
    options,
  );
}
export type PatientExportDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientExportDataQuery,
  PatientExportDataQueryVariables
>;
export const PatientGroupsDocument = gql`
  query patientGroups {
    patientGroups {
      id
      name
    }
  }
`;

/**
 * __usePatientGroupsQuery__
 *
 * To run a query within a Vue component, call `usePatientGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientGroupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientGroupsQuery();
 */
export function usePatientGroupsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<PatientGroupsQuery, PatientGroupsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientGroupsQuery, PatientGroupsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientGroupsQuery, PatientGroupsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientGroupsQuery, PatientGroupsQueryVariables>(
    PatientGroupsDocument,
    {},
    options,
  );
}
export function usePatientGroupsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<PatientGroupsQuery, PatientGroupsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientGroupsQuery, PatientGroupsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientGroupsQuery, PatientGroupsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientGroupsQuery, PatientGroupsQueryVariables>(
    PatientGroupsDocument,
    {},
    options,
  );
}
export type PatientGroupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientGroupsQuery,
  PatientGroupsQueryVariables
>;
export const GetAllSelfTreatmentPlanTemplatesDocument = gql`
  query getAllSelfTreatmentPlanTemplates {
    getAllSelfTreatmentPlanTemplates {
      id
      status
      lastUpdated
      title
      subject {
        display
      }
      goals {
        id
        goal
      }
      medicalStates {
        green {
          symptoms
          treatments
        }
        yellow {
          symptoms
          treatments
        }
        red {
          symptoms
          treatments
        }
      }
    }
  }
`;

/**
 * __useGetAllSelfTreatmentPlanTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetAllSelfTreatmentPlanTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSelfTreatmentPlanTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllSelfTreatmentPlanTemplatesQuery();
 */
export function useGetAllSelfTreatmentPlanTemplatesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllSelfTreatmentPlanTemplatesQuery,
        GetAllSelfTreatmentPlanTemplatesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllSelfTreatmentPlanTemplatesQuery,
          GetAllSelfTreatmentPlanTemplatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllSelfTreatmentPlanTemplatesQuery,
          GetAllSelfTreatmentPlanTemplatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllSelfTreatmentPlanTemplatesQuery,
    GetAllSelfTreatmentPlanTemplatesQueryVariables
  >(GetAllSelfTreatmentPlanTemplatesDocument, {}, options);
}
export function useGetAllSelfTreatmentPlanTemplatesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllSelfTreatmentPlanTemplatesQuery,
        GetAllSelfTreatmentPlanTemplatesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllSelfTreatmentPlanTemplatesQuery,
          GetAllSelfTreatmentPlanTemplatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllSelfTreatmentPlanTemplatesQuery,
          GetAllSelfTreatmentPlanTemplatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllSelfTreatmentPlanTemplatesQuery,
    GetAllSelfTreatmentPlanTemplatesQueryVariables
  >(GetAllSelfTreatmentPlanTemplatesDocument, {}, options);
}
export type GetAllSelfTreatmentPlanTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllSelfTreatmentPlanTemplatesQuery,
  GetAllSelfTreatmentPlanTemplatesQueryVariables
>;
export const GetSelfTreatmentPlanTemplateByIdDocument = gql`
  query getSelfTreatmentPlanTemplateById($selfTreatmentPlanId: ID!) {
    getSelfTreatmentPlanTemplateById(selfTreatmentPlanId: $selfTreatmentPlanId) {
      id
      status
      lastUpdated
      title
      subject {
        display
      }
      goals {
        id
        goal
      }
      medicalStates {
        green {
          symptoms
          treatments
        }
        yellow {
          symptoms
          treatments
        }
        red {
          symptoms
          treatments
        }
      }
    }
  }
`;

/**
 * __useGetSelfTreatmentPlanTemplateByIdQuery__
 *
 * To run a query within a Vue component, call `useGetSelfTreatmentPlanTemplateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelfTreatmentPlanTemplateByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSelfTreatmentPlanTemplateByIdQuery({
 *   selfTreatmentPlanId: // value for 'selfTreatmentPlanId'
 * });
 */
export function useGetSelfTreatmentPlanTemplateByIdQuery(
  variables:
    | GetSelfTreatmentPlanTemplateByIdQueryVariables
    | VueCompositionApi.Ref<GetSelfTreatmentPlanTemplateByIdQueryVariables>
    | ReactiveFunction<GetSelfTreatmentPlanTemplateByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSelfTreatmentPlanTemplateByIdQuery,
        GetSelfTreatmentPlanTemplateByIdQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSelfTreatmentPlanTemplateByIdQuery,
          GetSelfTreatmentPlanTemplateByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSelfTreatmentPlanTemplateByIdQuery,
          GetSelfTreatmentPlanTemplateByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetSelfTreatmentPlanTemplateByIdQuery,
    GetSelfTreatmentPlanTemplateByIdQueryVariables
  >(GetSelfTreatmentPlanTemplateByIdDocument, variables, options);
}
export function useGetSelfTreatmentPlanTemplateByIdLazyQuery(
  variables?:
    | GetSelfTreatmentPlanTemplateByIdQueryVariables
    | VueCompositionApi.Ref<GetSelfTreatmentPlanTemplateByIdQueryVariables>
    | ReactiveFunction<GetSelfTreatmentPlanTemplateByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSelfTreatmentPlanTemplateByIdQuery,
        GetSelfTreatmentPlanTemplateByIdQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSelfTreatmentPlanTemplateByIdQuery,
          GetSelfTreatmentPlanTemplateByIdQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSelfTreatmentPlanTemplateByIdQuery,
          GetSelfTreatmentPlanTemplateByIdQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetSelfTreatmentPlanTemplateByIdQuery,
    GetSelfTreatmentPlanTemplateByIdQueryVariables
  >(GetSelfTreatmentPlanTemplateByIdDocument, variables, options);
}
export type GetSelfTreatmentPlanTemplateByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetSelfTreatmentPlanTemplateByIdQuery,
  GetSelfTreatmentPlanTemplateByIdQueryVariables
>;
export const SupportTeamLinkedHealthProvidersDocument = gql`
  query supportTeamLinkedHealthProviders {
    supportTeamLinkedHealthProviders {
      name
      displayName
      url
    }
  }
`;

/**
 * __useSupportTeamLinkedHealthProvidersQuery__
 *
 * To run a query within a Vue component, call `useSupportTeamLinkedHealthProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportTeamLinkedHealthProvidersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSupportTeamLinkedHealthProvidersQuery();
 */
export function useSupportTeamLinkedHealthProvidersQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        SupportTeamLinkedHealthProvidersQuery,
        SupportTeamLinkedHealthProvidersQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          SupportTeamLinkedHealthProvidersQuery,
          SupportTeamLinkedHealthProvidersQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          SupportTeamLinkedHealthProvidersQuery,
          SupportTeamLinkedHealthProvidersQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    SupportTeamLinkedHealthProvidersQuery,
    SupportTeamLinkedHealthProvidersQueryVariables
  >(SupportTeamLinkedHealthProvidersDocument, {}, options);
}
export function useSupportTeamLinkedHealthProvidersLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        SupportTeamLinkedHealthProvidersQuery,
        SupportTeamLinkedHealthProvidersQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          SupportTeamLinkedHealthProvidersQuery,
          SupportTeamLinkedHealthProvidersQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          SupportTeamLinkedHealthProvidersQuery,
          SupportTeamLinkedHealthProvidersQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    SupportTeamLinkedHealthProvidersQuery,
    SupportTeamLinkedHealthProvidersQueryVariables
  >(SupportTeamLinkedHealthProvidersDocument, {}, options);
}
export type SupportTeamLinkedHealthProvidersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  SupportTeamLinkedHealthProvidersQuery,
  SupportTeamLinkedHealthProvidersQueryVariables
>;
export const UserGroupForTreeDocument = gql`
  query userGroupForTree($id: ID) {
    userGroup(userGroupId: $id) {
      id
      name
      type
      rules
      parentId
      protected
      subTree {
        ...subTree
      }
      roles {
        basedOn
        protected
        ...Role
      }
      linkedPatientGroups {
        ...PatientGroup
      }
      patientGroups {
        ...PatientGroup
      }
      deviceGroups {
        id
        name
      }
      skyresponse {
        skyresponseAlarmHandlingRuleId
      }
    }
  }
  ${SubTreeFragmentDoc}
  ${RoleFragmentDoc}
  ${PatientGroupFragmentDoc}
`;

/**
 * __useUserGroupForTreeQuery__
 *
 * To run a query within a Vue component, call `useUserGroupForTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupForTreeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupForTreeQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserGroupForTreeQuery(
  variables:
    | UserGroupForTreeQueryVariables
    | VueCompositionApi.Ref<UserGroupForTreeQueryVariables>
    | ReactiveFunction<UserGroupForTreeQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForTreeQuery, UserGroupForTreeQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupForTreeQuery, UserGroupForTreeQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupForTreeQuery, UserGroupForTreeQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UserGroupForTreeQuery, UserGroupForTreeQueryVariables>(
    UserGroupForTreeDocument,
    variables,
    options,
  );
}
export function useUserGroupForTreeLazyQuery(
  variables:
    | UserGroupForTreeQueryVariables
    | VueCompositionApi.Ref<UserGroupForTreeQueryVariables>
    | ReactiveFunction<UserGroupForTreeQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForTreeQuery, UserGroupForTreeQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupForTreeQuery, UserGroupForTreeQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupForTreeQuery, UserGroupForTreeQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupForTreeQuery, UserGroupForTreeQueryVariables>(
    UserGroupForTreeDocument,
    variables,
    options,
  );
}
export type UserGroupForTreeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupForTreeQuery,
  UserGroupForTreeQueryVariables
>;
export const UserGroupForMoveButtonDocument = gql`
  query userGroupForMoveButton($id: ID) {
    userGroup(userGroupId: $id) {
      id
      name
      type
      rules
      parentId
      subTree {
        id
        name
        parentId
        subGroups {
          id
          name
          type
          rules
        }
        roles {
          id
        }
      }
      subGroups {
        id
        name
      }
      roles {
        ...Role
      }
    }
  }
  ${RoleFragmentDoc}
`;

/**
 * __useUserGroupForMoveButtonQuery__
 *
 * To run a query within a Vue component, call `useUserGroupForMoveButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupForMoveButtonQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupForMoveButtonQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserGroupForMoveButtonQuery(
  variables:
    | UserGroupForMoveButtonQueryVariables
    | VueCompositionApi.Ref<UserGroupForMoveButtonQueryVariables>
    | ReactiveFunction<UserGroupForMoveButtonQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>(
    UserGroupForMoveButtonDocument,
    variables,
    options,
  );
}
export function useUserGroupForMoveButtonLazyQuery(
  variables:
    | UserGroupForMoveButtonQueryVariables
    | VueCompositionApi.Ref<UserGroupForMoveButtonQueryVariables>
    | ReactiveFunction<UserGroupForMoveButtonQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupForMoveButtonQuery, UserGroupForMoveButtonQueryVariables>(
    UserGroupForMoveButtonDocument,
    variables,
    options,
  );
}
export type UserGroupForMoveButtonQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupForMoveButtonQuery,
  UserGroupForMoveButtonQueryVariables
>;
export const UserGroupDocument = gql`
  query userGroup($id: ID) {
    userGroup(userGroupId: $id) {
      id
      name
      subTree {
        id
        name
        roles {
          id
        }
      }
      roles {
        ...Role
      }
    }
  }
  ${RoleFragmentDoc}
`;

/**
 * __useUserGroupQuery__
 *
 * To run a query within a Vue component, call `useUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserGroupQuery(
  variables:
    | UserGroupQueryVariables
    | VueCompositionApi.Ref<UserGroupQueryVariables>
    | ReactiveFunction<UserGroupQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupQuery, UserGroupQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupQuery, UserGroupQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupQuery, UserGroupQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UserGroupQuery, UserGroupQueryVariables>(UserGroupDocument, variables, options);
}
export function useUserGroupLazyQuery(
  variables:
    | UserGroupQueryVariables
    | VueCompositionApi.Ref<UserGroupQueryVariables>
    | ReactiveFunction<UserGroupQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupQuery, UserGroupQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupQuery, UserGroupQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupQuery, UserGroupQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupQuery, UserGroupQueryVariables>(
    UserGroupDocument,
    variables,
    options,
  );
}
export type UserGroupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupQuery,
  UserGroupQueryVariables
>;
export const UserGroupCompleteDocument = gql`
  query userGroupComplete($userGroupId: ID) {
    userGroup(userGroupId: $userGroupId) {
      id
      name
      type
      rules
      parentId
      protected
      escalationDelay
      allowedRoleDefinitionIds
      skyresponse {
        enabled
        organizationId
        hasSkyresponseExternalId
        hasSkyresponseCredentials
        skyresponseAlarmHandlingRuleId
        allowedAlarmHandlingRuleIds
        publicArcObjectId
        privateArcObjectId
      }
      careTeams {
        id
        name
        telecom {
          value
          system
          use
        }
      }
      subGroups {
        ...subGroups
      }
      roles {
        ...Role
        protected
      }
      contacts {
        id
        name
        telecom {
          system
          value
        }
        availableHours
        skyresponseConfig {
          callMethod
        }
      }
      linkedPatientGroups {
        id
        name
        patientsCount
        enableDistanceEstimation
        enableOnSiteRegistration
        hideTechnicalAlarmNotifications
      }
      patientGroups {
        id
        name
        patientsCount
        enableDistanceEstimation
        enableOnSiteRegistration
        hideTechnicalAlarmNotifications
      }
      deviceGroups {
        id
        name
        hasCmpCredentials
        streamTTL
      }
    }
  }
  ${SubGroupsFragmentDoc}
  ${RoleFragmentDoc}
`;

/**
 * __useUserGroupCompleteQuery__
 *
 * To run a query within a Vue component, call `useUserGroupCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupCompleteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupCompleteQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useUserGroupCompleteQuery(
  variables:
    | UserGroupCompleteQueryVariables
    | VueCompositionApi.Ref<UserGroupCompleteQueryVariables>
    | ReactiveFunction<UserGroupCompleteQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>(
    UserGroupCompleteDocument,
    variables,
    options,
  );
}
export function useUserGroupCompleteLazyQuery(
  variables:
    | UserGroupCompleteQueryVariables
    | VueCompositionApi.Ref<UserGroupCompleteQueryVariables>
    | ReactiveFunction<UserGroupCompleteQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupCompleteQuery, UserGroupCompleteQueryVariables>(
    UserGroupCompleteDocument,
    variables,
    options,
  );
}
export type UserGroupCompleteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupCompleteQuery,
  UserGroupCompleteQueryVariables
>;
export const GetAllUserGroupChildrenDocument = gql`
  query getAllUserGroupChildren($userGroupId: ID!) {
    getAllUserGroupChildren(userGroupId: $userGroupId) {
      id
      name
    }
  }
`;

/**
 * __useGetAllUserGroupChildrenQuery__
 *
 * To run a query within a Vue component, call `useGetAllUserGroupChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUserGroupChildrenQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllUserGroupChildrenQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useGetAllUserGroupChildrenQuery(
  variables:
    | GetAllUserGroupChildrenQueryVariables
    | VueCompositionApi.Ref<GetAllUserGroupChildrenQueryVariables>
    | ReactiveFunction<GetAllUserGroupChildrenQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>(
    GetAllUserGroupChildrenDocument,
    variables,
    options,
  );
}
export function useGetAllUserGroupChildrenLazyQuery(
  variables?:
    | GetAllUserGroupChildrenQueryVariables
    | VueCompositionApi.Ref<GetAllUserGroupChildrenQueryVariables>
    | ReactiveFunction<GetAllUserGroupChildrenQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllUserGroupChildrenQuery, GetAllUserGroupChildrenQueryVariables>(
    GetAllUserGroupChildrenDocument,
    variables,
    options,
  );
}
export type GetAllUserGroupChildrenQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllUserGroupChildrenQuery,
  GetAllUserGroupChildrenQueryVariables
>;
export const UserGroupForDashboardDocument = gql`
  query userGroupForDashboard($id: ID) {
    userGroup(userGroupId: $id) {
      id
      subTree {
        patientGroups {
          id
          name
        }
      }
      patientGroups {
        id
        name
      }
    }
  }
`;

/**
 * __useUserGroupForDashboardQuery__
 *
 * To run a query within a Vue component, call `useUserGroupForDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupForDashboardQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupForDashboardQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserGroupForDashboardQuery(
  variables:
    | UserGroupForDashboardQueryVariables
    | VueCompositionApi.Ref<UserGroupForDashboardQueryVariables>
    | ReactiveFunction<UserGroupForDashboardQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>(
    UserGroupForDashboardDocument,
    variables,
    options,
  );
}
export function useUserGroupForDashboardLazyQuery(
  variables:
    | UserGroupForDashboardQueryVariables
    | VueCompositionApi.Ref<UserGroupForDashboardQueryVariables>
    | ReactiveFunction<UserGroupForDashboardQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupForDashboardQuery, UserGroupForDashboardQueryVariables>(
    UserGroupForDashboardDocument,
    variables,
    options,
  );
}
export type UserGroupForDashboardQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupForDashboardQuery,
  UserGroupForDashboardQueryVariables
>;
export const UsersDocument = gql`
  query users($id: ID) {
    users(id: $id) {
      id
      firstName
      lastName
      pendingEmailInvitation
      enabled
      email
      username
      ipRestrictions
      otpStatus
      smsOtpStatus
      smsOtpPhoneNumber
      externalIdP
      passwordStatus
      created
      requestedExternalIds {
        externalHumanIdType
        requested
      }
      roles {
        id
        display {
          key
          value
        }
        roleDefinitionId
        userGroup {
          id
          name
        }
      }
      externalIdentities {
        provider
      }
      externalUserIds {
        externalId
        externalHumanIdType {
          id
          localeEntries {
            localeId
            displayName
            description
          }
        }
      }
      lastActive
      timeLimitedAccess {
        start
        end
      }
    }
  }
`;

/**
 * __useUsersQuery__
 *
 * To run a query within a Vue component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUsersQuery({
 *   id: // value for 'id'
 * });
 */
export function useUsersQuery(
  variables:
    | UsersQueryVariables
    | VueCompositionApi.Ref<UsersQueryVariables>
    | ReactiveFunction<UsersQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UsersQuery, UsersQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersQuery, UsersQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersQuery, UsersQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, variables, options);
}
export function useUsersLazyQuery(
  variables:
    | UsersQueryVariables
    | VueCompositionApi.Ref<UsersQueryVariables>
    | ReactiveFunction<UsersQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UsersQuery, UsersQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersQuery, UsersQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersQuery, UsersQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, variables, options);
}
export type UsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UsersQuery, UsersQueryVariables>;
export const UserNotificationsDataDocument = gql`
  query userNotificationsData {
    getMyUserProfile {
      id
      email
      mobileNumber
    }
  }
`;

/**
 * __useUserNotificationsDataQuery__
 *
 * To run a query within a Vue component, call `useUserNotificationsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationsDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserNotificationsDataQuery();
 */
export function useUserNotificationsDataQuery(
  options:
    | VueApolloComposable.UseQueryOptions<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>(
    UserNotificationsDataDocument,
    {},
    options,
  );
}
export function useUserNotificationsDataLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserNotificationsDataQuery, UserNotificationsDataQueryVariables>(
    UserNotificationsDataDocument,
    {},
    options,
  );
}
export type UserNotificationsDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserNotificationsDataQuery,
  UserNotificationsDataQueryVariables
>;
export const UserForEditFormDocument = gql`
  query userForEditForm($id: ID) {
    users(id: $id) {
      id
      firstName
      lastName
      email
      enabled
      username
      mobileNumber
      otpStatus
      pendingEmailInvitation
      ipRestrictions
      requestedExternalIds {
        externalHumanIdType
        requested
      }
      externalUserIds {
        externalId
        externalHumanIdType {
          id
        }
      }
      roles {
        id
        roleDefinitionId
        display {
          key
          value
        }
      }
      timeLimitedAccess {
        start
        end
      }
      smsOtpStatus
      smsOtpPhoneNumber
      externalIdP
      passwordStatus
    }
  }
`;

/**
 * __useUserForEditFormQuery__
 *
 * To run a query within a Vue component, call `useUserForEditFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserForEditFormQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserForEditFormQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserForEditFormQuery(
  variables:
    | UserForEditFormQueryVariables
    | VueCompositionApi.Ref<UserForEditFormQueryVariables>
    | ReactiveFunction<UserForEditFormQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserForEditFormQuery, UserForEditFormQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserForEditFormQuery, UserForEditFormQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserForEditFormQuery, UserForEditFormQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UserForEditFormQuery, UserForEditFormQueryVariables>(
    UserForEditFormDocument,
    variables,
    options,
  );
}
export function useUserForEditFormLazyQuery(
  variables:
    | UserForEditFormQueryVariables
    | VueCompositionApi.Ref<UserForEditFormQueryVariables>
    | ReactiveFunction<UserForEditFormQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserForEditFormQuery, UserForEditFormQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserForEditFormQuery, UserForEditFormQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserForEditFormQuery, UserForEditFormQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UserForEditFormQuery, UserForEditFormQueryVariables>(
    UserForEditFormDocument,
    variables,
    options,
  );
}
export type UserForEditFormQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserForEditFormQuery,
  UserForEditFormQueryVariables
>;
export const UsersNamesDocument = gql`
  query usersNames($id: ID) {
    users(id: $id) {
      pendingEmailInvitation
      id
      username
      firstName
      lastName
      email
      enabled
    }
  }
`;

/**
 * __useUsersNamesQuery__
 *
 * To run a query within a Vue component, call `useUsersNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersNamesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUsersNamesQuery({
 *   id: // value for 'id'
 * });
 */
export function useUsersNamesQuery(
  variables:
    | UsersNamesQueryVariables
    | VueCompositionApi.Ref<UsersNamesQueryVariables>
    | ReactiveFunction<UsersNamesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UsersNamesQuery, UsersNamesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersNamesQuery, UsersNamesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersNamesQuery, UsersNamesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UsersNamesQuery, UsersNamesQueryVariables>(
    UsersNamesDocument,
    variables,
    options,
  );
}
export function useUsersNamesLazyQuery(
  variables:
    | UsersNamesQueryVariables
    | VueCompositionApi.Ref<UsersNamesQueryVariables>
    | ReactiveFunction<UsersNamesQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UsersNamesQuery, UsersNamesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UsersNamesQuery, UsersNamesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UsersNamesQuery, UsersNamesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UsersNamesQuery, UsersNamesQueryVariables>(
    UsersNamesDocument,
    variables,
    options,
  );
}
export type UsersNamesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UsersNamesQuery,
  UsersNamesQueryVariables
>;
export const AllUsersDocument = gql`
  query allUsers {
    users {
      id
      firstName
      lastName
      pendingEmailInvitation
      enabled
      email
      username
      ipRestrictions
      otpStatus
      smsOtpStatus
      smsOtpPhoneNumber
      externalIdP
      passwordStatus
      externalIdentities {
        provider
      }
      externalUserIds {
        externalId
        externalHumanIdType {
          id
        }
      }
      lastActive
    }
  }
`;

/**
 * __useAllUsersQuery__
 *
 * To run a query within a Vue component, call `useAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllUsersQuery();
 */
export function useAllUsersQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AllUsersQuery, AllUsersQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllUsersQuery, AllUsersQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllUsersQuery, AllUsersQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, {}, options);
}
export function useAllUsersLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<AllUsersQuery, AllUsersQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AllUsersQuery, AllUsersQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<AllUsersQuery, AllUsersQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<AllUsersQuery, AllUsersQueryVariables>(AllUsersDocument, {}, options);
}
export type AllUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  AllUsersQuery,
  AllUsersQueryVariables
>;
export const CreateUserDocument = gql`
  mutation createUser($userInput: UserCreateInput!) {
    createUser(userInput: $userInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
      user {
        id
      }
    }
  }
`;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUserMutation({
 *   variables: {
 *     userInput: // value for 'userInput'
 *   },
 * });
 */
export function useCreateUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateUserMutation, CreateUserMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateUserMutation, CreateUserMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
}
export type CreateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateUserMutation,
  CreateUserMutationVariables
>;
export const UpdateUserBeforeDeletionDocument = gql`
  mutation updateUserBeforeDeletion($userId: ID!, $userInput: UserUpdateInput!) {
    updateUser(userId: $userId, userInput: $userInput) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useUpdateUserBeforeDeletionMutation__
 *
 * To run a mutation, you first call `useUpdateUserBeforeDeletionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserBeforeDeletionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserBeforeDeletionMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     userInput: // value for 'userInput'
 *   },
 * });
 */
export function useUpdateUserBeforeDeletionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateUserBeforeDeletionMutation,
        UpdateUserBeforeDeletionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateUserBeforeDeletionMutation,
          UpdateUserBeforeDeletionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateUserBeforeDeletionMutation, UpdateUserBeforeDeletionMutationVariables>(
    UpdateUserBeforeDeletionDocument,
    options,
  );
}
export type UpdateUserBeforeDeletionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateUserBeforeDeletionMutation,
  UpdateUserBeforeDeletionMutationVariables
>;
export const DeleteUserDocument = gql`
  mutation deleteUser($userId: ID!) {
    deleteUser(userId: $userId) {
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUserMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
}
export type DeleteUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;
export const UpdateUserDocument = gql`
  mutation updateUser($userId: ID!, $userInput: UserUpdateInput!) {
    updateUser(userId: $userId, userInput: $userInput) {
      success
      message
    }
  }
`;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     userInput: // value for 'userInput'
 *   },
 * });
 */
export function useUpdateUserMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
}
export type UpdateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;
export const ResetUserPasswordDocument = gql`
  mutation resetUserPassword($userId: ID!) {
    resetUserPassword(userId: $userId)
  }
`;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetUserPasswordMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useResetUserPasswordMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(
    ResetUserPasswordDocument,
    options,
  );
}
export type ResetUserPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ResetUserPasswordMutation,
  ResetUserPasswordMutationVariables
>;
export const DisableUserPasswordDocument = gql`
  mutation disableUserPassword($userId: ID!) {
    disableUserPassword(userId: $userId)
  }
`;

/**
 * __useDisableUserPasswordMutation__
 *
 * To run a mutation, you first call `useDisableUserPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableUserPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableUserPasswordMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useDisableUserPasswordMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DisableUserPasswordMutation, DisableUserPasswordMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DisableUserPasswordMutation, DisableUserPasswordMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DisableUserPasswordMutation, DisableUserPasswordMutationVariables>(
    DisableUserPasswordDocument,
    options,
  );
}
export type DisableUserPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DisableUserPasswordMutation,
  DisableUserPasswordMutationVariables
>;
export const UpdateUserPasswordDocument = gql`
  mutation updateUserPassword($userId: ID!, $password: String!) {
    updateUserPassword(userId: $userId, password: $password)
  }
`;

/**
 * __useUpdateUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateUserPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserPasswordMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useUpdateUserPasswordMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(
    UpdateUserPasswordDocument,
    options,
  );
}
export type UpdateUserPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateUserPasswordMutation,
  UpdateUserPasswordMutationVariables
>;
export const ActivateOtpDocument = gql`
  mutation activateOtp($userId: ID!) {
    activateOtp(userId: $userId)
  }
`;

/**
 * __useActivateOtpMutation__
 *
 * To run a mutation, you first call `useActivateOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateOtpMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useActivateOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ActivateOtpMutation, ActivateOtpMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<ActivateOtpMutation, ActivateOtpMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<ActivateOtpMutation, ActivateOtpMutationVariables>(
    ActivateOtpDocument,
    options,
  );
}
export type ActivateOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateOtpMutation,
  ActivateOtpMutationVariables
>;
export const DeleteOtpDocument = gql`
  mutation deleteOtp($userId: ID!) {
    deleteOtp(userId: $userId)
  }
`;

/**
 * __useDeleteOtpMutation__
 *
 * To run a mutation, you first call `useDeleteOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOtpMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteOtpMutation, DeleteOtpMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOtpMutation, DeleteOtpMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<DeleteOtpMutation, DeleteOtpMutationVariables>(DeleteOtpDocument, options);
}
export type DeleteOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteOtpMutation,
  DeleteOtpMutationVariables
>;
export const CancelOtpDocument = gql`
  mutation cancelOtp($userId: ID!) {
    cancelOtp(userId: $userId)
  }
`;

/**
 * __useCancelOtpMutation__
 *
 * To run a mutation, you first call `useCancelOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelOtpMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useCancelOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CancelOtpMutation, CancelOtpMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelOtpMutation, CancelOtpMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<CancelOtpMutation, CancelOtpMutationVariables>(CancelOtpDocument, options);
}
export type CancelOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CancelOtpMutation,
  CancelOtpMutationVariables
>;
export const ActivateSmsOtpDocument = gql`
  mutation activateSmsOtp($userId: ID!, $phoneNumber: String!) {
    activateSmsOtp(userId: $userId, phoneNumber: $phoneNumber)
  }
`;

/**
 * __useActivateSmsOtpMutation__
 *
 * To run a mutation, you first call `useActivateSmsOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateSmsOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateSmsOtpMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useActivateSmsOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ActivateSmsOtpMutation, ActivateSmsOtpMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ActivateSmsOtpMutation, ActivateSmsOtpMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ActivateSmsOtpMutation, ActivateSmsOtpMutationVariables>(
    ActivateSmsOtpDocument,
    options,
  );
}
export type ActivateSmsOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateSmsOtpMutation,
  ActivateSmsOtpMutationVariables
>;
export const DeactivateSmsOtpDocument = gql`
  mutation deactivateSmsOtp($userId: ID!) {
    deactivateSmsOtp(userId: $userId)
  }
`;

/**
 * __useDeactivateSmsOtpMutation__
 *
 * To run a mutation, you first call `useDeactivateSmsOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateSmsOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeactivateSmsOtpMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useDeactivateSmsOtpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeactivateSmsOtpMutation, DeactivateSmsOtpMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeactivateSmsOtpMutation, DeactivateSmsOtpMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeactivateSmsOtpMutation, DeactivateSmsOtpMutationVariables>(
    DeactivateSmsOtpDocument,
    options,
  );
}
export type DeactivateSmsOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeactivateSmsOtpMutation,
  DeactivateSmsOtpMutationVariables
>;
export const SetExternalIdentitiesDocument = gql`
  mutation setExternalIdentities($userId: ID!, $identities: [ExternalIdentityInput]) {
    setExternalIdentities(userId: $userId, identities: $identities)
  }
`;

/**
 * __useSetExternalIdentitiesMutation__
 *
 * To run a mutation, you first call `useSetExternalIdentitiesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetExternalIdentitiesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetExternalIdentitiesMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     identities: // value for 'identities'
 *   },
 * });
 */
export function useSetExternalIdentitiesMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SetExternalIdentitiesMutation, SetExternalIdentitiesMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SetExternalIdentitiesMutation, SetExternalIdentitiesMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SetExternalIdentitiesMutation, SetExternalIdentitiesMutationVariables>(
    SetExternalIdentitiesDocument,
    options,
  );
}
export type SetExternalIdentitiesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetExternalIdentitiesMutation,
  SetExternalIdentitiesMutationVariables
>;
export const SetExternalIdPDocument = gql`
  mutation setExternalIdP($userId: ID!, $idP: String!) {
    setExternalIdP(userId: $userId, idP: $idP)
  }
`;

/**
 * __useSetExternalIdPMutation__
 *
 * To run a mutation, you first call `useSetExternalIdPMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetExternalIdPMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetExternalIdPMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *     idP: // value for 'idP'
 *   },
 * });
 */
export function useSetExternalIdPMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SetExternalIdPMutation, SetExternalIdPMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SetExternalIdPMutation, SetExternalIdPMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SetExternalIdPMutation, SetExternalIdPMutationVariables>(
    SetExternalIdPDocument,
    options,
  );
}
export type SetExternalIdPMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetExternalIdPMutation,
  SetExternalIdPMutationVariables
>;
export const EnableUserPasswordDocument = gql`
  mutation enableUserPassword($userId: ID!) {
    enableUserPassword(userId: $userId)
  }
`;

/**
 * __useEnableUserPasswordMutation__
 *
 * To run a mutation, you first call `useEnableUserPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableUserPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableUserPasswordMutation({
 *   variables: {
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useEnableUserPasswordMutation(
  options:
    | VueApolloComposable.UseMutationOptions<EnableUserPasswordMutation, EnableUserPasswordMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<EnableUserPasswordMutation, EnableUserPasswordMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<EnableUserPasswordMutation, EnableUserPasswordMutationVariables>(
    EnableUserPasswordDocument,
    options,
  );
}
export type EnableUserPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  EnableUserPasswordMutation,
  EnableUserPasswordMutationVariables
>;
export const VkpPatientCareplanDocument = gql`
  query vkpPatientCareplan($id: ID!) {
    vkpPatientCareplan(id: $id) {
      fnr
      responseAsJson
    }
  }
`;

/**
 * __useVkpPatientCareplanQuery__
 *
 * To run a query within a Vue component, call `useVkpPatientCareplanQuery` and pass it any options that fit your needs.
 * When your component renders, `useVkpPatientCareplanQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVkpPatientCareplanQuery({
 *   id: // value for 'id'
 * });
 */
export function useVkpPatientCareplanQuery(
  variables:
    | VkpPatientCareplanQueryVariables
    | VueCompositionApi.Ref<VkpPatientCareplanQueryVariables>
    | ReactiveFunction<VkpPatientCareplanQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>(
    VkpPatientCareplanDocument,
    variables,
    options,
  );
}
export function useVkpPatientCareplanLazyQuery(
  variables?:
    | VkpPatientCareplanQueryVariables
    | VueCompositionApi.Ref<VkpPatientCareplanQueryVariables>
    | ReactiveFunction<VkpPatientCareplanQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<VkpPatientCareplanQuery, VkpPatientCareplanQueryVariables>(
    VkpPatientCareplanDocument,
    variables,
    options,
  );
}
export type VkpPatientCareplanQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  VkpPatientCareplanQuery,
  VkpPatientCareplanQueryVariables
>;
export const VkpPatientEpisodesOfCareDocument = gql`
  query vkpPatientEpisodesOfCare($id: ID!) {
    vkpPatientEpisodesOfCare(id: $id) {
      fnr
      responseAsJson
    }
  }
`;

/**
 * __useVkpPatientEpisodesOfCareQuery__
 *
 * To run a query within a Vue component, call `useVkpPatientEpisodesOfCareQuery` and pass it any options that fit your needs.
 * When your component renders, `useVkpPatientEpisodesOfCareQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVkpPatientEpisodesOfCareQuery({
 *   id: // value for 'id'
 * });
 */
export function useVkpPatientEpisodesOfCareQuery(
  variables:
    | VkpPatientEpisodesOfCareQueryVariables
    | VueCompositionApi.Ref<VkpPatientEpisodesOfCareQueryVariables>
    | ReactiveFunction<VkpPatientEpisodesOfCareQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>(
    VkpPatientEpisodesOfCareDocument,
    variables,
    options,
  );
}
export function useVkpPatientEpisodesOfCareLazyQuery(
  variables?:
    | VkpPatientEpisodesOfCareQueryVariables
    | VueCompositionApi.Ref<VkpPatientEpisodesOfCareQueryVariables>
    | ReactiveFunction<VkpPatientEpisodesOfCareQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<VkpPatientEpisodesOfCareQuery, VkpPatientEpisodesOfCareQueryVariables>(
    VkpPatientEpisodesOfCareDocument,
    variables,
    options,
  );
}
export type VkpPatientEpisodesOfCareQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  VkpPatientEpisodesOfCareQuery,
  VkpPatientEpisodesOfCareQueryVariables
>;
export const ServicesDocument = gql`
  query services {
    services {
      id
      name
      roles {
        userGroup {
          isTopLevel
        }
        basedOn
        userManuals {
          id
          name
          icon
          applications {
            tilsyn
            dho
          }
          localeEntries {
            localeId
            description
            displayName
            url
          }
          roleDefinitions {
            id
          }
        }
        id
        roleDefinitionId
        display {
          key
          value
        }
        abilities {
          operation
          resource
        }
        dashboardRouteName
        userGroup {
          id
          name
        }
        canAssignRoles
      }
      applications {
        dialogg
        tilsyn
        dho
      }
      features {
        distanceApi
        externalHumanIdTypeIdForPatient
        externalHumanIdTypeIdForUser
        externalHumanIdTypeIdForDialoggUser
        videoMeetings
        defaultLocale
        axisCameras
        disablePasswordForDialoggUsers
        smsNotifications
        emailNotifications
        continuousSupervision
        vkpSearchEnabled
        hasKomp
        joinNhnMeeting
        sendNotificationToNextOfKin
        selfTreatmentPlan
        hasJournalConfig
        hasSkyresponseCustomerGroup
        hasCmpAccount
        safemateIntegration
        tcifIntegration
        skyresponse
      }
      configuration {
        alarmAckTemplates {
          template
          status
        }
      }
    }
  }
`;

/**
 * __useServicesQuery__
 *
 * To run a query within a Vue component, call `useServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useServicesQuery();
 */
export function useServicesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ServicesQuery, ServicesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ServicesQuery, ServicesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ServicesQuery, ServicesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, {}, options);
}
export function useServicesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ServicesQuery, ServicesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ServicesQuery, ServicesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ServicesQuery, ServicesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, {}, options);
}
export type ServicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ServicesQuery,
  ServicesQueryVariables
>;
export const RegisterPushIdForShiftSessionDocument = gql`
  mutation registerPushIdForShiftSession($pushNotificationSettings: PushNotificationSettingsInput!) {
    registerPushIdForShiftSession(pushNotificationSettings: $pushNotificationSettings) {
      success
      message
    }
  }
`;

/**
 * __useRegisterPushIdForShiftSessionMutation__
 *
 * To run a mutation, you first call `useRegisterPushIdForShiftSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPushIdForShiftSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterPushIdForShiftSessionMutation({
 *   variables: {
 *     pushNotificationSettings: // value for 'pushNotificationSettings'
 *   },
 * });
 */
export function useRegisterPushIdForShiftSessionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RegisterPushIdForShiftSessionMutation,
        RegisterPushIdForShiftSessionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RegisterPushIdForShiftSessionMutation,
          RegisterPushIdForShiftSessionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RegisterPushIdForShiftSessionMutation,
    RegisterPushIdForShiftSessionMutationVariables
  >(RegisterPushIdForShiftSessionDocument, options);
}
export type RegisterPushIdForShiftSessionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RegisterPushIdForShiftSessionMutation,
  RegisterPushIdForShiftSessionMutationVariables
>;
export const CreateShiftSessionForPatientGroupsDocument = gql`
  mutation createShiftSessionForPatientGroups($patientGroupIds: [ID!]!) {
    createShiftSessionForPatientGroups(patientGroupIds: $patientGroupIds) {
      patientGroupIdsAndNames {
        id
        name
      }
      pushNotificationSettings {
        type
        device
      }
      notificationSettings {
        sendEmail
        sendSms
        locale
      }
      createdAt
      lastUpdated
    }
  }
`;

/**
 * __useCreateShiftSessionForPatientGroupsMutation__
 *
 * To run a mutation, you first call `useCreateShiftSessionForPatientGroupsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateShiftSessionForPatientGroupsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateShiftSessionForPatientGroupsMutation({
 *   variables: {
 *     patientGroupIds: // value for 'patientGroupIds'
 *   },
 * });
 */
export function useCreateShiftSessionForPatientGroupsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateShiftSessionForPatientGroupsMutation,
        CreateShiftSessionForPatientGroupsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateShiftSessionForPatientGroupsMutation,
          CreateShiftSessionForPatientGroupsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateShiftSessionForPatientGroupsMutation,
    CreateShiftSessionForPatientGroupsMutationVariables
  >(CreateShiftSessionForPatientGroupsDocument, options);
}
export type CreateShiftSessionForPatientGroupsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateShiftSessionForPatientGroupsMutation,
  CreateShiftSessionForPatientGroupsMutationVariables
>;
export const SetEmailAndSmsNotificationSettingsForShiftSessionDocument = gql`
  mutation setEmailAndSmsNotificationSettingsForShiftSession($notificationSettings: SessionNotificationSettingsInput!) {
    setEmailAndSmsNotificationSettingsForShiftSession(notificationSettings: $notificationSettings) {
      patientGroupIdsAndNames {
        id
        name
      }
      pushNotificationSettings {
        type
        device
      }
      notificationSettings {
        sendEmail
        sendSms
        locale
        mobileNumber
        email
      }
      createdAt
      lastUpdated
    }
  }
`;

/**
 * __useSetEmailAndSmsNotificationSettingsForShiftSessionMutation__
 *
 * To run a mutation, you first call `useSetEmailAndSmsNotificationSettingsForShiftSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetEmailAndSmsNotificationSettingsForShiftSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetEmailAndSmsNotificationSettingsForShiftSessionMutation({
 *   variables: {
 *     notificationSettings: // value for 'notificationSettings'
 *   },
 * });
 */
export function useSetEmailAndSmsNotificationSettingsForShiftSessionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SetEmailAndSmsNotificationSettingsForShiftSessionMutation,
        SetEmailAndSmsNotificationSettingsForShiftSessionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetEmailAndSmsNotificationSettingsForShiftSessionMutation,
          SetEmailAndSmsNotificationSettingsForShiftSessionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SetEmailAndSmsNotificationSettingsForShiftSessionMutation,
    SetEmailAndSmsNotificationSettingsForShiftSessionMutationVariables
  >(SetEmailAndSmsNotificationSettingsForShiftSessionDocument, options);
}
export type SetEmailAndSmsNotificationSettingsForShiftSessionMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    SetEmailAndSmsNotificationSettingsForShiftSessionMutation,
    SetEmailAndSmsNotificationSettingsForShiftSessionMutationVariables
  >;
export const ShiftSessionDocument = gql`
  query shiftSession {
    shiftSession {
      patientGroupIdsAndNames {
        id
        name
      }
      pushNotificationSettings {
        type
        device
        createdAt
      }
      notificationSettings {
        sendEmail
        sendSms
        mobileNumber
        email
      }
    }
  }
`;

/**
 * __useShiftSessionQuery__
 *
 * To run a query within a Vue component, call `useShiftSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftSessionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useShiftSessionQuery();
 */
export function useShiftSessionQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ShiftSessionQuery, ShiftSessionQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShiftSessionQuery, ShiftSessionQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShiftSessionQuery, ShiftSessionQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ShiftSessionQuery, ShiftSessionQueryVariables>(ShiftSessionDocument, {}, options);
}
export function useShiftSessionLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ShiftSessionQuery, ShiftSessionQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShiftSessionQuery, ShiftSessionQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShiftSessionQuery, ShiftSessionQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ShiftSessionQuery, ShiftSessionQueryVariables>(
    ShiftSessionDocument,
    {},
    options,
  );
}
export type ShiftSessionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ShiftSessionQuery,
  ShiftSessionQueryVariables
>;
export const AddPatientAlarmHandlingDocument = gql`
  mutation addPatientAlarmHandling($patientId: ID!, $fromTemplate: ID!, $input: AlarmActivityInput!) {
    addPatientAlarmHandling(patientId: $patientId, fromTemplate: $fromTemplate, input: $input) {
      success
      message
      inputValidation {
        message
      }
    }
  }
`;

/**
 * __useAddPatientAlarmHandlingMutation__
 *
 * To run a mutation, you first call `useAddPatientAlarmHandlingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientAlarmHandlingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPatientAlarmHandlingMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     fromTemplate: // value for 'fromTemplate'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddPatientAlarmHandlingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddPatientAlarmHandlingMutation, AddPatientAlarmHandlingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddPatientAlarmHandlingMutation,
          AddPatientAlarmHandlingMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<AddPatientAlarmHandlingMutation, AddPatientAlarmHandlingMutationVariables>(
    AddPatientAlarmHandlingDocument,
    options,
  );
}
export type AddPatientAlarmHandlingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddPatientAlarmHandlingMutation,
  AddPatientAlarmHandlingMutationVariables
>;
export const UpdatePatientAlarmHandlingDocument = gql`
  mutation updatePatientAlarmHandling($patientId: ID!, $alarmId: ID!, $input: AlarmActivityInput!) {
    updatePatientAlarmHandling(patientId: $patientId, alarmId: $alarmId, input: $input) {
      success
    }
  }
`;

/**
 * __useUpdatePatientAlarmHandlingMutation__
 *
 * To run a mutation, you first call `useUpdatePatientAlarmHandlingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientAlarmHandlingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientAlarmHandlingMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     alarmId: // value for 'alarmId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePatientAlarmHandlingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdatePatientAlarmHandlingMutation,
        UpdatePatientAlarmHandlingMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdatePatientAlarmHandlingMutation,
          UpdatePatientAlarmHandlingMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdatePatientAlarmHandlingMutation,
    UpdatePatientAlarmHandlingMutationVariables
  >(UpdatePatientAlarmHandlingDocument, options);
}
export type UpdatePatientAlarmHandlingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientAlarmHandlingMutation,
  UpdatePatientAlarmHandlingMutationVariables
>;
export const RemovePatientAlarmHandlingDocument = gql`
  mutation removePatientAlarmHandling($patientId: ID!, $alarmId: ID!) {
    removePatientAlarmHandling(patientId: $patientId, alarmId: $alarmId) {
      success
    }
  }
`;

/**
 * __useRemovePatientAlarmHandlingMutation__
 *
 * To run a mutation, you first call `useRemovePatientAlarmHandlingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemovePatientAlarmHandlingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemovePatientAlarmHandlingMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     alarmId: // value for 'alarmId'
 *   },
 * });
 */
export function useRemovePatientAlarmHandlingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemovePatientAlarmHandlingMutation,
        RemovePatientAlarmHandlingMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemovePatientAlarmHandlingMutation,
          RemovePatientAlarmHandlingMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemovePatientAlarmHandlingMutation,
    RemovePatientAlarmHandlingMutationVariables
  >(RemovePatientAlarmHandlingDocument, options);
}
export type RemovePatientAlarmHandlingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemovePatientAlarmHandlingMutation,
  RemovePatientAlarmHandlingMutationVariables
>;
export const GetAlarmHandlingPlanAlarmsDocument = gql`
  query getAlarmHandlingPlanAlarms($patientId: ID!) {
    getAlarmHandlingPlanAlarms(patientId: $patientId) {
      id
      alarmIcon
      callbackMinutes
      technical
      tagAction {
        target
        type
        label
      }
      generatesAlarm
      noCarePlanRequired
      resolveAction
      identifier {
        value
      }
      description
      code {
        coding {
          display
          code
          system
        }
        text
      }
      effectiveTiming {
        repeat {
          dayOfWeek
          timeOfDay
        }
      }
      interpretation {
        text
        coding {
          code
          display
        }
      }
      component {
        code {
          coding {
            system
            display
            code
          }
          text
        }
      }
      cep {
        trigger
        cancelledBy
        after
      }
    }
  }
`;

/**
 * __useGetAlarmHandlingPlanAlarmsQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmHandlingPlanAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmHandlingPlanAlarmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmHandlingPlanAlarmsQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetAlarmHandlingPlanAlarmsQuery(
  variables:
    | GetAlarmHandlingPlanAlarmsQueryVariables
    | VueCompositionApi.Ref<GetAlarmHandlingPlanAlarmsQueryVariables>
    | ReactiveFunction<GetAlarmHandlingPlanAlarmsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmHandlingPlanAlarmsQuery, GetAlarmHandlingPlanAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmHandlingPlanAlarmsQuery, GetAlarmHandlingPlanAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmHandlingPlanAlarmsQuery, GetAlarmHandlingPlanAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAlarmHandlingPlanAlarmsQuery, GetAlarmHandlingPlanAlarmsQueryVariables>(
    GetAlarmHandlingPlanAlarmsDocument,
    variables,
    options,
  );
}
export function useGetAlarmHandlingPlanAlarmsLazyQuery(
  variables?:
    | GetAlarmHandlingPlanAlarmsQueryVariables
    | VueCompositionApi.Ref<GetAlarmHandlingPlanAlarmsQueryVariables>
    | ReactiveFunction<GetAlarmHandlingPlanAlarmsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmHandlingPlanAlarmsQuery, GetAlarmHandlingPlanAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmHandlingPlanAlarmsQuery, GetAlarmHandlingPlanAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmHandlingPlanAlarmsQuery, GetAlarmHandlingPlanAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAlarmHandlingPlanAlarmsQuery, GetAlarmHandlingPlanAlarmsQueryVariables>(
    GetAlarmHandlingPlanAlarmsDocument,
    variables,
    options,
  );
}
export type GetAlarmHandlingPlanAlarmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmHandlingPlanAlarmsQuery,
  GetAlarmHandlingPlanAlarmsQueryVariables
>;
export const GetAlarmTemplatesForAlarmHandlingDocument = gql`
  query getAlarmTemplatesForAlarmHandling {
    getAlarmTemplates {
      id
      identifier {
        value
      }
      description
      status
      code {
        coding {
          display
          code
          system
        }
        text
      }
      component {
        code {
          coding {
            system
            display
            code
          }
          text
        }
      }
      alarmIcon
      callbackMinutes
      technical
      tagAction {
        target
        type
        label
      }
      generatesAlarm
      noCarePlanRequired
      resolveAction
      effectiveTiming {
        repeat {
          dayOfWeek
          timeOfDay
        }
      }
      interpretation {
        text
        coding {
          code
          display
        }
      }
      cep {
        trigger
        after
        cancelledBy
      }
    }
  }
`;

/**
 * __useGetAlarmTemplatesForAlarmHandlingQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmTemplatesForAlarmHandlingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmTemplatesForAlarmHandlingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmTemplatesForAlarmHandlingQuery();
 */
export function useGetAlarmTemplatesForAlarmHandlingQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForAlarmHandlingQuery,
        GetAlarmTemplatesForAlarmHandlingQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForAlarmHandlingQuery,
          GetAlarmTemplatesForAlarmHandlingQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForAlarmHandlingQuery,
          GetAlarmTemplatesForAlarmHandlingQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAlarmTemplatesForAlarmHandlingQuery,
    GetAlarmTemplatesForAlarmHandlingQueryVariables
  >(GetAlarmTemplatesForAlarmHandlingDocument, {}, options);
}
export function useGetAlarmTemplatesForAlarmHandlingLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForAlarmHandlingQuery,
        GetAlarmTemplatesForAlarmHandlingQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForAlarmHandlingQuery,
          GetAlarmTemplatesForAlarmHandlingQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForAlarmHandlingQuery,
          GetAlarmTemplatesForAlarmHandlingQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAlarmTemplatesForAlarmHandlingQuery,
    GetAlarmTemplatesForAlarmHandlingQueryVariables
  >(GetAlarmTemplatesForAlarmHandlingDocument, {}, options);
}
export type GetAlarmTemplatesForAlarmHandlingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmTemplatesForAlarmHandlingQuery,
  GetAlarmTemplatesForAlarmHandlingQueryVariables
>;
export const GetAlarmTemplatesForAlarmWizardDocument = gql`
  query getAlarmTemplatesForAlarmWizard {
    getAlarmTemplates {
      id
      identifier {
        value
      }
      description
      status
      code {
        coding {
          display
          code
          system
        }
        text
      }
      component {
        code {
          coding {
            system
            display
            code
          }
          text
        }
      }
      alarmIcon
      callbackMinutes
      technical
      tagAction {
        target
        type
        label
      }
      generatesAlarm
      noCarePlanRequired
      resolveAction
      effectiveTiming {
        repeat {
          dayOfWeek
          timeOfDay
        }
      }
      interpretation {
        text
        coding {
          code
          display
        }
      }
      cep {
        trigger
        after
        cancelledBy
      }
    }
  }
`;

/**
 * __useGetAlarmTemplatesForAlarmWizardQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmTemplatesForAlarmWizardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmTemplatesForAlarmWizardQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmTemplatesForAlarmWizardQuery();
 */
export function useGetAlarmTemplatesForAlarmWizardQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForAlarmWizardQuery,
        GetAlarmTemplatesForAlarmWizardQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForAlarmWizardQuery,
          GetAlarmTemplatesForAlarmWizardQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForAlarmWizardQuery,
          GetAlarmTemplatesForAlarmWizardQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAlarmTemplatesForAlarmWizardQuery,
    GetAlarmTemplatesForAlarmWizardQueryVariables
  >(GetAlarmTemplatesForAlarmWizardDocument, {}, options);
}
export function useGetAlarmTemplatesForAlarmWizardLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForAlarmWizardQuery,
        GetAlarmTemplatesForAlarmWizardQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForAlarmWizardQuery,
          GetAlarmTemplatesForAlarmWizardQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForAlarmWizardQuery,
          GetAlarmTemplatesForAlarmWizardQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAlarmTemplatesForAlarmWizardQuery,
    GetAlarmTemplatesForAlarmWizardQueryVariables
  >(GetAlarmTemplatesForAlarmWizardDocument, {}, options);
}
export type GetAlarmTemplatesForAlarmWizardQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmTemplatesForAlarmWizardQuery,
  GetAlarmTemplatesForAlarmWizardQueryVariables
>;
export const DeleteAlarmTemplateDocument = gql`
  mutation deleteAlarmTemplate($id: ID!) {
    deleteAlarmTemplate(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteAlarmTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteAlarmTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlarmTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAlarmTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAlarmTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteAlarmTemplateMutation, DeleteAlarmTemplateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteAlarmTemplateMutation, DeleteAlarmTemplateMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteAlarmTemplateMutation, DeleteAlarmTemplateMutationVariables>(
    DeleteAlarmTemplateDocument,
    options,
  );
}
export type DeleteAlarmTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteAlarmTemplateMutation,
  DeleteAlarmTemplateMutationVariables
>;
export const ConfigureCameraEventsDocument = gql`
  mutation configureCameraEvents($cameraId: ID!) {
    configureCameraEvents(cameraId: $cameraId) {
      success
    }
  }
`;

/**
 * __useConfigureCameraEventsMutation__
 *
 * To run a mutation, you first call `useConfigureCameraEventsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfigureCameraEventsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfigureCameraEventsMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useConfigureCameraEventsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ConfigureCameraEventsMutation, ConfigureCameraEventsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ConfigureCameraEventsMutation, ConfigureCameraEventsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ConfigureCameraEventsMutation, ConfigureCameraEventsMutationVariables>(
    ConfigureCameraEventsDocument,
    options,
  );
}
export type ConfigureCameraEventsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ConfigureCameraEventsMutation,
  ConfigureCameraEventsMutationVariables
>;
export const SetAnonymizationRequirementDocument = gql`
  mutation setAnonymizationRequirement($cameraId: ID!, $anonymizationRequirement: Boolean!) {
    setAnonymizationRequirement(cameraId: $cameraId, anonymizationRequirement: $anonymizationRequirement)
  }
`;

/**
 * __useSetAnonymizationRequirementMutation__
 *
 * To run a mutation, you first call `useSetAnonymizationRequirementMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetAnonymizationRequirementMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetAnonymizationRequirementMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     anonymizationRequirement: // value for 'anonymizationRequirement'
 *   },
 * });
 */
export function useSetAnonymizationRequirementMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SetAnonymizationRequirementMutation,
        SetAnonymizationRequirementMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetAnonymizationRequirementMutation,
          SetAnonymizationRequirementMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SetAnonymizationRequirementMutation,
    SetAnonymizationRequirementMutationVariables
  >(SetAnonymizationRequirementDocument, options);
}
export type SetAnonymizationRequirementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetAnonymizationRequirementMutation,
  SetAnonymizationRequirementMutationVariables
>;
export const StartAppDocument = gql`
  mutation startApp($cameraId: ID!, $appId: String!) {
    startApp(cameraId: $cameraId, appId: $appId)
  }
`;

/**
 * __useStartAppMutation__
 *
 * To run a mutation, you first call `useStartAppMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartAppMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartAppMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     appId: // value for 'appId'
 *   },
 * });
 */
export function useStartAppMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StartAppMutation, StartAppMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<StartAppMutation, StartAppMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<StartAppMutation, StartAppMutationVariables>(StartAppDocument, options);
}
export type StartAppMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StartAppMutation,
  StartAppMutationVariables
>;
export const StopAppDocument = gql`
  mutation stopApp($cameraId: ID!, $appId: String!) {
    stopApp(cameraId: $cameraId, appId: $appId)
  }
`;

/**
 * __useStopAppMutation__
 *
 * To run a mutation, you first call `useStopAppMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStopAppMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStopAppMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     appId: // value for 'appId'
 *   },
 * });
 */
export function useStopAppMutation(
  options:
    | VueApolloComposable.UseMutationOptions<StopAppMutation, StopAppMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<StopAppMutation, StopAppMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<StopAppMutation, StopAppMutationVariables>(StopAppDocument, options);
}
export type StopAppMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  StopAppMutation,
  StopAppMutationVariables
>;
export const RebootDocument = gql`
  mutation reboot($cameraId: ID!) {
    reboot(cameraId: $cameraId)
  }
`;

/**
 * __useRebootMutation__
 *
 * To run a mutation, you first call `useRebootMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRebootMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRebootMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useRebootMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RebootMutation, RebootMutationVariables>
    | ReactiveFunction<VueApolloComposable.UseMutationOptions<RebootMutation, RebootMutationVariables>> = {},
) {
  return VueApolloComposable.useMutation<RebootMutation, RebootMutationVariables>(RebootDocument, options);
}
export type RebootMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RebootMutation,
  RebootMutationVariables
>;
export const GetCameraAdminAppsDocument = gql`
  query getCameraAdminApps($cameraId: ID!) {
    getCameraAdmin(cameraId: $cameraId) {
      adminApps {
        id
        url
      }
    }
  }
`;

/**
 * __useGetCameraAdminAppsQuery__
 *
 * To run a query within a Vue component, call `useGetCameraAdminAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraAdminAppsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraAdminAppsQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useGetCameraAdminAppsQuery(
  variables:
    | GetCameraAdminAppsQueryVariables
    | VueCompositionApi.Ref<GetCameraAdminAppsQueryVariables>
    | ReactiveFunction<GetCameraAdminAppsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>(
    GetCameraAdminAppsDocument,
    variables,
    options,
  );
}
export function useGetCameraAdminAppsLazyQuery(
  variables?:
    | GetCameraAdminAppsQueryVariables
    | VueCompositionApi.Ref<GetCameraAdminAppsQueryVariables>
    | ReactiveFunction<GetCameraAdminAppsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraAdminAppsQuery, GetCameraAdminAppsQueryVariables>(
    GetCameraAdminAppsDocument,
    variables,
    options,
  );
}
export type GetCameraAdminAppsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraAdminAppsQuery,
  GetCameraAdminAppsQueryVariables
>;
export const GetAvailableCamerasInInventoryDocument = gql`
  query getAvailableCamerasInInventory {
    getAvailableCamerasInInventory {
      macAddress
      modelNumber
    }
  }
`;

/**
 * __useGetAvailableCamerasInInventoryQuery__
 *
 * To run a query within a Vue component, call `useGetAvailableCamerasInInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableCamerasInInventoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAvailableCamerasInInventoryQuery();
 */
export function useGetAvailableCamerasInInventoryQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAvailableCamerasInInventoryQuery,
        GetAvailableCamerasInInventoryQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAvailableCamerasInInventoryQuery,
          GetAvailableCamerasInInventoryQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAvailableCamerasInInventoryQuery,
          GetAvailableCamerasInInventoryQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAvailableCamerasInInventoryQuery,
    GetAvailableCamerasInInventoryQueryVariables
  >(GetAvailableCamerasInInventoryDocument, {}, options);
}
export function useGetAvailableCamerasInInventoryLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAvailableCamerasInInventoryQuery,
        GetAvailableCamerasInInventoryQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAvailableCamerasInInventoryQuery,
          GetAvailableCamerasInInventoryQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAvailableCamerasInInventoryQuery,
          GetAvailableCamerasInInventoryQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAvailableCamerasInInventoryQuery,
    GetAvailableCamerasInInventoryQueryVariables
  >(GetAvailableCamerasInInventoryDocument, {}, options);
}
export type GetAvailableCamerasInInventoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAvailableCamerasInInventoryQuery,
  GetAvailableCamerasInInventoryQueryVariables
>;
export const GetCameraForFormDocument = gql`
  query getCameraForForm($cameraId: ID!) {
    getCamera(cameraId: $cameraId) {
      id
      isConfiguredInRegistry
      deviceGroup {
        id
        name
      }
      name
      macAddress
      modelName
      manufacturer
      anonymization {
        supports
        requirement
      }
    }
  }
`;

/**
 * __useGetCameraForFormQuery__
 *
 * To run a query within a Vue component, call `useGetCameraForFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraForFormQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraForFormQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useGetCameraForFormQuery(
  variables:
    | GetCameraForFormQueryVariables
    | VueCompositionApi.Ref<GetCameraForFormQueryVariables>
    | ReactiveFunction<GetCameraForFormQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraForFormQuery, GetCameraForFormQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraForFormQuery, GetCameraForFormQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraForFormQuery, GetCameraForFormQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetCameraForFormQuery, GetCameraForFormQueryVariables>(
    GetCameraForFormDocument,
    variables,
    options,
  );
}
export function useGetCameraForFormLazyQuery(
  variables?:
    | GetCameraForFormQueryVariables
    | VueCompositionApi.Ref<GetCameraForFormQueryVariables>
    | ReactiveFunction<GetCameraForFormQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraForFormQuery, GetCameraForFormQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraForFormQuery, GetCameraForFormQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraForFormQuery, GetCameraForFormQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraForFormQuery, GetCameraForFormQueryVariables>(
    GetCameraForFormDocument,
    variables,
    options,
  );
}
export type GetCameraForFormQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraForFormQuery,
  GetCameraForFormQueryVariables
>;
export const GetCameraAdminDocument = gql`
  query getCameraAdmin($cameraId: ID!) {
    getCameraAdmin(cameraId: $cameraId) {
      id
      online
      firmware
      adminApps {
        id
        name
        status
        profiles {
          id
          name
          accountTemplate {
            code
            title
            displayText
            icon
          }
          patientTemplate {
            code
            title
            displayText
            icon
          }
          cameraTopic
        }
      }
      router {
        mac
        vendor
      }
      mqttClientStatus {
        state
        connectionStatus
      }
    }
  }
`;

/**
 * __useGetCameraAdminQuery__
 *
 * To run a query within a Vue component, call `useGetCameraAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraAdminQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraAdminQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useGetCameraAdminQuery(
  variables:
    | GetCameraAdminQueryVariables
    | VueCompositionApi.Ref<GetCameraAdminQueryVariables>
    | ReactiveFunction<GetCameraAdminQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraAdminQuery, GetCameraAdminQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraAdminQuery, GetCameraAdminQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraAdminQuery, GetCameraAdminQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetCameraAdminQuery, GetCameraAdminQueryVariables>(
    GetCameraAdminDocument,
    variables,
    options,
  );
}
export function useGetCameraAdminLazyQuery(
  variables?:
    | GetCameraAdminQueryVariables
    | VueCompositionApi.Ref<GetCameraAdminQueryVariables>
    | ReactiveFunction<GetCameraAdminQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraAdminQuery, GetCameraAdminQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCameraAdminQuery, GetCameraAdminQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCameraAdminQuery, GetCameraAdminQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraAdminQuery, GetCameraAdminQueryVariables>(
    GetCameraAdminDocument,
    variables,
    options,
  );
}
export type GetCameraAdminQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraAdminQuery,
  GetCameraAdminQueryVariables
>;
export const SetPatientCamerasInPrivacyModeDocument = gql`
  mutation setPatientCamerasInPrivacyMode($patientId: ID!, $seconds: Int) {
    setPatientCamerasInPrivacyMode(patientId: $patientId, seconds: $seconds) {
      success
    }
  }
`;

/**
 * __useSetPatientCamerasInPrivacyModeMutation__
 *
 * To run a mutation, you first call `useSetPatientCamerasInPrivacyModeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetPatientCamerasInPrivacyModeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetPatientCamerasInPrivacyModeMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     seconds: // value for 'seconds'
 *   },
 * });
 */
export function useSetPatientCamerasInPrivacyModeMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SetPatientCamerasInPrivacyModeMutation,
        SetPatientCamerasInPrivacyModeMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SetPatientCamerasInPrivacyModeMutation,
          SetPatientCamerasInPrivacyModeMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SetPatientCamerasInPrivacyModeMutation,
    SetPatientCamerasInPrivacyModeMutationVariables
  >(SetPatientCamerasInPrivacyModeDocument, options);
}
export type SetPatientCamerasInPrivacyModeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SetPatientCamerasInPrivacyModeMutation,
  SetPatientCamerasInPrivacyModeMutationVariables
>;
export const UnsetPatientCamerasFromPrivacyModeDocument = gql`
  mutation unsetPatientCamerasFromPrivacyMode($patientId: ID!) {
    unsetPatientCamerasFromPrivacyMode(patientId: $patientId) {
      success
    }
  }
`;

/**
 * __useUnsetPatientCamerasFromPrivacyModeMutation__
 *
 * To run a mutation, you first call `useUnsetPatientCamerasFromPrivacyModeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnsetPatientCamerasFromPrivacyModeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnsetPatientCamerasFromPrivacyModeMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useUnsetPatientCamerasFromPrivacyModeMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UnsetPatientCamerasFromPrivacyModeMutation,
        UnsetPatientCamerasFromPrivacyModeMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UnsetPatientCamerasFromPrivacyModeMutation,
          UnsetPatientCamerasFromPrivacyModeMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UnsetPatientCamerasFromPrivacyModeMutation,
    UnsetPatientCamerasFromPrivacyModeMutationVariables
  >(UnsetPatientCamerasFromPrivacyModeDocument, options);
}
export type UnsetPatientCamerasFromPrivacyModeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UnsetPatientCamerasFromPrivacyModeMutation,
  UnsetPatientCamerasFromPrivacyModeMutationVariables
>;
export const GetDeviceModelNumberByIdDocument = gql`
  query getDeviceModelNumberById($id: ID!) {
    getWelfareDevice(id: $id) {
      id
      modelNumber
    }
  }
`;

/**
 * __useGetDeviceModelNumberByIdQuery__
 *
 * To run a query within a Vue component, call `useGetDeviceModelNumberByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceModelNumberByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeviceModelNumberByIdQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDeviceModelNumberByIdQuery(
  variables:
    | GetDeviceModelNumberByIdQueryVariables
    | VueCompositionApi.Ref<GetDeviceModelNumberByIdQueryVariables>
    | ReactiveFunction<GetDeviceModelNumberByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>(
    GetDeviceModelNumberByIdDocument,
    variables,
    options,
  );
}
export function useGetDeviceModelNumberByIdLazyQuery(
  variables?:
    | GetDeviceModelNumberByIdQueryVariables
    | VueCompositionApi.Ref<GetDeviceModelNumberByIdQueryVariables>
    | ReactiveFunction<GetDeviceModelNumberByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetDeviceModelNumberByIdQuery, GetDeviceModelNumberByIdQueryVariables>(
    GetDeviceModelNumberByIdDocument,
    variables,
    options,
  );
}
export type GetDeviceModelNumberByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDeviceModelNumberByIdQuery,
  GetDeviceModelNumberByIdQueryVariables
>;
export const GetDeviceNameByIdDocument = gql`
  query getDeviceNameById($id: ID!) {
    getWelfareDevice(id: $id) {
      id
      deviceName {
        name
      }
    }
  }
`;

/**
 * __useGetDeviceNameByIdQuery__
 *
 * To run a query within a Vue component, call `useGetDeviceNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceNameByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeviceNameByIdQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDeviceNameByIdQuery(
  variables:
    | GetDeviceNameByIdQueryVariables
    | VueCompositionApi.Ref<GetDeviceNameByIdQueryVariables>
    | ReactiveFunction<GetDeviceNameByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>(
    GetDeviceNameByIdDocument,
    variables,
    options,
  );
}
export function useGetDeviceNameByIdLazyQuery(
  variables?:
    | GetDeviceNameByIdQueryVariables
    | VueCompositionApi.Ref<GetDeviceNameByIdQueryVariables>
    | ReactiveFunction<GetDeviceNameByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetDeviceNameByIdQuery, GetDeviceNameByIdQueryVariables>(
    GetDeviceNameByIdDocument,
    variables,
    options,
  );
}
export type GetDeviceNameByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDeviceNameByIdQuery,
  GetDeviceNameByIdQueryVariables
>;
export const GetWelfareDeviceDocument = gql`
  query getWelfareDevice($id: ID!) {
    getWelfareDevice(id: $id) {
      id
      uniqueIdentifier
      modelNumber
      property {
        callbackPhoneNumber
        pin
      }
      deviceName {
        name
      }
      deviceGroup {
        name
        id
      }
      tags
    }
  }
`;

/**
 * __useGetWelfareDeviceQuery__
 *
 * To run a query within a Vue component, call `useGetWelfareDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWelfareDeviceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWelfareDeviceQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetWelfareDeviceQuery(
  variables:
    | GetWelfareDeviceQueryVariables
    | VueCompositionApi.Ref<GetWelfareDeviceQueryVariables>
    | ReactiveFunction<GetWelfareDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetWelfareDeviceQuery, GetWelfareDeviceQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetWelfareDeviceQuery, GetWelfareDeviceQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetWelfareDeviceQuery, GetWelfareDeviceQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetWelfareDeviceQuery, GetWelfareDeviceQueryVariables>(
    GetWelfareDeviceDocument,
    variables,
    options,
  );
}
export function useGetWelfareDeviceLazyQuery(
  variables?:
    | GetWelfareDeviceQueryVariables
    | VueCompositionApi.Ref<GetWelfareDeviceQueryVariables>
    | ReactiveFunction<GetWelfareDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetWelfareDeviceQuery, GetWelfareDeviceQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetWelfareDeviceQuery, GetWelfareDeviceQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetWelfareDeviceQuery, GetWelfareDeviceQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetWelfareDeviceQuery, GetWelfareDeviceQueryVariables>(
    GetWelfareDeviceDocument,
    variables,
    options,
  );
}
export type GetWelfareDeviceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetWelfareDeviceQuery,
  GetWelfareDeviceQueryVariables
>;
export const GetAllTechnicalAlarmEventsForDevicePaginatedDocument = gql`
  query getAllTechnicalAlarmEventsForDevicePaginated(
    $deviceId: String!
    $from: dateTime
    $to: dateTime
    $limit: Int
    $cursor: cursor = ""
  ) {
    getAllTechnicalAlarmEventsForDevicePaginated(
      deviceId: $deviceId
      from: $from
      to: $to
      limit: $limit
      cursor: $cursor
    ) {
      cursor
      events {
        id
        code {
          coding {
            code
            display
            system
          }
        }
        effectiveDateTime
        status
        handlingStatuses {
          handler
          initiatedAt
          attempts {
            startedAt
            doneAt
            status
            handledBy
            payload
            rawResponse
            rawStatus
            details
          }
        }
      }
    }
  }
`;

/**
 * __useGetAllTechnicalAlarmEventsForDevicePaginatedQuery__
 *
 * To run a query within a Vue component, call `useGetAllTechnicalAlarmEventsForDevicePaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTechnicalAlarmEventsForDevicePaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllTechnicalAlarmEventsForDevicePaginatedQuery({
 *   deviceId: // value for 'deviceId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 * });
 */
export function useGetAllTechnicalAlarmEventsForDevicePaginatedQuery(
  variables:
    | GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
    | VueCompositionApi.Ref<GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables>
    | ReactiveFunction<GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
        GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
          GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
          GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
    GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
  >(GetAllTechnicalAlarmEventsForDevicePaginatedDocument, variables, options);
}
export function useGetAllTechnicalAlarmEventsForDevicePaginatedLazyQuery(
  variables?:
    | GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
    | VueCompositionApi.Ref<GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables>
    | ReactiveFunction<GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
        GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
          GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
          GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
    GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
  >(GetAllTechnicalAlarmEventsForDevicePaginatedDocument, variables, options);
}
export type GetAllTechnicalAlarmEventsForDevicePaginatedQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetAllTechnicalAlarmEventsForDevicePaginatedQuery,
    GetAllTechnicalAlarmEventsForDevicePaginatedQueryVariables
  >;
export const AddNextOfKinInImportComponentDocument = gql`
  mutation addNextOfKinInImportComponent($patientId: ID!, $nextOfKinInput: CreateNextOfKinInput!) {
    addNextOfKin(patientId: $patientId, nextOfKinInput: $nextOfKinInput) {
      success
      message
      nextOfKin {
        id
      }
    }
  }
`;

/**
 * __useAddNextOfKinInImportComponentMutation__
 *
 * To run a mutation, you first call `useAddNextOfKinInImportComponentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddNextOfKinInImportComponentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddNextOfKinInImportComponentMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     nextOfKinInput: // value for 'nextOfKinInput'
 *   },
 * });
 */
export function useAddNextOfKinInImportComponentMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddNextOfKinInImportComponentMutation,
        AddNextOfKinInImportComponentMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddNextOfKinInImportComponentMutation,
          AddNextOfKinInImportComponentMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddNextOfKinInImportComponentMutation,
    AddNextOfKinInImportComponentMutationVariables
  >(AddNextOfKinInImportComponentDocument, options);
}
export type AddNextOfKinInImportComponentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddNextOfKinInImportComponentMutation,
  AddNextOfKinInImportComponentMutationVariables
>;
export const UpdateNextOfKinInImportComponentDocument = gql`
  mutation updateNextOfKinInImportComponent($nokId: ID!, $nextOfKinInput: UpdateNextOfKinInput!) {
    updateNextOfKin(nokId: $nokId, nextOfKinInput: $nextOfKinInput) {
      success
      message
    }
  }
`;

/**
 * __useUpdateNextOfKinInImportComponentMutation__
 *
 * To run a mutation, you first call `useUpdateNextOfKinInImportComponentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNextOfKinInImportComponentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateNextOfKinInImportComponentMutation({
 *   variables: {
 *     nokId: // value for 'nokId'
 *     nextOfKinInput: // value for 'nextOfKinInput'
 *   },
 * });
 */
export function useUpdateNextOfKinInImportComponentMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateNextOfKinInImportComponentMutation,
        UpdateNextOfKinInImportComponentMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateNextOfKinInImportComponentMutation,
          UpdateNextOfKinInImportComponentMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateNextOfKinInImportComponentMutation,
    UpdateNextOfKinInImportComponentMutationVariables
  >(UpdateNextOfKinInImportComponentDocument, options);
}
export type UpdateNextOfKinInImportComponentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateNextOfKinInImportComponentMutation,
  UpdateNextOfKinInImportComponentMutationVariables
>;
export const MarkNextOfKinAsMainDocument = gql`
  mutation markNextOfKinAsMain($nokId: ID!) {
    markNextOfKinAsMain(nokId: $nokId) {
      success
      message
    }
  }
`;

/**
 * __useMarkNextOfKinAsMainMutation__
 *
 * To run a mutation, you first call `useMarkNextOfKinAsMainMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkNextOfKinAsMainMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkNextOfKinAsMainMutation({
 *   variables: {
 *     nokId: // value for 'nokId'
 *   },
 * });
 */
export function useMarkNextOfKinAsMainMutation(
  options:
    | VueApolloComposable.UseMutationOptions<MarkNextOfKinAsMainMutation, MarkNextOfKinAsMainMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<MarkNextOfKinAsMainMutation, MarkNextOfKinAsMainMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<MarkNextOfKinAsMainMutation, MarkNextOfKinAsMainMutationVariables>(
    MarkNextOfKinAsMainDocument,
    options,
  );
}
export type MarkNextOfKinAsMainMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  MarkNextOfKinAsMainMutation,
  MarkNextOfKinAsMainMutationVariables
>;
export const AddPatientContactDocument = gql`
  mutation addPatientContact($patientId: ID!, $contact: CreateContactInput!) {
    addPatientContact(patientId: $patientId, contact: $contact) {
      success
    }
  }
`;

/**
 * __useAddPatientContactMutation__
 *
 * To run a mutation, you first call `useAddPatientContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddPatientContactMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     contact: // value for 'contact'
 *   },
 * });
 */
export function useAddPatientContactMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddPatientContactMutation, AddPatientContactMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddPatientContactMutation, AddPatientContactMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddPatientContactMutation, AddPatientContactMutationVariables>(
    AddPatientContactDocument,
    options,
  );
}
export type AddPatientContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddPatientContactMutation,
  AddPatientContactMutationVariables
>;
export const AddUserGroupContactDocument = gql`
  mutation addUserGroupContact($userGroupId: ID!, $contact: CreateContactInput!) {
    addUserGroupContact(userGroupId: $userGroupId, contact: $contact) {
      success
    }
  }
`;

/**
 * __useAddUserGroupContactMutation__
 *
 * To run a mutation, you first call `useAddUserGroupContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddUserGroupContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddUserGroupContactMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     contact: // value for 'contact'
 *   },
 * });
 */
export function useAddUserGroupContactMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddUserGroupContactMutation, AddUserGroupContactMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddUserGroupContactMutation, AddUserGroupContactMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddUserGroupContactMutation, AddUserGroupContactMutationVariables>(
    AddUserGroupContactDocument,
    options,
  );
}
export type AddUserGroupContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddUserGroupContactMutation,
  AddUserGroupContactMutationVariables
>;
export const CreateUserGroupForImportComponentDocument = gql`
  mutation createUserGroupForImportComponent($newUserGroup: CreateUserGroupInput!, $parentUserGroupId: ID!) {
    createUserGroup(parentId: $parentUserGroupId, userGroup: $newUserGroup) {
      success
      message
      userGroup {
        id
      }
    }
  }
`;

/**
 * __useCreateUserGroupForImportComponentMutation__
 *
 * To run a mutation, you first call `useCreateUserGroupForImportComponentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserGroupForImportComponentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUserGroupForImportComponentMutation({
 *   variables: {
 *     newUserGroup: // value for 'newUserGroup'
 *     parentUserGroupId: // value for 'parentUserGroupId'
 *   },
 * });
 */
export function useCreateUserGroupForImportComponentMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateUserGroupForImportComponentMutation,
        CreateUserGroupForImportComponentMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateUserGroupForImportComponentMutation,
          CreateUserGroupForImportComponentMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateUserGroupForImportComponentMutation,
    CreateUserGroupForImportComponentMutationVariables
  >(CreateUserGroupForImportComponentDocument, options);
}
export type CreateUserGroupForImportComponentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateUserGroupForImportComponentMutation,
  CreateUserGroupForImportComponentMutationVariables
>;
export const UpdateUserGroupForImportComponentDocument = gql`
  mutation updateUserGroupForImportComponent($userGroup: UpdateUserGroupInput!, $userGroupId: ID!) {
    updateUserGroup(userGroupId: $userGroupId, userGroup: $userGroup) {
      success
      userGroup {
        id
      }
    }
  }
`;

/**
 * __useUpdateUserGroupForImportComponentMutation__
 *
 * To run a mutation, you first call `useUpdateUserGroupForImportComponentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGroupForImportComponentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserGroupForImportComponentMutation({
 *   variables: {
 *     userGroup: // value for 'userGroup'
 *     userGroupId: // value for 'userGroupId'
 *   },
 * });
 */
export function useUpdateUserGroupForImportComponentMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateUserGroupForImportComponentMutation,
        UpdateUserGroupForImportComponentMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateUserGroupForImportComponentMutation,
          UpdateUserGroupForImportComponentMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateUserGroupForImportComponentMutation,
    UpdateUserGroupForImportComponentMutationVariables
  >(UpdateUserGroupForImportComponentDocument, options);
}
export type UpdateUserGroupForImportComponentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateUserGroupForImportComponentMutation,
  UpdateUserGroupForImportComponentMutationVariables
>;
export const UpdateUserGroupContactDocument = gql`
  mutation updateUserGroupContact($userGroupId: ID!, $contact: UpdateContactInput!) {
    updateUserGroupContact(userGroupId: $userGroupId, contact: $contact) {
      success
    }
  }
`;

/**
 * __useUpdateUserGroupContactMutation__
 *
 * To run a mutation, you first call `useUpdateUserGroupContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGroupContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserGroupContactMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     contact: // value for 'contact'
 *   },
 * });
 */
export function useUpdateUserGroupContactMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateUserGroupContactMutation, UpdateUserGroupContactMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateUserGroupContactMutation, UpdateUserGroupContactMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateUserGroupContactMutation, UpdateUserGroupContactMutationVariables>(
    UpdateUserGroupContactDocument,
    options,
  );
}
export type UpdateUserGroupContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateUserGroupContactMutation,
  UpdateUserGroupContactMutationVariables
>;
export const UpdatePatientGroupsOfPatientDocument = gql`
  mutation updatePatientGroupsOfPatient(
    $addPatientGroups: [String!]
    $removePatientGroups: [String!]
    $patientId: ID!
  ) {
    updatePatientGroupsOfPatient(
      addPatientGroups: $addPatientGroups
      removePatientGroups: $removePatientGroups
      patientId: $patientId
    ) {
      success
    }
  }
`;

/**
 * __useUpdatePatientGroupsOfPatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientGroupsOfPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientGroupsOfPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientGroupsOfPatientMutation({
 *   variables: {
 *     addPatientGroups: // value for 'addPatientGroups'
 *     removePatientGroups: // value for 'removePatientGroups'
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useUpdatePatientGroupsOfPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdatePatientGroupsOfPatientMutation,
        UpdatePatientGroupsOfPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdatePatientGroupsOfPatientMutation,
          UpdatePatientGroupsOfPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdatePatientGroupsOfPatientMutation,
    UpdatePatientGroupsOfPatientMutationVariables
  >(UpdatePatientGroupsOfPatientDocument, options);
}
export type UpdatePatientGroupsOfPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientGroupsOfPatientMutation,
  UpdatePatientGroupsOfPatientMutationVariables
>;
export const PatientsForImportDocument = gql`
  query patientsForImport {
    patientsForImport {
      id
      externalIds {
        type
        id
      }
      contacts {
        id
        name
      }
      nextOfKins {
        id
        name {
          given
          family
          text
        }
      }
      patientGroups {
        id
        name
      }
    }
  }
`;

/**
 * __usePatientsForImportQuery__
 *
 * To run a query within a Vue component, call `usePatientsForImportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientsForImportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientsForImportQuery();
 */
export function usePatientsForImportQuery(
  options:
    | VueApolloComposable.UseQueryOptions<PatientsForImportQuery, PatientsForImportQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientsForImportQuery, PatientsForImportQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientsForImportQuery, PatientsForImportQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientsForImportQuery, PatientsForImportQueryVariables>(
    PatientsForImportDocument,
    {},
    options,
  );
}
export function usePatientsForImportLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<PatientsForImportQuery, PatientsForImportQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientsForImportQuery, PatientsForImportQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientsForImportQuery, PatientsForImportQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientsForImportQuery, PatientsForImportQueryVariables>(
    PatientsForImportDocument,
    {},
    options,
  );
}
export type PatientsForImportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientsForImportQuery,
  PatientsForImportQueryVariables
>;
export const UserGroupForImportComponentDocument = gql`
  query userGroupForImportComponent($id: ID) {
    userGroup(userGroupId: $id) {
      id
      name
      type
      patientGroups {
        id
        name
        patientsCount
      }
      subTree {
        id
        name
        type
        rules
        parentId
        roles {
          id
          roleDefinitionId
          display {
            key
            value
          }
          protected
        }
        patientGroups {
          id
          name
          patientsCount
        }
        contacts {
          id
          name
          telecom {
            system
            value
          }
        }
      }
      contacts {
        id
        name
        telecom {
          system
          value
        }
      }
    }
  }
`;

/**
 * __useUserGroupForImportComponentQuery__
 *
 * To run a query within a Vue component, call `useUserGroupForImportComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupForImportComponentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupForImportComponentQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserGroupForImportComponentQuery(
  variables:
    | UserGroupForImportComponentQueryVariables
    | VueCompositionApi.Ref<UserGroupForImportComponentQueryVariables>
    | ReactiveFunction<UserGroupForImportComponentQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>(
    UserGroupForImportComponentDocument,
    variables,
    options,
  );
}
export function useUserGroupForImportComponentLazyQuery(
  variables:
    | UserGroupForImportComponentQueryVariables
    | VueCompositionApi.Ref<UserGroupForImportComponentQueryVariables>
    | ReactiveFunction<UserGroupForImportComponentQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupForImportComponentQuery, UserGroupForImportComponentQueryVariables>(
    UserGroupForImportComponentDocument,
    variables,
    options,
  );
}
export type UserGroupForImportComponentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupForImportComponentQuery,
  UserGroupForImportComponentQueryVariables
>;
export const GetIotcommsLogsDocument = gql`
  query getIotcommsLogs($fields: [String!], $limit: Int, $observationId: String!) {
    getIotcommsLogs(fields: $fields, limit: $limit, observationId: $observationId) {
      success
      message
      logs
    }
  }
`;

/**
 * __useGetIotcommsLogsQuery__
 *
 * To run a query within a Vue component, call `useGetIotcommsLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIotcommsLogsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetIotcommsLogsQuery({
 *   fields: // value for 'fields'
 *   limit: // value for 'limit'
 *   observationId: // value for 'observationId'
 * });
 */
export function useGetIotcommsLogsQuery(
  variables:
    | GetIotcommsLogsQueryVariables
    | VueCompositionApi.Ref<GetIotcommsLogsQueryVariables>
    | ReactiveFunction<GetIotcommsLogsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetIotcommsLogsQuery, GetIotcommsLogsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIotcommsLogsQuery, GetIotcommsLogsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIotcommsLogsQuery, GetIotcommsLogsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetIotcommsLogsQuery, GetIotcommsLogsQueryVariables>(
    GetIotcommsLogsDocument,
    variables,
    options,
  );
}
export function useGetIotcommsLogsLazyQuery(
  variables?:
    | GetIotcommsLogsQueryVariables
    | VueCompositionApi.Ref<GetIotcommsLogsQueryVariables>
    | ReactiveFunction<GetIotcommsLogsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetIotcommsLogsQuery, GetIotcommsLogsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIotcommsLogsQuery, GetIotcommsLogsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIotcommsLogsQuery, GetIotcommsLogsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetIotcommsLogsQuery, GetIotcommsLogsQueryVariables>(
    GetIotcommsLogsDocument,
    variables,
    options,
  );
}
export type GetIotcommsLogsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetIotcommsLogsQuery,
  GetIotcommsLogsQueryVariables
>;
export const SimulateNovoEventDocument = gql`
  mutation simulateNovoEvent($event: NovoEventInput!) {
    simulateNovoEvent(event: $event) {
      success
      message
    }
  }
`;

/**
 * __useSimulateNovoEventMutation__
 *
 * To run a mutation, you first call `useSimulateNovoEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSimulateNovoEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSimulateNovoEventMutation({
 *   variables: {
 *     event: // value for 'event'
 *   },
 * });
 */
export function useSimulateNovoEventMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SimulateNovoEventMutation, SimulateNovoEventMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SimulateNovoEventMutation, SimulateNovoEventMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SimulateNovoEventMutation, SimulateNovoEventMutationVariables>(
    SimulateNovoEventDocument,
    options,
  );
}
export type SimulateNovoEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SimulateNovoEventMutation,
  SimulateNovoEventMutationVariables
>;
export const GetDeviceByIdForOpenTechnicalAlarmDocument = gql`
  query getDeviceByIdForOpenTechnicalAlarm($id: ID!) {
    getWelfareDevice(id: $id) {
      id
      uniqueIdentifier
      modelNumber
      userFriendlyName
      serialNumber
      deviceName {
        name
      }
      deviceGroup {
        name
        id
      }
      tags
    }
  }
`;

/**
 * __useGetDeviceByIdForOpenTechnicalAlarmQuery__
 *
 * To run a query within a Vue component, call `useGetDeviceByIdForOpenTechnicalAlarmQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceByIdForOpenTechnicalAlarmQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeviceByIdForOpenTechnicalAlarmQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDeviceByIdForOpenTechnicalAlarmQuery(
  variables:
    | GetDeviceByIdForOpenTechnicalAlarmQueryVariables
    | VueCompositionApi.Ref<GetDeviceByIdForOpenTechnicalAlarmQueryVariables>
    | ReactiveFunction<GetDeviceByIdForOpenTechnicalAlarmQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetDeviceByIdForOpenTechnicalAlarmQuery,
        GetDeviceByIdForOpenTechnicalAlarmQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetDeviceByIdForOpenTechnicalAlarmQuery,
          GetDeviceByIdForOpenTechnicalAlarmQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetDeviceByIdForOpenTechnicalAlarmQuery,
          GetDeviceByIdForOpenTechnicalAlarmQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetDeviceByIdForOpenTechnicalAlarmQuery,
    GetDeviceByIdForOpenTechnicalAlarmQueryVariables
  >(GetDeviceByIdForOpenTechnicalAlarmDocument, variables, options);
}
export function useGetDeviceByIdForOpenTechnicalAlarmLazyQuery(
  variables?:
    | GetDeviceByIdForOpenTechnicalAlarmQueryVariables
    | VueCompositionApi.Ref<GetDeviceByIdForOpenTechnicalAlarmQueryVariables>
    | ReactiveFunction<GetDeviceByIdForOpenTechnicalAlarmQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetDeviceByIdForOpenTechnicalAlarmQuery,
        GetDeviceByIdForOpenTechnicalAlarmQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetDeviceByIdForOpenTechnicalAlarmQuery,
          GetDeviceByIdForOpenTechnicalAlarmQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetDeviceByIdForOpenTechnicalAlarmQuery,
          GetDeviceByIdForOpenTechnicalAlarmQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetDeviceByIdForOpenTechnicalAlarmQuery,
    GetDeviceByIdForOpenTechnicalAlarmQueryVariables
  >(GetDeviceByIdForOpenTechnicalAlarmDocument, variables, options);
}
export type GetDeviceByIdForOpenTechnicalAlarmQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDeviceByIdForOpenTechnicalAlarmQuery,
  GetDeviceByIdForOpenTechnicalAlarmQueryVariables
>;
export const GetCameraForOpenTechnicalAlarmDocument = gql`
  query getCameraForOpenTechnicalAlarm($cameraId: ID!) {
    getCamera(cameraId: $cameraId) {
      id
      isConfiguredInRegistry
      deviceGroup {
        id
        name
      }
      name
      macAddress
      modelName
      manufacturer
    }
  }
`;

/**
 * __useGetCameraForOpenTechnicalAlarmQuery__
 *
 * To run a query within a Vue component, call `useGetCameraForOpenTechnicalAlarmQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraForOpenTechnicalAlarmQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraForOpenTechnicalAlarmQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useGetCameraForOpenTechnicalAlarmQuery(
  variables:
    | GetCameraForOpenTechnicalAlarmQueryVariables
    | VueCompositionApi.Ref<GetCameraForOpenTechnicalAlarmQueryVariables>
    | ReactiveFunction<GetCameraForOpenTechnicalAlarmQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetCameraForOpenTechnicalAlarmQuery,
        GetCameraForOpenTechnicalAlarmQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetCameraForOpenTechnicalAlarmQuery,
          GetCameraForOpenTechnicalAlarmQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetCameraForOpenTechnicalAlarmQuery,
          GetCameraForOpenTechnicalAlarmQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetCameraForOpenTechnicalAlarmQuery,
    GetCameraForOpenTechnicalAlarmQueryVariables
  >(GetCameraForOpenTechnicalAlarmDocument, variables, options);
}
export function useGetCameraForOpenTechnicalAlarmLazyQuery(
  variables?:
    | GetCameraForOpenTechnicalAlarmQueryVariables
    | VueCompositionApi.Ref<GetCameraForOpenTechnicalAlarmQueryVariables>
    | ReactiveFunction<GetCameraForOpenTechnicalAlarmQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetCameraForOpenTechnicalAlarmQuery,
        GetCameraForOpenTechnicalAlarmQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetCameraForOpenTechnicalAlarmQuery,
          GetCameraForOpenTechnicalAlarmQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetCameraForOpenTechnicalAlarmQuery,
          GetCameraForOpenTechnicalAlarmQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetCameraForOpenTechnicalAlarmQuery,
    GetCameraForOpenTechnicalAlarmQueryVariables
  >(GetCameraForOpenTechnicalAlarmDocument, variables, options);
}
export type GetCameraForOpenTechnicalAlarmQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraForOpenTechnicalAlarmQuery,
  GetCameraForOpenTechnicalAlarmQueryVariables
>;
export const PutPatientAlarmHandlingPlanOnHoldDocument = gql`
  mutation putPatientAlarmHandlingPlanOnHold($patientId: ID!) {
    putPatientAlarmHandlingPlanOnHold(patientId: $patientId) {
      success
    }
  }
`;

/**
 * __usePutPatientAlarmHandlingPlanOnHoldMutation__
 *
 * To run a mutation, you first call `usePutPatientAlarmHandlingPlanOnHoldMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePutPatientAlarmHandlingPlanOnHoldMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePutPatientAlarmHandlingPlanOnHoldMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function usePutPatientAlarmHandlingPlanOnHoldMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        PutPatientAlarmHandlingPlanOnHoldMutation,
        PutPatientAlarmHandlingPlanOnHoldMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          PutPatientAlarmHandlingPlanOnHoldMutation,
          PutPatientAlarmHandlingPlanOnHoldMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    PutPatientAlarmHandlingPlanOnHoldMutation,
    PutPatientAlarmHandlingPlanOnHoldMutationVariables
  >(PutPatientAlarmHandlingPlanOnHoldDocument, options);
}
export type PutPatientAlarmHandlingPlanOnHoldMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  PutPatientAlarmHandlingPlanOnHoldMutation,
  PutPatientAlarmHandlingPlanOnHoldMutationVariables
>;
export const ResumePatientAlarmHandlingPlanDocument = gql`
  mutation resumePatientAlarmHandlingPlan($patientId: ID!) {
    resumePatientAlarmHandlingPlan(patientId: $patientId) {
      success
    }
  }
`;

/**
 * __useResumePatientAlarmHandlingPlanMutation__
 *
 * To run a mutation, you first call `useResumePatientAlarmHandlingPlanMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResumePatientAlarmHandlingPlanMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResumePatientAlarmHandlingPlanMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useResumePatientAlarmHandlingPlanMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ResumePatientAlarmHandlingPlanMutation,
        ResumePatientAlarmHandlingPlanMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ResumePatientAlarmHandlingPlanMutation,
          ResumePatientAlarmHandlingPlanMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ResumePatientAlarmHandlingPlanMutation,
    ResumePatientAlarmHandlingPlanMutationVariables
  >(ResumePatientAlarmHandlingPlanDocument, options);
}
export type ResumePatientAlarmHandlingPlanMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ResumePatientAlarmHandlingPlanMutation,
  ResumePatientAlarmHandlingPlanMutationVariables
>;
export const CreateUnplannedSupervisionDocument = gql`
  mutation createUnplannedSupervision($patientId: ID!) {
    createUnplannedSupervision(patientId: $patientId) {
      success
      message
      task {
        id
      }
    }
  }
`;

/**
 * __useCreateUnplannedSupervisionMutation__
 *
 * To run a mutation, you first call `useCreateUnplannedSupervisionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnplannedSupervisionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateUnplannedSupervisionMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useCreateUnplannedSupervisionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CreateUnplannedSupervisionMutation,
        CreateUnplannedSupervisionMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateUnplannedSupervisionMutation,
          CreateUnplannedSupervisionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CreateUnplannedSupervisionMutation,
    CreateUnplannedSupervisionMutationVariables
  >(CreateUnplannedSupervisionDocument, options);
}
export type CreateUnplannedSupervisionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateUnplannedSupervisionMutation,
  CreateUnplannedSupervisionMutationVariables
>;
export const SimulateSafemateEventDocument = gql`
  mutation simulateSafemateEvent($event: SafemateEventInput!) {
    simulateSafemateEvent(event: $event) {
      success
      message
    }
  }
`;

/**
 * __useSimulateSafemateEventMutation__
 *
 * To run a mutation, you first call `useSimulateSafemateEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSimulateSafemateEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSimulateSafemateEventMutation({
 *   variables: {
 *     event: // value for 'event'
 *   },
 * });
 */
export function useSimulateSafemateEventMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SimulateSafemateEventMutation, SimulateSafemateEventMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SimulateSafemateEventMutation, SimulateSafemateEventMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SimulateSafemateEventMutation, SimulateSafemateEventMutationVariables>(
    SimulateSafemateEventDocument,
    options,
  );
}
export type SimulateSafemateEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SimulateSafemateEventMutation,
  SimulateSafemateEventMutationVariables
>;
export const SimulateSkyResponseEventDocument = gql`
  mutation simulateSkyResponseEvent(
    $patientId: ID!
    $externalAccessId: ID!
    $templateId: ID!
    $event: SkyresponseEventInput!
  ) {
    simulateSkyResponseEvent(
      patientId: $patientId
      externalAccessId: $externalAccessId
      templateId: $templateId
      event: $event
    ) {
      success
      message
    }
  }
`;

/**
 * __useSimulateSkyResponseEventMutation__
 *
 * To run a mutation, you first call `useSimulateSkyResponseEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSimulateSkyResponseEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSimulateSkyResponseEventMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     externalAccessId: // value for 'externalAccessId'
 *     templateId: // value for 'templateId'
 *     event: // value for 'event'
 *   },
 * });
 */
export function useSimulateSkyResponseEventMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SimulateSkyResponseEventMutation,
        SimulateSkyResponseEventMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SimulateSkyResponseEventMutation,
          SimulateSkyResponseEventMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<SimulateSkyResponseEventMutation, SimulateSkyResponseEventMutationVariables>(
    SimulateSkyResponseEventDocument,
    options,
  );
}
export type SimulateSkyResponseEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SimulateSkyResponseEventMutation,
  SimulateSkyResponseEventMutationVariables
>;
export const GetAvailableWelfareDevicesInInventoryDocument = gql`
  query getAvailableWelfareDevicesInInventory {
    getAvailableWelfareDevicesInInventory {
      uniqueIdentifier
      modelNumber
    }
  }
`;

/**
 * __useGetAvailableWelfareDevicesInInventoryQuery__
 *
 * To run a query within a Vue component, call `useGetAvailableWelfareDevicesInInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableWelfareDevicesInInventoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAvailableWelfareDevicesInInventoryQuery();
 */
export function useGetAvailableWelfareDevicesInInventoryQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAvailableWelfareDevicesInInventoryQuery,
        GetAvailableWelfareDevicesInInventoryQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAvailableWelfareDevicesInInventoryQuery,
          GetAvailableWelfareDevicesInInventoryQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAvailableWelfareDevicesInInventoryQuery,
          GetAvailableWelfareDevicesInInventoryQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAvailableWelfareDevicesInInventoryQuery,
    GetAvailableWelfareDevicesInInventoryQueryVariables
  >(GetAvailableWelfareDevicesInInventoryDocument, {}, options);
}
export function useGetAvailableWelfareDevicesInInventoryLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAvailableWelfareDevicesInInventoryQuery,
        GetAvailableWelfareDevicesInInventoryQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAvailableWelfareDevicesInInventoryQuery,
          GetAvailableWelfareDevicesInInventoryQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAvailableWelfareDevicesInInventoryQuery,
          GetAvailableWelfareDevicesInInventoryQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAvailableWelfareDevicesInInventoryQuery,
    GetAvailableWelfareDevicesInInventoryQueryVariables
  >(GetAvailableWelfareDevicesInInventoryDocument, {}, options);
}
export type GetAvailableWelfareDevicesInInventoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAvailableWelfareDevicesInInventoryQuery,
  GetAvailableWelfareDevicesInInventoryQueryVariables
>;
export const GetAlarmTemplatesForTemplateCepDocument = gql`
  query getAlarmTemplatesForTemplateCep {
    getAlarmTemplates {
      id
      technical
      alarmIcon
      identifier {
        value
      }
      status
      code {
        coding {
          display
          code
          system
        }
        text
      }
    }
  }
`;

/**
 * __useGetAlarmTemplatesForTemplateCepQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmTemplatesForTemplateCepQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmTemplatesForTemplateCepQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmTemplatesForTemplateCepQuery();
 */
export function useGetAlarmTemplatesForTemplateCepQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForTemplateCepQuery,
        GetAlarmTemplatesForTemplateCepQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForTemplateCepQuery,
          GetAlarmTemplatesForTemplateCepQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForTemplateCepQuery,
          GetAlarmTemplatesForTemplateCepQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAlarmTemplatesForTemplateCepQuery,
    GetAlarmTemplatesForTemplateCepQueryVariables
  >(GetAlarmTemplatesForTemplateCepDocument, {}, options);
}
export function useGetAlarmTemplatesForTemplateCepLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForTemplateCepQuery,
        GetAlarmTemplatesForTemplateCepQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForTemplateCepQuery,
          GetAlarmTemplatesForTemplateCepQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForTemplateCepQuery,
          GetAlarmTemplatesForTemplateCepQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAlarmTemplatesForTemplateCepQuery,
    GetAlarmTemplatesForTemplateCepQueryVariables
  >(GetAlarmTemplatesForTemplateCepDocument, {}, options);
}
export type GetAlarmTemplatesForTemplateCepQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmTemplatesForTemplateCepQuery,
  GetAlarmTemplatesForTemplateCepQueryVariables
>;
export const NotifyNextOfKinsDocument = gql`
  mutation notifyNextOfKins($patientId: ID!, $message: String!) {
    notifyNextOfKins(patientId: $patientId, message: $message) {
      phoneNumber
      messageStatus
    }
  }
`;

/**
 * __useNotifyNextOfKinsMutation__
 *
 * To run a mutation, you first call `useNotifyNextOfKinsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useNotifyNextOfKinsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useNotifyNextOfKinsMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     message: // value for 'message'
 *   },
 * });
 */
export function useNotifyNextOfKinsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<NotifyNextOfKinsMutation, NotifyNextOfKinsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<NotifyNextOfKinsMutation, NotifyNextOfKinsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<NotifyNextOfKinsMutation, NotifyNextOfKinsMutationVariables>(
    NotifyNextOfKinsDocument,
    options,
  );
}
export type NotifyNextOfKinsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  NotifyNextOfKinsMutation,
  NotifyNextOfKinsMutationVariables
>;
export const GetAlarmTemplatesForSyncAlarmSimulatorDocument = gql`
  query getAlarmTemplatesForSyncAlarmSimulator {
    getAlarmTemplates {
      id
      identifier {
        value
      }
      status
      code {
        coding {
          display
          code
          system
        }
      }
      alarmIcon
      interpretation {
        text
        coding {
          code
          display
        }
      }
      description
    }
  }
`;

/**
 * __useGetAlarmTemplatesForSyncAlarmSimulatorQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmTemplatesForSyncAlarmSimulatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmTemplatesForSyncAlarmSimulatorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmTemplatesForSyncAlarmSimulatorQuery();
 */
export function useGetAlarmTemplatesForSyncAlarmSimulatorQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForSyncAlarmSimulatorQuery,
        GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForSyncAlarmSimulatorQuery,
          GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForSyncAlarmSimulatorQuery,
          GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAlarmTemplatesForSyncAlarmSimulatorQuery,
    GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
  >(GetAlarmTemplatesForSyncAlarmSimulatorDocument, {}, options);
}
export function useGetAlarmTemplatesForSyncAlarmSimulatorLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmTemplatesForSyncAlarmSimulatorQuery,
        GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForSyncAlarmSimulatorQuery,
          GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmTemplatesForSyncAlarmSimulatorQuery,
          GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAlarmTemplatesForSyncAlarmSimulatorQuery,
    GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
  >(GetAlarmTemplatesForSyncAlarmSimulatorDocument, {}, options);
}
export type GetAlarmTemplatesForSyncAlarmSimulatorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmTemplatesForSyncAlarmSimulatorQuery,
  GetAlarmTemplatesForSyncAlarmSimulatorQueryVariables
>;
export const GetOpenPatientAlarmsDocument = gql`
  query getOpenPatientAlarms($sessionFilter: Boolean, $hideAssignedToOtherUsers: Boolean) {
    getOpenPatientAlarms(sessionFilter: $sessionFilter, hideAssignedToOtherUsers: $hideAssignedToOtherUsers) {
      id
      status
      code {
        text
      }
      priority
      directRoutingDetails {
        hasActiveCall
        escalationStatus
      }
      priorityInput {
        valueReference {
          reference
        }
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      authoredOn
      owner {
        reference
        display
        identifier {
          value
        }
      }
      input {
        valueReference {
          reference
        }
        values {
          name
          valueString
          valueBoolean
          valueNumber
        }
        type {
          text
          coding {
            code
          }
        }
        timestamp
        priority
        icon
      }
      locationTraces {
        forDeviceId
        gpsLocations {
          position {
            longitude
            latitude
            altitude
          }
          description
          address {
            use
            line
            city
            postalCode
            country
            text
          }
          gpsTimestamp
          receivedTimestamp
        }
        latestGpsLocation {
          position {
            longitude
            latitude
            altitude
          }
          description
          address {
            use
            line
            city
            postalCode
            country
            text
          }
          gpsTimestamp
          receivedTimestamp
        }
      }
      patient {
        id
        name {
          given
          family
        }
        patientGroups {
          id
          name
          enableDistanceEstimation
          enableOnSiteRegistration
        }
        address {
          line
          postalCode
          city
          country
          text
        }
        skyresponseDetails {
          enabled
          organizationId
          hasSkyresponseExternalId
          hasSkyresponseCredentials
        }
      }
    }
  }
`;

/**
 * __useGetOpenPatientAlarmsQuery__
 *
 * To run a query within a Vue component, call `useGetOpenPatientAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenPatientAlarmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOpenPatientAlarmsQuery({
 *   sessionFilter: // value for 'sessionFilter'
 *   hideAssignedToOtherUsers: // value for 'hideAssignedToOtherUsers'
 * });
 */
export function useGetOpenPatientAlarmsQuery(
  variables:
    | GetOpenPatientAlarmsQueryVariables
    | VueCompositionApi.Ref<GetOpenPatientAlarmsQueryVariables>
    | ReactiveFunction<GetOpenPatientAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>(
    GetOpenPatientAlarmsDocument,
    variables,
    options,
  );
}
export function useGetOpenPatientAlarmsLazyQuery(
  variables:
    | GetOpenPatientAlarmsQueryVariables
    | VueCompositionApi.Ref<GetOpenPatientAlarmsQueryVariables>
    | ReactiveFunction<GetOpenPatientAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOpenPatientAlarmsQuery, GetOpenPatientAlarmsQueryVariables>(
    GetOpenPatientAlarmsDocument,
    variables,
    options,
  );
}
export type GetOpenPatientAlarmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOpenPatientAlarmsQuery,
  GetOpenPatientAlarmsQueryVariables
>;
export const GetPatientWithAlarmsDocument = gql`
  query getPatientWithAlarms($id: ID!) {
    getPatientWithAlarms(id: $id) {
      patient {
        id
        active
      }
      openTechnicalAlarms {
        forDeviceType
        forDeviceName
        id
        status
        code {
          text
        }
        for {
          reference
          identifier {
            system
            use
            value
          }
          type
          display
        }
        basedOn {
          reference
          type
          display
        }
        focus {
          reference
          identifier {
            system
            use
            value
          }
          type
          display
        }
        acceptedAt
        presentAt
        completedAt
        priorityInput {
          timestamp
          icon
          priority
          templateCode
          templateDisplayName
        }
        partOf {
          reference
          identifier {
            system
            use
            value
          }
          type
          display
        }
        description
        intent
        priority
        authoredOn
        firstEventTimestamp
        executionPeriod {
          start
          end
        }
        lastModified
        note {
          authorString
          time
          text
        }
        restriction {
          period {
            start
            end
          }
          recipient {
            reference
            identifier {
              system
              use
              value
            }
            type
            display
          }
        }
      }
      openPatientAlarms {
        forDeviceType
        forDeviceName
        id
        status
        code {
          text
        }
        for {
          reference
          type
          display
        }
        basedOn {
          reference
          type
          display
        }
        focus {
          reference
          type
          display
        }
        partOf {
          reference
          type
          display
        }
        description
        intent
        priority
        authoredOn
        firstEventTimestamp
        executionPeriod {
          start
          end
        }
        lastModified
        note {
          authorString
          time
          text
        }
        acceptedAt
        presentAt
        completedAt
        priorityInput {
          timestamp
          icon
          priority
          templateCode
          templateDisplayName
        }
        owner {
          reference
          type
          display
        }
      }
    }
  }
`;

/**
 * __useGetPatientWithAlarmsQuery__
 *
 * To run a query within a Vue component, call `useGetPatientWithAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientWithAlarmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientWithAlarmsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPatientWithAlarmsQuery(
  variables:
    | GetPatientWithAlarmsQueryVariables
    | VueCompositionApi.Ref<GetPatientWithAlarmsQueryVariables>
    | ReactiveFunction<GetPatientWithAlarmsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>(
    GetPatientWithAlarmsDocument,
    variables,
    options,
  );
}
export function useGetPatientWithAlarmsLazyQuery(
  variables?:
    | GetPatientWithAlarmsQueryVariables
    | VueCompositionApi.Ref<GetPatientWithAlarmsQueryVariables>
    | ReactiveFunction<GetPatientWithAlarmsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientWithAlarmsQuery, GetPatientWithAlarmsQueryVariables>(
    GetPatientWithAlarmsDocument,
    variables,
    options,
  );
}
export type GetPatientWithAlarmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientWithAlarmsQuery,
  GetPatientWithAlarmsQueryVariables
>;
export const GetCoordinateOfAddressDocument = gql`
  query getCoordinateOfAddress($address: String!) {
    getCoordinateOfAddress(address: $address) {
      status
      latLng {
        latitude
        longitude
      }
    }
  }
`;

/**
 * __useGetCoordinateOfAddressQuery__
 *
 * To run a query within a Vue component, call `useGetCoordinateOfAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoordinateOfAddressQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCoordinateOfAddressQuery({
 *   address: // value for 'address'
 * });
 */
export function useGetCoordinateOfAddressQuery(
  variables:
    | GetCoordinateOfAddressQueryVariables
    | VueCompositionApi.Ref<GetCoordinateOfAddressQueryVariables>
    | ReactiveFunction<GetCoordinateOfAddressQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCoordinateOfAddressQuery, GetCoordinateOfAddressQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCoordinateOfAddressQuery, GetCoordinateOfAddressQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCoordinateOfAddressQuery, GetCoordinateOfAddressQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCoordinateOfAddressQuery, GetCoordinateOfAddressQueryVariables>(
    GetCoordinateOfAddressDocument,
    variables,
    options,
  );
}
export function useGetCoordinateOfAddressLazyQuery(
  variables?:
    | GetCoordinateOfAddressQueryVariables
    | VueCompositionApi.Ref<GetCoordinateOfAddressQueryVariables>
    | ReactiveFunction<GetCoordinateOfAddressQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCoordinateOfAddressQuery, GetCoordinateOfAddressQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCoordinateOfAddressQuery, GetCoordinateOfAddressQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCoordinateOfAddressQuery, GetCoordinateOfAddressQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCoordinateOfAddressQuery, GetCoordinateOfAddressQueryVariables>(
    GetCoordinateOfAddressDocument,
    variables,
    options,
  );
}
export type GetCoordinateOfAddressQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCoordinateOfAddressQuery,
  GetCoordinateOfAddressQueryVariables
>;
export const GetAlarmStatusDocument = gql`
  query getAlarmStatus($taskId: ID!) {
    getAlarmStatus(taskId: $taskId) {
      id
      status
      priorityInput {
        valueReference {
          reference
        }
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      owner {
        reference
        display
        identifier {
          value
        }
      }
      input {
        values {
          name
          valueString
          valueBoolean
          valueNumber
        }
        valueReference {
          reference
        }
        type {
          text
          coding {
            system
            code
          }
        }
        icon
        priority
        timestamp
      }
      directRoutingDetails {
        hasActiveCall
        escalationStatus
      }
    }
  }
`;

/**
 * __useGetAlarmStatusQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmStatusQuery({
 *   taskId: // value for 'taskId'
 * });
 */
export function useGetAlarmStatusQuery(
  variables:
    | GetAlarmStatusQueryVariables
    | VueCompositionApi.Ref<GetAlarmStatusQueryVariables>
    | ReactiveFunction<GetAlarmStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>(
    GetAlarmStatusDocument,
    variables,
    options,
  );
}
export function useGetAlarmStatusLazyQuery(
  variables?:
    | GetAlarmStatusQueryVariables
    | VueCompositionApi.Ref<GetAlarmStatusQueryVariables>
    | ReactiveFunction<GetAlarmStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetAlarmStatusQuery, GetAlarmStatusQueryVariables>(
    GetAlarmStatusDocument,
    variables,
    options,
  );
}
export type GetAlarmStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmStatusQuery,
  GetAlarmStatusQueryVariables
>;
export const GetAlarmByIdDocument = gql`
  query getAlarmById($taskId: ID!) {
    getAlarmById(taskId: $taskId) {
      id
      status
      code {
        text
      }
      intent
      acceptedAt
      presentAt
      completedAt
      lastModified
      priority
      priorityInput {
        valueReference {
          reference
        }
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      for {
        reference
      }
      description
      authoredOn
      firstEventTimestamp
      subTasks {
        id
      }
      owner {
        reference
        display
        identifier {
          value
        }
      }
      input {
        values {
          name
          valueString
          valueBoolean
          valueNumber
        }
        valueReference {
          reference
        }
        type {
          text
          coding {
            system
            code
          }
        }
        icon
        priority
        timestamp
      }
      note {
        authorString
        time
        text
      }
      completionOptions
      vkpConfiguration {
        enabled
      }
      isSupervisionAlarmWithAnOpenedCameraStream
      isSupervisionAlarm
      directRoutingDetails {
        hasActiveCall
        escalationStatus
      }
      patient {
        id
        keyCode
        addressNote
        name {
          given
          family
        }
        note
        telecom {
          value
          system
          use
        }
        photo {
          url
        }
        secretAddress
        address {
          line
          postalCode
          city
          country
          text
        }
        cameras {
          id
          name
          macAddress
          serialNumber
          availableHours
          isConfiguredInRegistry
          hasOfflineAlarm
          userHasAccessToPatient
          isAttachedToPatient
          detailedStatus {
            lastSeen
            heartbeatCount
            isAssociatedToPatient
            ttl
            privacyMode
          }
        }
        welfareDevices {
          id
          uniqueIdentifier
          deviceName {
            name
          }
          modelNumber
          configuration {
            registeredInInventory
          }
        }
        patientGroups {
          id
          name
          enableDistanceEstimation
          enableOnSiteRegistration
        }
        skyresponseDetails {
          enabled
          organizationId
          hasSkyresponseExternalId
          hasSkyresponseCredentials
        }
      }
      locationTraces {
        forDeviceId
        gpsLocations {
          position {
            longitude
            latitude
            altitude
          }
          description
          address {
            use
            line
            city
            postalCode
            country
            text
          }
          gpsTimestamp
          receivedTimestamp
        }
        latestGpsLocation {
          position {
            longitude
            latitude
            altitude
          }
          description
          address {
            use
            line
            city
            postalCode
            country
            text
          }
          gpsTimestamp
          receivedTimestamp
        }
      }
    }
  }
`;

/**
 * __useGetAlarmByIdQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmByIdQuery({
 *   taskId: // value for 'taskId'
 * });
 */
export function useGetAlarmByIdQuery(
  variables:
    | GetAlarmByIdQueryVariables
    | VueCompositionApi.Ref<GetAlarmByIdQueryVariables>
    | ReactiveFunction<GetAlarmByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>(
    GetAlarmByIdDocument,
    variables,
    options,
  );
}
export function useGetAlarmByIdLazyQuery(
  variables?:
    | GetAlarmByIdQueryVariables
    | VueCompositionApi.Ref<GetAlarmByIdQueryVariables>
    | ReactiveFunction<GetAlarmByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetAlarmByIdQuery, GetAlarmByIdQueryVariables>(
    GetAlarmByIdDocument,
    variables,
    options,
  );
}
export type GetAlarmByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmByIdQuery,
  GetAlarmByIdQueryVariables
>;
export const GetAllTechnicalAlarmsDocument = gql`
  query getAllTechnicalAlarms($from: dateTime, $to: dateTime, $type: String) {
    getAllTechnicalAlarms(from: $from, to: $to, type: $type) {
      id
      status
      intent
      priority
      authoredOn
      for {
        reference
      }
      description
      lastModified
      owner {
        reference
        display
        identifier {
          value
        }
      }
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        type {
          text
        }
        valueReference {
          reference
          identifier {
            value
          }
          type
          display
        }
        valueString
        timestamp
        icon
        priority
      }
      note {
        authorString
        time
        text
      }
      forDeviceName
      forDeviceType
      syncAlarmDetails {
        userGroupId
        entityName
      }
      patientLink {
        patientId
        userHasAccessToPatient
      }
    }
  }
`;

/**
 * __useGetAllTechnicalAlarmsQuery__
 *
 * To run a query within a Vue component, call `useGetAllTechnicalAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTechnicalAlarmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllTechnicalAlarmsQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   type: // value for 'type'
 * });
 */
export function useGetAllTechnicalAlarmsQuery(
  variables:
    | GetAllTechnicalAlarmsQueryVariables
    | VueCompositionApi.Ref<GetAllTechnicalAlarmsQueryVariables>
    | ReactiveFunction<GetAllTechnicalAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>(
    GetAllTechnicalAlarmsDocument,
    variables,
    options,
  );
}
export function useGetAllTechnicalAlarmsLazyQuery(
  variables:
    | GetAllTechnicalAlarmsQueryVariables
    | VueCompositionApi.Ref<GetAllTechnicalAlarmsQueryVariables>
    | ReactiveFunction<GetAllTechnicalAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllTechnicalAlarmsQuery, GetAllTechnicalAlarmsQueryVariables>(
    GetAllTechnicalAlarmsDocument,
    variables,
    options,
  );
}
export type GetAllTechnicalAlarmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllTechnicalAlarmsQuery,
  GetAllTechnicalAlarmsQueryVariables
>;
export const GetAllTechnicalAlarmsForDevicesDocument = gql`
  query getAllTechnicalAlarmsForDevices($deviceIds: [ID]!, $from: dateTime, $to: dateTime) {
    getAllTechnicalAlarmsForDevices(deviceIds: $deviceIds, from: $from, to: $to) {
      id
      status
      code {
        text
      }
      intent
      priority
      for {
        reference
      }
      description
      authoredOn
      firstEventTimestamp
      lastModified
      owner {
        reference
        display
        identifier {
          value
        }
      }
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        valueReference {
          reference
        }
        type {
          text
        }
        timestamp
        icon
        priority
      }
      note {
        authorString
        time
        text
      }
      forDeviceName
      forDeviceType
    }
  }
`;

/**
 * __useGetAllTechnicalAlarmsForDevicesQuery__
 *
 * To run a query within a Vue component, call `useGetAllTechnicalAlarmsForDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTechnicalAlarmsForDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllTechnicalAlarmsForDevicesQuery({
 *   deviceIds: // value for 'deviceIds'
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useGetAllTechnicalAlarmsForDevicesQuery(
  variables:
    | GetAllTechnicalAlarmsForDevicesQueryVariables
    | VueCompositionApi.Ref<GetAllTechnicalAlarmsForDevicesQueryVariables>
    | ReactiveFunction<GetAllTechnicalAlarmsForDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllTechnicalAlarmsForDevicesQuery,
        GetAllTechnicalAlarmsForDevicesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmsForDevicesQuery,
          GetAllTechnicalAlarmsForDevicesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmsForDevicesQuery,
          GetAllTechnicalAlarmsForDevicesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllTechnicalAlarmsForDevicesQuery,
    GetAllTechnicalAlarmsForDevicesQueryVariables
  >(GetAllTechnicalAlarmsForDevicesDocument, variables, options);
}
export function useGetAllTechnicalAlarmsForDevicesLazyQuery(
  variables?:
    | GetAllTechnicalAlarmsForDevicesQueryVariables
    | VueCompositionApi.Ref<GetAllTechnicalAlarmsForDevicesQueryVariables>
    | ReactiveFunction<GetAllTechnicalAlarmsForDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllTechnicalAlarmsForDevicesQuery,
        GetAllTechnicalAlarmsForDevicesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmsForDevicesQuery,
          GetAllTechnicalAlarmsForDevicesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllTechnicalAlarmsForDevicesQuery,
          GetAllTechnicalAlarmsForDevicesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllTechnicalAlarmsForDevicesQuery,
    GetAllTechnicalAlarmsForDevicesQueryVariables
  >(GetAllTechnicalAlarmsForDevicesDocument, variables, options);
}
export type GetAllTechnicalAlarmsForDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllTechnicalAlarmsForDevicesQuery,
  GetAllTechnicalAlarmsForDevicesQueryVariables
>;
export const GetOpenTechnicalAlarmsForDevicesDocument = gql`
  query getOpenTechnicalAlarmsForDevices($deviceIds: [ID]!) {
    getOpenTechnicalAlarmsForDevices(deviceIds: $deviceIds) {
      id
      status
      code {
        text
      }
      intent
      priority
      for {
        reference
      }
      description
      authoredOn
      firstEventTimestamp
      lastModified
      owner {
        reference
        display
        identifier {
          value
        }
      }
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        valueReference {
          reference
        }
        type {
          text
        }
        timestamp
        icon
        priority
      }
      note {
        authorString
        time
        text
      }
      forDeviceName
      forDeviceType
    }
  }
`;

/**
 * __useGetOpenTechnicalAlarmsForDevicesQuery__
 *
 * To run a query within a Vue component, call `useGetOpenTechnicalAlarmsForDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenTechnicalAlarmsForDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOpenTechnicalAlarmsForDevicesQuery({
 *   deviceIds: // value for 'deviceIds'
 * });
 */
export function useGetOpenTechnicalAlarmsForDevicesQuery(
  variables:
    | GetOpenTechnicalAlarmsForDevicesQueryVariables
    | VueCompositionApi.Ref<GetOpenTechnicalAlarmsForDevicesQueryVariables>
    | ReactiveFunction<GetOpenTechnicalAlarmsForDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetOpenTechnicalAlarmsForDevicesQuery,
        GetOpenTechnicalAlarmsForDevicesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetOpenTechnicalAlarmsForDevicesQuery,
          GetOpenTechnicalAlarmsForDevicesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetOpenTechnicalAlarmsForDevicesQuery,
          GetOpenTechnicalAlarmsForDevicesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetOpenTechnicalAlarmsForDevicesQuery,
    GetOpenTechnicalAlarmsForDevicesQueryVariables
  >(GetOpenTechnicalAlarmsForDevicesDocument, variables, options);
}
export function useGetOpenTechnicalAlarmsForDevicesLazyQuery(
  variables?:
    | GetOpenTechnicalAlarmsForDevicesQueryVariables
    | VueCompositionApi.Ref<GetOpenTechnicalAlarmsForDevicesQueryVariables>
    | ReactiveFunction<GetOpenTechnicalAlarmsForDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetOpenTechnicalAlarmsForDevicesQuery,
        GetOpenTechnicalAlarmsForDevicesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetOpenTechnicalAlarmsForDevicesQuery,
          GetOpenTechnicalAlarmsForDevicesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetOpenTechnicalAlarmsForDevicesQuery,
          GetOpenTechnicalAlarmsForDevicesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetOpenTechnicalAlarmsForDevicesQuery,
    GetOpenTechnicalAlarmsForDevicesQueryVariables
  >(GetOpenTechnicalAlarmsForDevicesDocument, variables, options);
}
export type GetOpenTechnicalAlarmsForDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOpenTechnicalAlarmsForDevicesQuery,
  GetOpenTechnicalAlarmsForDevicesQueryVariables
>;
export const GetOpenSyncAlarmsDocument = gql`
  query getOpenSyncAlarms($type: String) {
    getOpenTechnicalAlarms(type: $type) {
      id
      status
      intent
      priority
      authoredOn
      for {
        reference
      }
      lastModified
      owner {
        reference
        display
        identifier {
          value
        }
      }
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        type {
          text
        }
        valueReference {
          reference
          identifier {
            value
          }
          type
          display
        }
        valueString
        timestamp
        icon
        priority
      }
      syncAlarmDetails {
        userGroupId
        entityName
      }
      syncPending
    }
  }
`;

/**
 * __useGetOpenSyncAlarmsQuery__
 *
 * To run a query within a Vue component, call `useGetOpenSyncAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenSyncAlarmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOpenSyncAlarmsQuery({
 *   type: // value for 'type'
 * });
 */
export function useGetOpenSyncAlarmsQuery(
  variables:
    | GetOpenSyncAlarmsQueryVariables
    | VueCompositionApi.Ref<GetOpenSyncAlarmsQueryVariables>
    | ReactiveFunction<GetOpenSyncAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>(
    GetOpenSyncAlarmsDocument,
    variables,
    options,
  );
}
export function useGetOpenSyncAlarmsLazyQuery(
  variables:
    | GetOpenSyncAlarmsQueryVariables
    | VueCompositionApi.Ref<GetOpenSyncAlarmsQueryVariables>
    | ReactiveFunction<GetOpenSyncAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetOpenSyncAlarmsQuery, GetOpenSyncAlarmsQueryVariables>(
    GetOpenSyncAlarmsDocument,
    variables,
    options,
  );
}
export type GetOpenSyncAlarmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetOpenSyncAlarmsQuery,
  GetOpenSyncAlarmsQueryVariables
>;
export const GetTechnicalAlarmByIdDocument = gql`
  query getTechnicalAlarmById($taskId: ID!, $type: String) {
    getTechnicalAlarmById(taskId: $taskId, type: $type) {
      id
      status
      code {
        text
      }
      intent
      priority
      for {
        reference
      }
      description
      authoredOn
      firstEventTimestamp
      owner {
        reference
        display
        identifier {
          value
        }
      }
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        type {
          text
          coding {
            system
            code
          }
        }
        valueString
        templateDisplayName
        valueReference {
          reference
          display
          type
        }
        timestamp
        icon
        priority
      }
      note {
        authorString
        time
        text
      }
      forDeviceName
      forDeviceType
    }
  }
`;

/**
 * __useGetTechnicalAlarmByIdQuery__
 *
 * To run a query within a Vue component, call `useGetTechnicalAlarmByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTechnicalAlarmByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTechnicalAlarmByIdQuery({
 *   taskId: // value for 'taskId'
 *   type: // value for 'type'
 * });
 */
export function useGetTechnicalAlarmByIdQuery(
  variables:
    | GetTechnicalAlarmByIdQueryVariables
    | VueCompositionApi.Ref<GetTechnicalAlarmByIdQueryVariables>
    | ReactiveFunction<GetTechnicalAlarmByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>(
    GetTechnicalAlarmByIdDocument,
    variables,
    options,
  );
}
export function useGetTechnicalAlarmByIdLazyQuery(
  variables?:
    | GetTechnicalAlarmByIdQueryVariables
    | VueCompositionApi.Ref<GetTechnicalAlarmByIdQueryVariables>
    | ReactiveFunction<GetTechnicalAlarmByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetTechnicalAlarmByIdQuery, GetTechnicalAlarmByIdQueryVariables>(
    GetTechnicalAlarmByIdDocument,
    variables,
    options,
  );
}
export type GetTechnicalAlarmByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetTechnicalAlarmByIdQuery,
  GetTechnicalAlarmByIdQueryVariables
>;
export const GetSyncAlarmByIdDocument = gql`
  query getSyncAlarmById($taskId: ID!, $type: String) {
    getTechnicalAlarmById(taskId: $taskId, type: $type) {
      id
      status
      code {
        text
      }
      intent
      priority
      for {
        reference
      }
      description
      authoredOn
      firstEventTimestamp
      owner {
        reference
        display
        identifier {
          value
        }
      }
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        type {
          text
          coding {
            system
            code
          }
        }
        valueString
        templateDisplayName
        valueReference {
          reference
          display
          type
        }
        timestamp
        icon
        priority
        syncEventDetails {
          flowName
          stepName
          flowLogs {
            timestamp
            details
            auditLogReferences {
              auditEventId
              description
            }
          }
        }
      }
      syncAlarmDetails {
        userGroupId
        entityName
      }
      syncPending
    }
  }
`;

/**
 * __useGetSyncAlarmByIdQuery__
 *
 * To run a query within a Vue component, call `useGetSyncAlarmByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSyncAlarmByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSyncAlarmByIdQuery({
 *   taskId: // value for 'taskId'
 *   type: // value for 'type'
 * });
 */
export function useGetSyncAlarmByIdQuery(
  variables:
    | GetSyncAlarmByIdQueryVariables
    | VueCompositionApi.Ref<GetSyncAlarmByIdQueryVariables>
    | ReactiveFunction<GetSyncAlarmByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>(
    GetSyncAlarmByIdDocument,
    variables,
    options,
  );
}
export function useGetSyncAlarmByIdLazyQuery(
  variables?:
    | GetSyncAlarmByIdQueryVariables
    | VueCompositionApi.Ref<GetSyncAlarmByIdQueryVariables>
    | ReactiveFunction<GetSyncAlarmByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetSyncAlarmByIdQuery, GetSyncAlarmByIdQueryVariables>(
    GetSyncAlarmByIdDocument,
    variables,
    options,
  );
}
export type GetSyncAlarmByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetSyncAlarmByIdQuery,
  GetSyncAlarmByIdQueryVariables
>;
export const UpdateTaskAcceptedAtDocument = gql`
  mutation updateTaskAcceptedAt($taskId: ID!, $when: dateTime) {
    updateTaskAcceptedAt(taskId: $taskId, when: $when) {
      success
      message
      inputValidation {
        message
        valid
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdateTaskAcceptedAtMutation__
 *
 * To run a mutation, you first call `useUpdateTaskAcceptedAtMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskAcceptedAtMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTaskAcceptedAtMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     when: // value for 'when'
 *   },
 * });
 */
export function useUpdateTaskAcceptedAtMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateTaskAcceptedAtMutation, UpdateTaskAcceptedAtMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateTaskAcceptedAtMutation, UpdateTaskAcceptedAtMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateTaskAcceptedAtMutation, UpdateTaskAcceptedAtMutationVariables>(
    UpdateTaskAcceptedAtDocument,
    options,
  );
}
export type UpdateTaskAcceptedAtMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateTaskAcceptedAtMutation,
  UpdateTaskAcceptedAtMutationVariables
>;
export const UpdateTaskPresenceAtDocument = gql`
  mutation updateTaskPresenceAt($taskId: ID!, $when: dateTime) {
    updateTaskPresenceAt(taskId: $taskId, when: $when) {
      success
      message
      inputValidation {
        message
        valid
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdateTaskPresenceAtMutation__
 *
 * To run a mutation, you first call `useUpdateTaskPresenceAtMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskPresenceAtMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTaskPresenceAtMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     when: // value for 'when'
 *   },
 * });
 */
export function useUpdateTaskPresenceAtMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateTaskPresenceAtMutation, UpdateTaskPresenceAtMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateTaskPresenceAtMutation, UpdateTaskPresenceAtMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateTaskPresenceAtMutation, UpdateTaskPresenceAtMutationVariables>(
    UpdateTaskPresenceAtDocument,
    options,
  );
}
export type UpdateTaskPresenceAtMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateTaskPresenceAtMutation,
  UpdateTaskPresenceAtMutationVariables
>;
export const UpdateAlarmStatusDocument = gql`
  mutation updateAlarmStatus($taskId: ID!, $status: String!) {
    updateAlarmStatus(taskId: $taskId, status: $status) {
      success
      message
      inputValidation {
        message
        valid
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdateAlarmStatusMutation__
 *
 * To run a mutation, you first call `useUpdateAlarmStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlarmStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAlarmStatusMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     status: // value for 'status'
 *   },
 * });
 */
export function useUpdateAlarmStatusMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateAlarmStatusMutation, UpdateAlarmStatusMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateAlarmStatusMutation, UpdateAlarmStatusMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateAlarmStatusMutation, UpdateAlarmStatusMutationVariables>(
    UpdateAlarmStatusDocument,
    options,
  );
}
export type UpdateAlarmStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAlarmStatusMutation,
  UpdateAlarmStatusMutationVariables
>;
export const CompleteAlarmDocument = gql`
  mutation completeAlarm($taskId: ID!, $completionInput: CompleteAlarmInput!, $force: Boolean) {
    completeAlarm(taskId: $taskId, completionInput: $completionInput, force: $force) {
      success
      message
      inputValidation {
        message
        valid
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useCompleteAlarmMutation__
 *
 * To run a mutation, you first call `useCompleteAlarmMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAlarmMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCompleteAlarmMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     completionInput: // value for 'completionInput'
 *     force: // value for 'force'
 *   },
 * });
 */
export function useCompleteAlarmMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CompleteAlarmMutation, CompleteAlarmMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CompleteAlarmMutation, CompleteAlarmMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CompleteAlarmMutation, CompleteAlarmMutationVariables>(
    CompleteAlarmDocument,
    options,
  );
}
export type CompleteAlarmMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CompleteAlarmMutation,
  CompleteAlarmMutationVariables
>;
export const UpdateTechnicalAlarmStatusDocument = gql`
  mutation updateTechnicalAlarmStatus($taskId: ID!, $status: String!, $force: Boolean) {
    updateTechnicalAlarmStatus(taskId: $taskId, status: $status, force: $force) {
      success
      message
      inputValidation {
        message
        valid
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdateTechnicalAlarmStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTechnicalAlarmStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTechnicalAlarmStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTechnicalAlarmStatusMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     status: // value for 'status'
 *     force: // value for 'force'
 *   },
 * });
 */
export function useUpdateTechnicalAlarmStatusMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        UpdateTechnicalAlarmStatusMutation,
        UpdateTechnicalAlarmStatusMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          UpdateTechnicalAlarmStatusMutation,
          UpdateTechnicalAlarmStatusMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    UpdateTechnicalAlarmStatusMutation,
    UpdateTechnicalAlarmStatusMutationVariables
  >(UpdateTechnicalAlarmStatusDocument, options);
}
export type UpdateTechnicalAlarmStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateTechnicalAlarmStatusMutation,
  UpdateTechnicalAlarmStatusMutationVariables
>;
export const AddNotesToAlarmDocument = gql`
  mutation addNotesToAlarm($taskId: ID!, $note: [AnnotationInput]) {
    addNotesToAlarm(taskId: $taskId, note: $note) {
      success
      message
    }
  }
`;

/**
 * __useAddNotesToAlarmMutation__
 *
 * To run a mutation, you first call `useAddNotesToAlarmMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddNotesToAlarmMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddNotesToAlarmMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     note: // value for 'note'
 *   },
 * });
 */
export function useAddNotesToAlarmMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddNotesToAlarmMutation, AddNotesToAlarmMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddNotesToAlarmMutation, AddNotesToAlarmMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddNotesToAlarmMutation, AddNotesToAlarmMutationVariables>(
    AddNotesToAlarmDocument,
    options,
  );
}
export type AddNotesToAlarmMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddNotesToAlarmMutation,
  AddNotesToAlarmMutationVariables
>;
export const AddNotesToTechnicalAlarmDocument = gql`
  mutation addNotesToTechnicalAlarm($taskId: ID!, $note: [AnnotationInput]) {
    addNotesToTechnicalAlarm(taskId: $taskId, note: $note) {
      success
      message
    }
  }
`;

/**
 * __useAddNotesToTechnicalAlarmMutation__
 *
 * To run a mutation, you first call `useAddNotesToTechnicalAlarmMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddNotesToTechnicalAlarmMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddNotesToTechnicalAlarmMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *     note: // value for 'note'
 *   },
 * });
 */
export function useAddNotesToTechnicalAlarmMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddNotesToTechnicalAlarmMutation,
        AddNotesToTechnicalAlarmMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddNotesToTechnicalAlarmMutation,
          AddNotesToTechnicalAlarmMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<AddNotesToTechnicalAlarmMutation, AddNotesToTechnicalAlarmMutationVariables>(
    AddNotesToTechnicalAlarmDocument,
    options,
  );
}
export type AddNotesToTechnicalAlarmMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddNotesToTechnicalAlarmMutation,
  AddNotesToTechnicalAlarmMutationVariables
>;
export const TriggerResolveActionsForSyncAlarmsDocument = gql`
  mutation triggerResolveActionsForSyncAlarms($alarmIds: [ID!]!) {
    triggerResolveActionsForSyncAlarms(alarmIds: $alarmIds) {
      success
      message
    }
  }
`;

/**
 * __useTriggerResolveActionsForSyncAlarmsMutation__
 *
 * To run a mutation, you first call `useTriggerResolveActionsForSyncAlarmsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerResolveActionsForSyncAlarmsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerResolveActionsForSyncAlarmsMutation({
 *   variables: {
 *     alarmIds: // value for 'alarmIds'
 *   },
 * });
 */
export function useTriggerResolveActionsForSyncAlarmsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        TriggerResolveActionsForSyncAlarmsMutation,
        TriggerResolveActionsForSyncAlarmsMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          TriggerResolveActionsForSyncAlarmsMutation,
          TriggerResolveActionsForSyncAlarmsMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    TriggerResolveActionsForSyncAlarmsMutation,
    TriggerResolveActionsForSyncAlarmsMutationVariables
  >(TriggerResolveActionsForSyncAlarmsDocument, options);
}
export type TriggerResolveActionsForSyncAlarmsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  TriggerResolveActionsForSyncAlarmsMutation,
  TriggerResolveActionsForSyncAlarmsMutationVariables
>;
export const CancelSkyresponseSyncAlarmDocument = gql`
  mutation cancelSkyresponseSyncAlarm($taskId: ID!) {
    cancelSkyresponseSyncAlarm(taskId: $taskId) {
      success
      message
    }
  }
`;

/**
 * __useCancelSkyresponseSyncAlarmMutation__
 *
 * To run a mutation, you first call `useCancelSkyresponseSyncAlarmMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelSkyresponseSyncAlarmMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelSkyresponseSyncAlarmMutation({
 *   variables: {
 *     taskId: // value for 'taskId'
 *   },
 * });
 */
export function useCancelSkyresponseSyncAlarmMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        CancelSkyresponseSyncAlarmMutation,
        CancelSkyresponseSyncAlarmMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CancelSkyresponseSyncAlarmMutation,
          CancelSkyresponseSyncAlarmMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    CancelSkyresponseSyncAlarmMutation,
    CancelSkyresponseSyncAlarmMutationVariables
  >(CancelSkyresponseSyncAlarmDocument, options);
}
export type CancelSkyresponseSyncAlarmMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CancelSkyresponseSyncAlarmMutation,
  CancelSkyresponseSyncAlarmMutationVariables
>;
export const SimulateSyncEventDocument = gql`
  mutation simulateSyncEvent(
    $patientId: ID
    $contactId: ID
    $userGroupId: ID
    $eventCode: String!
    $payload: SimulateSyncEventPayloadInput
  ) {
    simulateSyncEvent(
      patientId: $patientId
      contactId: $contactId
      userGroupId: $userGroupId
      eventCode: $eventCode
      payload: $payload
    ) {
      success
      message
    }
  }
`;

/**
 * __useSimulateSyncEventMutation__
 *
 * To run a mutation, you first call `useSimulateSyncEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSimulateSyncEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSimulateSyncEventMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     contactId: // value for 'contactId'
 *     userGroupId: // value for 'userGroupId'
 *     eventCode: // value for 'eventCode'
 *     payload: // value for 'payload'
 *   },
 * });
 */
export function useSimulateSyncEventMutation(
  options:
    | VueApolloComposable.UseMutationOptions<SimulateSyncEventMutation, SimulateSyncEventMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<SimulateSyncEventMutation, SimulateSyncEventMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<SimulateSyncEventMutation, SimulateSyncEventMutationVariables>(
    SimulateSyncEventDocument,
    options,
  );
}
export type SimulateSyncEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SimulateSyncEventMutation,
  SimulateSyncEventMutationVariables
>;
export const TriggerEventInCameraDocument = gql`
  mutation triggerEventInCamera($cameraId: ID!, $profileId: Int!, $appName: String!) {
    triggerEventInCamera(cameraId: $cameraId, profileId: $profileId, appName: $appName)
  }
`;

/**
 * __useTriggerEventInCameraMutation__
 *
 * To run a mutation, you first call `useTriggerEventInCameraMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerEventInCameraMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerEventInCameraMutation({
 *   variables: {
 *     cameraId: // value for 'cameraId'
 *     profileId: // value for 'profileId'
 *     appName: // value for 'appName'
 *   },
 * });
 */
export function useTriggerEventInCameraMutation(
  options:
    | VueApolloComposable.UseMutationOptions<TriggerEventInCameraMutation, TriggerEventInCameraMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<TriggerEventInCameraMutation, TriggerEventInCameraMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<TriggerEventInCameraMutation, TriggerEventInCameraMutationVariables>(
    TriggerEventInCameraDocument,
    options,
  );
}
export type TriggerEventInCameraMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  TriggerEventInCameraMutation,
  TriggerEventInCameraMutationVariables
>;
export const RemovePatientContactDocument = gql`
  mutation removePatientContact($patientId: ID!, $contactId: ID!) {
    removePatientContact(patientId: $patientId, contactId: $contactId) {
      success
    }
  }
`;

/**
 * __useRemovePatientContactMutation__
 *
 * To run a mutation, you first call `useRemovePatientContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemovePatientContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemovePatientContactMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     contactId: // value for 'contactId'
 *   },
 * });
 */
export function useRemovePatientContactMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RemovePatientContactMutation, RemovePatientContactMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RemovePatientContactMutation, RemovePatientContactMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RemovePatientContactMutation, RemovePatientContactMutationVariables>(
    RemovePatientContactDocument,
    options,
  );
}
export type RemovePatientContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemovePatientContactMutation,
  RemovePatientContactMutationVariables
>;
export const UpdatePatientContactDocument = gql`
  mutation updatePatientContact($patientId: ID!, $contact: UpdateContactInput!) {
    updatePatientContact(patientId: $patientId, contact: $contact) {
      success
    }
  }
`;

/**
 * __useUpdatePatientContactMutation__
 *
 * To run a mutation, you first call `useUpdatePatientContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientContactMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     contact: // value for 'contact'
 *   },
 * });
 */
export function useUpdatePatientContactMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdatePatientContactMutation, UpdatePatientContactMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdatePatientContactMutation, UpdatePatientContactMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePatientContactMutation, UpdatePatientContactMutationVariables>(
    UpdatePatientContactDocument,
    options,
  );
}
export type UpdatePatientContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientContactMutation,
  UpdatePatientContactMutationVariables
>;
export const PatientContactsDocument = gql`
  query patientContacts($id: ID!) {
    patient(id: $id) {
      id
      contacts {
        patientContacts {
          id
          name
          telecom {
            system
            value
          }
          availableHours
          skyresponseConfig {
            callMethod
          }
          priority
        }
        groupContacts {
          id
          name
          telecom {
            system
            value
          }
          availableHours
          skyresponseConfig {
            callMethod
          }
          priority
        }
      }
    }
  }
`;

/**
 * __usePatientContactsQuery__
 *
 * To run a query within a Vue component, call `usePatientContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientContactsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientContactsQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientContactsQuery(
  variables:
    | PatientContactsQueryVariables
    | VueCompositionApi.Ref<PatientContactsQueryVariables>
    | ReactiveFunction<PatientContactsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientContactsQuery, PatientContactsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientContactsQuery, PatientContactsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientContactsQuery, PatientContactsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientContactsQuery, PatientContactsQueryVariables>(
    PatientContactsDocument,
    variables,
    options,
  );
}
export function usePatientContactsLazyQuery(
  variables?:
    | PatientContactsQueryVariables
    | VueCompositionApi.Ref<PatientContactsQueryVariables>
    | ReactiveFunction<PatientContactsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientContactsQuery, PatientContactsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientContactsQuery, PatientContactsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientContactsQuery, PatientContactsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientContactsQuery, PatientContactsQueryVariables>(
    PatientContactsDocument,
    variables,
    options,
  );
}
export type PatientContactsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientContactsQuery,
  PatientContactsQueryVariables
>;
export const OrderPatientContactsDocument = gql`
  mutation orderPatientContacts($patientId: ID!, $orderedContactIds: [ID!]!) {
    orderPatientContacts(patientId: $patientId, orderedContactIds: $orderedContactIds) {
      success
    }
  }
`;

/**
 * __useOrderPatientContactsMutation__
 *
 * To run a mutation, you first call `useOrderPatientContactsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useOrderPatientContactsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useOrderPatientContactsMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     orderedContactIds: // value for 'orderedContactIds'
 *   },
 * });
 */
export function useOrderPatientContactsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<OrderPatientContactsMutation, OrderPatientContactsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<OrderPatientContactsMutation, OrderPatientContactsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<OrderPatientContactsMutation, OrderPatientContactsMutationVariables>(
    OrderPatientContactsDocument,
    options,
  );
}
export type OrderPatientContactsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  OrderPatientContactsMutation,
  OrderPatientContactsMutationVariables
>;
export const OrderUserGroupContactsDocument = gql`
  mutation orderUserGroupContacts($userGroupId: ID!, $orderedContactIds: [ID!]!) {
    orderUserGroupContacts(userGroupId: $userGroupId, orderedContactIds: $orderedContactIds) {
      success
    }
  }
`;

/**
 * __useOrderUserGroupContactsMutation__
 *
 * To run a mutation, you first call `useOrderUserGroupContactsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useOrderUserGroupContactsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useOrderUserGroupContactsMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     orderedContactIds: // value for 'orderedContactIds'
 *   },
 * });
 */
export function useOrderUserGroupContactsMutation(
  options:
    | VueApolloComposable.UseMutationOptions<OrderUserGroupContactsMutation, OrderUserGroupContactsMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<OrderUserGroupContactsMutation, OrderUserGroupContactsMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<OrderUserGroupContactsMutation, OrderUserGroupContactsMutationVariables>(
    OrderUserGroupContactsDocument,
    options,
  );
}
export type OrderUserGroupContactsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  OrderUserGroupContactsMutation,
  OrderUserGroupContactsMutationVariables
>;
export const RemoveUserGroupContactDocument = gql`
  mutation removeUserGroupContact($userGroupId: ID!, $contactId: ID!) {
    removeUserGroupContact(userGroupId: $userGroupId, contactId: $contactId) {
      success
    }
  }
`;

/**
 * __useRemoveUserGroupContactMutation__
 *
 * To run a mutation, you first call `useRemoveUserGroupContactMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserGroupContactMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveUserGroupContactMutation({
 *   variables: {
 *     userGroupId: // value for 'userGroupId'
 *     contactId: // value for 'contactId'
 *   },
 * });
 */
export function useRemoveUserGroupContactMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RemoveUserGroupContactMutation, RemoveUserGroupContactMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RemoveUserGroupContactMutation, RemoveUserGroupContactMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RemoveUserGroupContactMutation, RemoveUserGroupContactMutationVariables>(
    RemoveUserGroupContactDocument,
    options,
  );
}
export type RemoveUserGroupContactMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveUserGroupContactMutation,
  RemoveUserGroupContactMutationVariables
>;
export const UserGroupContactsAndSkyresponseSyncStatusDocument = gql`
  query userGroupContactsAndSkyresponseSyncStatus($id: ID) {
    userGroup(userGroupId: $id) {
      id
      contacts {
        id
        name
        telecom {
          system
          value
        }
        availableHours
        skyresponseConfig {
          callMethod
        }
        priority
      }
      skyresponseSyncStatus {
        status
        openAlarms {
          id
          authoredOn
        }
      }
    }
  }
`;

/**
 * __useUserGroupContactsAndSkyresponseSyncStatusQuery__
 *
 * To run a query within a Vue component, call `useUserGroupContactsAndSkyresponseSyncStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupContactsAndSkyresponseSyncStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupContactsAndSkyresponseSyncStatusQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserGroupContactsAndSkyresponseSyncStatusQuery(
  variables:
    | UserGroupContactsAndSkyresponseSyncStatusQueryVariables
    | VueCompositionApi.Ref<UserGroupContactsAndSkyresponseSyncStatusQueryVariables>
    | ReactiveFunction<UserGroupContactsAndSkyresponseSyncStatusQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        UserGroupContactsAndSkyresponseSyncStatusQuery,
        UserGroupContactsAndSkyresponseSyncStatusQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          UserGroupContactsAndSkyresponseSyncStatusQuery,
          UserGroupContactsAndSkyresponseSyncStatusQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          UserGroupContactsAndSkyresponseSyncStatusQuery,
          UserGroupContactsAndSkyresponseSyncStatusQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    UserGroupContactsAndSkyresponseSyncStatusQuery,
    UserGroupContactsAndSkyresponseSyncStatusQueryVariables
  >(UserGroupContactsAndSkyresponseSyncStatusDocument, variables, options);
}
export function useUserGroupContactsAndSkyresponseSyncStatusLazyQuery(
  variables:
    | UserGroupContactsAndSkyresponseSyncStatusQueryVariables
    | VueCompositionApi.Ref<UserGroupContactsAndSkyresponseSyncStatusQueryVariables>
    | ReactiveFunction<UserGroupContactsAndSkyresponseSyncStatusQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        UserGroupContactsAndSkyresponseSyncStatusQuery,
        UserGroupContactsAndSkyresponseSyncStatusQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          UserGroupContactsAndSkyresponseSyncStatusQuery,
          UserGroupContactsAndSkyresponseSyncStatusQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          UserGroupContactsAndSkyresponseSyncStatusQuery,
          UserGroupContactsAndSkyresponseSyncStatusQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    UserGroupContactsAndSkyresponseSyncStatusQuery,
    UserGroupContactsAndSkyresponseSyncStatusQueryVariables
  >(UserGroupContactsAndSkyresponseSyncStatusDocument, variables, options);
}
export type UserGroupContactsAndSkyresponseSyncStatusQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    UserGroupContactsAndSkyresponseSyncStatusQuery,
    UserGroupContactsAndSkyresponseSyncStatusQueryVariables
  >;
export const PatientStatsDocument = gql`
  query patientStats($from: dateTime, $to: dateTime) {
    patientStats(from: $from, to: $to) {
      stats {
        timestamp
        alarms
        alarmEvents
      }
    }
  }
`;

/**
 * __usePatientStatsQuery__
 *
 * To run a query within a Vue component, call `usePatientStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientStatsQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function usePatientStatsQuery(
  variables:
    | PatientStatsQueryVariables
    | VueCompositionApi.Ref<PatientStatsQueryVariables>
    | ReactiveFunction<PatientStatsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<PatientStatsQuery, PatientStatsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientStatsQuery, PatientStatsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientStatsQuery, PatientStatsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientStatsQuery, PatientStatsQueryVariables>(
    PatientStatsDocument,
    variables,
    options,
  );
}
export function usePatientStatsLazyQuery(
  variables:
    | PatientStatsQueryVariables
    | VueCompositionApi.Ref<PatientStatsQueryVariables>
    | ReactiveFunction<PatientStatsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<PatientStatsQuery, PatientStatsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientStatsQuery, PatientStatsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientStatsQuery, PatientStatsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientStatsQuery, PatientStatsQueryVariables>(
    PatientStatsDocument,
    variables,
    options,
  );
}
export type PatientStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientStatsQuery,
  PatientStatsQueryVariables
>;
export const GetPatientsWithoutAuditLogDocument = gql`
  query getPatientsWithoutAuditLog($onlyActive: Boolean) {
    getPatientsWithoutAuditLog(onlyActive: $onlyActive) {
      id
      name {
        text
      }
      lastSupervisionTimestamp
      lastSupervisionPerformedByUserId
      address {
        text
        line
        city
        postalCode
      }
      addressNote
      keyCode
      patientGroups {
        id
        name
      }
      cameras {
        id
        name
        isConfiguredInRegistry
        hasOfflineAlarm
        userHasAccessToPatient
        detailedStatus {
          ttl
          privacyMode
        }
      }
    }
  }
`;

/**
 * __useGetPatientsWithoutAuditLogQuery__
 *
 * To run a query within a Vue component, call `useGetPatientsWithoutAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientsWithoutAuditLogQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientsWithoutAuditLogQuery({
 *   onlyActive: // value for 'onlyActive'
 * });
 */
export function useGetPatientsWithoutAuditLogQuery(
  variables:
    | GetPatientsWithoutAuditLogQueryVariables
    | VueCompositionApi.Ref<GetPatientsWithoutAuditLogQueryVariables>
    | ReactiveFunction<GetPatientsWithoutAuditLogQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientsWithoutAuditLogQuery, GetPatientsWithoutAuditLogQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientsWithoutAuditLogQuery, GetPatientsWithoutAuditLogQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientsWithoutAuditLogQuery, GetPatientsWithoutAuditLogQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientsWithoutAuditLogQuery, GetPatientsWithoutAuditLogQueryVariables>(
    GetPatientsWithoutAuditLogDocument,
    variables,
    options,
  );
}
export function useGetPatientsWithoutAuditLogLazyQuery(
  variables:
    | GetPatientsWithoutAuditLogQueryVariables
    | VueCompositionApi.Ref<GetPatientsWithoutAuditLogQueryVariables>
    | ReactiveFunction<GetPatientsWithoutAuditLogQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientsWithoutAuditLogQuery, GetPatientsWithoutAuditLogQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientsWithoutAuditLogQuery, GetPatientsWithoutAuditLogQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientsWithoutAuditLogQuery, GetPatientsWithoutAuditLogQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientsWithoutAuditLogQuery, GetPatientsWithoutAuditLogQueryVariables>(
    GetPatientsWithoutAuditLogDocument,
    variables,
    options,
  );
}
export type GetPatientsWithoutAuditLogQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientsWithoutAuditLogQuery,
  GetPatientsWithoutAuditLogQueryVariables
>;
export const GetSkyresponseStatusesForPatientDocument = gql`
  query getSkyresponseStatusesForPatient($patientId: ID!) {
    getSkyresponseStatusesForPatient(patientId: $patientId) {
      patientId
      flowName
      status
      timestamp
      logs {
        timestamp
        details
        auditLogReferences {
          auditEventId
          description
        }
      }
    }
  }
`;

/**
 * __useGetSkyresponseStatusesForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetSkyresponseStatusesForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkyresponseStatusesForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSkyresponseStatusesForPatientQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetSkyresponseStatusesForPatientQuery(
  variables:
    | GetSkyresponseStatusesForPatientQueryVariables
    | VueCompositionApi.Ref<GetSkyresponseStatusesForPatientQueryVariables>
    | ReactiveFunction<GetSkyresponseStatusesForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSkyresponseStatusesForPatientQuery,
        GetSkyresponseStatusesForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForPatientQuery,
          GetSkyresponseStatusesForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForPatientQuery,
          GetSkyresponseStatusesForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetSkyresponseStatusesForPatientQuery,
    GetSkyresponseStatusesForPatientQueryVariables
  >(GetSkyresponseStatusesForPatientDocument, variables, options);
}
export function useGetSkyresponseStatusesForPatientLazyQuery(
  variables?:
    | GetSkyresponseStatusesForPatientQueryVariables
    | VueCompositionApi.Ref<GetSkyresponseStatusesForPatientQueryVariables>
    | ReactiveFunction<GetSkyresponseStatusesForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSkyresponseStatusesForPatientQuery,
        GetSkyresponseStatusesForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForPatientQuery,
          GetSkyresponseStatusesForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForPatientQuery,
          GetSkyresponseStatusesForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetSkyresponseStatusesForPatientQuery,
    GetSkyresponseStatusesForPatientQueryVariables
  >(GetSkyresponseStatusesForPatientDocument, variables, options);
}
export type GetSkyresponseStatusesForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetSkyresponseStatusesForPatientQuery,
  GetSkyresponseStatusesForPatientQueryVariables
>;
export const PatientSyncStatusDocument = gql`
  query patientSyncStatus($id: ID!) {
    patient(id: $id) {
      id
      skyresponseSyncStatus
      skyresponseSyncOpenAlarms {
        id
        timestamp
      }
    }
  }
`;

/**
 * __usePatientSyncStatusQuery__
 *
 * To run a query within a Vue component, call `usePatientSyncStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientSyncStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientSyncStatusQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientSyncStatusQuery(
  variables:
    | PatientSyncStatusQueryVariables
    | VueCompositionApi.Ref<PatientSyncStatusQueryVariables>
    | ReactiveFunction<PatientSyncStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>(
    PatientSyncStatusDocument,
    variables,
    options,
  );
}
export function usePatientSyncStatusLazyQuery(
  variables?:
    | PatientSyncStatusQueryVariables
    | VueCompositionApi.Ref<PatientSyncStatusQueryVariables>
    | ReactiveFunction<PatientSyncStatusQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientSyncStatusQuery, PatientSyncStatusQueryVariables>(
    PatientSyncStatusDocument,
    variables,
    options,
  );
}
export type PatientSyncStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientSyncStatusQuery,
  PatientSyncStatusQueryVariables
>;
export const SyncSpecificPatientWithSkyresponseDocument = gql`
  mutation syncSpecificPatientWithSkyresponse($patientId: ID!) {
    syncSpecificPatientWithSkyresponse(patientId: $patientId) {
      success
    }
  }
`;

/**
 * __useSyncSpecificPatientWithSkyresponseMutation__
 *
 * To run a mutation, you first call `useSyncSpecificPatientWithSkyresponseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSyncSpecificPatientWithSkyresponseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSyncSpecificPatientWithSkyresponseMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *   },
 * });
 */
export function useSyncSpecificPatientWithSkyresponseMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        SyncSpecificPatientWithSkyresponseMutation,
        SyncSpecificPatientWithSkyresponseMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          SyncSpecificPatientWithSkyresponseMutation,
          SyncSpecificPatientWithSkyresponseMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    SyncSpecificPatientWithSkyresponseMutation,
    SyncSpecificPatientWithSkyresponseMutationVariables
  >(SyncSpecificPatientWithSkyresponseDocument, options);
}
export type SyncSpecificPatientWithSkyresponseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  SyncSpecificPatientWithSkyresponseMutation,
  SyncSpecificPatientWithSkyresponseMutationVariables
>;
export const GetSkyresponseStatusesForUserGroupDocument = gql`
  query getSkyresponseStatusesForUserGroup($userGroupId: ID!) {
    getSkyresponseStatusesForUserGroup(userGroupId: $userGroupId) {
      flowName
      status
      timestamp
      logs {
        timestamp
        details
        auditLogReferences {
          auditEventId
          description
        }
      }
    }
  }
`;

/**
 * __useGetSkyresponseStatusesForUserGroupQuery__
 *
 * To run a query within a Vue component, call `useGetSkyresponseStatusesForUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkyresponseStatusesForUserGroupQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSkyresponseStatusesForUserGroupQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useGetSkyresponseStatusesForUserGroupQuery(
  variables:
    | GetSkyresponseStatusesForUserGroupQueryVariables
    | VueCompositionApi.Ref<GetSkyresponseStatusesForUserGroupQueryVariables>
    | ReactiveFunction<GetSkyresponseStatusesForUserGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSkyresponseStatusesForUserGroupQuery,
        GetSkyresponseStatusesForUserGroupQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForUserGroupQuery,
          GetSkyresponseStatusesForUserGroupQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForUserGroupQuery,
          GetSkyresponseStatusesForUserGroupQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetSkyresponseStatusesForUserGroupQuery,
    GetSkyresponseStatusesForUserGroupQueryVariables
  >(GetSkyresponseStatusesForUserGroupDocument, variables, options);
}
export function useGetSkyresponseStatusesForUserGroupLazyQuery(
  variables?:
    | GetSkyresponseStatusesForUserGroupQueryVariables
    | VueCompositionApi.Ref<GetSkyresponseStatusesForUserGroupQueryVariables>
    | ReactiveFunction<GetSkyresponseStatusesForUserGroupQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSkyresponseStatusesForUserGroupQuery,
        GetSkyresponseStatusesForUserGroupQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForUserGroupQuery,
          GetSkyresponseStatusesForUserGroupQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSkyresponseStatusesForUserGroupQuery,
          GetSkyresponseStatusesForUserGroupQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetSkyresponseStatusesForUserGroupQuery,
    GetSkyresponseStatusesForUserGroupQueryVariables
  >(GetSkyresponseStatusesForUserGroupDocument, variables, options);
}
export type GetSkyresponseStatusesForUserGroupQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetSkyresponseStatusesForUserGroupQuery,
  GetSkyresponseStatusesForUserGroupQueryVariables
>;
export const PatientDocument = gql`
  query patient($id: ID!) {
    patient(id: $id) {
      id
      active
      patientGroups {
        name
        id
      }
      name {
        given
        family
        text
      }
      identifier {
        value
        use
      }
      welfareDevices {
        id
        uniqueIdentifier
        modelNumber
        userFriendlyName
        configuration {
          registeredInInventory
        }
      }
      cameras {
        id
        name
        modelName
        manufacturer
        macAddress
        availableHours
        isConfiguredInRegistry
        hasOfflineAlarm
        detailedStatus {
          lastSeen
          heartbeatCount
          isAssociatedToPatient
          ttl
          privacyMode
        }
      }
      journalConfigForPatient {
        remoteSupervision {
          enabled
        }
      }
    }
  }
`;

/**
 * __usePatientQuery__
 *
 * To run a query within a Vue component, call `usePatientQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientQuery(
  variables:
    | PatientQueryVariables
    | VueCompositionApi.Ref<PatientQueryVariables>
    | ReactiveFunction<PatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientQuery, PatientQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientQuery, PatientQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientQuery, PatientQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientQuery, PatientQueryVariables>(PatientDocument, variables, options);
}
export function usePatientLazyQuery(
  variables?:
    | PatientQueryVariables
    | VueCompositionApi.Ref<PatientQueryVariables>
    | ReactiveFunction<PatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientQuery, PatientQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientQuery, PatientQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientQuery, PatientQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientQuery, PatientQueryVariables>(PatientDocument, variables, options);
}
export type PatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientQuery,
  PatientQueryVariables
>;
export const ActivateAlarmTemplateDocument = gql`
  mutation activateAlarmTemplate($id: ID!) {
    activateAlarmTemplate(id: $id) {
      alarmTemplate {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useActivateAlarmTemplateMutation__
 *
 * To run a mutation, you first call `useActivateAlarmTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateAlarmTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateAlarmTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useActivateAlarmTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<ActivateAlarmTemplateMutation, ActivateAlarmTemplateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<ActivateAlarmTemplateMutation, ActivateAlarmTemplateMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<ActivateAlarmTemplateMutation, ActivateAlarmTemplateMutationVariables>(
    ActivateAlarmTemplateDocument,
    options,
  );
}
export type ActivateAlarmTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ActivateAlarmTemplateMutation,
  ActivateAlarmTemplateMutationVariables
>;
export const CreatePatientInGroupDocument = gql`
  mutation createPatientInGroup($patientGroup: ID!, $patientInput: CreatePatientInput!) {
    createPatientInGroup(patientGroup: $patientGroup, patientInput: $patientInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      patient {
        id
      }
    }
  }
`;

/**
 * __useCreatePatientInGroupMutation__
 *
 * To run a mutation, you first call `useCreatePatientInGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientInGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePatientInGroupMutation({
 *   variables: {
 *     patientGroup: // value for 'patientGroup'
 *     patientInput: // value for 'patientInput'
 *   },
 * });
 */
export function useCreatePatientInGroupMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreatePatientInGroupMutation, CreatePatientInGroupMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreatePatientInGroupMutation, CreatePatientInGroupMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreatePatientInGroupMutation, CreatePatientInGroupMutationVariables>(
    CreatePatientInGroupDocument,
    options,
  );
}
export type CreatePatientInGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreatePatientInGroupMutation,
  CreatePatientInGroupMutationVariables
>;
export const AddShareSkyresponseAlarmWithPatientDocument = gql`
  mutation addShareSkyresponseAlarmWithPatient($patientId: ID!, $shareWithPatientIds: [ID]!) {
    addShareSkyresponseAlarmWithPatient(patientId: $patientId, shareWithPatientIds: $shareWithPatientIds) {
      success
      message
    }
  }
`;

/**
 * __useAddShareSkyresponseAlarmWithPatientMutation__
 *
 * To run a mutation, you first call `useAddShareSkyresponseAlarmWithPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddShareSkyresponseAlarmWithPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddShareSkyresponseAlarmWithPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     shareWithPatientIds: // value for 'shareWithPatientIds'
 *   },
 * });
 */
export function useAddShareSkyresponseAlarmWithPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        AddShareSkyresponseAlarmWithPatientMutation,
        AddShareSkyresponseAlarmWithPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          AddShareSkyresponseAlarmWithPatientMutation,
          AddShareSkyresponseAlarmWithPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    AddShareSkyresponseAlarmWithPatientMutation,
    AddShareSkyresponseAlarmWithPatientMutationVariables
  >(AddShareSkyresponseAlarmWithPatientDocument, options);
}
export type AddShareSkyresponseAlarmWithPatientMutationCompositionFunctionResult =
  VueApolloComposable.UseMutationReturn<
    AddShareSkyresponseAlarmWithPatientMutation,
    AddShareSkyresponseAlarmWithPatientMutationVariables
  >;
export const CreateAlarmTemplateDocument = gql`
  mutation createAlarmTemplate($input: AlarmTemplateCreateInput!) {
    createAlarmTemplate(input: $input) {
      alarmTemplate {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useCreateAlarmTemplateMutation__
 *
 * To run a mutation, you first call `useCreateAlarmTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlarmTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAlarmTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateAlarmTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateAlarmTemplateMutation, CreateAlarmTemplateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateAlarmTemplateMutation, CreateAlarmTemplateMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateAlarmTemplateMutation, CreateAlarmTemplateMutationVariables>(
    CreateAlarmTemplateDocument,
    options,
  );
}
export type CreateAlarmTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateAlarmTemplateMutation,
  CreateAlarmTemplateMutationVariables
>;
export const RetireAlarmTemplateDocument = gql`
  mutation retireAlarmTemplate($id: ID!) {
    retireAlarmTemplate(id: $id) {
      alarmTemplate {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useRetireAlarmTemplateMutation__
 *
 * To run a mutation, you first call `useRetireAlarmTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetireAlarmTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetireAlarmTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRetireAlarmTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RetireAlarmTemplateMutation, RetireAlarmTemplateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RetireAlarmTemplateMutation, RetireAlarmTemplateMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RetireAlarmTemplateMutation, RetireAlarmTemplateMutationVariables>(
    RetireAlarmTemplateDocument,
    options,
  );
}
export type RetireAlarmTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RetireAlarmTemplateMutation,
  RetireAlarmTemplateMutationVariables
>;
export const UpdateAlarmTemplateDocument = gql`
  mutation updateAlarmTemplate($id: ID!, $input: AlarmTemplateUpdateInput!) {
    updateAlarmTemplate(id: $id, input: $input) {
      alarmTemplate {
        id
      }
      success
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
      message
    }
  }
`;

/**
 * __useUpdateAlarmTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateAlarmTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlarmTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAlarmTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAlarmTemplateMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateAlarmTemplateMutation, UpdateAlarmTemplateMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateAlarmTemplateMutation, UpdateAlarmTemplateMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateAlarmTemplateMutation, UpdateAlarmTemplateMutationVariables>(
    UpdateAlarmTemplateDocument,
    options,
  );
}
export type UpdateAlarmTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAlarmTemplateMutation,
  UpdateAlarmTemplateMutationVariables
>;
export const CreateAlarmSubscriptionDocument = gql`
  mutation createAlarmSubscription($createInput: AlarmSubscriptionCreateInput!) {
    createAlarmSubscription(createInput: $createInput) {
      success
      inputValidation {
        valid
        errors {
          message
        }
      }
      message
      alarmSubscription {
        id
      }
    }
  }
`;

/**
 * __useCreateAlarmSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateAlarmSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlarmSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAlarmSubscriptionMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateAlarmSubscriptionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateAlarmSubscriptionMutation, CreateAlarmSubscriptionMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          CreateAlarmSubscriptionMutation,
          CreateAlarmSubscriptionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<CreateAlarmSubscriptionMutation, CreateAlarmSubscriptionMutationVariables>(
    CreateAlarmSubscriptionDocument,
    options,
  );
}
export type CreateAlarmSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateAlarmSubscriptionMutation,
  CreateAlarmSubscriptionMutationVariables
>;
export const DeleteAlarmSubscriptionDocument = gql`
  mutation deleteAlarmSubscription($id: String!) {
    deleteAlarmSubscription(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteAlarmSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteAlarmSubscriptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlarmSubscriptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAlarmSubscriptionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAlarmSubscriptionMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteAlarmSubscriptionMutation, DeleteAlarmSubscriptionMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          DeleteAlarmSubscriptionMutation,
          DeleteAlarmSubscriptionMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteAlarmSubscriptionMutation, DeleteAlarmSubscriptionMutationVariables>(
    DeleteAlarmSubscriptionDocument,
    options,
  );
}
export type DeleteAlarmSubscriptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteAlarmSubscriptionMutation,
  DeleteAlarmSubscriptionMutationVariables
>;
export const UpdatePatientProfileDocument = gql`
  mutation updatePatientProfile($patientId: ID!, $patientInput: UpdatePatientInput!) {
    updatePatient(patientId: $patientId, patientInput: $patientInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdatePatientProfileMutation__
 *
 * To run a mutation, you first call `useUpdatePatientProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientProfileMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     patientInput: // value for 'patientInput'
 *   },
 * });
 */
export function useUpdatePatientProfileMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdatePatientProfileMutation, UpdatePatientProfileMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdatePatientProfileMutation, UpdatePatientProfileMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePatientProfileMutation, UpdatePatientProfileMutationVariables>(
    UpdatePatientProfileDocument,
    options,
  );
}
export type UpdatePatientProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientProfileMutation,
  UpdatePatientProfileMutationVariables
>;
export const GetAlarmTemplateDocument = gql`
  query getAlarmTemplate($id: ID!) {
    getAlarmTemplate(id: $id) {
      id
      status
      alarmIcon
      callbackMinutes
      debounceDelay
      cep {
        trigger
        after
        cancelledBy
      }
      technical
      tagAction {
        target
        type
        label
      }
      vkpEncounter {
        type
        reason
      }
      generatesAlarm
      locationTraceOnly
      forwardingOnly
      noCarePlanRequired
      resolveAction
      identifier {
        value
      }
      description
      code {
        coding {
          display
          code
          system
        }
        text
      }
      effectiveTiming {
        repeat {
          dayOfWeek
          timeOfDay
        }
      }
      interpretation {
        text
        coding {
          code
          display
        }
      }
      component {
        code {
          coding {
            system
            display
            code
          }
          text
        }
        extension {
          url
          valueBoolean
          valueInteger
          valueString
          ValueId
        }
      }
      direction
    }
  }
`;

/**
 * __useGetAlarmTemplateQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmTemplateQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetAlarmTemplateQuery(
  variables:
    | GetAlarmTemplateQueryVariables
    | VueCompositionApi.Ref<GetAlarmTemplateQueryVariables>
    | ReactiveFunction<GetAlarmTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>(
    GetAlarmTemplateDocument,
    variables,
    options,
  );
}
export function useGetAlarmTemplateLazyQuery(
  variables?:
    | GetAlarmTemplateQueryVariables
    | VueCompositionApi.Ref<GetAlarmTemplateQueryVariables>
    | ReactiveFunction<GetAlarmTemplateQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetAlarmTemplateQuery, GetAlarmTemplateQueryVariables>(
    GetAlarmTemplateDocument,
    variables,
    options,
  );
}
export type GetAlarmTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmTemplateQuery,
  GetAlarmTemplateQueryVariables
>;
export const HealthProviderSettingsForExternalIdHumanInputDocument = gql`
  query healthProviderSettingsForExternalIdHumanInput {
    healthProviderSettings {
      userAuth {
        twoFactorSms
        externalIdP {
          alias
          default
          displayName
          enabled
          support
        }
      }
      patientAuth {
        twoFactorSms
      }
      externalHumanIdTypes {
        id
      }
    }
  }
`;

/**
 * __useHealthProviderSettingsForExternalIdHumanInputQuery__
 *
 * To run a query within a Vue component, call `useHealthProviderSettingsForExternalIdHumanInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthProviderSettingsForExternalIdHumanInputQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHealthProviderSettingsForExternalIdHumanInputQuery();
 */
export function useHealthProviderSettingsForExternalIdHumanInputQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsForExternalIdHumanInputQuery,
        HealthProviderSettingsForExternalIdHumanInputQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForExternalIdHumanInputQuery,
          HealthProviderSettingsForExternalIdHumanInputQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForExternalIdHumanInputQuery,
          HealthProviderSettingsForExternalIdHumanInputQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    HealthProviderSettingsForExternalIdHumanInputQuery,
    HealthProviderSettingsForExternalIdHumanInputQueryVariables
  >(HealthProviderSettingsForExternalIdHumanInputDocument, {}, options);
}
export function useHealthProviderSettingsForExternalIdHumanInputLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsForExternalIdHumanInputQuery,
        HealthProviderSettingsForExternalIdHumanInputQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForExternalIdHumanInputQuery,
          HealthProviderSettingsForExternalIdHumanInputQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsForExternalIdHumanInputQuery,
          HealthProviderSettingsForExternalIdHumanInputQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    HealthProviderSettingsForExternalIdHumanInputQuery,
    HealthProviderSettingsForExternalIdHumanInputQueryVariables
  >(HealthProviderSettingsForExternalIdHumanInputDocument, {}, options);
}
export type HealthProviderSettingsForExternalIdHumanInputQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    HealthProviderSettingsForExternalIdHumanInputQuery,
    HealthProviderSettingsForExternalIdHumanInputQueryVariables
  >;
export const DeleteAscomForwarderDocument = gql`
  mutation deleteAscomForwarder($id: ID!) {
    deleteAscomForwarder(id: $id) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
    }
  }
`;

/**
 * __useDeleteAscomForwarderMutation__
 *
 * To run a mutation, you first call `useDeleteAscomForwarderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAscomForwarderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAscomForwarderMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAscomForwarderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteAscomForwarderMutation, DeleteAscomForwarderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteAscomForwarderMutation, DeleteAscomForwarderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteAscomForwarderMutation, DeleteAscomForwarderMutationVariables>(
    DeleteAscomForwarderDocument,
    options,
  );
}
export type DeleteAscomForwarderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteAscomForwarderMutation,
  DeleteAscomForwarderMutationVariables
>;
export const UpdateAscomForwarderDocument = gql`
  mutation updateAscomForwarder($id: ID!, $updateInput: UpdateAscomForwarder!) {
    updateAscomForwarder(id: $id, updateInput: $updateInput) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
    }
  }
`;

/**
 * __useUpdateAscomForwarderMutation__
 *
 * To run a mutation, you first call `useUpdateAscomForwarderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAscomForwarderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAscomForwarderMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateAscomForwarderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateAscomForwarderMutation, UpdateAscomForwarderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateAscomForwarderMutation, UpdateAscomForwarderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateAscomForwarderMutation, UpdateAscomForwarderMutationVariables>(
    UpdateAscomForwarderDocument,
    options,
  );
}
export type UpdateAscomForwarderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAscomForwarderMutation,
  UpdateAscomForwarderMutationVariables
>;
export const CreateAscomForwarderDocument = gql`
  mutation createAscomForwarder($input: CreateAscomForwarder!) {
    createAscomForwarder(input: $input) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
    }
  }
`;

/**
 * __useCreateAscomForwarderMutation__
 *
 * To run a mutation, you first call `useCreateAscomForwarderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAscomForwarderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAscomForwarderMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateAscomForwarderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateAscomForwarderMutation, CreateAscomForwarderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateAscomForwarderMutation, CreateAscomForwarderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateAscomForwarderMutation, CreateAscomForwarderMutationVariables>(
    CreateAscomForwarderDocument,
    options,
  );
}
export type CreateAscomForwarderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateAscomForwarderMutation,
  CreateAscomForwarderMutationVariables
>;
export const GetAscomForwardersDocument = gql`
  query getAscomForwarders {
    ascomForwarders {
      id
      primaryUrl
      displayName
      apiKey
      ascomIntegrationId
      heartbeatRate
      active
      connectionStatus {
        httpStatus
        details
        timestamp
      }
    }
  }
`;

/**
 * __useGetAscomForwardersQuery__
 *
 * To run a query within a Vue component, call `useGetAscomForwardersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAscomForwardersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAscomForwardersQuery();
 */
export function useGetAscomForwardersQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAscomForwardersQuery, GetAscomForwardersQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAscomForwardersQuery, GetAscomForwardersQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAscomForwardersQuery, GetAscomForwardersQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAscomForwardersQuery, GetAscomForwardersQueryVariables>(
    GetAscomForwardersDocument,
    {},
    options,
  );
}
export function useGetAscomForwardersLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAscomForwardersQuery, GetAscomForwardersQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAscomForwardersQuery, GetAscomForwardersQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAscomForwardersQuery, GetAscomForwardersQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAscomForwardersQuery, GetAscomForwardersQueryVariables>(
    GetAscomForwardersDocument,
    {},
    options,
  );
}
export type GetAscomForwardersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAscomForwardersQuery,
  GetAscomForwardersQueryVariables
>;
export const GetAlmaForwardersDocument = gql`
  query getAlmaForwarders {
    almaForwarders {
      id
      primaryUrl
      displayName
      username
      password
    }
  }
`;

/**
 * __useGetAlmaForwardersQuery__
 *
 * To run a query within a Vue component, call `useGetAlmaForwardersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlmaForwardersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlmaForwardersQuery();
 */
export function useGetAlmaForwardersQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAlmaForwardersQuery, GetAlmaForwardersQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlmaForwardersQuery, GetAlmaForwardersQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlmaForwardersQuery, GetAlmaForwardersQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAlmaForwardersQuery, GetAlmaForwardersQueryVariables>(
    GetAlmaForwardersDocument,
    {},
    options,
  );
}
export function useGetAlmaForwardersLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAlmaForwardersQuery, GetAlmaForwardersQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlmaForwardersQuery, GetAlmaForwardersQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlmaForwardersQuery, GetAlmaForwardersQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAlmaForwardersQuery, GetAlmaForwardersQueryVariables>(
    GetAlmaForwardersDocument,
    {},
    options,
  );
}
export type GetAlmaForwardersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlmaForwardersQuery,
  GetAlmaForwardersQueryVariables
>;
export const CreateAlmaForwarderDocument = gql`
  mutation createAlmaForwarder($input: CreateAlmaForwarder!) {
    createAlmaForwarder(input: $input) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
    }
  }
`;

/**
 * __useCreateAlmaForwarderMutation__
 *
 * To run a mutation, you first call `useCreateAlmaForwarderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlmaForwarderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAlmaForwarderMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateAlmaForwarderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateAlmaForwarderMutation, CreateAlmaForwarderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateAlmaForwarderMutation, CreateAlmaForwarderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateAlmaForwarderMutation, CreateAlmaForwarderMutationVariables>(
    CreateAlmaForwarderDocument,
    options,
  );
}
export type CreateAlmaForwarderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateAlmaForwarderMutation,
  CreateAlmaForwarderMutationVariables
>;
export const UpdateAlmaForwarderDocument = gql`
  mutation updateAlmaForwarder($id: ID!, $updateInput: UpdateAlmaForwarder!) {
    updateAlmaForwarder(id: $id, updateInput: $updateInput) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
    }
  }
`;

/**
 * __useUpdateAlmaForwarderMutation__
 *
 * To run a mutation, you first call `useUpdateAlmaForwarderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlmaForwarderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAlmaForwarderMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateAlmaForwarderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateAlmaForwarderMutation, UpdateAlmaForwarderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateAlmaForwarderMutation, UpdateAlmaForwarderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateAlmaForwarderMutation, UpdateAlmaForwarderMutationVariables>(
    UpdateAlmaForwarderDocument,
    options,
  );
}
export type UpdateAlmaForwarderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAlmaForwarderMutation,
  UpdateAlmaForwarderMutationVariables
>;
export const DeleteAlmaForwarderDocument = gql`
  mutation deleteAlmaForwarder($id: ID!) {
    deleteAlmaForwarder(id: $id) {
      success
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      message
    }
  }
`;

/**
 * __useDeleteAlmaForwarderMutation__
 *
 * To run a mutation, you first call `useDeleteAlmaForwarderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlmaForwarderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAlmaForwarderMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAlmaForwarderMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteAlmaForwarderMutation, DeleteAlmaForwarderMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteAlmaForwarderMutation, DeleteAlmaForwarderMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteAlmaForwarderMutation, DeleteAlmaForwarderMutationVariables>(
    DeleteAlmaForwarderDocument,
    options,
  );
}
export type DeleteAlmaForwarderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteAlmaForwarderMutation,
  DeleteAlmaForwarderMutationVariables
>;
export const GetAllAlarmHistoryDocument = gql`
  query getAllAlarmHistory($from: dateTime!, $to: dateTime!, $patientGroupIds: [ID!]) {
    getAllAlarmHistory(from: $from, to: $to, patientGroupIds: $patientGroupIds) {
      telluAlarmId
      responseCenterAlarmId
      tag
      name {
        display
      }
      owner {
        display
      }
      alarmEvent
      serverAlarmTime
      deactivationTime
      patientId
      alarmHandling
      journalWorkflowStatus
      alarmReason
      acceptedAt
      alarmCode
      priority
      organization
      group
      alarmAction
      timeUntilVisible
      responseCenter
      textMessage
      globalAlarmId
      identifier
      patientName {
        given
        family
        text
      }
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
    }
  }
`;

/**
 * __useGetAllAlarmHistoryQuery__
 *
 * To run a query within a Vue component, call `useGetAllAlarmHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAlarmHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllAlarmHistoryQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   patientGroupIds: // value for 'patientGroupIds'
 * });
 */
export function useGetAllAlarmHistoryQuery(
  variables:
    | GetAllAlarmHistoryQueryVariables
    | VueCompositionApi.Ref<GetAllAlarmHistoryQueryVariables>
    | ReactiveFunction<GetAllAlarmHistoryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>(
    GetAllAlarmHistoryDocument,
    variables,
    options,
  );
}
export function useGetAllAlarmHistoryLazyQuery(
  variables?:
    | GetAllAlarmHistoryQueryVariables
    | VueCompositionApi.Ref<GetAllAlarmHistoryQueryVariables>
    | ReactiveFunction<GetAllAlarmHistoryQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllAlarmHistoryQuery, GetAllAlarmHistoryQueryVariables>(
    GetAllAlarmHistoryDocument,
    variables,
    options,
  );
}
export type GetAllAlarmHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllAlarmHistoryQuery,
  GetAllAlarmHistoryQueryVariables
>;
export const GetAlarmHistoryForPatientDocument = gql`
  query getAlarmHistoryForPatient($from: dateTime!, $to: dateTime!, $patientId: ID!) {
    getAlarmHistoryForPatient(from: $from, to: $to, patientId: $patientId) {
      telluAlarmId
      responseCenterAlarmId
      tag
      name {
        display
      }
      owner {
        display
      }
      alarmEvent
      serverAlarmTime
      deactivationTime
      patientId
      alarmHandling
      journalWorkflowStatus
      alarmReason
      acceptedAt
      alarmCode
      priority
      organization
      group
      alarmAction
      timeUntilVisible
      responseCenter
      textMessage
      identifier
      globalAlarmId
      patientName {
        given
        family
        text
      }
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
    }
  }
`;

/**
 * __useGetAlarmHistoryForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmHistoryForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmHistoryForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmHistoryForPatientQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetAlarmHistoryForPatientQuery(
  variables:
    | GetAlarmHistoryForPatientQueryVariables
    | VueCompositionApi.Ref<GetAlarmHistoryForPatientQueryVariables>
    | ReactiveFunction<GetAlarmHistoryForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>(
    GetAlarmHistoryForPatientDocument,
    variables,
    options,
  );
}
export function useGetAlarmHistoryForPatientLazyQuery(
  variables?:
    | GetAlarmHistoryForPatientQueryVariables
    | VueCompositionApi.Ref<GetAlarmHistoryForPatientQueryVariables>
    | ReactiveFunction<GetAlarmHistoryForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAlarmHistoryForPatientQuery, GetAlarmHistoryForPatientQueryVariables>(
    GetAlarmHistoryForPatientDocument,
    variables,
    options,
  );
}
export type GetAlarmHistoryForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmHistoryForPatientQuery,
  GetAlarmHistoryForPatientQueryVariables
>;
export const UserGroupForAlarmHistoryDocument = gql`
  query userGroupForAlarmHistory($userGroupId: ID) {
    userGroup(userGroupId: $userGroupId) {
      id
      name
      skyresponse {
        enabled
        organizationId
        hasSkyresponseExternalId
        hasSkyresponseCredentials
      }
    }
  }
`;

/**
 * __useUserGroupForAlarmHistoryQuery__
 *
 * To run a query within a Vue component, call `useUserGroupForAlarmHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupForAlarmHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupForAlarmHistoryQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useUserGroupForAlarmHistoryQuery(
  variables:
    | UserGroupForAlarmHistoryQueryVariables
    | VueCompositionApi.Ref<UserGroupForAlarmHistoryQueryVariables>
    | ReactiveFunction<UserGroupForAlarmHistoryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>(
    UserGroupForAlarmHistoryDocument,
    variables,
    options,
  );
}
export function useUserGroupForAlarmHistoryLazyQuery(
  variables:
    | UserGroupForAlarmHistoryQueryVariables
    | VueCompositionApi.Ref<UserGroupForAlarmHistoryQueryVariables>
    | ReactiveFunction<UserGroupForAlarmHistoryQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupForAlarmHistoryQuery, UserGroupForAlarmHistoryQueryVariables>(
    UserGroupForAlarmHistoryDocument,
    variables,
    options,
  );
}
export type UserGroupForAlarmHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupForAlarmHistoryQuery,
  UserGroupForAlarmHistoryQueryVariables
>;
export const GetAlarmHistoryDetailByIdDocument = gql`
  query getAlarmHistoryDetailById($telluAlarmId: ID, $skyresponseAlarmId: ID) {
    getAlarmHistoryDetailById(telluAlarmId: $telluAlarmId, skyresponseAlarmId: $skyresponseAlarmId) {
      skyresponseAlarmDetail {
        id
        userId
        name
        messages
        serverAlarmTime
        deactivationTime
        responseCenter
        globalAlarmId
        reason
        identifier
        action
        acceptedAt
        logs {
          created
          type
          subType
          text
          name
        }
        textMessage
        alarmCode
      }
      telluAlarmDetail {
        input {
          values {
            name
            valueString
            valueBoolean
            valueNumber
          }
          valueReference {
            reference
          }
          type {
            text
            coding {
              system
              code
            }
          }
          icon
          priority
          timestamp
        }
        priorityInput {
          timestamp
          icon
          priority
          templateCode
          templateDisplayName
        }
        patient {
          id
          name {
            given
            family
            text
          }
          patientGroups {
            id
            name
          }
        }
        id
        for {
          display
        }
        description
        priority
        authoredOn
        note {
          authorString
          authorReference {
            display
          }
          time
          text
        }
        acceptedAt
        presentAt
        completedAt
        journalWorkflow {
          type
          status
          userGroupId
          retriedAt
          nextRetry
          completedAt
          freeTextNote
          completionOptions
          debugDetails
        }
      }
    }
  }
`;

/**
 * __useGetAlarmHistoryDetailByIdQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmHistoryDetailByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmHistoryDetailByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmHistoryDetailByIdQuery({
 *   telluAlarmId: // value for 'telluAlarmId'
 *   skyresponseAlarmId: // value for 'skyresponseAlarmId'
 * });
 */
export function useGetAlarmHistoryDetailByIdQuery(
  variables:
    | GetAlarmHistoryDetailByIdQueryVariables
    | VueCompositionApi.Ref<GetAlarmHistoryDetailByIdQueryVariables>
    | ReactiveFunction<GetAlarmHistoryDetailByIdQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>(
    GetAlarmHistoryDetailByIdDocument,
    variables,
    options,
  );
}
export function useGetAlarmHistoryDetailByIdLazyQuery(
  variables:
    | GetAlarmHistoryDetailByIdQueryVariables
    | VueCompositionApi.Ref<GetAlarmHistoryDetailByIdQueryVariables>
    | ReactiveFunction<GetAlarmHistoryDetailByIdQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAlarmHistoryDetailByIdQuery, GetAlarmHistoryDetailByIdQueryVariables>(
    GetAlarmHistoryDetailByIdDocument,
    variables,
    options,
  );
}
export type GetAlarmHistoryDetailByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmHistoryDetailByIdQuery,
  GetAlarmHistoryDetailByIdQueryVariables
>;
export const GetAlarmHistoryForResponseOperatorDocument = gql`
  query getAlarmHistoryForResponseOperator(
    $sessionFilter: Boolean
    $from: dateTime
    $to: dateTime
    $onlyClosedByResponseOperator: Boolean
  ) {
    getAlarmHistoryForResponseOperator(
      sessionFilter: $sessionFilter
      from: $from
      to: $to
      onlyClosedByResponseOperator: $onlyClosedByResponseOperator
    ) {
      id
      status
      code {
        text
      }
      intent
      priority
      acceptedAt
      presentAt
      completedAt
      priorityInput {
        valueReference {
          reference
        }
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      for {
        reference
      }
      description
      authoredOn
      firstEventTimestamp
      owner {
        reference
        display
        identifier {
          value
        }
      }
      input {
        valueReference {
          reference
        }
        values {
          name
          valueString
          valueBoolean
          valueNumber
        }
        type {
          text
          coding {
            code
          }
        }
        timestamp
        priority
        icon
      }
      note {
        authorString
        time
        text
      }
      locationTraces {
        forDeviceId
        gpsLocations {
          position {
            longitude
            latitude
            altitude
          }
          description
          address {
            use
            line
            city
            postalCode
            country
            text
          }
          gpsTimestamp
          receivedTimestamp
        }
        latestGpsLocation {
          position {
            longitude
            latitude
            altitude
          }
          description
          address {
            use
            line
            city
            postalCode
            country
            text
          }
          gpsTimestamp
          receivedTimestamp
        }
      }
      journalWorkflow {
        type
        status
        userGroupId
        retriedAt
        nextRetry
        completedAt
        freeTextNote
        completionOptions
        debugDetails
      }
      patient {
        id
        name {
          given
          family
        }
        patientGroups {
          id
          name
          enableDistanceEstimation
          enableOnSiteRegistration
        }
        address {
          line
          postalCode
          city
          country
          text
        }
        photo {
          url
        }
        skyresponseDetails {
          enabled
          organizationId
          hasSkyresponseExternalId
          hasSkyresponseCredentials
        }
      }
    }
  }
`;

/**
 * __useGetAlarmHistoryForResponseOperatorQuery__
 *
 * To run a query within a Vue component, call `useGetAlarmHistoryForResponseOperatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmHistoryForResponseOperatorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAlarmHistoryForResponseOperatorQuery({
 *   sessionFilter: // value for 'sessionFilter'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   onlyClosedByResponseOperator: // value for 'onlyClosedByResponseOperator'
 * });
 */
export function useGetAlarmHistoryForResponseOperatorQuery(
  variables:
    | GetAlarmHistoryForResponseOperatorQueryVariables
    | VueCompositionApi.Ref<GetAlarmHistoryForResponseOperatorQueryVariables>
    | ReactiveFunction<GetAlarmHistoryForResponseOperatorQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmHistoryForResponseOperatorQuery,
        GetAlarmHistoryForResponseOperatorQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmHistoryForResponseOperatorQuery,
          GetAlarmHistoryForResponseOperatorQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmHistoryForResponseOperatorQuery,
          GetAlarmHistoryForResponseOperatorQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAlarmHistoryForResponseOperatorQuery,
    GetAlarmHistoryForResponseOperatorQueryVariables
  >(GetAlarmHistoryForResponseOperatorDocument, variables, options);
}
export function useGetAlarmHistoryForResponseOperatorLazyQuery(
  variables:
    | GetAlarmHistoryForResponseOperatorQueryVariables
    | VueCompositionApi.Ref<GetAlarmHistoryForResponseOperatorQueryVariables>
    | ReactiveFunction<GetAlarmHistoryForResponseOperatorQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAlarmHistoryForResponseOperatorQuery,
        GetAlarmHistoryForResponseOperatorQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAlarmHistoryForResponseOperatorQuery,
          GetAlarmHistoryForResponseOperatorQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAlarmHistoryForResponseOperatorQuery,
          GetAlarmHistoryForResponseOperatorQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAlarmHistoryForResponseOperatorQuery,
    GetAlarmHistoryForResponseOperatorQueryVariables
  >(GetAlarmHistoryForResponseOperatorDocument, variables, options);
}
export type GetAlarmHistoryForResponseOperatorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAlarmHistoryForResponseOperatorQuery,
  GetAlarmHistoryForResponseOperatorQueryVariables
>;
export const CmpAccountsDocument = gql`
  query cmpAccounts {
    cmpAccounts {
      id
      clientId
      clientSecret
      customerGroup
    }
  }
`;

/**
 * __useCmpAccountsQuery__
 *
 * To run a query within a Vue component, call `useCmpAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmpAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCmpAccountsQuery();
 */
export function useCmpAccountsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<CmpAccountsQuery, CmpAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CmpAccountsQuery, CmpAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CmpAccountsQuery, CmpAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<CmpAccountsQuery, CmpAccountsQueryVariables>(CmpAccountsDocument, {}, options);
}
export function useCmpAccountsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<CmpAccountsQuery, CmpAccountsQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CmpAccountsQuery, CmpAccountsQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<CmpAccountsQuery, CmpAccountsQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<CmpAccountsQuery, CmpAccountsQueryVariables>(
    CmpAccountsDocument,
    {},
    options,
  );
}
export type CmpAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  CmpAccountsQuery,
  CmpAccountsQueryVariables
>;
export const ValidateCustomerGroupTowardsCmpDocument = gql`
  mutation validateCustomerGroupTowardsCmp($id: String!) {
    validateCustomerGroupTowardsCmp(id: $id) {
      success
      message
      device
      totalDevices
    }
  }
`;

/**
 * __useValidateCustomerGroupTowardsCmpMutation__
 *
 * To run a mutation, you first call `useValidateCustomerGroupTowardsCmpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useValidateCustomerGroupTowardsCmpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useValidateCustomerGroupTowardsCmpMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useValidateCustomerGroupTowardsCmpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ValidateCustomerGroupTowardsCmpMutation,
        ValidateCustomerGroupTowardsCmpMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ValidateCustomerGroupTowardsCmpMutation,
          ValidateCustomerGroupTowardsCmpMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ValidateCustomerGroupTowardsCmpMutation,
    ValidateCustomerGroupTowardsCmpMutationVariables
  >(ValidateCustomerGroupTowardsCmpDocument, options);
}
export type ValidateCustomerGroupTowardsCmpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ValidateCustomerGroupTowardsCmpMutation,
  ValidateCustomerGroupTowardsCmpMutationVariables
>;
export const DeleteCmpAccountDocument = gql`
  mutation deleteCmpAccount($id: String!) {
    deleteCmpAccount(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useDeleteCmpAccountMutation__
 *
 * To run a mutation, you first call `useDeleteCmpAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCmpAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCmpAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCmpAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteCmpAccountMutation, DeleteCmpAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteCmpAccountMutation, DeleteCmpAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteCmpAccountMutation, DeleteCmpAccountMutationVariables>(
    DeleteCmpAccountDocument,
    options,
  );
}
export type DeleteCmpAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteCmpAccountMutation,
  DeleteCmpAccountMutationVariables
>;
export const ValidateCmpAccountTowardsCmpDocument = gql`
  mutation validateCmpAccountTowardsCmp($id: String!) {
    validateCmpAccountTowardsCmp(id: $id) {
      success
      message
    }
  }
`;

/**
 * __useValidateCmpAccountTowardsCmpMutation__
 *
 * To run a mutation, you first call `useValidateCmpAccountTowardsCmpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useValidateCmpAccountTowardsCmpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useValidateCmpAccountTowardsCmpMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useValidateCmpAccountTowardsCmpMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ValidateCmpAccountTowardsCmpMutation,
        ValidateCmpAccountTowardsCmpMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ValidateCmpAccountTowardsCmpMutation,
          ValidateCmpAccountTowardsCmpMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ValidateCmpAccountTowardsCmpMutation,
    ValidateCmpAccountTowardsCmpMutationVariables
  >(ValidateCmpAccountTowardsCmpDocument, options);
}
export type ValidateCmpAccountTowardsCmpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ValidateCmpAccountTowardsCmpMutation,
  ValidateCmpAccountTowardsCmpMutationVariables
>;
export const CreateCmpAccountDocument = gql`
  mutation createCmpAccount($input: CmpAccountCreateInput!) {
    createCmpAccount(input: $input) {
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useCreateCmpAccountMutation__
 *
 * To run a mutation, you first call `useCreateCmpAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCmpAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCmpAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCmpAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCmpAccountMutation, CreateCmpAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateCmpAccountMutation, CreateCmpAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCmpAccountMutation, CreateCmpAccountMutationVariables>(
    CreateCmpAccountDocument,
    options,
  );
}
export type CreateCmpAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCmpAccountMutation,
  CreateCmpAccountMutationVariables
>;
export const UpdateCmpAccountDocument = gql`
  mutation updateCmpAccount($id: String!, $input: CmpAccountUpdateInput!) {
    updateCmpAccount(id: $id, input: $input) {
      success
      message
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useUpdateCmpAccountMutation__
 *
 * To run a mutation, you first call `useUpdateCmpAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCmpAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCmpAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCmpAccountMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateCmpAccountMutation, UpdateCmpAccountMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateCmpAccountMutation, UpdateCmpAccountMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateCmpAccountMutation, UpdateCmpAccountMutationVariables>(
    UpdateCmpAccountDocument,
    options,
  );
}
export type UpdateCmpAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateCmpAccountMutation,
  UpdateCmpAccountMutationVariables
>;
export const GetPatientCmpDevicesDocument = gql`
  query getPatientCmpDevices($id: ID!) {
    getPatientCmpDevices(id: $id) {
      id
      portalConnection {
        name
        value
        time
      }
      batteryStatus {
        name
        value
        time
      }
      powerSupply {
        name
        value
        time
      }
      alarmCode
      operationalStatus {
        name
        value
      }
      groupName
      url
      children {
        radioIdCode
        activeTimeSpan {
          hasTimeSpan
          timeSpan
        }
        equipmentType {
          name
          value
        }
        locationCode {
          name
          value
        }
        batteryStatus {
          name
          value
        }
        supervisionStatus {
          name
          value
          time
        }
      }
    }
  }
`;

/**
 * __useGetPatientCmpDevicesQuery__
 *
 * To run a query within a Vue component, call `useGetPatientCmpDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientCmpDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientCmpDevicesQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPatientCmpDevicesQuery(
  variables:
    | GetPatientCmpDevicesQueryVariables
    | VueCompositionApi.Ref<GetPatientCmpDevicesQueryVariables>
    | ReactiveFunction<GetPatientCmpDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>(
    GetPatientCmpDevicesDocument,
    variables,
    options,
  );
}
export function useGetPatientCmpDevicesLazyQuery(
  variables?:
    | GetPatientCmpDevicesQueryVariables
    | VueCompositionApi.Ref<GetPatientCmpDevicesQueryVariables>
    | ReactiveFunction<GetPatientCmpDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientCmpDevicesQuery, GetPatientCmpDevicesQueryVariables>(
    GetPatientCmpDevicesDocument,
    variables,
    options,
  );
}
export type GetPatientCmpDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientCmpDevicesQuery,
  GetPatientCmpDevicesQueryVariables
>;
export const GetAllAlarmSubscriptionsDocument = gql`
  query getAllAlarmSubscriptions {
    getAllAlarmSubscriptions {
      id
      userId
      type
      targetEmails
      targetPhoneNumbers
      deviceGroupIds
      patientGroupIds
    }
  }
`;

/**
 * __useGetAllAlarmSubscriptionsQuery__
 *
 * To run a query within a Vue component, call `useGetAllAlarmSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAlarmSubscriptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllAlarmSubscriptionsQuery();
 */
export function useGetAllAlarmSubscriptionsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>(
    GetAllAlarmSubscriptionsDocument,
    {},
    options,
  );
}
export function useGetAllAlarmSubscriptionsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllAlarmSubscriptionsQuery, GetAllAlarmSubscriptionsQueryVariables>(
    GetAllAlarmSubscriptionsDocument,
    {},
    options,
  );
}
export type GetAllAlarmSubscriptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllAlarmSubscriptionsQuery,
  GetAllAlarmSubscriptionsQueryVariables
>;
export const GetAllUsersAlarmSubscriptionsDocument = gql`
  query getAllUsersAlarmSubscriptions {
    getAllUsersAlarmSubscriptions {
      id
      userId
      type
      targetEmails
      targetPhoneNumbers
      deviceGroupIds
      patientGroupIds
    }
  }
`;

/**
 * __useGetAllUsersAlarmSubscriptionsQuery__
 *
 * To run a query within a Vue component, call `useGetAllUsersAlarmSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersAlarmSubscriptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllUsersAlarmSubscriptionsQuery();
 */
export function useGetAllUsersAlarmSubscriptionsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllUsersAlarmSubscriptionsQuery,
        GetAllUsersAlarmSubscriptionsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllUsersAlarmSubscriptionsQuery,
          GetAllUsersAlarmSubscriptionsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllUsersAlarmSubscriptionsQuery,
          GetAllUsersAlarmSubscriptionsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllUsersAlarmSubscriptionsQuery, GetAllUsersAlarmSubscriptionsQueryVariables>(
    GetAllUsersAlarmSubscriptionsDocument,
    {},
    options,
  );
}
export function useGetAllUsersAlarmSubscriptionsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllUsersAlarmSubscriptionsQuery,
        GetAllUsersAlarmSubscriptionsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllUsersAlarmSubscriptionsQuery,
          GetAllUsersAlarmSubscriptionsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllUsersAlarmSubscriptionsQuery,
          GetAllUsersAlarmSubscriptionsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllUsersAlarmSubscriptionsQuery,
    GetAllUsersAlarmSubscriptionsQueryVariables
  >(GetAllUsersAlarmSubscriptionsDocument, {}, options);
}
export type GetAllUsersAlarmSubscriptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllUsersAlarmSubscriptionsQuery,
  GetAllUsersAlarmSubscriptionsQueryVariables
>;
export const GetCameraAdminUrlDocument = gql`
  query getCameraAdminUrl($cameraId: ID!) {
    getCameraAdmin(cameraId: $cameraId) {
      adminUrl
    }
  }
`;

/**
 * __useGetCameraAdminUrlQuery__
 *
 * To run a query within a Vue component, call `useGetCameraAdminUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraAdminUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCameraAdminUrlQuery({
 *   cameraId: // value for 'cameraId'
 * });
 */
export function useGetCameraAdminUrlQuery(
  variables:
    | GetCameraAdminUrlQueryVariables
    | VueCompositionApi.Ref<GetCameraAdminUrlQueryVariables>
    | ReactiveFunction<GetCameraAdminUrlQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>(
    GetCameraAdminUrlDocument,
    variables,
    options,
  );
}
export function useGetCameraAdminUrlLazyQuery(
  variables?:
    | GetCameraAdminUrlQueryVariables
    | VueCompositionApi.Ref<GetCameraAdminUrlQueryVariables>
    | ReactiveFunction<GetCameraAdminUrlQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetCameraAdminUrlQuery, GetCameraAdminUrlQueryVariables>(
    GetCameraAdminUrlDocument,
    variables,
    options,
  );
}
export type GetCameraAdminUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetCameraAdminUrlQuery,
  GetCameraAdminUrlQueryVariables
>;
export const GetExternalUrlForWelfareDeviceDocument = gql`
  query getExternalUrlForWelfareDevice($id: ID!) {
    getExternalUrlForWelfareDevice(id: $id)
  }
`;

/**
 * __useGetExternalUrlForWelfareDeviceQuery__
 *
 * To run a query within a Vue component, call `useGetExternalUrlForWelfareDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalUrlForWelfareDeviceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetExternalUrlForWelfareDeviceQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetExternalUrlForWelfareDeviceQuery(
  variables:
    | GetExternalUrlForWelfareDeviceQueryVariables
    | VueCompositionApi.Ref<GetExternalUrlForWelfareDeviceQueryVariables>
    | ReactiveFunction<GetExternalUrlForWelfareDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetExternalUrlForWelfareDeviceQuery,
        GetExternalUrlForWelfareDeviceQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetExternalUrlForWelfareDeviceQuery,
          GetExternalUrlForWelfareDeviceQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetExternalUrlForWelfareDeviceQuery,
          GetExternalUrlForWelfareDeviceQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetExternalUrlForWelfareDeviceQuery,
    GetExternalUrlForWelfareDeviceQueryVariables
  >(GetExternalUrlForWelfareDeviceDocument, variables, options);
}
export function useGetExternalUrlForWelfareDeviceLazyQuery(
  variables?:
    | GetExternalUrlForWelfareDeviceQueryVariables
    | VueCompositionApi.Ref<GetExternalUrlForWelfareDeviceQueryVariables>
    | ReactiveFunction<GetExternalUrlForWelfareDeviceQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetExternalUrlForWelfareDeviceQuery,
        GetExternalUrlForWelfareDeviceQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetExternalUrlForWelfareDeviceQuery,
          GetExternalUrlForWelfareDeviceQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetExternalUrlForWelfareDeviceQuery,
          GetExternalUrlForWelfareDeviceQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetExternalUrlForWelfareDeviceQuery,
    GetExternalUrlForWelfareDeviceQueryVariables
  >(GetExternalUrlForWelfareDeviceDocument, variables, options);
}
export type GetExternalUrlForWelfareDeviceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetExternalUrlForWelfareDeviceQuery,
  GetExternalUrlForWelfareDeviceQueryVariables
>;
export const GetNextOfKinDocument = gql`
  query getNextOfKin($patientId: ID!) {
    getNextOfKin(patientId: $patientId) {
      id
      notifyNextOfKin
      name {
        text
      }
      telecom {
        value
      }
    }
  }
`;

/**
 * __useGetNextOfKinQuery__
 *
 * To run a query within a Vue component, call `useGetNextOfKinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextOfKinQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNextOfKinQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetNextOfKinQuery(
  variables:
    | GetNextOfKinQueryVariables
    | VueCompositionApi.Ref<GetNextOfKinQueryVariables>
    | ReactiveFunction<GetNextOfKinQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetNextOfKinQuery, GetNextOfKinQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNextOfKinQuery, GetNextOfKinQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNextOfKinQuery, GetNextOfKinQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetNextOfKinQuery, GetNextOfKinQueryVariables>(
    GetNextOfKinDocument,
    variables,
    options,
  );
}
export function useGetNextOfKinLazyQuery(
  variables?:
    | GetNextOfKinQueryVariables
    | VueCompositionApi.Ref<GetNextOfKinQueryVariables>
    | ReactiveFunction<GetNextOfKinQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetNextOfKinQuery, GetNextOfKinQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNextOfKinQuery, GetNextOfKinQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNextOfKinQuery, GetNextOfKinQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetNextOfKinQuery, GetNextOfKinQueryVariables>(
    GetNextOfKinDocument,
    variables,
    options,
  );
}
export type GetNextOfKinQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetNextOfKinQuery,
  GetNextOfKinQueryVariables
>;
export const PatientForViewDocument = gql`
  query patientForView($id: ID!) {
    patient(id: $id) {
      id
      active
      externalPatientIds {
        ...externalPatientIds
      }
      userReservations {
        userId
        firstName
        lastName
      }
      name {
        given
        family
        text
      }
      birthDate
      gender
      languages {
        language
        preferred
      }
      identifier {
        value
        use
      }
      telecom {
        system
        value
      }
      skyresponseDetails {
        organizationId
        hasSkyresponseExternalId
        hasSkyresponseCredentials
      }
      address {
        ...address
      }
      secretAddress
      addressNote
      keyCode
      photo {
        url
      }
      patientGroups {
        ...patientGroups
      }
      tags
      note
      notification {
        ...notification
      }
      documents {
        ...documents
      }
      carePlans {
        ...carePlans
      }
      rpmMedicalDevices {
        ...rpmMedicalDevices
      }
      welfareDevices {
        ...welfareDevices
      }
      rpmGateways {
        ...rpmGateways
      }
      dialoggUser {
        ...dialoggUser
      }
      referenceRange {
        ...referenceRange
      }
    }
  }
  ${ExternalPatientIdsFragmentDoc}
  ${AddressFragmentDoc}
  ${PatientGroupsFragmentDoc}
  ${NotificationFragmentDoc}
  ${DocumentsFragmentDoc}
  ${CarePlansFragmentDoc}
  ${RpmMedicalDevicesFragmentDoc}
  ${WelfareDevicesFragmentDoc}
  ${RpmGatewaysFragmentDoc}
  ${DialoggUserFragmentDoc}
  ${ReferenceRangeFragmentDoc}
`;

/**
 * __usePatientForViewQuery__
 *
 * To run a query within a Vue component, call `usePatientForViewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientForViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientForViewQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientForViewQuery(
  variables:
    | PatientForViewQueryVariables
    | VueCompositionApi.Ref<PatientForViewQueryVariables>
    | ReactiveFunction<PatientForViewQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForViewQuery, PatientForViewQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientForViewQuery, PatientForViewQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientForViewQuery, PatientForViewQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientForViewQuery, PatientForViewQueryVariables>(
    PatientForViewDocument,
    variables,
    options,
  );
}
export function usePatientForViewLazyQuery(
  variables?:
    | PatientForViewQueryVariables
    | VueCompositionApi.Ref<PatientForViewQueryVariables>
    | ReactiveFunction<PatientForViewQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForViewQuery, PatientForViewQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientForViewQuery, PatientForViewQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientForViewQuery, PatientForViewQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientForViewQuery, PatientForViewQueryVariables>(
    PatientForViewDocument,
    variables,
    options,
  );
}
export type PatientForViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientForViewQuery,
  PatientForViewQueryVariables
>;
export const PatientForSharedAlarmsDocument = gql`
  query patientForSharedAlarms($id: ID!) {
    patient(id: $id) {
      id
      shareAlarmWith {
        id
        name
        norwegianId
        isPrimary
      }
    }
  }
`;

/**
 * __usePatientForSharedAlarmsQuery__
 *
 * To run a query within a Vue component, call `usePatientForSharedAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientForSharedAlarmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientForSharedAlarmsQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientForSharedAlarmsQuery(
  variables:
    | PatientForSharedAlarmsQueryVariables
    | VueCompositionApi.Ref<PatientForSharedAlarmsQueryVariables>
    | ReactiveFunction<PatientForSharedAlarmsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>(
    PatientForSharedAlarmsDocument,
    variables,
    options,
  );
}
export function usePatientForSharedAlarmsLazyQuery(
  variables?:
    | PatientForSharedAlarmsQueryVariables
    | VueCompositionApi.Ref<PatientForSharedAlarmsQueryVariables>
    | ReactiveFunction<PatientForSharedAlarmsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientForSharedAlarmsQuery, PatientForSharedAlarmsQueryVariables>(
    PatientForSharedAlarmsDocument,
    variables,
    options,
  );
}
export type PatientForSharedAlarmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientForSharedAlarmsQuery,
  PatientForSharedAlarmsQueryVariables
>;
export const GetSharedSkyResponseAlarmsPatientCandidatesDocument = gql`
  query getSharedSkyResponseAlarmsPatientCandidates($patientId: ID!) {
    getSharedSkyResponseAlarmsPatientCandidates(patientId: $patientId) {
      id
      name {
        given
        family
        text
      }
      externalPatientIds {
        type
        id
      }
    }
  }
`;

/**
 * __useGetSharedSkyResponseAlarmsPatientCandidatesQuery__
 *
 * To run a query within a Vue component, call `useGetSharedSkyResponseAlarmsPatientCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedSkyResponseAlarmsPatientCandidatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSharedSkyResponseAlarmsPatientCandidatesQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetSharedSkyResponseAlarmsPatientCandidatesQuery(
  variables:
    | GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
    | VueCompositionApi.Ref<GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables>
    | ReactiveFunction<GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSharedSkyResponseAlarmsPatientCandidatesQuery,
        GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSharedSkyResponseAlarmsPatientCandidatesQuery,
          GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSharedSkyResponseAlarmsPatientCandidatesQuery,
          GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetSharedSkyResponseAlarmsPatientCandidatesQuery,
    GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
  >(GetSharedSkyResponseAlarmsPatientCandidatesDocument, variables, options);
}
export function useGetSharedSkyResponseAlarmsPatientCandidatesLazyQuery(
  variables?:
    | GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
    | VueCompositionApi.Ref<GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables>
    | ReactiveFunction<GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetSharedSkyResponseAlarmsPatientCandidatesQuery,
        GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetSharedSkyResponseAlarmsPatientCandidatesQuery,
          GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetSharedSkyResponseAlarmsPatientCandidatesQuery,
          GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetSharedSkyResponseAlarmsPatientCandidatesQuery,
    GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
  >(GetSharedSkyResponseAlarmsPatientCandidatesDocument, variables, options);
}
export type GetSharedSkyResponseAlarmsPatientCandidatesQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    GetSharedSkyResponseAlarmsPatientCandidatesQuery,
    GetSharedSkyResponseAlarmsPatientCandidatesQueryVariables
  >;
export const RetryAlarmJournalingDocument = gql`
  mutation retryAlarmJournaling($alarmId: ID!) {
    retryAlarmJournaling(alarmId: $alarmId) {
      success
      message
    }
  }
`;

/**
 * __useRetryAlarmJournalingMutation__
 *
 * To run a mutation, you first call `useRetryAlarmJournalingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetryAlarmJournalingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetryAlarmJournalingMutation({
 *   variables: {
 *     alarmId: // value for 'alarmId'
 *   },
 * });
 */
export function useRetryAlarmJournalingMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RetryAlarmJournalingMutation, RetryAlarmJournalingMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<RetryAlarmJournalingMutation, RetryAlarmJournalingMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<RetryAlarmJournalingMutation, RetryAlarmJournalingMutationVariables>(
    RetryAlarmJournalingDocument,
    options,
  );
}
export type RetryAlarmJournalingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RetryAlarmJournalingMutation,
  RetryAlarmJournalingMutationVariables
>;
export const BadgesDocument = gql`
  query badges {
    badges {
      technicalAlarms
      syncAlarms
    }
  }
`;

/**
 * __useBadgesQuery__
 *
 * To run a query within a Vue component, call `useBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBadgesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBadgesQuery();
 */
export function useBadgesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<BadgesQuery, BadgesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BadgesQuery, BadgesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<BadgesQuery, BadgesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<BadgesQuery, BadgesQueryVariables>(BadgesDocument, {}, options);
}
export function useBadgesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<BadgesQuery, BadgesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BadgesQuery, BadgesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<BadgesQuery, BadgesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<BadgesQuery, BadgesQueryVariables>(BadgesDocument, {}, options);
}
export type BadgesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  BadgesQuery,
  BadgesQueryVariables
>;
export const GetDistanceToPositionsDocument = gql`
  query getDistanceToPositions($origins: [GpsPositionOrStringInput!]!, $destinations: [GpsPositionOrStringInput!]!) {
    getDistanceToPositions(origins: $origins, destinations: $destinations) {
      status
      rows {
        elements {
          status
          duration {
            value
            text
          }
          durationInTraffic {
            value
            text
          }
          distance {
            value
            text
          }
        }
      }
    }
  }
`;

/**
 * __useGetDistanceToPositionsQuery__
 *
 * To run a query within a Vue component, call `useGetDistanceToPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistanceToPositionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDistanceToPositionsQuery({
 *   origins: // value for 'origins'
 *   destinations: // value for 'destinations'
 * });
 */
export function useGetDistanceToPositionsQuery(
  variables:
    | GetDistanceToPositionsQueryVariables
    | VueCompositionApi.Ref<GetDistanceToPositionsQueryVariables>
    | ReactiveFunction<GetDistanceToPositionsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDistanceToPositionsQuery, GetDistanceToPositionsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDistanceToPositionsQuery, GetDistanceToPositionsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDistanceToPositionsQuery, GetDistanceToPositionsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetDistanceToPositionsQuery, GetDistanceToPositionsQueryVariables>(
    GetDistanceToPositionsDocument,
    variables,
    options,
  );
}
export function useGetDistanceToPositionsLazyQuery(
  variables?:
    | GetDistanceToPositionsQueryVariables
    | VueCompositionApi.Ref<GetDistanceToPositionsQueryVariables>
    | ReactiveFunction<GetDistanceToPositionsQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDistanceToPositionsQuery, GetDistanceToPositionsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDistanceToPositionsQuery, GetDistanceToPositionsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDistanceToPositionsQuery, GetDistanceToPositionsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetDistanceToPositionsQuery, GetDistanceToPositionsQueryVariables>(
    GetDistanceToPositionsDocument,
    variables,
    options,
  );
}
export type GetDistanceToPositionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDistanceToPositionsQuery,
  GetDistanceToPositionsQueryVariables
>;
export const GetAllPatientAlarmsDocument = gql`
  query getAllPatientAlarms($from: dateTime, $to: dateTime) {
    getAllPatientAlarms(from: $from, to: $to) {
      id
      status
      intent
      priority
      for {
        reference
      }
      description
      lastModified
      owner {
        reference
        display
        identifier {
          value
        }
      }
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        type {
          text
        }
        valueReference {
          reference
          identifier {
            value
          }
          type
          display
        }
        valueString
        timestamp
      }
      note {
        authorString
        time
        text
      }
      patient {
        id
        name {
          given
          family
        }
        address {
          line
          postalCode
          city
          country
          text
        }
        telecom {
          system
          value
        }
        photo {
          url
        }
      }
    }
  }
`;

/**
 * __useGetAllPatientAlarmsQuery__
 *
 * To run a query within a Vue component, call `useGetAllPatientAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPatientAlarmsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllPatientAlarmsQuery({
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useGetAllPatientAlarmsQuery(
  variables:
    | GetAllPatientAlarmsQueryVariables
    | VueCompositionApi.Ref<GetAllPatientAlarmsQueryVariables>
    | ReactiveFunction<GetAllPatientAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAllPatientAlarmsQuery, GetAllPatientAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllPatientAlarmsQuery, GetAllPatientAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllPatientAlarmsQuery, GetAllPatientAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllPatientAlarmsQuery, GetAllPatientAlarmsQueryVariables>(
    GetAllPatientAlarmsDocument,
    variables,
    options,
  );
}
export function useGetAllPatientAlarmsLazyQuery(
  variables:
    | GetAllPatientAlarmsQueryVariables
    | VueCompositionApi.Ref<GetAllPatientAlarmsQueryVariables>
    | ReactiveFunction<GetAllPatientAlarmsQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<GetAllPatientAlarmsQuery, GetAllPatientAlarmsQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetAllPatientAlarmsQuery, GetAllPatientAlarmsQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetAllPatientAlarmsQuery, GetAllPatientAlarmsQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetAllPatientAlarmsQuery, GetAllPatientAlarmsQueryVariables>(
    GetAllPatientAlarmsDocument,
    variables,
    options,
  );
}
export type GetAllPatientAlarmsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllPatientAlarmsQuery,
  GetAllPatientAlarmsQueryVariables
>;
export const GetDeviceByIdForTechnicalAlarmDocument = gql`
  query getDeviceByIdForTechnicalAlarm($id: ID!) {
    getWelfareDevice(id: $id) {
      id
      modelNumber
    }
  }
`;

/**
 * __useGetDeviceByIdForTechnicalAlarmQuery__
 *
 * To run a query within a Vue component, call `useGetDeviceByIdForTechnicalAlarmQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceByIdForTechnicalAlarmQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeviceByIdForTechnicalAlarmQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDeviceByIdForTechnicalAlarmQuery(
  variables:
    | GetDeviceByIdForTechnicalAlarmQueryVariables
    | VueCompositionApi.Ref<GetDeviceByIdForTechnicalAlarmQueryVariables>
    | ReactiveFunction<GetDeviceByIdForTechnicalAlarmQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetDeviceByIdForTechnicalAlarmQuery,
        GetDeviceByIdForTechnicalAlarmQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetDeviceByIdForTechnicalAlarmQuery,
          GetDeviceByIdForTechnicalAlarmQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetDeviceByIdForTechnicalAlarmQuery,
          GetDeviceByIdForTechnicalAlarmQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetDeviceByIdForTechnicalAlarmQuery,
    GetDeviceByIdForTechnicalAlarmQueryVariables
  >(GetDeviceByIdForTechnicalAlarmDocument, variables, options);
}
export function useGetDeviceByIdForTechnicalAlarmLazyQuery(
  variables?:
    | GetDeviceByIdForTechnicalAlarmQueryVariables
    | VueCompositionApi.Ref<GetDeviceByIdForTechnicalAlarmQueryVariables>
    | ReactiveFunction<GetDeviceByIdForTechnicalAlarmQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetDeviceByIdForTechnicalAlarmQuery,
        GetDeviceByIdForTechnicalAlarmQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetDeviceByIdForTechnicalAlarmQuery,
          GetDeviceByIdForTechnicalAlarmQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetDeviceByIdForTechnicalAlarmQuery,
          GetDeviceByIdForTechnicalAlarmQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetDeviceByIdForTechnicalAlarmQuery,
    GetDeviceByIdForTechnicalAlarmQueryVariables
  >(GetDeviceByIdForTechnicalAlarmDocument, variables, options);
}
export type GetDeviceByIdForTechnicalAlarmQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDeviceByIdForTechnicalAlarmQuery,
  GetDeviceByIdForTechnicalAlarmQueryVariables
>;
export const CreateCameraDocument = gql`
  mutation createCamera($createInput: CreateCameraInput!) {
    createCamera(createInput: $createInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useCreateCameraMutation__
 *
 * To run a mutation, you first call `useCreateCameraMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCameraMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCameraMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useCreateCameraMutation(
  options:
    | VueApolloComposable.UseMutationOptions<CreateCameraMutation, CreateCameraMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<CreateCameraMutation, CreateCameraMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<CreateCameraMutation, CreateCameraMutationVariables>(
    CreateCameraDocument,
    options,
  );
}
export type CreateCameraMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  CreateCameraMutation,
  CreateCameraMutationVariables
>;
export const UpdateCameraDocument = gql`
  mutation updateCamera($id: ID!, $updateInput: UpdateCameraInput!) {
    updateCamera(id: $id, updateInput: $updateInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
    }
  }
`;

/**
 * __useUpdateCameraMutation__
 *
 * To run a mutation, you first call `useUpdateCameraMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCameraMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCameraMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateCameraMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateCameraMutation, UpdateCameraMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateCameraMutation, UpdateCameraMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateCameraMutation, UpdateCameraMutationVariables>(
    UpdateCameraDocument,
    options,
  );
}
export type UpdateCameraMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateCameraMutation,
  UpdateCameraMutationVariables
>;
export const GetDeviceGroupExternalUrlDocument = gql`
  query getDeviceGroupExternalUrl($id: ID!) {
    getDeviceGroupExternalUrl(id: $id)
  }
`;

/**
 * __useGetDeviceGroupExternalUrlQuery__
 *
 * To run a query within a Vue component, call `useGetDeviceGroupExternalUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceGroupExternalUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeviceGroupExternalUrlQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDeviceGroupExternalUrlQuery(
  variables:
    | GetDeviceGroupExternalUrlQueryVariables
    | VueCompositionApi.Ref<GetDeviceGroupExternalUrlQueryVariables>
    | ReactiveFunction<GetDeviceGroupExternalUrlQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>(
    GetDeviceGroupExternalUrlDocument,
    variables,
    options,
  );
}
export function useGetDeviceGroupExternalUrlLazyQuery(
  variables?:
    | GetDeviceGroupExternalUrlQueryVariables
    | VueCompositionApi.Ref<GetDeviceGroupExternalUrlQueryVariables>
    | ReactiveFunction<GetDeviceGroupExternalUrlQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetDeviceGroupExternalUrlQuery, GetDeviceGroupExternalUrlQueryVariables>(
    GetDeviceGroupExternalUrlDocument,
    variables,
    options,
  );
}
export type GetDeviceGroupExternalUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDeviceGroupExternalUrlQuery,
  GetDeviceGroupExternalUrlQueryVariables
>;
export const UserGroupForCmpDocument = gql`
  query userGroupForCmp($userGroupId: ID) {
    userGroup(userGroupId: $userGroupId) {
      name
      deviceGroups {
        id
        name
      }
      subTree {
        name
        deviceGroups {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useUserGroupForCmpQuery__
 *
 * To run a query within a Vue component, call `useUserGroupForCmpQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupForCmpQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupForCmpQuery({
 *   userGroupId: // value for 'userGroupId'
 * });
 */
export function useUserGroupForCmpQuery(
  variables:
    | UserGroupForCmpQueryVariables
    | VueCompositionApi.Ref<UserGroupForCmpQueryVariables>
    | ReactiveFunction<UserGroupForCmpQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>(
    UserGroupForCmpDocument,
    variables,
    options,
  );
}
export function useUserGroupForCmpLazyQuery(
  variables:
    | UserGroupForCmpQueryVariables
    | VueCompositionApi.Ref<UserGroupForCmpQueryVariables>
    | ReactiveFunction<UserGroupForCmpQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupForCmpQuery, UserGroupForCmpQueryVariables>(
    UserGroupForCmpDocument,
    variables,
    options,
  );
}
export type UserGroupForCmpQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupForCmpQuery,
  UserGroupForCmpQueryVariables
>;
export const GetDeviceByIdForSimulatorDocument = gql`
  query getDeviceByIdForSimulator($id: ID!) {
    getWelfareDevice(id: $id) {
      id
      uniqueIdentifier
      modelNumber
      deviceName {
        name
      }
      deviceGroup {
        name
        id
      }
      tags
    }
  }
`;

/**
 * __useGetDeviceByIdForSimulatorQuery__
 *
 * To run a query within a Vue component, call `useGetDeviceByIdForSimulatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceByIdForSimulatorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeviceByIdForSimulatorQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDeviceByIdForSimulatorQuery(
  variables:
    | GetDeviceByIdForSimulatorQueryVariables
    | VueCompositionApi.Ref<GetDeviceByIdForSimulatorQueryVariables>
    | ReactiveFunction<GetDeviceByIdForSimulatorQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>(
    GetDeviceByIdForSimulatorDocument,
    variables,
    options,
  );
}
export function useGetDeviceByIdForSimulatorLazyQuery(
  variables?:
    | GetDeviceByIdForSimulatorQueryVariables
    | VueCompositionApi.Ref<GetDeviceByIdForSimulatorQueryVariables>
    | ReactiveFunction<GetDeviceByIdForSimulatorQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetDeviceByIdForSimulatorQuery, GetDeviceByIdForSimulatorQueryVariables>(
    GetDeviceByIdForSimulatorDocument,
    variables,
    options,
  );
}
export type GetDeviceByIdForSimulatorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetDeviceByIdForSimulatorQuery,
  GetDeviceByIdForSimulatorQueryVariables
>;
export const GetAvailableDevicesInSafemateProDocument = gql`
  query getAvailableDevicesInSafematePro {
    getAvailableDevicesInSafematePro {
      hasSafemateIntegration
      safemateDevices {
        serial
        name
        status
        lastMessageFromDevice
        customerName
        isInRegistry
        isInWrongHealthProvider
        healthProviderName
      }
    }
  }
`;

/**
 * __useGetAvailableDevicesInSafemateProQuery__
 *
 * To run a query within a Vue component, call `useGetAvailableDevicesInSafemateProQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableDevicesInSafemateProQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAvailableDevicesInSafemateProQuery();
 */
export function useGetAvailableDevicesInSafemateProQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAvailableDevicesInSafemateProQuery,
        GetAvailableDevicesInSafemateProQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAvailableDevicesInSafemateProQuery,
          GetAvailableDevicesInSafemateProQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAvailableDevicesInSafemateProQuery,
          GetAvailableDevicesInSafemateProQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAvailableDevicesInSafemateProQuery,
    GetAvailableDevicesInSafemateProQueryVariables
  >(GetAvailableDevicesInSafemateProDocument, {}, options);
}
export function useGetAvailableDevicesInSafemateProLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAvailableDevicesInSafemateProQuery,
        GetAvailableDevicesInSafemateProQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAvailableDevicesInSafemateProQuery,
          GetAvailableDevicesInSafemateProQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAvailableDevicesInSafemateProQuery,
          GetAvailableDevicesInSafemateProQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAvailableDevicesInSafemateProQuery,
    GetAvailableDevicesInSafemateProQueryVariables
  >(GetAvailableDevicesInSafemateProDocument, {}, options);
}
export type GetAvailableDevicesInSafemateProQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAvailableDevicesInSafemateProQuery,
  GetAvailableDevicesInSafemateProQueryVariables
>;
export const ImportDevicesFromSafemateProDocument = gql`
  mutation importDevicesFromSafematePro($createInput: ImportDevicesInput!) {
    importDevicesFromSafematePro(createInput: $createInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      devices {
        id
      }
    }
  }
`;

/**
 * __useImportDevicesFromSafemateProMutation__
 *
 * To run a mutation, you first call `useImportDevicesFromSafemateProMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportDevicesFromSafemateProMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportDevicesFromSafemateProMutation({
 *   variables: {
 *     createInput: // value for 'createInput'
 *   },
 * });
 */
export function useImportDevicesFromSafemateProMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        ImportDevicesFromSafemateProMutation,
        ImportDevicesFromSafemateProMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          ImportDevicesFromSafemateProMutation,
          ImportDevicesFromSafemateProMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    ImportDevicesFromSafemateProMutation,
    ImportDevicesFromSafemateProMutationVariables
  >(ImportDevicesFromSafemateProDocument, options);
}
export type ImportDevicesFromSafemateProMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  ImportDevicesFromSafemateProMutation,
  ImportDevicesFromSafemateProMutationVariables
>;
export const GetListOfUnallocatedCamerasDocument = gql`
  query getListOfUnallocatedCameras {
    getListOfUnallocatedCameras {
      id
      name
      macAddress
      active
      modelName
    }
  }
`;

/**
 * __useGetListOfUnallocatedCamerasQuery__
 *
 * To run a query within a Vue component, call `useGetListOfUnallocatedCamerasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListOfUnallocatedCamerasQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetListOfUnallocatedCamerasQuery();
 */
export function useGetListOfUnallocatedCamerasQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>(
    GetListOfUnallocatedCamerasDocument,
    {},
    options,
  );
}
export function useGetListOfUnallocatedCamerasLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetListOfUnallocatedCamerasQuery, GetListOfUnallocatedCamerasQueryVariables>(
    GetListOfUnallocatedCamerasDocument,
    {},
    options,
  );
}
export type GetListOfUnallocatedCamerasQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetListOfUnallocatedCamerasQuery,
  GetListOfUnallocatedCamerasQueryVariables
>;
export const AddCameraToPatientDocument = gql`
  mutation addCameraToPatient($patientId: ID!, $cameraId: ID!) {
    addCameraToPatient(patientId: $patientId, cameraId: $cameraId) {
      success
    }
  }
`;

/**
 * __useAddCameraToPatientMutation__
 *
 * To run a mutation, you first call `useAddCameraToPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCameraToPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCameraToPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useAddCameraToPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddCameraToPatientMutation, AddCameraToPatientMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddCameraToPatientMutation, AddCameraToPatientMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddCameraToPatientMutation, AddCameraToPatientMutationVariables>(
    AddCameraToPatientDocument,
    options,
  );
}
export type AddCameraToPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddCameraToPatientMutation,
  AddCameraToPatientMutationVariables
>;
export const UpdateAvailableHoursDocument = gql`
  mutation updateAvailableHours($patientId: ID!, $cameraId: ID!, $availableHours: String!) {
    updateAvailableHours(patientId: $patientId, cameraId: $cameraId, availableHours: $availableHours) {
      success
    }
  }
`;

/**
 * __useUpdateAvailableHoursMutation__
 *
 * To run a mutation, you first call `useUpdateAvailableHoursMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvailableHoursMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAvailableHoursMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     cameraId: // value for 'cameraId'
 *     availableHours: // value for 'availableHours'
 *   },
 * });
 */
export function useUpdateAvailableHoursMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateAvailableHoursMutation, UpdateAvailableHoursMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateAvailableHoursMutation, UpdateAvailableHoursMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateAvailableHoursMutation, UpdateAvailableHoursMutationVariables>(
    UpdateAvailableHoursDocument,
    options,
  );
}
export type UpdateAvailableHoursMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateAvailableHoursMutation,
  UpdateAvailableHoursMutationVariables
>;
export const RemoveCameraFromPatientDocument = gql`
  mutation removeCameraFromPatient($patientId: ID!, $cameraId: ID!) {
    removeCameraFromPatient(patientId: $patientId, cameraId: $cameraId) {
      success
    }
  }
`;

/**
 * __useRemoveCameraFromPatientMutation__
 *
 * To run a mutation, you first call `useRemoveCameraFromPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCameraFromPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveCameraFromPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useRemoveCameraFromPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<RemoveCameraFromPatientMutation, RemoveCameraFromPatientMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveCameraFromPatientMutation,
          RemoveCameraFromPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<RemoveCameraFromPatientMutation, RemoveCameraFromPatientMutationVariables>(
    RemoveCameraFromPatientDocument,
    options,
  );
}
export type RemoveCameraFromPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveCameraFromPatientMutation,
  RemoveCameraFromPatientMutationVariables
>;
export const RequestSinglePatientUrlDocument = gql`
  query requestSinglePatientUrl($patientId: ID!, $externalAccessId: ID!) {
    requestSinglePatientUrl(patientId: $patientId, externalAccessId: $externalAccessId)
  }
`;

/**
 * __useRequestSinglePatientUrlQuery__
 *
 * To run a query within a Vue component, call `useRequestSinglePatientUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestSinglePatientUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRequestSinglePatientUrlQuery({
 *   patientId: // value for 'patientId'
 *   externalAccessId: // value for 'externalAccessId'
 * });
 */
export function useRequestSinglePatientUrlQuery(
  variables:
    | RequestSinglePatientUrlQueryVariables
    | VueCompositionApi.Ref<RequestSinglePatientUrlQueryVariables>
    | ReactiveFunction<RequestSinglePatientUrlQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>(
    RequestSinglePatientUrlDocument,
    variables,
    options,
  );
}
export function useRequestSinglePatientUrlLazyQuery(
  variables?:
    | RequestSinglePatientUrlQueryVariables
    | VueCompositionApi.Ref<RequestSinglePatientUrlQueryVariables>
    | ReactiveFunction<RequestSinglePatientUrlQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<RequestSinglePatientUrlQuery, RequestSinglePatientUrlQueryVariables>(
    RequestSinglePatientUrlDocument,
    variables,
    options,
  );
}
export type RequestSinglePatientUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  RequestSinglePatientUrlQuery,
  RequestSinglePatientUrlQueryVariables
>;
export const UpdatePatientNoteDocument = gql`
  mutation updatePatientNote($patientId: ID!, $patientInput: UpdatePatientInput!) {
    updatePatient(patientId: $patientId, patientInput: $patientInput) {
      success
    }
  }
`;

/**
 * __useUpdatePatientNoteMutation__
 *
 * To run a mutation, you first call `useUpdatePatientNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePatientNoteMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     patientInput: // value for 'patientInput'
 *   },
 * });
 */
export function useUpdatePatientNoteMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdatePatientNoteMutation, UpdatePatientNoteMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdatePatientNoteMutation, UpdatePatientNoteMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdatePatientNoteMutation, UpdatePatientNoteMutationVariables>(
    UpdatePatientNoteDocument,
    options,
  );
}
export type UpdatePatientNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdatePatientNoteMutation,
  UpdatePatientNoteMutationVariables
>;
export const PatientForPatientDashboardDocument = gql`
  query patientForPatientDashboard($patientId: ID!) {
    patient(id: $patientId) {
      id
      name {
        given
        family
        text
      }
      externalPatientIds {
        externalHumanIdType {
          id
        }
        externalId
      }
      identifier {
        value
        use
      }
      active
      birthDate
      addressNote
      keyCode
      gender
      note
      isAlarmHandlingPlanActive
      languages {
        language
        preferred
      }
      telecom {
        system
        value
      }
      address {
        line
        postalCode
        city
        country
        text
      }
      patientGroups {
        id
        name
      }
      alarmRoutes {
        configName
        configType
        incomingTemplate {
          isPresentInAccount
          code
          title
          system
          displayText
          icon
        }
        outgoingTemplate {
          isPresentInAccount
          code
          title
          system
          displayText
          icon
        }
        idMappingStrategy
      }
      welfareDevices {
        id
        uniqueIdentifier
        modelNumber
        userFriendlyName
      }
      cameras {
        id
        name
        modelName
        manufacturer
        macAddress
        availableHours
        isConfiguredInRegistry
        hasOfflineAlarm
        detailedStatus {
          lastSeen
          heartbeatCount
          isAssociatedToPatient
          ttl
          privacyMode
          privacyModeUntil
        }
      }
    }
  }
`;

/**
 * __usePatientForPatientDashboardQuery__
 *
 * To run a query within a Vue component, call `usePatientForPatientDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientForPatientDashboardQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientForPatientDashboardQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function usePatientForPatientDashboardQuery(
  variables:
    | PatientForPatientDashboardQueryVariables
    | VueCompositionApi.Ref<PatientForPatientDashboardQueryVariables>
    | ReactiveFunction<PatientForPatientDashboardQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>(
    PatientForPatientDashboardDocument,
    variables,
    options,
  );
}
export function usePatientForPatientDashboardLazyQuery(
  variables?:
    | PatientForPatientDashboardQueryVariables
    | VueCompositionApi.Ref<PatientForPatientDashboardQueryVariables>
    | ReactiveFunction<PatientForPatientDashboardQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientForPatientDashboardQuery, PatientForPatientDashboardQueryVariables>(
    PatientForPatientDashboardDocument,
    variables,
    options,
  );
}
export type PatientForPatientDashboardQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientForPatientDashboardQuery,
  PatientForPatientDashboardQueryVariables
>;
export const GetAllExternalAccessForPatientDocument = gql`
  query getAllExternalAccessForPatient($patientId: ID!) {
    getAllExternalAccessForPatient(patientId: $patientId) {
      id
      name
    }
  }
`;

/**
 * __useGetAllExternalAccessForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetAllExternalAccessForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllExternalAccessForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllExternalAccessForPatientQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetAllExternalAccessForPatientQuery(
  variables:
    | GetAllExternalAccessForPatientQueryVariables
    | VueCompositionApi.Ref<GetAllExternalAccessForPatientQueryVariables>
    | ReactiveFunction<GetAllExternalAccessForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllExternalAccessForPatientQuery,
        GetAllExternalAccessForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllExternalAccessForPatientQuery,
          GetAllExternalAccessForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllExternalAccessForPatientQuery,
          GetAllExternalAccessForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllExternalAccessForPatientQuery,
    GetAllExternalAccessForPatientQueryVariables
  >(GetAllExternalAccessForPatientDocument, variables, options);
}
export function useGetAllExternalAccessForPatientLazyQuery(
  variables?:
    | GetAllExternalAccessForPatientQueryVariables
    | VueCompositionApi.Ref<GetAllExternalAccessForPatientQueryVariables>
    | ReactiveFunction<GetAllExternalAccessForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllExternalAccessForPatientQuery,
        GetAllExternalAccessForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllExternalAccessForPatientQuery,
          GetAllExternalAccessForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllExternalAccessForPatientQuery,
          GetAllExternalAccessForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllExternalAccessForPatientQuery,
    GetAllExternalAccessForPatientQueryVariables
  >(GetAllExternalAccessForPatientDocument, variables, options);
}
export type GetAllExternalAccessForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllExternalAccessForPatientQuery,
  GetAllExternalAccessForPatientQueryVariables
>;
export const RemoveWelfareDeviceFromPatientDocument = gql`
  mutation removeWelfareDeviceFromPatient($patientId: ID!, $welfareDeviceId: ID!) {
    removeWelfareDeviceFromPatient(patientId: $patientId, welfareDeviceId: $welfareDeviceId) {
      success
    }
  }
`;

/**
 * __useRemoveWelfareDeviceFromPatientMutation__
 *
 * To run a mutation, you first call `useRemoveWelfareDeviceFromPatientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWelfareDeviceFromPatientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveWelfareDeviceFromPatientMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     welfareDeviceId: // value for 'welfareDeviceId'
 *   },
 * });
 */
export function useRemoveWelfareDeviceFromPatientMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        RemoveWelfareDeviceFromPatientMutation,
        RemoveWelfareDeviceFromPatientMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          RemoveWelfareDeviceFromPatientMutation,
          RemoveWelfareDeviceFromPatientMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    RemoveWelfareDeviceFromPatientMutation,
    RemoveWelfareDeviceFromPatientMutationVariables
  >(RemoveWelfareDeviceFromPatientDocument, options);
}
export type RemoveWelfareDeviceFromPatientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  RemoveWelfareDeviceFromPatientMutation,
  RemoveWelfareDeviceFromPatientMutationVariables
>;
export const DeleteNextOfKinDocument = gql`
  mutation deleteNextOfKin($nokId: ID!) {
    deleteNextOfKin(nokId: $nokId) {
      success
      message
    }
  }
`;

/**
 * __useDeleteNextOfKinMutation__
 *
 * To run a mutation, you first call `useDeleteNextOfKinMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNextOfKinMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteNextOfKinMutation({
 *   variables: {
 *     nokId: // value for 'nokId'
 *   },
 * });
 */
export function useDeleteNextOfKinMutation(
  options:
    | VueApolloComposable.UseMutationOptions<DeleteNextOfKinMutation, DeleteNextOfKinMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<DeleteNextOfKinMutation, DeleteNextOfKinMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<DeleteNextOfKinMutation, DeleteNextOfKinMutationVariables>(
    DeleteNextOfKinDocument,
    options,
  );
}
export type DeleteNextOfKinMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  DeleteNextOfKinMutation,
  DeleteNextOfKinMutationVariables
>;
export const GetPatientNextOfKinDocument = gql`
  query getPatientNextOfKin($patientId: ID!) {
    getNextOfKin(patientId: $patientId) {
      id
      notifyNextOfKin
      name {
        given
        family
        text
      }
      active
      isMain
      telecom {
        system
        value
      }
      address {
        line
        postalCode
        city
        country
        text
      }
      relationship
    }
  }
`;

/**
 * __useGetPatientNextOfKinQuery__
 *
 * To run a query within a Vue component, call `useGetPatientNextOfKinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientNextOfKinQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientNextOfKinQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetPatientNextOfKinQuery(
  variables:
    | GetPatientNextOfKinQueryVariables
    | VueCompositionApi.Ref<GetPatientNextOfKinQueryVariables>
    | ReactiveFunction<GetPatientNextOfKinQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>(
    GetPatientNextOfKinDocument,
    variables,
    options,
  );
}
export function useGetPatientNextOfKinLazyQuery(
  variables?:
    | GetPatientNextOfKinQueryVariables
    | VueCompositionApi.Ref<GetPatientNextOfKinQueryVariables>
    | ReactiveFunction<GetPatientNextOfKinQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientNextOfKinQuery, GetPatientNextOfKinQueryVariables>(
    GetPatientNextOfKinDocument,
    variables,
    options,
  );
}
export type GetPatientNextOfKinQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientNextOfKinQuery,
  GetPatientNextOfKinQueryVariables
>;
export const AddNextOfKinDocument = gql`
  mutation addNextOfKin($patientId: ID!, $nextOfKinInput: CreateNextOfKinInput!) {
    addNextOfKin(patientId: $patientId, nextOfKinInput: $nextOfKinInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      nextOfKin {
        id
      }
    }
  }
`;

/**
 * __useAddNextOfKinMutation__
 *
 * To run a mutation, you first call `useAddNextOfKinMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddNextOfKinMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddNextOfKinMutation({
 *   variables: {
 *     patientId: // value for 'patientId'
 *     nextOfKinInput: // value for 'nextOfKinInput'
 *   },
 * });
 */
export function useAddNextOfKinMutation(
  options:
    | VueApolloComposable.UseMutationOptions<AddNextOfKinMutation, AddNextOfKinMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<AddNextOfKinMutation, AddNextOfKinMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<AddNextOfKinMutation, AddNextOfKinMutationVariables>(
    AddNextOfKinDocument,
    options,
  );
}
export type AddNextOfKinMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  AddNextOfKinMutation,
  AddNextOfKinMutationVariables
>;
export const UpdateNextOfKinDocument = gql`
  mutation updateNextOfKin($nokId: ID!, $nextOfKinInput: UpdateNextOfKinInput!) {
    updateNextOfKin(nokId: $nokId, nextOfKinInput: $nextOfKinInput) {
      success
      message
      inputValidation {
        valid
        message
        errors {
          path
          message
        }
      }
      nextOfKin {
        id
      }
    }
  }
`;

/**
 * __useUpdateNextOfKinMutation__
 *
 * To run a mutation, you first call `useUpdateNextOfKinMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNextOfKinMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateNextOfKinMutation({
 *   variables: {
 *     nokId: // value for 'nokId'
 *     nextOfKinInput: // value for 'nextOfKinInput'
 *   },
 * });
 */
export function useUpdateNextOfKinMutation(
  options:
    | VueApolloComposable.UseMutationOptions<UpdateNextOfKinMutation, UpdateNextOfKinMutationVariables>
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<UpdateNextOfKinMutation, UpdateNextOfKinMutationVariables>
      > = {},
) {
  return VueApolloComposable.useMutation<UpdateNextOfKinMutation, UpdateNextOfKinMutationVariables>(
    UpdateNextOfKinDocument,
    options,
  );
}
export type UpdateNextOfKinMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  UpdateNextOfKinMutation,
  UpdateNextOfKinMutationVariables
>;
export const GetNextOfKinByIdDocument = gql`
  query getNextOfKinById($patientId: ID!, $nokId: ID!) {
    getNextOfKinById(patientId: $patientId, nokId: $nokId) {
      id
      name {
        given
        family
        text
      }
      notifyNextOfKin
      active
      isMain
      telecom {
        system
        value
      }
      address {
        line
        postalCode
        city
        country
        text
      }
      relationship
    }
  }
`;

/**
 * __useGetNextOfKinByIdQuery__
 *
 * To run a query within a Vue component, call `useGetNextOfKinByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextOfKinByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNextOfKinByIdQuery({
 *   patientId: // value for 'patientId'
 *   nokId: // value for 'nokId'
 * });
 */
export function useGetNextOfKinByIdQuery(
  variables:
    | GetNextOfKinByIdQueryVariables
    | VueCompositionApi.Ref<GetNextOfKinByIdQueryVariables>
    | ReactiveFunction<GetNextOfKinByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>(
    GetNextOfKinByIdDocument,
    variables,
    options,
  );
}
export function useGetNextOfKinByIdLazyQuery(
  variables?:
    | GetNextOfKinByIdQueryVariables
    | VueCompositionApi.Ref<GetNextOfKinByIdQueryVariables>
    | ReactiveFunction<GetNextOfKinByIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<GetNextOfKinByIdQuery, GetNextOfKinByIdQueryVariables>(
    GetNextOfKinByIdDocument,
    variables,
    options,
  );
}
export type GetNextOfKinByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetNextOfKinByIdQuery,
  GetNextOfKinByIdQueryVariables
>;
export const GetNumberOfAccessiblePatientsDocument = gql`
  query getNumberOfAccessiblePatients {
    getNumberOfAccessiblePatients
  }
`;

/**
 * __useGetNumberOfAccessiblePatientsQuery__
 *
 * To run a query within a Vue component, call `useGetNumberOfAccessiblePatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfAccessiblePatientsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetNumberOfAccessiblePatientsQuery();
 */
export function useGetNumberOfAccessiblePatientsQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetNumberOfAccessiblePatientsQuery,
        GetNumberOfAccessiblePatientsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetNumberOfAccessiblePatientsQuery,
          GetNumberOfAccessiblePatientsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetNumberOfAccessiblePatientsQuery,
          GetNumberOfAccessiblePatientsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetNumberOfAccessiblePatientsQuery, GetNumberOfAccessiblePatientsQueryVariables>(
    GetNumberOfAccessiblePatientsDocument,
    {},
    options,
  );
}
export function useGetNumberOfAccessiblePatientsLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        GetNumberOfAccessiblePatientsQuery,
        GetNumberOfAccessiblePatientsQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetNumberOfAccessiblePatientsQuery,
          GetNumberOfAccessiblePatientsQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetNumberOfAccessiblePatientsQuery,
          GetNumberOfAccessiblePatientsQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetNumberOfAccessiblePatientsQuery,
    GetNumberOfAccessiblePatientsQueryVariables
  >(GetNumberOfAccessiblePatientsDocument, {}, options);
}
export type GetNumberOfAccessiblePatientsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetNumberOfAccessiblePatientsQuery,
  GetNumberOfAccessiblePatientsQueryVariables
>;
export const PatientForSimpleViewDocument = gql`
  query patientForSimpleView($patientId: ID!) {
    patient(id: $patientId) {
      id
      active
      name {
        given
        family
        text
      }
      birthDate
      identifier {
        value
        use
      }
      photo {
        url
      }
      address {
        line
        postalCode
        city
        country
        text
      }
      addressNote
      keyCode
      patientGroups {
        id
        name
      }
      telecom {
        system
        value
      }
      note
      cameras {
        id
        name
        isConfiguredInRegistry
        detailedStatus {
          privacyMode
          privacyModeUntil
        }
      }
      isAlarmHandlingPlanActive
    }
  }
`;

/**
 * __usePatientForSimpleViewQuery__
 *
 * To run a query within a Vue component, call `usePatientForSimpleViewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientForSimpleViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientForSimpleViewQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function usePatientForSimpleViewQuery(
  variables:
    | PatientForSimpleViewQueryVariables
    | VueCompositionApi.Ref<PatientForSimpleViewQueryVariables>
    | ReactiveFunction<PatientForSimpleViewQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForSimpleViewQuery, PatientForSimpleViewQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientForSimpleViewQuery, PatientForSimpleViewQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientForSimpleViewQuery, PatientForSimpleViewQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientForSimpleViewQuery, PatientForSimpleViewQueryVariables>(
    PatientForSimpleViewDocument,
    variables,
    options,
  );
}
export function usePatientForSimpleViewLazyQuery(
  variables?:
    | PatientForSimpleViewQueryVariables
    | VueCompositionApi.Ref<PatientForSimpleViewQueryVariables>
    | ReactiveFunction<PatientForSimpleViewQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientForSimpleViewQuery, PatientForSimpleViewQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientForSimpleViewQuery, PatientForSimpleViewQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientForSimpleViewQuery, PatientForSimpleViewQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientForSimpleViewQuery, PatientForSimpleViewQueryVariables>(
    PatientForSimpleViewDocument,
    variables,
    options,
  );
}
export type PatientForSimpleViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientForSimpleViewQuery,
  PatientForSimpleViewQueryVariables
>;
export const GetAllPatientAlarmsForPatientDocument = gql`
  query getAllPatientAlarmsForPatient($patientId: ID!) {
    getAllPatientAlarmsForPatient(patientId: $patientId) {
      id
      status
      code {
        text
      }
      intent
      priority
      for {
        reference
      }
      description
      authoredOn
      subTasks {
        id
      }
      owner {
        reference
        display
        identifier {
          value
        }
      }
      priorityInput {
        timestamp
        icon
        priority
        templateCode
        templateDisplayName
      }
      input {
        valueReference {
          reference
        }
        type {
          text
        }
        icon
        priority
        timestamp
      }
      note {
        authorString
        time
        text
      }
    }
  }
`;

/**
 * __useGetAllPatientAlarmsForPatientQuery__
 *
 * To run a query within a Vue component, call `useGetAllPatientAlarmsForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPatientAlarmsForPatientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllPatientAlarmsForPatientQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useGetAllPatientAlarmsForPatientQuery(
  variables:
    | GetAllPatientAlarmsForPatientQueryVariables
    | VueCompositionApi.Ref<GetAllPatientAlarmsForPatientQueryVariables>
    | ReactiveFunction<GetAllPatientAlarmsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllPatientAlarmsForPatientQuery,
        GetAllPatientAlarmsForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientAlarmsForPatientQuery,
          GetAllPatientAlarmsForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientAlarmsForPatientQuery,
          GetAllPatientAlarmsForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<GetAllPatientAlarmsForPatientQuery, GetAllPatientAlarmsForPatientQueryVariables>(
    GetAllPatientAlarmsForPatientDocument,
    variables,
    options,
  );
}
export function useGetAllPatientAlarmsForPatientLazyQuery(
  variables?:
    | GetAllPatientAlarmsForPatientQueryVariables
    | VueCompositionApi.Ref<GetAllPatientAlarmsForPatientQueryVariables>
    | ReactiveFunction<GetAllPatientAlarmsForPatientQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllPatientAlarmsForPatientQuery,
        GetAllPatientAlarmsForPatientQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientAlarmsForPatientQuery,
          GetAllPatientAlarmsForPatientQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllPatientAlarmsForPatientQuery,
          GetAllPatientAlarmsForPatientQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllPatientAlarmsForPatientQuery,
    GetAllPatientAlarmsForPatientQueryVariables
  >(GetAllPatientAlarmsForPatientDocument, variables, options);
}
export type GetAllPatientAlarmsForPatientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllPatientAlarmsForPatientQuery,
  GetAllPatientAlarmsForPatientQueryVariables
>;
export const PatientWithCamerasDocument = gql`
  query patientWithCameras($id: ID!) {
    patient(id: $id) {
      id
      name {
        given
        family
        text
      }
      identifier {
        value
        use
      }
      welfareDevices {
        id
        uniqueIdentifier
        modelNumber
        userFriendlyName
        configuration {
          hasExternalUrl
          registeredInInventory
        }
      }
      cameras {
        id
        name
        modelName
        manufacturer
        macAddress
        availableHours
        isConfiguredInRegistry
        hasOfflineAlarm
        detailedStatus {
          lastSeen
          heartbeatCount
          isAssociatedToPatient
          ttl
          privacyMode
          privacyModeUntil
        }
        anonymization {
          supports
          requirement
        }
        deviceGroup {
          name
          id
        }
        patientReference {
          reference
        }
        userHasAccessToPatient
      }
    }
  }
`;

/**
 * __usePatientWithCamerasQuery__
 *
 * To run a query within a Vue component, call `usePatientWithCamerasQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientWithCamerasQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientWithCamerasQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientWithCamerasQuery(
  variables:
    | PatientWithCamerasQueryVariables
    | VueCompositionApi.Ref<PatientWithCamerasQueryVariables>
    | ReactiveFunction<PatientWithCamerasQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>(
    PatientWithCamerasDocument,
    variables,
    options,
  );
}
export function usePatientWithCamerasLazyQuery(
  variables?:
    | PatientWithCamerasQueryVariables
    | VueCompositionApi.Ref<PatientWithCamerasQueryVariables>
    | ReactiveFunction<PatientWithCamerasQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientWithCamerasQuery, PatientWithCamerasQueryVariables>(
    PatientWithCamerasDocument,
    variables,
    options,
  );
}
export type PatientWithCamerasQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientWithCamerasQuery,
  PatientWithCamerasQueryVariables
>;
export const PatientWithWelfareDevicesDocument = gql`
  query patientWithWelfareDevices($id: ID!) {
    patient(id: $id) {
      id
      name {
        given
        family
        text
      }
      identifier {
        value
        use
      }
      patientGroups {
        id
        name
      }
      welfareDevices {
        id
        uniqueIdentifier
        tags
        modelNumber
        userFriendlyName
        deviceGroup {
          name
          id
        }
        deviceName {
          name
        }
        configuration {
          hasExternalUrl
          registeredInInventory
        }
        status {
          lastSeen
          lastBatteryStatus
          lastBatteryTimestamp
        }
      }
      skyresponseDetails {
        enabled
        organizationId
        hasSkyresponseExternalId
        hasSkyresponseCredentials
      }
    }
  }
`;

/**
 * __usePatientWithWelfareDevicesQuery__
 *
 * To run a query within a Vue component, call `usePatientWithWelfareDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientWithWelfareDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientWithWelfareDevicesQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientWithWelfareDevicesQuery(
  variables:
    | PatientWithWelfareDevicesQueryVariables
    | VueCompositionApi.Ref<PatientWithWelfareDevicesQueryVariables>
    | ReactiveFunction<PatientWithWelfareDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>(
    PatientWithWelfareDevicesDocument,
    variables,
    options,
  );
}
export function usePatientWithWelfareDevicesLazyQuery(
  variables?:
    | PatientWithWelfareDevicesQueryVariables
    | VueCompositionApi.Ref<PatientWithWelfareDevicesQueryVariables>
    | ReactiveFunction<PatientWithWelfareDevicesQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientWithWelfareDevicesQuery, PatientWithWelfareDevicesQueryVariables>(
    PatientWithWelfareDevicesDocument,
    variables,
    options,
  );
}
export type PatientWithWelfareDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientWithWelfareDevicesQuery,
  PatientWithWelfareDevicesQueryVariables
>;
export const PatientListDocument = gql`
  query patientList($onlyActive: Boolean) {
    patientList(onlyActive: $onlyActive) {
      id
      createdAt
      tags
      openSyncAlarmId
      externalIds {
        type
        id
      }
      active
      firstName
      shareAlarmWithPatients {
        isPrimary
        id
        name
      }
      lastName
      patientGroupNames
      location
      devices {
        name
        type
        deviceType
        isSharedDevice
      }
      secretAddress
      rpmLastActive
      primaryAddress {
        addressLine
        postalCode
        city
        room
      }
    }
  }
`;

/**
 * __usePatientListQuery__
 *
 * To run a query within a Vue component, call `usePatientListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientListQuery({
 *   onlyActive: // value for 'onlyActive'
 * });
 */
export function usePatientListQuery(
  variables:
    | PatientListQueryVariables
    | VueCompositionApi.Ref<PatientListQueryVariables>
    | ReactiveFunction<PatientListQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<PatientListQuery, PatientListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientListQuery, PatientListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientListQuery, PatientListQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientListQuery, PatientListQueryVariables>(
    PatientListDocument,
    variables,
    options,
  );
}
export function usePatientListLazyQuery(
  variables:
    | PatientListQueryVariables
    | VueCompositionApi.Ref<PatientListQueryVariables>
    | ReactiveFunction<PatientListQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<PatientListQuery, PatientListQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientListQuery, PatientListQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientListQuery, PatientListQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientListQuery, PatientListQueryVariables>(
    PatientListDocument,
    variables,
    options,
  );
}
export type PatientListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientListQuery,
  PatientListQueryVariables
>;
export const PatientsByActivityDocument = gql`
  query patientsByActivity($onlyActive: Boolean) {
    patients(onlyActive: $onlyActive) {
      id
      active
      isAlarmHandlingPlanActive
      externalPatientIds {
        externalHumanIdType {
          id
        }
        externalId
      }
      name {
        given
        family
        text
      }
      gender
      birthDate
      telecom {
        system
        value
      }
      address {
        line
        postalCode
        city
        country
        text
      }
      addressNote
      keyCode
      patientGroups {
        id
        name
      }
      tags
      cameras {
        modelName
        manufacturer
        id
        name
      }
      welfareDevices {
        id
        uniqueIdentifier
        modelNumber
        deviceName {
          name
        }
      }
      hasSkyresponseSyncFailed
    }
  }
`;

/**
 * __usePatientsByActivityQuery__
 *
 * To run a query within a Vue component, call `usePatientsByActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientsByActivityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientsByActivityQuery({
 *   onlyActive: // value for 'onlyActive'
 * });
 */
export function usePatientsByActivityQuery(
  variables:
    | PatientsByActivityQueryVariables
    | VueCompositionApi.Ref<PatientsByActivityQueryVariables>
    | ReactiveFunction<PatientsByActivityQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<PatientsByActivityQuery, PatientsByActivityQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientsByActivityQuery, PatientsByActivityQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientsByActivityQuery, PatientsByActivityQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<PatientsByActivityQuery, PatientsByActivityQueryVariables>(
    PatientsByActivityDocument,
    variables,
    options,
  );
}
export function usePatientsByActivityLazyQuery(
  variables:
    | PatientsByActivityQueryVariables
    | VueCompositionApi.Ref<PatientsByActivityQueryVariables>
    | ReactiveFunction<PatientsByActivityQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<PatientsByActivityQuery, PatientsByActivityQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<PatientsByActivityQuery, PatientsByActivityQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<PatientsByActivityQuery, PatientsByActivityQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<PatientsByActivityQuery, PatientsByActivityQueryVariables>(
    PatientsByActivityDocument,
    variables,
    options,
  );
}
export type PatientsByActivityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientsByActivityQuery,
  PatientsByActivityQueryVariables
>;
export const ExportFhirPatientBundleDocument = gql`
  query exportFhirPatientBundle($patientId: ID!) {
    exportFhirPatientBundle(patientId: $patientId) {
      bundle
    }
  }
`;

/**
 * __useExportFhirPatientBundleQuery__
 *
 * To run a query within a Vue component, call `useExportFhirPatientBundleQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportFhirPatientBundleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportFhirPatientBundleQuery({
 *   patientId: // value for 'patientId'
 * });
 */
export function useExportFhirPatientBundleQuery(
  variables:
    | ExportFhirPatientBundleQueryVariables
    | VueCompositionApi.Ref<ExportFhirPatientBundleQueryVariables>
    | ReactiveFunction<ExportFhirPatientBundleQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ExportFhirPatientBundleQuery, ExportFhirPatientBundleQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ExportFhirPatientBundleQuery, ExportFhirPatientBundleQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ExportFhirPatientBundleQuery, ExportFhirPatientBundleQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<ExportFhirPatientBundleQuery, ExportFhirPatientBundleQueryVariables>(
    ExportFhirPatientBundleDocument,
    variables,
    options,
  );
}
export function useExportFhirPatientBundleLazyQuery(
  variables?:
    | ExportFhirPatientBundleQueryVariables
    | VueCompositionApi.Ref<ExportFhirPatientBundleQueryVariables>
    | ReactiveFunction<ExportFhirPatientBundleQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<ExportFhirPatientBundleQuery, ExportFhirPatientBundleQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<ExportFhirPatientBundleQuery, ExportFhirPatientBundleQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<ExportFhirPatientBundleQuery, ExportFhirPatientBundleQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<ExportFhirPatientBundleQuery, ExportFhirPatientBundleQueryVariables>(
    ExportFhirPatientBundleDocument,
    variables,
    options,
  );
}
export type ExportFhirPatientBundleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ExportFhirPatientBundleQuery,
  ExportFhirPatientBundleQueryVariables
>;
export const HealthProviderSettingsWithExternalHumanIdTypesDocument = gql`
  query healthProviderSettingsWithExternalHumanIdTypes {
    healthProviderSettings {
      externalHumanIdTypes {
        id
      }
    }
  }
`;

/**
 * __useHealthProviderSettingsWithExternalHumanIdTypesQuery__
 *
 * To run a query within a Vue component, call `useHealthProviderSettingsWithExternalHumanIdTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthProviderSettingsWithExternalHumanIdTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHealthProviderSettingsWithExternalHumanIdTypesQuery();
 */
export function useHealthProviderSettingsWithExternalHumanIdTypesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsWithExternalHumanIdTypesQuery,
        HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsWithExternalHumanIdTypesQuery,
          HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsWithExternalHumanIdTypesQuery,
          HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    HealthProviderSettingsWithExternalHumanIdTypesQuery,
    HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
  >(HealthProviderSettingsWithExternalHumanIdTypesDocument, {}, options);
}
export function useHealthProviderSettingsWithExternalHumanIdTypesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<
        HealthProviderSettingsWithExternalHumanIdTypesQuery,
        HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsWithExternalHumanIdTypesQuery,
          HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          HealthProviderSettingsWithExternalHumanIdTypesQuery,
          HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    HealthProviderSettingsWithExternalHumanIdTypesQuery,
    HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
  >(HealthProviderSettingsWithExternalHumanIdTypesDocument, {}, options);
}
export type HealthProviderSettingsWithExternalHumanIdTypesQueryCompositionFunctionResult =
  VueApolloComposable.UseQueryReturn<
    HealthProviderSettingsWithExternalHumanIdTypesQuery,
    HealthProviderSettingsWithExternalHumanIdTypesQueryVariables
  >;
export const GetPatientByExternalIdDocument = gql`
  query getPatientByExternalId($externalPatientId: String!, $externalHumanIdTypeId: String!) {
    getPatientByExternalId(externalPatientId: $externalPatientId, externalHumanIdTypeId: $externalHumanIdTypeId) {
      success
      found
      patient {
        id
        identityNumber
        active
        name {
          given
          family
          text
        }
        gender
        birthDate
        telecom {
          system
          value
        }
        address {
          line
          postalCode
          city
          country
          text
        }
        addressNote
        keyCode
        patientGroups {
          id
          name
        }
      }
      inputValidation {
        errors {
          path
          message
        }
        valid
        message
      }
    }
  }
`;

/**
 * __useGetPatientByExternalIdQuery__
 *
 * To run a query within a Vue component, call `useGetPatientByExternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientByExternalIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPatientByExternalIdQuery({
 *   externalPatientId: // value for 'externalPatientId'
 *   externalHumanIdTypeId: // value for 'externalHumanIdTypeId'
 * });
 */
export function useGetPatientByExternalIdQuery(
  variables:
    | GetPatientByExternalIdQueryVariables
    | VueCompositionApi.Ref<GetPatientByExternalIdQueryVariables>
    | ReactiveFunction<GetPatientByExternalIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>(
    GetPatientByExternalIdDocument,
    variables,
    options,
  );
}
export function useGetPatientByExternalIdLazyQuery(
  variables?:
    | GetPatientByExternalIdQueryVariables
    | VueCompositionApi.Ref<GetPatientByExternalIdQueryVariables>
    | ReactiveFunction<GetPatientByExternalIdQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<GetPatientByExternalIdQuery, GetPatientByExternalIdQueryVariables>(
    GetPatientByExternalIdDocument,
    variables,
    options,
  );
}
export type GetPatientByExternalIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetPatientByExternalIdQuery,
  GetPatientByExternalIdQueryVariables
>;
export const PatientNameDocument = gql`
  query patientName($id: ID!) {
    patient(id: $id) {
      id
      name {
        given
        family
        text
      }
    }
  }
`;

/**
 * __usePatientNameQuery__
 *
 * To run a query within a Vue component, call `usePatientNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientNameQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePatientNameQuery({
 *   id: // value for 'id'
 * });
 */
export function usePatientNameQuery(
  variables:
    | PatientNameQueryVariables
    | VueCompositionApi.Ref<PatientNameQueryVariables>
    | ReactiveFunction<PatientNameQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientNameQuery, PatientNameQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientNameQuery, PatientNameQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientNameQuery, PatientNameQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<PatientNameQuery, PatientNameQueryVariables>(
    PatientNameDocument,
    variables,
    options,
  );
}
export function usePatientNameLazyQuery(
  variables?:
    | PatientNameQueryVariables
    | VueCompositionApi.Ref<PatientNameQueryVariables>
    | ReactiveFunction<PatientNameQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<PatientNameQuery, PatientNameQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PatientNameQuery, PatientNameQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<PatientNameQuery, PatientNameQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<PatientNameQuery, PatientNameQueryVariables>(
    PatientNameDocument,
    variables,
    options,
  );
}
export type PatientNameQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  PatientNameQuery,
  PatientNameQueryVariables
>;
export const GetAllAlarmEventsForPatientPaginatedDocument = gql`
  query getAllAlarmEventsForPatientPaginated(
    $patientId: ID!
    $from: dateTime
    $to: dateTime
    $limit: Int
    $cursor: cursor
  ) {
    getAllAlarmEventsForPatientPaginated(patientId: $patientId, from: $from, to: $to, limit: $limit, cursor: $cursor) {
      events {
        effectiveDateTime
        id
        status
        code {
          coding {
            code
            display
          }
          text
        }
        handlingStatuses {
          handler
          initiatedAt
          attempts {
            startedAt
            doneAt
            status
            handledBy
            payload
            rawResponse
            rawStatus
            details
          }
        }
        component {
          code {
            text
          }
          valueString
        }
      }
      cursor
    }
  }
`;

/**
 * __useGetAllAlarmEventsForPatientPaginatedQuery__
 *
 * To run a query within a Vue component, call `useGetAllAlarmEventsForPatientPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAlarmEventsForPatientPaginatedQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllAlarmEventsForPatientPaginatedQuery({
 *   patientId: // value for 'patientId'
 *   from: // value for 'from'
 *   to: // value for 'to'
 *   limit: // value for 'limit'
 *   cursor: // value for 'cursor'
 * });
 */
export function useGetAllAlarmEventsForPatientPaginatedQuery(
  variables:
    | GetAllAlarmEventsForPatientPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAllAlarmEventsForPatientPaginatedQueryVariables>
    | ReactiveFunction<GetAllAlarmEventsForPatientPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllAlarmEventsForPatientPaginatedQuery,
        GetAllAlarmEventsForPatientPaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllAlarmEventsForPatientPaginatedQuery,
          GetAllAlarmEventsForPatientPaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllAlarmEventsForPatientPaginatedQuery,
          GetAllAlarmEventsForPatientPaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useQuery<
    GetAllAlarmEventsForPatientPaginatedQuery,
    GetAllAlarmEventsForPatientPaginatedQueryVariables
  >(GetAllAlarmEventsForPatientPaginatedDocument, variables, options);
}
export function useGetAllAlarmEventsForPatientPaginatedLazyQuery(
  variables?:
    | GetAllAlarmEventsForPatientPaginatedQueryVariables
    | VueCompositionApi.Ref<GetAllAlarmEventsForPatientPaginatedQueryVariables>
    | ReactiveFunction<GetAllAlarmEventsForPatientPaginatedQueryVariables>,
  options:
    | VueApolloComposable.UseQueryOptions<
        GetAllAlarmEventsForPatientPaginatedQuery,
        GetAllAlarmEventsForPatientPaginatedQueryVariables
      >
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<
          GetAllAlarmEventsForPatientPaginatedQuery,
          GetAllAlarmEventsForPatientPaginatedQueryVariables
        >
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<
          GetAllAlarmEventsForPatientPaginatedQuery,
          GetAllAlarmEventsForPatientPaginatedQueryVariables
        >
      > = {},
) {
  return VueApolloComposable.useLazyQuery<
    GetAllAlarmEventsForPatientPaginatedQuery,
    GetAllAlarmEventsForPatientPaginatedQueryVariables
  >(GetAllAlarmEventsForPatientPaginatedDocument, variables, options);
}
export type GetAllAlarmEventsForPatientPaginatedQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  GetAllAlarmEventsForPatientPaginatedQuery,
  GetAllAlarmEventsForPatientPaginatedQueryVariables
>;
export const OpenPatientGroupsForExternalAccessDocument = gql`
  mutation openPatientGroupsForExternalAccess($input: UpdateExternalAccessInput!) {
    openPatientGroupsForExternalAccess(input: $input) {
      success
    }
  }
`;

/**
 * __useOpenPatientGroupsForExternalAccessMutation__
 *
 * To run a mutation, you first call `useOpenPatientGroupsForExternalAccessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useOpenPatientGroupsForExternalAccessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useOpenPatientGroupsForExternalAccessMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useOpenPatientGroupsForExternalAccessMutation(
  options:
    | VueApolloComposable.UseMutationOptions<
        OpenPatientGroupsForExternalAccessMutation,
        OpenPatientGroupsForExternalAccessMutationVariables
      >
    | ReactiveFunction<
        VueApolloComposable.UseMutationOptions<
          OpenPatientGroupsForExternalAccessMutation,
          OpenPatientGroupsForExternalAccessMutationVariables
        >
      > = {},
) {
  return VueApolloComposable.useMutation<
    OpenPatientGroupsForExternalAccessMutation,
    OpenPatientGroupsForExternalAccessMutationVariables
  >(OpenPatientGroupsForExternalAccessDocument, options);
}
export type OpenPatientGroupsForExternalAccessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<
  OpenPatientGroupsForExternalAccessMutation,
  OpenPatientGroupsForExternalAccessMutationVariables
>;
export const UserGroupForExternalAccessDocument = gql`
  query userGroupForExternalAccess($id: ID) {
    userGroup(userGroupId: $id) {
      id
      name
      parentId
      protected
      subTree {
        id
        name
        parentId
        patientGroups {
          id
          name
        }
      }
      patientGroups {
        id
        name
      }
    }
  }
`;

/**
 * __useUserGroupForExternalAccessQuery__
 *
 * To run a query within a Vue component, call `useUserGroupForExternalAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupForExternalAccessQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserGroupForExternalAccessQuery({
 *   id: // value for 'id'
 * });
 */
export function useUserGroupForExternalAccessQuery(
  variables:
    | UserGroupForExternalAccessQueryVariables
    | VueCompositionApi.Ref<UserGroupForExternalAccessQueryVariables>
    | ReactiveFunction<UserGroupForExternalAccessQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>
      > = {},
) {
  return VueApolloComposable.useQuery<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>(
    UserGroupForExternalAccessDocument,
    variables,
    options,
  );
}
export function useUserGroupForExternalAccessLazyQuery(
  variables:
    | UserGroupForExternalAccessQueryVariables
    | VueCompositionApi.Ref<UserGroupForExternalAccessQueryVariables>
    | ReactiveFunction<UserGroupForExternalAccessQueryVariables> = {},
  options:
    | VueApolloComposable.UseQueryOptions<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>
    | VueCompositionApi.Ref<
        VueApolloComposable.UseQueryOptions<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>
      >
    | ReactiveFunction<
        VueApolloComposable.UseQueryOptions<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>
      > = {},
) {
  return VueApolloComposable.useLazyQuery<UserGroupForExternalAccessQuery, UserGroupForExternalAccessQueryVariables>(
    UserGroupForExternalAccessDocument,
    variables,
    options,
  );
}
export type UserGroupForExternalAccessQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  UserGroupForExternalAccessQuery,
  UserGroupForExternalAccessQueryVariables
>;
export const ExternalAccessesDocument = gql`
  query externalAccesses {
    externalAccesses {
      id
      name
      patientGroupIds
      scim
    }
  }
`;

/**
 * __useExternalAccessesQuery__
 *
 * To run a query within a Vue component, call `useExternalAccessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalAccessesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExternalAccessesQuery();
 */
export function useExternalAccessesQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ExternalAccessesQuery, ExternalAccessesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExternalAccessesQuery, ExternalAccessesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExternalAccessesQuery, ExternalAccessesQueryVariables>> = {},
) {
  return VueApolloComposable.useQuery<ExternalAccessesQuery, ExternalAccessesQueryVariables>(
    ExternalAccessesDocument,
    {},
    options,
  );
}
export function useExternalAccessesLazyQuery(
  options:
    | VueApolloComposable.UseQueryOptions<ExternalAccessesQuery, ExternalAccessesQueryVariables>
    | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ExternalAccessesQuery, ExternalAccessesQueryVariables>>
    | ReactiveFunction<VueApolloComposable.UseQueryOptions<ExternalAccessesQuery, ExternalAccessesQueryVariables>> = {},
) {
  return VueApolloComposable.useLazyQuery<ExternalAccessesQuery, ExternalAccessesQueryVariables>(
    ExternalAccessesDocument,
    {},
    options,
  );
}
export type ExternalAccessesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<
  ExternalAccessesQuery,
  ExternalAccessesQueryVariables
>;
